/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 149);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(156);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(189);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var version = "3.7.1",

	rhtmlSuffix = /HTML$/i,

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},


	// Retrieve the text value of an array of DOM nodes
	text: function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += jQuery.text( node );
			}
		}
		if ( nodeType === 1 || nodeType === 11 ) {
			return elem.textContent;
		}
		if ( nodeType === 9 ) {
			return elem.documentElement.textContent;
		}
		if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	isXMLDoc: function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		// Assume HTML when documentElement doesn't yet exist, such as inside
		// document fragments.
		return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}


function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var pop = arr.pop;


var sort = arr.sort;


var splice = arr.splice;


var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




// Note: an element does not contain itself
jQuery.contains = function( a, b ) {
	var bup = b && b.parentNode;

	return a === bup || !!( bup && bup.nodeType === 1 && (

		// Support: IE 9 - 11+
		// IE doesn't have `contains` on SVG.
		a.contains ?
			a.contains( bup ) :
			a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	) );
};




// CSS string/identifier serialization
// https://drafts.csswg.org/cssom/#common-serializing-idioms
var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

function fcssescape( ch, asCodePoint ) {
	if ( asCodePoint ) {

		// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
		if ( ch === "\0" ) {
			return "\uFFFD";
		}

		// Control characters and (dependent upon position) numbers get escaped as code points
		return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
	}

	// Other potentially-special ASCII characters get backslash-escaped
	return "\\" + ch;
}

jQuery.escapeSelector = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};




var preferredDoc = document,
	pushNative = push;

( function() {

var i,
	Expr,
	outermostContext,
	sortInput,
	hasDuplicate,
	push = pushNative,

	// Local document vars
	document,
	documentElement,
	documentIsHTML,
	rbuggyQSA,
	matches,

	// Instance-specific data
	expando = jQuery.expando,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
		"loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
		whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		ID: new RegExp( "^#(" + identifier + ")" ),
		CLASS: new RegExp( "^\\.(" + identifier + ")" ),
		TAG: new RegExp( "^(" + identifier + "|[*])" ),
		ATTR: new RegExp( "^" + attributes ),
		PSEUDO: new RegExp( "^" + pseudos ),
		CHILD: new RegExp(
			"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		bool: new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		needsContext: new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		if ( nonHex ) {

			// Strip the backslash prefix from a non-hex escape sequence
			return nonHex;
		}

		// Replace a hexadecimal escape sequence with the encoded Unicode code point
		// Support: IE <=11+
		// For values outside the Basic Multilingual Plane (BMP), manually construct a
		// surrogate pair
		return high < 0 ?
			String.fromCharCode( high + 0x10000 ) :
			String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes; see `setDocument`.
	// Support: IE 9 - 11+, Edge 12 - 18+
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE/Edge.
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && nodeName( elem, "fieldset" );
		},
		{ dir: "parentNode", next: "legend" }
	);

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android <=4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = {
		apply: function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		},
		call: function( target ) {
			pushNative.apply( target, slice.call( arguments, 1 ) );
		}
	};
}

function find( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								push.call( results, elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE 9 only
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							find.contains( context, elem ) &&
							elem.id === m ) {

							push.call( results, elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( !nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when
					// strict-comparing two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( newContext != context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = jQuery.escapeSelector( nid );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties
		// (see https://github.com/jquery/sizzle/issues/157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		return nodeName( elem, "input" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
			elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11+
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
function setDocument( node ) {
	var subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	documentElement = document.documentElement;
	documentIsHTML = !jQuery.isXMLDoc( document );

	// Support: iOS 7 only, IE 9 - 11+
	// Older browsers didn't support unprefixed `matches`.
	matches = documentElement.matches ||
		documentElement.webkitMatchesSelector ||
		documentElement.msMatchesSelector;

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors
	// (see trac-13936).
	// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
	// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
	if ( documentElement.msMatchesSelector &&

		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 9 - 11+, Edge 12 - 18+
		subWindow.addEventListener( "unload", unloadHandler );
	}

	// Support: IE <10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		documentElement.appendChild( el ).id = jQuery.expando;
		return !document.getElementsByName ||
			!document.getElementsByName( jQuery.expando ).length;
	} );

	// Support: IE 9 only
	// Check to see if it's possible to do matchesSelector
	// on a disconnected node.
	support.disconnectedMatch = assert( function( el ) {
		return matches.call( el, "*" );
	} );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// IE/Edge don't support the :scope pseudo-class.
	support.scope = assert( function() {
		return document.querySelectorAll( ":scope" );
	} );

	// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
	// Make sure the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter.ID = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter.ID =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find.TAG = function( tag, context ) {
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			return context.getElementsByTagName( tag );

		// DocumentFragment nodes don't have gEBTN
		} else {
			return context.querySelectorAll( tag );
		}
	};

	// Class
	Expr.find.CLASS = function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	rbuggyQSA = [];

	// Build QSA regex
	// Regex strategy adopted from Diego Perini
	assert( function( el ) {

		var input;

		documentElement.appendChild( el ).innerHTML =
			"<a id='" + expando + "' href='' disabled='disabled'></a>" +
			"<select id='" + expando + "-\r\\' disabled='disabled'>" +
			"<option selected=''></option></select>";

		// Support: iOS <=7 - 8 only
		// Boolean attributes and "value" are not treated correctly in some XML documents
		if ( !el.querySelectorAll( "[selected]" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
		}

		// Support: iOS <=7 - 8 only
		if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
			rbuggyQSA.push( "~=" );
		}

		// Support: iOS 8 only
		// https://bugs.webkit.org/show_bug.cgi?id=136851
		// In-page `selector#id sibling-combinator selector` fails
		if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
			rbuggyQSA.push( ".#.+[+~]" );
		}

		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		if ( !el.querySelectorAll( ":checked" ).length ) {
			rbuggyQSA.push( ":checked" );
		}

		// Support: Windows 8 Native Apps
		// The type and name attributes are restricted during .innerHTML assignment
		input = document.createElement( "input" );
		input.setAttribute( "type", "hidden" );
		el.appendChild( input ).setAttribute( "name", "D" );

		// Support: IE 9 - 11+
		// IE's :disabled selector does not pick up the children of disabled fieldsets
		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		documentElement.appendChild( el ).disabled = true;
		if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
			rbuggyQSA.push( ":enabled", ":disabled" );
		}

		// Support: IE 11+, Edge 15 - 18+
		// IE 11/Edge don't find elements on a `[name='']` query in some cases.
		// Adding a temporary attribute to the document before the selection works
		// around the issue.
		// Interestingly, IE 10 & older don't seem to have the issue.
		input = document.createElement( "input" );
		input.setAttribute( "name", "" );
		el.appendChild( input );
		if ( !el.querySelectorAll( "[name='']" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
				whitespace + "*(?:''|\"\")" );
		}
	} );

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a === document || a.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b === document || b.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	};

	return document;
}

find.matches = function( expr, elements ) {
	return find( expr, null, null, elements );
};

find.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return find( expr, document, null, [ elem ] ).length > 0;
};

find.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return jQuery.contains( context, elem );
};


find.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (see trac-13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	if ( val !== undefined ) {
		return val;
	}

	return elem.getAttribute( name );
};

find.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
jQuery.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	//
	// Support: Android <=4.0+
	// Testing for detecting duplicates is unpredictable so instead assume we can't
	// depend on duplicate detection in all browsers without a stable sort.
	hasDuplicate = !support.sortStable;
	sortInput = !support.sortStable && slice.call( results, 0 );
	sort.call( results, sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			splice.call( results, duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

jQuery.fn.uniqueSort = function() {
	return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
};

Expr = jQuery.expr = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		ATTR: function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
				.replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		CHILD: function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					find.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
				);
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

			// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				find.error( match[ 0 ] );
			}

			return match;
		},

		PSEUDO: function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		TAG: function( nodeNameSelector ) {
			var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return nodeName( elem, expectedNodeName );
				};
		},

		CLASS: function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace + ")" + className +
					"(" + whitespace + "|$)" ) ) &&
				classCache( className, function( elem ) {
					return pattern.test(
						typeof elem.className === "string" && elem.className ||
							typeof elem.getAttribute !== "undefined" &&
								elem.getAttribute( "class" ) ||
							""
					);
				} );
		},

		ATTR: function( name, operator, check ) {
			return function( elem ) {
				var result = find.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				if ( operator === "=" ) {
					return result === check;
				}
				if ( operator === "!=" ) {
					return result !== check;
				}
				if ( operator === "^=" ) {
					return check && result.indexOf( check ) === 0;
				}
				if ( operator === "*=" ) {
					return check && result.indexOf( check ) > -1;
				}
				if ( operator === "$=" ) {
					return check && result.slice( -check.length ) === check;
				}
				if ( operator === "~=" ) {
					return ( " " + result.replace( rwhitespace, " " ) + " " )
						.indexOf( check ) > -1;
				}
				if ( operator === "|=" ) {
					return result === check || result.slice( 0, check.length + 1 ) === check + "-";
				}

				return false;
			};
		},

		CHILD: function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || ( parent[ expando ] = {} );
							cache = outerCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {
								outerCache = elem[ expando ] || ( elem[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );
											outerCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		PSEUDO: function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// https://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					find.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as jQuery does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		not: markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrimCSS, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element
					// (see https://github.com/jquery/sizzle/issues/299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		has: markFunction( function( selector ) {
			return function( elem ) {
				return find( selector, elem ).length > 0;
			};
		} ),

		contains: markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// https://www.w3.org/TR/selectors/#lang-pseudo
		lang: markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				find.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		target: function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		root: function( elem ) {
			return elem === documentElement;
		},

		focus: function( elem ) {
			return elem === safeActiveElement() &&
				document.hasFocus() &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		enabled: createDisabledPseudo( false ),
		disabled: createDisabledPseudo( true ),

		checked: function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			return ( nodeName( elem, "input" ) && !!elem.checked ) ||
				( nodeName( elem, "option" ) && !!elem.selected );
		},

		selected: function( elem ) {

			// Support: IE <=11+
			// Accessing the selectedIndex property
			// forces the browser to treat the default option as
			// selected when in an optgroup.
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		empty: function( elem ) {

			// https://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		parent: function( elem ) {
			return !Expr.pseudos.empty( elem );
		},

		// Element/input types
		header: function( elem ) {
			return rheader.test( elem.nodeName );
		},

		input: function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		button: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "button" ||
				nodeName( elem, "button" );
		},

		text: function( elem ) {
			var attr;
			return nodeName( elem, "input" ) && elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear
				// with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		first: createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		last: createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		even: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		odd: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i;

			if ( argument < 0 ) {
				i = argument + length;
			} else if ( argument > length ) {
				i = length;
			} else {
				i = argument;
			}

			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos.nth = Expr.pseudos.eq;

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrimCSS, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	if ( parseOnly ) {
		return soFar.length;
	}

	return soFar ?
		find.error( selector ) :

		// Cache the tokens
		tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						if ( skip && nodeName( elem, skip ) ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = outerCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							outerCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		find( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem, matcherOut,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed ||
				multipleContexts( selector || "*",
					context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems;

		if ( matcher ) {

			// If we have a postFinder, or filtered seed, or non-seed postFilter
			// or preexisting results,
			matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results;

			// Find primary matches
			matcher( matcherIn, matcherOut, context, xml );
		} else {
			matcherOut = matcherIn;
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element
			// (see https://github.com/jquery/sizzle/issues/299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrimCSS, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find.TAG( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: iOS <=7 - 9 only
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
			// elements by id. (see trac-14142)
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							push.call( results, elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					jQuery.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

function compile( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
}

/**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find.ID(
				token.matches[ 0 ].replace( runescape, funescape ),
				context
			) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) &&
						testContext( context.parentNode ) || context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

// One-time assignments

// Support: Android <=4.0 - 4.1+
// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Initialize against the default document
setDocument();

// Support: Android <=4.0 - 4.1+
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

jQuery.find = find;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.unique = jQuery.uniqueSort;

// These have always been private, but they used to be documented as part of
// Sizzle so let's maintain them for now for backwards compatibility purposes.
find.compile = compile;
find.select = select;
find.setDocument = setDocument;
find.tokenize = tokenize;

find.escape = jQuery.escapeSelector;
find.getText = jQuery.text;
find.isXML = jQuery.isXMLDoc;
find.selectors = jQuery.expr;
find.support = jQuery.support;
find.uniqueSort = jQuery.uniqueSort;

	/* eslint-enable */

} )();


var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to jQuery#find
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.error );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the error, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getErrorHook ) {
									process.error = jQuery.Deferred.getErrorHook();

								// The deprecated alias of the above. While the name suggests
								// returning the stack, not an error instance, jQuery just passes
								// it directly to `console.warn` so both will work; an instance
								// just better cooperates with source maps.
								} else if ( jQuery.Deferred.getStackHook ) {
									process.error = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
// captured before the async barrier to get the original error cause
// which may otherwise be hidden.
jQuery.Deferred.exceptionHook = function( error, asyncError ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message,
			error.stack, asyncError );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", true );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, isSetup ) {

	// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
	if ( !isSetup ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				if ( !saved ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					this[ type ]();
					result = dataPriv.get( this, type );
					dataPriv.set( this, type, false );

					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						return result;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering
				// the native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved ) {

				// ...and capture the result
				dataPriv.set( this, type, jQuery.event.trigger(
					saved[ 0 ],
					saved.slice( 1 ),
					this
				) );

				// Abort handling of the native event by all jQuery handlers while allowing
				// native handlers on the same element to run. On target, this is achieved
				// by stopping immediate propagation just on the jQuery event. However,
				// the native event is re-wrapped by a jQuery one on each level of the
				// propagation so the only way to stop it for jQuery is to stop it for
				// everyone via native `stopPropagation()`. This is not a problem for
				// focus/blur which don't bubble, but it does also stop click on checkboxes
				// and radios. We accept this limitation.
				event.stopPropagation();
				event.isImmediatePropagationStopped = returnTrue;
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

	function focusMappedHandler( nativeEvent ) {
		if ( document.documentMode ) {

			// Support: IE 11+
			// Attach a single focusin/focusout handler on the document while someone wants
			// focus/blur. This is because the former are synchronous in IE while the latter
			// are async. In other browsers, all those handlers are invoked synchronously.

			// `handle` from private data would already wrap the event, but we need
			// to change the `type` here.
			var handle = dataPriv.get( this, "handle" ),
				event = jQuery.event.fix( nativeEvent );
			event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
			event.isSimulated = true;

			// First, handle focusin/focusout
			handle( nativeEvent );

			// ...then, handle focus/blur
			//
			// focus/blur don't bubble while focusin/focusout do; simulate the former by only
			// invoking the handler at the lower level.
			if ( event.target === event.currentTarget ) {

				// The setup part calls `leverageNative`, which, in turn, calls
				// `jQuery.event.add`, so event handle will already have been set
				// by this point.
				handle( event );
			}
		} else {

			// For non-IE browsers, attach a single capturing handler on the document
			// while someone wants focusin/focusout.
			jQuery.event.simulate( delegateType, nativeEvent.target,
				jQuery.event.fix( nativeEvent ) );
		}
	}

	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			var attaches;

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, true );

			if ( document.documentMode ) {

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				attaches = dataPriv.get( this, delegateType );
				if ( !attaches ) {
					this.addEventListener( delegateType, focusMappedHandler );
				}
				dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
			} else {

				// Return false to allow normal processing in the caller
				return false;
			}
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		teardown: function() {
			var attaches;

			if ( document.documentMode ) {
				attaches = dataPriv.get( this, delegateType ) - 1;
				if ( !attaches ) {
					this.removeEventListener( delegateType, focusMappedHandler );
					dataPriv.remove( this, delegateType );
				} else {
					dataPriv.set( this, delegateType, attaches );
				}
			} else {

				// Return false to indicate standard teardown should be applied
				return false;
			}
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	//
	// Support: IE 9 - 11+
	// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
	// attach a single handler for both events in IE.
	jQuery.event.special[ delegateType ] = {
		setup: function() {

			// Handle: regular nodes (via `this.ownerDocument`), window
			// (via `this.document`) & document (via `this`).
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType );

			// Support: IE 9 - 11+
			// We use the same native handler for focusin & focus (and focusout & blur)
			// so we need to coordinate setup & teardown parts between those events.
			// Use `delegateType` as the key as `type` is already used by `leverageNative`.
			if ( !attaches ) {
				if ( document.documentMode ) {
					this.addEventListener( delegateType, focusMappedHandler );
				} else {
					doc.addEventListener( type, focusMappedHandler, true );
				}
			}
			dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
		},
		teardown: function() {
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType ) - 1;

			if ( !attaches ) {
				if ( document.documentMode ) {
					this.removeEventListener( delegateType, focusMappedHandler );
				} else {
					doc.removeEventListener( type, focusMappedHandler, true );
				}
				dataPriv.remove( dataHolder, delegateType );
			} else {
				dataPriv.set( dataHolder, delegateType, attaches );
			}
		}
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Re-enable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew jQuery#find here for performance reasons:
			// https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "box-sizing:content-box;border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is `display: block`
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0,
		marginDelta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		// Count margin delta separately to only add it after scroll gutter adjustment.
		// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
		if ( box === "margin" ) {
			marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta + marginDelta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		animationIterationCount: true,
		aspectRatio: true,
		borderImageSlice: true,
		columnCount: true,
		flexGrow: true,
		flexShrink: true,
		fontWeight: true,
		gridArea: true,
		gridColumn: true,
		gridColumnEnd: true,
		gridColumnStart: true,
		gridRow: true,
		gridRowEnd: true,
		gridRowStart: true,
		lineHeight: true,
		opacity: true,
		order: true,
		orphans: true,
		scale: true,
		widows: true,
		zIndex: true,
		zoom: true,

		// SVG-related
		fillOpacity: true,
		floodOpacity: true,
		stopOpacity: true,
		strokeMiterlimit: true,
		strokeOpacity: true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this
			.on( "mouseenter", fnOver )
			.on( "mouseleave", fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(190);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(200);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(93);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(121);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/**
 * @private
 */
var _isPromisesAPlusCompliant = true;

/**
 * A Promise is returned by async methods as a hook to provide callbacks to be
 * called when the async task is fulfilled.
 *
 * <p>Typical usage would be like:<pre>
 *    query.find().then(function(results) {
 *      results[0].set("foo", "bar");
 *      return results[0].saveAsync();
 *    }).then(function(result) {
 *      console.log("Updated " + result.id);
 *    });
 * </pre></p>
 *
 * @alias Parse.Promise
 */

var ParsePromise = function () {
  function ParsePromise(executor) {
    (0, _classCallCheck3.default)(this, ParsePromise);

    this._resolved = false;
    this._rejected = false;
    this._resolvedCallbacks = [];
    this._rejectedCallbacks = [];

    if (typeof executor === 'function') {
      executor(this.resolve.bind(this), this.reject.bind(this));
    }
  }

  /**
   * Marks this promise as fulfilled, firing any callbacks waiting on it.
    * @param {Object} result the result to pass to the callbacks.
   */

  (0, _createClass3.default)(ParsePromise, [{
    key: 'resolve',
    value: function () {
      if (this._resolved || this._rejected) {
        throw new Error('A promise was resolved even though it had already been ' + (this._resolved ? 'resolved' : 'rejected') + '.');
      }
      this._resolved = true;

      for (var _len = arguments.length, results = Array(_len), _key = 0; _key < _len; _key++) {
        results[_key] = arguments[_key];
      }

      this._result = results;
      for (var i = 0; i < this._resolvedCallbacks.length; i++) {
        this._resolvedCallbacks[i].apply(this, results);
      }

      this._resolvedCallbacks = [];
      this._rejectedCallbacks = [];
    }

    /**
     * Marks this promise as fulfilled, firing any callbacks waiting on it.
      * @param {Object} error the error to pass to the callbacks.
     */

  }, {
    key: 'reject',
    value: function (error) {
      if (this._resolved || this._rejected) {
        throw new Error('A promise was rejected even though it had already been ' + (this._resolved ? 'resolved' : 'rejected') + '.');
      }
      this._rejected = true;
      this._error = error;
      for (var i = 0; i < this._rejectedCallbacks.length; i++) {
        this._rejectedCallbacks[i](error);
      }
      this._resolvedCallbacks = [];
      this._rejectedCallbacks = [];
    }

    /**
     * Adds callbacks to be called when this promise is fulfilled. Returns a new
     * Promise that will be fulfilled when the callback is complete. It allows
     * chaining. If the callback itself returns a Promise, then the one returned
     * by "then" will not be fulfilled until that one returned by the callback
     * is fulfilled.
      * @param {Function} resolvedCallback Function that is called when this
     * Promise is resolved. Once the callback is complete, then the Promise
     * returned by "then" will also be fulfilled.
     * @param {Function} rejectedCallback Function that is called when this
     * Promise is rejected with an error. Once the callback is complete, then
     * the promise returned by "then" with be resolved successfully. If
     * rejectedCallback is null, or it returns a rejected Promise, then the
     * Promise returned by "then" will be rejected with that error.
     * @return {Parse.Promise} A new Promise that will be fulfilled after this
     * Promise is fulfilled and either callback has completed. If the callback
     * returned a Promise, then this Promise will not be fulfilled until that
     * one is.
     */

  }, {
    key: 'then',
    value: function (resolvedCallback, rejectedCallback) {
      var _this = this;

      var promise = new ParsePromise();

      var wrappedResolvedCallback = function () {
        for (var _len2 = arguments.length, results = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          results[_key2] = arguments[_key2];
        }

        if (typeof resolvedCallback === 'function') {
          if (_isPromisesAPlusCompliant) {
            try {
              results = [resolvedCallback.apply(this, results)];
            } catch (e) {
              results = [ParsePromise.error(e)];
            }
          } else {
            results = [resolvedCallback.apply(this, results)];
          }
        }
        if (results.length === 1 && ParsePromise.is(results[0])) {
          results[0].then(function () {
            promise.resolve.apply(promise, arguments);
          }, function (error) {
            promise.reject(error);
          });
        } else {
          promise.resolve.apply(promise, results);
        }
      };

      var wrappedRejectedCallback = function (error) {
        var result = [];
        if (typeof rejectedCallback === 'function') {
          if (_isPromisesAPlusCompliant) {
            try {
              result = [rejectedCallback(error)];
            } catch (e) {
              result = [ParsePromise.error(e)];
            }
          } else {
            result = [rejectedCallback(error)];
          }
          if (result.length === 1 && ParsePromise.is(result[0])) {
            result[0].then(function () {
              promise.resolve.apply(promise, arguments);
            }, function (error) {
              promise.reject(error);
            });
          } else {
            if (_isPromisesAPlusCompliant) {
              promise.resolve.apply(promise, result);
            } else {
              promise.reject(result[0]);
            }
          }
        } else {
          promise.reject(error);
        }
      };

      var runLater = function (fn) {
        fn.call();
      };
      if (_isPromisesAPlusCompliant) {
        if (typeof process !== 'undefined' && typeof process.nextTick === 'function') {
          runLater = function (fn) {
            process.nextTick(fn);
          };
        } else if (typeof setTimeout === 'function') {
          runLater = function (fn) {
            setTimeout(fn, 0);
          };
        }
      }

      if (this._resolved) {
        runLater(function () {
          wrappedResolvedCallback.apply(_this, _this._result);
        });
      } else if (this._rejected) {
        runLater(function () {
          wrappedRejectedCallback(_this._error);
        });
      } else {
        this._resolvedCallbacks.push(wrappedResolvedCallback);
        this._rejectedCallbacks.push(wrappedRejectedCallback);
      }

      return promise;
    }

    /**
     * Add handlers to be called when the promise
     * is either resolved or rejected
      */

  }, {
    key: 'always',
    value: function (callback) {
      return this.then(callback, callback);
    }

    /**
     * Add handlers to be called when the Promise object is resolved
      */

  }, {
    key: 'done',
    value: function (callback) {
      return this.then(callback);
    }

    /**
     * Add handlers to be called when the Promise object is rejected
     * Alias for catch().
      */

  }, {
    key: 'fail',
    value: function (callback) {
      return this.then(null, callback);
    }

    /**
     * Add handlers to be called when the Promise object is rejected
      */

  }, {
    key: 'catch',
    value: function (callback) {
      return this.then(null, callback);
    }

    /**
     * Run the given callbacks after this promise is fulfilled.
      * @param optionsOrCallback {} A Backbone-style options callback, or a
     * callback function. If this is an options object and contains a "model"
     * attributes, that will be passed to error callbacks as the first argument.
     * @param model {} If truthy, this will be passed as the first result of
     * error callbacks. This is for Backbone-compatability.
     * @return {Parse.Promise} A promise that will be resolved after the
     * callbacks are run, with the same result as this.
     */

  }, {
    key: '_thenRunCallbacks',
    value: function (optionsOrCallback, model) {
      var options = {};
      if (typeof optionsOrCallback === 'function') {
        options.success = function (result) {
          optionsOrCallback(result, null);
        };
        options.error = function (error) {
          optionsOrCallback(null, error);
        };
      } else if ((typeof optionsOrCallback === 'undefined' ? 'undefined' : (0, _typeof3.default)(optionsOrCallback)) === 'object') {
        if (typeof optionsOrCallback.success === 'function') {
          options.success = optionsOrCallback.success;
        }
        if (typeof optionsOrCallback.error === 'function') {
          options.error = optionsOrCallback.error;
        }
      }

      return this.then(function () {
        for (var _len3 = arguments.length, results = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          results[_key3] = arguments[_key3];
        }

        if (options.success) {
          options.success.apply(this, results);
        }
        return ParsePromise.as.apply(ParsePromise, arguments);
      }, function (error) {
        if (options.error) {
          if (typeof model !== 'undefined') {
            options.error(model, error);
          } else {
            options.error(error);
          }
        }
        // By explicitly returning a rejected Promise, this will work with
        // either jQuery or Promises/A+ semantics.
        return ParsePromise.error(error);
      });
    }

    /**
     * Adds a callback function that should be called regardless of whether
     * this promise failed or succeeded. The callback will be given either the
     * array of results for its first argument, or the error as its second,
     * depending on whether this Promise was rejected or resolved. Returns a
     * new Promise, like "then" would.
      * @param {Function} continuation the callback.
     */

  }, {
    key: '_continueWith',
    value: function (continuation) {
      return this.then(function () {
        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        return continuation(args, null);
      }, function (error) {
        return continuation(null, error);
      });
    }

    /**
     * Returns true iff the given object fulfils the Promise interface.
      * @param {Object} promise The object to test
     * @static
     * @return {Boolean}
     */

  }], [{
    key: 'is',
    value: function (promise) {
      return promise != null && typeof promise.then === 'function';
    }

    /**
     * Returns a new promise that is resolved with a given value.
      * @param value The value to resolve the promise with
     * @static
     * @return {Parse.Promise} the new promise.
     */

  }, {
    key: 'as',
    value: function () {
      var promise = new ParsePromise();

      for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        values[_key5] = arguments[_key5];
      }

      promise.resolve.apply(promise, values);
      return promise;
    }

    /**
     * Returns a new promise that is resolved with a given value.
     * If that value is a thenable Promise (has a .then() prototype
     * method), the new promise will be chained to the end of the
     * value.
      * @param value The value to resolve the promise with
     * @static
     * @return {Parse.Promise} the new promise.
     */

  }, {
    key: 'resolve',
    value: function (value) {
      return new ParsePromise(function (resolve, reject) {
        if (ParsePromise.is(value)) {
          value.then(resolve, reject);
        } else {
          resolve(value);
        }
      });
    }

    /**
     * Returns a new promise that is rejected with a given error.
      * @param error The error to reject the promise with
     * @static
     * @return {Parse.Promise} the new promise.
     */

  }, {
    key: 'error',
    value: function () {
      var promise = new ParsePromise();

      for (var _len6 = arguments.length, errors = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        errors[_key6] = arguments[_key6];
      }

      promise.reject.apply(promise, errors);
      return promise;
    }

    /**
     * Returns a new promise that is rejected with a given error.
     * This is an alias for Parse.Promise.error, for compliance with
     * the ES6 implementation.
      * @param error The error to reject the promise with
     * @static
     * @return {Parse.Promise} the new promise.
     */

  }, {
    key: 'reject',
    value: function () {
      for (var _len7 = arguments.length, errors = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        errors[_key7] = arguments[_key7];
      }

      return ParsePromise.error.apply(null, errors);
    }

    /**
     * Returns a new promise that is fulfilled when all of the input promises
     * are resolved. If any promise in the list fails, then the returned promise
     * will be rejected with an array containing the error from each promise.
     * If they all succeed, then the returned promise will succeed, with the
     * results being the results of all the input
     * promises. For example: <pre>
     *   var p1 = Parse.Promise.as(1);
     *   var p2 = Parse.Promise.as(2);
     *   var p3 = Parse.Promise.as(3);
     *
     *   Parse.Promise.when(p1, p2, p3).then(function(r1, r2, r3) {
     *     console.log(r1);  // prints 1
     *     console.log(r2);  // prints 2
     *     console.log(r3);  // prints 3
     *   });</pre>
     *
     * The input promises can also be specified as an array: <pre>
     *   var promises = [p1, p2, p3];
     *   Parse.Promise.when(promises).then(function(results) {
     *     console.log(results);  // prints [1,2,3]
     *   });
     * </pre>
      * @param {Array} promises a list of promises to wait for.
     * @static
     * @return {Parse.Promise} the new promise.
     */

  }, {
    key: 'when',
    value: function (promises) {
      var objects;
      var arrayArgument = Array.isArray(promises);
      if (arrayArgument) {
        objects = promises;
      } else {
        objects = arguments;
      }

      var total = objects.length;
      var hadError = false;
      var results = [];
      var returnValue = arrayArgument ? [results] : results;
      var errors = [];
      results.length = objects.length;
      errors.length = objects.length;

      if (total === 0) {
        return ParsePromise.as.apply(this, returnValue);
      }

      var promise = new ParsePromise();

      var resolveOne = function () {
        total--;
        if (total <= 0) {
          if (hadError) {
            promise.reject(errors);
          } else {
            promise.resolve.apply(promise, returnValue);
          }
        }
      };

      var chain = function (object, index) {
        if (ParsePromise.is(object)) {
          object.then(function (result) {
            results[index] = result;
            resolveOne();
          }, function (error) {
            errors[index] = error;
            hadError = true;
            resolveOne();
          });
        } else {
          results[i] = object;
          resolveOne();
        }
      };
      for (var i = 0; i < objects.length; i++) {
        chain(objects[i], i);
      }

      return promise;
    }

    /**
     * Returns a new promise that is fulfilled when all of the promises in the
     * iterable argument are resolved. If any promise in the list fails, then
     * the returned promise will be immediately rejected with the reason that
     * single promise rejected. If they all succeed, then the returned promise
     * will succeed, with the results being the results of all the input
     * promises. If the iterable provided is empty, the returned promise will
     * be immediately resolved.
     * 
     * For example: <pre>
     *   var p1 = Parse.Promise.as(1);
     *   var p2 = Parse.Promise.as(2);
     *   var p3 = Parse.Promise.as(3);
     *
     *   Parse.Promise.all([p1, p2, p3]).then(function([r1, r2, r3]) {
     *     console.log(r1);  // prints 1
     *     console.log(r2);  // prints 2
     *     console.log(r3);  // prints 3
     *   });</pre>
     *
      * @param {Iterable} promises an iterable of promises to wait for.
     * @static
     * @return {Parse.Promise} the new promise.
     */

  }, {
    key: 'all',
    value: function (promises) {
      var total = 0;
      var objects = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(promises), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var p = _step.value;

          objects[total++] = p;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (total === 0) {
        return ParsePromise.as([]);
      }

      var hadError = false;
      var promise = new ParsePromise();
      var resolved = 0;
      var results = [];
      objects.forEach(function (object, i) {
        if (ParsePromise.is(object)) {
          object.then(function (result) {
            if (hadError) {
              return false;
            }
            results[i] = result;
            resolved++;
            if (resolved >= total) {
              promise.resolve(results);
            }
          }, function (error) {
            // Reject immediately
            promise.reject(error);
            hadError = true;
          });
        } else {
          results[i] = object;
          resolved++;
          if (!hadError && resolved >= total) {
            promise.resolve(results);
          }
        }
      });

      return promise;
    }

    /**
     * Returns a new promise that is immediately fulfilled when any of the
     * promises in the iterable argument are resolved or rejected. If the
     * first promise to complete is resolved, the returned promise will be
     * resolved with the same value. Likewise, if the first promise to
     * complete is rejected, the returned promise will be rejected with the
     * same reason.
     *
      * @param {Iterable} promises an iterable of promises to wait for.
     * @static
     * @return {Parse.Promise} the new promise.
     */

  }, {
    key: 'race',
    value: function (promises) {
      var completed = false;
      var promise = new ParsePromise();
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(promises), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var p = _step2.value;

          if (ParsePromise.is(p)) {
            p.then(function (result) {
              if (completed) {
                return;
              }
              completed = true;
              promise.resolve(result);
            }, function (error) {
              if (completed) {
                return;
              }
              completed = true;
              promise.reject(error);
            });
          } else if (!completed) {
            completed = true;
            promise.resolve(p);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return promise;
    }

    /**
     * Runs the given asyncFunction repeatedly, as long as the predicate
     * function returns a truthy value. Stops repeating if asyncFunction returns
     * a rejected promise.
      * @param {Function} predicate should return false when ready to stop.
     * @param {Function} asyncFunction should return a Promise.
     * @static
     */

  }, {
    key: '_continueWhile',
    value: function (predicate, asyncFunction) {
      if (predicate()) {
        return asyncFunction().then(function () {
          return ParsePromise._continueWhile(predicate, asyncFunction);
        });
      }
      return ParsePromise.as();
    }
  }, {
    key: 'isPromisesAPlusCompliant',
    value: function () {
      return _isPromisesAPlusCompliant;
    }
  }, {
    key: 'enableAPlusCompliant',
    value: function () {
      _isPromisesAPlusCompliant = true;
    }
  }, {
    key: 'disableAPlusCompliant',
    value: function () {
      _isPromisesAPlusCompliant = false;
    }
  }]);
  return ParsePromise;
}();

exports.default = ParsePromise;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(93);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _create = __webpack_require__(120);

var _create2 = _interopRequireDefault(_create);

var _freeze = __webpack_require__(222);

var _freeze2 = _interopRequireDefault(_freeze);

var _stringify = __webpack_require__(42);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(49);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _CoreManager = __webpack_require__(9);

var _CoreManager2 = _interopRequireDefault(_CoreManager);

var _canBeSerialized = __webpack_require__(226);

var _canBeSerialized2 = _interopRequireDefault(_canBeSerialized);

var _decode = __webpack_require__(45);

var _decode2 = _interopRequireDefault(_decode);

var _encode = __webpack_require__(36);

var _encode2 = _interopRequireDefault(_encode);

var _equals = __webpack_require__(229);

var _equals2 = _interopRequireDefault(_equals);

var _escape2 = __webpack_require__(126);

var _escape3 = _interopRequireDefault(_escape2);

var _ParseACL = __webpack_require__(41);

var _ParseACL2 = _interopRequireDefault(_ParseACL);

var _parseDate = __webpack_require__(127);

var _parseDate2 = _interopRequireDefault(_parseDate);

var _ParseError = __webpack_require__(28);

var _ParseError2 = _interopRequireDefault(_ParseError);

var _ParseFile = __webpack_require__(29);

var _ParseFile2 = _interopRequireDefault(_ParseFile);

var _ParseOp = __webpack_require__(43);

var _ParsePromise = __webpack_require__(7);

var _ParsePromise2 = _interopRequireDefault(_ParsePromise);

var _ParseQuery = __webpack_require__(66);

var _ParseQuery2 = _interopRequireDefault(_ParseQuery);

var _ParseRelation = __webpack_require__(30);

var _ParseRelation2 = _interopRequireDefault(_ParseRelation);

var _SingleInstanceStateController = __webpack_require__(230);

var SingleInstanceStateController = _interopRequireWildcard(_SingleInstanceStateController);

var _unique = __webpack_require__(125);

var _unique2 = _interopRequireDefault(_unique);

var _UniqueInstanceStateController = __webpack_require__(231);

var UniqueInstanceStateController = _interopRequireWildcard(_UniqueInstanceStateController);

var _unsavedChildren = __webpack_require__(243);

var _unsavedChildren2 = _interopRequireDefault(_unsavedChildren);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// Mapping of class names to constructors, so we can populate objects from the
// server with appropriate subclasses of ParseObject
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var classMap = {};

// Global counter for generating unique local Ids
var localCount = 0;
// Global counter for generating unique Ids for non-single-instance objects
var objectCount = 0;
// On web clients, objects are single-instance: any two objects with the same Id
// will have the same attributes. However, this may be dangerous default
// behavior in a server scenario
var singleInstance = !_CoreManager2.default.get('IS_NODE');
if (singleInstance) {
  _CoreManager2.default.setObjectStateController(SingleInstanceStateController);
} else {
  _CoreManager2.default.setObjectStateController(UniqueInstanceStateController);
}

function getServerUrlPath() {
  var serverUrl = _CoreManager2.default.get('SERVER_URL');
  if (serverUrl[serverUrl.length - 1] !== '/') {
    serverUrl += '/';
  }
  var url = serverUrl.replace(/https?:\/\//, '');
  return url.substr(url.indexOf('/'));
}

/**
 * Creates a new model with defined attributes.
  *
  * <p>You won't normally call this method directly.  It is recommended that
  * you use a subclass of <code>Parse.Object</code> instead, created by calling
  * <code>extend</code>.</p>
  *
  * <p>However, if you don't want to use a subclass, or aren't sure which
  * subclass is appropriate, you can use this form:<pre>
  *     var object = new Parse.Object("ClassName");
  * </pre>
  * That is basically equivalent to:<pre>
  *     var MyClass = Parse.Object.extend("ClassName");
  *     var object = new MyClass();
  * </pre></p>
  *
 * @alias Parse.Object
 */

var ParseObject = function () {
  /**
   * @param {String} className The class name for the object
   * @param {Object} attributes The initial set of data to store in the object.
   * @param {Object} options The options for this object instance.
   */
  function ParseObject(className, attributes, options) {
    (0, _classCallCheck3.default)(this, ParseObject);

    // Enable legacy initializers
    if (typeof this.initialize === 'function') {
      this.initialize.apply(this, arguments);
    }

    var toSet = null;
    this._objCount = objectCount++;
    if (typeof className === 'string') {
      this.className = className;
      if (attributes && (typeof attributes === 'undefined' ? 'undefined' : (0, _typeof3.default)(attributes)) === 'object') {
        toSet = attributes;
      }
    } else if (className && (typeof className === 'undefined' ? 'undefined' : (0, _typeof3.default)(className)) === 'object') {
      this.className = className.className;
      toSet = {};
      for (var attr in className) {
        if (attr !== 'className') {
          toSet[attr] = className[attr];
        }
      }
      if (attributes && (typeof attributes === 'undefined' ? 'undefined' : (0, _typeof3.default)(attributes)) === 'object') {
        options = attributes;
      }
    }
    if (toSet && !this.set(toSet, options)) {
      throw new Error('Can\'t create an invalid Parse Object');
    }
  }

  /**
   * The ID of this object, unique within its class.
   * @property id
   * @type String
   */

  (0, _createClass3.default)(ParseObject, [{
    key: '_getId',

    /** Private methods **/

    /**
     * Returns a local or server Id used uniquely identify this object
     */
    value: function () {
      if (typeof this.id === 'string') {
        return this.id;
      }
      if (typeof this._localId === 'string') {
        return this._localId;
      }
      var localId = 'local' + String(localCount++);
      this._localId = localId;
      return localId;
    }

    /**
     * Returns a unique identifier used to pull data from the State Controller.
     */

  }, {
    key: '_getStateIdentifier',
    value: function () {
      if (singleInstance) {
        var _id = this.id;
        if (!_id) {
          _id = this._getId();
        }
        return {
          id: _id,
          className: this.className
        };
      } else {
        return this;
      }
    }
  }, {
    key: '_getServerData',
    value: function () {
      var stateController = _CoreManager2.default.getObjectStateController();
      return stateController.getServerData(this._getStateIdentifier());
    }
  }, {
    key: '_clearServerData',
    value: function () {
      var serverData = this._getServerData();
      var unset = {};
      for (var attr in serverData) {
        unset[attr] = undefined;
      }
      var stateController = _CoreManager2.default.getObjectStateController();
      stateController.setServerData(this._getStateIdentifier(), unset);
    }
  }, {
    key: '_getPendingOps',
    value: function () {
      var stateController = _CoreManager2.default.getObjectStateController();
      return stateController.getPendingOps(this._getStateIdentifier());
    }
  }, {
    key: '_clearPendingOps',
    value: function () {
      var pending = this._getPendingOps();
      var latest = pending[pending.length - 1];
      var keys = (0, _keys2.default)(latest);
      keys.forEach(function (key) {
        delete latest[key];
      });
    }
  }, {
    key: '_getDirtyObjectAttributes',
    value: function () {
      var attributes = this.attributes;
      var stateController = _CoreManager2.default.getObjectStateController();
      var objectCache = stateController.getObjectCache(this._getStateIdentifier());
      var dirty = {};
      for (var attr in attributes) {
        var val = attributes[attr];
        if (val && (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object' && !(val instanceof ParseObject) && !(val instanceof _ParseFile2.default) && !(val instanceof _ParseRelation2.default)) {
          // Due to the way browsers construct maps, the key order will not change
          // unless the object is changed
          try {
            var json = (0, _encode2.default)(val, false, true);
            var stringified = (0, _stringify2.default)(json);
            if (objectCache[attr] !== stringified) {
              dirty[attr] = val;
            }
          } catch (e) {
            // Error occurred, possibly by a nested unsaved pointer in a mutable container
            // No matter how it happened, it indicates a change in the attribute
            dirty[attr] = val;
          }
        }
      }
      return dirty;
    }
  }, {
    key: '_toFullJSON',
    value: function (seen) {
      var json = this.toJSON(seen);
      json.__type = 'Object';
      json.className = this.className;
      return json;
    }
  }, {
    key: '_getSaveJSON',
    value: function () {
      var pending = this._getPendingOps();
      var dirtyObjects = this._getDirtyObjectAttributes();
      var json = {};

      for (var attr in dirtyObjects) {
        json[attr] = new _ParseOp.SetOp(dirtyObjects[attr]).toJSON();
      }
      for (attr in pending[0]) {
        json[attr] = pending[0][attr].toJSON();
      }
      return json;
    }
  }, {
    key: '_getSaveParams',
    value: function () {
      var method = this.id ? 'PUT' : 'POST';
      var body = this._getSaveJSON();
      var path = 'classes/' + this.className;
      if (this.id) {
        path += '/' + this.id;
      } else if (this.className === '_User') {
        path = 'users';
      }
      return {
        method: method,
        body: body,
        path: path
      };
    }
  }, {
    key: '_finishFetch',
    value: function (serverData) {
      if (!this.id && serverData.objectId) {
        this.id = serverData.objectId;
      }
      var stateController = _CoreManager2.default.getObjectStateController();
      stateController.initializeState(this._getStateIdentifier());
      var decoded = {};
      for (var attr in serverData) {
        if (attr === 'ACL') {
          decoded[attr] = new _ParseACL2.default(serverData[attr]);
        } else if (attr !== 'objectId') {
          decoded[attr] = (0, _decode2.default)(serverData[attr]);
          if (decoded[attr] instanceof _ParseRelation2.default) {
            decoded[attr]._ensureParentAndKey(this, attr);
          }
        }
      }
      if (decoded.createdAt && typeof decoded.createdAt === 'string') {
        decoded.createdAt = (0, _parseDate2.default)(decoded.createdAt);
      }
      if (decoded.updatedAt && typeof decoded.updatedAt === 'string') {
        decoded.updatedAt = (0, _parseDate2.default)(decoded.updatedAt);
      }
      if (!decoded.updatedAt && decoded.createdAt) {
        decoded.updatedAt = decoded.createdAt;
      }
      stateController.commitServerChanges(this._getStateIdentifier(), decoded);
    }
  }, {
    key: '_setExisted',
    value: function (existed) {
      var stateController = _CoreManager2.default.getObjectStateController();
      var state = stateController.getState(this._getStateIdentifier());
      if (state) {
        state.existed = existed;
      }
    }
  }, {
    key: '_migrateId',
    value: function (serverId) {
      if (this._localId && serverId) {
        if (singleInstance) {
          var stateController = _CoreManager2.default.getObjectStateController();
          var oldState = stateController.removeState(this._getStateIdentifier());
          this.id = serverId;
          delete this._localId;
          if (oldState) {
            stateController.initializeState(this._getStateIdentifier(), oldState);
          }
        } else {
          this.id = serverId;
          delete this._localId;
        }
      }
    }
  }, {
    key: '_handleSaveResponse',
    value: function (response, status) {
      var changes = {};

      var stateController = _CoreManager2.default.getObjectStateController();
      var pending = stateController.popPendingState(this._getStateIdentifier());
      for (var attr in pending) {
        if (pending[attr] instanceof _ParseOp.RelationOp) {
          changes[attr] = pending[attr].applyTo(undefined, this, attr);
        } else if (!(attr in response)) {
          // Only SetOps and UnsetOps should not come back with results
          changes[attr] = pending[attr].applyTo(undefined);
        }
      }
      for (attr in response) {
        if ((attr === 'createdAt' || attr === 'updatedAt') && typeof response[attr] === 'string') {
          changes[attr] = (0, _parseDate2.default)(response[attr]);
        } else if (attr === 'ACL') {
          changes[attr] = new _ParseACL2.default(response[attr]);
        } else if (attr !== 'objectId') {
          changes[attr] = (0, _decode2.default)(response[attr]);
          if (changes[attr] instanceof _ParseOp.UnsetOp) {
            changes[attr] = undefined;
          }
        }
      }
      if (changes.createdAt && !changes.updatedAt) {
        changes.updatedAt = changes.createdAt;
      }

      this._migrateId(response.objectId);

      if (status !== 201) {
        this._setExisted(true);
      }

      stateController.commitServerChanges(this._getStateIdentifier(), changes);
    }
  }, {
    key: '_handleSaveError',
    value: function () {
      this._getPendingOps();

      var stateController = _CoreManager2.default.getObjectStateController();
      stateController.mergeFirstPendingState(this._getStateIdentifier());
    }

    /** Public methods **/

  }, {
    key: 'initialize',
    value: function () {}
    // NOOP


    /**
     * Returns a JSON version of the object suitable for saving to Parse.
     * @return {Object}
     */

  }, {
    key: 'toJSON',
    value: function (seen) {
      var seenEntry = this.id ? this.className + ':' + this.id : this;
      var seen = seen || [seenEntry];
      var json = {};
      var attrs = this.attributes;
      for (var attr in attrs) {
        if ((attr === 'createdAt' || attr === 'updatedAt') && attrs[attr].toJSON) {
          json[attr] = attrs[attr].toJSON();
        } else {
          json[attr] = (0, _encode2.default)(attrs[attr], false, false, seen);
        }
      }
      var pending = this._getPendingOps();
      for (var attr in pending[0]) {
        json[attr] = pending[0][attr].toJSON();
      }

      if (this.id) {
        json.objectId = this.id;
      }
      return json;
    }

    /**
     * Determines whether this ParseObject is equal to another ParseObject
     * @param {Object} other - An other object ot compare
     * @return {Boolean}
     */

  }, {
    key: 'equals',
    value: function (other) {
      if (this === other) {
        return true;
      }
      return other instanceof ParseObject && this.className === other.className && this.id === other.id && typeof this.id !== 'undefined';
    }

    /**
     * Returns true if this object has been modified since its last
     * save/refresh.  If an attribute is specified, it returns true only if that
     * particular attribute has been modified since the last save/refresh.
     * @param {String} attr An attribute name (optional).
     * @return {Boolean}
     */

  }, {
    key: 'dirty',
    value: function (attr) {
      if (!this.id) {
        return true;
      }
      var pendingOps = this._getPendingOps();
      var dirtyObjects = this._getDirtyObjectAttributes();
      if (attr) {
        if (dirtyObjects.hasOwnProperty(attr)) {
          return true;
        }
        for (var i = 0; i < pendingOps.length; i++) {
          if (pendingOps[i].hasOwnProperty(attr)) {
            return true;
          }
        }
        return false;
      }
      if ((0, _keys2.default)(pendingOps[0]).length !== 0) {
        return true;
      }
      if ((0, _keys2.default)(dirtyObjects).length !== 0) {
        return true;
      }
      return false;
    }

    /**
     * Returns an array of keys that have been modified since last save/refresh
     * @return {String[]}
     */

  }, {
    key: 'dirtyKeys',
    value: function () {
      var pendingOps = this._getPendingOps();
      var keys = {};
      for (var i = 0; i < pendingOps.length; i++) {
        for (var attr in pendingOps[i]) {
          keys[attr] = true;
        }
      }
      var dirtyObjects = this._getDirtyObjectAttributes();
      for (var attr in dirtyObjects) {
        keys[attr] = true;
      }
      return (0, _keys2.default)(keys);
    }

    /**
     * Gets a Pointer referencing this Object.
     * @return {Pointer}
     */

  }, {
    key: 'toPointer',
    value: function () {
      if (!this.id) {
        throw new Error('Cannot create a pointer to an unsaved ParseObject');
      }
      return {
        __type: 'Pointer',
        className: this.className,
        objectId: this.id
      };
    }

    /**
     * Gets the value of an attribute.
     * @param {String} attr The string name of an attribute.
     */

  }, {
    key: 'get',
    value: function (attr) {
      return this.attributes[attr];
    }

    /**
     * Gets a relation on the given class for the attribute.
     * @param String attr The attribute to get the relation for.
     * @return {Parse.Relation}
     */

  }, {
    key: 'relation',
    value: function (attr) {
      var value = this.get(attr);
      if (value) {
        if (!(value instanceof _ParseRelation2.default)) {
          throw new Error('Called relation() on non-relation field ' + attr);
        }
        value._ensureParentAndKey(this, attr);
        return value;
      }
      return new _ParseRelation2.default(this, attr);
    }

    /**
     * Gets the HTML-escaped value of an attribute.
     * @param {String} attr The string name of an attribute.
     */

  }, {
    key: 'escape',
    value: function (attr) {
      var val = this.attributes[attr];
      if (val == null) {
        return '';
      }

      if (typeof val !== 'string') {
        if (typeof val.toString !== 'function') {
          return '';
        }
        val = val.toString();
      }
      return (0, _escape3.default)(val);
    }

    /**
     * Returns <code>true</code> if the attribute contains a value that is not
     * null or undefined.
     * @param {String} attr The string name of the attribute.
     * @return {Boolean}
     */

  }, {
    key: 'has',
    value: function (attr) {
      var attributes = this.attributes;
      if (attributes.hasOwnProperty(attr)) {
        return attributes[attr] != null;
      }
      return false;
    }

    /**
     * Sets a hash of model attributes on the object.
     *
     * <p>You can call it with an object containing keys and values, or with one
     * key and value.  For example:<pre>
     *   gameTurn.set({
     *     player: player1,
     *     diceRoll: 2
     *   }, {
     *     error: function(gameTurnAgain, error) {
     *       // The set failed validation.
     *     }
     *   });
     *
     *   game.set("currentPlayer", player2, {
     *     error: function(gameTurnAgain, error) {
     *       // The set failed validation.
     *     }
     *   });
     *
     *   game.set("finished", true);</pre></p>
     *
     * @param {String} key The key to set.
     * @param {} value The value to give it.
     * @param {Object} options A set of options for the set.
     *     The only supported option is <code>error</code>.
     * @return {Boolean} true if the set succeeded.
     */

  }, {
    key: 'set',
    value: function (key, value, options) {
      var changes = {};
      var newOps = {};
      if (key && (typeof key === 'undefined' ? 'undefined' : (0, _typeof3.default)(key)) === 'object') {
        changes = key;
        options = value;
      } else if (typeof key === 'string') {
        changes[key] = value;
      } else {
        return this;
      }

      options = options || {};
      var readonly = [];
      if (typeof this.constructor.readOnlyAttributes === 'function') {
        readonly = readonly.concat(this.constructor.readOnlyAttributes());
      }
      for (var k in changes) {
        if (k === 'createdAt' || k === 'updatedAt') {
          // This property is read-only, but for legacy reasons we silently
          // ignore it
          continue;
        }
        if (readonly.indexOf(k) > -1) {
          throw new Error('Cannot modify readonly attribute: ' + k);
        }
        if (options.unset) {
          newOps[k] = new _ParseOp.UnsetOp();
        } else if (changes[k] instanceof _ParseOp.Op) {
          newOps[k] = changes[k];
        } else if (changes[k] && (0, _typeof3.default)(changes[k]) === 'object' && typeof changes[k].__op === 'string') {
          newOps[k] = (0, _ParseOp.opFromJSON)(changes[k]);
        } else if (k === 'objectId' || k === 'id') {
          if (typeof changes[k] === 'string') {
            this.id = changes[k];
          }
        } else if (k === 'ACL' && (0, _typeof3.default)(changes[k]) === 'object' && !(changes[k] instanceof _ParseACL2.default)) {
          newOps[k] = new _ParseOp.SetOp(new _ParseACL2.default(changes[k]));
        } else {
          newOps[k] = new _ParseOp.SetOp(changes[k]);
        }
      }

      // Calculate new values
      var currentAttributes = this.attributes;
      var newValues = {};
      for (var attr in newOps) {
        if (newOps[attr] instanceof _ParseOp.RelationOp) {
          newValues[attr] = newOps[attr].applyTo(currentAttributes[attr], this, attr);
        } else if (!(newOps[attr] instanceof _ParseOp.UnsetOp)) {
          newValues[attr] = newOps[attr].applyTo(currentAttributes[attr]);
        }
      }

      // Validate changes
      if (!options.ignoreValidation) {
        var validation = this.validate(newValues);
        if (validation) {
          if (typeof options.error === 'function') {
            options.error(this, validation);
          }
          return false;
        }
      }

      // Consolidate Ops
      var pendingOps = this._getPendingOps();
      var last = pendingOps.length - 1;
      var stateController = _CoreManager2.default.getObjectStateController();
      for (var attr in newOps) {
        var nextOp = newOps[attr].mergeWith(pendingOps[last][attr]);
        stateController.setPendingOp(this._getStateIdentifier(), attr, nextOp);
      }

      return this;
    }

    /**
     * Remove an attribute from the model. This is a noop if the attribute doesn't
     * exist.
     * @param {String} attr The string name of an attribute.
     */

  }, {
    key: 'unset',
    value: function (attr, options) {
      options = options || {};
      options.unset = true;
      return this.set(attr, null, options);
    }

    /**
     * Atomically increments the value of the given attribute the next time the
     * object is saved. If no amount is specified, 1 is used by default.
     *
     * @param attr {String} The key.
     * @param amount {Number} The amount to increment by (optional).
     */

  }, {
    key: 'increment',
    value: function (attr, amount) {
      if (typeof amount === 'undefined') {
        amount = 1;
      }
      if (typeof amount !== 'number') {
        throw new Error('Cannot increment by a non-numeric amount.');
      }
      return this.set(attr, new _ParseOp.IncrementOp(amount));
    }

    /**
     * Atomically add an object to the end of the array associated with a given
     * key.
     * @param attr {String} The key.
     * @param item {} The item to add.
     * @return {(ParseObject|Boolean)}
     */

  }, {
    key: 'add',
    value: function (attr, item) {
      return this.set(attr, new _ParseOp.AddOp([item]));
    }

    /**
     * Atomically add the objects to the end of the array associated with a given
     * key.
     * @param attr {String} The key.
     * @param items {Object[]} The items to add.
     */

  }, {
    key: 'addAll',
    value: function (attr, items) {
      return this.set(attr, new _ParseOp.AddOp(items));
    }

    /**
     * Atomically add an object to the array associated with a given key, only
     * if it is not already present in the array. The position of the insert is
     * not guaranteed.
     *
     * @param attr {String} The key.
     * @param item {} The object to add.
     */

  }, {
    key: 'addUnique',
    value: function (attr, item) {
      return this.set(attr, new _ParseOp.AddUniqueOp([item]));
    }

    /**
     * Atomically add the objects to the array associated with a given key, only
     * if it is not already present in the array. The position of the insert is
     * not guaranteed.
     *
     * @param attr {String} The key.
     * @param items {Object[]} The objects to add.
     */

  }, {
    key: 'addAllUnique',
    value: function (attr, items) {
      return this.set(attr, new _ParseOp.AddUniqueOp(items));
    }

    /**
     * Atomically remove all instances of an object from the array associated
     * with a given key.
     *
     * @param attr {String} The key.
     * @param item {} The object to remove.
     */

  }, {
    key: 'remove',
    value: function (attr, item) {
      return this.set(attr, new _ParseOp.RemoveOp([item]));
    }

    /**
     * Atomically remove all instances of the objects from the array associated
     * with a given key.
     *
     * @param attr {String} The key.
     * @param items {Object[]} The object to remove.
     */

  }, {
    key: 'removeAll',
    value: function (attr, items) {
      return this.set(attr, new _ParseOp.RemoveOp(items));
    }

    /**
     * Returns an instance of a subclass of Parse.Op describing what kind of
     * modification has been performed on this field since the last time it was
     * saved. For example, after calling object.increment("x"), calling
     * object.op("x") would return an instance of Parse.Op.Increment.
     *
     * @param attr {String} The key.
     * @returns {Parse.Op} The operation, or undefined if none.
     */

  }, {
    key: 'op',
    value: function (attr) {
      var pending = this._getPendingOps();
      for (var i = pending.length; i--;) {
        if (pending[i][attr]) {
          return pending[i][attr];
        }
      }
    }

    /**
     * Creates a new model with identical attributes to this one, similar to Backbone.Model's clone()
     * @return {Parse.Object}
     */

  }, {
    key: 'clone',
    value: function () {
      var clone = new this.constructor();
      if (!clone.className) {
        clone.className = this.className;
      }
      var attributes = this.attributes;
      if (typeof this.constructor.readOnlyAttributes === 'function') {
        var readonly = this.constructor.readOnlyAttributes() || [];
        // Attributes are frozen, so we have to rebuild an object,
        // rather than delete readonly keys
        var copy = {};
        for (var a in attributes) {
          if (readonly.indexOf(a) < 0) {
            copy[a] = attributes[a];
          }
        }
        attributes = copy;
      }
      if (clone.set) {
        clone.set(attributes);
      }
      return clone;
    }

    /**
     * Creates a new instance of this object. Not to be confused with clone()
     * @return {Parse.Object}
     */

  }, {
    key: 'newInstance',
    value: function () {
      var clone = new this.constructor();
      if (!clone.className) {
        clone.className = this.className;
      }
      clone.id = this.id;
      if (singleInstance) {
        // Just return an object with the right id
        return clone;
      }

      var stateController = _CoreManager2.default.getObjectStateController();
      if (stateController) {
        stateController.duplicateState(this._getStateIdentifier(), clone._getStateIdentifier());
      }
      return clone;
    }

    /**
     * Returns true if this object has never been saved to Parse.
     * @return {Boolean}
     */

  }, {
    key: 'isNew',
    value: function () {
      return !this.id;
    }

    /**
     * Returns true if this object was created by the Parse server when the
     * object might have already been there (e.g. in the case of a Facebook
     * login)
     * @return {Boolean}
     */

  }, {
    key: 'existed',
    value: function () {
      if (!this.id) {
        return false;
      }
      var stateController = _CoreManager2.default.getObjectStateController();
      var state = stateController.getState(this._getStateIdentifier());
      if (state) {
        return state.existed;
      }
      return false;
    }

    /**
     * Checks if the model is currently in a valid state.
     * @return {Boolean}
     */

  }, {
    key: 'isValid',
    value: function () {
      return !this.validate(this.attributes);
    }

    /**
     * You should not call this function directly unless you subclass
     * <code>Parse.Object</code>, in which case you can override this method
     * to provide additional validation on <code>set</code> and
     * <code>save</code>.  Your implementation should return
     *
     * @param {Object} attrs The current data to validate.
     * @return {} False if the data is valid.  An error object otherwise.
     * @see Parse.Object#set
     */

  }, {
    key: 'validate',
    value: function (attrs) {
      if (attrs.hasOwnProperty('ACL') && !(attrs.ACL instanceof _ParseACL2.default)) {
        return new _ParseError2.default(_ParseError2.default.OTHER_CAUSE, 'ACL must be a Parse ACL.');
      }
      for (var key in attrs) {
        if (!/^[A-Za-z][0-9A-Za-z_]*$/.test(key)) {
          return new _ParseError2.default(_ParseError2.default.INVALID_KEY_NAME);
        }
      }
      return false;
    }

    /**
     * Returns the ACL for this object.
     * @returns {Parse.ACL} An instance of Parse.ACL.
     * @see Parse.Object#get
     */

  }, {
    key: 'getACL',
    value: function () {
      var acl = this.get('ACL');
      if (acl instanceof _ParseACL2.default) {
        return acl;
      }
      return null;
    }

    /**
     * Sets the ACL to be used for this object.
     * @param {Parse.ACL} acl An instance of Parse.ACL.
     * @param {Object} options Optional Backbone-like options object to be
     *     passed in to set.
     * @return {Boolean} Whether the set passed validation.
     * @see Parse.Object#set
     */

  }, {
    key: 'setACL',
    value: function (acl, options) {
      return this.set('ACL', acl, options);
    }

    /**
     * Clears any changes to this object made since the last call to save()
     */

  }, {
    key: 'revert',
    value: function () {
      this._clearPendingOps();
    }

    /**
     * Clears all attributes on a model
     * @return {(ParseObject | boolean)}
     */

  }, {
    key: 'clear',
    value: function () {
      var attributes = this.attributes;
      var erasable = {};
      var readonly = ['createdAt', 'updatedAt'];
      if (typeof this.constructor.readOnlyAttributes === 'function') {
        readonly = readonly.concat(this.constructor.readOnlyAttributes());
      }
      for (var attr in attributes) {
        if (readonly.indexOf(attr) < 0) {
          erasable[attr] = true;
        }
      }
      return this.set(erasable, { unset: true });
    }

    /**
     * Fetch the model from the server. If the server's representation of the
     * model differs from its current attributes, they will be overriden.
     *
     * @param {Object} options A Backbone-style callback object.
     * Valid options are:<ul>
     *   <li>success: A Backbone-style success callback.
     *   <li>error: An Backbone-style error callback.
     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
     *     be used for this request.
     *   <li>sessionToken: A valid session token, used for making a request on
     *       behalf of a specific user.
     * </ul>
     * @return {Parse.Promise} A promise that is fulfilled when the fetch
     *     completes.
     */

  }, {
    key: 'fetch',
    value: function (options) {
      options = options || {};
      var fetchOptions = {};
      if (options.hasOwnProperty('useMasterKey')) {
        fetchOptions.useMasterKey = options.useMasterKey;
      }
      if (options.hasOwnProperty('sessionToken')) {
        fetchOptions.sessionToken = options.sessionToken;
      }
      var controller = _CoreManager2.default.getObjectController();
      return controller.fetch(this, true, fetchOptions)._thenRunCallbacks(options);
    }

    /**
     * Set a hash of model attributes, and save the model to the server.
     * updatedAt will be updated when the request returns.
     * You can either call it as:<pre>
     *   object.save();</pre>
     * or<pre>
     *   object.save(null, options);</pre>
     * or<pre>
     *   object.save(attrs, options);</pre>
     * or<pre>
     *   object.save(key, value, options);</pre>
     *
     * For example, <pre>
     *   gameTurn.save({
     *     player: "Jake Cutter",
     *     diceRoll: 2
     *   }, {
     *     success: function(gameTurnAgain) {
     *       // The save was successful.
     *     },
     *     error: function(gameTurnAgain, error) {
     *       // The save failed.  Error is an instance of Parse.Error.
     *     }
     *   });</pre>
     * or with promises:<pre>
     *   gameTurn.save({
     *     player: "Jake Cutter",
     *     diceRoll: 2
     *   }).then(function(gameTurnAgain) {
     *     // The save was successful.
     *   }, function(error) {
     *     // The save failed.  Error is an instance of Parse.Error.
     *   });</pre>
     *
     * @param {Object} options A Backbone-style callback object.
     * Valid options are:<ul>
     *   <li>success: A Backbone-style success callback.
     *   <li>error: An Backbone-style error callback.
     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
     *     be used for this request.
     *   <li>sessionToken: A valid session token, used for making a request on
     *       behalf of a specific user.
     * </ul>
     * @return {Parse.Promise} A promise that is fulfilled when the save
     *     completes.
     */

  }, {
    key: 'save',
    value: function (arg1, arg2, arg3) {
      var _this = this;

      var attrs;
      var options;
      if ((typeof arg1 === 'undefined' ? 'undefined' : (0, _typeof3.default)(arg1)) === 'object' || typeof arg1 === 'undefined') {
        attrs = arg1;
        if ((typeof arg2 === 'undefined' ? 'undefined' : (0, _typeof3.default)(arg2)) === 'object') {
          options = arg2;
        }
      } else {
        attrs = {};
        attrs[arg1] = arg2;
        options = arg3;
      }

      // Support save({ success: function() {}, error: function() {} })
      if (!options && attrs) {
        options = {};
        if (typeof attrs.success === 'function') {
          options.success = attrs.success;
          delete attrs.success;
        }
        if (typeof attrs.error === 'function') {
          options.error = attrs.error;
          delete attrs.error;
        }
      }

      if (attrs) {
        var validation = this.validate(attrs);
        if (validation) {
          if (options && typeof options.error === 'function') {
            options.error(this, validation);
          }
          return _ParsePromise2.default.error(validation);
        }
        this.set(attrs, options);
      }

      options = options || {};
      var saveOptions = {};
      if (options.hasOwnProperty('useMasterKey')) {
        saveOptions.useMasterKey = !!options.useMasterKey;
      }
      if (options.hasOwnProperty('sessionToken') && typeof options.sessionToken === 'string') {
        saveOptions.sessionToken = options.sessionToken;
      }

      var controller = _CoreManager2.default.getObjectController();
      var unsaved = (0, _unsavedChildren2.default)(this);
      return controller.save(unsaved, saveOptions).then(function () {
        return controller.save(_this, saveOptions);
      })._thenRunCallbacks(options, this);
    }

    /**
     * Destroy this model on the server if it was already persisted.
     * If `wait: true` is passed, waits for the server to respond
     * before removal.
     *
     * @param {Object} options A Backbone-style callback object.
     * Valid options are:<ul>
     *   <li>success: A Backbone-style success callback
     *   <li>error: An Backbone-style error callback.
     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
     *     be used for this request.
     *   <li>sessionToken: A valid session token, used for making a request on
     *       behalf of a specific user.
     * </ul>
     * @return {Parse.Promise} A promise that is fulfilled when the destroy
     *     completes.
     */

  }, {
    key: 'destroy',
    value: function (options) {
      options = options || {};
      var destroyOptions = {};
      if (options.hasOwnProperty('useMasterKey')) {
        destroyOptions.useMasterKey = options.useMasterKey;
      }
      if (options.hasOwnProperty('sessionToken')) {
        destroyOptions.sessionToken = options.sessionToken;
      }
      if (!this.id) {
        return _ParsePromise2.default.as()._thenRunCallbacks(options);
      }
      return _CoreManager2.default.getObjectController().destroy(this, destroyOptions)._thenRunCallbacks(options);
    }

    /** Static methods **/

  }, {
    key: 'attributes',

    /** Prototype getters / setters **/

    get: function () {
      var stateController = _CoreManager2.default.getObjectStateController();
      return (0, _freeze2.default)(stateController.estimateAttributes(this._getStateIdentifier()));
    }

    /**
     * The first time this object was saved on the server.
     * @property createdAt
     * @type Date
     */

  }, {
    key: 'createdAt',
    get: function () {
      return this._getServerData().createdAt;
    }

    /**
     * The last time this object was updated on the server.
     * @property updatedAt
     * @type Date
     */

  }, {
    key: 'updatedAt',
    get: function () {
      return this._getServerData().updatedAt;
    }
  }], [{
    key: '_clearAllState',
    value: function () {
      var stateController = _CoreManager2.default.getObjectStateController();
      stateController.clearAllState();
    }

    /**
     * Fetches the given list of Parse.Object.
     * If any error is encountered, stops and calls the error handler.
     *
     * <pre>
     *   Parse.Object.fetchAll([object1, object2, ...], {
     *     success: function(list) {
     *       // All the objects were fetched.
     *     },
     *     error: function(error) {
     *       // An error occurred while fetching one of the objects.
     *     },
     *   });
     * </pre>
     *
     * @param {Array} list A list of <code>Parse.Object</code>.
     * @param {Object} options A Backbone-style callback object.
     * @static
     * Valid options are:<ul>
     *   <li>success: A Backbone-style success callback.
     *   <li>error: An Backbone-style error callback.
     * </ul>
     */

  }, {
    key: 'fetchAll',
    value: function (list, options) {
      var options = options || {};

      var queryOptions = {};
      if (options.hasOwnProperty('useMasterKey')) {
        queryOptions.useMasterKey = options.useMasterKey;
      }
      if (options.hasOwnProperty('sessionToken')) {
        queryOptions.sessionToken = options.sessionToken;
      }
      return _CoreManager2.default.getObjectController().fetch(list, true, queryOptions)._thenRunCallbacks(options);
    }

    /**
     * Fetches the given list of Parse.Object if needed.
     * If any error is encountered, stops and calls the error handler.
     *
     * <pre>
     *   Parse.Object.fetchAllIfNeeded([object1, ...], {
     *     success: function(list) {
     *       // Objects were fetched and updated.
     *     },
     *     error: function(error) {
     *       // An error occurred while fetching one of the objects.
     *     },
     *   });
     * </pre>
     *
     * @param {Array} list A list of <code>Parse.Object</code>.
     * @param {Object} options A Backbone-style callback object.
     * @static
     * Valid options are:<ul>
     *   <li>success: A Backbone-style success callback.
     *   <li>error: An Backbone-style error callback.
     * </ul>
     */

  }, {
    key: 'fetchAllIfNeeded',
    value: function (list, options) {
      var options = options || {};

      var queryOptions = {};
      if (options.hasOwnProperty('useMasterKey')) {
        queryOptions.useMasterKey = options.useMasterKey;
      }
      if (options.hasOwnProperty('sessionToken')) {
        queryOptions.sessionToken = options.sessionToken;
      }
      return _CoreManager2.default.getObjectController().fetch(list, false, queryOptions)._thenRunCallbacks(options);
    }

    /**
     * Destroy the given list of models on the server if it was already persisted.
     *
     * <p>Unlike saveAll, if an error occurs while deleting an individual model,
     * this method will continue trying to delete the rest of the models if
     * possible, except in the case of a fatal error like a connection error.
     *
     * <p>In particular, the Parse.Error object returned in the case of error may
     * be one of two types:
     *
     * <ul>
     *   <li>A Parse.Error.AGGREGATE_ERROR. This object's "errors" property is an
     *       array of other Parse.Error objects. Each error object in this array
     *       has an "object" property that references the object that could not be
     *       deleted (for instance, because that object could not be found).</li>
     *   <li>A non-aggregate Parse.Error. This indicates a serious error that
     *       caused the delete operation to be aborted partway through (for
     *       instance, a connection failure in the middle of the delete).</li>
     * </ul>
     *
     * <pre>
     *   Parse.Object.destroyAll([object1, object2, ...], {
     *     success: function() {
     *       // All the objects were deleted.
     *     },
     *     error: function(error) {
     *       // An error occurred while deleting one or more of the objects.
     *       // If this is an aggregate error, then we can inspect each error
     *       // object individually to determine the reason why a particular
     *       // object was not deleted.
     *       if (error.code === Parse.Error.AGGREGATE_ERROR) {
     *         for (var i = 0; i < error.errors.length; i++) {
     *           console.log("Couldn't delete " + error.errors[i].object.id +
     *             "due to " + error.errors[i].message);
     *         }
     *       } else {
     *         console.log("Delete aborted because of " + error.message);
     *       }
     *     },
     *   });
     * </pre>
     *
     * @param {Array} list A list of <code>Parse.Object</code>.
     * @param {Object} options A Backbone-style callback object.
     * @static
     * Valid options are:<ul>
     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
     *     be used for this request.
     *   <li>sessionToken: A valid session token, used for making a request on
     *       behalf of a specific user.
     * </ul>
     * @return {Parse.Promise} A promise that is fulfilled when the destroyAll
     *     completes.
     */

  }, {
    key: 'destroyAll',
    value: function (list, options) {
      var options = options || {};

      var destroyOptions = {};
      if (options.hasOwnProperty('useMasterKey')) {
        destroyOptions.useMasterKey = options.useMasterKey;
      }
      if (options.hasOwnProperty('sessionToken')) {
        destroyOptions.sessionToken = options.sessionToken;
      }
      return _CoreManager2.default.getObjectController().destroy(list, destroyOptions)._thenRunCallbacks(options);
    }

    /**
     * Saves the given list of Parse.Object.
     * If any error is encountered, stops and calls the error handler.
     *
     * <pre>
     *   Parse.Object.saveAll([object1, object2, ...], {
     *     success: function(list) {
     *       // All the objects were saved.
     *     },
     *     error: function(error) {
     *       // An error occurred while saving one of the objects.
     *     },
     *   });
     * </pre>
     *
     * @param {Array} list A list of <code>Parse.Object</code>.
     * @param {Object} options A Backbone-style callback object.
     * @static
     * Valid options are:<ul>
     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
     *     be used for this request.
     *   <li>sessionToken: A valid session token, used for making a request on
     *       behalf of a specific user.
     * </ul>
     */

  }, {
    key: 'saveAll',
    value: function (list, options) {
      var options = options || {};

      var saveOptions = {};
      if (options.hasOwnProperty('useMasterKey')) {
        saveOptions.useMasterKey = options.useMasterKey;
      }
      if (options.hasOwnProperty('sessionToken')) {
        saveOptions.sessionToken = options.sessionToken;
      }
      return _CoreManager2.default.getObjectController().save(list, saveOptions)._thenRunCallbacks(options);
    }

    /**
     * Creates a reference to a subclass of Parse.Object with the given id. This
     * does not exist on Parse.Object, only on subclasses.
     *
     * <p>A shortcut for: <pre>
     *  var Foo = Parse.Object.extend("Foo");
     *  var pointerToFoo = new Foo();
     *  pointerToFoo.id = "myObjectId";
     * </pre>
     *
     * @param {String} id The ID of the object to create a reference to.
     * @static
     * @return {Parse.Object} A Parse.Object reference.
     */

  }, {
    key: 'createWithoutData',
    value: function (id) {
      var obj = new this();
      obj.id = id;
      return obj;
    }

    /**
     * Creates a new instance of a Parse Object from a JSON representation.
     * @param {Object} json The JSON map of the Object's data
     * @param {boolean} override In single instance mode, all old server data
     *   is overwritten if this is set to true
     * @static
     * @return {Parse.Object} A Parse.Object reference
     */

  }, {
    key: 'fromJSON',
    value: function (json, override) {
      if (!json.className) {
        throw new Error('Cannot create an object without a className');
      }
      var constructor = classMap[json.className];
      var o = constructor ? new constructor() : new ParseObject(json.className);
      var otherAttributes = {};
      for (var attr in json) {
        if (attr !== 'className' && attr !== '__type') {
          otherAttributes[attr] = json[attr];
        }
      }
      if (override) {
        // id needs to be set before clearServerData can work
        if (otherAttributes.objectId) {
          o.id = otherAttributes.objectId;
        }
        var preserved = null;
        if (typeof o._preserveFieldsOnFetch === 'function') {
          preserved = o._preserveFieldsOnFetch();
        }
        o._clearServerData();
        if (preserved) {
          o._finishFetch(preserved);
        }
      }
      o._finishFetch(otherAttributes);
      if (json.objectId) {
        o._setExisted(true);
      }
      return o;
    }

    /**
     * Registers a subclass of Parse.Object with a specific class name.
     * When objects of that class are retrieved from a query, they will be
     * instantiated with this subclass.
     * This is only necessary when using ES6 subclassing.
     * @param {String} className The class name of the subclass
     * @param {Class} constructor The subclass
     */

  }, {
    key: 'registerSubclass',
    value: function (className, constructor) {
      if (typeof className !== 'string') {
        throw new TypeError('The first argument must be a valid class name.');
      }
      if (typeof constructor === 'undefined') {
        throw new TypeError('You must supply a subclass constructor.');
      }
      if (typeof constructor !== 'function') {
        throw new TypeError('You must register the subclass constructor. ' + 'Did you attempt to register an instance of the subclass?');
      }
      classMap[className] = constructor;
      if (!constructor.className) {
        constructor.className = className;
      }
    }

    /**
     * Creates a new subclass of Parse.Object for the given Parse class name.
     *
     * <p>Every extension of a Parse class will inherit from the most recent
     * previous extension of that class. When a Parse.Object is automatically
     * created by parsing JSON, it will use the most recent extension of that
     * class.</p>
     *
     * <p>You should call either:<pre>
     *     var MyClass = Parse.Object.extend("MyClass", {
     *         <i>Instance methods</i>,
     *         initialize: function(attrs, options) {
     *             this.someInstanceProperty = [],
     *             <i>Other instance properties</i>
     *         }
     *     }, {
     *         <i>Class properties</i>
     *     });</pre>
     * or, for Backbone compatibility:<pre>
     *     var MyClass = Parse.Object.extend({
     *         className: "MyClass",
     *         <i>Instance methods</i>,
     *         initialize: function(attrs, options) {
     *             this.someInstanceProperty = [],
     *             <i>Other instance properties</i>
     *         }
     *     }, {
     *         <i>Class properties</i>
     *     });</pre></p>
     *
     * @param {String} className The name of the Parse class backing this model.
     * @param {Object} protoProps Instance properties to add to instances of the
     *     class returned from this method.
     * @param {Object} classProps Class properties to add the class returned from
     *     this method.
     * @return {Class} A new subclass of Parse.Object.
     */

  }, {
    key: 'extend',
    value: function (className, protoProps, classProps) {
      if (typeof className !== 'string') {
        if (className && typeof className.className === 'string') {
          return ParseObject.extend(className.className, className, protoProps);
        } else {
          throw new Error('Parse.Object.extend\'s first argument should be the className.');
        }
      }
      var adjustedClassName = className;

      if (adjustedClassName === 'User' && _CoreManager2.default.get('PERFORM_USER_REWRITE')) {
        adjustedClassName = '_User';
      }

      var parentProto = ParseObject.prototype;
      if (this.hasOwnProperty('__super__') && this.__super__) {
        parentProto = this.prototype;
      } else if (classMap[adjustedClassName]) {
        parentProto = classMap[adjustedClassName].prototype;
      }
      var ParseObjectSubclass = function (attributes, options) {
        this.className = adjustedClassName;
        this._objCount = objectCount++;
        // Enable legacy initializers
        if (typeof this.initialize === 'function') {
          this.initialize.apply(this, arguments);
        }

        if (attributes && (typeof attributes === 'undefined' ? 'undefined' : (0, _typeof3.default)(attributes)) === 'object') {
          if (!this.set(attributes || {}, options)) {
            throw new Error('Can\'t create an invalid Parse Object');
          }
        }
      };
      ParseObjectSubclass.className = adjustedClassName;
      ParseObjectSubclass.__super__ = parentProto;

      ParseObjectSubclass.prototype = (0, _create2.default)(parentProto, {
        constructor: {
          value: ParseObjectSubclass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });

      if (protoProps) {
        for (var prop in protoProps) {
          if (prop !== 'className') {
            (0, _defineProperty2.default)(ParseObjectSubclass.prototype, prop, {
              value: protoProps[prop],
              enumerable: false,
              writable: true,
              configurable: true
            });
          }
        }
      }

      if (classProps) {
        for (var prop in classProps) {
          if (prop !== 'className') {
            (0, _defineProperty2.default)(ParseObjectSubclass, prop, {
              value: classProps[prop],
              enumerable: false,
              writable: true,
              configurable: true
            });
          }
        }
      }

      ParseObjectSubclass.extend = function (name, protoProps, classProps) {
        if (typeof name === 'string') {
          return ParseObject.extend.call(ParseObjectSubclass, name, protoProps, classProps);
        }
        return ParseObject.extend.call(ParseObjectSubclass, adjustedClassName, name, protoProps);
      };
      ParseObjectSubclass.createWithoutData = ParseObject.createWithoutData;

      classMap[adjustedClassName] = ParseObjectSubclass;
      return ParseObjectSubclass;
    }

    /**
     * Enable single instance objects, where any local objects with the same Id
     * share the same attributes, and stay synchronized with each other.
     * This is disabled by default in server environments, since it can lead to
     * security issues.
     * @static
     */

  }, {
    key: 'enableSingleInstance',
    value: function () {
      singleInstance = true;
      _CoreManager2.default.setObjectStateController(SingleInstanceStateController);
    }

    /**
     * Disable single instance objects, where any local objects with the same Id
     * share the same attributes, and stay synchronized with each other.
     * When disabled, you can have two instances of the same object in memory
     * without them sharing attributes.
     * @static
     */

  }, {
    key: 'disableSingleInstance',
    value: function () {
      singleInstance = false;
      _CoreManager2.default.setObjectStateController(UniqueInstanceStateController);
    }
  }]);
  return ParseObject;
}();

var DefaultController = {
  fetch: function (target, forceFetch, options) {
    if (Array.isArray(target)) {
      if (target.length < 1) {
        return _ParsePromise2.default.as([]);
      }
      var objs = [];
      var ids = [];
      var className = null;
      var results = [];
      var error = null;
      target.forEach(function (el) {
        if (error) {
          return;
        }
        if (!className) {
          className = el.className;
        }
        if (className !== el.className) {
          error = new _ParseError2.default(_ParseError2.default.INVALID_CLASS_NAME, 'All objects should be of the same class');
        }
        if (!el.id) {
          error = new _ParseError2.default(_ParseError2.default.MISSING_OBJECT_ID, 'All objects must have an ID');
        }
        if (forceFetch || (0, _keys2.default)(el._getServerData()).length === 0) {
          ids.push(el.id);
          objs.push(el);
        }
        results.push(el);
      });
      if (error) {
        return _ParsePromise2.default.error(error);
      }
      var query = new _ParseQuery2.default(className);
      query.containedIn('objectId', ids);
      query._limit = ids.length;
      return query.find(options).then(function (objects) {
        var idMap = {};
        objects.forEach(function (o) {
          idMap[o.id] = o;
        });
        for (var i = 0; i < objs.length; i++) {
          var obj = objs[i];
          if (!obj || !obj.id || !idMap[obj.id]) {
            if (forceFetch) {
              return _ParsePromise2.default.error(new _ParseError2.default(_ParseError2.default.OBJECT_NOT_FOUND, 'All objects must exist on the server.'));
            }
          }
        }
        if (!singleInstance) {
          // If single instance objects are disabled, we need to replace the
          for (var i = 0; i < results.length; i++) {
            var obj = results[i];
            if (obj && obj.id && idMap[obj.id]) {
              var id = obj.id;
              obj._finishFetch(idMap[id].toJSON());
              results[i] = idMap[id];
            }
          }
        }
        return _ParsePromise2.default.as(results);
      });
    } else {
      var RESTController = _CoreManager2.default.getRESTController();
      return RESTController.request('GET', 'classes/' + target.className + '/' + target._getId(), {}, options).then(function (response) {
        if (target instanceof ParseObject) {
          target._clearPendingOps();
          target._clearServerData();
          target._finishFetch(response);
        }
        return target;
      });
    }
  },
  destroy: function (target, options) {
    var RESTController = _CoreManager2.default.getRESTController();
    if (Array.isArray(target)) {
      if (target.length < 1) {
        return _ParsePromise2.default.as([]);
      }
      var batches = [[]];
      target.forEach(function (obj) {
        if (!obj.id) {
          return;
        }
        batches[batches.length - 1].push(obj);
        if (batches[batches.length - 1].length >= 20) {
          batches.push([]);
        }
      });
      if (batches[batches.length - 1].length === 0) {
        // If the last batch is empty, remove it
        batches.pop();
      }
      var deleteCompleted = _ParsePromise2.default.as();
      var errors = [];
      batches.forEach(function (batch) {
        deleteCompleted = deleteCompleted.then(function () {
          return RESTController.request('POST', 'batch', {
            requests: batch.map(function (obj) {
              return {
                method: 'DELETE',
                path: getServerUrlPath() + 'classes/' + obj.className + '/' + obj._getId(),
                body: {}
              };
            })
          }, options).then(function (results) {
            for (var i = 0; i < results.length; i++) {
              if (results[i] && results[i].hasOwnProperty('error')) {
                var err = new _ParseError2.default(results[i].error.code, results[i].error.error);
                err.object = batch[i];
                errors.push(err);
              }
            }
          });
        });
      });
      return deleteCompleted.then(function () {
        if (errors.length) {
          var aggregate = new _ParseError2.default(_ParseError2.default.AGGREGATE_ERROR);
          aggregate.errors = errors;
          return _ParsePromise2.default.error(aggregate);
        }
        return _ParsePromise2.default.as(target);
      });
    } else if (target instanceof ParseObject) {
      return RESTController.request('DELETE', 'classes/' + target.className + '/' + target._getId(), {}, options).then(function () {
        return _ParsePromise2.default.as(target);
      });
    }
    return _ParsePromise2.default.as(target);
  },
  save: function (target, options) {
    var RESTController = _CoreManager2.default.getRESTController();
    var stateController = _CoreManager2.default.getObjectStateController();
    if (Array.isArray(target)) {
      if (target.length < 1) {
        return _ParsePromise2.default.as([]);
      }

      var unsaved = target.concat();
      for (var i = 0; i < target.length; i++) {
        if (target[i] instanceof ParseObject) {
          unsaved = unsaved.concat((0, _unsavedChildren2.default)(target[i], true));
        }
      }
      unsaved = (0, _unique2.default)(unsaved);

      var filesSaved = _ParsePromise2.default.as();
      var pending = [];
      unsaved.forEach(function (el) {
        if (el instanceof _ParseFile2.default) {
          filesSaved = filesSaved.then(function () {
            return el.save();
          });
        } else if (el instanceof ParseObject) {
          pending.push(el);
        }
      });

      return filesSaved.then(function () {
        var objectError = null;
        return _ParsePromise2.default._continueWhile(function () {
          return pending.length > 0;
        }, function () {
          var batch = [];
          var nextPending = [];
          pending.forEach(function (el) {
            if (batch.length < 20 && (0, _canBeSerialized2.default)(el)) {
              batch.push(el);
            } else {
              nextPending.push(el);
            }
          });
          pending = nextPending;
          if (batch.length < 1) {
            return _ParsePromise2.default.error(new _ParseError2.default(_ParseError2.default.OTHER_CAUSE, 'Tried to save a batch with a cycle.'));
          }

          // Queue up tasks for each object in the batch.
          // When every task is ready, the API request will execute
          var batchReturned = new _ParsePromise2.default();
          var batchReady = [];
          var batchTasks = [];
          batch.forEach(function (obj, index) {
            var ready = new _ParsePromise2.default();
            batchReady.push(ready);

            stateController.pushPendingState(obj._getStateIdentifier());
            batchTasks.push(stateController.enqueueTask(obj._getStateIdentifier(), function () {
              ready.resolve();
              return batchReturned.then(function (responses, status) {
                if (responses[index].hasOwnProperty('success')) {
                  obj._handleSaveResponse(responses[index].success, status);
                } else {
                  if (!objectError && responses[index].hasOwnProperty('error')) {
                    var serverError = responses[index].error;
                    objectError = new _ParseError2.default(serverError.code, serverError.error);
                    // Cancel the rest of the save
                    pending = [];
                  }
                  obj._handleSaveError();
                }
              });
            }));
          });

          _ParsePromise2.default.when(batchReady).then(function () {
            // Kick off the batch request
            return RESTController.request('POST', 'batch', {
              requests: batch.map(function (obj) {
                var params = obj._getSaveParams();
                params.path = getServerUrlPath() + params.path;
                return params;
              })
            }, options);
          }).then(function (response, status) {
            batchReturned.resolve(response, status);
          });

          return _ParsePromise2.default.when(batchTasks);
        }).then(function () {
          if (objectError) {
            return _ParsePromise2.default.error(objectError);
          }
          return _ParsePromise2.default.as(target);
        });
      });
    } else if (target instanceof ParseObject) {
      // copying target lets Flow guarantee the pointer isn't modified elsewhere
      var targetCopy = target;
      var task = function () {
        var params = targetCopy._getSaveParams();
        return RESTController.request(params.method, params.path, params.body, options).then(function (response, status) {
          targetCopy._handleSaveResponse(response, status);
        }, function (error) {
          targetCopy._handleSaveError();
          return _ParsePromise2.default.error(error);
        });
      };

      stateController.pushPendingState(target._getStateIdentifier());
      return stateController.enqueueTask(target._getStateIdentifier(), task).then(function () {
        return target;
      }, function (error) {
        return _ParsePromise2.default.error(error);
      });
    }
    return _ParsePromise2.default.as();
  }
};

_CoreManager2.default.setObjectController(DefaultController);

exports.default = ParseObject;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var config = {
  // Defaults
  IS_NODE: typeof process !== 'undefined' && !!process.versions && !!process.versions.node && !process.versions.electron,
  REQUEST_ATTEMPT_LIMIT: 5,
  SERVER_URL: 'https://api.parse.com/1',
  LIVEQUERY_SERVER_URL: null,
  VERSION: 'js' + '1.11.1',
  APPLICATION_ID: null,
  JAVASCRIPT_KEY: null,
  MASTER_KEY: null,
  USE_MASTER_KEY: false,
  PERFORM_USER_REWRITE: true,
  FORCE_REVOCABLE_SESSION: false
}; /*
    * Copyright (c) 2015-present, Parse, LLC.
    * All rights reserved.
    *
    * This source code is licensed under the BSD-style license found in the
    * LICENSE file in the root directory of this source tree. An additional grant
    * of patent rights can be found in the PATENTS file in the same directory.
    *
    * 
    */

function requireMethods(name, methods, controller) {
  methods.forEach(function (func) {
    if (typeof controller[func] !== 'function') {
      throw new Error(name + ' must implement ' + func + '()');
    }
  });
}

module.exports = {
  get: function (key) {
    if (config.hasOwnProperty(key)) {
      return config[key];
    }
    throw new Error('Configuration key not found: ' + key);
  },

  set: function (key, value) {
    config[key] = value;
  },

  /* Specialized Controller Setters/Getters */

  setAnalyticsController: function (controller) {
    requireMethods('AnalyticsController', ['track'], controller);
    config['AnalyticsController'] = controller;
  },
  getAnalyticsController: function () {
    return config['AnalyticsController'];
  },
  setCloudController: function (controller) {
    requireMethods('CloudController', ['run'], controller);
    config['CloudController'] = controller;
  },
  getCloudController: function () {
    return config['CloudController'];
  },
  setConfigController: function (controller) {
    requireMethods('ConfigController', ['current', 'get'], controller);
    config['ConfigController'] = controller;
  },
  getConfigController: function () {
    return config['ConfigController'];
  },
  setFileController: function (controller) {
    requireMethods('FileController', ['saveFile', 'saveBase64'], controller);
    config['FileController'] = controller;
  },
  getFileController: function () {
    return config['FileController'];
  },
  setInstallationController: function (controller) {
    requireMethods('InstallationController', ['currentInstallationId'], controller);
    config['InstallationController'] = controller;
  },
  getInstallationController: function () {
    return config['InstallationController'];
  },
  setObjectController: function (controller) {
    requireMethods('ObjectController', ['save', 'fetch', 'destroy'], controller);
    config['ObjectController'] = controller;
  },
  getObjectController: function () {
    return config['ObjectController'];
  },
  setObjectStateController: function (controller) {
    requireMethods('ObjectStateController', ['getState', 'initializeState', 'removeState', 'getServerData', 'setServerData', 'getPendingOps', 'setPendingOp', 'pushPendingState', 'popPendingState', 'mergeFirstPendingState', 'getObjectCache', 'estimateAttribute', 'estimateAttributes', 'commitServerChanges', 'enqueueTask', 'clearAllState'], controller);

    config['ObjectStateController'] = controller;
  },
  getObjectStateController: function () {
    return config['ObjectStateController'];
  },
  setPushController: function (controller) {
    requireMethods('PushController', ['send'], controller);
    config['PushController'] = controller;
  },
  getPushController: function () {
    return config['PushController'];
  },
  setQueryController: function (controller) {
    requireMethods('QueryController', ['find', 'aggregate'], controller);
    config['QueryController'] = controller;
  },
  getQueryController: function () {
    return config['QueryController'];
  },
  setRESTController: function (controller) {
    requireMethods('RESTController', ['request', 'ajax'], controller);
    config['RESTController'] = controller;
  },
  getRESTController: function () {
    return config['RESTController'];
  },
  setSchemaController: function (controller) {
    requireMethods('SchemaController', ['get', 'create', 'update', 'delete', 'send', 'purge'], controller);
    config['SchemaController'] = controller;
  },
  getSchemaController: function () {
    return config['SchemaController'];
  },
  setSessionController: function (controller) {
    requireMethods('SessionController', ['getSession'], controller);
    config['SessionController'] = controller;
  },
  getSessionController: function () {
    return config['SessionController'];
  },
  setStorageController: function (controller) {
    if (controller.async) {
      requireMethods('An async StorageController', ['getItemAsync', 'setItemAsync', 'removeItemAsync'], controller);
    } else {
      requireMethods('A synchronous StorageController', ['getItem', 'setItem', 'removeItem'], controller);
    }
    config['StorageController'] = controller;
  },
  getStorageController: function () {
    return config['StorageController'];
  },
  setAsyncStorage: function (storage) {
    config['AsyncStorage'] = storage;
  },
  getAsyncStorage: function () {
    return config['AsyncStorage'];
  },
  setUserController: function (controller) {
    requireMethods('UserController', ['setCurrentUser', 'currentUser', 'currentUserAsync', 'signUp', 'logIn', 'become', 'logOut', 'requestPasswordReset', 'upgradeToRevocableSession', 'linkWith'], controller);
    config['UserController'] = controller;
  },
  getUserController: function () {
    return config['UserController'];
  },
  setLiveQueryController: function (controller) {
    requireMethods('LiveQueryController', ['subscribe', 'unsubscribe', 'open', 'close'], controller);
    config['LiveQueryController'] = controller;
  },
  getLiveQueryController: function () {
    return config['LiveQueryController'];
  },
  setHooksController: function (controller) {
    requireMethods('HooksController', ['create', 'get', 'update', 'remove'], controller);
    config['HooksController'] = controller;
  },
  getHooksController: function () {
    return config['HooksController'];
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)))

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(161);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(168);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(105);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(169);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(171);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(173);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(175);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(106);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(73);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(177);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(181);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(182);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(183);
/* unused harmony reexport withRouter */





























/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(162)();
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {global.foo="foo";global.bar="bar";global.curRecipe=null;global.curProduct=null;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Leftsidebar=function(_Component){_inherits(Leftsidebar,_Component);function Leftsidebar(props){_classCallCheck(this,Leftsidebar);var _this=_possibleConstructorReturn(this,(Leftsidebar.__proto__||Object.getPrototypeOf(Leftsidebar)).call(this,props));__WEBPACK_IMPORTED_MODULE_1_parse___default.a.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5","sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw");//PASTE HERE YOUR Back4App APPLICATION ID AND YOUR JavaScript KEY
__WEBPACK_IMPORTED_MODULE_1_parse___default.a.serverURL="https://parse.joelskitchen.com/parse";//Parse.serverURL = "https://parsetest.joelskitchen.com/parse";
var now=new Date();var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();var displayUsername='';if(currentUser){displayUsername=currentUser.get("displayUsername");}_this.usernameParam=displayUsername;_this.state={users:{},created_at:now.getTime(),userImage:null};_this.getSuggestedUsers();_this.queryForUserRecordData();_this.getMenu();_this.getTabletMenu();// this.getNotification();
// this.getNotificationClose();
return _this;}_createClass(Leftsidebar,[{key:'queryForUserRecordData',value:function queryForUserRecordData(){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('User');query.equalTo("displayUsername",this.usernameParam);query.include("image");query.include("thumbnail");var self=this;query.first().then(function(result){if(result){self.setState({userImage:result.get("profilePictureSmall").url()});}else{}},function(error){console.error("Error loading post Error: "+error);//promise.error(error);
});}},{key:'getSuggestedUsers',value:function getSuggestedUsers(){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('User');query.equalTo('isSuggested',1);query.include("username");query.descending('_created_at');var self=this;query.find().then(function(result){if(result){self.setState({users:result});}else{console.log("No user found");}},function(error){console.error("Error loading post Error: "+error);});}},{key:'getMenu',value:function getMenu(){var menuval=__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#menuval').val();if(menuval==false){__WEBPACK_IMPORTED_MODULE_2_jquery___default()(".pagelink-grp").css({"height":"auto","visibility":"visible","opacity":"1"});__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#menuval').val(1);}else{__WEBPACK_IMPORTED_MODULE_2_jquery___default()(".pagelink-grp").css({"height":"0","visibility":"hidden","opacity":"0"});__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#menuval').val(0);}}},{key:'notlogin',value:function notlogin(){__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#login_popup_btn').trigger('click');}},{key:'getNotification',value:function getNotification(){__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#notf_sidebar').val(0);var notf_sidebar=__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#notf_sidebar').val();if(notf_sidebar!=true){__WEBPACK_IMPORTED_MODULE_2_jquery___default()(".notf_sidebar").css({"left":"398px"});__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#notf_sidebar').val(1);__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#notf_sidebar_close').val(0);}else{__WEBPACK_IMPORTED_MODULE_2_jquery___default()(".notf_sidebar").css({"left":"-398px"});__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#notf_sidebar').val(0);__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#notf_sidebar_close').val(1);}}},{key:'getTabletMenu',value:function getTabletMenu(){var tabletMenu=__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#tabletMenu').val();if(tabletMenu==false){__WEBPACK_IMPORTED_MODULE_2_jquery___default()(".hamburger_wrap .menu_wrpa").css({"height":"auto","visibility":"visible","opacity":"1"});__WEBPACK_IMPORTED_MODULE_2_jquery___default()(".hamburger_wrap .hamburger").addClass('active');__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#tabletMenu').val(1);}else{__WEBPACK_IMPORTED_MODULE_2_jquery___default()(".hamburger_wrap .menu_wrpa").css({"height":"0","visibility":"hidden","opacity":"0"});__WEBPACK_IMPORTED_MODULE_2_jquery___default()(".hamburger_wrap .hamburger").removeClass('active');__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#tabletMenu').val(0);}}// getNotificationClose() {
//   let notf_sidebar_close=$('#notf_sidebar_close').val('');
//   let notf_sidebar=$('#notf_sidebar').val('');
//   if(notf_sidebar_close==true) {
//     $(".notf_sidebar").css({"left": "398px"});
//     $('#notf_sidebar_close').val(0);
//     $('#notf_sidebar').val(1);
//   } else { 
//     $(".notf_sidebar").css({"left": "-398px"});
//     $('#notf_sidebar_close').val(1);
//     $('#notf_sidebar').val(0);
//   }
// } 
},{key:'renderUsers',value:function renderUsers(){var buffer=[];if(this.state.users){for(var i=0;i<this.state.users.length;i++){var user=this.state.users[i];var profile_picture=user.get("profilePictureSmall").url();if(profile_picture!==undefined){profile_picture=profile_picture;}else{profile_picture="/images/menu-account.svg";}buffer.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu',key:69*i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/user/'+user.get("displayUsername"),title:user.get("displayUsername"),className:'media'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'media-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:profile_picture,width:'40px',height:'40px',alt:'itsallgoodvegan'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'media-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'mt-0'},user.get("displayUsername")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,user.get("displayName"))))));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list_grp'},buffer);}},{key:'render',value:function render(){var getLoggedinUsername=localStorage.getItem('username');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dt_sidebar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'menu_sidebar'},getLoggedinUsername!=null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list_grp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/',title:'Home'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'thumb'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/menu-home.svg',width:'40px',height:'40px',alt:'Home'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'name'},'Home'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu dm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/messages',title:'Messages',onClick:this.notlogin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'thumb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{width:'40px',height:'40px',src:'/images/direct_message.png',alt:'Messages'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'name'},'Messages'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',title:'Create',type:'button','data-toggle':'modal','data-target':'#createPostModal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'thumb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/create_post_menu.svg',width:'40px',height:'40px',alt:'Create'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'name'},'Create'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',className:'menu-notf-lnk',title:'Notifications',onClick:this.getNotification},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'thumb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/menu-notifications.svg',width:'40px',height:'40px',alt:'Notifications'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'name'},'Notifications'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu userProfile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/my-profile',title:'Profile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'thumb'},this.state.userImage!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{height:'150',width:'150',className:'userProfileImageLarge',src:this.state.userImage,alt:this.usernameParam}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{height:'150',width:'150',src:'/images/default_userpic0.png',alt:'Profile Picture'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'name'},'Profile')))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list_grp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/',title:'Home'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'thumb'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/menu-home.svg',width:'40px',height:'40px',alt:'Home'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'name'},'Home'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu dm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',title:'Messages',onClick:this.notlogin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'thumb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{width:'40px',height:'40px',src:'/images/direct_message.png',alt:'Messages'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'name'},'Messages'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:this.notlogin,title:'Create'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'thumb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/create_post_menu.svg',width:'40px',height:'40px',alt:'Create'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'name'},'Create'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:this.notlogin,className:'menu-notf-lnk',title:'Notifications'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'thumb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/menu-notifications.svg',width:'40px',height:'40px',alt:'Notifications'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'name'},'Notifications'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu userProfile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',title:'Profile',onClick:this.notlogin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'thumb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{height:'150',width:'150',src:'/images/default_userpic0.png',alt:'Profile Picture'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'name'},'Profile'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'suggested_acunt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Suggested Accounts'),this.renderUsers()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'pagelink-grp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list_grp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:information@joelskitchen.com',title:'Contact Us'},'Contact Us')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://joelskitchen.com/privacy',title:'Privacy Policy'},'Privacy Policy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://joelskitchen.com/terms',title:'Terms'},'Terms'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list_grp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://create.joelskitchen.com/business/',target:'_blank',title:'Creator Marketplace'},'Creator Marketplace')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://joelskitchen.com/creatordirectory',target:'_blank',title:'Creator Directory '},'Creator Directory '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list_grp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.instagram.com/joels_kitchen/',target:'_blank',title:'Instagram'},'Instagram')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.tiktok.com/@joels_kitchen',target:'_blank',title:'TikTok'},'TikTok')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.facebook.com/joelskitchenapp',target:'_blank',title:'Facebook'},'Facebook')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.pinterest.com/joelskitchen/',target:'_blank',title:'Pinterest'},'Pinterest')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hamburger_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'tabletMenu',id:'tabletMenu',value:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'hamburger',onClick:this.getTabletMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu_wrpa'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'suggested_acunt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Suggested Accounts'),this.renderUsers()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'pagelink-grp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list_grp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',title:'Contact Us'},'Contact Us')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',title:'Privacy Policy'},'Privacy Policy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',title:'Terms'},'Terms'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list_grp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://create.joelskitchen.com/business/creators',target:'_blank',title:'Creator Directory '},'Creator Directory ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://create.joelskitchen.com/business/',target:'_blank',title:'Creator Marketplace'},'Creator Marketplace'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list_grp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.instagram.com/joels_kitchen/',target:'_blank',title:'Instagram'},'Instagram')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.tiktok.com/@joels_kitchen',target:'_blank',title:'TikTok'},'TikTok')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.facebook.com/joelskitchenapp',target:'_blank',title:'Facebook'},'Facebook')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.pinterest.com/joelskitchen/',target:'_blank',title:'Pinterest'},'Pinterest'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mb_sidebar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'menu_sidebar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list_grp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/menu-home.svg',width:'40px',height:'40px',alt:'Explore'}),'Explore')),getLoggedinUsername!=null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',type:'button','data-toggle':'modal','data-target':'#createPostModal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/create_post_menu.svg',width:'40px',height:'40px',alt:'Create'}),'Create')):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',className:'menu-notf-lnk',title:'Notifications',onClick:this.getNotification},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/menu-notifications.svg',width:'40px',height:'40px',alt:'Notifications'}),'Notifications')),getLoggedinUsername!=null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu userProfile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/my-profile'},'  ',this.state.userImage!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{height:'150',width:'150',className:'userProfileImageLarge',src:this.state.userImage,alt:this.usernameParam}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{height:'150',width:'150',src:'/images/default_userpic0.png',alt:'Profile Picture'}),' Profile')):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'other_link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'hamburger',onClick:this.getMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagelink-grp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list_grp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',title:'Contact Us'},'Contact Us')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',title:'Privacy Policy'},'Privacy Policy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',title:'Terms'},'Terms')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://create.joelskitchen.com/business/creators',target:'_blank',title:'Creator Directory '},'Creator Directory ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://create.joelskitchen.com/business',target:'_blank',title:'Creator Marketplace'},'Creator Marketplace')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.instagram.com/joels_kitchen/',target:'_blank',title:'Instagram'},'Instagram')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.tiktok.com/@joels_kitchen',target:'_blank',title:'TikTok'},'TikTok')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.facebook.com/joelskitchenapp',target:'_blank',title:'Facebook'},'Facebook')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.pinterest.com/joelskitchen/',target:'_blank',title:'Pinterest'},'Pinterest')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'menuval',id:'menuval',value:'0'}))))))));}}]);return Leftsidebar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Leftsidebar);

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(86)('wks');
var uid = __webpack_require__(59);
var Symbol = __webpack_require__(17).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var core = __webpack_require__(5);
var ctx = __webpack_require__(39);
var hide = __webpack_require__(24);
var has = __webpack_require__(26);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 17 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(21);
var IE8_DOM_DEFINE = __webpack_require__(111);
var toPrimitive = __webpack_require__(80);
var dP = Object.defineProperty;

exports.f = __webpack_require__(19) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(25)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(187);


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(18);
var createDesc = __webpack_require__(57);
module.exports = __webpack_require__(19) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(211), __esModule: true };

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/**
 * Constructs a new Parse.Error object with the given code and message.
 * @alias Parse.Error
 */
var ParseError = function () {
  /**
   * @param {Number} code An error code constant from <code>Parse.Error</code>.
   * @param {String} message A detailed description of the error.
   */
  function ParseError(code, message) {
    (0, _classCallCheck3.default)(this, ParseError);

    this.code = code;
    this.message = message;
  }

  (0, _createClass3.default)(ParseError, [{
    key: 'toString',
    value: function () {
      return 'ParseError: ' + this.code + ' ' + this.message;
    }
  }]);
  return ParseError;
}();

/**
 * Error code indicating some error other than those enumerated here.
 * @property OTHER_CAUSE
 * @static
 * @final
 */

ParseError.OTHER_CAUSE = -1;

/**
 * Error code indicating that something has gone wrong with the server.
 * If you get this error code, it is Parse's fault. Contact us at
 * https://parse.com/help
 * @property INTERNAL_SERVER_ERROR
 * @static
 * @final
 */
ParseError.INTERNAL_SERVER_ERROR = 1;

/**
 * Error code indicating the connection to the Parse servers failed.
 * @property CONNECTION_FAILED
 * @static
 * @final
 */
ParseError.CONNECTION_FAILED = 100;

/**
 * Error code indicating the specified object doesn't exist.
 * @property OBJECT_NOT_FOUND
 * @static
 * @final
 */
ParseError.OBJECT_NOT_FOUND = 101;

/**
 * Error code indicating you tried to query with a datatype that doesn't
 * support it, like exact matching an array or object.
 * @property INVALID_QUERY
 * @static
 * @final
 */
ParseError.INVALID_QUERY = 102;

/**
 * Error code indicating a missing or invalid classname. Classnames are
 * case-sensitive. They must start with a letter, and a-zA-Z0-9_ are the
 * only valid characters.
 * @property INVALID_CLASS_NAME
 * @static
 * @final
 */
ParseError.INVALID_CLASS_NAME = 103;

/**
 * Error code indicating an unspecified object id.
 * @property MISSING_OBJECT_ID
 * @static
 * @final
 */
ParseError.MISSING_OBJECT_ID = 104;

/**
 * Error code indicating an invalid key name. Keys are case-sensitive. They
 * must start with a letter, and a-zA-Z0-9_ are the only valid characters.
 * @property INVALID_KEY_NAME
 * @static
 * @final
 */
ParseError.INVALID_KEY_NAME = 105;

/**
 * Error code indicating a malformed pointer. You should not see this unless
 * you have been mucking about changing internal Parse code.
 * @property INVALID_POINTER
 * @static
 * @final
 */
ParseError.INVALID_POINTER = 106;

/**
 * Error code indicating that badly formed JSON was received upstream. This
 * either indicates you have done something unusual with modifying how
 * things encode to JSON, or the network is failing badly.
 * @property INVALID_JSON
 * @static
 * @final
 */
ParseError.INVALID_JSON = 107;

/**
 * Error code indicating that the feature you tried to access is only
 * available internally for testing purposes.
 * @property COMMAND_UNAVAILABLE
 * @static
 * @final
 */
ParseError.COMMAND_UNAVAILABLE = 108;

/**
 * You must call Parse.initialize before using the Parse library.
 * @property NOT_INITIALIZED
 * @static
 * @final
 */
ParseError.NOT_INITIALIZED = 109;

/**
 * Error code indicating that a field was set to an inconsistent type.
 * @property INCORRECT_TYPE
 * @static
 * @final
 */
ParseError.INCORRECT_TYPE = 111;

/**
 * Error code indicating an invalid channel name. A channel name is either
 * an empty string (the broadcast channel) or contains only a-zA-Z0-9_
 * characters and starts with a letter.
 * @property INVALID_CHANNEL_NAME
 * @static
 * @final
 */
ParseError.INVALID_CHANNEL_NAME = 112;

/**
 * Error code indicating that push is misconfigured.
 * @property PUSH_MISCONFIGURED
 * @static
 * @final
 */
ParseError.PUSH_MISCONFIGURED = 115;

/**
 * Error code indicating that the object is too large.
 * @property OBJECT_TOO_LARGE
 * @static
 * @final
 */
ParseError.OBJECT_TOO_LARGE = 116;

/**
 * Error code indicating that the operation isn't allowed for clients.
 * @property OPERATION_FORBIDDEN
 * @static
 * @final
 */
ParseError.OPERATION_FORBIDDEN = 119;

/**
 * Error code indicating the result was not found in the cache.
 * @property CACHE_MISS
 * @static
 * @final
 */
ParseError.CACHE_MISS = 120;

/**
 * Error code indicating that an invalid key was used in a nested
 * JSONObject.
 * @property INVALID_NESTED_KEY
 * @static
 * @final
 */
ParseError.INVALID_NESTED_KEY = 121;

/**
 * Error code indicating that an invalid filename was used for ParseFile.
 * A valid file name contains only a-zA-Z0-9_. characters and is between 1
 * and 128 characters.
 * @property INVALID_FILE_NAME
 * @static
 * @final
 */
ParseError.INVALID_FILE_NAME = 122;

/**
 * Error code indicating an invalid ACL was provided.
 * @property INVALID_ACL
 * @static
 * @final
 */
ParseError.INVALID_ACL = 123;

/**
 * Error code indicating that the request timed out on the server. Typically
 * this indicates that the request is too expensive to run.
 * @property TIMEOUT
 * @static
 * @final
 */
ParseError.TIMEOUT = 124;

/**
 * Error code indicating that the email address was invalid.
 * @property INVALID_EMAIL_ADDRESS
 * @static
 * @final
 */
ParseError.INVALID_EMAIL_ADDRESS = 125;

/**
 * Error code indicating a missing content type.
 * @property MISSING_CONTENT_TYPE
 * @static
 * @final
 */
ParseError.MISSING_CONTENT_TYPE = 126;

/**
 * Error code indicating a missing content length.
 * @property MISSING_CONTENT_LENGTH
 * @static
 * @final
 */
ParseError.MISSING_CONTENT_LENGTH = 127;

/**
 * Error code indicating an invalid content length.
 * @property INVALID_CONTENT_LENGTH
 * @static
 * @final
 */
ParseError.INVALID_CONTENT_LENGTH = 128;

/**
 * Error code indicating a file that was too large.
 * @property FILE_TOO_LARGE
 * @static
 * @final
 */
ParseError.FILE_TOO_LARGE = 129;

/**
 * Error code indicating an error saving a file.
 * @property FILE_SAVE_ERROR
 * @static
 * @final
 */
ParseError.FILE_SAVE_ERROR = 130;

/**
 * Error code indicating that a unique field was given a value that is
 * already taken.
 * @property DUPLICATE_VALUE
 * @static
 * @final
 */
ParseError.DUPLICATE_VALUE = 137;

/**
 * Error code indicating that a role's name is invalid.
 * @property INVALID_ROLE_NAME
 * @static
 * @final
 */
ParseError.INVALID_ROLE_NAME = 139;

/**
 * Error code indicating that an application quota was exceeded.  Upgrade to
 * resolve.
 * @property EXCEEDED_QUOTA
 * @static
 * @final
 */
ParseError.EXCEEDED_QUOTA = 140;

/**
 * Error code indicating that a Cloud Code script failed.
 * @property SCRIPT_FAILED
 * @static
 * @final
 */
ParseError.SCRIPT_FAILED = 141;

/**
 * Error code indicating that a Cloud Code validation failed.
 * @property VALIDATION_ERROR
 * @static
 * @final
 */
ParseError.VALIDATION_ERROR = 142;

/**
 * Error code indicating that invalid image data was provided.
 * @property INVALID_IMAGE_DATA
 * @static
 * @final
 */
ParseError.INVALID_IMAGE_DATA = 143;

/**
 * Error code indicating an unsaved file.
 * @property UNSAVED_FILE_ERROR
 * @static
 * @final
 */
ParseError.UNSAVED_FILE_ERROR = 151;

/**
 * Error code indicating an invalid push time.
 * @property INVALID_PUSH_TIME_ERROR
 * @static
 * @final
 */
ParseError.INVALID_PUSH_TIME_ERROR = 152;

/**
 * Error code indicating an error deleting a file.
 * @property FILE_DELETE_ERROR
 * @static
 * @final
 */
ParseError.FILE_DELETE_ERROR = 153;

/**
 * Error code indicating that the application has exceeded its request
 * limit.
 * @property REQUEST_LIMIT_EXCEEDED
 * @static
 * @final
 */
ParseError.REQUEST_LIMIT_EXCEEDED = 155;

/**
 * Error code indicating an invalid event name.
 * @property INVALID_EVENT_NAME
 * @static
 * @final
 */
ParseError.INVALID_EVENT_NAME = 160;

/**
 * Error code indicating that the username is missing or empty.
 * @property USERNAME_MISSING
 * @static
 * @final
 */
ParseError.USERNAME_MISSING = 200;

/**
 * Error code indicating that the password is missing or empty.
 * @property PASSWORD_MISSING
 * @static
 * @final
 */
ParseError.PASSWORD_MISSING = 201;

/**
 * Error code indicating that the username has already been taken.
 * @property USERNAME_TAKEN
 * @static
 * @final
 */
ParseError.USERNAME_TAKEN = 202;

/**
 * Error code indicating that the email has already been taken.
 * @property EMAIL_TAKEN
 * @static
 * @final
 */
ParseError.EMAIL_TAKEN = 203;

/**
 * Error code indicating that the email is missing, but must be specified.
 * @property EMAIL_MISSING
 * @static
 * @final
 */
ParseError.EMAIL_MISSING = 204;

/**
 * Error code indicating that a user with the specified email was not found.
 * @property EMAIL_NOT_FOUND
 * @static
 * @final
 */
ParseError.EMAIL_NOT_FOUND = 205;

/**
 * Error code indicating that a user object without a valid session could
 * not be altered.
 * @property SESSION_MISSING
 * @static
 * @final
 */
ParseError.SESSION_MISSING = 206;

/**
 * Error code indicating that a user can only be created through signup.
 * @property MUST_CREATE_USER_THROUGH_SIGNUP
 * @static
 * @final
 */
ParseError.MUST_CREATE_USER_THROUGH_SIGNUP = 207;

/**
 * Error code indicating that an an account being linked is already linked
 * to another user.
 * @property ACCOUNT_ALREADY_LINKED
 * @static
 * @final
 */
ParseError.ACCOUNT_ALREADY_LINKED = 208;

/**
 * Error code indicating that the current session token is invalid.
 * @property INVALID_SESSION_TOKEN
 * @static
 * @final
 */
ParseError.INVALID_SESSION_TOKEN = 209;

/**
 * Error code indicating that a user cannot be linked to an account because
 * that account's id could not be found.
 * @property LINKED_ID_MISSING
 * @static
 * @final
 */
ParseError.LINKED_ID_MISSING = 250;

/**
 * Error code indicating that a user with a linked (e.g. Facebook) account
 * has an invalid session.
 * @property INVALID_LINKED_SESSION
 * @static
 * @final
 */
ParseError.INVALID_LINKED_SESSION = 251;

/**
 * Error code indicating that a service being linked (e.g. Facebook or
 * Twitter) is unsupported.
 * @property UNSUPPORTED_SERVICE
 * @static
 * @final
 */
ParseError.UNSUPPORTED_SERVICE = 252;

/**
 * Error code indicating an invalid operation occured on schema
 * @property INVALID_SCHEMA_OPERATION
 * @static
 * @final
 */
ParseError.INVALID_SCHEMA_OPERATION = 255;

/**
 * Error code indicating that there were multiple errors. Aggregate errors
 * have an "errors" property, which is an array of error objects with more
 * detail about each error that occurred.
 * @property AGGREGATE_ERROR
 * @static
 * @final
 */
ParseError.AGGREGATE_ERROR = 600;

/**
 * Error code indicating the client was unable to read an input file.
 * @property FILE_READ_ERROR
 * @static
 * @final
 */
ParseError.FILE_READ_ERROR = 601;

/**
 * Error code indicating a real error code is unavailable because
 * we had to use an XDomainRequest object to allow CORS requests in
 * Internet Explorer, which strips the body from HTTP responses that have
 * a non-2XX status code.
 * @property X_DOMAIN_REQUEST
 * @static
 * @final
 */
ParseError.X_DOMAIN_REQUEST = 602;

exports.default = ParseError;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _CoreManager = __webpack_require__(9);

var _CoreManager2 = _interopRequireDefault(_CoreManager);

var _ParsePromise = __webpack_require__(7);

var _ParsePromise2 = _interopRequireDefault(_ParsePromise);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var dataUriRegexp = /^data:([a-zA-Z]*\/[a-zA-Z+.-]*);(charset=[a-zA-Z0-9\-\/\s]*,)?base64,/;

function b64Digit(number) {
  if (number < 26) {
    return String.fromCharCode(65 + number);
  }
  if (number < 52) {
    return String.fromCharCode(97 + (number - 26));
  }
  if (number < 62) {
    return String.fromCharCode(48 + (number - 52));
  }
  if (number === 62) {
    return '+';
  }
  if (number === 63) {
    return '/';
  }
  throw new TypeError('Tried to encode large digit ' + number + ' in base64.');
}

/**
 * A Parse.File is a local representation of a file that is saved to the Parse
 * cloud.
 * @alias Parse.File
 */

var ParseFile = function () {

  /**
   * @param name {String} The file's name. This will be prefixed by a unique
   *     value once the file has finished saving. The file name must begin with
   *     an alphanumeric character, and consist of alphanumeric characters,
   *     periods, spaces, underscores, or dashes.
   * @param data {Array} The data for the file, as either:
   *     1. an Array of byte value Numbers, or
   *     2. an Object like { base64: "..." } with a base64-encoded String.
   *     3. a File object selected with a file upload control. (3) only works
   *        in Firefox 3.6+, Safari 6.0.2+, Chrome 7+, and IE 10+.
   *        For example:<pre>
   * var fileUploadControl = $("#profilePhotoFileUpload")[0];
   * if (fileUploadControl.files.length > 0) {
   *   var file = fileUploadControl.files[0];
   *   var name = "photo.jpg";
   *   var parseFile = new Parse.File(name, file);
   *   parseFile.save().then(function() {
   *     // The file has been saved to Parse.
   *   }, function(error) {
   *     // The file either could not be read, or could not be saved to Parse.
   *   });
   * }</pre>
   * @param type {String} Optional Content-Type header to use for the file. If
   *     this is omitted, the content type will be inferred from the name's
   *     extension.
   */
  function ParseFile(name, data, type) {
    (0, _classCallCheck3.default)(this, ParseFile);

    var specifiedType = type || '';

    this._name = name;

    if (data !== undefined) {
      if (Array.isArray(data)) {
        this._source = {
          format: 'base64',
          base64: ParseFile.encodeBase64(data),
          type: specifiedType
        };
      } else if (typeof File !== 'undefined' && data instanceof File) {
        this._source = {
          format: 'file',
          file: data,
          type: specifiedType
        };
      } else if (data && typeof data.base64 === 'string') {
        var _base = data.base64;
        var commaIndex = _base.indexOf(',');

        if (commaIndex !== -1) {
          var matches = dataUriRegexp.exec(_base.slice(0, commaIndex + 1));
          // if data URI with type and charset, there will be 4 matches.
          this._source = {
            format: 'base64',
            base64: _base.slice(commaIndex + 1),
            type: matches[1]
          };
        } else {
          this._source = {
            format: 'base64',
            base64: _base,
            type: specifiedType
          };
        }
      } else {
        throw new TypeError('Cannot create a Parse.File with that data.');
      }
    }
  }

  /**
   * Gets the name of the file. Before save is called, this is the filename
   * given by the user. After save is called, that name gets prefixed with a
   * unique identifier.
   * @return {String}
   */

  (0, _createClass3.default)(ParseFile, [{
    key: 'name',
    value: function () {
      return this._name;
    }

    /**
     * Gets the url of the file. It is only available after you save the file or
     * after you get the file from a Parse.Object.
     * @param {Object} options An object to specify url options
     * @return {String}
     */

  }, {
    key: 'url',
    value: function (options) {
      options = options || {};
      if (!this._url) {
        return;
      }
      if (options.forceSecure) {
        return this._url.replace(/^http:\/\//i, 'https://');
      } else {
        return this._url;
      }
    }

    /**
     * Saves the file to the Parse cloud.
     * @param {Object} options A Backbone-style options object.
     * @return {Parse.Promise} Promise that is resolved when the save finishes.
     */

  }, {
    key: 'save',
    value: function (options) {
      var _this = this;

      options = options || {};
      var controller = _CoreManager2.default.getFileController();
      if (!this._previousSave) {
        if (this._source.format === 'file') {
          this._previousSave = controller.saveFile(this._name, this._source, options).then(function (res) {
            _this._name = res.name;
            _this._url = res.url;
            return _this;
          });
        } else {
          this._previousSave = controller.saveBase64(this._name, this._source, options).then(function (res) {
            _this._name = res.name;
            _this._url = res.url;
            return _this;
          });
        }
      }
      if (this._previousSave) {
        return this._previousSave._thenRunCallbacks(options);
      }
    }
  }, {
    key: 'toJSON',
    value: function () {
      return {
        __type: 'File',
        name: this._name,
        url: this._url
      };
    }
  }, {
    key: 'equals',
    value: function (other) {
      if (this === other) {
        return true;
      }
      // Unsaved Files are never equal, since they will be saved to different URLs
      return other instanceof ParseFile && this.name() === other.name() && this.url() === other.url() && typeof this.url() !== 'undefined';
    }
  }], [{
    key: 'fromJSON',
    value: function (obj) {
      if (obj.__type !== 'File') {
        throw new TypeError('JSON object does not represent a ParseFile');
      }
      var file = new ParseFile(obj.name);
      file._url = obj.url;
      return file;
    }
  }, {
    key: 'encodeBase64',
    value: function (bytes) {
      var chunks = [];
      chunks.length = Math.ceil(bytes.length / 3);
      for (var i = 0; i < chunks.length; i++) {
        var b1 = bytes[i * 3];
        var b2 = bytes[i * 3 + 1] || 0;
        var b3 = bytes[i * 3 + 2] || 0;

        var has2 = i * 3 + 1 < bytes.length;
        var has3 = i * 3 + 2 < bytes.length;

        chunks[i] = [b64Digit(b1 >> 2 & 0x3F), b64Digit(b1 << 4 & 0x30 | b2 >> 4 & 0x0F), has2 ? b64Digit(b2 << 2 & 0x3C | b3 >> 6 & 0x03) : '=', has3 ? b64Digit(b3 & 0x3F) : '='].join('');
      }

      return chunks.join('');
    }
  }]);
  return ParseFile;
}();

var DefaultController = {
  saveFile: function (name, source) {
    if (source.format !== 'file') {
      throw new Error('saveFile can only be used with File-type sources.');
    }
    // To directly upload a File, we use a REST-style AJAX request
    var headers = {
      'X-Parse-Application-ID': _CoreManager2.default.get('APPLICATION_ID'),
      'X-Parse-JavaScript-Key': _CoreManager2.default.get('JAVASCRIPT_KEY'),
      'Content-Type': source.type || (source.file ? source.file.type : null)
    };
    var url = _CoreManager2.default.get('SERVER_URL');
    if (url[url.length - 1] !== '/') {
      url += '/';
    }
    url += 'files/' + name;
    return _CoreManager2.default.getRESTController().ajax('POST', url, source.file, headers);
  },

  saveBase64: function (name, source, options) {
    if (source.format !== 'base64') {
      throw new Error('saveBase64 can only be used with Base64-type sources.');
    }
    var data = {
      base64: source.base64
    };
    if (source.type) {
      data._ContentType = source.type;
    }

    return _CoreManager2.default.getRESTController().request('POST', 'files/' + name, data, options);
  }
};

_CoreManager2.default.setFileController(DefaultController);

exports.default = ParseFile;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _ParseOp = __webpack_require__(43);

var _ParseObject = __webpack_require__(8);

var _ParseObject2 = _interopRequireDefault(_ParseObject);

var _ParseQuery = __webpack_require__(66);

var _ParseQuery2 = _interopRequireDefault(_ParseQuery);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Creates a new Relation for the given parent object and key. This
 * constructor should rarely be used directly, but rather created by
 * Parse.Object.relation.
 *
 * <p>
 * A class that is used to access all of the children of a many-to-many
 * relationship.  Each instance of Parse.Relation is associated with a
 * particular parent object and key.
 * </p>
 * @alias Parse.Relation
 */
var ParseRelation = function () {

  /**
   * @param {Parse.Object} parent The parent of this relation.
   * @param {String} key The key for this relation on the parent.
   */
  function ParseRelation(parent, key) {
    (0, _classCallCheck3.default)(this, ParseRelation);

    this.parent = parent;
    this.key = key;
    this.targetClassName = null;
  }

  /*
   * Makes sure that this relation has the right parent and key.
   */

  (0, _createClass3.default)(ParseRelation, [{
    key: '_ensureParentAndKey',
    value: function (parent, key) {
      this.key = this.key || key;
      if (this.key !== key) {
        throw new Error('Internal Error. Relation retrieved from two different keys.');
      }
      if (this.parent) {
        if (this.parent.className !== parent.className) {
          throw new Error('Internal Error. Relation retrieved from two different Objects.');
        }
        if (this.parent.id) {
          if (this.parent.id !== parent.id) {
            throw new Error('Internal Error. Relation retrieved from two different Objects.');
          }
        } else if (parent.id) {
          this.parent = parent;
        }
      } else {
        this.parent = parent;
      }
    }

    /**
     * Adds a Parse.Object or an array of Parse.Objects to the relation.
      * @param {} objects The item or items to add.
     */

  }, {
    key: 'add',
    value: function (objects) {
      if (!Array.isArray(objects)) {
        objects = [objects];
      }

      var change = new _ParseOp.RelationOp(objects, []);
      var parent = this.parent;
      if (!parent) {
        throw new Error('Cannot add to a Relation without a parent');
      }
      parent.set(this.key, change);
      this.targetClassName = change._targetClassName;
      return parent;
    }

    /**
     * Removes a Parse.Object or an array of Parse.Objects from this relation.
      * @param {} objects The item or items to remove.
     */

  }, {
    key: 'remove',
    value: function (objects) {
      if (!Array.isArray(objects)) {
        objects = [objects];
      }

      var change = new _ParseOp.RelationOp([], objects);
      if (!this.parent) {
        throw new Error('Cannot remove from a Relation without a parent');
      }
      this.parent.set(this.key, change);
      this.targetClassName = change._targetClassName;
    }

    /**
     * Returns a JSON version of the object suitable for saving to disk.
      * @return {Object}
     */

  }, {
    key: 'toJSON',
    value: function () {
      return {
        __type: 'Relation',
        className: this.targetClassName
      };
    }

    /**
     * Returns a Parse.Query that is limited to objects in this
     * relation.
      * @return {Parse.Query}
     */

  }, {
    key: 'query',
    value: function () {
      var query;
      var parent = this.parent;
      if (!parent) {
        throw new Error('Cannot construct a query for a Relation without a parent');
      }
      if (!this.targetClassName) {
        query = new _ParseQuery2.default(parent.className);
        query._extraOptions.redirectClassNameForKey = this.key;
      } else {
        query = new _ParseQuery2.default(this.targetClassName);
      }
      query._addCondition('$relatedTo', 'object', {
        __type: 'Pointer',
        className: parent.className,
        objectId: parent.id
      });
      query._addCondition('$relatedTo', 'key', this.key);

      return query;
    }
  }]);
  return ParseRelation;
}(); /**
      * Copyright (c) 2015-present, Parse, LLC.
      * All rights reserved.
      *
      * This source code is licensed under the BSD-style license found in the
      * LICENSE file in the root directory of this source tree. An additional grant
      * of patent rights can be found in the PATENTS file in the same directory.
      *
      * 
      */

exports.default = ParseRelation;

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_emoji_picker_react__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_emoji_picker_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_emoji_picker_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_mentions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__defaultStyle__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__defaultMentionStyle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__saveNotification_jsx__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// CommonPopup.js
function time_ago(time){switch(typeof time==='undefined'?'undefined':_typeof(time)){case'number':break;case'string':time=+new Date(time);break;case'object':if(time.constructor===Date)time=time.getTime();break;default:time=+new Date();}var time_formats=[[60,'s',1],// 60
[120,'1m','1 minute from now'],// 60*2
[3600,'m',60],// 60*60, 60
[7200,'1h','1 hour from now'],// 60*60*2
[86400,'h',3600],// 60*60*24, 60*60
[172800,'1d','Tomorrow'],// 60*60*24*2
[604800,'d',86400],// 60*60*24*7, 60*60*24
[1209600,'1w','Next week'],// 60*60*24*7*4*2
[2419200,'w',604800],// 60*60*24*7*4, 60*60*24*7
[4838400,'1m','Next month'],// 60*60*24*7*4*2
[29030400,'m',2419200],// 60*60*24*7*4*12, 60*60*24*7*4
[58060800,'1y','Next year'],// 60*60*24*7*4*12*2
[2903040000,'y',29030400],// 60*60*24*7*4*12*100, 60*60*24*7*4*12
[5806080000,'Last century','Next century'],// 60*60*24*7*4*12*100*2
[58060800000,'centuries',2903040000]// 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
];var seconds=(+new Date()-time)/1000,token='',list_choice=1;if(seconds==0){return'';}if(seconds<0){seconds=Math.abs(seconds);//token = 'from now';
token='';list_choice=2;}var i=0,format;while(format=time_formats[i++]){if(seconds<format[0]){if(typeof format[2]=='string')return format[list_choice];else return Math.floor(seconds/format[2])+''+format[1]+''+token;}}return time;}var CommonPopup=function(_Component){_inherits(CommonPopup,_Component);function CommonPopup(props){var _this2=this,_this$state2;_classCallCheck(this,CommonPopup);var _this=_possibleConstructorReturn(this,(CommonPopup.__proto__||Object.getPrototypeOf(CommonPopup)).call(this,props));_this.handleUnFollowMyProfile=function(e){var self=_this;var datapost_id=e.target.dataset.id;var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('User');query.equalTo("objectId",datapost_id);query.first().then(function(result){if(result){var touser=result;var checksavequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');checksavequery.equalTo('type','follow');checksavequery.equalTo('toUser',touser);checksavequery.equalTo('fromUser',currentUser);checksavequery.first().then(function(object){if(object){return object.destroy();}}).then(function(deletedObject){setTimeout(function(){self.singlegetUsersLike(datapost_id);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style","display: block");},1000);}).catch(function(error){console.error('Error deleting record:',error);});}});//setTimeout(() => {
// self.singlegetUsersLike(datapost_id);
//$('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style", "display: none");
//$('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style", "display: block");
//   },1000);
}else{// $('#kitchenQrModal_btn').trigger('click');  
return false;}};_this.singlerenderUserSuggestionPopup=function(suggestion,search,highlightedDisplay){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user-suggestion'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:suggestion.avatar,alt:suggestion.display,className:'user-avatar'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'displayUserName'},highlightedDisplay),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'displayName'},suggestion.displayName)));};_this.toggleNotification=function(postid,msg,comment){var self=_this;self.setState(function(prevState){return{isNotificationOpen:!prevState.isNotificationOpen,post_Notification_Id:postid,post_Notification_Msg:msg,post_Notification_Comment:comment};});//self.setState({ post_Notification_Id: postid });        
};_this.handlePhotoLike=function(post_id,page){var posts_id='';if(page==='popup'){post_id=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#popup_post_id_common').val();posts_id=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#popup_post_id_common').val();}var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{//$('a.liked .default#like_'+post_id).attr("style", "display: none");
__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked1#like_'+post_id).attr("style","pointer-events: none");var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Photo');query.equalTo('objectId',post_id);var self=_this;query.find().then(function(photo){if(photo){var photo_ob=photo[0];var photoid=photo_ob.id;var likeCount=photo_ob.get('likeCountNew');if(likeCount===undefined||likeCount===0){likeCount=1;}else{likeCount=likeCount+1;}photo_ob.set("likeCountNew",likeCount);photo_ob.save();var Like=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend("Like");var like=new Like();var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var currentUser_id=currentUser.id;like.set('fromUser',currentUser);like.set('photo',photo_ob);like.set("_wperm",{"*":{"read":true,"write":true}});like.set("_rperm",{"*":{"read":true,"write":true}});like.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);acl.setWriteAccess(currentUser,true);acl.setReadAccess(currentUser,true);like.setACL(acl);var fromUserThumb=currentUser.get('profilePictureSmall');if(fromUserThumb!=undefined){like.set('fromUserThumb',fromUserThumb);}like.save().then(function(likeSaved){self.setState({likeCount:likeCount});__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: block");if(posts_id){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_mn #like_counts_'+posts_id).html(likeCount);var likesWord="Likes";//if (likeCount == 1) likesWord = "Like";
if(likeCount==1){likesWord="Like";__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_mn #like_words_'+posts_id).html(likesWord);}}var likeCountNew=likeCount;__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#like_count_new_common').html(likeCountNew+' '+likesWord);//$('#home_fetch').trigger('click');
__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#popup_post_id_common').val(posts_id);// this.handleGetLikePost(post_id);
self.handleGetLikePost(post_id);self.handleGetLikeUser(post_id);}).catch(function(error){});}else{}},function(error){});setTimeout(function(){var self=_this;_this.toggleNotification(post_id,'liked photo','');self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});},1000);}};_this.handleFollowMyProfile=function(e){var datapost_id=e.target.dataset.id;var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var self=_this;if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('User');query.equalTo("objectId",datapost_id);query.first().then(function(result){if(result){var touser=result;var Activity=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend("Activity");var activity=new Activity();activity.set('fromUser',currentUser);activity.set('toUser',touser);activity.set('type','follow');activity.save().then(function(savedFile){setTimeout(function(){//$('a.unfollowpost_link#follow_'+datapost_id).attr("style", "display: block");
//$('a.followpost_link#follow_'+datapost_id).attr("style", "display: none");
self.singlegetUsersLike(datapost_id);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style","display: block");self.toggleNotification(touser,'started following you.','');self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});},1000);}).catch(function(error){});}});}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}};_this.handleFollowMyProfileLike=function(e){var datapost_id=e.target.dataset.id;var self=_this;var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('User');query.equalTo("objectId",datapost_id);query.first().then(function(result){if(result){var touser=result;var Activity=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend("Activity");var activity=new Activity();activity.set('fromUser',currentUser);activity.set('toUser',touser);activity.set('type','follow');activity.save().then(function(savedFile){setTimeout(function(){//$('a.unfollowpost_link#follow_'+datapost_id).attr("style", "display: block");
//$('a.followpost_link#follow_'+datapost_id).attr("style", "display: none");
__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style","display: block");self.singlegetUsersCommentLike(datapost_id);},1000);}).catch(function(error){});}});// setTimeout(() => {
//self.singlegetUsersCommentLike(datapost_id);            
//},2000);
}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}};_this.handleUnFollowMyProfileLike=function(e){var datapost_id=e.target.dataset.id;var self=_this;var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('User');query.equalTo("objectId",datapost_id);query.first().then(function(result){if(result){var touser=result;var checksavequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');checksavequery.equalTo('type','follow');checksavequery.equalTo('toUser',touser);checksavequery.equalTo('fromUser',currentUser);checksavequery.first().then(function(object){if(object){return object.destroy();}}).then(function(deletedObject){setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style","display: block");self.singlegetUsersCommentLike(datapost_id);},1000);}).catch(function(error){console.error('Error deleting record:',error);});}});//setTimeout(() => {
//  self.singlegetUsersCommentLike(datapost_id);
// },2000);
}else{// $('#kitchenQrModal_btn').trigger('click');  
return false;}};_this.handleGetLikeUser=function(post_id){if(post_id){var like=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');var self=_this;like.equalTo('photo','Photo$'+post_id);like.doesNotExist('activity');like.find().then(function(result){if(result){self.setState({likeuserlist:result});}});}};_this.handleGetActivityLikePost=function(comment_id){var check_value=0;var post_id=_this.state.post_common_id;//this.state.postID;
var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultLikedid=0;var checklikequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');checklikequery.include("activity");checklikequery.equalTo('photo',"Photo$"+post_id);checklikequery.equalTo('activity',"Activity$"+comment_id);checklikequery.equalTo('fromUser',currentUser);var self=_this;checklikequery.find().then(function(resultLike){if(resultLike){var resultLiked=resultLike[0];resultLikedid=resultLiked.id;if(resultLikedid!==undefined){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(' a.liked_activity .activitydefault#comment_'+comment_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity .activityactive#comment_'+comment_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_userimg_inner .like.box.maincomment#'+comment_id).attr("style","display: block");// $(' a.liked_activity#comment_'+comment_id).attr("disabled", false);
/*if ($('a.liked_activity#comment_'+comment_id).hasClass('disabled'))
                       {
                         $('a.liked_activity#comment_'+comment_id).removeClass('disabled'); 
                       }*/__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity#comment_'+comment_id).attr("style","pointer-events: auto");}if(resultLikedid===undefined){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity .activitydefault#comment_'+comment_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity .activityactive#comment_'+comment_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_userimg_inner .like.box.maincomment#'+comment_id).attr("style","display: none");}}});}};_this.handlePhotoActivityUnLike=function(e){var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{var post_id=e.target.id;var datapost_id=e.target.dataset.id;//$('a.liked_activity .activityactive#comment_'+datapost_id).attr("style", "display: none");
__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity#comment_'+datapost_id).attr("style","pointer-events: none");var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');query.equalTo('objectId',datapost_id);var self=_this;query.find().then(function(activity){if(activity){var activity_ob=activity[0];var likeCount=void 0;if(activity_ob){likeCount=activity_ob.get('likeCount');}else{likeCount=0;}if(likeCount===undefined||likeCount===0){likeCount=0;}else{likeCount=likeCount-1;}/*if(likeCount==undefined || likeCount < 0)
                              {
                                  likeCount=0;
                              }else
                              {
                                  likeCount=likeCount-1;
                              }*/var photo_ob=activity_ob.get('photo');activity_ob.set("likeCount",likeCount);activity_ob.save();//like 
var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var currentUser_id=currentUser.id;var checklikequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');checklikequery.equalTo('photo',photo_ob);checklikequery.equalTo('fromUser',currentUser);checklikequery.equalTo('activity',activity_ob);checklikequery.first().then(function(object){if(object){return object.destroy();}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity .activitydefault#comment_'+datapost_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity .activityactive#comment_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_userimg_inner .like.box.maincomment#'+datapost_id).attr("style","display: none");}}).then(function(deletedObject){//self.setState({likeCount:likeCount});  
//$('#home_fetch').trigger('click');
self.setState({singlelikeCount:likeCount});__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity .activityactive#comment_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity .activitydefault#comment_'+datapost_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity#comment_'+datapost_id).attr("style","pointer-events: auto");}).catch(function(error){console.error('Error deleting record:',error);});//like  
}});setTimeout(function(){var self=_this;self.handleGetActivityLikePost(datapost_id);},500);}};_this.updateInputPopup=function(event){//console.log('updateInputPopup');
var reply_id=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#reply_id').val();if(reply_id===''){//console.log('singlementioned_popup==='+event.target.value)
_this.state.singlementioned_popup='';}var self=_this;_this.setState({singlementioned_popup:event.target.value});_this.setState({postcomment_popup:event.target.value});_this.setState({inputText:event.target.value});if(event.target.value!==null&&reply_id===''){}else{//console.log('Test2');
}};_this.handlePhotoActivityLike=function(e){var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{var post_id=e.target.id;var datapost_id=e.target.dataset.id;//$('a.liked_activity .activitydefault#comment_'+datapost_id).attr("style", "display: none");
//$('a.liked_activity .activitydefault#comment_'+datapost_id).attr("disabled", true);
//if(('a.liked_activity .activitydefault#comment_'+datapost_id).attr('disabled') === 'true'){  return;}
__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity#comment_'+datapost_id).attr("style","pointer-events: none");//e.stopImmediatePropagation();
var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');query.equalTo('objectId',datapost_id);var self=_this;query.find().then(function(activity){if(activity){var activity_ob=activity[0];var activity_ob_comment=activity_ob.get('content');var likeCount=void 0;if(activity_ob){likeCount=activity_ob.get('likeCount');}else{likeCount=0;}if(likeCount==undefined){likeCount=1;}else{likeCount=likeCount+1;}var photo_ob=activity_ob.get('photo');activity_ob.set("likeCount",likeCount);activity_ob.save();//like 
var Like=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend("Like");var like=new Like();var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var currentUser_id=currentUser.id;like.set('fromUser',currentUser);like.set('photo',photo_ob);like.set('activity',activity_ob);like.set("_wperm",{"*":{"read":true,"write":true}});like.set("_rperm",{"*":{"read":true,"write":true}});like.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);acl.setWriteAccess(currentUser,true);acl.setReadAccess(currentUser,true);like.setACL(acl);var fromUserThumb=currentUser.get('profilePictureSmall');if(fromUserThumb!=undefined){like.set('fromUserThumb',fromUserThumb);}like.save().then(function(likeActivitySaved){//if ($('a.liked_activity#comment_'+datapost_id).hasClass('disabled')){ return false;}               
self.setState({singlelikeCount:likeCount});}).catch(function(error){});//like  
self.toggleNotification(post_id,'liked comment',activity_ob);self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});}});setTimeout(function(){var self=_this;console.log('activity like setTimeout');self.handleGetActivityLikePost(datapost_id);},500);}};_this.openPopupCommon=function(e){var postId=_this.props.postcommonid;__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#popup_post_id_common').val(postId);_this.setState({isPopupOpenCommon:true,post_common_id:postId},function(){_this.fetchPostDataCommon(postId);});};_this.handleGetSavePost=function(post_id,page){var posts_id='';if(page==='popup'){posts_id=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#popup_post_id_common').val();post_id=posts_id;}var check_value=0;var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultSavedid=0;var checksavequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Save');checksavequery.equalTo('photo',"Photo$"+post_id);checksavequery.equalTo('fromUser',"_User$"+currentUser_id);checksavequery.find().then(function(resultSave){if(resultSave){var resultSaved=resultSave[0];resultSavedid=resultSaved.id;var photo_id=resultSaved.get('photo').id;if(resultSavedid){//$('.active#save_'+post_id).attr("style", "display: block"); 
//$('.default#save_'+post_id).attr("style", "display: none"); 
//$('a.savepost_link#save_'+post_id).attr("style", "display: none");  
__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.savepost_link1#save_'+post_id).attr("style","pointer-events: auto");if(posts_id){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.post_save1 a.savepost_link1 .savedefault1#save_'+posts_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.post_save1 a.savepost_link1 .saveactive1#save_'+posts_id).attr("style","display: block");}}}});}};_this.fetchPostDataCommon=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(postId){var Post,query,post,userlikelist,query1,self;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({loading_common:true,error_common:null});_context.prev=1;Post=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend('Photo');query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query(Post);_context.next=6;return query.get(postId);case 6:post=_context.sent;userlikelist=[];query1=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');query1.equalTo('photo',"Photo$"+postId);query1.equalTo("type","comment");query1.include("fromUser");query1.include("photo");query1.include("image");query1.include("content");query1.include("_created_at");query1.include("createdAt");query1.doesNotExist("activity");query1.ascending("_created_at");self=_this;query1.find().then(function(result){if(result){var commentdataresults=[];var _loop=function _loop(){var userActivitylist=[];comment=result[i];replyQuery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');replyQuery.equalTo('photo',"Photo$"+postId);replyQuery.exists("activity");replyQuery.equalTo('activity',"Activity$"+comment.id);replyQuery.include("photo");replyQuery.ascending("_created_at");replyQuery.find().then(function(result){if(result){var processedData=result.map(function(result){return{id:result.id,content:result.get('content'),createdAt:result.get('createdAt'),fromUser:result.get('fromUser'),likeCount:result.get('likeCount'),toUser:result.get('toUser'),type:result.get('type'),updatedAt:result.get('updatedAt')};});userActivitylist.push(processedData);}});commentdataresults.push({comments:comment,children:userActivitylist});};for(var i=0;i<result.length;i++){var comment;var replyQuery;_loop();}self.setState({postDetailscomment_common:commentdataresults,postDetails_common:post,loading_common:false,loadingdata_common:true});var obj=post.get('caption')!=''?self.formatRenderComments2main(post.get('caption')):self.formatRenderComments2main(post.get('caption'));var full_text=obj.a.props.children?obj.a.props.children:'';__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#full_text_common').html(full_text);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#lef_img_common').attr('src','../images/default_userpic0.png');__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.popup_user_image_common').attr('src','../images/default_userpic0.png');__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.popup_display_userimage_common').attr('src','../images/default_userpic0.png');__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.user_name a.popup_user_name_common').html('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.user_name a.popup_user_name_common').html(post.get('user').get('displayUsername'));__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.user_name a.popup_user_name_common').attr("href","/user/"+post.get('user').get('displayUsername'));__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.popup_display_username_common').html(post.get('user').get('displayUsername'));__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.popup_display_username_common').attr("href","/user/"+post.get('user').get('displayUsername'));var userprofileimage=post?post.get('user')?post.get('user').get('profilePictureSmall')?post.get('user').get('profilePictureSmall').url():'../images/default_userpic0.png':'../images/default_userpic0.png':'../images/default_userpic0.png';__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.popup_user_image_common').attr('src',userprofileimage);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.popup_display_userimage_common').attr('src',userprofileimage);var photo_img=post?post.get('image')?post.get('image')?post.get('image').url():'../images/default_userpic0.png':'../images/default_userpic0.png':'../images/default_userpic0.png';__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#lef_img_common').attr('src',photo_img);var likeCountNew=post.get('likeCountNew')?post.get('likeCountNew'):0;var likesWord="Likes";if(likeCountNew==1){likesWord="Like";}__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#like_count_new_common').html(likeCountNew+' '+likesWord);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.time_interval_new_common').html(time_ago(post.get('createdAt')));document.getElementById('large_challenge_image_common_btn').click();self.singlegetAllUsersPopup();self.handleGetSavePost(post.id,'popup');self.singlegetUsersLike(post.id);self.handleGetLikeUser(postId);/*url update*///count update
var postimpt=post?post.get('impr')+1:1;post.set('impr',postimpt);post.save().then(function(postupdated){});//count update
//let stateObj = { postId: postId }; 
//  window.history.replaceState("", "","/post/"+postId); 
window.history.pushState(null,'',"/post/"+postId);/*url update*/if(post.get("isChallenge")){this.setState({isChallenge:post.get("isChallenge")});}}else{}},function(error){});_context.next=26;break;case 23:_context.prev=23;_context.t0=_context['catch'](1);_this.setState({loading_common:false});case 26:case'end':return _context.stop();}}},_callee,_this2,[[1,23]]);}));return function(_x){return _ref.apply(this,arguments);};}();_this.handleCommentClick=function(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.add_in_comment #comment_box_popup').focus();};_this.handleNotLoginClick=function(){var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}};_this.handleRemoveSavePost=function(post_id,page){var posts_id='';if(page==='popup'){posts_id=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#popup_post_id_common').val();post_id=posts_id;}var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){//window.alert('You need to login to save post.');
return false;}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.savepost_link1#save_'+post_id).attr("style","pointer-events: none");var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Photo');query.equalTo('objectId',post_id);query.find().then(function(photo){if(photo){var photo_ob=photo[0];var photoid=photo_ob.id;var saveCount=photo_ob.get('saveCount');if(saveCount==undefined||saveCount<0){saveCount=0;}else{saveCount=saveCount-1;}photo_ob.set("saveCount",saveCount);photo_ob.save();var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var checklikequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Save');checklikequery.equalTo('photo',photo_ob);checklikequery.equalTo('fromUser',currentUser);checklikequery.first().then(function(object){if(object){return object.destroy();}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.post_save1 a.savepost_link1 .savedefault1#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.post_save1 a.savepost_link1 .saveactive1#save_'+post_id).attr("style","display: none");}}).then(function(deletedObject){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.post_save1 a.savepost_link1 .savedefault1#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.post_save1 a.savepost_link1 .saveactive1#save_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.savepost_link1#save_'+post_id).attr("style","pointer-events: auto");}).catch(function(error){console.error('Error deleting record:',error);});}else{//console.log("No post found");
}},function(error){//   console.error("Error loading post Error: " + error);
//promise.error(error);
});setTimeout(function(){var self=_this;self.handleGetSavePost(post_id,page);},1000);}};_this.handleSavePost=function(post_id,page){var posts_id='';if(page==='popup'){posts_id=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#popup_post_id_common').val();post_id=posts_id;}var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){//window.alert('You need to login to save post.');
return false;}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.savepost_link1#save_'+post_id).attr("style","pointer-events: none");var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Photo');query.equalTo('objectId',post_id);var self=_this;query.find().then(function(photo){//$('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style", "display: none"); 
if(photo){var photo_ob=photo[0];var photoid=photo_ob.id;var saveCount=photo_ob.get('saveCount');if(saveCount==undefined){saveCount=1;}else{saveCount=saveCount+1;}photo_ob.set("saveCount",saveCount);photo_ob.save();var Save=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend("Save");var save=new Save();var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var currentUser_id=currentUser.id;save.set('fromUser',currentUser);save.set('photo',photo_ob);save.set("_wperm",{"*":{"read":true,"write":true}});save.set("_rperm",{"*":{"read":true,"write":true}});save.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);//acl.setWriteAccess(photo_ob.get('user'), true); 
acl.setWriteAccess(currentUser,true);acl.setReadAccess(currentUser,true);save.setACL(acl);save.save().then(function(savedFile){//  window.alert('You Saved post.');
//  window.location.href = "/";
}).catch(function(error){});self.toggleNotification(post_id,'saved photo','');self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});}else{//console.log("No post found");
}},function(error){//   console.error("Error loading post Error: " + error);
//promise.error(error);
});setTimeout(function(){var self=_this;self.handleGetSavePost(post_id,page);/*if(posts_id)
                          {
                            self.handleGetSavePost(post_id,'popup');
                          }*/},1500);}};_this.handleGetLikePost=function(post_id){var check_value=0;var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultLikedid=0;var checklikequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');checklikequery.equalTo('photo',"Photo$"+post_id);//checklikequery.equalTo('fromUser',"_User$"+currentUser_id);
checklikequery.equalTo('fromUser',currentUser);//checklikequery.notContainedIn("activity");   
checklikequery.doesNotExist("activity");checklikequery.find().then(function(resultLike){if(resultLike){var resultLiked=resultLike[0];resultLikedid=resultLiked.id;if(resultLikedid!==undefined){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_like_shere a.liked1 .active1#like_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_like_shere a.liked1 .default1#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked1#like_'+post_id).attr("style","pointer-events: auto");}if(resultLikedid===undefined){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_like_shere a.liked1 .active1#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_like_shere a.liked1 .default1#like_'+post_id).attr("style","display: block");}}});}};_this.handlePhotoUnLike=function(post_id,page){var posts_id='';if(page==='popup'){//post_id=post_id;
//post_id=$('#popup_post_id').val();
//posts_id=$('#popup_post_id').val();
post_id=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#popup_post_id_common').val();posts_id=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#popup_post_id_common').val();}var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{//$('a.liked .active#like_'+post_id).attr("style", "display: none");
__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked1#like_'+post_id).attr("style","pointer-events: none");var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Photo');query.equalTo('objectId',post_id);//query.equalTo('user', currentUser);
var self=_this;query.find().then(function(photo){if(photo){var photo_ob=photo[0];var photoid=photo_ob.id;var likeCount=photo_ob.get('likeCountNew');if(likeCount==undefined||likeCount==1){likeCount=0;}else{likeCount=likeCount-1;}photo_ob.set("likeCountNew",likeCount);photo_ob.save();var checklikequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');checklikequery.equalTo('photo',photo_ob);checklikequery.equalTo('fromUser',currentUser);checklikequery.first().then(function(object){if(object){return object.destroy();__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: block");if(posts_id){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style","display: block");}}else{/*$('a.liked .active#like_'+post_id).attr("style", "display: none"); 
                                    $('a.liked .default#like_'+post_id).attr("style", "display: block");
                                    if(posts_id)
                                    {
                                      $('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style", "display: none"); 
                                      $('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style", "display: block");
                                  }*/}}).then(function(deletedObject){self.handleGetLikeUser(post_id);self.handleGetLikePost(post_id);self.setState({likeCount:likeCount});//self.setState({likeCount1:likeCount}); 
//$('#home_fetch').trigger('click');
__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: block");if(posts_id){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style","display: block");var likesWord="Likes";if(likeCount==1)likesWord="Like";__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_mn #like_counts_'+posts_id).html(likeCount);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_mn #like_words_'+posts_id).html(likesWord);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked1#like_'+post_id).attr("style","pointer-events: auto");/*if(likeCount==1)
                                  {
                                    likesWord = "Like";
                                   
                                  }*/}var likeCountNew=likeCount;__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#like_count_new_common').html(likeCountNew+' '+likesWord);//$('#popup_post_id').val(posts_id);  
}).catch(function(error){console.error('Error deleting record:',error);});__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#home_fetch').trigger('click');}});/*setTimeout(() => {
                            var self = this;
                           self.handleGetLikeUser(post_id);
                           if(posts_id)
                           {                            
                             self.handleGetLikeUser(posts_id); 
                           }                                                  
                      },1500);*//*  setTimeout(() => {
                          var self = this;
                          self.handleGetLikePost(post_id);
                          self.handleGetLikeUser(post_id);                          
                     },2000);*/}}};_this.handleGetActivityLikePostChild=function(comment_id){//console.log('handleGetActivityLikePostChild click'+comment_id);
var check_value=0;var post_id=_this.state.post_common_id;//this.state.postID;
var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultLikedid=0;var checklikequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');checklikequery.include("activity");checklikequery.equalTo('photo',"Photo$"+post_id);checklikequery.equalTo('activity',"Activity$"+comment_id);checklikequery.equalTo('fromUser',currentUser);checklikequery.find().then(function(resultLike){if(resultLike){var resultLiked=resultLike[0];resultLikedid=resultLiked.id;if(resultLikedid!==undefined){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(' a.liked_activity_child .activitydefault#comment_'+comment_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity_child .activityactive#comment_'+comment_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.like.box.childcomment#child_'+comment_id).attr("style","display: block");//$('.comment_like  .comment.box a .reply_count#comnt_'+comment_id).trigger('click');
__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_user_content .liked_activity_child#comment_'+comment_id).attr("style","pointer-events: auto");}if(resultLikedid===undefined){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity_child .activitydefault#comment_'+comment_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity_child .activityactive#comment_'+comment_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.like.box.childcomment#child_'+comment_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_user_content .liked_activity_child#comment_'+comment_id).attr("style","pointer-events: auto");}}});// this.state.singlementioned_popup='';
/*  var reply_id=$('#reply_id').val();
         if(reply_id==='')
          {
           this.state.singlementioned_popup='';
          }*///setTimeout(() => {
//  var self = this;
//  self.handleCommentPostUpdate();
// },1000);
}};_this.togglePicker=function(){_this.setState(function(prevState){return{showPicker:!prevState.showPicker};});};_this.onEmojiClick=function(event,emojiObject){_this.setState(function(prevState){return{//inputText: prevState.inputText + emojiObject.emoji,
singlementioned_popup:prevState.singlementioned_popup+emojiObject.emoji,showPicker:false// Optional: hide the picker after selection
};});};_this.handlePhotoActivityUnLikeChild=function(e){var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{var post_id=e.target.id;var datapost_id=e.target.dataset.id;//$('a.liked_activity .activityactive#comment_'+datapost_id).attr("style", "display: none");
//console.log('datapost_id'+datapost_id);
__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_user_content .liked_activity_child#comment_'+datapost_id).attr("style","pointer-events: none");var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');query.equalTo('objectId',datapost_id);var self=_this;query.find().then(function(activity){if(activity){var activity_ob=activity[0];var likeCount=void 0;if(activity_ob){likeCount=activity_ob.get('likeCount');}else{likeCount=0;}if(likeCount===undefined||likeCount===0){likeCount=0;}else{likeCount=likeCount-1;}var photo_ob=activity_ob.get('photo');activity_ob.set("likeCount",likeCount);activity_ob.save();//like 
var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var currentUser_id=currentUser.id;var checklikequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');checklikequery.equalTo('photo',photo_ob);checklikequery.equalTo('fromUser',currentUser);checklikequery.equalTo('activity',activity_ob);checklikequery.first().then(function(object){if(object){return object.destroy();}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity_child .activitydefault#comment_'+datapost_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity_child .activityactive#comment_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.like.box.childcomment#child_'+datapost_id).attr("style","display: none");}}).then(function(deletedObject){//self.setState({likeCount:likeCount});  
//$('#home_fetch').trigger('click');
self.setState({singlelikeCountChild:likeCount});var likesWord="Likes";if(likeCount==1){likesWord="Like";}__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.like.box .count#childlike_'+datapost_id).html(likeCount);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.like.box .like_count#childlike_'+datapost_id).html(likesWord);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.like.box .like_count#childlike_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity_child .activityactive#comment_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity_child .activitydefault#comment_'+datapost_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_user_content .liked_activity_child#comment_'+datapost_id).attr("style","pointer-events: auto");if(likeCount===0){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.like.box.childcomment#child_'+datapost_id).attr("style","display: none");}}).catch(function(error){console.error('Error deleting record:',error);});//like  
}});setTimeout(function(){var self=_this;self.handleGetActivityLikePostChild(datapost_id);},2000);}};_this.handlePhotoActivityLikeChild=function(e){var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{var post_id=e.target.id;var datapost_id=e.target.dataset.id;__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.comment_user_content .liked_activity_child#comment_'+datapost_id).attr("style","pointer-events: none");var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');query.equalTo('objectId',datapost_id);var self=_this;query.find().then(function(activity){if(activity){var activity_ob=activity[0];var likeCount=void 0;if(activity_ob){likeCount=activity_ob.get('likeCount');}else{likeCount=0;}if(likeCount==undefined){likeCount=1;}else{likeCount=likeCount+1;}var photo_ob=activity_ob.get('photo');activity_ob.set("likeCount",likeCount);activity_ob.save();//like 
var Like=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend("Like");var like=new Like();var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var currentUser_id=currentUser.id;like.set('fromUser',currentUser);like.set('photo',photo_ob);like.set('activity',activity_ob);like.set("_wperm",{"*":{"read":true,"write":true}});like.set("_rperm",{"*":{"read":true,"write":true}});like.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);acl.setWriteAccess(currentUser,true);acl.setReadAccess(currentUser,true);like.setACL(acl);var fromUserThumb=currentUser.get('profilePictureSmall');if(fromUserThumb!=undefined){like.set('fromUserThumb',fromUserThumb);}like.save().then(function(likeActivitySaved){var likesWord="Likes";if(likeCount==1){likesWord="Like";}__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.like.box .count#childlike_'+datapost_id).html(likeCount);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.like.box .like_count#childlike_'+datapost_id).html(likesWord);if(likeCount===0){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.like.box.childcomment#child_'+datapost_id).attr("style","display: none");}self.setState({singlelikeCountChild:likeCount});}).catch(function(error){});//like  
self.toggleNotification(post_id,'liked comment',activity_ob);self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});}});setTimeout(function(){var self=_this;self.handleGetActivityLikePostChild(datapost_id);},2000);}};_this.handleCommentPostPopup=function(e){var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.post_button_comment#handleCommentPost_popup').attr("disabled",true);var self=this;e.preventDefault();//$(".add_in_comment .emoji_icon_input_row .textarea_bottom.active").attr("style", "visibility: hidden");
var Photo=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend("Photo");var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query(Photo);var photo_post_id=this.state.post_common_id;var postcomment=this.state.singlementioned_popup;//this.state.postcomment_popup;
var reply_id=this.state.reply_id;//$('#reply_id').val();
var activity_parent_id=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#activity_parent_id').val();if(postcomment){query.include("user");query.include("image");query.include("thumbnail");query.include("likeCountNew");query.include("saveCount");query.include("commentcount");query.include("_created_at");query.include("createdAt");query.exists("user");query.descending("createdAt");query.find({success:function success(results){if(results.length>0){self.setState({loader:true});results.forEach(function(photo){if(photo.id===photo_post_id){var Activity=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend("Activity");var activity=new Activity();var _currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();activity.set('fromUser',_currentUser);activity.set('toUser',photo.get("user"));activity.set('content',postcomment);activity.set('type','comment');if(reply_id){activity.set('activity','Activity$'+activity_parent_id);}activity.set('photo',photo);activity.set('likeCount',0);var currentUser_id=_currentUser.id;try{activity.save().then(function(savedActivity){var activityId=savedActivity.id;self.setState({reply_thread_id:activityId});// setTimeout(() => {
// $('a.liked_activity .activityactive#comment_'+activityId).attr("style", "display: none"); 
//$('a.liked_activity .activitydefault#comment_'+activityId).attr("style", "display: block"); 
// },1000);  
if(reply_id){self.toggleNotification(photo_post_id,'commented post reply',savedActivity);}else{self.toggleNotification(photo_post_id,'commented post',savedActivity);}// self.toggleNotification(photo_post_id,'commented post',savedActivity);
self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});var captionusername='';var captionusernameupdated='';if(postcomment){captionusername=postcomment.match(/@\w+/);if(captionusername){captionusernameupdated=captionusername[0].substr(1);if(captionusernameupdated){//self.toggleNotification(photo_post_id,'tagged you in a comment',savedActivity);
self.toggleNotification(photo_post_id,'mentioned you in a comment',savedActivity);self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});}}}}).catch(function(error){});__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".comment_box_popup").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#comment_box_popup").val('');var updated_photo_id=photo.get('id');var Photo_single=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend("Photo");var Photoquery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query(Photo_single);var photoId=photo.id;Photoquery.get(photoId).then(function(photo){var commentcount_val=parseInt(photo.get('commentcount'));if(isNaN(commentcount_val)){commentcount_val=0;}var updated_comment_count=commentcount_val+1;photo.set("commentcount",updated_comment_count.toString());self.setState({commentCount:updated_comment_count.toString()});photo.save();self.setState({singlementioned_popup:''});}).catch(function(error){});setTimeout(function(){self.setState({singlementioned_popup:'',reply_id:''});self.handleCommentPostUpdate();},500);}catch(error){}}});}else{}},error:function error(_error){}});}var self=this;var post_id=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#popup_post_id_common').val();}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}};_this.handleCommentPostLikes=function(){var post_id=_this.state.post_common_id;var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var query_activityChild=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');query_activityChild.equalTo('photo',"Photo$"+post_id);query_activityChild.exists("activity");query_activityChild.find().then(function(resultactivity){var resultactivitys=resultactivity;var _loop2=function _loop2(objects){setTimeout(function(){if(objects.get('likeCount')===0){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity_child .activityactive#comment_'+objects.id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity_child .activitydefault#comment_'+objects.id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.like.box .count#childlike_'+objects.id).html(0);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.like.box .like_count#childlike_'+objects.id).html('Likes');}},1000);};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=resultactivitys[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var objects=_step.value;_loop2(objects);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}});}};_this.handleCommentPostUpdate=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var photo_post_id,reply_thread_id,self,query,reply_id,commentCountval,getPhotoquery;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0://$(".add_in_comment .emoji_icon_input_row .textarea_bottom.active").attr("style", "visibility: hidden");   
//$('.add_in_comment #comment_box_popup').attr("style", "color: transparent");
//$('.add_in_comment #comment_box_popup').attr('placeholder','Add a comment...');
photo_post_id=_this.state.post_common_id;reply_thread_id=_this.state.reply_thread_id;self=_this;query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');reply_id=_this.state.reply_id;query.equalTo('photo',"Photo$"+photo_post_id);query.equalTo("type","comment");query.doesNotExist("activity");query.include("fromUser");query.include("photo");query.limit(999999999);query.include("image");query.include("content");query.include("_created_at");query.include("createdAt");//query.descending("_created_at");
query.ascending("_created_at");commentCountval=_this.state.commentCount;query.find().then(function(result){var commentdataresults1=[];if(result){var totalcomment=result.length;var totalcommentchild=0;self.setState({singlementioned_popup:''});self.setState({comments:result});var _loop3=function _loop3(){var userActivitylist=[];comment=result[i];comment_idsval=comment.id;replyQuery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');replyQuery.equalTo('photo',"Photo$"+photo_post_id);replyQuery.exists("activity");replyQuery.equalTo('activity',"Activity$"+comment.id);replyQuery.include("photo");replyQuery.ascending("_created_at");// replyQuery.descending("_created_at");
replyQuery.find().then(function(result){if(result){//totalcommentchild=result.length;
var processedData=result.map(function(result){return{id:result.id,content:result.get('content'),createdAt:result.get('createdAt'),fromUser:result.get('fromUser'),likeCount:result.get('likeCount'),toUser:result.get('toUser'),type:result.get('type'),updatedAt:result.get('updatedAt')};});userActivitylist.push(processedData);}//self.handleGetActivityLikePostChild(comment_idsval) ; 
//self.handleGetActivityLikePost(result.id); 
});commentdataresults1.push({comments:comment,children:userActivitylist});/*setTimeout(() => {
                if(comment.id) {
                  // $('.comment_like  .comment.box a .reply_count#comnt_'+comment.id).trigger('click');
                    self.handleGetActivityLikePostChild(comment.id)
                }
              },1000); */};for(var i=0;i<result.length;i++){var comment;var comment_idsval;var replyQuery;_loop3();}setTimeout(function(){self.setState({postDetailscomment_common:commentdataresults1},function(){self.setState({loadingdata_common:true,loading_common:false,singlementioned_popup:'',loader:false,reply_id:''});});if(reply_thread_id){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(' a.liked_activity_child .activitydefault#comment_'+reply_thread_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('a.liked_activity_child .activityactive#comment_'+reply_thread_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.like.box .count#childlike_'+reply_thread_id).html(0);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.like.box .like_count#childlike_'+reply_thread_id).html('Likes');}self.setState({reply_thread_id:''});setTimeout(function(){self.handleCommentPostLikes();__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#activity_parent_id').val('');},500);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.post_button_comment#handleCommentPost_popup').attr("disabled",false);},3500);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#reply_id').val('');//self.setState({ reply_id: '' });
//self.setState({singlementioned_popup: ''});
//self.setState({commentCount:totalcomment});
//console.log('totalcomment'+totalcomment)
//self.setState({postDetailscomment: result});
//self.renderDetailPage(photo_post_id);
/*setTimeout(() => {
                if(commentdataresults1) {
                  for (var i = 0; i < commentdataresults1.length; i++) {
                    var commentdataresults1 = commentdataresults1[i]; 
                    let comment= commentdataresults1.comments; 
                    console.log('comment');
                    console.log(comment);
                    console.log('.comment_like  .comment.box a .reply_count#comnt_'+comment.id);
                    $('.comment_like  .comment.box a .reply_count#comnt_'+comment.id).trigger('click');
                  }
                }
              },1000); *//*setTimeout(() => {
              self.setState({reply_id: ''});
              $('#reply_id').val('');
              $(".add_in_comment #comment_box_popup").val('');
              self.setState({singlementioned_popup: ''});
                $('#clearInput').trigger('click');                 
              },2000); */}else{}},function(error){});getPhotoquery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Photo');getPhotoquery.equalTo('objectId',photo_post_id);self=_this;getPhotoquery.find().then(function(photo){if(photo){var photo_ob=photo[0];var commentcount=photo_ob.get('commentcount')?photo_ob.get('commentcount'):0;self.setState({commentCount:commentcount});photo_ob.set("commentcount",commentcount.toString());photo_ob.save();}});case 22:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.replyComment=function(commentId,activity_parent_id,event){var commentIds=commentId.split('comnt_');var commenUpdatedId=commentIds[1];__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#reply_id').val(commenUpdatedId);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#activity_parent_id').val(activity_parent_id);_this.setState({reply_id:commenUpdatedId});var reply_id=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#reply_id').val();var query1=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');query1.equalTo('objectId',commenUpdatedId);query1.equalTo("type","comment");query1.include("fromUser");var self=_this;__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.add_in_comment #comment_box_popup').val('');var activity_parent_ids=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#activity_parent_id').val();query1.find().then(function(photo){if(photo){var photo_ob=photo[0];var displayusername=photo_ob?photo_ob.get('fromUser')?'@'+photo_ob.get('fromUser').get('displayUsername')+'  ':'':'';var displayusernameval=photo_ob?photo_ob.get('fromUser')?photo_ob.get('fromUser').get('displayUsername'):'':'';self.setState({singlementioned_popup:displayusername});}});setTimeout(function(){if(activity_parent_ids===''&&reply_id===''){self.setState({singlementioned_popup:''});__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#clearInput').trigger('click');}},2000);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.add_in_comment #comment_box_popup').focus();};_this.renderDetailPageCommon=function(post_id){var _this$state=_this.state,postDetails_common=_this$state.postDetails_common,postDetailscomment_common=_this$state.postDetailscomment_common,likeuserlist=_this$state.likeuserlist,inputText=_this$state.inputText,showPicker=_this$state.showPicker,loadingdata_common=_this$state.loadingdata_common,loader=_this$state.loader;var othertext='';var bufferdata_common=[];var bufferdatacommentreply=[];var userlikeusername=[];var fetchuserlikeusername=[];var bufferfollowers=[];var bufferlikefollowers=[];var formatRenderCommentChild=function formatRenderCommentChild(origComment,comnt_id,comment_id){var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,buffer);}var stringSplit=origComment.split(" ");var maxLength=250;for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);var self=_this;if(firstChar=="#"){buffer.push(comp);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){buffer.push(comp);}else if(comp.indexOf("@")!==-1||comp.indexOf("@")!==-1){var userdisplayname=comp.replace('@','');var linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';buffer.push(linkdata);}else{buffer.push(comp);}}var content=buffer.join(' ');var _this$props=_this.props,_this$props$showMoreT=_this$props.showMoreText,showMoreText=_this$props$showMoreT===undefined?'more':_this$props$showMoreT,_this$props$showLessT=_this$props.showLessText,showLessText=_this$props$showLessT===undefined?'less':_this$props$showLessT;var isExpanded=_this.state.isExpanded;var expandedCommentId=_this.state.expandedCommentId;var shouldTruncate=content.length>maxLength&&!isExpanded;var displayText=shouldTruncate?content.slice(0,maxLength)+'...':content;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'cmt-txt',id:comment_id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:displayText}}),shouldTruncate&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{onClick:function onClick(){return _this.toggleExpand(comment_id);},style:{color:'#868589',cursor:'pointer',border:'none',background:'none'}},isExpanded?showLessText:showMoreText));};var singlePostModalClose1Common=function singlePostModalClose1Common(){/*url update*/var current_weburl=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#current_weburl').val();var search_txt_box=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#search_txt_box').val();var current_weburls=_this.state.previousUrl;//console.log(this.state.previousUrl+'previousUrl');
if(search_txt_box!==''&&current_weburl.includes('search')){// window.history.replaceState("","", current_weburl+'?q='+search_txt_box);
setTimeout(function(){window.history.replaceState("","",'/search?q='+search_txt_box);},500);}else{setTimeout(function(){window.history.replaceState("","",current_weburls);},500);}//window.history.replaceState("","", current_weburl);  
/*url update*/__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#closepopup_common').click();_this.setState({isPopupOpenCommon:false,postDetails_common:null,postDetailscomment_common:null});__WEBPACK_IMPORTED_MODULE_3_jquery___default()("body").removeClass("sngl_mdl_open");__WEBPACK_IMPORTED_MODULE_3_jquery___default()("body").removeClass("modal-open1");__WEBPACK_IMPORTED_MODULE_3_jquery___default()("body").removeClass("modal-open");__WEBPACK_IMPORTED_MODULE_3_jquery___default()("body").removeClass("modal-open-search");__WEBPACK_IMPORTED_MODULE_3_jquery___default()("body").removeClass("modelopenexplore");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#popup_post_id_common').val('');//tabopenarray.length = 0; 
//$('#closepopupsingle').click();
_this.setState({loading_common:false});};var clearInput=function clearInput(){console.log('clearInput');var self=_this;self.setState({singlementioned_popup:''});};var getCommentProfilePicChild=function getCommentProfilePicChild(comment){var user=comment.fromUser;if(user&&user!=undefined){var pic=user.get('profilePictureSmall');if(pic&&pic!=undefined)return pic.url();}return"/images/default_userpic0.png";};if(_this.state.postDetailscomment_common){if(_this.state.postDetailscomment_common.length>0){var buffercommentdata=[];var _loop4=function _loop4(){comment=_this.state.postDetailscomment_common[i];var children=comment.children!==undefined?comment.children[0]:'';comment=comment.comments;var comment_activity_id="comment_"+comment.id;var comment_id="comnt_"+comment.id;var comment_par_id="comnt_"+comment.id;var likeCount=comment.get("likeCount")?comment.get("likeCount"):0;likesWord="Likes";if(likeCount==1)likesWord="Like";var comment_fromuserid=comment.get("fromUser").id;var comment_currentUserId=_this.state.currentUserId;var hasKey=comment.has('activity');self=_this;var main_activity_id=comment.id;bufferdata_common.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:69*i,className:'cmt_wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'detail_bottom user_top_row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_top_card'},hasKey==false?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_inline_row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_leftbar_img'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'user_icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:_this.getCommentProfilePicCommon(comment)}),'  ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_name_wrapper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_name'},comment.get("fromUser")?comment.get("fromUser").get('displayUsername')?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+comment.get("fromUser").get('displayUsername')},comment.get("fromUser").get('displayUsername')):'':'',hasKey==false?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'content-span'},'  ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'cmt_cnt',id:comment_id},_this.formatRenderComment(comment.get("content"),comment_id,comment.id))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,_this.formatRenderComment(comment.get("content"),comment_id,comment.id),' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_sidebar_heart'},_this.handleGetActivityLikePost(comment.id),likeCount==0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'liked_activity',id:comment_activity_id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{'data-id':comment.id,id:comment_activity_id,onClick:function onClick(e){_this.handlePhotoActivityLike(e);},className:'activitydefault',src:'../images/cmt-like.svg'})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'liked_activity',id:comment_activity_id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{'data-id':comment.id,id:comment_activity_id,onClick:function onClick(e){_this.handlePhotoActivityUnLike(e);},className:'activityactive',style:{display:"none"},src:'../images/like-fill.svg'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{'data-id':comment.id,id:comment_activity_id,onClick:function onClick(e){_this.handlePhotoActivityLike(e);},className:'activitydefault',src:'../images/cmt-like.svg'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'like box maincomment',id:comment.id,style:{display:likeCount===0?'none':'block'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:;',id:'like_button_challenge',onClick:function onClick(e){_this.singlePostLikeModalLikes(main_activity_id,false);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'count'},likeCount),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'like_count',style:{display:"none"}},likesWord))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'product_content_details'},hasKey==false?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center',id:comment_id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'day box'},time_ago(comment.get("createdAt"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'reply_count',id:comment_id,onClick:function onClick(e){return _this.replyComment(comment_id,main_activity_id,e);}},'Reply'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'comment box',style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/small_dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},comment_fromuserid===comment_currentUserId?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button',onClick:function onClick(e){return _this.deleteCommentIdOverlay(comment_id);},id:'close_deleteCommentwithdiscard','aria-label':'Modal'},'Delete'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item',type:'button'},'Cancel')))))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null),children!==undefined&&children.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'view_replies_comment'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'faq-drawer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{className:'faq-drawer__trigger',id:"faq-drawer-"+comment.id,type:'checkbox',title:comment_id,onClick:function onClick(e){return _this.faqOpenClose(comment_id);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'faq-drawer__title',htmlFor:"faq-drawer-"+comment.id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{id:"faq-"+comment.id},'View Replies '),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'replies_count',id:"faqreply-"+comment.id},'(',children.length,')'),' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'faq-drawer__content-wrapper',id:"fq-"+comment.id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'faq-drawer__content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'ul_list_replay_user'},loadingdata_common&&children&&children.map(function(child,i,row){{var _comment_fromuserid=child.fromUser.id;var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var _comment_currentUserId='';if(currentUser){_comment_currentUserId=currentUser.id;}var comment_activity_id_child="comment_"+child.id;var comment_id_child="comnt_"+child.id;var likeCountChild=child.likeCount?child.likeCount:0;var likesWord="Likes";if(likeCountChild==1)likesWord="Like";return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'li_list_replay_user',key:69*i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'comment_replay_row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'comment_replay_inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'comment_userimg_inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'comment_user_img'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:getCommentProfilePicChild(child)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'comment_content_inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content_replay'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'title_userName'},' ',child.fromUser?child.fromUser.get('displayUsername')?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+child.fromUser.get('displayUsername')},child.fromUser.get('displayUsername')):'':'',' '),'  ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'content-span'},'  ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'cmt_cnt',id:comment_id_child},formatRenderCommentChild(child.content,comment_id_child,child.id)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'day box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:;'},time_ago(child.createdAt))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'reply_count',id:comment_id_child,onClick:function onClick(e){return self.replyComment(comment_id_child,main_activity_id,e);}},'Reply'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'comment box',style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot dropup'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist1',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/small_dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dropdown-menu'},_comment_fromuserid===_comment_currentUserId?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button',onClick:function onClick(e){return self.deleteCommentIdOverlay(comment_id_child);},id:'close_deleteCommentwithdiscard','aria-label':'Modal'},'Delete'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item',type:'button'},'Cancel'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'comment_user_content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'liked_activity_child',id:comment_activity_id_child},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{'data-id':child.id,id:comment_activity_id_child,onClick:function onClick(e){self.handlePhotoActivityUnLikeChild(e);},className:'activityactive',style:{display:"none"},src:'../images/like-fill.svg'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{'data-id':child.id,id:comment_activity_id_child,onClick:function onClick(e){self.handlePhotoActivityLikeChild(e);},className:'activitydefault',src:'../images/cmt-like.svg',style:{display:"block"}})),self.handleGetActivityLikePostChild(child.id,child),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'like box childcomment',id:"child_"+child.id,style:{display:likeCountChild===0?'none':'block'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:;',id:'like_button_challenge',onClick:function onClick(e){self.singlePostLikeModalLikes(child.id,false);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'count',id:"childlike_"+child.id},likeCountChild),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'like_count',style:{display:"none"},id:"childlike_"+child.id},likesWord))))))));}})))))))))):''))));};for(var i=0;i<_this.state.postDetailscomment_common.length;i++){var comment;var likesWord;var self;_loop4();}}}if(_this.state.likeuserlist){var rows=_this.state.likeuserlist.length;var other=0;for(var i=0;i<rows;i++){var likeuser=_this.state.likeuserlist[i];if(rows>1){other=rows-1;}if(i==0){if(likeuser.get('fromUser')&&likeuser.get('fromUser').id!==undefined){userlikeusername.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:69*i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+likeuser.get('fromUser').get("displayUsername"),id:'like_button_challenge',onClick:_this.singlePostLikeModal,type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},'  ',likeuser.get('fromUser').get("displayUsername"))));}}}if(userlikeusername){fetchuserlikeusername.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:69*i},userlikeusername!=''?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'liked_others'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Liked by  ',userlikeusername,' ',rows>1&&other?other==1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,' and ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:'like_button_challenge',onClick:_this.singlePostLikeModal,type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},other),'  other '):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,' and ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:'like_button_challenge',onClick:_this.singlePostLikeModal,type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},other),'  others '):"",' ')):''));}}if(_this.state.followersListing){var followinguserid=_this.state.followinguserid;var following_match_id=[];var rows=_this.state.followersListing.length;if(rows!=undefined){for(var i=0;i<rows;i++){var followers=_this.state.followersListing[i];var follow_id_ms='followpopup_'+followers.id;var userimage=null;if(followers.image){userimage=followers.image;}else{userimage="/images/default_userpic0.png";}var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var currentUserid=currentUser.id;var chek=followinguserid.find(function(c){return c.id===followers.id;});var followingresults=chek!=undefined?JSON.parse(JSON.stringify(chek)):"";bufferfollowers.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:69*i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'img_like_li'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'like_user_img'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'mr-3',src:userimage,alt:'Generic placeholder image'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'like_user_name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+followers.displayUsername},followers.displayName,' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'name_tagline'},followers.displayUsername))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'followimg_button'},currentUserid===followers.id?"":followingresults.id===followers.id?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'following_user follow_button ',id:follow_id_ms,title:'UnFollow','data-id':followers.id,onClick:function onClick(e){return _this.handleUnFollowMyProfile(e);}},'Unfollow'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:follow_id_ms,title:followers.toUser,'data-id':followers.id,onClick:function onClick(e){return _this.handleFollowMyProfile(e);},style:{display:"block"},href:'javascript:void(0);',className:'follow_user follow_button'},'Follow'))));}else{bufferfollowers.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:69*i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'img_like_li'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'like_user_img'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'mr-3',src:userimage,alt:'Generic placeholder image'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'like_user_name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+followers.displayUsername},followers.displayName,' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'name_tagline'},followers.displayUsername))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'followimg_button'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:follow_id_ms,title:followers.toUser,'data-id':followers.id,onClick:function onClick(e){return _this.handleFollowMyProfile(e);},style:{display:"block"},href:'javascript:void(0);',className:'follow_user follow_button'},'Follow'))));}}}}if(_this.state.followerslikeListing){var _followinguserid=_this.state.followinglikeuserid;var following_match_id=[];var rows=_this.state.followerslikeListing.length;if(rows!=undefined){for(var i=0;i<rows;i++){var followers=_this.state.followerslikeListing[i];var follow_id_ms='followpopup_'+followers.id;var _userimage=null;if(followers.image){_userimage=followers.image;}else{_userimage="/images/default_userpic0.png";}var _currentUser2=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(_currentUser2){var _currentUserid=_currentUser2.id;var chek=_followinguserid.find(function(c){return c.id===followers.id;});var followingresults=chek!=undefined?JSON.parse(JSON.stringify(chek)):"";bufferlikefollowers.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:69*i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'img_like_li'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'like_user_img'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'mr-3',src:_userimage,alt:'Generic placeholder image'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'like_user_name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+followers.displayUsername},followers.displayName,' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'name_tagline'},followers.displayUsername))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'followimg_button'},_currentUserid===followers.id?"":followingresults.id===followers.id?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'following_user follow_button ',id:follow_id_ms,title:'UnFollow','data-id':followers.id,onClick:function onClick(e){return self.handleUnFollowMyProfileLike(e);}},'Unfollow'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:follow_id_ms,title:followers.toUser,'data-id':followers.id,onClick:function onClick(e){return self.handleFollowMyProfileLike(e);},style:{display:"block"},href:'javascript:void(0);',className:'follow_user follow_button'},'Follow'))));}else{bufferlikefollowers.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:69*i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'img_like_li'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'like_user_img'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'mr-3',src:_userimage,alt:'Generic placeholder image'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'like_user_name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+followers.displayUsername},followers.displayName,' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'name_tagline'},followers.displayUsername))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'followimg_button'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:follow_id_ms,title:followers.toUser,'data-id':followers.id,onClick:function onClick(e){return self.handleFollowMyProfileLike(e);},style:{display:"block"},href:'javascript:void(0);',className:'follow_user follow_button'},'Follow'))));}}}}var getLoggedinUsername=localStorage.getItem('username');var post_id_m='save_'+post_id;var follow_id_m='follow_'+postDetails_common.get('user').id;var currentuserImage=_this.state.currentuserImage;var post_like_id_m='like_'+post_id;var currentUserId=_this.state.currentUserId;var sameprofile=0;if(currentUserId===postDetails_common.get('user').id){sameprofile=1;}var isNotificationOpen=_this.state.isNotificationOpen;var post_Notification_Ids=_this.state.post_Notification_Id;var post_Notification_Msg=_this.state.post_Notification_Msg;var post_Notification_Comment=_this.state.post_Notification_Comment;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay singlePostOverlayModal createPostCloseModal large_challenge_image_common',id:'large_challenge_image_common','data-backdrop':'false','data-keyboard':'true',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel',onClick:singlePostModalClose1Common,'data-dismiss':'modal','aria-label':'Close',title:'Close'},'\u2715')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{style:{display:"none"},href:'javascript:void(0);',type:'button',className:'btn','data-toggle':'modal','data-target':'#large_challenge_like_list_likes1',id:'large_challenge_like_list_likes'},'get '),isNotificationOpen?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__saveNotification_jsx__["a" /* default */],{isOpen:isNotificationOpen,postNotificationid:post_Notification_Ids,postMsg:post_Notification_Msg,postPhotoid:post_id,postActivityComment:post_Notification_Comment}):"",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inner_post_row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'img_leftSide'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{id:'lef_img_common',src:'../images/default_userpic0.png',alt:'Comment'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'right_side_content_post'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_top_row border_bottom'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_top_card'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'user_icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'popup_user_image_common',src:'../images/default_userpic0.png',alt:'img'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'popup_user_name_common',href:'#'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},sameprofile===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'post_delete_cm'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button',id:'delete_post_with_discardpoup',onClick:function onClick(e){return _this.deletePostId(post_id);},title:'Delete','data-toggle':'modal','data-target':'#deletePostCloseModalpopup'},'Delete')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);','aria-label':'Close',className:'dropdown-item',type:'button',title:'Cancel'},'Cancel'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'post_listing_ul_wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'post_listing_ul'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'post_listing_li'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'detail_bottom user_top_row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_top_card'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_inline_row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_leftbar_img'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'user_icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'popup_display_userimage_common',src:'../images/default_userpic0.png',alt:'img'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_name_wrapper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:;',className:'popup_display_username_common'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'cmt_box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'cmt_cnt'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'cmt-txt',id:'full_text_common'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'content-span'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user_sidebar_heart'},' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'product_content_details'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'day box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'time_interval_new_common'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'like box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:;',id:'like_button_challenge',onClick:_this.singlePostLikeModal,type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{id:'like_count_new_common'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'comment box'}))))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'post_listing_li'},bufferdata_common))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'hidden',id:'popup_post_id_common',name:'popup_post_id_common',value:post_id}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'comment_post_bottom_add'},sameprofile===1&&_this.state.isChallenge==0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'create_challenge_row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/create-challenge/'+_this.state.post_common_id,className:'create_button',title:'Create Challenge'},'Create Challenge')):"",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'comment_like_shere'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'wrapper d-flex flex-row flex-wrap align-items-center justify-content-between w-100'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action_grp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'hidden',id:'popup_load_id',name:'popup_load_id',onClick:function onClick(){return _this.handleLoadPopup(post_id);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'hidden',id:'reply_id',name:'reply_id'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'hidden',id:'activity_parent_id',name:'activity_parent_id'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'like-icon liked1',id:post_like_id_m},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{id:post_like_id_m,onClick:function onClick(){return _this.handlePhotoLike(post_id,'popup');},className:'default1',src:'../images/like.svg'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{id:post_like_id_m,onClick:function onClick(){return _this.handlePhotoUnLike(post_id,'popup');},className:'active1',style:{display:"none"},src:'../images/like-fill.svg'}),_this.handleGetLikePost(post_id)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:;',onClick:function onClick(){return _this.handleCommentClick();},className:'comment-icon home-comment'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'../images/comment-bold.svg',alt:'Comment'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:;',className:'share-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'../images/cmt-share-bold.svg',alt:'Share'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'post_save1'},getLoggedinUsername!=null?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',style:{display:"block"},id:post_id_m,className:'savepost_link1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{id:post_id_m,style:{display:"block"},className:'savedefault1',src:'../images/bookmark.svg',onClick:function onClick(){return _this.handleSavePost(post_id,'popup');},alt:'No BookMark'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{id:post_id_m,style:{display:"none"},className:'saveactive1',src:'../images/bookmark-fill.svg',onClick:function onClick(){return _this.handleRemoveSavePost(post_id,'popup');},alt:'BookMark'}),_this.handleGetSavePost(post_id,'popup')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this.handleNotLoginClick();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{style:{display:"block"},className:'savedefault1',src:'../images/bookmark.svg',alt:'No BookMark'})))),fetchuserlikeusername),showPicker&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_emoji_picker_react___default.a,{onEmojiClick:_this.onEmojiClick}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'add_in_comment'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'emoji_icon_input_row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'emogi_icon'},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'../images/add_reaction.svg',alt:'img',onClick:_this.togglePicker})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'textarea_bottom active'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_mentions__["b" /* MentionsInput */],{placeholder:'Add a comment...',value:_this.state.singlementioned_popup,id:'comment_box_popup',onChange:_this.updateInputPopup,style:__WEBPACK_IMPORTED_MODULE_6__defaultStyle__["a" /* default */],onKeyDown:_this.handleSinglePostPopupEnter},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_mentions__["a" /* Mention */],{trigger:'@',data:_this.state.singleget_allusers_popup,markup:'@__display__ ',displayTransform:function displayTransform(id,display,displayName){return'@'+display;},appendSpaceOnAdd:true,style:__WEBPACK_IMPORTED_MODULE_7__defaultMentionStyle__["a" /* default */],renderSuggestion:_this.singlerenderUserSuggestionPopup,required:true,id:'comment_box_popup',className:'mentions__mention',placeholder:'Add a comment...'}))),_this.state.singlementioned_popup===''?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{id:'handleCommentPost_popup',disabled:true,className:'post_button_comment',onClick:_this.handleCommentPostPopup},'Post'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{id:'handleCommentPost_popup',className:'post_button_comment',onClick:_this.handleCommentPostPopup},'Post'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{style:{display:"none"},onClick:clearInput,id:'clearInput'},'Clear Input'),_this.state.loader&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'loading_img',style:{'position':"absolute",'top':"50%",'left':"50%",'transform':"translate(-50%, -50%)"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{style:{'width':"40px"},src:'/images/loading-gif.gif'})))))))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal fade post_modal singlelikesModal createPostCloseModal large_challenge_image',id:'large_challenge_like_list',onKeyDown:_this.singlePostLikeModalClose,'data-backdrop':'false','data-keyboard':'true',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel','data-dismiss':'modal','aria-label':'Close',onClick:_this.singlePostLikeModalClose,title:'Close'},'\u2715')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'likes_user_model'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'likes_model_row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:'like_title'},'Likes')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'model_likes_main'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'like_total_list'},bufferfollowers)))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal fade post_modal singlelikesModal createPostCloseModal large_challenge_image',id:'large_challenge_like_list_likes1',onKeyDown:_this.singlePostLikeModalClose,'data-backdrop':'false','data-keyboard':'true',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel','data-dismiss':'modal','aria-label':'Close',onClick:_this.singlePostLikeModalClose,title:'Close'},'\u2715')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'likes_user_model'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'likes_model_row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:'like_title'},'Likes')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'model_likes_main'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'like_total_list'},bufferlikefollowers)))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay deletePostCloseModalpopup',id:'deletePostCloseModalpopup','data-backdrop':'false','data-keyboard':'false',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'Are you sure you want to delete this post?')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'hidden',id:'delete_post_id',name:'delete_post_id'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this.checkDeletePost();},className:'btn danger btn-post-discard','data-dismiss':'modal','aria-label':'Close',title:'Delete'},'Delete'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel','data-dismiss':'modal','aria-label':'Close',title:'Cancel'},'Cancel'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay deleteCommentCloseModal',id:'deleteCommentCloseModal','data-backdrop':'false','data-keyboard':'false',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'Are you sure you want to delete?')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'hidden',id:'delete_comment_id',name:'delete_comment_id'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn danger btn-post-discard','data-dismiss':'modal','aria-label':'Close',onClick:_this.checkDeleteComment,title:'Discard'},'Delete'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel','data-dismiss':'modal','aria-label':'Close',title:'Cancel'},'Cancel'))))))));};_this.state=(_this$state2={//data: null,
isPopupOpenCommon:false,loading_common:false,error_common:null,post_common_id:'',postDetailscomment_common:null,postDetails_common:null,loadingdata_common:false,postData:'',likeuserlist:[],followersListing:{},followinguserid:[],inputText:'',showPicker:false,reply_id:'',//loadingdata:false,
singlelikeCountChild:0,loader:false,reply_thread_id:'',followinglikeuserid:[],followerslikeListing:{},singlelikeCount:0,singleget_allusers_popup:[],isChallenge:"0"},_defineProperty(_this$state2,'showPicker',false),_defineProperty(_this$state2,'singlementioned_popup',''),_defineProperty(_this$state2,'reply_id',''),_defineProperty(_this$state2,'commentCount',0),_defineProperty(_this$state2,'singleget_allusers',[]),_defineProperty(_this$state2,'previousUrl',''),_defineProperty(_this$state2,'isNotificationOpen',false),_defineProperty(_this$state2,'post_Notification_Id',''),_defineProperty(_this$state2,'post_Notification_Msg',''),_defineProperty(_this$state2,'post_Notification_Comment',''),_this$state2);_this.getUserProfileImage();_this.handleGetLikePost=_this.handleGetLikePost.bind(_this);_this.handlePhotoUnLike=_this.handlePhotoUnLike.bind(_this);_this.handlePhotoActivityLike=_this.handlePhotoActivityLike.bind(_this);_this.handleGetActivityLikePost=_this.handleGetActivityLikePost.bind(_this);_this.handlePhotoActivityUnLike=_this.handlePhotoActivityUnLike.bind(_this);// this.handleGetLikeUser = this.handleGetLikeUser.bind(this);
_this.deletePostId=_this.deletePostId.bind(_this);_this.singlePostLikeModal=_this.singlePostLikeModal.bind(_this);_this.singlePostLikeModalClose=_this.singlePostLikeModalClose.bind(_this);_this.handleFollowMyProfile=_this.handleFollowMyProfile.bind(_this);_this.handleUnFollowMyProfile=_this.handleUnFollowMyProfile.bind(_this);_this.handleFollowMyProfileLike=_this.handleFollowMyProfileLike.bind(_this);_this.handleUnFollowMyProfileLike=_this.handleUnFollowMyProfileLike.bind(_this);_this.updateInputPopup=_this.updateInputPopup.bind(_this);_this.handleCommentPostPopup=_this.handleCommentPostPopup.bind(_this);_this.handleCommentPostUpdate=_this.handleCommentPostUpdate.bind(_this);return _this;}_createClass(CommonPopup,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(!prevProps.isOpen&&this.props.isOpen){/*this.props.fetchData().then(response => {
        this.setState({ data: response });
      });*///this.setState({ data: this.props.postcommonid});
//$('#large_challenge_image_btn_common').trigger('click');
this.openPopupCommon();}}},{key:'componentDidMount',value:function componentDidMount(){// Save the current URL
this.setState({previousUrl:window.location.pathname});}},{key:'deletePostId',value:function deletePostId(post_id){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#delete_post_id').val(post_id);}},{key:'handleSinglePostPopupEnter',value:function handleSinglePostPopupEnter(event){if(event.key==="Enter"){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.post_button_comment#handleCommentPost_popup').click();}}},{key:'singlegetUsersLike',value:function singlegetUsersLike(post_id){var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){//following
var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');query.include("user");query.include("image");query.include("toUser");query.include("thumbnail");query.equalTo("type","follow");query.equalTo("fromUser",currentUser);var self=this;query.find().then(function(result){if(result){var resultcount=result.length;var followingdataresult1=[];if(resultcount>0){var userdataresult1=[];for(var i=0;i<resultcount;i++){var user=result[i];var userimage='';if(user.get("toUser").get("profilePictureSmall")&&user.get("toUser").get("profilePictureSmall").url()!==undefined){userimage=user.get("toUser").get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}//console.log(user.get("fromUser").id);
//console.log(user.get("toUser").id);
userdataresult1.push({'id':user.get("toUser").id,'displayName':user.get("toUser").get("displayName"),'displayUsername':user.get("toUser").get("displayUsername"),'image':userimage,'fromUser':user.get("fromUser").id});followingdataresult1.push({'id':user.get("toUser").id,'name':user.get("toUser").id});self.setState({followinguserid:followingdataresult1});}}else{self.setState({followinguserid:[]});}}});//followers 
var followersquery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');followersquery.include("user");followersquery.include("fromUser");followersquery.include("image");followersquery.include("thumbnail");followersquery.doesNotExist("activity");followersquery.equalTo('photo',"Photo$"+post_id);//followersquery.equalTo("fromUser", currentUser);
var self=this;followersquery.find().then(function(followerresult){if(followerresult){var resultcount=followerresult.length;if(followerresult.length>0){var userdataresult=[];//self.setState({followersListing:'followerresult'});
for(var i=0;i<resultcount;i++){var Images=null;var user=followerresult[i];if(user.get("fromUser").get("profilePictureSmall")&&user.get("fromUser").get("profilePictureSmall").url()!==undefined){Images=user.get("fromUser").get("profilePictureSmall").url();}userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});//self.setState({followersListing:resultcount});
}self.setState({followersListing:userdataresult});}}});}else{var followersquery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');followersquery.include("user");followersquery.include("fromUser");followersquery.include("image");followersquery.include("thumbnail");followersquery.doesNotExist("activity");followersquery.equalTo('photo',"Photo$"+post_id);//followersquery.equalTo("fromUser", currentUser);
var self=this;followersquery.find().then(function(followerresult){if(followerresult){var resultcount=followerresult.length;if(resultcount>0){var userdataresult=[];//self.setState({followersListing:'followerresult'});
for(var i=0;i<resultcount;i++){var Images=null;var user=followerresult[i];if(user.get("fromUser").get("profilePictureSmall")&&user.get("fromUser").get("profilePictureSmall").url()!==undefined){Images=user.get("fromUser").get("profilePictureSmall").url();}userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});//self.setState({followersListing:resultcount});
}self.setState({followersListing:userdataresult});}}});}}},{key:'singlePostLikeModal',value:function singlePostLikeModal(){var self=this;var post_id=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#popup_post_id_common').val();console.log(post_id+'post_id');this.singlegetUsersLike(post_id);__WEBPACK_IMPORTED_MODULE_3_jquery___default()("body").addClass("sngl_mdlpstlk_open");}},{key:'checkDeletePost',value:function checkDeletePost(){var delete_post_id=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#delete_post_id').val();var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Photo');query.equalTo('objectId',delete_post_id);console.log(delete_post_id);var queryString=window.location.href;var self=this;query.find().then(function(photo){if(photo){var photo_ob=photo[0];var checklikequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');checklikequery.equalTo('photo',"Photo$"+delete_post_id);checklikequery.find().then(function(object){if(object){var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=object[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var objects=_step2.value;objects.destroy();}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});var checkActivityquery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');checkActivityquery.equalTo('photo',"Photo$"+delete_post_id);checkActivityquery.find().then(function(object){if(object){var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=object[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var objects=_step3.value;objects.destroy();}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});var checkSavequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Save');checkSavequery.equalTo('photo',"Photo$"+delete_post_id);checkSavequery.find().then(function(object){if(object){var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=object[Symbol.iterator](),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){var objects=_step4.value;objects.destroy();}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});if(photo_ob){photo_ob.destroy();}setTimeout(function(){//window.location.href = "/";
window.location.href=queryString;},1000);}});}}},{key:'getUserProfileImage',value:function getUserProfileImage(){var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var profile_picture=currentUser.get("profilePictureSmall");if(profile_picture){this.state.currentuserImage=profile_picture.url();}this.state.currentUserId=currentUser.id;}}},{key:'formatRenderComments2main',value:function formatRenderComments2main(origComment){var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,buffer);}var stringSplit=origComment.split(" ");var maxLength=320;for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);if(comp.indexOf("#")!==-1){//buffer.push(<a href="/appstore">{comp} </a>);
//var userdisplayname = comp.replace('#','');
var linkdata='<a>'+comp+'</a>';buffer.push(linkdata);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){buffer.push('<a href='+comp+'>'+comp+'</a>');}else if(comp.indexOf("@")!==-1||comp.indexOf("@")!==-1){/* var userdisplayname = comp.replace(/\s/g, "").replace('@','');
              let linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';
                  buffer.push(linkdata);  */var regex=/@(\w+)/g;var linkedText=comp.replace(regex,'<a href="/user/$1">@$1</a>');buffer.push(linkedText);}else{buffer.push(comp);}}var content=buffer.join(' ');return{'a':__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'cmt-txt'},content)};//return <img src={"https:aaaa"} />
}// updateInputPopup(event){
},{key:'singlegetAllUsersPopup',value:function singlegetAllUsersPopup(){var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('_User');query.limit(999999999);query.include("profilePictureSmall");query.include("displayUsername");query.exists("displayUsername");query.include("name");var self=this;query.find().then(function(result){var userdataresult1=[];if(result){for(var i=0;i<result.length;i++){var user=result[i];var userimage='';if(user.get("profilePictureSmall")&&user.get("profilePictureSmall").url()!==undefined){userimage=user.get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}//userdataresult1.push({'id':user.id,'display':user.get("displayName"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
//self.state.singleget_allusers.push({'id':user.id,'display':user.get("displayName"),'username':user.get("username"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
userdataresult1.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});self.state.singleget_allusers_popup.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});}this.state.singleget_allusers_popup=userdataresult1;}else{// console.log("No users found");
}},function(error){});}},{key:'singlegetAllUsers',value:function singlegetAllUsers(){var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('_User');query.limit(999999999);query.include("profilePictureSmall");query.include("displayUsername");query.include("name");var self=this;query.find().then(function(result){var userdataresult1=[];if(result){for(var i=0;i<result.length;i++){var user=result[i];var userimage='';if(user.get("profilePictureSmall")&&user.get("profilePictureSmall").url()!==undefined){userimage=user.get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}//userdataresult1.push({'id':user.id,'display':user.get("displayName"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
//self.state.singleget_allusers.push({'id':user.id,'display':user.get("displayName"),'username':user.get("username"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
userdataresult1.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});self.state.singleget_allusers.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});}this.state.singleget_allusers=userdataresult1;}else{// console.log("No users found");
}},function(error){});}},{key:'toggleExpand',/*singlePostModalClose1Common() {
      console.log('singlePostModalClose1Common');
        this.setState({isPopupOpenCommon: false,
            postDetails_common: null,
            postDetailscomment_common: null});
        $("body").removeClass("sngl_mdl_open");
        $("body").removeClass("modal-open1");
        $("body").removeClass("modal-open");
        $('#popup_post_id_common').val('');
        this.setState({loading_common: false});  
      } */value:function toggleExpand(commentId){this.setState(function(prevState){return{isExpanded:!prevState.isExpanded};});this.setState(function(prevStates){return{expandedCommentId:commentId};});}},{key:'formatRenderComment',value:function formatRenderComment(origComment,comnt_id,comment_id){var _this3=this;var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,buffer);}var stringSplit=origComment.split(" ");var maxLength=250;for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);var self=this;if(firstChar=="#"){//buffer.push(<a href="/appstore">{comp} </a>);
buffer.push(comp);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){//link
// buffer.push(<a href={comp}>{comp} </a>);
buffer.push(comp);}else if(comp.indexOf("@")!==-1||comp.indexOf("@")!==-1){/*var userdisplayname = comp.replace('@','');
               var query = new Parse.Query('_User');
               query.include("displayUsername");
               query.include("username");
               query.equalTo("displayUsername", userdisplayname);
               query.first().then(function(result){
                if(result){
                    let userdata=result;
                    let linkdatas='/user/'+userdata.get('displayUsername');
                    self.setState({linkdata:linkdatas}); 
                }
                })
                let linkdata='<a href ='+this.state.linkdata+'>'+comp+'</a>';
                  buffer.push(linkdata);  */var userdisplayname=comp.replace('@','');var linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';buffer.push(linkdata);}else{// buffer.push(<span>{comp} </span>);  
//buffer.push(comp+' ');  
buffer.push(comp);}}var content=buffer.join(' ');/* return ( <span className='cmt-txt'>
                {buffer}
                </span>
        );*/var _props=this.props,_props$showMoreText=_props.showMoreText,showMoreText=_props$showMoreText===undefined?'more':_props$showMoreText,_props$showLessText=_props.showLessText,showLessText=_props$showLessText===undefined?'less':_props$showLessText;var isExpanded=this.state.isExpanded;var expandedCommentId=this.state.expandedCommentId;// Determine whether to truncate the text
var shouldTruncate=content.length>maxLength&&!isExpanded;// Truncate the text if necessary  //expandedCommentId===comment_id
var displayText=shouldTruncate?content.slice(0,maxLength)+'...':content;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'cmt-txt',id:comment_id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:displayText}}),shouldTruncate&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{onClick:function onClick(){return _this3.toggleExpand(comment_id);},style:{color:'#868589',cursor:'pointer',border:'none',background:'none'}},isExpanded?showLessText:showMoreText));}},{key:'faqOpenClose',value:function faqOpenClose(commentId){var commentIds=commentId.split('comnt_');var commenUpdatedId=commentIds[1];var self=this;var check=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".view_replies_comment .faq-drawer #faq-drawer-"+commenUpdatedId).is(":checked");if(check){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".view_replies_comment .faq-drawer label.faq-drawer__title span#faq-"+commenUpdatedId).html('Hide Replies');__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.view_replies_comment .faq-drawer .faq-drawer__content-wrapper#fq-'+commenUpdatedId).addClass('active');}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".view_replies_comment .faq-drawer label.faq-drawer__title span#faq-"+commenUpdatedId).html('View Replies');if(__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.view_replies_comment .faq-drawer .faq-drawer__content-wrapper#fq-'+commenUpdatedId).hasClass("active")){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.view_replies_comment .faq-drawer .faq-drawer__content-wrapper#fq-'+commenUpdatedId).removeClass('active');}}}},{key:'singlePostLikeModalClose',value:function singlePostLikeModalClose(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()("body").addClass("modal-open1");__WEBPACK_IMPORTED_MODULE_3_jquery___default()("body").removeClass("sngl_mdlpstlk_open");// console.log("Test");
}},{key:'singlePostLikeModalLikes',value:function singlePostLikeModalLikes(main_activity_id){var post_id=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#popup_post_id_common').val();this.singlegetUsersCommentLike(post_id,main_activity_id);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#large_challenge_like_list_likes').trigger('click');},500);__WEBPACK_IMPORTED_MODULE_3_jquery___default()("body").addClass("sngl_mdlpstlk_open");}},{key:'singlegetUsersCommentLike',value:function singlegetUsersCommentLike(post_id,main_activity_id){var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){//following
var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');query.include("user");query.include("image");query.include("toUser");query.include("thumbnail");query.equalTo("type","follow");query.equalTo("fromUser",currentUser);var self=this;query.find().then(function(result){if(result){var resultcount=result.length;var followingdataresult1=[];if(resultcount>0){var userdataresult1=[];for(var i=0;i<resultcount;i++){var user=result[i];var userimage='';if(user.get("toUser").get("profilePictureSmall")&&user.get("toUser").get("profilePictureSmall").url()!==undefined){userimage=user.get("toUser").get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}//console.log(user.get("fromUser").id);
//console.log(user.get("toUser").id);
userdataresult1.push({'id':user.get("toUser").id,'displayName':user.get("toUser").get("displayName"),'displayUsername':user.get("toUser").get("displayUsername"),'image':userimage,'fromUser':user.get("fromUser").id});followingdataresult1.push({'id':user.get("toUser").id,'name':user.get("toUser").id});self.setState({followinglikeuserid:followingdataresult1});}}else{self.setState({followinglikeuserid:[]});}}});//followers 
var followersquery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');followersquery.include("user");followersquery.include("fromUser");followersquery.include("image");followersquery.include("thumbnail");followersquery.doesNotExist("activity");followersquery.equalTo('activity',"Activity$"+main_activity_id);followersquery.equalTo('photo',"Photo$"+post_id);//followersquery.equalTo("fromUser", currentUser);
var self=this;followersquery.find().then(function(followerresult){if(followerresult){var resultcount=followerresult.length;if(followerresult.length>0){var userdataresult=[];//self.setState({followersListing:'followerresult'});
for(var i=0;i<resultcount;i++){var Images=null;var user=followerresult[i];if(user.get("fromUser").get("profilePictureSmall")&&user.get("fromUser").get("profilePictureSmall").url()!==undefined){Images=user.get("fromUser").get("profilePictureSmall").url();}userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});//self.setState({followersListing:resultcount});
}self.setState({followerslikeListing:userdataresult});}}});}else{var followersquery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');followersquery.include("user");followersquery.include("fromUser");followersquery.include("image");followersquery.include("thumbnail");followersquery.doesNotExist("activity");followersquery.equalTo('activity',"Activity$"+main_activity_id);followersquery.equalTo('photo',"Photo$"+post_id);//followersquery.equalTo("fromUser", currentUser);
var self=this;followersquery.find().then(function(followerresult){if(followerresult){var resultcount=followerresult.length;if(resultcount>0){var userdataresult=[];//self.setState({followersListing:'followerresult'});
for(var i=0;i<resultcount;i++){var Images=null;var user=followerresult[i];if(user.get("fromUser").get("profilePictureSmall")&&user.get("fromUser").get("profilePictureSmall").url()!==undefined){Images=user.get("fromUser").get("profilePictureSmall").url();}userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});//self.setState({followersListing:resultcount});
}self.setState({followerslikeListing:userdataresult});}}});}}},{key:'deleteCommentIdOverlay',value:function deleteCommentIdOverlay(commentId){var commentIds=commentId.split('comnt_');var commenUpdatedId=commentIds[1];__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#delete_comment_id').val(commenUpdatedId);this.checkDeleteComment();}},{key:'checkDeleteComment',value:function checkDeleteComment(){var _this4=this;var delete_comment_id=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#delete_comment_id').val();var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var photo_post_id=this.state.post_common_id;var self=this;if(currentUser){/*child*/var query_activityChild=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');query_activityChild.equalTo('activity',"Activity$"+delete_comment_id);query_activityChild.equalTo('fromUser',currentUser);query_activityChild.find().then(function(object){if(object){var _iteratorNormalCompletion5=true;var _didIteratorError5=false;var _iteratorError5=undefined;try{for(var _iterator5=object[Symbol.iterator](),_step5;!(_iteratorNormalCompletion5=(_step5=_iterator5.next()).done);_iteratorNormalCompletion5=true){var objects=_step5.value;objects.destroy();var checklikequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');checklikequery.equalTo('photo',"Photo$"+photo_post_id);//checklikequery.equalTo('fromUser', currentUser);
checklikequery.equalTo('activity',"Activity$"+objects.id);checklikequery.find().then(function(object){if(object){var _iteratorNormalCompletion6=true;var _didIteratorError6=false;var _iteratorError6=undefined;try{for(var _iterator6=object[Symbol.iterator](),_step6;!(_iteratorNormalCompletion6=(_step6=_iterator6.next()).done);_iteratorNormalCompletion6=true){var _objects=_step6.value;_objects.destroy();}}catch(err){_didIteratorError6=true;_iteratorError6=err;}finally{try{if(!_iteratorNormalCompletion6&&_iterator6.return){_iterator6.return();}}finally{if(_didIteratorError6){throw _iteratorError6;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});}//return object.destroy();
}catch(err){_didIteratorError5=true;_iteratorError5=err;}finally{try{if(!_iteratorNormalCompletion5&&_iterator5.return){_iterator5.return();}}finally{if(_didIteratorError5){throw _iteratorError5;}}}}}).then(function(deletedObject){/*setTimeout(() => {
              var self = this;
              self.handleCommentPostUpdate();
            },500);*/}).catch(function(error){console.error('Error deleting record:',error);});/*child*//*like*/var checklikequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');checklikequery.equalTo('photo',"Photo$"+photo_post_id);//checklikequery.equalTo('fromUser', currentUser);
checklikequery.equalTo('activity',"Activity$"+delete_comment_id);checklikequery.find().then(function(object){if(object){var _iteratorNormalCompletion7=true;var _didIteratorError7=false;var _iteratorError7=undefined;try{for(var _iterator7=object[Symbol.iterator](),_step7;!(_iteratorNormalCompletion7=(_step7=_iterator7.next()).done);_iteratorNormalCompletion7=true){var objects=_step7.value;objects.destroy();}}catch(err){_didIteratorError7=true;_iteratorError7=err;}finally{try{if(!_iteratorNormalCompletion7&&_iterator7.return){_iterator7.return();}}finally{if(_didIteratorError7){throw _iteratorError7;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});/*like*/var query_activity=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');query_activity.equalTo('objectId',delete_comment_id);//query_activity.equalTo('fromUser', currentUser);
query_activity.first().then(function(object){if(object){//var photo_obj_id= object.get('photo').id;         
/*photo*//*var query = new Parse.Query('Photo');  
              query.equalTo('objectId', photo_obj_id);
              query.find().then(function(photo){
              if(photo)
              {
                  let photo_ob=photo[0];
                  var photoid= photo_ob.id;
                  var commentcount= photo_ob.get('commentcount');
                  if(commentcount==undefined || commentcount===1 || commentcount < 0)
                  {
                      commentcount=0;
                  }else
                  {
                      commentcount=commentcount-1;
                  } 
                    photo_ob.set("commentcount", commentcount.toString()); 
                    photo_ob.save();
                  }
              });*//*photo*/return object.destroy();}}).then(function(deletedObject){/* var getActivityquery = new Parse.Query('Activity');  
          getActivityquery.equalTo('objectId', delete_comment_id);
          var self = this;
          getActivityquery.find().then(function(activitydata){
          if(activitydata)
          {
              let activity_ob=activitydata[0];
              console.log(activity_ob.length);
            }
          })*/var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');var reply_id=_this4.state.reply_id;query.equalTo('photo',"Photo$"+photo_post_id);query.equalTo("type","comment");//query.doesNotExist("activity");
query.include("fromUser");query.include("photo");query.include("image");query.include("content");query.include("_created_at");query.include("createdAt");query.descending("_created_at");var self=_this4;query.find().then(function(result){if(result){var totalcomment=result.length;//console.log(totalcomment+'totalcomment')
var getPhotoquery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Photo');var self=this;getPhotoquery.equalTo('objectId',photo_post_id);getPhotoquery.find().then(function(photo){if(photo){var photo_ob=photo[0];var commentcount=totalcomment?totalcomment:0;photo_ob.set("commentcount",commentcount.toString());photo_ob.save();self.setState({commentCount:commentcount.toString()});// setTimeout(() => {
//var self = this;
// this.handleCommentPostUpdate();
//},1000);
}});}});setTimeout(function(){var self=_this4;self.handleCommentPostUpdate();},2000);}).catch(function(error){console.error('Error deleting record:',error);});}}},{key:'getCommentProfilePicCommon',value:function getCommentProfilePicCommon(comment){var user=comment.get("fromUser");if(user&&user!=undefined){var pic=user.get("profilePictureSmall");if(pic&&pic!=undefined)return pic.url();}return"/images/default_userpic0.png";}},{key:'render',value:function render(){var _props2=this.props,isOpen=_props2.isOpen,onClose=_props2.onClose;//const { data } = this.state;
var _state=this.state,isPopupOpenCommon=_state.isPopupOpenCommon,loading_common=_state.loading_common,error_common=_state.error_common,post_common_id=_state.post_common_id,postDetails_common=_state.postDetails_common,postData=_state.postData;if(!isOpen)return null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'popup-overlay'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'popup-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{id:'closepopup_common',style:{display:"none"},onClick:onClose},'Close'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:;',style:{display:"none"},'data-toggle':'modal','data-target':'#large_challenge_image_common',id:'large_challenge_image_common_btn',type:'button'},'modal'),isPopupOpenCommon&&loading_common?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null):error_common?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null):isPopupOpenCommon&&postDetails_common&&this.renderDetailPageCommon(post_common_id)));}}]);return CommonPopup;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CommonPopup);

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var saveNotification=function(_React$Component){_inherits(saveNotification,_React$Component);function saveNotification(props){_classCallCheck(this,saveNotification);var _this=_possibleConstructorReturn(this,(saveNotification.__proto__||Object.getPrototypeOf(saveNotification)).call(this,props));var currentUser=__WEBPACK_IMPORTED_MODULE_0_parse___default.a.User.current();var postNotificationid=props.postNotificationid;var postPhotoid=props.postPhotoid;var postMsg=props.postMsg;var communityComment='';var comment='';var postActivityComment=props.postActivityComment;var self=_this;if(currentUser){if(postMsg==='started following you.'){var _currentUser=__WEBPACK_IMPORTED_MODULE_0_parse___default.a.User.current();var Notification=__WEBPACK_IMPORTED_MODULE_0_parse___default.a.Object.extend("Notification");var notification=new Notification();communityComment=_currentUser.get("displayUsername")+"'s started following "+postNotificationid.get("displayUsername");comment="started following you.";var mobile_notification_text=_currentUser.get("displayUsername")+" started following you. ";var mobile_notification_user=_currentUser.get("displayUsername")?_currentUser.get("displayUsername"):_currentUser.get("displayName");var mobile_notification_user_token=postNotificationid.get("FCMDeviceToken")?postNotificationid.get("FCMDeviceToken"):'';notification.set('notifiedUser',postNotificationid);var currentUser_id=_currentUser.id;notification.set('viewed',0);var fromUserThumb=_currentUser.get('profilePictureSmall');// const thumbnail = photo_ob.get('thumbnail');
/*if(thumbnail!=undefined)
                             { 
                                  notification.set('thumbnail', '');
                             }*/notification.set('commentingUser',_currentUser);if(fromUserThumb!=undefined){notification.set('profilePictureSmall',fromUserThumb);}//notification.set('photo', '');
notification.set("_wperm",{"*":{"read":true,"write":true}});notification.set("_rperm",{"*":{"read":true,"write":true}});notification.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_0_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);acl.setWriteAccess(_currentUser,true);acl.setReadAccess(_currentUser,true);notification.setACL(acl);notification.set('communityComment',communityComment);notification.set('comment',comment);notification.set('index',0);notification.set('webviewed',1);notification.save().then(function(likeSaved){console.log('notification saved');console.log(likeSaved);});var settings={"url":"https://joelpush.5edev.com/api/send-push-notification","method":"POST","timeout":0,"headers":{"Content-Type":"application/json"},"data":JSON.stringify({"notification":{"badge":1,"body":mobile_notification_text,"sound":"default","title":'Joel’s Kitchen'},"priority":"high","device_token":mobile_notification_user_token})};if(mobile_notification_user_token!==''){__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax(settings).done(function(response){console.log(response);});}//send notification
}else{var query=new __WEBPACK_IMPORTED_MODULE_0_parse___default.a.Query('Photo');query.equalTo('objectId',postPhotoid);query.include("user");query.find().then(function(photo){var _this2=this;if(photo){var photoid;var photouser;var Notification;var notification;var userquery;var self;var userquery;var self;var acl;var settings;(function(){var photo_ob=photo[0];photoid=photo_ob.id;photouser=photo_ob.get('user').id;Notification=__WEBPACK_IMPORTED_MODULE_0_parse___default.a.Object.extend("Notification");notification=new Notification();if(postMsg==='mentioned you in a post'){var commentcaptiondata=photo_ob.get('caption');var usernameRegex=/@(\w+)/g;var usernamesmatchupdated=[].concat(_toConsumableArray(commentcaptiondata.matchAll(usernameRegex))).map(function(match){return match[0];});if(usernamesmatchupdated){var _loop=function _loop(matchusername){var NotificationN=__WEBPACK_IMPORTED_MODULE_0_parse___default.a.Object.extend("Notification");var notificationNew=new NotificationN();communityComment=photo_ob.get('user').get("displayUsername")+"'s mentioned you in a post";comment="mentioned you in a post";var mobile_notification_text=photo_ob.get('user').get("displayUsername")+" mentioned you in a post";var mobile_notification_user=photo_ob.get('user').get("displayUsername")?photo_ob.get('user').get("displayUsername"):photo_ob.get('user').get("displayName");//notificationNew.set('activity', postActivityComment);
var newusername=matchusername.replace('@','');userquery=new __WEBPACK_IMPORTED_MODULE_0_parse___default.a.Query('User');userquery.equalTo("displayUsername",newusername);self=_this2;userquery.first().then(function(result){if(result){notificationNew.set('notifiedUser',result);var _mobile_notification_user_token=result.get("FCMDeviceToken")?result.get("FCMDeviceToken"):'';var _currentUser2=__WEBPACK_IMPORTED_MODULE_0_parse___default.a.User.current();var _currentUser_id=_currentUser2.id;notificationNew.set('viewed',0);var _fromUserThumb=_currentUser2.get('profilePictureSmall');var thumbnail=photo_ob.get('thumbnail');if(thumbnail!=undefined){notificationNew.set('thumbnail',thumbnail);}notificationNew.set('commentingUser',_currentUser2);if(_fromUserThumb!=undefined){notificationNew.set('profilePictureSmall',_fromUserThumb);}notificationNew.set('photo',photo_ob);notificationNew.set("_wperm",{"*":{"read":true,"write":true}});notificationNew.set("_rperm",{"*":{"read":true,"write":true}});notificationNew.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_0_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);acl.setWriteAccess(_currentUser2,true);acl.setReadAccess(_currentUser2,true);notificationNew.setACL(acl);notificationNew.set('communityComment',communityComment);notificationNew.set('comment',comment);notificationNew.set('index',0);notificationNew.set('webviewed',1);notificationNew.save().then(function(likeSaved){console.log('notification saved');console.log(likeSaved);});//send notification
var settings={"url":"https://joelpush.5edev.com/api/send-push-notification","method":"POST","timeout":0,"headers":{"Content-Type":"application/json"},"data":JSON.stringify({"notification":{"badge":1,"body":mobile_notification_text,"sound":"default","title":'Joel’s Kitchen'},"priority":"high","device_token":_mobile_notification_user_token})};if(_mobile_notification_user_token!==''){__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax(settings).done(function(response){console.log(response);});}//send notification
}});};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=usernamesmatchupdated[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var matchusername=_step.value;_loop(matchusername);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}//code
/* communityComment=photo_ob.get('user').get("displayUsername")+"'s tagged you in a post";
                                comment="tagged you in a post";  
                                let captiondata=photo_ob.get('caption');
                                let captionusernameupdated='';
                                let captionusername='';
                                captionusername = captiondata.match(/@\w+/);
                                 if (captionusername) {
                                  captionusernameupdated=captionusername[0].substr(1);
                                } 
                              
                                var userquery = new Parse.Query('User');       
                                userquery.equalTo("displayUsername", captionusernameupdated);
                                var self = this;
                                userquery.first().then(function(result){
                                    if(result){ 
                                        console.log(result);
                                         notification.set('notifiedUser', result);

                                               let currentUser = Parse.User.current(); 
                                                let currentUser_id=currentUser.id; 
                                                notification.set('viewed', 0);
                                                const fromUserThumb = currentUser.get('profilePictureSmall');
                                                const thumbnail = photo_ob.get('thumbnail');
                                                if(thumbnail!=undefined)
                                                 { 
                                                      notification.set('thumbnail', thumbnail);
                                                 }
                                                 
                                                
                                                notification.set('commentingUser', currentUser);
                                                if(fromUserThumb!=undefined)
                                                 { 
                                                      notification.set('profilePictureSmall', fromUserThumb);
                                                 }
                                                notification.set('photo', photo_ob);
                                                notification.set("_wperm", {
                                                  "*": {
                                                    "read": true,
                                                    "write": true 
                                                  }
                                                });
                                                 notification.set("_rperm", {
                                                  "*": {
                                                   "read": true,
                                                    "write": true 
                                                  }
                                                });
                                                 notification.set("_acl", {
                                                  "*": {
                                                    "read": true,
                                                    "write": true 
                                                  }
                                                });
                                                var acl = new Parse.ACL();
                                                acl.setPublicReadAccess(true);
                                                acl.setPublicWriteAccess(true);
                                                acl.setWriteAccess(currentUser, true); 
                                                acl.setReadAccess(currentUser, true); 
                                                notification.setACL(acl);
                                                notification.set('communityComment', communityComment);
                                                notification.set('comment', comment);
                                                notification.set('index', 0);            

                                                notification.save().then((likeSaved) => {
                                                     console.log('notification saved');
                                                     console.log(likeSaved);
                                                })
                                    }
                                    })    */}/*else if(postMsg==='created a challenge')
                            {
                             console.log('msg created a challenge')   ;
                             
                           var userquery = new Parse.Query('User');    
                            userquery.limit(999999999);  
                            userquery.notEqualTo("displayUsername", currentUser.get("displayUsername"));                            
                            userquery.find().then(function(result){
                          
                        
                          if(result)
                            {
                            for (const matchusername of result) 
                                 {
                                   let NotificationN = Parse.Object.extend("Notification");
                                   let notificationNew = new NotificationN();
                                    communityComment=photo_ob.get('user').get("displayUsername")+"'s created a challenge";
                                    comment="created a challenge";                                
                                    let newusername=matchusername.get("displayUsername");
                                    notificationNew.set('notifiedUser', matchusername);

                                               let currentUser = Parse.User.current(); 
                                                let currentUser_id=currentUser.id; 
                                                notificationNew.set('viewed', 0);
                                                const fromUserThumb = matchusername.get('profilePictureSmall');

                                                const thumbnail = photo_ob.get('thumbnail');
                                                if(thumbnail!=undefined)
                                                 { 
                                                      notificationNew.set('thumbnail', thumbnail);
                                                 }
                                                 
                                                
                                                notificationNew.set('commentingUser', currentUser);
                                                if(fromUserThumb!=undefined)
                                                 { 
                                                      notificationNew.set('profilePictureSmall', fromUserThumb);
                                                 }
                                                notificationNew.set('photo', photo_ob);
                                                notificationNew.set("_wperm", {
                                                  "*": {
                                                    "read": true,
                                                    "write": true 
                                                  }
                                                });
                                                 notificationNew.set("_rperm", {
                                                  "*": {
                                                   "read": true,
                                                    "write": true 
                                                  }
                                                });
                                                 notificationNew.set("_acl", {
                                                  "*": {
                                                    "read": true,
                                                    "write": true 
                                                  }
                                                });
                                                 notificationNew.set('challenge', 1);     
                                                var acl = new Parse.ACL();
                                                acl.setPublicReadAccess(true);
                                                acl.setPublicWriteAccess(true);
                                                acl.setWriteAccess(currentUser, true); 
                                                acl.setReadAccess(currentUser, true); 
                                                notificationNew.setACL(acl);
                                                notificationNew.set('communityComment', communityComment);
                                                notificationNew.set('comment', comment);
                                                notificationNew.set('index', 0);            
                                                console.log(notificationNew);
                                                setTimeout(() => {
                                                notificationNew.save().then((likeSaved) => {
                                                     console.log('notification saved');
                                                    console.log(likeSaved);
                                                })
                                                  },500);
                                                      
                                        }
                                    }
                                
                            })
                         
                           
                                      
                           

                           } */else if(postMsg==='mentioned you in a comment'){/*let captionusernameupdated='';
                                let captionusername='';
                                captionusername = captiondata.match(/@\w+/);
                                 if (captionusername) {
                                  captionusernameupdated=captionusername[0].substr(1);
                                } 
                                console.log(captiondata+'---captiondata');
                                console.log(captionusernameupdated+'---captionusernameupdated');
                                var userquery = new Parse.Query('User');       
                                userquery.equalTo("displayUsername", captionusernameupdated);
                                var self = this;*//*userquery.first().then(function(result){
                                    if(result){ 
                                        console.log(result);
                                         notification.set('notifiedUser', result);

                                               let currentUser = Parse.User.current(); 
                                                let currentUser_id=currentUser.id; 
                                                notification.set('viewed', 0);
                                                const fromUserThumb = currentUser.get('profilePictureSmall');
                                                const thumbnail = photo_ob.get('thumbnail');
                                                if(thumbnail!=undefined)
                                                 { 
                                                      notification.set('thumbnail', thumbnail);
                                                 }
                                                 
                                                
                                                notification.set('commentingUser', currentUser);
                                                if(fromUserThumb!=undefined)
                                                 { 
                                                      notification.set('profilePictureSmall', fromUserThumb);
                                                 }
                                                notification.set('photo', photo_ob);
                                                notification.set("_wperm", {
                                                  "*": {
                                                    "read": true,
                                                    "write": true 
                                                  }
                                                });
                                                 notification.set("_rperm", {
                                                  "*": {
                                                   "read": true,
                                                    "write": true 
                                                  }
                                                });
                                                 notification.set("_acl", {
                                                  "*": {
                                                    "read": true,
                                                    "write": true 
                                                  }
                                                });
                                                var acl = new Parse.ACL();
                                                acl.setPublicReadAccess(true);
                                                acl.setPublicWriteAccess(true);
                                                acl.setWriteAccess(currentUser, true); 
                                                acl.setReadAccess(currentUser, true); 
                                                notification.setACL(acl);
                                                notification.set('communityComment', communityComment);
                                                notification.set('comment', comment);
                                                notification.set('index', 0);            

                                                notification.save().then((likeSaved) => {
                                                     console.log('notification saved');
                                                     console.log(likeSaved);
                                                })
                                    }
                                    })  *///code
var _commentcaptiondata=postActivityComment.get('content');var _usernameRegex=/@(\w+)/g;var _usernamesmatchupdated=[].concat(_toConsumableArray(_commentcaptiondata.matchAll(_usernameRegex))).map(function(match){return match[0];});if(_usernamesmatchupdated){var _loop2=function _loop2(_matchusername){var NotificationN=__WEBPACK_IMPORTED_MODULE_0_parse___default.a.Object.extend("Notification");var notificationNew=new NotificationN();communityComment=postActivityComment.get('fromUser').get("displayUsername")+"'s mentioned you in a post";comment="mentioned you in a post";var mobile_notification_text=postActivityComment.get('fromUser').get("displayUsername")+" mentioned you in a post";var mobile_notification_user=postActivityComment.get('fromUser').get("displayUsername")?postActivityComment.get('fromUser').get("displayUsername"):postActivityComment.get('fromUser').get("displayName");notificationNew.set('activity',postActivityComment);var newusername=_matchusername.replace('@','');userquery=new __WEBPACK_IMPORTED_MODULE_0_parse___default.a.Query('User');userquery.equalTo("displayUsername",newusername);self=_this2;userquery.first().then(function(result){if(result){notificationNew.set('notifiedUser',result);var _mobile_notification_user_token2=result.get("FCMDeviceToken")?result.get("FCMDeviceToken"):'';var _currentUser3=__WEBPACK_IMPORTED_MODULE_0_parse___default.a.User.current();var _currentUser_id2=_currentUser3.id;notificationNew.set('viewed',0);var _fromUserThumb2=_currentUser3.get('profilePictureSmall');var thumbnail=photo_ob.get('thumbnail');if(thumbnail!=undefined){notificationNew.set('thumbnail',thumbnail);}notificationNew.set('commentingUser',_currentUser3);if(_fromUserThumb2!=undefined){notificationNew.set('profilePictureSmall',_fromUserThumb2);}notificationNew.set('photo',photo_ob);notificationNew.set("_wperm",{"*":{"read":true,"write":true}});notificationNew.set("_rperm",{"*":{"read":true,"write":true}});notificationNew.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_0_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);acl.setWriteAccess(_currentUser3,true);acl.setReadAccess(_currentUser3,true);notificationNew.setACL(acl);notificationNew.set('communityComment',communityComment);notificationNew.set('comment',comment);notificationNew.set('index',0);notificationNew.set('webviewed',1);notificationNew.save().then(function(likeSaved){console.log('notification saved');console.log(likeSaved);});//send notification
var settings={"url":"https://joelpush.5edev.com/api/send-push-notification","method":"POST","timeout":0,"headers":{"Content-Type":"application/json"},"data":JSON.stringify({"notification":{"badge":1,"body":mobile_notification_text,"sound":"default","title":'Joel’s Kitchen'},"priority":"high","device_token":_mobile_notification_user_token2})};if(_mobile_notification_user_token2!==''){__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax(settings).done(function(response){console.log(response);});}//send notification
}});};var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=_usernamesmatchupdated[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var _matchusername=_step2.value;_loop2(_matchusername);}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}//code
}else{var _currentUser4=__WEBPACK_IMPORTED_MODULE_0_parse___default.a.User.current();var _mobile_notification_text='';var _mobile_notification_user='';var _mobile_notification_user_token3='';if(postMsg==='liked photo'){communityComment="liked "+photo_ob.get('user').get("displayUsername")+"'s post.";comment="liked your post.";notification.set('notifiedUser',photo_ob.get('user'));_mobile_notification_text=_currentUser4.get("displayUsername")+' liked your post.';_mobile_notification_user=_currentUser4.get("displayUsername")?_currentUser4.get("displayUsername"):_currentUser4.get("displayName");_mobile_notification_user_token3=photo_ob.get('user').get("FCMDeviceToken")?photo_ob.get('user').get("FCMDeviceToken"):'';}else if(postMsg==='liked comment'){communityComment="liked "+photo_ob.get('user').get("displayUsername")+"'s post.";comment="liked your comment: “"+postActivityComment.get('content')+"”";//"liked your comment";    
notification.set('activity',postActivityComment);notification.set('notifiedUser',postActivityComment.get('fromUser'));_mobile_notification_text=_currentUser4.get("displayUsername")+" liked your comment: “"+postActivityComment.get('content')+"”";_mobile_notification_user=_currentUser4.get("displayUsername")?_currentUser4.get("displayUsername"):_currentUser4.get("displayName");_mobile_notification_user_token3=postActivityComment.get('fromUser').get("FCMDeviceToken")?postActivityComment.get('fromUser').get("FCMDeviceToken"):'';}else if(postMsg==='commented post reply'){communityComment="commented "+photo_ob.get('user').get("displayUsername")+"'s post.";comment=postActivityComment.get('content');//"commented your post";    
notification.set('activity',postActivityComment);notification.set('notifiedUser',photo_ob.get('user'));notification.set('reply',true);_mobile_notification_text=_currentUser4.get("displayUsername")+" replied to a comment on your post: "+" “"+postActivityComment.get('content')+'” ';_mobile_notification_user=_currentUser4.get("displayUsername")?_currentUser4.get("displayUsername"):_currentUser4.get("displayName");_mobile_notification_user_token3=photo_ob.get('user').get("FCMDeviceToken")?photo_ob.get('user').get("FCMDeviceToken"):'';}else if(postMsg==='commented post'){communityComment="commented "+photo_ob.get('user').get("displayUsername")+"'s post.";comment=postActivityComment.get('content');//"commented your post";    
notification.set('activity',postActivityComment);notification.set('notifiedUser',photo_ob.get('user'));notification.set('reply',false);_mobile_notification_text=_currentUser4.get("displayUsername")+" commented on your post: "+" “"+postActivityComment.get('content')+'” ';_mobile_notification_user=_currentUser4.get("displayUsername")?_currentUser4.get("displayUsername"):_currentUser4.get("displayName");_mobile_notification_user_token3=photo_ob.get('user').get("FCMDeviceToken")?photo_ob.get('user').get("FCMDeviceToken"):'';}else if(postMsg==='saved photo'){communityComment="liked "+photo_ob.get('user').get("displayUsername")+"'s post.";comment="saved your post.";notification.set('notifiedUser',photo_ob.get('user'));_mobile_notification_text=_currentUser4.get("displayUsername")+" saved your post.";_mobile_notification_user=_currentUser4.get("displayUsername")?_currentUser4.get("displayUsername"):_currentUser4.get("displayName");_mobile_notification_user_token3=photo_ob.get('user').get("FCMDeviceToken")?photo_ob.get('user').get("FCMDeviceToken"):'';}else if(postMsg==='created a challenge'){communityComment=photo_ob.get('user').get("displayUsername")+"'s challenge became active!";comment="challenge became active!";notification.set('notifiedUser',photo_ob.get('user'));notification.set('challenge',1);notification.set('global',1);_mobile_notification_text=photo_ob.get('user').get("displayUsername")+"'s challenge became active!";_mobile_notification_user=photo_ob.get('user').get("displayUsername")?photo_ob.get('user').get("displayUsername"):photo_ob.get('user').get("displayName");_mobile_notification_user_token3=photo_ob.get('user').get("FCMDeviceToken")?photo_ob.get('user').get("FCMDeviceToken"):'';}else if(postMsg==='Thank you for submitting your challenge. It is currently pending review.'){communityComment="Thank you for submitting your challenge. It is currently pending review. "+photo_ob.get('user').get("displayUsername")+"'s ";comment="Thank you for submitting your challenge. It is currently pending review.";notification.set('notifiedUser',photo_ob.get('user'));notification.set('challenge',1);_mobile_notification_text="Thank you for submitting your challenge. It is currently pending review.";_mobile_notification_user=photo_ob.get('user').get("displayUsername")?photo_ob.get('user').get("displayUsername"):photo_ob.get('user').get("displayName");_mobile_notification_user_token3=photo_ob.get('user').get("FCMDeviceToken")?photo_ob.get('user').get("FCMDeviceToken"):'';}else if(postMsg==='Your challenge is approved'){communityComment="Your challenge is approved!";comment="Your challenge is approved!";notification.set('notifiedUser',photo_ob.get('user'));notification.set('challenge',1);_mobile_notification_text="Your challenge is approved!";_mobile_notification_user=photo_ob.get('user').get("displayUsername")?photo_ob.get('user').get("displayUsername"):photo_ob.get('user').get("displayName");_mobile_notification_user_token3=photo_ob.get('user').get("FCMDeviceToken")?photo_ob.get('user').get("FCMDeviceToken"):'';}else if(postMsg==='posted to your challenge'){communityComment=_currentUser4.get("displayUsername")+"'s posted to your challenge ";comment="posted to your challenge.";notification.set('notifiedUser',photo_ob.get('challenge').get('user'));_mobile_notification_text=_currentUser4.get("displayUsername")+" posted to your challenge ";_mobile_notification_user=_currentUser4.get("displayUsername")?_currentUser4.get("displayUsername"):_currentUser4.get("displayName");_mobile_notification_user_token3=photo_ob.get('challenge').get('user').get("FCMDeviceToken")?photo_ob.get('challenge').get('user').get("FCMDeviceToken"):'';}var _currentUser_id3=_currentUser4.id;notification.set('viewed',0);var _fromUserThumb3=_currentUser4.get('profilePictureSmall');var thumbnail=photo_ob.get('thumbnail');if(thumbnail!=undefined){notification.set('thumbnail',thumbnail);}notification.set('commentingUser',_currentUser4);if(_fromUserThumb3!=undefined){notification.set('profilePictureSmall',_fromUserThumb3);}notification.set('photo',photo_ob);notification.set("_wperm",{"*":{"read":true,"write":true}});notification.set("_rperm",{"*":{"read":true,"write":true}});notification.set("_acl",{"*":{"read":true,"write":true}});acl=new __WEBPACK_IMPORTED_MODULE_0_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);acl.setWriteAccess(_currentUser4,true);acl.setReadAccess(_currentUser4,true);notification.setACL(acl);notification.set('communityComment',communityComment);notification.set('comment',comment);notification.set('index',0);notification.set('webviewed',1);notification.save().then(function(likeSaved){console.log('notification saved');console.log(likeSaved);});//send notification
settings={"url":"https://joelpush.5edev.com/api/send-push-notification","method":"POST","timeout":0,"headers":{"Content-Type":"application/json"},"data":JSON.stringify({"notification":{"badge":1,"body":_mobile_notification_text,"sound":"default","title":'Joel’s Kitchen'},"priority":"high","device_token":_mobile_notification_user_token3})};if(_mobile_notification_user_token3!==''){__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax(settings).done(function(response){console.log(response);});}//send notification
}})();}});}/* const currentUser_id = currentUser.id;        
            var resultLikedid=0;
            var checklikequery = new Parse.Query('Like');  
            checklikequery.equalTo('photo', "Photo$"+post_id);
            checklikequery.equalTo('fromUser', currentUser);  
            checklikequery.doesNotExist("activity");
            checklikequery.find().then(function(resultLike){
                if(resultLike)
                {             
                    let resultLiked=resultLike[0];
                    resultLikedid= resultLiked.id;
                    if(resultLikedid!==undefined)
                    {  
                       $('a.liked .active#like_'+post_id).attr("style", "display: block"); 
                       $('a.liked .default#like_'+post_id).attr("style", "display: none");

                       $('.comment_like_shere a.liked1 .active1#like_'+post_id).attr("style", "display: block"); 
                       $('.comment_like_shere a.liked1 .default1#like_'+post_id).attr("style", "display: none");
                       $('a.liked1#like_'+post_id).attr("style", "pointer-events: auto");
                    }
                    if(resultLikedid===undefined){                     
                       $('a.liked .active#like_'+post_id).attr("style", "display: none"); 
                       $('a.liked .default#like_'+post_id).attr("style", "display: block");

                       $('.comment_like_shere a.liked1 .active1#like_'+post_id).attr("style", "display: none"); 
                       $('.comment_like_shere a.liked1 .default1#like_'+post_id).attr("style", "display: block"); 
                    }                              
                }
            })*/}return _this;}_createClass(saveNotification,[{key:'render',value:function render(){return'';}}]);return saveNotification;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (saveNotification);

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(82);
var defined = __webpack_require__(78);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(216);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(120);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(49);

var _keys2 = _interopRequireDefault(_keys);

exports.default = function (value, disallowObjects, forcePointers, seen) {
  return encode(value, !!disallowObjects, !!forcePointers, seen || []);
};

var _ParseACL = __webpack_require__(41);

var _ParseACL2 = _interopRequireDefault(_ParseACL);

var _ParseFile = __webpack_require__(29);

var _ParseFile2 = _interopRequireDefault(_ParseFile);

var _ParseGeoPoint = __webpack_require__(44);

var _ParseGeoPoint2 = _interopRequireDefault(_ParseGeoPoint);

var _ParsePolygon = __webpack_require__(65);

var _ParsePolygon2 = _interopRequireDefault(_ParsePolygon);

var _ParseObject = __webpack_require__(8);

var _ParseObject2 = _interopRequireDefault(_ParseObject);

var _ParseOp = __webpack_require__(43);

var _ParseRelation = __webpack_require__(30);

var _ParseRelation2 = _interopRequireDefault(_ParseRelation);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var toString = Object.prototype.toString; /**
                                           * Copyright (c) 2015-present, Parse, LLC.
                                           * All rights reserved.
                                           *
                                           * This source code is licensed under the BSD-style license found in the
                                           * LICENSE file in the root directory of this source tree. An additional grant
                                           * of patent rights can be found in the PATENTS file in the same directory.
                                           *
                                           * 
                                           */

function encode(value, disallowObjects, forcePointers, seen) {
  if (value instanceof _ParseObject2.default) {
    if (disallowObjects) {
      throw new Error('Parse Objects not allowed here');
    }
    var seenEntry = value.id ? value.className + ':' + value.id : value;
    if (forcePointers || !seen || seen.indexOf(seenEntry) > -1 || value.dirty() || (0, _keys2.default)(value._getServerData()).length < 1) {
      return value.toPointer();
    }
    seen = seen.concat(seenEntry);
    return value._toFullJSON(seen);
  }
  if (value instanceof _ParseOp.Op || value instanceof _ParseACL2.default || value instanceof _ParseGeoPoint2.default || value instanceof _ParsePolygon2.default || value instanceof _ParseRelation2.default) {
    return value.toJSON();
  }
  if (value instanceof _ParseFile2.default) {
    if (!value.url()) {
      throw new Error('Tried to encode an unsaved file.');
    }
    return value.toJSON();
  }
  if (toString.call(value) === '[object Date]') {
    if (isNaN(value)) {
      throw new Error('Tried to encode an invalid date.');
    }
    return { __type: 'Date', iso: value.toJSON() };
  }
  if (toString.call(value) === '[object RegExp]' && typeof value.source === 'string') {
    return value.source;
  }

  if (Array.isArray(value)) {
    return value.map(function (v) {
      return encode(v, disallowObjects, forcePointers, seen);
    });
  }

  if (value && (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object') {
    var output = {};
    for (var k in value) {
      output[k] = encode(value[k], disallowObjects, forcePointers, seen);
    }
    return output;
  }

  return value;
}

/***/ }),
/* 37 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(167);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');
  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(110);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(59)('meta');
var isObject = __webpack_require__(14);
var has = __webpack_require__(26);
var setDesc = __webpack_require__(18).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(25)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(49);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _ParseRole = __webpack_require__(118);

var _ParseRole2 = _interopRequireDefault(_ParseRole);

var _ParseUser = __webpack_require__(68);

var _ParseUser2 = _interopRequireDefault(_ParseUser);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var PUBLIC_KEY = '*';

/**
 * Creates a new ACL.
 * If no argument is given, the ACL has no permissions for anyone.
 * If the argument is a Parse.User, the ACL will have read and write
 *   permission for only that user.
 * If the argument is any other JSON object, that object will be interpretted
 *   as a serialized ACL created with toJSON().
 * 
 * <p>An ACL, or Access Control List can be added to any
 * <code>Parse.Object</code> to restrict access to only a subset of users
 * of your application.</p>
 * @alias Parse.ACL
 */

var ParseACL = function () {

  /**
   * @param {(Parse.User|Object)} user The user to initialize the ACL for
   */
  function ParseACL(arg1) {
    (0, _classCallCheck3.default)(this, ParseACL);

    this.permissionsById = {};
    if (arg1 && (typeof arg1 === 'undefined' ? 'undefined' : (0, _typeof3.default)(arg1)) === 'object') {
      if (arg1 instanceof _ParseUser2.default) {
        this.setReadAccess(arg1, true);
        this.setWriteAccess(arg1, true);
      } else {
        for (var userId in arg1) {
          var accessList = arg1[userId];
          if (typeof userId !== 'string') {
            throw new TypeError('Tried to create an ACL with an invalid user id.');
          }
          this.permissionsById[userId] = {};
          for (var permission in accessList) {
            var allowed = accessList[permission];
            if (permission !== 'read' && permission !== 'write') {
              throw new TypeError('Tried to create an ACL with an invalid permission type.');
            }
            if (typeof allowed !== 'boolean') {
              throw new TypeError('Tried to create an ACL with an invalid permission value.');
            }
            this.permissionsById[userId][permission] = allowed;
          }
        }
      }
    } else if (typeof arg1 === 'function') {
      throw new TypeError('ParseACL constructed with a function. Did you forget ()?');
    }
  }

  /**
   * Returns a JSON-encoded version of the ACL.
   * @return {Object}
   */

  (0, _createClass3.default)(ParseACL, [{
    key: 'toJSON',
    value: function () {
      var permissions = {};
      for (var p in this.permissionsById) {
        permissions[p] = this.permissionsById[p];
      }
      return permissions;
    }

    /**
     * Returns whether this ACL is equal to another object
     * @param other The other object to compare to
     * @return {Boolean}
     */

  }, {
    key: 'equals',
    value: function (other) {
      if (!(other instanceof ParseACL)) {
        return false;
      }
      var users = (0, _keys2.default)(this.permissionsById);
      var otherUsers = (0, _keys2.default)(other.permissionsById);
      if (users.length !== otherUsers.length) {
        return false;
      }
      for (var u in this.permissionsById) {
        if (!other.permissionsById[u]) {
          return false;
        }
        if (this.permissionsById[u].read !== other.permissionsById[u].read) {
          return false;
        }
        if (this.permissionsById[u].write !== other.permissionsById[u].write) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: '_setAccess',
    value: function (accessType, userId, allowed) {
      if (userId instanceof _ParseUser2.default) {
        userId = userId.id;
      } else if (userId instanceof _ParseRole2.default) {
        var name = userId.getName();
        if (!name) {
          throw new TypeError('Role must have a name');
        }
        userId = 'role:' + name;
      }
      if (typeof userId !== 'string') {
        throw new TypeError('userId must be a string.');
      }
      if (typeof allowed !== 'boolean') {
        throw new TypeError('allowed must be either true or false.');
      }
      var permissions = this.permissionsById[userId];
      if (!permissions) {
        if (!allowed) {
          // The user already doesn't have this permission, so no action is needed
          return;
        } else {
          permissions = {};
          this.permissionsById[userId] = permissions;
        }
      }

      if (allowed) {
        this.permissionsById[userId][accessType] = true;
      } else {
        delete permissions[accessType];
        if ((0, _keys2.default)(permissions).length === 0) {
          delete this.permissionsById[userId];
        }
      }
    }
  }, {
    key: '_getAccess',
    value: function (accessType, userId) {
      if (userId instanceof _ParseUser2.default) {
        userId = userId.id;
        if (!userId) {
          throw new Error('Cannot get access for a ParseUser without an ID');
        }
      } else if (userId instanceof _ParseRole2.default) {
        var name = userId.getName();
        if (!name) {
          throw new TypeError('Role must have a name');
        }
        userId = 'role:' + name;
      }
      var permissions = this.permissionsById[userId];
      if (!permissions) {
        return false;
      }
      return !!permissions[accessType];
    }

    /**
     * Sets whether the given user is allowed to read this object.
     * @param userId An instance of Parse.User or its objectId.
     * @param {Boolean} allowed Whether that user should have read access.
     */

  }, {
    key: 'setReadAccess',
    value: function (userId, allowed) {
      this._setAccess('read', userId, allowed);
    }

    /**
     * Get whether the given user id is *explicitly* allowed to read this object.
     * Even if this returns false, the user may still be able to access it if
     * getPublicReadAccess returns true or a role that the user belongs to has
     * write access.
     * @param userId An instance of Parse.User or its objectId, or a Parse.Role.
     * @return {Boolean}
     */

  }, {
    key: 'getReadAccess',
    value: function (userId) {
      return this._getAccess('read', userId);
    }

    /**
     * Sets whether the given user id is allowed to write this object.
     * @param userId An instance of Parse.User or its objectId, or a Parse.Role..
     * @param {Boolean} allowed Whether that user should have write access.
     */

  }, {
    key: 'setWriteAccess',
    value: function (userId, allowed) {
      this._setAccess('write', userId, allowed);
    }

    /**
     * Gets whether the given user id is *explicitly* allowed to write this object.
     * Even if this returns false, the user may still be able to write it if
     * getPublicWriteAccess returns true or a role that the user belongs to has
     * write access.
     * @param userId An instance of Parse.User or its objectId, or a Parse.Role.
     * @return {Boolean}
     */

  }, {
    key: 'getWriteAccess',
    value: function (userId) {
      return this._getAccess('write', userId);
    }

    /**
     * Sets whether the public is allowed to read this object.
     * @param {Boolean} allowed
     */

  }, {
    key: 'setPublicReadAccess',
    value: function (allowed) {
      this.setReadAccess(PUBLIC_KEY, allowed);
    }

    /**
     * Gets whether the public is allowed to read this object.
     * @return {Boolean}
     */

  }, {
    key: 'getPublicReadAccess',
    value: function () {
      return this.getReadAccess(PUBLIC_KEY);
    }

    /**
     * Sets whether the public is allowed to write this object.
     * @param {Boolean} allowed
     */

  }, {
    key: 'setPublicWriteAccess',
    value: function (allowed) {
      this.setWriteAccess(PUBLIC_KEY, allowed);
    }

    /**
     * Gets whether the public is allowed to write this object.
     * @return {Boolean}
     */

  }, {
    key: 'getPublicWriteAccess',
    value: function () {
      return this.getWriteAccess(PUBLIC_KEY);
    }

    /**
     * Gets whether users belonging to the given role are allowed
     * to read this object. Even if this returns false, the role may
     * still be able to write it if a parent role has read access.
     *
     * @param role The name of the role, or a Parse.Role object.
     * @return {Boolean} true if the role has read access. false otherwise.
     * @throws {TypeError} If role is neither a Parse.Role nor a String.
     */

  }, {
    key: 'getRoleReadAccess',
    value: function (role) {
      if (role instanceof _ParseRole2.default) {
        // Normalize to the String name
        role = role.getName();
      }
      if (typeof role !== 'string') {
        throw new TypeError('role must be a ParseRole or a String');
      }
      return this.getReadAccess('role:' + role);
    }

    /**
     * Gets whether users belonging to the given role are allowed
     * to write this object. Even if this returns false, the role may
     * still be able to write it if a parent role has write access.
     *
     * @param role The name of the role, or a Parse.Role object.
     * @return {Boolean} true if the role has write access. false otherwise.
     * @throws {TypeError} If role is neither a Parse.Role nor a String.
     */

  }, {
    key: 'getRoleWriteAccess',
    value: function (role) {
      if (role instanceof _ParseRole2.default) {
        // Normalize to the String name
        role = role.getName();
      }
      if (typeof role !== 'string') {
        throw new TypeError('role must be a ParseRole or a String');
      }
      return this.getWriteAccess('role:' + role);
    }

    /**
     * Sets whether users belonging to the given role are allowed
     * to read this object.
     *
     * @param role The name of the role, or a Parse.Role object.
     * @param {Boolean} allowed Whether the given role can read this object.
     * @throws {TypeError} If role is neither a Parse.Role nor a String.
     */

  }, {
    key: 'setRoleReadAccess',
    value: function (role, allowed) {
      if (role instanceof _ParseRole2.default) {
        // Normalize to the String name
        role = role.getName();
      }
      if (typeof role !== 'string') {
        throw new TypeError('role must be a ParseRole or a String');
      }
      this.setReadAccess('role:' + role, allowed);
    }

    /**
     * Sets whether users belonging to the given role are allowed
     * to write this object.
     *
     * @param role The name of the role, or a Parse.Role object.
     * @param {Boolean} allowed Whether the given role can write this object.
     * @throws {TypeError} If role is neither a Parse.Role nor a String.
     */

  }, {
    key: 'setRoleWriteAccess',
    value: function (role, allowed) {
      if (role instanceof _ParseRole2.default) {
        // Normalize to the String name
        role = role.getName();
      }
      if (typeof role !== 'string') {
        throw new TypeError('role must be a ParseRole or a String');
      }
      this.setWriteAccess('role:' + role, allowed);
    }
  }]);
  return ParseACL;
}();

exports.default = ParseACL;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(225), __esModule: true };

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RelationOp = exports.RemoveOp = exports.AddUniqueOp = exports.AddOp = exports.IncrementOp = exports.UnsetOp = exports.SetOp = exports.Op = undefined;

var _getPrototypeOf = __webpack_require__(27);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = __webpack_require__(34);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(35);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.opFromJSON = opFromJSON;

var _arrayContainsObject = __webpack_require__(124);

var _arrayContainsObject2 = _interopRequireDefault(_arrayContainsObject);

var _decode = __webpack_require__(45);

var _decode2 = _interopRequireDefault(_decode);

var _encode = __webpack_require__(36);

var _encode2 = _interopRequireDefault(_encode);

var _ParseObject = __webpack_require__(8);

var _ParseObject2 = _interopRequireDefault(_ParseObject);

var _ParseRelation = __webpack_require__(30);

var _ParseRelation2 = _interopRequireDefault(_ParseRelation);

var _unique = __webpack_require__(125);

var _unique2 = _interopRequireDefault(_unique);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function opFromJSON(json) {
  if (!json || !json.__op) {
    return null;
  }
  switch (json.__op) {
    case 'Delete':
      return new UnsetOp();
    case 'Increment':
      return new IncrementOp(json.amount);
    case 'Add':
      return new AddOp((0, _decode2.default)(json.objects));
    case 'AddUnique':
      return new AddUniqueOp((0, _decode2.default)(json.objects));
    case 'Remove':
      return new RemoveOp((0, _decode2.default)(json.objects));
    case 'AddRelation':
      var toAdd = (0, _decode2.default)(json.objects);
      if (!Array.isArray(toAdd)) {
        return new RelationOp([], []);
      }
      return new RelationOp(toAdd, []);
    case 'RemoveRelation':
      var toRemove = (0, _decode2.default)(json.objects);
      if (!Array.isArray(toRemove)) {
        return new RelationOp([], []);
      }
      return new RelationOp([], toRemove);
    case 'Batch':
      var toAdd = [];
      var toRemove = [];
      for (var i = 0; i < json.ops.length; i++) {
        if (json.ops[i].__op === 'AddRelation') {
          toAdd = toAdd.concat((0, _decode2.default)(json.ops[i].objects));
        } else if (json.ops[i].__op === 'RemoveRelation') {
          toRemove = toRemove.concat((0, _decode2.default)(json.ops[i].objects));
        }
      }
      return new RelationOp(toAdd, toRemove);
  }
  return null;
}

var Op = exports.Op = function () {
  function Op() {
    (0, _classCallCheck3.default)(this, Op);
  }

  (0, _createClass3.default)(Op, [{
    key: 'applyTo',

    // Empty parent class
    value: function () {}
  }, {
    key: 'mergeWith',
    value: function () {}
  }, {
    key: 'toJSON',
    value: function () {}
  }]);
  return Op;
}();

var SetOp = exports.SetOp = function (_Op) {
  (0, _inherits3.default)(SetOp, _Op);

  function SetOp(value) {
    (0, _classCallCheck3.default)(this, SetOp);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SetOp.__proto__ || (0, _getPrototypeOf2.default)(SetOp)).call(this));

    _this._value = value;
    return _this;
  }

  (0, _createClass3.default)(SetOp, [{
    key: 'applyTo',
    value: function () {
      return this._value;
    }
  }, {
    key: 'mergeWith',
    value: function () {
      return new SetOp(this._value);
    }
  }, {
    key: 'toJSON',
    value: function () {
      return (0, _encode2.default)(this._value, false, true);
    }
  }]);
  return SetOp;
}(Op);

var UnsetOp = exports.UnsetOp = function (_Op2) {
  (0, _inherits3.default)(UnsetOp, _Op2);

  function UnsetOp() {
    (0, _classCallCheck3.default)(this, UnsetOp);
    return (0, _possibleConstructorReturn3.default)(this, (UnsetOp.__proto__ || (0, _getPrototypeOf2.default)(UnsetOp)).apply(this, arguments));
  }

  (0, _createClass3.default)(UnsetOp, [{
    key: 'applyTo',
    value: function () {
      return undefined;
    }
  }, {
    key: 'mergeWith',
    value: function () {
      return new UnsetOp();
    }
  }, {
    key: 'toJSON',
    value: function () {
      return { __op: 'Delete' };
    }
  }]);
  return UnsetOp;
}(Op);

var IncrementOp = exports.IncrementOp = function (_Op3) {
  (0, _inherits3.default)(IncrementOp, _Op3);

  function IncrementOp(amount) {
    (0, _classCallCheck3.default)(this, IncrementOp);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (IncrementOp.__proto__ || (0, _getPrototypeOf2.default)(IncrementOp)).call(this));

    if (typeof amount !== 'number') {
      throw new TypeError('Increment Op must be initialized with a numeric amount.');
    }
    _this3._amount = amount;
    return _this3;
  }

  (0, _createClass3.default)(IncrementOp, [{
    key: 'applyTo',
    value: function (value) {
      if (typeof value === 'undefined') {
        return this._amount;
      }
      if (typeof value !== 'number') {
        throw new TypeError('Cannot increment a non-numeric value.');
      }
      return this._amount + value;
    }
  }, {
    key: 'mergeWith',
    value: function (previous) {
      if (!previous) {
        return this;
      }
      if (previous instanceof SetOp) {
        return new SetOp(this.applyTo(previous._value));
      }
      if (previous instanceof UnsetOp) {
        return new SetOp(this._amount);
      }
      if (previous instanceof IncrementOp) {
        return new IncrementOp(this.applyTo(previous._amount));
      }
      throw new Error('Cannot merge Increment Op with the previous Op');
    }
  }, {
    key: 'toJSON',
    value: function () {
      return { __op: 'Increment', amount: this._amount };
    }
  }]);
  return IncrementOp;
}(Op);

var AddOp = exports.AddOp = function (_Op4) {
  (0, _inherits3.default)(AddOp, _Op4);

  function AddOp(value) {
    (0, _classCallCheck3.default)(this, AddOp);

    var _this4 = (0, _possibleConstructorReturn3.default)(this, (AddOp.__proto__ || (0, _getPrototypeOf2.default)(AddOp)).call(this));

    _this4._value = Array.isArray(value) ? value : [value];
    return _this4;
  }

  (0, _createClass3.default)(AddOp, [{
    key: 'applyTo',
    value: function (value) {
      if (value == null) {
        return this._value;
      }
      if (Array.isArray(value)) {
        return value.concat(this._value);
      }
      throw new Error('Cannot add elements to a non-array value');
    }
  }, {
    key: 'mergeWith',
    value: function (previous) {
      if (!previous) {
        return this;
      }
      if (previous instanceof SetOp) {
        return new SetOp(this.applyTo(previous._value));
      }
      if (previous instanceof UnsetOp) {
        return new SetOp(this._value);
      }
      if (previous instanceof AddOp) {
        return new AddOp(this.applyTo(previous._value));
      }
      throw new Error('Cannot merge Add Op with the previous Op');
    }
  }, {
    key: 'toJSON',
    value: function () {
      return { __op: 'Add', objects: (0, _encode2.default)(this._value, false, true) };
    }
  }]);
  return AddOp;
}(Op);

var AddUniqueOp = exports.AddUniqueOp = function (_Op5) {
  (0, _inherits3.default)(AddUniqueOp, _Op5);

  function AddUniqueOp(value) {
    (0, _classCallCheck3.default)(this, AddUniqueOp);

    var _this5 = (0, _possibleConstructorReturn3.default)(this, (AddUniqueOp.__proto__ || (0, _getPrototypeOf2.default)(AddUniqueOp)).call(this));

    _this5._value = (0, _unique2.default)(Array.isArray(value) ? value : [value]);
    return _this5;
  }

  (0, _createClass3.default)(AddUniqueOp, [{
    key: 'applyTo',
    value: function (value) {
      if (value == null) {
        return this._value || [];
      }
      if (Array.isArray(value)) {
        // copying value lets Flow guarantee the pointer isn't modified elsewhere
        var valueCopy = value;
        var toAdd = [];
        this._value.forEach(function (v) {
          if (v instanceof _ParseObject2.default) {
            if (!(0, _arrayContainsObject2.default)(valueCopy, v)) {
              toAdd.push(v);
            }
          } else {
            if (valueCopy.indexOf(v) < 0) {
              toAdd.push(v);
            }
          }
        });
        return value.concat(toAdd);
      }
      throw new Error('Cannot add elements to a non-array value');
    }
  }, {
    key: 'mergeWith',
    value: function (previous) {
      if (!previous) {
        return this;
      }
      if (previous instanceof SetOp) {
        return new SetOp(this.applyTo(previous._value));
      }
      if (previous instanceof UnsetOp) {
        return new SetOp(this._value);
      }
      if (previous instanceof AddUniqueOp) {
        return new AddUniqueOp(this.applyTo(previous._value));
      }
      throw new Error('Cannot merge AddUnique Op with the previous Op');
    }
  }, {
    key: 'toJSON',
    value: function () {
      return { __op: 'AddUnique', objects: (0, _encode2.default)(this._value, false, true) };
    }
  }]);
  return AddUniqueOp;
}(Op);

var RemoveOp = exports.RemoveOp = function (_Op6) {
  (0, _inherits3.default)(RemoveOp, _Op6);

  function RemoveOp(value) {
    (0, _classCallCheck3.default)(this, RemoveOp);

    var _this6 = (0, _possibleConstructorReturn3.default)(this, (RemoveOp.__proto__ || (0, _getPrototypeOf2.default)(RemoveOp)).call(this));

    _this6._value = (0, _unique2.default)(Array.isArray(value) ? value : [value]);
    return _this6;
  }

  (0, _createClass3.default)(RemoveOp, [{
    key: 'applyTo',
    value: function (value) {
      if (value == null) {
        return [];
      }
      if (Array.isArray(value)) {
        var i = value.indexOf(this._value);
        var removed = value.concat([]);
        for (var i = 0; i < this._value.length; i++) {
          var index = removed.indexOf(this._value[i]);
          while (index > -1) {
            removed.splice(index, 1);
            index = removed.indexOf(this._value[i]);
          }
          if (this._value[i] instanceof _ParseObject2.default && this._value[i].id) {
            for (var j = 0; j < removed.length; j++) {
              if (removed[j] instanceof _ParseObject2.default && this._value[i].id === removed[j].id) {
                removed.splice(j, 1);
                j--;
              }
            }
          }
        }
        return removed;
      }
      throw new Error('Cannot remove elements from a non-array value');
    }
  }, {
    key: 'mergeWith',
    value: function (previous) {
      if (!previous) {
        return this;
      }
      if (previous instanceof SetOp) {
        return new SetOp(this.applyTo(previous._value));
      }
      if (previous instanceof UnsetOp) {
        return new UnsetOp();
      }
      if (previous instanceof RemoveOp) {
        var uniques = previous._value.concat([]);
        for (var i = 0; i < this._value.length; i++) {
          if (this._value[i] instanceof _ParseObject2.default) {
            if (!(0, _arrayContainsObject2.default)(uniques, this._value[i])) {
              uniques.push(this._value[i]);
            }
          } else {
            if (uniques.indexOf(this._value[i]) < 0) {
              uniques.push(this._value[i]);
            }
          }
        }
        return new RemoveOp(uniques);
      }
      throw new Error('Cannot merge Remove Op with the previous Op');
    }
  }, {
    key: 'toJSON',
    value: function () {
      return { __op: 'Remove', objects: (0, _encode2.default)(this._value, false, true) };
    }
  }]);
  return RemoveOp;
}(Op);

var RelationOp = exports.RelationOp = function (_Op7) {
  (0, _inherits3.default)(RelationOp, _Op7);

  function RelationOp(adds, removes) {
    (0, _classCallCheck3.default)(this, RelationOp);

    var _this7 = (0, _possibleConstructorReturn3.default)(this, (RelationOp.__proto__ || (0, _getPrototypeOf2.default)(RelationOp)).call(this));

    _this7._targetClassName = null;

    if (Array.isArray(adds)) {
      _this7.relationsToAdd = (0, _unique2.default)(adds.map(_this7._extractId, _this7));
    }

    if (Array.isArray(removes)) {
      _this7.relationsToRemove = (0, _unique2.default)(removes.map(_this7._extractId, _this7));
    }
    return _this7;
  }

  (0, _createClass3.default)(RelationOp, [{
    key: '_extractId',
    value: function (obj) {
      if (typeof obj === 'string') {
        return obj;
      }
      if (!obj.id) {
        throw new Error('You cannot add or remove an unsaved Parse Object from a relation');
      }
      if (!this._targetClassName) {
        this._targetClassName = obj.className;
      }
      if (this._targetClassName !== obj.className) {
        throw new Error('Tried to create a Relation with 2 different object types: ' + this._targetClassName + ' and ' + obj.className + '.');
      }
      return obj.id;
    }
  }, {
    key: 'applyTo',
    value: function (value, object, key) {
      if (!value) {
        if (!object || !key) {
          throw new Error('Cannot apply a RelationOp without either a previous value, or an object and a key');
        }
        var parent = new _ParseObject2.default(object.className);
        if (object.id && object.id.indexOf('local') === 0) {
          parent._localId = object.id;
        } else if (object.id) {
          parent.id = object.id;
        }
        var relation = new _ParseRelation2.default(parent, key);
        relation.targetClassName = this._targetClassName;
        return relation;
      }
      if (value instanceof _ParseRelation2.default) {
        if (this._targetClassName) {
          if (value.targetClassName) {
            if (this._targetClassName !== value.targetClassName) {
              throw new Error('Related object must be a ' + value.targetClassName + ', but a ' + this._targetClassName + ' was passed in.');
            }
          } else {
            value.targetClassName = this._targetClassName;
          }
        }
        return value;
      } else {
        throw new Error('Relation cannot be applied to a non-relation field');
      }
    }
  }, {
    key: 'mergeWith',
    value: function (previous) {
      if (!previous) {
        return this;
      } else if (previous instanceof UnsetOp) {
        throw new Error('You cannot modify a relation after deleting it.');
      } else if (previous instanceof RelationOp) {
        if (previous._targetClassName && previous._targetClassName !== this._targetClassName) {
          throw new Error('Related object must be of class ' + previous._targetClassName + ', but ' + (this._targetClassName || 'null') + ' was passed in.');
        }
        var newAdd = previous.relationsToAdd.concat([]);
        this.relationsToRemove.forEach(function (r) {
          var index = newAdd.indexOf(r);
          if (index > -1) {
            newAdd.splice(index, 1);
          }
        });
        this.relationsToAdd.forEach(function (r) {
          var index = newAdd.indexOf(r);
          if (index < 0) {
            newAdd.push(r);
          }
        });

        var newRemove = previous.relationsToRemove.concat([]);
        this.relationsToAdd.forEach(function (r) {
          var index = newRemove.indexOf(r);
          if (index > -1) {
            newRemove.splice(index, 1);
          }
        });
        this.relationsToRemove.forEach(function (r) {
          var index = newRemove.indexOf(r);
          if (index < 0) {
            newRemove.push(r);
          }
        });

        var newRelation = new RelationOp(newAdd, newRemove);
        newRelation._targetClassName = this._targetClassName;
        return newRelation;
      }
      throw new Error('Cannot merge Relation Op with the previous Op');
    }
  }, {
    key: 'toJSON',
    value: function () {
      var _this8 = this;

      var idToPointer = function (id) {
        return {
          __type: 'Pointer',
          className: _this8._targetClassName,
          objectId: id
        };
      };

      var adds = null;
      var removes = null;
      var pointers = null;

      if (this.relationsToAdd.length > 0) {
        pointers = this.relationsToAdd.map(idToPointer);
        adds = { __op: 'AddRelation', objects: pointers };
      }
      if (this.relationsToRemove.length > 0) {
        pointers = this.relationsToRemove.map(idToPointer);
        removes = { __op: 'RemoveRelation', objects: pointers };
      }

      if (adds && removes) {
        return { __op: 'Batch', ops: [adds, removes] };
      }

      return adds || removes || {};
    }
  }]);
  return RelationOp;
}(Op);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _ParsePromise = __webpack_require__(7);

var _ParsePromise2 = _interopRequireDefault(_ParsePromise);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Creates a new GeoPoint with any of the following forms:<br>
 *   <pre>
 *   new GeoPoint(otherGeoPoint)
 *   new GeoPoint(30, 30)
 *   new GeoPoint([30, 30])
 *   new GeoPoint({latitude: 30, longitude: 30})
 *   new GeoPoint()  // defaults to (0, 0)
 *   </pre>
 * <p>Represents a latitude / longitude point that may be associated
 * with a key in a ParseObject or used as a reference point for geo queries.
 * This allows proximity-based queries on the key.</p>
 *
 * <p>Only one key in a class may contain a GeoPoint.</p>
 *
 * <p>Example:<pre>
 *   var point = new Parse.GeoPoint(30.0, -20.0);
 *   var object = new Parse.Object("PlaceObject");
 *   object.set("location", point);
 *   object.save();</pre></p>
 * @alias Parse.GeoPoint
 */
var ParseGeoPoint = function () {

  /**
   * @param {(Number[]|Object|Number)} options Either a list of coordinate pairs, an object with `latitude`, `longitude`, or the latitude or the point. 
   * @param {Number} longitude The longitude of the GeoPoint
   */
  function ParseGeoPoint(arg1, arg2) {
    (0, _classCallCheck3.default)(this, ParseGeoPoint);

    if (Array.isArray(arg1)) {
      ParseGeoPoint._validate(arg1[0], arg1[1]);
      this._latitude = arg1[0];
      this._longitude = arg1[1];
    } else if ((typeof arg1 === 'undefined' ? 'undefined' : (0, _typeof3.default)(arg1)) === 'object') {
      ParseGeoPoint._validate(arg1.latitude, arg1.longitude);
      this._latitude = arg1.latitude;
      this._longitude = arg1.longitude;
    } else if (typeof arg1 === 'number' && typeof arg2 === 'number') {
      ParseGeoPoint._validate(arg1, arg2);
      this._latitude = arg1;
      this._longitude = arg2;
    } else {
      this._latitude = 0;
      this._longitude = 0;
    }
  }

  /**
   * North-south portion of the coordinate, in range [-90, 90].
   * Throws an exception if set out of range in a modern browser.
   * @property latitude
   * @type Number
   */

  (0, _createClass3.default)(ParseGeoPoint, [{
    key: 'toJSON',

    /**
     * Returns a JSON representation of the GeoPoint, suitable for Parse.
      * @return {Object}
     */
    value: function () {
      ParseGeoPoint._validate(this._latitude, this._longitude);
      return {
        __type: 'GeoPoint',
        latitude: this._latitude,
        longitude: this._longitude
      };
    }
  }, {
    key: 'equals',
    value: function (other) {
      return other instanceof ParseGeoPoint && this.latitude === other.latitude && this.longitude === other.longitude;
    }

    /**
     * Returns the distance from this GeoPoint to another in radians.
      * @param {Parse.GeoPoint} point the other Parse.GeoPoint.
     * @return {Number}
     */

  }, {
    key: 'radiansTo',
    value: function (point) {
      var d2r = Math.PI / 180.0;
      var lat1rad = this.latitude * d2r;
      var long1rad = this.longitude * d2r;
      var lat2rad = point.latitude * d2r;
      var long2rad = point.longitude * d2r;

      var sinDeltaLatDiv2 = Math.sin((lat1rad - lat2rad) / 2);
      var sinDeltaLongDiv2 = Math.sin((long1rad - long2rad) / 2);
      // Square of half the straight line chord distance between both points.
      var a = sinDeltaLatDiv2 * sinDeltaLatDiv2 + Math.cos(lat1rad) * Math.cos(lat2rad) * sinDeltaLongDiv2 * sinDeltaLongDiv2;
      a = Math.min(1.0, a);
      return 2 * Math.asin(Math.sqrt(a));
    }

    /**
     * Returns the distance from this GeoPoint to another in kilometers.
      * @param {Parse.GeoPoint} point the other Parse.GeoPoint.
     * @return {Number}
     */

  }, {
    key: 'kilometersTo',
    value: function (point) {
      return this.radiansTo(point) * 6371.0;
    }

    /**
     * Returns the distance from this GeoPoint to another in miles.
      * @param {Parse.GeoPoint} point the other Parse.GeoPoint.
     * @return {Number}
     */

  }, {
    key: 'milesTo',
    value: function (point) {
      return this.radiansTo(point) * 3958.8;
    }

    /*
     * Throws an exception if the given lat-long is out of bounds.
     */

  }, {
    key: 'latitude',
    get: function () {
      return this._latitude;
    },
    set: function (val) {
      ParseGeoPoint._validate(val, this.longitude);
      this._latitude = val;
    }

    /**
     * East-west portion of the coordinate, in range [-180, 180].
     * Throws if set out of range in a modern browser.
     * @property longitude
     * @type Number
     */

  }, {
    key: 'longitude',
    get: function () {
      return this._longitude;
    },
    set: function (val) {
      ParseGeoPoint._validate(this.latitude, val);
      this._longitude = val;
    }
  }], [{
    key: '_validate',
    value: function (latitude, longitude) {
      if (latitude !== latitude || longitude !== longitude) {
        throw new TypeError('GeoPoint latitude and longitude must be valid numbers');
      }
      if (latitude < -90.0) {
        throw new TypeError('GeoPoint latitude out of bounds: ' + latitude + ' < -90.0.');
      }
      if (latitude > 90.0) {
        throw new TypeError('GeoPoint latitude out of bounds: ' + latitude + ' > 90.0.');
      }
      if (longitude < -180.0) {
        throw new TypeError('GeoPoint longitude out of bounds: ' + longitude + ' < -180.0.');
      }
      if (longitude > 180.0) {
        throw new TypeError('GeoPoint longitude out of bounds: ' + longitude + ' > 180.0.');
      }
    }

    /**
     * Creates a GeoPoint with the user's current location, if available.
     * Calls options.success with a new GeoPoint instance or calls options.error.
      * @param {Object} options An object with success and error callbacks.
     * @static
     */

  }, {
    key: 'current',
    value: function (options) {
      var promise = new _ParsePromise2.default();
      navigator.geolocation.getCurrentPosition(function (location) {
        promise.resolve(new ParseGeoPoint(location.coords.latitude, location.coords.longitude));
      }, function (error) {
        promise.reject(error);
      });

      return promise._thenRunCallbacks(options);
    }
  }]);
  return ParseGeoPoint;
}(); /**
      * Copyright (c) 2015-present, Parse, LLC.
      * All rights reserved.
      *
      * This source code is licensed under the BSD-style license found in the
      * LICENSE file in the root directory of this source tree. An additional grant
      * of patent rights can be found in the PATENTS file in the same directory.
      *
      * 
      */

exports.default = ParseGeoPoint;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = decode;

var _ParseACL = __webpack_require__(41);

var _ParseACL2 = _interopRequireDefault(_ParseACL);

var _ParseFile = __webpack_require__(29);

var _ParseFile2 = _interopRequireDefault(_ParseFile);

var _ParseGeoPoint = __webpack_require__(44);

var _ParseGeoPoint2 = _interopRequireDefault(_ParseGeoPoint);

var _ParsePolygon = __webpack_require__(65);

var _ParsePolygon2 = _interopRequireDefault(_ParsePolygon);

var _ParseObject = __webpack_require__(8);

var _ParseObject2 = _interopRequireDefault(_ParseObject);

var _ParseOp = __webpack_require__(43);

var _ParseRelation = __webpack_require__(30);

var _ParseRelation2 = _interopRequireDefault(_ParseRelation);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function decode(value) {
  if (value === null || (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) !== 'object') {
    return value;
  }
  if (Array.isArray(value)) {
    var dup = [];
    value.forEach(function (v, i) {
      dup[i] = decode(v);
    });
    return dup;
  }
  if (typeof value.__op === 'string') {
    return (0, _ParseOp.opFromJSON)(value);
  }
  if (value.__type === 'Pointer' && value.className) {
    return _ParseObject2.default.fromJSON(value);
  }
  if (value.__type === 'Object' && value.className) {
    return _ParseObject2.default.fromJSON(value);
  }
  if (value.__type === 'Relation') {
    // The parent and key fields will be populated by the parent
    var relation = new _ParseRelation2.default(null, null);
    relation.targetClassName = value.className;
    return relation;
  }
  if (value.__type === 'Date') {
    return new Date(value.iso);
  }
  if (value.__type === 'File') {
    return _ParseFile2.default.fromJSON(value);
  }
  if (value.__type === 'GeoPoint') {
    return new _ParseGeoPoint2.default({
      latitude: value.latitude,
      longitude: value.longitude
    });
  }
  if (value.__type === 'Polygon') {
    return new _ParsePolygon2.default(value.coordinates);
  }
  var copy = {};
  for (var k in value) {
    copy[k] = decode(value[k]);
  }
  return copy;
} /**
   * Copyright (c) 2015-present, Parse, LLC.
   * All rights reserved.
   *
   * This source code is licensed under the BSD-style license found in the
   * LICENSE file in the root directory of this source tree. An additional grant
   * of patent rights can be found in the PATENTS file in the same directory.
   *
   * 
   */

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(113);
var enumBugKeys = __webpack_require__(87);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(78);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(207), __esModule: true };

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(39);
var call = __webpack_require__(239);
var isArrayIter = __webpack_require__(240);
var anObject = __webpack_require__(21);
var toLength = __webpack_require__(84);
var getIterFn = __webpack_require__(122);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CoreManager = __webpack_require__(9);

var _CoreManager2 = _interopRequireDefault(_CoreManager);

var _ParsePromise = __webpack_require__(7);

var _ParsePromise2 = _interopRequireDefault(_ParsePromise);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var Storage = {
  async: function () {
    var controller = _CoreManager2.default.getStorageController();
    return !!controller.async;
  },
  getItem: function (path) {
    var controller = _CoreManager2.default.getStorageController();
    if (controller.async === 1) {
      throw new Error('Synchronous storage is not supported by the current storage controller');
    }
    return controller.getItem(path);
  },
  getItemAsync: function (path) {
    var controller = _CoreManager2.default.getStorageController();
    if (controller.async === 1) {
      return controller.getItemAsync(path);
    }
    return _ParsePromise2.default.as(controller.getItem(path));
  },
  setItem: function (path, value) {
    var controller = _CoreManager2.default.getStorageController();
    if (controller.async === 1) {
      throw new Error('Synchronous storage is not supported by the current storage controller');
    }
    return controller.setItem(path, value);
  },
  setItemAsync: function (path, value) {
    var controller = _CoreManager2.default.getStorageController();
    if (controller.async === 1) {
      return controller.setItemAsync(path, value);
    }
    return _ParsePromise2.default.as(controller.setItem(path, value));
  },
  removeItem: function (path) {
    var controller = _CoreManager2.default.getStorageController();
    if (controller.async === 1) {
      throw new Error('Synchronous storage is not supported by the current storage controller');
    }
    return controller.removeItem(path);
  },
  removeItemAsync: function (path) {
    var controller = _CoreManager2.default.getStorageController();
    if (controller.async === 1) {
      return controller.removeItemAsync(path);
    }
    return _ParsePromise2.default.as(controller.removeItem(path));
  },
  generatePath: function (path) {
    if (!_CoreManager2.default.get('APPLICATION_ID')) {
      throw new Error('You need to call Parse.initialize before using Parse.');
    }
    if (typeof path !== 'string') {
      throw new Error('Tried to get a Storage path that was not a String.');
    }
    if (path[0] === '/') {
      path = path.substr(1);
    }
    return 'Parse/' + _CoreManager2.default.get('APPLICATION_ID') + '/' + path;
  },
  _clear: function () {
    var controller = _CoreManager2.default.getStorageController();
    if (controller.hasOwnProperty('clear')) {
      controller.clear();
    }
  }
};

module.exports = Storage;

_CoreManager2.default.setStorageController(__webpack_require__(244));

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Mention; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MentionsInput$1; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_substyle__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_dom__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_dom__);

















// escape RegExp special characters https://stackoverflow.com/a/9310752/5142490
var escapeRegex = function escapeRegex(str) {
  return str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};

var PLACEHOLDERS = {
  id: '__id__',
  display: '__display__'
};

var findPositionOfCapturingGroup = function findPositionOfCapturingGroup(markup, parameterName) {
  __WEBPACK_IMPORTED_MODULE_10_invariant___default()(parameterName === 'id' || parameterName === 'display', "Second arg must be either \"id\" or \"display\", got: \"".concat(parameterName, "\"")); // find positions of placeholders in the markup

  var indexDisplay = markup.indexOf(PLACEHOLDERS.display);
  var indexId = markup.indexOf(PLACEHOLDERS.id); // set indices to null if not found

  if (indexDisplay < 0) indexDisplay = null;
  if (indexId < 0) indexId = null; // markup must contain one of the mandatory placeholders

  __WEBPACK_IMPORTED_MODULE_10_invariant___default()(indexDisplay !== null || indexId !== null, "The markup '".concat(markup, "' does not contain either of the placeholders '__id__' or '__display__'"));

  if (indexDisplay !== null && indexId !== null) {
    // both placeholders are used, return 0 or 1 depending on the position of the requested parameter
    return parameterName === 'id' && indexId <= indexDisplay || parameterName === 'display' && indexDisplay <= indexId ? 0 : 1;
  } // just one placeholder is being used, we'll use the captured string for both parameters


  return 0;
};

var combineRegExps = function combineRegExps(regExps) {
  var serializedRegexParser = /^\/(.+)\/(\w+)?$/;
  return new RegExp(regExps.map(function (regex) {
    var _serializedRegexParse = serializedRegexParser.exec(regex.toString()),
        _serializedRegexParse2 = Object(__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_serializedRegexParse, 3),
        regexString = _serializedRegexParse2[1],
        regexFlags = _serializedRegexParse2[2];

    __WEBPACK_IMPORTED_MODULE_10_invariant___default()(!regexFlags, "RegExp flags are not supported. Change /".concat(regexString, "/").concat(regexFlags, " into /").concat(regexString, "/"));
    return "(".concat(regexString, ")");
  }).join('|'), 'g');
};

var countPlaceholders = function countPlaceholders(markup) {
  var count = 0;
  if (markup.indexOf('__id__') >= 0) count++;
  if (markup.indexOf('__display__') >= 0) count++;
  return count;
};

var emptyFn = function emptyFn() {}; // Finds all occurrences of the markup in the value and calls the `markupIteratee` callback for each of them.
// The optional `textIteratee` callback is called for each plain text ranges in between these markup occurrences.


var iterateMentionsMarkup = function iterateMentionsMarkup(value, config, markupIteratee) {
  var textIteratee = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : emptyFn;
  var regex = combineRegExps(config.map(function (c) {
    return c.regex;
  }));
  var accOffset = 2; // first is whole match, second is the for the capturing group of first regexp component

  var captureGroupOffsets = config.map(function (_ref) {
    var markup = _ref.markup;
    var result = accOffset; // + 1 is for the capturing group we add around each regexp component in combineRegExps

    accOffset += countPlaceholders(markup) + 1;
    return result;
  });
  var match;
  var start = 0;
  var currentPlainTextIndex = 0; // detect all mention markup occurrences in the value and iterate the matches

  while ((match = regex.exec(value)) !== null) {
    var offset = captureGroupOffsets.find(function (o) {
      return !!match[o];
    }); // eslint-disable-line no-loop-func

    var mentionChildIndex = captureGroupOffsets.indexOf(offset);
    var _config$mentionChildI = config[mentionChildIndex],
        markup = _config$mentionChildI.markup,
        displayTransform = _config$mentionChildI.displayTransform;
    var idPos = offset + findPositionOfCapturingGroup(markup, 'id');
    var displayPos = offset + findPositionOfCapturingGroup(markup, 'display');
    var id = match[idPos];
    var display = displayTransform(id, match[displayPos]);
    var substr = value.substring(start, match.index);
    textIteratee(substr, start, currentPlainTextIndex);
    currentPlainTextIndex += substr.length;
    markupIteratee(match[0], match.index, currentPlainTextIndex, id, display, mentionChildIndex, start);
    currentPlainTextIndex += display.length;
    start = regex.lastIndex;
  }

  if (start < value.length) {
    textIteratee(value.substring(start), start, currentPlainTextIndex);
  }
};

var getPlainText = function getPlainText(value, config) {
  var result = '';
  iterateMentionsMarkup(value, config, function (match, index, plainTextIndex, id, display) {
    result += display;
  }, function (plainText) {
    result += plainText;
  });
  return result;
};

// in the marked up value string.
// If the passed character index lies inside a mention, the value of `inMarkupCorrection` defines the
// correction to apply:
//   - 'START' to return the index of the mention markup's first char (default)
//   - 'END' to return the index after its last char
//   - 'NULL' to return null

var mapPlainTextIndex = function mapPlainTextIndex(value, config, indexInPlainText) {
  var inMarkupCorrection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'START';

  if (typeof indexInPlainText !== 'number') {
    return indexInPlainText;
  }

  var result;

  var textIteratee = function textIteratee(substr, index, substrPlainTextIndex) {
    if (result !== undefined) return;

    if (substrPlainTextIndex + substr.length >= indexInPlainText) {
      // found the corresponding position in the current plain text range
      result = index + indexInPlainText - substrPlainTextIndex;
    }
  };

  var markupIteratee = function markupIteratee(markup, index, mentionPlainTextIndex, id, display, childIndex, lastMentionEndIndex) {
    if (result !== undefined) return;

    if (mentionPlainTextIndex + display.length > indexInPlainText) {
      // found the corresponding position inside current match,
      // return the index of the first or after the last char of the matching markup
      // depending on whether the `inMarkupCorrection`
      if (inMarkupCorrection === 'NULL') {
        result = null;
      } else {
        result = index + (inMarkupCorrection === 'END' ? markup.length : 0);
      }
    }
  };

  iterateMentionsMarkup(value, config, markupIteratee, textIteratee); // when a mention is at the end of the value and we want to get the caret position
  // at the end of the string, result is undefined

  return result === undefined ? value.length : result;
};

var spliceString = function spliceString(str, start, end, insert) {
  return str.substring(0, start) + insert + str.substring(end);
};

// guided by the textarea text selection ranges before and after the change

var applyChangeToValue = function applyChangeToValue(value, plainTextValue, _ref, config) {
  var selectionStartBefore = _ref.selectionStartBefore,
      selectionEndBefore = _ref.selectionEndBefore,
      selectionEndAfter = _ref.selectionEndAfter;
  var oldPlainTextValue = getPlainText(value, config);
  var lengthDelta = oldPlainTextValue.length - plainTextValue.length;

  if (selectionStartBefore === 'undefined') {
    selectionStartBefore = selectionEndAfter + lengthDelta;
  }

  if (selectionEndBefore === 'undefined') {
    selectionEndBefore = selectionStartBefore;
  } // Fixes an issue with replacing combined characters for complex input. Eg like acented letters on OSX


  if (selectionStartBefore === selectionEndBefore && selectionEndBefore === selectionEndAfter && oldPlainTextValue.length === plainTextValue.length) {
    selectionStartBefore = selectionStartBefore - 1;
  } // extract the insertion from the new plain text value


  var insert = plainTextValue.slice(selectionStartBefore, selectionEndAfter); // handling for Backspace key with no range selection

  var spliceStart = Math.min(selectionStartBefore, selectionEndAfter);
  var spliceEnd = selectionEndBefore;

  if (selectionStartBefore === selectionEndAfter) {
    // handling for Delete key with no range selection
    spliceEnd = Math.max(selectionEndBefore, selectionStartBefore + lengthDelta);
  }

  var mappedSpliceStart = mapPlainTextIndex(value, config, spliceStart, 'START');
  var mappedSpliceEnd = mapPlainTextIndex(value, config, spliceEnd, 'END');
  var controlSpliceStart = mapPlainTextIndex(value, config, spliceStart, 'NULL');
  var controlSpliceEnd = mapPlainTextIndex(value, config, spliceEnd, 'NULL');
  var willRemoveMention = controlSpliceStart === null || controlSpliceEnd === null;
  var newValue = spliceString(value, mappedSpliceStart, mappedSpliceEnd, insert);

  if (!willRemoveMention) {
    // test for auto-completion changes
    var controlPlainTextValue = getPlainText(newValue, config);

    if (controlPlainTextValue !== plainTextValue) {
      // some auto-correction is going on
      // find start of diff
      spliceStart = 0;

      while (plainTextValue[spliceStart] === controlPlainTextValue[spliceStart]) {
        spliceStart++;
      } // extract auto-corrected insertion


      insert = plainTextValue.slice(spliceStart, selectionEndAfter); // find index of the unchanged remainder

      spliceEnd = oldPlainTextValue.lastIndexOf(plainTextValue.substring(selectionEndAfter)); // re-map the corrected indices

      mappedSpliceStart = mapPlainTextIndex(value, config, spliceStart, 'START');
      mappedSpliceEnd = mapPlainTextIndex(value, config, spliceEnd, 'END');
      newValue = spliceString(value, mappedSpliceStart, mappedSpliceEnd, insert);
    }
  }

  return newValue;
};

// returns a the index of of the first char of the mention in the plain text.
// If indexInPlainText does not lie inside a mention, returns indexInPlainText.

var findStartOfMentionInPlainText = function findStartOfMentionInPlainText(value, config, indexInPlainText) {
  var result = indexInPlainText;
  var foundMention = false;

  var markupIteratee = function markupIteratee(markup, index, mentionPlainTextIndex, id, display, childIndex, lastMentionEndIndex) {
    if (mentionPlainTextIndex <= indexInPlainText && mentionPlainTextIndex + display.length > indexInPlainText) {
      result = mentionPlainTextIndex;
      foundMention = true;
    }
  };

  iterateMentionsMarkup(value, config, markupIteratee);

  if (foundMention) {
    return result;
  }
};

var getMentions = function getMentions(value, config) {
  var mentions = [];
  iterateMentionsMarkup(value, config, function (match, index, plainTextIndex, id, display, childIndex, start) {
    mentions.push({
      id: id,
      display: display,
      childIndex: childIndex,
      index: index,
      plainTextIndex: plainTextIndex
    });
  });
  return mentions;
};

var getSuggestionHtmlId = function getSuggestionHtmlId(prefix, id) {
  return "".concat(prefix, "-").concat(id);
};

var countSuggestions = function countSuggestions(suggestions) {
  return Object.values(suggestions).reduce(function (acc, _ref) {
    var results = _ref.results;
    return acc + results.length;
  }, 0);
};

var getEndOfLastMention = function getEndOfLastMention(value, config) {
  var mentions = getMentions(value, config);
  var lastMention = mentions[mentions.length - 1];
  return lastMention ? lastMention.plainTextIndex + lastMention.display.length : 0;
};

var markupToRegex = function markupToRegex(markup) {
  var escapedMarkup = escapeRegex(markup);
  var charAfterDisplay = markup[markup.indexOf(PLACEHOLDERS.display) + PLACEHOLDERS.display.length];
  var charAfterId = markup[markup.indexOf(PLACEHOLDERS.id) + PLACEHOLDERS.id.length];
  return new RegExp(escapedMarkup.replace(PLACEHOLDERS.display, "([^".concat(escapeRegex(charAfterDisplay || ''), "]+?)")).replace(PLACEHOLDERS.id, "([^".concat(escapeRegex(charAfterId || ''), "]+?)")));
};

var readConfigFromChildren = function readConfigFromChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children).map(function (_ref) {
    var _ref$props = _ref.props,
        markup = _ref$props.markup,
        regex = _ref$props.regex,
        displayTransform = _ref$props.displayTransform;
    return {
      markup: markup,
      regex: regex ? coerceCapturingGroups(regex, markup) : markupToRegex(markup),
      displayTransform: displayTransform || function (id, display) {
        return display || id;
      }
    };
  });
}; // make sure that the custom regex defines the correct number of capturing groups


var coerceCapturingGroups = function coerceCapturingGroups(regex, markup) {
  var numberOfGroups = new RegExp(regex.toString() + '|').exec('').length - 1;
  var numberOfPlaceholders = countPlaceholders(markup);
  __WEBPACK_IMPORTED_MODULE_10_invariant___default()(numberOfGroups === numberOfPlaceholders, "Number of capturing groups in RegExp ".concat(regex.toString(), " (").concat(numberOfGroups, ") does not match the number of placeholders in the markup '").concat(markup, "' (").concat(numberOfPlaceholders, ")"));
  return regex;
};

var makeMentionsMarkup = function makeMentionsMarkup(markup, id, display) {
  return markup.replace(PLACEHOLDERS.id, id).replace(PLACEHOLDERS.display, display);
};

// This contains all the latin letters and the regex that match these letters with diacritics
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
var lettersDiacritics = [{
  base: 'A',
  letters: /(&#65;|&#9398;|&#65313;|&#192;|&#193;|&#194;|&#7846;|&#7844;|&#7850;|&#7848;|&#195;|&#256;|&#258;|&#7856;|&#7854;|&#7860;|&#7858;|&#550;|&#480;|&#196;|&#478;|&#7842;|&#197;|&#506;|&#461;|&#512;|&#514;|&#7840;|&#7852;|&#7862;|&#7680;|&#260;|&#570;|&#11375;|[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F])/g
}, {
  base: 'AA',
  letters: /(&#42802;|[\uA732])/g
}, {
  base: 'AE',
  letters: /(&#198;|&#508;|&#482;|[\u00C6\u01FC\u01E2])/g
}, {
  base: 'AO',
  letters: /(&#42804;|[\uA734])/g
}, {
  base: 'AU',
  letters: /(&#42806;|[\uA736])/g
}, {
  base: 'AV',
  letters: /(&#42808;|&#42810;|[\uA738\uA73A])/g
}, {
  base: 'AY',
  letters: /(&#42812;|[\uA73C])/g
}, {
  base: 'B',
  letters: /(&#66;|&#9399;|&#65314;|&#7682;|&#7684;|&#7686;|&#579;|&#386;|&#385;|[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181])/g
}, {
  base: 'C',
  letters: /(&#67;|&#9400;|&#65315;|&#262;|&#264;|&#266;|&#268;|&#199;|&#7688;|&#391;|&#571;|&#42814;|[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E])/g
}, {
  base: 'D',
  letters: /(&#68;|&#9401;|&#65316;|&#7690;|&#270;|&#7692;|&#7696;|&#7698;|&#7694;|&#272;|&#395;|&#394;|&#393;|&#42873;|&#208;|[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\u00D0])/g
}, {
  base: 'DZ',
  letters: /(&#497;|&#452;|[\u01F1\u01C4])/g
}, {
  base: 'Dz',
  letters: /(&#498;|&#453;|[\u01F2\u01C5])/g
}, {
  base: 'E',
  letters: /(&#69;|&#9402;|&#65317;|&#200;|&#201;|&#202;|&#7872;|&#7870;|&#7876;|&#7874;|&#7868;|&#274;|&#7700;|&#7702;|&#276;|&#278;|&#203;|&#7866;|&#282;|&#516;|&#518;|&#7864;|&#7878;|&#552;|&#7708;|&#280;|&#7704;|&#7706;|&#400;|&#398;|[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E])/g
}, {
  base: 'F',
  letters: /(&#70;|&#9403;|&#65318;|&#7710;|&#401;|&#42875;|[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B])/g
}, {
  base: 'G',
  letters: /(&#71;|&#9404;|&#65319;|&#500;|&#284;|&#7712;|&#286;|&#288;|&#486;|&#290;|&#484;|&#403;|&#42912;|&#42877;|&#42878;|[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E])/g
}, {
  base: 'H',
  letters: /(&#72;|&#9405;|&#65320;|&#292;|&#7714;|&#7718;|&#542;|&#7716;|&#7720;|&#7722;|&#294;|&#11367;|&#11381;|&#42893;|[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D])/g
}, {
  base: 'I',
  letters: /(&#73;|&#9406;|&#65321;|&#204;|&#205;|&#206;|&#296;|&#298;|&#300;|&#304;|&#207;|&#7726;|&#7880;|&#463;|&#520;|&#522;|&#7882;|&#302;|&#7724;|&#407;|[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197])/g
}, {
  base: 'J',
  letters: /(&#74;|&#9407;|&#65322;|&#308;|&#584;|[\u004A\u24BF\uFF2A\u0134\u0248])/g
}, {
  base: 'K',
  letters: /(&#75;|&#9408;|&#65323;|&#7728;|&#488;|&#7730;|&#310;|&#7732;|&#408;|&#11369;|&#42816;|&#42818;|&#42820;|&#42914;|[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2])/g
}, {
  base: 'L',
  letters: /(&#76;|&#9409;|&#65324;|&#319;|&#313;|&#317;|&#7734;|&#7736;|&#315;|&#7740;|&#7738;|&#321;|&#573;|&#11362;|&#11360;|&#42824;|&#42822;|&#42880;|[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780])/g
}, {
  base: 'LJ',
  letters: /(&#455;|[\u01C7])/g
}, {
  base: 'Lj',
  letters: /(&#456;|[\u01C8])/g
}, {
  base: 'M',
  letters: /(&#77;|&#9410;|&#65325;|&#7742;|&#7744;|&#7746;|&#11374;|&#412;|[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C])/g
}, {
  base: 'N',
  letters: /(&#78;|&#9411;|&#65326;|&#504;|&#323;|&#209;|&#7748;|&#327;|&#7750;|&#325;|&#7754;|&#7752;|&#544;|&#413;|&#42896;|&#42916;|&#330;|[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4\u014A])/g
}, {
  base: 'NJ',
  letters: /(&#458;|[\u01CA])/g
}, {
  base: 'Nj',
  letters: /(&#459;|[\u01CB])/g
}, {
  base: 'O',
  letters: /(&#79;|&#9412;|&#65327;|&#210;|&#211;|&#212;|&#7890;|&#7888;|&#7894;|&#7892;|&#213;|&#7756;|&#556;|&#7758;|&#332;|&#7760;|&#7762;|&#334;|&#558;|&#560;|&#214;|&#554;|&#7886;|&#336;|&#465;|&#524;|&#526;|&#416;|&#7900;|&#7898;|&#7904;|&#7902;|&#7906;|&#7884;|&#7896;|&#490;|&#492;|&#216;|&#510;|&#390;|&#415;|&#42826;|&#42828;|[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C])/g
}, {
  base: 'OE',
  letters: /(&#338;|[\u0152])/g
}, {
  base: 'OI',
  letters: /(&#418;|[\u01A2])/g
}, {
  base: 'OO',
  letters: /(&#42830;|[\uA74E])/g
}, {
  base: 'OU',
  letters: /(&#546;|[\u0222])/g
}, {
  base: 'P',
  letters: /(&#80;|&#9413;|&#65328;|&#7764;|&#7766;|&#420;|&#11363;|&#42832;|&#42834;|&#42836;|[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754])/g
}, {
  base: 'Q',
  letters: /(&#81;|&#9414;|&#65329;|&#42838;|&#42840;|&#586;|[\u0051\u24C6\uFF31\uA756\uA758\u024A])/g
}, {
  base: 'R',
  letters: /(&#82;|&#9415;|&#65330;|&#340;|&#7768;|&#344;|&#528;|&#530;|&#7770;|&#7772;|&#342;|&#7774;|&#588;|&#11364;|&#42842;|&#42918;|&#42882;|[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782])/g
}, {
  base: 'S',
  letters: /(&#83;|&#9416;|&#65331;|&#7838;|&#346;|&#7780;|&#348;|&#7776;|&#352;|&#7782;|&#7778;|&#7784;|&#536;|&#350;|&#11390;|&#42920;|&#42884;|[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784])/g
}, {
  base: 'T',
  letters: /(&#84;|&#9417;|&#65332;|&#7786;|&#356;|&#7788;|&#538;|&#354;|&#7792;|&#7790;|&#358;|&#428;|&#430;|&#574;|&#42886;|[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786])/g
}, {
  base: 'TH',
  letters: /(&#222;|[\u00DE])/g
}, {
  base: 'TZ',
  letters: /(&#42792;|[\uA728])/g
}, {
  base: 'U',
  letters: /(&#85;|&#9418;|&#65333;|&#217;|&#218;|&#219;|&#360;|&#7800;|&#362;|&#7802;|&#364;|&#220;|&#475;|&#471;|&#469;|&#473;|&#7910;|&#366;|&#368;|&#467;|&#532;|&#534;|&#431;|&#7914;|&#7912;|&#7918;|&#7916;|&#7920;|&#7908;|&#7794;|&#370;|&#7798;|&#7796;|&#580;|[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244])/g
}, {
  base: 'V',
  letters: /(&#86;|&#9419;|&#65334;|&#7804;|&#7806;|&#434;|&#42846;|&#581;|[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245])/g
}, {
  base: 'VY',
  letters: /(&#42848;|[\uA760])/g
}, {
  base: 'W',
  letters: /(&#87;|&#9420;|&#65335;|&#7808;|&#7810;|&#372;|&#7814;|&#7812;|&#7816;|&#11378;|[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72])/g
}, {
  base: 'X',
  letters: /(&#88;|&#9421;|&#65336;|&#7818;|&#7820;|[\u0058\u24CD\uFF38\u1E8A\u1E8C])/g
}, {
  base: 'Y',
  letters: /(&#89;|&#9422;|&#65337;|&#7922;|&#221;|&#374;|&#7928;|&#562;|&#7822;|&#376;|&#7926;|&#7924;|&#435;|&#590;|&#7934;|[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE])/g
}, {
  base: 'Z',
  letters: /(&#90;|&#9423;|&#65338;|&#377;|&#7824;|&#379;|&#381;|&#7826;|&#7828;|&#437;|&#548;|&#11391;|&#11371;|&#42850;|[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762])/g
}, {
  base: 'a',
  letters: /(&#97;|&#9424;|&#65345;|&#7834;|&#224;|&#225;|&#226;|&#7847;|&#7845;|&#7851;|&#7849;|&#227;|&#257;|&#259;|&#7857;|&#7855;|&#7861;|&#7859;|&#551;|&#481;|&#228;|&#479;|&#7843;|&#229;|&#507;|&#462;|&#513;|&#515;|&#7841;|&#7853;|&#7863;|&#7681;|&#261;|&#11365;|&#592;|[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250])/g
}, {
  base: 'aa',
  letters: /(&#42803;|[\uA733])/g
}, {
  base: 'ae',
  letters: /(&#230;|&#509;|&#483;|[\u00E6\u01FD\u01E3])/g
}, {
  base: 'ao',
  letters: /(&#42805;|[\uA735])/g
}, {
  base: 'au',
  letters: /(&#42807;|[\uA737])/g
}, {
  base: 'av',
  letters: /(&#42809;|&#42811;|[\uA739\uA73B])/g
}, {
  base: 'ay',
  letters: /(&#42813;|[\uA73D])/g
}, {
  base: 'b',
  letters: /(&#98;|&#9425;|&#65346;|&#7683;|&#7685;|&#7687;|&#384;|&#387;|&#595;|[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253])/g
}, {
  base: 'c',
  letters: /(&#99;|&#9426;|&#65347;|&#263;|&#265;|&#267;|&#269;|&#231;|&#7689;|&#392;|&#572;|&#42815;|&#8580;|[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184])/g
}, {
  base: 'd',
  letters: /(&#100;|&#9427;|&#65348;|&#7691;|&#271;|&#7693;|&#7697;|&#7699;|&#7695;|&#273;|&#396;|&#598;|&#599;|&#42874;|&#240;|[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A\u00F0])/g
}, {
  base: 'dz',
  letters: /(&#499;|&#454;|[\u01F3\u01C6])/g
}, {
  base: 'e',
  letters: /(&#101;|&#9428;|&#65349;|&#232;|&#233;|&#234;|&#7873;|&#7871;|&#7877;|&#7875;|&#7869;|&#275;|&#7701;|&#7703;|&#277;|&#279;|&#235;|&#7867;|&#283;|&#517;|&#519;|&#7865;|&#7879;|&#553;|&#7709;|&#281;|&#7705;|&#7707;|&#583;|&#603;|&#477;|[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD])/g
}, {
  base: 'f',
  letters: /(&#102;|&#9429;|&#65350;|&#7711;|&#402;|&#42876;|[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C])/g
}, {
  base: 'g',
  letters: /(&#103;|&#9430;|&#65351;|&#501;|&#285;|&#7713;|&#287;|&#289;|&#487;|&#291;|&#485;|&#608;|&#42913;|&#7545;|&#42879;|[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F])/g
}, {
  base: 'h',
  letters: /(&#104;|&#9431;|&#65352;|&#293;|&#7715;|&#7719;|&#543;|&#7717;|&#7721;|&#7723;|&#7830;|&#295;|&#11368;|&#11382;|&#613;|[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265])/g
}, {
  base: 'hv',
  letters: /(&#405;|[\u0195])/g
}, {
  base: 'i',
  letters: /(&#105;|&#9432;|&#65353;|&#236;|&#237;|&#238;|&#297;|&#299;|&#301;|&#239;|&#7727;|&#7881;|&#464;|&#521;|&#523;|&#7883;|&#303;|&#7725;|&#616;|&#305;|[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131])/g
}, {
  base: 'ij',
  letters: /(&#307;|[\u0133])/g
}, {
  base: 'j',
  letters: /(&#106;|&#9433;|&#65354;|&#309;|&#496;|&#585;|[\u006A\u24D9\uFF4A\u0135\u01F0\u0249])/g
}, {
  base: 'k',
  letters: /(&#107;|&#9434;|&#65355;|&#7729;|&#489;|&#7731;|&#311;|&#7733;|&#409;|&#11370;|&#42817;|&#42819;|&#42821;|&#42915;|[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3])/g
}, {
  base: 'l',
  letters: /(&#108;|&#9435;|&#65356;|&#320;|&#314;|&#318;|&#7735;|&#7737;|&#316;|&#7741;|&#7739;|&#322;|&#410;|&#619;|&#11361;|&#42825;|&#42881;|&#42823;|[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u0142\u019A\u026B\u2C61\uA749\uA781\uA747])/g
}, {
  base: 'lj',
  letters: /(&#457;|[\u01C9])/g
}, {
  base: 'm',
  letters: /(&#109;|&#9436;|&#65357;|&#7743;|&#7745;|&#7747;|&#625;|&#623;|[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F])/g
}, {
  base: 'n',
  letters: /(&#110;|&#9437;|&#65358;|&#505;|&#324;|&#241;|&#7749;|&#328;|&#7751;|&#326;|&#7755;|&#7753;|&#414;|&#626;|&#329;|&#42897;|&#42917;|&#331;|[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u014B])/g
}, {
  base: 'nj',
  letters: /(&#460;|[\u01CC])/g
}, {
  base: 'o',
  letters: /(&#111;|&#9438;|&#65359;|&#242;|&#243;|&#244;|&#7891;|&#7889;|&#7895;|&#7893;|&#245;|&#7757;|&#557;|&#7759;|&#333;|&#7761;|&#7763;|&#335;|&#559;|&#561;|&#246;|&#555;|&#7887;|&#337;|&#466;|&#525;|&#527;|&#417;|&#7901;|&#7899;|&#7905;|&#7903;|&#7907;|&#7885;|&#7897;|&#491;|&#493;|&#248;|&#511;|&#596;|&#42827;|&#42829;|&#629;|[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275])/g
}, {
  base: 'oe',
  letters: /(&#339;|[\u0153])/g
}, {
  base: 'oi',
  letters: /(&#419;|[\u01A3])/g
}, {
  base: 'ou',
  letters: /(&#547;|[\u0223])/g
}, {
  base: 'oo',
  letters: /(&#42831;|[\uA74F])/g
}, {
  base: 'p',
  letters: /(&#112;|&#9439;|&#65360;|&#7765;|&#7767;|&#421;|&#7549;|&#42833;|&#42835;|&#42837;|[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755])/g
}, {
  base: 'q',
  letters: /(&#113;|&#9440;|&#65361;|&#587;|&#42839;|&#42841;|[\u0071\u24E0\uFF51\u024B\uA757\uA759])/g
}, {
  base: 'r',
  letters: /(&#114;|&#9441;|&#65362;|&#341;|&#7769;|&#345;|&#529;|&#531;|&#7771;|&#7773;|&#343;|&#7775;|&#589;|&#637;|&#42843;|&#42919;|&#42883;|[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783])/g
}, {
  base: 's',
  letters: /(&#115;|&#9442;|&#65363;|&#347;|&#7781;|&#349;|&#7777;|&#353;|&#7783;|&#7779;|&#7785;|&#537;|&#351;|&#575;|&#42921;|&#42885;|&#7835;|&#383;|[\u0073\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B\u017F])/g
}, {
  base: 'ss',
  letters: /(&#223;|[\u00DF])/g
}, {
  base: 't',
  letters: /(&#116;|&#9443;|&#65364;|&#7787;|&#7831;|&#357;|&#7789;|&#539;|&#355;|&#7793;|&#7791;|&#359;|&#429;|&#648;|&#11366;|&#42887;|[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787])/g
}, {
  base: 'th',
  letters: /(&#254;|[\u00FE])/g
}, {
  base: 'tz',
  letters: /(&#42793;|[\uA729])/g
}, {
  base: 'u',
  letters: /(&#117;|&#9444;|&#65365;|&#249;|&#250;|&#251;|&#361;|&#7801;|&#363;|&#7803;|&#365;|&#252;|&#476;|&#472;|&#470;|&#474;|&#7911;|&#367;|&#369;|&#468;|&#533;|&#535;|&#432;|&#7915;|&#7913;|&#7919;|&#7917;|&#7921;|&#7909;|&#7795;|&#371;|&#7799;|&#7797;|&#649;|[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289])/g
}, {
  base: 'v',
  letters: /(&#118;|&#9445;|&#65366;|&#7805;|&#7807;|&#651;|&#42847;|&#652;|[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C])/g
}, {
  base: 'vy',
  letters: /(&#42849;|[\uA761])/g
}, {
  base: 'w',
  letters: /(&#119;|&#9446;|&#65367;|&#7809;|&#7811;|&#373;|&#7815;|&#7813;|&#7832;|&#7817;|&#11379;|[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73])/g
}, {
  base: 'x',
  letters: /(&#120;|&#9447;|&#65368;|&#7819;|&#7821;|[\u0078\u24E7\uFF58\u1E8B\u1E8D])/g
}, {
  base: 'y',
  letters: /(&#121;|&#9448;|&#65369;|&#7923;|&#253;|&#375;|&#7929;|&#563;|&#7823;|&#255;|&#7927;|&#7833;|&#7925;|&#436;|&#591;|&#7935;|[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF])/g
}, {
  base: 'z',
  letters: /(&#122;|&#9449;|&#65370;|&#378;|&#7825;|&#380;|&#382;|&#7827;|&#7829;|&#438;|&#549;|&#576;|&#11372;|&#42851;|[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763])/g
}];

var removeAccents = function removeAccents(str) {
  var formattedStr = str;
  lettersDiacritics.forEach(function (letterDiacritics) {
    formattedStr = formattedStr.replace(letterDiacritics.letters, letterDiacritics.base);
  });
  return formattedStr;
};

var normalizeString = function normalizeString(str) {
  return removeAccents(str).toLowerCase();
};

var getSubstringIndex = function getSubstringIndex(str, substr, ignoreAccents) {
  if (!ignoreAccents) {
    return str.toLowerCase().indexOf(substr.toLowerCase());
  }

  return normalizeString(str).indexOf(normalizeString(substr));
};

var isIE = function isIE() {
  return !!document.documentMode;
};

var isNumber = function isNumber(val) {
  return typeof val === 'number';
};

var keys = function keys(obj) {
  return obj === Object(obj) ? Object.keys(obj) : [];
};

var omit = function omit(obj) {
  var _ref;

  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  var keys = (_ref = []).concat.apply(_ref, rest);

  return Object.keys(obj).reduce(function (acc, k) {
    if (obj.hasOwnProperty(k) && !keys.includes(k) && obj[k] !== undefined) {
      acc[k] = obj[k];
    }

    return acc;
  }, {});
};

var _excluded = ["style", "className", "classNames"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function createDefaultStyle(defaultStyle, getModifiers) {
  var enhance = function enhance(ComponentToWrap) {
    var DefaultStyleEnhancer = function DefaultStyleEnhancer(_ref) {
      var style = _ref.style,
          className = _ref.className,
          classNames = _ref.classNames,
          rest = Object(__WEBPACK_IMPORTED_MODULE_12__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, _excluded);

      var modifiers = getModifiers ? getModifiers(rest) : undefined;
      var styles = Object(__WEBPACK_IMPORTED_MODULE_13_substyle__["a" /* default */])(defaultStyle, {
        style: style,
        className: className,
        classNames: classNames
      }, modifiers);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(ComponentToWrap, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        style: styles
      }));
    };

    var displayName = ComponentToWrap.displayName || ComponentToWrap.name || 'Component';
    DefaultStyleEnhancer.displayName = "defaultStyle(".concat(displayName, ")"); // return DefaultStyleEnhancer

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.forwardRef(function (props, ref) {
      return DefaultStyleEnhancer(_objectSpread(_objectSpread({}, props), {}, {
        ref: ref
      }));
    });
  };

  return enhance;
}

var _generateComponentKey = function _generateComponentKey(usedKeys, id) {
  if (!usedKeys.hasOwnProperty(id)) {
    usedKeys[id] = 0;
  } else {
    usedKeys[id]++;
  }

  return id + '_' + usedKeys[id];
};

function Highlighter(_ref) {
  var selectionStart = _ref.selectionStart,
      selectionEnd = _ref.selectionEnd,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      onCaretPositionChange = _ref.onCaretPositionChange,
      containerRef = _ref.containerRef,
      children = _ref.children,
      singleLine = _ref.singleLine,
      style = _ref.style;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_9_react__["useState"])({
    left: undefined,
    top: undefined
  }),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_9_react__["useState"])(),
      _useState4 = Object(__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState3, 2),
      caretElement = _useState4[0],
      setCaretElement = _useState4[1];

  Object(__WEBPACK_IMPORTED_MODULE_9_react__["useEffect"])(function () {
    notifyCaretPosition();
  });

  var notifyCaretPosition = function notifyCaretPosition() {
    if (!caretElement) {
      return;
    }

    var offsetLeft = caretElement.offsetLeft,
        offsetTop = caretElement.offsetTop;

    if (position.left === offsetLeft && position.top === offsetTop) {
      return;
    }

    var newPosition = {
      left: offsetLeft,
      top: offsetTop
    };
    setPosition(newPosition);
    onCaretPositionChange(newPosition);
  };

  var config = readConfigFromChildren(children);
  var caretPositionInMarkup;

  if (selectionEnd === selectionStart) {
    caretPositionInMarkup = mapPlainTextIndex(value, config, selectionStart, 'START');
  }

  var resultComponents = [];
  var componentKeys = {};
  var components = resultComponents;
  var substringComponentKey = 0;

  var textIteratee = function textIteratee(substr, index, indexInPlainText) {
    // check whether the caret element has to be inserted inside the current plain substring
    if (isNumber(caretPositionInMarkup) && caretPositionInMarkup >= index && caretPositionInMarkup <= index + substr.length) {
      // if yes, split substr at the caret position and insert the caret component
      var splitIndex = caretPositionInMarkup - index;
      components.push(renderSubstring(substr.substring(0, splitIndex), substringComponentKey)); // add all following substrings and mention components as children of the caret component

      components = [renderSubstring(substr.substring(splitIndex), substringComponentKey)];
    } else {
      components.push(renderSubstring(substr, substringComponentKey));
    }

    substringComponentKey++;
  };

  var mentionIteratee = function mentionIteratee(markup, index, indexInPlainText, id, display, mentionChildIndex, lastMentionEndIndex) {
    var key = _generateComponentKey(componentKeys, id);

    components.push(getMentionComponentForMatch(id, display, mentionChildIndex, key));
  };

  var renderSubstring = function renderSubstring(string, key) {
    // set substring span to hidden, so that Emojis are not shown double in Mobile Safari
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, style('substring'), {
      key: key
    }), string);
  };

  var getMentionComponentForMatch = function getMentionComponentForMatch(id, display, mentionChildIndex, key) {
    var props = {
      id: id,
      display: display,
      key: key
    };
    var child = __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children)[mentionChildIndex];
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.cloneElement(child, props);
  };

  var renderHighlighterCaret = function renderHighlighterCaret(children) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, style('caret'), {
      ref: setCaretElement,
      key: "caret"
    }), children);
  };

  iterateMentionsMarkup(value, config, mentionIteratee, textIteratee); // append a span containing a space, to ensure the last text line has the correct height

  components.push(' ');

  if (components !== resultComponents) {
    // if a caret component is to be rendered, add all components that followed as its children
    resultComponents.push(renderHighlighterCaret(components));
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, style, {
    ref: containerRef
  }), resultComponents);
}

Highlighter.propTypes = {
  selectionStart: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number,
  selectionEnd: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string.isRequired,
  onCaretPositionChange: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func.isRequired,
  containerRef: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.shape({
    current: typeof Element === 'undefined' ? __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.any : __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.instanceOf(Element)
  })]),
  children: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.element)]).isRequired
};
var styled = createDefaultStyle({
  position: 'relative',
  boxSizing: 'border-box',
  width: '100%',
  color: 'transparent',
  overflow: 'hidden',
  whiteSpace: 'pre-wrap',
  wordWrap: 'break-word',
  border: '1px solid transparent',
  textAlign: 'start',
  '&singleLine': {
    whiteSpace: 'pre',
    wordWrap: null
  },
  substring: {
    visibility: 'hidden'
  }
}, function (props) {
  return {
    '&singleLine': props.singleLine
  };
});
var Highlighter$1 = styled(Highlighter);

function Suggestion(_ref) {
  var id = _ref.id,
      focused = _ref.focused,
      ignoreAccents = _ref.ignoreAccents,
      index = _ref.index,
      onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter,
      query = _ref.query,
      renderSuggestion = _ref.renderSuggestion,
      suggestion = _ref.suggestion,
      style = _ref.style,
      className = _ref.className,
      classNames = _ref.classNames;
  var rest = {
    onClick: onClick,
    onMouseEnter: onMouseEnter
  };

  var renderContent = function renderContent() {
    var display = getDisplay();
    var highlightedDisplay = renderHighlightedDisplay(display);

    if (renderSuggestion) {
      return renderSuggestion(suggestion, query, highlightedDisplay, index, focused);
    }

    return highlightedDisplay;
  };

  var getDisplay = function getDisplay() {
    if (typeof suggestion === 'string') {
      return suggestion;
    }

    var id = suggestion.id,
        display = suggestion.display;

    if (id === undefined || !display) {
      return id;
    }

    return display;
  };

  var renderHighlightedDisplay = function renderHighlightedDisplay(display) {
    var i = getSubstringIndex(display, query, ignoreAccents);

    if (i === -1) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("span", style('display'), display);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("span", style('display'), display.substring(0, i), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("b", style('highlight'), display.substring(i, i + query.length)), display.substring(i + query.length));
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    id: id,
    role: "option",
    "aria-selected": focused
  }, rest, style), renderContent());
}

Suggestion.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string.isRequired,
  query: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string.isRequired,
  index: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number.isRequired,
  ignoreAccents: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool,
  suggestion: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number]).isRequired,
    display: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string
  })]).isRequired,
  renderSuggestion: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,
  focused: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool
};
var styled$1 = createDefaultStyle({
  cursor: 'pointer'
}, function (props) {
  return {
    '&focused': props.focused
  };
});
var Suggestion$1 = styled$1(Suggestion);

function LoadingIndicator(_ref) {
  var style = _ref.style,
      className = _ref.className,
      classNames = _ref.classNames;
  var styles = Object(__WEBPACK_IMPORTED_MODULE_13_substyle__["a" /* default */])(defaultstyle, {
    style: style,
    className: className,
    classNames: classNames
  });
  var spinnerStyles = styles('spinner');
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", styles, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", spinnerStyles, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", spinnerStyles(['element', 'element1'])), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", spinnerStyles(['element', 'element2'])), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", spinnerStyles(['element', 'element3'])), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", spinnerStyles(['element', 'element4'])), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", spinnerStyles(['element', 'element5']))));
}

var defaultstyle = {};

function SuggestionsOverlay(_ref) {
  var id = _ref.id,
      _ref$suggestions = _ref.suggestions,
      suggestions = _ref$suggestions === void 0 ? {} : _ref$suggestions,
      a11ySuggestionsListLabel = _ref.a11ySuggestionsListLabel,
      focusIndex = _ref.focusIndex,
      position = _ref.position,
      left = _ref.left,
      right = _ref.right,
      top = _ref.top,
      scrollFocusedIntoView = _ref.scrollFocusedIntoView,
      isLoading = _ref.isLoading,
      isOpened = _ref.isOpened,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? function () {
    return null;
  } : _ref$onSelect,
      ignoreAccents = _ref.ignoreAccents,
      containerRef = _ref.containerRef,
      children = _ref.children,
      style = _ref.style,
      customSuggestionsContainer = _ref.customSuggestionsContainer,
      onMouseDown = _ref.onMouseDown,
      onMouseEnter = _ref.onMouseEnter;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_9_react__["useState"])(undefined),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      ulElement = _useState2[0],
      setUlElement = _useState2[1];

  Object(__WEBPACK_IMPORTED_MODULE_9_react__["useEffect"])(function () {
    if (!ulElement || ulElement.offsetHeight >= ulElement.scrollHeight || !scrollFocusedIntoView) {
      return;
    }

    var scrollTop = ulElement.scrollTop;

    var _ulElement$children$f = ulElement.children[focusIndex].getBoundingClientRect(),
        top = _ulElement$children$f.top,
        bottom = _ulElement$children$f.bottom;

    var _ulElement$getBoundin = ulElement.getBoundingClientRect(),
        topContainer = _ulElement$getBoundin.top;

    top = top - topContainer + scrollTop;
    bottom = bottom - topContainer + scrollTop;

    if (top < scrollTop) {
      ulElement.scrollTop = top;
    } else if (bottom > ulElement.offsetHeight) {
      ulElement.scrollTop = bottom - ulElement.offsetHeight;
    }
  }, [focusIndex, scrollFocusedIntoView, ulElement]);

  var renderSuggestions = function renderSuggestions() {
    var suggestionsToRender = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      ref: setUlElement,
      id: id,
      role: "listbox",
      "aria-label": a11ySuggestionsListLabel
    }, style('list')), Object.values(suggestions).reduce(function (accResults, _ref2) {
      var results = _ref2.results,
          queryInfo = _ref2.queryInfo;
      return [].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(accResults), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(results.map(function (result, index) {
        return renderSuggestion(result, queryInfo, accResults.length + index);
      })));
    }, []));
    if (customSuggestionsContainer) return customSuggestionsContainer(suggestionsToRender);
    return suggestionsToRender;
  };

  var renderSuggestion = function renderSuggestion(result, queryInfo, index) {
    var isFocused = index === focusIndex;
    var childIndex = queryInfo.childIndex,
        query = queryInfo.query;
    var renderSuggestion = __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children)[childIndex].props.renderSuggestion;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Suggestion$1, {
      style: style('item'),
      key: "".concat(childIndex, "-").concat(getID(result)),
      id: getSuggestionHtmlId(id, index),
      query: query,
      index: index,
      ignoreAccents: ignoreAccents,
      renderSuggestion: renderSuggestion,
      suggestion: result,
      focused: isFocused,
      onClick: function onClick() {
        return select(result, queryInfo);
      },
      onMouseEnter: function onMouseEnter() {
        return handleMouseEnter(index);
      }
    });
  };

  var renderLoadingIndicator = function renderLoadingIndicator() {
    if (!isLoading) {
      return;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(LoadingIndicator, {
      style: style('loadingIndicator')
    });
  };

  var handleMouseEnter = function handleMouseEnter(index, ev) {
    if (onMouseEnter) {
      onMouseEnter(index);
    }
  };

  var select = function select(suggestion, queryInfo) {
    onSelect(suggestion, queryInfo);
  };

  var getID = function getID(suggestion) {
    if (typeof suggestion === 'string') {
      return suggestion;
    }

    return suggestion.id;
  };

  if (!isOpened) {
    return null;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_13_substyle__["b" /* inline */])({
    position: position || 'absolute',
    left: left,
    right: right,
    top: top
  }, style), {
    onMouseDown: onMouseDown,
    ref: containerRef
  }), renderSuggestions(), renderLoadingIndicator());
}

SuggestionsOverlay.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string.isRequired,
  suggestions: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object.isRequired,
  a11ySuggestionsListLabel: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,
  focusIndex: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number,
  position: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,
  left: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number,
  right: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number,
  top: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number,
  scrollFocusedIntoView: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool,
  isLoading: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool,
  isOpened: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool.isRequired,
  onSelect: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,
  ignoreAccents: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool,
  customSuggestionsContainer: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,
  containerRef: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.shape({
    current: typeof Element === 'undefined' ? __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.any : __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.instanceOf(Element)
  })])
};
var styled$2 = createDefaultStyle({
  zIndex: 1,
  backgroundColor: 'white',
  marginTop: 14,
  minWidth: 100,
  list: {
    margin: 0,
    padding: 0,
    listStyleType: 'none'
  }
});
var SuggestionsOverlay$1 = styled$2(SuggestionsOverlay);

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var makeTriggerRegex = function makeTriggerRegex(trigger) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (trigger instanceof RegExp) {
    return trigger;
  } else {
    var allowSpaceInQuery = options.allowSpaceInQuery;
    var escapedTriggerChar = escapeRegex(trigger); // first capture group is the part to be replaced on completion
    // second capture group is for extracting the search query

    return new RegExp("(?:^|\\s)(".concat(escapedTriggerChar, "([^").concat(allowSpaceInQuery ? '' : '\\s').concat(escapedTriggerChar, "]*))$"));
  }
};

var getDataProvider = function getDataProvider(data, ignoreAccents) {
  if (data instanceof Array) {
    // if data is an array, create a function to query that
    return function (query, callback) {
      var results = [];

      for (var i = 0, l = data.length; i < l; ++i) {
        var display = data[i].display || data[i].id;

        if (getSubstringIndex(display, query, ignoreAccents) >= 0) {
          results.push(data[i]);
        }
      }

      return results;
    };
  } else {
    // expect data to be a query function
    return data;
  }
};

var KEY = {
  TAB: 9,
  RETURN: 13,
  ESC: 27,
  UP: 38,
  DOWN: 40
};
var isComposing = false;
var propTypes = {
  /**
   * If set to `true` a regular text input element will be rendered
   * instead of a textarea
   */
  singleLine: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool,
  allowSpaceInQuery: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool,
  allowSuggestionsAboveCursor: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool,
  forceSuggestionsAboveCursor: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool,
  ignoreAccents: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool,
  a11ySuggestionsListLabel: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,
  customSuggestionsContainer: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,
  suggestionsPortalHost: typeof Element === 'undefined' ? __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.any : __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.PropTypes.instanceOf(Element),
  inputRef: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.shape({
    current: typeof Element === 'undefined' ? __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.any : __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.instanceOf(Element)
  })]),
  children: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.element)]).isRequired
};

var MentionsInput = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(MentionsInput, _React$Component);

  var _super = _createSuper(MentionsInput);

  function MentionsInput(_props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MentionsInput);

    _this = _super.call(this, _props);

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "setContainerElement", function (el) {
      _this.containerElement = el;
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "getInputProps", function () {
      var _this$props = _this.props,
          readOnly = _this$props.readOnly,
          disabled = _this$props.disabled,
          style = _this$props.style; // pass all props that neither we, nor substyle, consume through to the input control

      var props = omit(_this.props, ['style', 'classNames', 'className'], // substyle props
      keys(propTypes));
      return _objectSpread$1(_objectSpread$1(_objectSpread$1(_objectSpread$1({}, props), style('input')), {}, {
        value: _this.getPlainText(),
        onScroll: _this.updateHighlighterScroll
      }, !readOnly && !disabled && {
        onChange: _this.handleChange,
        onSelect: _this.handleSelect,
        onKeyDown: _this.handleKeyDown,
        onBlur: _this.handleBlur,
        onCompositionStart: _this.handleCompositionStart,
        onCompositionEnd: _this.handleCompositionEnd
      }), _this.isOpened() && {
        role: 'combobox',
        'aria-controls': _this.uuidSuggestionsOverlay,
        'aria-expanded': true,
        'aria-autocomplete': 'list',
        'aria-haspopup': 'listbox',
        'aria-activedescendant': getSuggestionHtmlId(_this.uuidSuggestionsOverlay, _this.state.focusIndex)
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "renderControl", function () {
      var _this$props2 = _this.props,
          singleLine = _this$props2.singleLine,
          style = _this$props2.style;

      var inputProps = _this.getInputProps();

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", style('control'), _this.renderHighlighter(), singleLine ? _this.renderInput(inputProps) : _this.renderTextarea(inputProps));
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "renderInput", function (props) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        type: "text",
        ref: _this.setInputRef
      }, props));
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "renderTextarea", function (props) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("textarea", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: _this.setInputRef
      }, props));
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "setInputRef", function (el) {
      _this.inputElement = el;
      var inputRef = _this.props.inputRef;

      if (typeof inputRef === 'function') {
        inputRef(el);
      } else if (inputRef) {
        inputRef.current = el;
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "setSuggestionsElement", function (el) {
      _this.suggestionsElement = el;
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "renderSuggestionsOverlay", function () {
      if (!isNumber(_this.state.selectionStart)) {
        // do not show suggestions when the input does not have the focus
        return null;
      }

      var _this$state$suggestio = _this.state.suggestionsPosition,
          position = _this$state$suggestio.position,
          left = _this$state$suggestio.left,
          top = _this$state$suggestio.top,
          right = _this$state$suggestio.right;
      var suggestionsNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(SuggestionsOverlay$1, {
        id: _this.uuidSuggestionsOverlay,
        style: _this.props.style('suggestions'),
        position: position,
        left: left,
        top: top,
        right: right,
        focusIndex: _this.state.focusIndex,
        scrollFocusedIntoView: _this.state.scrollFocusedIntoView,
        containerRef: _this.setSuggestionsElement,
        suggestions: _this.state.suggestions,
        customSuggestionsContainer: _this.props.customSuggestionsContainer,
        onSelect: _this.addMention,
        onMouseDown: _this.handleSuggestionsMouseDown,
        onMouseEnter: _this.handleSuggestionsMouseEnter,
        isLoading: _this.isLoading(),
        isOpened: _this.isOpened(),
        ignoreAccents: _this.props.ignoreAccents,
        a11ySuggestionsListLabel: _this.props.a11ySuggestionsListLabel
      }, _this.props.children);

      if (_this.props.suggestionsPortalHost) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react_dom___default.a.createPortal(suggestionsNode, _this.props.suggestionsPortalHost);
      } else {
        return suggestionsNode;
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "renderHighlighter", function () {
      var _this$state = _this.state,
          selectionStart = _this$state.selectionStart,
          selectionEnd = _this$state.selectionEnd;
      var _this$props3 = _this.props,
          singleLine = _this$props3.singleLine,
          children = _this$props3.children,
          value = _this$props3.value,
          style = _this$props3.style;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Highlighter$1, {
        containerRef: _this.setHighlighterElement,
        style: style('highlighter'),
        value: value,
        singleLine: singleLine,
        selectionStart: selectionStart,
        selectionEnd: selectionEnd,
        onCaretPositionChange: _this.handleCaretPositionChange
      }, children);
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "setHighlighterElement", function (el) {
      _this.highlighterElement = el;
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "handleCaretPositionChange", function (position) {
      _this.setState({
        caretPosition: position
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "getPlainText", function () {
      return getPlainText(_this.props.value || '', readConfigFromChildren(_this.props.children));
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "executeOnChange", function (event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (_this.props.onChange) {
        var _this$props4;

        return (_this$props4 = _this.props).onChange.apply(_this$props4, [event].concat(args));
      }

      if (_this.props.valueLink) {
        var _this$props$valueLink;

        return (_this$props$valueLink = _this.props.valueLink).requestChange.apply(_this$props$valueLink, [event.target.value].concat(args));
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "handleChange", function (ev) {
      isComposing = false;

      if (isIE()) {
        // if we are inside iframe, we need to find activeElement within its contentDocument
        var currentDocument = document.activeElement && document.activeElement.contentDocument || document;

        if (currentDocument.activeElement !== ev.target) {
          // fix an IE bug (blur from empty input element with placeholder attribute trigger "input" event)
          return;
        }
      }

      var value = _this.props.value || '';
      var config = readConfigFromChildren(_this.props.children);
      var newPlainTextValue = ev.target.value;
      var selectionStartBefore = _this.state.selectionStart;

      if (selectionStartBefore == null) {
        selectionStartBefore = ev.target.selectionStart;
      }

      var selectionEndBefore = _this.state.selectionEnd;

      if (selectionEndBefore == null) {
        selectionEndBefore = ev.target.selectionEnd;
      } // Derive the new value to set by applying the local change in the textarea's plain text


      var newValue = applyChangeToValue(value, newPlainTextValue, {
        selectionStartBefore: selectionStartBefore,
        selectionEndBefore: selectionEndBefore,
        selectionEndAfter: ev.target.selectionEnd
      }, config); // In case a mention is deleted, also adjust the new plain text value

      newPlainTextValue = getPlainText(newValue, config); // Save current selection after change to be able to restore caret position after rerendering

      var selectionStart = ev.target.selectionStart;
      var selectionEnd = ev.target.selectionEnd;
      var setSelectionAfterMentionChange = false; // Adjust selection range in case a mention will be deleted by the characters outside of the
      // selection range that are automatically deleted

      var startOfMention = findStartOfMentionInPlainText(value, config, selectionStart);

      if (startOfMention !== undefined && _this.state.selectionEnd > startOfMention) {
        // only if a deletion has taken place
        selectionStart = startOfMention + (ev.nativeEvent.data ? ev.nativeEvent.data.length : 0);
        selectionEnd = selectionStart;
        setSelectionAfterMentionChange = true;
      }

      _this.setState({
        selectionStart: selectionStart,
        selectionEnd: selectionEnd,
        setSelectionAfterMentionChange: setSelectionAfterMentionChange
      });

      var mentions = getMentions(newValue, config);

      if (ev.nativeEvent.isComposing && selectionStart === selectionEnd) {
        _this.updateMentionsQueries(_this.inputElement.value, selectionStart);
      } // Propagate change
      // let handleChange = this.getOnChange(this.props) || emptyFunction;


      var eventMock = {
        target: {
          value: newValue
        }
      }; // this.props.onChange.call(this, eventMock, newValue, newPlainTextValue, mentions);

      _this.executeOnChange(eventMock, newValue, newPlainTextValue, mentions);
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "handleSelect", function (ev) {
      // keep track of selection range / caret position
      _this.setState({
        selectionStart: ev.target.selectionStart,
        selectionEnd: ev.target.selectionEnd
      }); // do nothing while a IME composition session is active


      if (isComposing) return; // refresh suggestions queries

      var el = _this.inputElement;

      if (ev.target.selectionStart === ev.target.selectionEnd) {
        _this.updateMentionsQueries(el.value, ev.target.selectionStart);
      } else {
        _this.clearSuggestions();
      } // sync highlighters scroll position


      _this.updateHighlighterScroll();

      _this.props.onSelect(ev);
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "handleKeyDown", function (ev) {
      // do not intercept key events if the suggestions overlay is not shown
      var suggestionsCount = countSuggestions(_this.state.suggestions);

      if (suggestionsCount === 0 || !_this.suggestionsElement) {
        _this.props.onKeyDown(ev);

        return;
      }

      if (Object.values(KEY).indexOf(ev.keyCode) >= 0) {
        ev.preventDefault();
        ev.stopPropagation();
      }

      switch (ev.keyCode) {
        case KEY.ESC:
          {
            _this.clearSuggestions();

            return;
          }

        case KEY.DOWN:
          {
            _this.shiftFocus(+1);

            return;
          }

        case KEY.UP:
          {
            _this.shiftFocus(-1);

            return;
          }

        case KEY.RETURN:
          {
            _this.selectFocused();

            return;
          }

        case KEY.TAB:
          {
            _this.selectFocused();

            return;
          }

        default:
          {
            return;
          }
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "shiftFocus", function (delta) {
      var suggestionsCount = countSuggestions(_this.state.suggestions);

      _this.setState({
        focusIndex: (suggestionsCount + _this.state.focusIndex + delta) % suggestionsCount,
        scrollFocusedIntoView: true
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "selectFocused", function () {
      var _this$state2 = _this.state,
          suggestions = _this$state2.suggestions,
          focusIndex = _this$state2.focusIndex;
      var _Object$values$reduce = Object.values(suggestions).reduce(function (acc, _ref) {
        var results = _ref.results,
            queryInfo = _ref.queryInfo;
        return [].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(acc), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(results.map(function (result) {
          return {
            result: result,
            queryInfo: queryInfo
          };
        })));
      }, [])[focusIndex],
          result = _Object$values$reduce.result,
          queryInfo = _Object$values$reduce.queryInfo;

      _this.addMention(result, queryInfo);

      _this.setState({
        focusIndex: 0
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "handleBlur", function (ev) {
      var clickedSuggestion = _this._suggestionsMouseDown;
      _this._suggestionsMouseDown = false; // only reset selection if the mousedown happened on an element
      // other than the suggestions overlay

      if (!clickedSuggestion) {
        _this.setState({
          selectionStart: null,
          selectionEnd: null
        });
      }

      window.setTimeout(function () {
        _this.updateHighlighterScroll();
      }, 1);

      _this.props.onBlur(ev, clickedSuggestion);
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "handleSuggestionsMouseDown", function (ev) {
      _this._suggestionsMouseDown = true;
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "handleSuggestionsMouseEnter", function (focusIndex) {
      _this.setState({
        focusIndex: focusIndex,
        scrollFocusedIntoView: false
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "updateSuggestionsPosition", function () {
      var caretPosition = _this.state.caretPosition;
      var _this$props5 = _this.props,
          suggestionsPortalHost = _this$props5.suggestionsPortalHost,
          allowSuggestionsAboveCursor = _this$props5.allowSuggestionsAboveCursor,
          forceSuggestionsAboveCursor = _this$props5.forceSuggestionsAboveCursor;

      if (!caretPosition || !_this.suggestionsElement) {
        return;
      }

      var suggestions = _this.suggestionsElement;
      var highlighter = _this.highlighterElement; // first get viewport-relative position (highlighter is offsetParent of caret):

      var caretOffsetParentRect = highlighter.getBoundingClientRect();
      var caretHeight = getComputedStyleLengthProp(highlighter, 'font-size');
      var viewportRelative = {
        left: caretOffsetParentRect.left + caretPosition.left,
        top: caretOffsetParentRect.top + caretPosition.top + caretHeight
      };
      var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

      if (!suggestions) {
        return;
      }

      var position = {}; // if suggestions menu is in a portal, update position to be releative to its portal node

      if (suggestionsPortalHost) {
        position.position = 'fixed';
        var left = viewportRelative.left;
        var top = viewportRelative.top; // absolute/fixed positioned elements are positioned according to their entire box including margins; so we remove margins here:

        left -= getComputedStyleLengthProp(suggestions, 'margin-left');
        top -= getComputedStyleLengthProp(suggestions, 'margin-top'); // take into account highlighter/textinput scrolling:

        left -= highlighter.scrollLeft;
        top -= highlighter.scrollTop; // guard for mentions suggestions list clipped by right edge of window

        var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        if (left + suggestions.offsetWidth > viewportWidth) {
          position.left = Math.max(0, viewportWidth - suggestions.offsetWidth);
        } else {
          position.left = left;
        } // guard for mentions suggestions list clipped by bottom edge of window if allowSuggestionsAboveCursor set to true.
        // Move the list up above the caret if it's getting cut off by the bottom of the window, provided that the list height
        // is small enough to NOT cover up the caret


        if (allowSuggestionsAboveCursor && top + suggestions.offsetHeight > viewportHeight && suggestions.offsetHeight < top - caretHeight || forceSuggestionsAboveCursor) {
          position.top = Math.max(0, top - suggestions.offsetHeight - caretHeight);
        } else {
          position.top = top;
        }
      } else {
        var _left = caretPosition.left - highlighter.scrollLeft;

        var _top = caretPosition.top - highlighter.scrollTop; // guard for mentions suggestions list clipped by right edge of window


        if (_left + suggestions.offsetWidth > _this.containerElement.offsetWidth) {
          position.right = 0;
        } else {
          position.left = _left;
        } // guard for mentions suggestions list clipped by bottom edge of window if allowSuggestionsAboveCursor set to true.
        // move the list up above the caret if it's getting cut off by the bottom of the window, provided that the list height
        // is small enough to NOT cover up the caret


        if (allowSuggestionsAboveCursor && viewportRelative.top - highlighter.scrollTop + suggestions.offsetHeight > viewportHeight && suggestions.offsetHeight < caretOffsetParentRect.top - caretHeight - highlighter.scrollTop || forceSuggestionsAboveCursor) {
          position.top = _top - suggestions.offsetHeight - caretHeight;
        } else {
          position.top = _top;
        }
      }

      if (position.left === _this.state.suggestionsPosition.left && position.top === _this.state.suggestionsPosition.top && position.position === _this.state.suggestionsPosition.position) {
        return;
      }

      _this.setState({
        suggestionsPosition: position
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "updateHighlighterScroll", function () {
      var input = _this.inputElement;
      var highlighter = _this.highlighterElement;

      if (!input || !highlighter) {
        // since the invocation of this function is deferred,
        // the whole component may have been unmounted in the meanwhile
        return;
      }

      highlighter.scrollLeft = input.scrollLeft;
      highlighter.scrollTop = input.scrollTop;
      highlighter.height = input.height;
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "handleCompositionStart", function () {
      isComposing = true;
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "handleCompositionEnd", function () {
      isComposing = false;
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "setSelection", function (selectionStart, selectionEnd) {
      if (selectionStart === null || selectionEnd === null) return;
      var el = _this.inputElement;

      if (el.setSelectionRange) {
        el.setSelectionRange(selectionStart, selectionEnd);
      } else if (el.createTextRange) {
        var range = el.createTextRange();
        range.collapse(true);
        range.moveEnd('character', selectionEnd);
        range.moveStart('character', selectionStart);
        range.select();
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "updateMentionsQueries", function (plainTextValue, caretPosition) {
      // Invalidate previous queries. Async results for previous queries will be neglected.
      _this._queryId++;
      _this.suggestions = {};

      _this.setState({
        suggestions: {}
      });

      var value = _this.props.value || '';
      var children = _this.props.children;
      var config = readConfigFromChildren(children);
      var positionInValue = mapPlainTextIndex(value, config, caretPosition, 'NULL'); // If caret is inside of mention, do not query

      if (positionInValue === null) {
        return;
      } // Extract substring in between the end of the previous mention and the caret


      var substringStartIndex = getEndOfLastMention(value.substring(0, positionInValue), config);
      var substring = plainTextValue.substring(substringStartIndex, caretPosition); // Check if suggestions have to be shown:
      // Match the trigger patterns of all Mention children on the extracted substring

      __WEBPACK_IMPORTED_MODULE_9_react___default.a.Children.forEach(children, function (child, childIndex) {
        if (!child) {
          return;
        }

        var regex = makeTriggerRegex(child.props.trigger, _this.props);
        var match = substring.match(regex);

        if (match) {
          var querySequenceStart = substringStartIndex + substring.indexOf(match[1], match.index);

          _this.queryData(match[2], childIndex, querySequenceStart, querySequenceStart + match[1].length, plainTextValue);
        }
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "clearSuggestions", function () {
      // Invalidate previous queries. Async results for previous queries will be neglected.
      _this._queryId++;
      _this.suggestions = {};

      _this.setState({
        suggestions: {},
        focusIndex: 0
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "queryData", function (query, childIndex, querySequenceStart, querySequenceEnd, plainTextValue) {
      var _this$props6 = _this.props,
          children = _this$props6.children,
          ignoreAccents = _this$props6.ignoreAccents;
      var mentionChild = __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children)[childIndex];
      var provideData = getDataProvider(mentionChild.props.data, ignoreAccents);
      var syncResult = provideData(query, _this.updateSuggestions.bind(null, _this._queryId, childIndex, query, querySequenceStart, querySequenceEnd, plainTextValue));

      if (syncResult instanceof Array) {
        _this.updateSuggestions(_this._queryId, childIndex, query, querySequenceStart, querySequenceEnd, plainTextValue, syncResult);
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "updateSuggestions", function (queryId, childIndex, query, querySequenceStart, querySequenceEnd, plainTextValue, results) {
      // neglect async results from previous queries
      if (queryId !== _this._queryId) return; // save in property so that multiple sync state updates from different mentions sources
      // won't overwrite each other

      _this.suggestions = _objectSpread$1(_objectSpread$1({}, _this.suggestions), {}, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, childIndex, {
        queryInfo: {
          childIndex: childIndex,
          query: query,
          querySequenceStart: querySequenceStart,
          querySequenceEnd: querySequenceEnd,
          plainTextValue: plainTextValue
        },
        results: results
      }));
      var focusIndex = _this.state.focusIndex;
      var suggestionsCount = countSuggestions(_this.suggestions);

      _this.setState({
        suggestions: _this.suggestions,
        focusIndex: focusIndex >= suggestionsCount ? Math.max(suggestionsCount - 1, 0) : focusIndex
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "addMention", function (_ref2, _ref3) {
      var id = _ref2.id,
          display = _ref2.display;
      var childIndex = _ref3.childIndex,
          querySequenceStart = _ref3.querySequenceStart,
          querySequenceEnd = _ref3.querySequenceEnd,
          plainTextValue = _ref3.plainTextValue;
      // Insert mention in the marked up value at the correct position
      var value = _this.props.value || '';
      var config = readConfigFromChildren(_this.props.children);
      var mentionsChild = __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(_this.props.children)[childIndex];
      var _mentionsChild$props = mentionsChild.props,
          markup = _mentionsChild$props.markup,
          displayTransform = _mentionsChild$props.displayTransform,
          appendSpaceOnAdd = _mentionsChild$props.appendSpaceOnAdd,
          onAdd = _mentionsChild$props.onAdd;
      var start = mapPlainTextIndex(value, config, querySequenceStart, 'START');
      var end = start + querySequenceEnd - querySequenceStart;
      var insert = makeMentionsMarkup(markup, id, display);

      if (appendSpaceOnAdd) {
        insert += ' ';
      }

      var newValue = spliceString(value, start, end, insert); // Refocus input and set caret position to end of mention

      _this.inputElement.focus();

      var displayValue = displayTransform(id, display);

      if (appendSpaceOnAdd) {
        displayValue += ' ';
      }

      var newCaretPosition = querySequenceStart + displayValue.length;

      _this.setState({
        selectionStart: newCaretPosition,
        selectionEnd: newCaretPosition,
        setSelectionAfterMentionChange: true
      }); // Propagate change


      var eventMock = {
        target: {
          value: newValue
        }
      };
      var mentions = getMentions(newValue, config);
      var newPlainTextValue = spliceString(plainTextValue, querySequenceStart, querySequenceEnd, displayValue);

      _this.executeOnChange(eventMock, newValue, newPlainTextValue, mentions);

      if (onAdd) {
        onAdd(id, display, start, end);
      } // Make sure the suggestions overlay is closed


      _this.clearSuggestions();
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "isLoading", function () {
      var isLoading = false;
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.Children.forEach(_this.props.children, function (child) {
        isLoading = isLoading || child && child.props.isLoading;
      });
      return isLoading;
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "isOpened", function () {
      return isNumber(_this.state.selectionStart) && (countSuggestions(_this.state.suggestions) !== 0 || _this.isLoading());
    });

    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "_queryId", 0);

    _this.suggestions = {};
    _this.uuidSuggestionsOverlay = Math.random().toString(16).substring(2);
    _this.handleCopy = _this.handleCopy.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    _this.handleCut = _this.handleCut.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    _this.handlePaste = _this.handlePaste.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    _this.state = {
      focusIndex: 0,
      selectionStart: null,
      selectionEnd: null,
      suggestions: {},
      caretPosition: null,
      suggestionsPosition: {},
      setSelectionAfterHandlePaste: false
    };
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(MentionsInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('copy', this.handleCopy);
      document.addEventListener('cut', this.handleCut);
      document.addEventListener('paste', this.handlePaste);
      this.updateSuggestionsPosition();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // Update position of suggestions unless this componentDidUpdate was
      // triggered by an update to suggestionsPosition.
      if (prevState.suggestionsPosition === this.state.suggestionsPosition) {
        this.updateSuggestionsPosition();
      } // maintain selection in case a mention is added/removed causing
      // the cursor to jump to the end


      if (this.state.setSelectionAfterMentionChange) {
        this.setState({
          setSelectionAfterMentionChange: false
        });
        this.setSelection(this.state.selectionStart, this.state.selectionEnd);
      }

      if (this.state.setSelectionAfterHandlePaste) {
        this.setState({
          setSelectionAfterHandlePaste: false
        });
        this.setSelection(this.state.selectionStart, this.state.selectionEnd);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('copy', this.handleCopy);
      document.removeEventListener('cut', this.handleCut);
      document.removeEventListener('paste', this.handlePaste);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: this.setContainerElement
      }, this.props.style), this.renderControl(), this.renderSuggestionsOverlay());
    }
  }, {
    key: "handlePaste",
    value: function handlePaste(event) {
      if (event.target !== this.inputElement) {
        return;
      }

      if (!this.supportsClipboardActions(event)) {
        return;
      }

      event.preventDefault();
      var _this$state3 = this.state,
          selectionStart = _this$state3.selectionStart,
          selectionEnd = _this$state3.selectionEnd;
      var _this$props7 = this.props,
          value = _this$props7.value,
          children = _this$props7.children;
      var config = readConfigFromChildren(children);
      var markupStartIndex = mapPlainTextIndex(value, config, selectionStart, 'START');
      var markupEndIndex = mapPlainTextIndex(value, config, selectionEnd, 'END');
      var pastedMentions = event.clipboardData.getData('text/react-mentions');
      var pastedData = event.clipboardData.getData('text/plain');
      var newValue = spliceString(value, markupStartIndex, markupEndIndex, pastedMentions || pastedData).replace(/\r/g, '');
      var newPlainTextValue = getPlainText(newValue, config);
      var eventMock = {
        target: _objectSpread$1(_objectSpread$1({}, event.target), {}, {
          value: newValue
        })
      };
      this.executeOnChange(eventMock, newValue, newPlainTextValue, getMentions(newValue, config)); // Move the cursor position to the end of the pasted data

      var startOfMention = findStartOfMentionInPlainText(value, config, selectionStart);
      var nextPos = (startOfMention || selectionStart) + getPlainText(pastedMentions || pastedData, config).length;
      this.setState({
        selectionStart: nextPos,
        selectionEnd: nextPos,
        setSelectionAfterHandlePaste: true
      });
    }
  }, {
    key: "saveSelectionToClipboard",
    value: function saveSelectionToClipboard(event) {
      // use the actual selectionStart & selectionEnd instead of the one stored
      // in state to ensure copy & paste also works on disabled inputs & textareas
      var selectionStart = this.inputElement.selectionStart;
      var selectionEnd = this.inputElement.selectionEnd;
      var _this$props8 = this.props,
          children = _this$props8.children,
          value = _this$props8.value;
      var config = readConfigFromChildren(children);
      var markupStartIndex = mapPlainTextIndex(value, config, selectionStart, 'START');
      var markupEndIndex = mapPlainTextIndex(value, config, selectionEnd, 'END');
      event.clipboardData.setData('text/plain', event.target.value.slice(selectionStart, selectionEnd));
      event.clipboardData.setData('text/react-mentions', value.slice(markupStartIndex, markupEndIndex));
    }
  }, {
    key: "supportsClipboardActions",
    value: function supportsClipboardActions(event) {
      return !!event.clipboardData;
    }
  }, {
    key: "handleCopy",
    value: function handleCopy(event) {
      if (event.target !== this.inputElement) {
        return;
      }

      if (!this.supportsClipboardActions(event)) {
        return;
      }

      event.preventDefault();
      this.saveSelectionToClipboard(event);
    }
  }, {
    key: "handleCut",
    value: function handleCut(event) {
      if (event.target !== this.inputElement) {
        return;
      }

      if (!this.supportsClipboardActions(event)) {
        return;
      }

      event.preventDefault();
      this.saveSelectionToClipboard(event);
      var _this$state4 = this.state,
          selectionStart = _this$state4.selectionStart,
          selectionEnd = _this$state4.selectionEnd;
      var _this$props9 = this.props,
          children = _this$props9.children,
          value = _this$props9.value;
      var config = readConfigFromChildren(children);
      var markupStartIndex = mapPlainTextIndex(value, config, selectionStart, 'START');
      var markupEndIndex = mapPlainTextIndex(value, config, selectionEnd, 'END');
      var newValue = [value.slice(0, markupStartIndex), value.slice(markupEndIndex)].join('');
      var newPlainTextValue = getPlainText(newValue, config);
      var eventMock = {
        target: _objectSpread$1(_objectSpread$1({}, event.target), {}, {
          value: newPlainTextValue
        })
      };
      this.executeOnChange(eventMock, newValue, newPlainTextValue, getMentions(value, config));
    } // Handle input element's change event

  }]);

  return MentionsInput;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
/**
 * Returns the computed length property value for the provided element.
 * Note: According to spec and testing, can count on length values coming back in pixels. See https://developer.mozilla.org/en-US/docs/Web/CSS/used_value#Difference_from_computed_value
 */


Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(MentionsInput, "propTypes", propTypes);

Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(MentionsInput, "defaultProps", {
  ignoreAccents: false,
  singleLine: false,
  allowSuggestionsAboveCursor: false,
  onKeyDown: function onKeyDown() {
    return null;
  },
  onSelect: function onSelect() {
    return null;
  },
  onBlur: function onBlur() {
    return null;
  }
});

var getComputedStyleLengthProp = function getComputedStyleLengthProp(forElement, propertyName) {
  var length = parseFloat(window.getComputedStyle(forElement, null).getPropertyValue(propertyName));
  return isFinite(length) ? length : 0;
};

var isMobileSafari = typeof navigator !== 'undefined' && /iPhone|iPad|iPod/i.test(navigator.userAgent);
var styled$3 = createDefaultStyle({
  position: 'relative',
  overflowY: 'visible',
  input: {
    display: 'block',
    width: '100%',
    position: 'absolute',
    margin: 0,
    top: 0,
    left: 0,
    boxSizing: 'border-box',
    backgroundColor: 'transparent',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    letterSpacing: 'inherit'
  },
  '&multiLine': {
    input: _objectSpread$1({
      height: '100%',
      bottom: 0,
      overflow: 'hidden',
      resize: 'none'
    }, isMobileSafari ? {
      marginTop: 1,
      marginLeft: -3
    } : null)
  }
}, function (_ref4) {
  var singleLine = _ref4.singleLine;
  return {
    '&singleLine': singleLine,
    '&multiLine': !singleLine
  };
});
var MentionsInput$1 = styled$3(MentionsInput);

var defaultStyle = {
  fontWeight: 'inherit'
};

var Mention = function Mention(_ref) {
  var display = _ref.display,
      style = _ref.style,
      className = _ref.className,
      classNames = _ref.classNames;
  var styles = Object(__WEBPACK_IMPORTED_MODULE_13_substyle__["a" /* default */])(defaultStyle, {
    style: style,
    className: className,
    classNames: classNames
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("strong", styles, display);
};

Mention.propTypes = {
  /**
   * Called when a new mention is added in the input
   *
   * Example:
   *
   * ```js
   * function(id, display) {
   *   console.log("user " + display + " was mentioned!");
   * }
   * ```
   */
  onAdd: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,
  onRemove: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,
  renderSuggestion: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,
  trigger: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.instanceOf(RegExp)]),
  markup: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,
  displayTransform: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,

  /**
   * If set to `true` spaces will not interrupt matching suggestions
   */
  allowSpaceInQuery: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool,
  isLoading: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool
};
Mention.defaultProps = {
  trigger: '@',
  markup: '@[__display__](__id__)',
  displayTransform: function displayTransform(id, display) {
    return display || id;
  },
  onAdd: function onAdd() {
    return null;
  },
  onRemove: function onRemove() {
    return null;
  },
  renderSuggestion: null,
  isLoading: false,
  appendSpaceOnAdd: false
};




/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({control:{backgroundColor:"#fff",fontSize:14,fontWeight:"normal"},"&multiLine":{control:{fontFamily:"monospace",minHeight:63},highlighter:{padding:9,border:"1px solid transparent"},input:{padding:9,border:"1px solid silver"}},"&singleLine":{display:"inline-block",width:180,highlighter:{padding:1,border:"2px inset transparent"},input:{padding:1,border:"2px inset"}},suggestions:{list:{backgroundColor:"white",border:"1px solid rgba(0,0,0,0.15)",fontSize:14},item:{padding:"5px 15px",borderBottom:"1px solid rgba(0,0,0,0.15)","&focused":{backgroundColor:"#cee4e5"}}}});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({backgroundColor:"#cee4e5"});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__singlepost_css__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__singlepost_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__singlepost_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_mentions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__defaultStyle__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__defaultMentionStyle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MentionTextarea_css__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MentionTextarea_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__MentionTextarea_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_emoji_picker_react__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_emoji_picker_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_emoji_picker_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__followersUser_jsx__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__postSaveUser_jsx__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__getLikePostHome_jsx__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Leftsidebar_jsx__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__saveNotification_jsx__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Recipe from "./recipe.jsx";
//import Product from "./product.jsx";
//import Modaldata from "./Modaldata.jsx";
function time_ago(time){switch(typeof time==='undefined'?'undefined':_typeof(time)){case'number':break;case'string':time=+new Date(time);break;case'object':if(time.constructor===Date)time=time.getTime();break;default:time=+new Date();}var time_formats=[[60,'s',1],// 60
[120,'1m','1 minute from now'],// 60*2
[3600,'m',60],// 60*60, 60
[7200,'1h','1 hour from now'],// 60*60*2
[86400,'h',3600],// 60*60*24, 60*60
[172800,'1d','Tomorrow'],// 60*60*24*2
[604800,'d',86400],// 60*60*24*7, 60*60*24
[1209600,'1w','Next week'],// 60*60*24*7*4*2
[2419200,'w',604800],// 60*60*24*7*4, 60*60*24*7
[4838400,'1m','Next month'],// 60*60*24*7*4*2
[29030400,'m',2419200],// 60*60*24*7*4*12, 60*60*24*7*4
[58060800,'1y','Next year'],// 60*60*24*7*4*12*2
[2903040000,'y',29030400],// 60*60*24*7*4*12*100, 60*60*24*7*4*12
[5806080000,'Last century','Next century'],// 60*60*24*7*4*12*100*2
[58060800000,'centuries',2903040000]// 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
];var seconds=(+new Date()-time)/1000,token='',list_choice=1;if(seconds==0){return'';}if(seconds<0){seconds=Math.abs(seconds);//token = 'from now';
token='';list_choice=2;}var i=0,format;while(format=time_formats[i++]){if(seconds<format[0]){if(typeof format[2]=='string')return format[list_choice];else return Math.floor(seconds/format[2])+''+format[1]+''+token;}}return time;}var SinglePost=function(_React$Component){_inherits(SinglePost,_React$Component);function SinglePost(props){_classCallCheck(this,SinglePost);var _this=_possibleConstructorReturn(this,(SinglePost.__proto__||Object.getPrototypeOf(SinglePost)).call(this,props));_initialiseProps.call(_this);__WEBPACK_IMPORTED_MODULE_3_parse___default.a.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5","sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw");//PASTE HERE YOUR Back4App APPLICATION ID AND YOUR JavaScript KEY
__WEBPACK_IMPORTED_MODULE_3_parse___default.a.serverURL="https://parse.joelskitchen.com/parse";//Parse.serverURL = "https://parsetest.joelskitchen.com/parse";
var now=new Date();_this.state={postID:0,postData:null,created_at:now.getTime(),comments:null,postImage:null,userImage:null,user:null,caption:null,likeCount:0,saveCount:0,commentCount:0,recipe:null,product:null,city:null,postcomment:'',isChallenge:"0",CurrentSaveCount:0,currentuserImage:null,currentUserId:null,singlelikeCount:0,isExpanded:false,expandedCommentId:null,blank_comment_message:null,challengeStatus:null,singlementioned:'',singleget_allusers:[],linkdata:'',loadpage:'home',getUsernamefetch:null,usertype:0,popup_username:null,popup_comments:null,commentsdatas:[],likeCount1:0,likeuserlist:[],single_post_id:null,bufferdatalist:[],singlemodalstates:false,isPopupOpen:false,postDetails:null,loading:false,error:null,postDetailscomment:null,singlementioned_popup:'',singleget_allusers_popup:[],postcomment_popup:'',blank_comment_message_popup:null,followersListing:{},followinguserid:[],inputText:'',showPicker:false,reply_id:'',loadingdata:false,singlelikeCountChild:0,loader:false,reply_thread_id:'',followinglikeuserid:[],followerslikeListing:{},isHideEntry:0,isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''};//load vals from post objects
//temp cheese
var result=props.postData;//console.log("********************************");
// console.log("RESULT: ", JSON.stringify(result));
// console.log("USER: ", JSON.stringify(result.get("user")));
// console.log("================================");
// if (result.get("user") != undefined)
//  console.log("Username: ", result.get("user").get("displayUsername"));
// else
//   console.log("UNDEFINED USER");
if(result.get("image")){//console.log("Image: ", result.get("image").url());
_this.state.postImage=result.get("image").url();}if(result.get("isChallenge")){//console.log("Image: ", result.get("image").url());
_this.state.isChallenge=result.get("isChallenge");}_this.state.user=result.get("user");var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser!=null){if(currentUser.get("isCreator")!==undefined&&currentUser.get("isCreator")===1||currentUser.get("isBusiness")!==undefined&&currentUser.get("isBusiness")===1||currentUser.get("isAdmin")!==undefined&&currentUser.get("isAdmin")==="1"){_this.state.usertype=1;}}_this.state.username=result.get("user").get("displayUsername");//new code
if(_this.state.user){_this.state.getUsernamefetch=_this.state.username;if(!_this.state.getUsernamefetch||_this.state.getUsernamefetch.length<2){_this.state.getUsernamefetch=_this.state.user.get("firstName")+"_"+_this.state.user.get("lastName");_this.state.getUsernamefetch=_this.state.getUsernamefetch.toLowerCase(_this.state.getUsernamefetch);}}//new code
if(result.get("user").get("profilePictureSmall")){//console.log("User image: ", result.get("user").get("profilePictureSmall").url());
_this.state.userImage=result.get("user").get("profilePictureSmall").url();//console.log('profile  pic small');
// console.log(result.get("user").get("profilePictureSmall").url());
}else{_this.state.userImage="/images/default_userpic0.png";}_this.state.caption=result.get("caption");_this.state.created_at=result.get("createdAt");_this.state.city=result.get("user").get("city");var likeCount=result.get("likeCountNew");//var likeCount1 = result.get("likeCountNew");
var saveCount=result.get("saveCount");var commentCount=result.get("commentcount");var imprCount=result.get("impr");_this.state.title=result.get("title");_this.state.url=result.get("url");_this.state.collabUser=result.get("collabUser");_this.state.collabUsername=result.get("collabUsername");if(_this.state.collabUser){result.get("collabUser").fetch();}if(!likeCount)likeCount=0;if(!saveCount)saveCount=0;if(!commentCount)commentCount=0;if(!imprCount)imprCount=1;_this.state.likeCount=likeCount;_this.state.saveCount=saveCount;_this.state.commentCount=commentCount;_this.state.imprCount=imprCount;_this.state.postID=result.id;_this.state.challengeStatus=result.get("challengeStatus");_this.state.isChallengeEntry=result.get("isChallengeEntry");_this.state.isChallengeWinner=result.get("isChallengeWinner");_this.state.isRecipe=result.get("isRecipe");_this.state.challenge_id=result.get("challenge")?result.get("challenge").id:'';_this.state.barcolor=result.get("challenge")?result.get("challenge").get('barcolor')?result.get("challenge").get('barcolor'):'':'';_this.state.challengeentrystatus=result.get("challenge")?result.get("challenge").get('challengeStatus')?result.get("challenge").get('challengeStatus'):'':'';_this.state.postLink="/posts/"+_this.state.postID;_this.state.recipe=result.get("recipeV2");_this.state.product=result.get("productV2");_this.state.isHideEntry=result.get("hideEntry")?result.get("hideEntry"):'0';if(_this.props.showComments&&_this.state.recipe)_this.state.recipe.fetch();if(_this.props.showComments&&_this.state.product)_this.state.product.fetch();if(_this.props.showComments)//detail view only
{_this.queryForComments();_this.props.postData.increment("impr");_this.props.postData.save();_this.state.loadpage='single';_this.singlegetAllUsers();imprCount++;_this.props.postData.set("imprcount",imprCount);_this.props.postData.save();}//this.popuprenderComments()
_this.updateInput=_this.updateInput.bind(_this);_this.handleCommentPost=_this.handleCommentPost.bind(_this);_this.handleCommentPostUpdate=_this.handleCommentPostUpdate.bind(_this);_this.handleSavePost=_this.handleSavePost.bind(_this);// this.handleGetSavePost = this.handleGetSavePost.bind(this);
_this.handleFollowUser=_this.handleFollowUser.bind(_this);_this.handleUnFollowUser=_this.handleUnFollowUser.bind(_this);//this.handleGetFollowUser = this.handleGetFollowUser.bind(this); 
_this.cancelText=_this.cancelText.bind(_this);_this.getUserProfileImage();_this.handlePhotoLike=_this.handlePhotoLike.bind(_this);_this.formatRenderComments=_this.formatRenderComments.bind(_this);_this.handlePostModelOpen=_this.handlePostModelOpen.bind(_this);//this.handleGetLikePost = this.handleGetLikePost.bind(this);
_this.handlePhotoUnLike=_this.handlePhotoUnLike.bind(_this);_this.handlePhotoActivityLike=_this.handlePhotoActivityLike.bind(_this);_this.handleGetActivityLikePost=_this.handleGetActivityLikePost.bind(_this);_this.handlePhotoActivityUnLike=_this.handlePhotoActivityUnLike.bind(_this);_this.handleRemoveSavePost=_this.handleRemoveSavePost.bind(_this);_this.handleNotLoginClick=_this.handleNotLoginClick.bind(_this);_this.singlePostModalClass=_this.singlePostModalClass.bind(_this);_this.singlePostLikeModal=_this.singlePostLikeModal.bind(_this);_this.singlePostLikeModalClose=_this.singlePostLikeModalClose.bind(_this);_this.toggleExpand=_this.toggleExpand.bind(_this);_this.deleteCommentId=_this.deleteCommentId.bind(_this);_this.checkDeleteComment=_this.checkDeleteComment.bind(_this);_this.deletePostId=_this.deletePostId.bind(_this);_this.checkDeletePost=_this.checkDeletePost.bind(_this);_this.handleGetLikeUser=_this.handleGetLikeUser.bind(_this);_this.renderDetailPage=_this.renderDetailPage.bind(_this);_this.singlePostModalClose1=_this.singlePostModalClose1.bind(_this);_this.handleCommentPostPopup=_this.handleCommentPostPopup.bind(_this);_this.updateInputPopup=_this.updateInputPopup.bind(_this);_this.handleFollowMyProfile=_this.handleFollowMyProfile.bind(_this);_this.onEmojiClick=_this.onEmojiClick.bind(_this);_this.handlePhotoActivityLikeChild=_this.handlePhotoActivityLikeChild.bind(_this);_this.handleGetActivityLikePostChild=_this.handleGetActivityLikePostChild.bind(_this);_this.handlePhotoActivityUnLikeChild=_this.handlePhotoActivityUnLikeChild.bind(_this);_this.replyComment=_this.replyComment.bind(_this);_this.handleUnFollowMyProfile=_this.handleUnFollowMyProfile.bind(_this);_this.handleFollowMyProfileLike=_this.handleFollowMyProfileLike.bind(_this);_this.handleUnFollowMyProfileLike=_this.handleUnFollowMyProfileLike.bind(_this);//this.toggleNotification = this.toggleNotification.bind(this);
return _this;}_createClass(SinglePost,[{key:'componentDidMount',value:function componentDidMount(){// console.log('componentDidMount')
//this.fetchPostData();
//this.handleCommentPostUpdate();
}// Method to fetch post data from Parse
},{key:'faqOpenClose',value:function faqOpenClose(commentId){var commentIds=commentId.split('comnt_');var commenUpdatedId=commentIds[1];var self=this;var check=__WEBPACK_IMPORTED_MODULE_6_jquery___default()(".view_replies_comment .faq-drawer #faq-drawer-"+commenUpdatedId).is(":checked");if(check){__WEBPACK_IMPORTED_MODULE_6_jquery___default()(".view_replies_comment .faq-drawer label.faq-drawer__title span#faq-"+commenUpdatedId).html('Hide Replies');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.view_replies_comment .faq-drawer .faq-drawer__content-wrapper#fq-'+commenUpdatedId).addClass('active');}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()(".view_replies_comment .faq-drawer label.faq-drawer__title span#faq-"+commenUpdatedId).html('View Replies');if(__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.view_replies_comment .faq-drawer .faq-drawer__content-wrapper#fq-'+commenUpdatedId).hasClass("active")){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.view_replies_comment .faq-drawer .faq-drawer__content-wrapper#fq-'+commenUpdatedId).removeClass('active');}}}//handleCommentPostUpdate = function(e){
//  handleCommentPostUpdate  = () => {
// Method to handle closing the popup
},{key:'singlegetUsersCommentLike',value:function singlegetUsersCommentLike(post_id,main_activity_id){var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){//following
var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query.include("user");query.include("image");query.include("toUser");query.include("thumbnail");query.equalTo("type","follow");query.equalTo("fromUser",currentUser);var self=this;query.find().then(function(result){if(result){var resultcount=result.length;var followingdataresult1=[];if(resultcount>0){var userdataresult1=[];for(var i=0;i<resultcount;i++){var user=result[i];var userimage='';if(user.get("toUser").get("profilePictureSmall")&&user.get("toUser").get("profilePictureSmall").url()!==undefined){userimage=user.get("toUser").get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}//console.log(user.get("fromUser").id);
//console.log(user.get("toUser").id);
userdataresult1.push({'id':user.get("toUser").id,'displayName':user.get("toUser").get("displayName"),'displayUsername':user.get("toUser").get("displayUsername"),'image':userimage,'fromUser':user.get("fromUser").id});followingdataresult1.push({'id':user.get("toUser").id,'name':user.get("toUser").id});self.setState({followinglikeuserid:followingdataresult1});}}else{self.setState({followinglikeuserid:[]});}}});//followers 
var followersquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');followersquery.include("user");followersquery.include("fromUser");followersquery.include("image");followersquery.include("thumbnail");followersquery.doesNotExist("activity");followersquery.equalTo('activity',"Activity$"+main_activity_id);followersquery.equalTo('photo',"Photo$"+post_id);//followersquery.equalTo("fromUser", currentUser);
var self=this;followersquery.find().then(function(followerresult){if(followerresult){var resultcount=followerresult.length;if(followerresult.length>0){var userdataresult=[];//self.setState({followersListing:'followerresult'});
for(var i=0;i<resultcount;i++){var Images=null;var user=followerresult[i];if(user.get("fromUser").get("profilePictureSmall")&&user.get("fromUser").get("profilePictureSmall").url()!==undefined){Images=user.get("fromUser").get("profilePictureSmall").url();}userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});//self.setState({followersListing:resultcount});
}self.setState({followerslikeListing:userdataresult});}}});}else{var followersquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');followersquery.include("user");followersquery.include("fromUser");followersquery.include("image");followersquery.include("thumbnail");followersquery.doesNotExist("activity");followersquery.equalTo('activity',"Activity$"+main_activity_id);followersquery.equalTo('photo',"Photo$"+post_id);//followersquery.equalTo("fromUser", currentUser);
var self=this;followersquery.find().then(function(followerresult){if(followerresult){var resultcount=followerresult.length;if(resultcount>0){var userdataresult=[];//self.setState({followersListing:'followerresult'});
for(var i=0;i<resultcount;i++){var Images=null;var user=followerresult[i];if(user.get("fromUser").get("profilePictureSmall")&&user.get("fromUser").get("profilePictureSmall").url()!==undefined){Images=user.get("fromUser").get("profilePictureSmall").url();}userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});//self.setState({followersListing:resultcount});
}self.setState({followerslikeListing:userdataresult});}}});}}},{key:'singlegetUsersLike',value:function singlegetUsersLike(post_id){var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){//following
var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query.include("user");query.include("image");query.include("toUser");query.include("thumbnail");query.equalTo("type","follow");query.equalTo("fromUser",currentUser);var self=this;query.find().then(function(result){if(result){var resultcount=result.length;var followingdataresult1=[];if(resultcount>0){var userdataresult1=[];for(var i=0;i<resultcount;i++){var user=result[i];var userimage='';if(user.get("toUser").get("profilePictureSmall")&&user.get("toUser").get("profilePictureSmall").url()!==undefined){userimage=user.get("toUser").get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}//console.log(user.get("fromUser").id);
//console.log(user.get("toUser").id);
userdataresult1.push({'id':user.get("toUser").id,'displayName':user.get("toUser").get("displayName"),'displayUsername':user.get("toUser").get("displayUsername"),'image':userimage,'fromUser':user.get("fromUser").id});followingdataresult1.push({'id':user.get("toUser").id,'name':user.get("toUser").id});self.setState({followinguserid:followingdataresult1});}}else{self.setState({followinguserid:[]});}}});//followers 
var followersquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');followersquery.include("user");followersquery.include("fromUser");followersquery.include("image");followersquery.include("thumbnail");followersquery.doesNotExist("activity");followersquery.equalTo('photo',"Photo$"+post_id);//followersquery.equalTo("fromUser", currentUser);
var self=this;followersquery.find().then(function(followerresult){if(followerresult){var resultcount=followerresult.length;if(followerresult.length>0){var userdataresult=[];//self.setState({followersListing:'followerresult'});
for(var i=0;i<resultcount;i++){var Images=null;var user=followerresult[i];if(user.get("fromUser").get("profilePictureSmall")&&user.get("fromUser").get("profilePictureSmall").url()!==undefined){Images=user.get("fromUser").get("profilePictureSmall").url();}userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});//self.setState({followersListing:resultcount});
}self.setState({followersListing:userdataresult});}}});}else{var followersquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');followersquery.include("user");followersquery.include("fromUser");followersquery.include("image");followersquery.include("thumbnail");followersquery.doesNotExist("activity");followersquery.equalTo('photo',"Photo$"+post_id);//followersquery.equalTo("fromUser", currentUser);
var self=this;followersquery.find().then(function(followerresult){if(followerresult){var resultcount=followerresult.length;if(resultcount>0){var userdataresult=[];//self.setState({followersListing:'followerresult'});
for(var i=0;i<resultcount;i++){var Images=null;var user=followerresult[i];if(user.get("fromUser").get("profilePictureSmall")&&user.get("fromUser").get("profilePictureSmall").url()!==undefined){Images=user.get("fromUser").get("profilePictureSmall").url();}userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});//self.setState({followersListing:resultcount});
}self.setState({followersListing:userdataresult});}}});}}},{key:'singlegetAllUsersPopup',value:function singlegetAllUsersPopup(){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('_User');query.limit(999999999);query.include("profilePictureSmall");query.include("displayUsername");query.exists("displayUsername");query.include("name");var self=this;query.find().then(function(result){var userdataresult1=[];if(result){for(var i=0;i<result.length;i++){var user=result[i];var userimage='';if(user.get("profilePictureSmall")&&user.get("profilePictureSmall").url()!==undefined){userimage=user.get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}//userdataresult1.push({'id':user.id,'display':user.get("displayName"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
//self.state.singleget_allusers.push({'id':user.id,'display':user.get("displayName"),'username':user.get("username"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
userdataresult1.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});self.state.singleget_allusers_popup.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});}this.state.singleget_allusers_popup=userdataresult1;}else{// console.log("No users found");
}},function(error){});}},{key:'singlegetAllUsers',value:function singlegetAllUsers(){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('_User');query.limit(999999999);query.include("profilePictureSmall");query.include("displayUsername");query.include("name");var self=this;query.find().then(function(result){var userdataresult1=[];if(result){for(var i=0;i<result.length;i++){var user=result[i];var userimage='';if(user.get("profilePictureSmall")&&user.get("profilePictureSmall").url()!==undefined){userimage=user.get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}//userdataresult1.push({'id':user.id,'display':user.get("displayName"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
//self.state.singleget_allusers.push({'id':user.id,'display':user.get("displayName"),'username':user.get("username"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
userdataresult1.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});self.state.singleget_allusers.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});}this.state.singleget_allusers=userdataresult1;}else{// console.log("No users found");
}},function(error){});}},{key:'getUserProfileImage',value:function getUserProfileImage(){var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var profile_picture=currentUser.get("profilePictureSmall");if(profile_picture){this.state.currentuserImage=profile_picture.url();}this.state.currentUserId=currentUser.id;}}},{key:'renderComments',value:function renderComments(){var _this2=this;//console.log("renderIngredients");
//return      <span key="66"><h4> ingredType  <a onClick={() => this.handleAdd(0)} >Add</a></h4></span>;
var buffer=[];if(this.state.comments&&this.props.showComments){var _loop=function _loop(){comment=_this2.state.comments[i];var comment_activity_id="comment_"+comment.id;var comment_id="comnt_"+comment.id;_this2.state.singlelikeCount=comment.get("likeCount")?comment.get("likeCount"):0;likesWord="Likes";if(_this2.state.singlelikeCount==1)likesWord="Like";var comment_fromuserid=comment.get("fromUser").id;var comment_currentUserId=_this2.state.currentUserId;// if (ingredType != undefined)
//console.log(comment.get('Photo').id);
buffer.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{key:69*i,className:'cmt_wrap'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usr_img_detail'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usr_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:_this2.getCommentProfilePic(comment)})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_usr'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'name'},comment.get("fromUser").get('displayUsername')!=undefined?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+comment.get("fromUser").get('displayUsername')},comment.get("fromUser").get('displayUsername')):"",__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,time_ago(comment.get("createdAt")))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'/images/dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},comment_fromuserid===comment_currentUserId?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button','data-toggle':'modal','data-target':'#deleteCommentCloseModal',onClick:function onClick(e){return _this2.deleteCommentId(comment_id);},id:'close_deleteCommentwithdiscard','aria-label':'Modal'},'Delete'):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item',type:'button'},'Cancel')))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_cnt',id:comment_id},_this2.formatRenderComment(comment.get("content"),comment_id,comment.id)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_mn '},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_action d-flex flex-column flex-wrap align-items-start w-100'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action_grp'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'liked_activity',id:comment_activity_id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{'data-id':comment.id,id:comment_activity_id,onClick:function onClick(e){_this2.handlePhotoActivityLike(e);},className:'activitydefault',src:'../images/cmt-like.svg'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{'data-id':comment.id,id:comment_activity_id,onClick:function onClick(e){_this2.handlePhotoActivityUnLike(e);},className:'activityactive',style:{display:"none"},src:'../images/like-fill.svg'}),_this2.handleGetActivityLikePost(comment.id))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_count'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'like box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'#'},' ',' ',_this2.state.singlelikeCount,' ',likesWord))))))));};for(var i=0;i<this.state.comments.length;i++){var comment;var likesWord;_loop();}}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_wrap_list'},buffer);}// handleGetSavePost = (post_id,page) => {
},{key:'updateInput',value:function updateInput(event){this.setState({singlementioned:event.target.value});this.setState({postcomment:event.target.value});}},{key:'handleSinglePostPopupEnter',value:function handleSinglePostPopupEnter(event){if(event.key==="Enter"){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_button_comment#handleCommentPost_popup').click();}}},{key:'updateInputPopup',value:function updateInputPopup(event){//console.log('updateInputPopup');
var reply_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#reply_id').val();if(reply_id===''){//console.log('singlementioned_popup==='+event.target.value)
this.state.singlementioned_popup='';}var self=this;this.setState({singlementioned_popup:event.target.value});this.setState({postcomment_popup:event.target.value});this.setState({inputText:event.target.value});if(event.target.value!==null&&reply_id===''){}else{//console.log('Test2');
}}},{key:'postHeaderText',value:function postHeaderText(){var headerText="";//disable timestamp 5/29/19 //time_ago(this.state.created_at);
if(this.state.city){headerText+=this.state.city;}return headerText;}},{key:'queryForComments',value:function queryForComments(){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query.equalTo("photo",this.props.postData);query.equalTo("type","comment");query.doesNotExist("activity");query.include("fromUser");query.include("image");query.include("content");query.include("_created_at");query.include("createdAt");//query.ascending("_created_at");
query.descending("_created_at");var self=this;query.find().then(function(result){if(result){self.setState({comments:result});//promise.resolve(result);
}else{// console.log("No comments found");
// promise.resolve(null);
}},function(error){//console.error("Error loading comments Error: " + error);
//promise.error(error);
});}},{key:'queryForCommentspopup',value:function queryForCommentspopup(photo_ob){var post_id=this.state.single_post_id?this.state.single_post_id:'';//$('#popup_post_id').val();
// console.log('single_post_id'+this.state.single_post_id); 
if(post_id){//console.log('queryForCommentspopup');
var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query.equalTo("photo",photo_ob);// query.equalTo('photo', "Photo$"+post_id);
query.equalTo("type","comment");query.include("fromUser");query.include("image");query.include("content");query.include("_created_at");query.include("createdAt");//query.ascending("_created_at");
query.descending("_created_at");var self=this;query.find().then(function(result){if(result){// this.setState({commentsdatas: result});
}else{}},function(error){});}}},{key:'cancelText',value:function cancelText(event){var _this3=this;var postcomment=this.state.postcomment;setTimeout(function(){_this3.state.postcomment='';__WEBPACK_IMPORTED_MODULE_6_jquery___default()(".comment_box").val('');},500);}},{key:'toggleExpand',value:function toggleExpand(commentId){this.setState(function(prevState){return{isExpanded:!prevState.isExpanded};});this.setState(function(prevStates){return{expandedCommentId:commentId};});}},{key:'deleteCommentId',value:function deleteCommentId(commentId){var commentIds=commentId.split('comnt_');var commenUpdatedId=commentIds[1];__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#delete_comment_id').val(commenUpdatedId);}},{key:'deleteCommentIdOverlay',value:function deleteCommentIdOverlay(commentId){var commentIds=commentId.split('comnt_');var commenUpdatedId=commentIds[1];__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#delete_comment_id').val(commenUpdatedId);this.checkDeleteComment();}},{key:'checkDeleteComment',value:function checkDeleteComment(){var _this4=this;var delete_comment_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#delete_comment_id').val();var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var photo_post_id=this.state.postID;var self=this;if(currentUser){/*child*/var query_activityChild=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query_activityChild.equalTo('activity',"Activity$"+delete_comment_id);query_activityChild.equalTo('fromUser',currentUser);query_activityChild.find().then(function(object){if(object){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=object[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var objects=_step.value;objects.destroy();var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequery.equalTo('photo',"Photo$"+photo_post_id);//checklikequery.equalTo('fromUser', currentUser);
checklikequery.equalTo('activity',"Activity$"+objects.id);checklikequery.find().then(function(object){if(object){var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=object[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var _objects=_step2.value;_objects.destroy();}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});}//return object.destroy();
}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}}).then(function(deletedObject){/*setTimeout(() => {
              var self = this;
              self.handleCommentPostUpdate();
            },500);*/}).catch(function(error){console.error('Error deleting record:',error);});/*child*//*like*/var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequery.equalTo('photo',"Photo$"+photo_post_id);//checklikequery.equalTo('fromUser', currentUser);
checklikequery.equalTo('activity',"Activity$"+delete_comment_id);checklikequery.find().then(function(object){if(object){var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=object[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var objects=_step3.value;objects.destroy();}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});/*like*/var query_activity=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query_activity.equalTo('objectId',delete_comment_id);//query_activity.equalTo('fromUser', currentUser);
query_activity.first().then(function(object){if(object){//var photo_obj_id= object.get('photo').id;         
/*photo*//*var query = new Parse.Query('Photo');  
              query.equalTo('objectId', photo_obj_id);
              query.find().then(function(photo){
              if(photo)
              {
                  let photo_ob=photo[0];
                  var photoid= photo_ob.id;
                  var commentcount= photo_ob.get('commentcount');
                  if(commentcount==undefined || commentcount===1 || commentcount < 0)
                  {
                      commentcount=0;
                  }else
                  {
                      commentcount=commentcount-1;
                  } 
                    photo_ob.set("commentcount", commentcount.toString()); 
                    photo_ob.save();
                  }
              });*//*photo*/return object.destroy();}}).then(function(deletedObject){/* var getActivityquery = new Parse.Query('Activity');  
          getActivityquery.equalTo('objectId', delete_comment_id);
          var self = this;
          getActivityquery.find().then(function(activitydata){
          if(activitydata)
          {
              let activity_ob=activitydata[0];
              console.log(activity_ob.length);
            }
          })*/var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');var reply_id=_this4.state.reply_id;query.equalTo('photo',"Photo$"+photo_post_id);query.equalTo("type","comment");//query.doesNotExist("activity");
query.include("fromUser");query.include("photo");query.include("image");query.include("content");query.include("_created_at");query.include("createdAt");query.descending("_created_at");var self=_this4;query.find().then(function(result){if(result){var totalcomment=result.length;//console.log(totalcomment+'totalcomment')
var getPhotoquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');var self=this;getPhotoquery.equalTo('objectId',photo_post_id);getPhotoquery.find().then(function(photo){if(photo){var photo_ob=photo[0];var commentcount=totalcomment?totalcomment:0;photo_ob.set("commentcount",commentcount.toString());photo_ob.save();self.setState({commentCount:commentcount.toString()});// setTimeout(() => {
//var self = this;
// this.handleCommentPostUpdate();
//},1000);
}});}});setTimeout(function(){var self=_this4;self.handleCommentPostUpdate();},1500);}).catch(function(error){console.error('Error deleting record:',error);});}}},{key:'deletePostId',value:function deletePostId(post_id){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#delete_post_id').val(post_id);}},{key:'checkDeletePost',value:function checkDeletePost(){var delete_post_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#delete_post_id').val();var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');query.equalTo('objectId',delete_post_id);var self=this;query.find().then(function(photo){if(photo){var photo_ob=photo[0];var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequery.equalTo('photo',"Photo$"+delete_post_id);checklikequery.find().then(function(object){if(object){var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=object[Symbol.iterator](),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){var objects=_step4.value;objects.destroy();}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});var checkActivityquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');checkActivityquery.equalTo('photo',"Photo$"+delete_post_id);checkActivityquery.find().then(function(object){if(object){var _iteratorNormalCompletion5=true;var _didIteratorError5=false;var _iteratorError5=undefined;try{for(var _iterator5=object[Symbol.iterator](),_step5;!(_iteratorNormalCompletion5=(_step5=_iterator5.next()).done);_iteratorNormalCompletion5=true){var objects=_step5.value;objects.destroy();}}catch(err){_didIteratorError5=true;_iteratorError5=err;}finally{try{if(!_iteratorNormalCompletion5&&_iterator5.return){_iterator5.return();}}finally{if(_didIteratorError5){throw _iteratorError5;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});var checkSavequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Save');checkSavequery.equalTo('photo',"Photo$"+delete_post_id);checkSavequery.find().then(function(object){if(object){var _iteratorNormalCompletion6=true;var _didIteratorError6=false;var _iteratorError6=undefined;try{for(var _iterator6=object[Symbol.iterator](),_step6;!(_iteratorNormalCompletion6=(_step6=_iterator6.next()).done);_iteratorNormalCompletion6=true){var objects=_step6.value;objects.destroy();}}catch(err){_didIteratorError6=true;_iteratorError6=err;}finally{try{if(!_iteratorNormalCompletion6&&_iterator6.return){_iterator6.return();}}finally{if(_didIteratorError6){throw _iteratorError6;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});if(photo_ob){photo_ob.destroy();}setTimeout(function(){window.location.href="/";},500);}});}}},{key:'formatComment',value:function formatComment(origComment){if(!origComment)return"";var stringSplit=origComment.split(" ");var result="";for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);if(firstChar=="#"){result+='<a href="/appstore">'+comp+'</a> ';}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){//link
result+='<a href="'+comp+'"">'+comp+'</a>';}else{result+=comp;}result+=" ";}return result;}},{key:'renderComment',value:function renderComment(comment){//console.log("renderIngredients");
//return      <span key="66"><h4> ingredType  <a onClick={() => this.handleAdd(0)} >Add</a></h4></span>;
var buffer=[];var cmt=this.formatComment(comment);buffer.push(cmt);return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,buffer);}},{key:'formatRenderComments',value:function formatRenderComments(origComment){var _this5=this;var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,buffer);}var self=this;var stringSplit=origComment.split(" ");var maxLength=320;for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];//console.log(comp);
comp=comp.replace(/<[^>]+>/g,"");var userdisplaynames='';var firstChar=comp.charAt(0);/*if (firstChar == "#")
            {
                buffer.push(comp);
            }*/if(comp.indexOf("#")!==-1){//buffer.push(<a href="/appstore">{comp} </a>);
//var userdisplayname = comp.replace('#','');
var linkdata='<a>'+comp+'</a>';buffer.push(linkdata);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){//link
//buffer.push(<a href={comp}>{comp} </a>);
buffer.push('<a href='+comp+'>'+comp+'</a>');}else if(comp.indexOf("@")!==-1){var regex=/@(\w+)/g;var linkedText=comp.replace(regex,'<a href="/user/$1">@$1</a>');//console.log(linkedText);
//console.log(self.state.singleget_allusers);
/*if(self.state.singleget_allusers.includes(comp))
               {
                console.log(self.state.singleget_allusers);
               }*//*if (self.state.singleget_allusers) {
                for (var i = 0; i < self.state.singleget_allusers.length; i++) {
                  var display = self.state.singleget_allusers[i];
                  let displayid=display.id;
                  console.log(displayid);

                }
              }*//*let linkdatas = singleget_alluserss.display.find(function(ele) {
                   ele.display === comp;
                   console.log(comp+'comp');
                   console.log(ele.display+'ele.display');
              });*//*const index = singleget_allusers.display.findIndex((el) => el === comp)
              arr[index] = 0;
              if(self.state.singleget_allusers.display.includes(comp))
              {
                linkdata= self.state.singleget_allusers.display;
              }*///let linkdatas='';
/*var userdisplayname = comp.replace('@','');
               var query = new Parse.Query('_User');
               query.include("displayUsername");
               query.equalTo("displayUsername", userdisplayname);
               query.first().then(function(result){
                if(result){
                    let userdata=result;
                    let linkdatas='/user/'+userdata.get('displayUsername');
                    self.setState({linkdata:linkdatas}); 
                }
                })*///replace(/<[^>]+>/g, "")
//let linkdata='<a href ='+this.state.linkdata+'>'+comp+'</a>';
// userdisplaynames = comp.replace('@','');
//let linkdata='<a href ='+window.location.origin+'/user/'+userdisplaynames+'>'+comp+'</a>';
// buffer.push(linkdata);  
buffer.push(linkedText);}else{buffer.push(comp);}}// Replace the item at the found index
// The new array with the replaced item
///<[^>]+>/g, ""
var content=buffer.join(' ');// var data=content.length > maxLength ? `${content.substring(0, maxLength).replace(/<[^>]+>/g, "")}...` : content;
var data=content.length>maxLength?content.substring(0,maxLength)+'...':content;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:data}}),content.length>maxLength&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',onClick:function onClick(){return _this5.openPopup(_this5.state.postID);}},'more'));}},{key:'formatRenderComment',value:function formatRenderComment(origComment,comnt_id,comment_id){var _this6=this;var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,buffer);}var stringSplit=origComment.split(" ");var maxLength=250;for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);var self=this;if(firstChar=="#"){//buffer.push(<a href="/appstore">{comp} </a>);
buffer.push(comp);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){//link
// buffer.push(<a href={comp}>{comp} </a>);
buffer.push(comp);}else if(comp.indexOf("@")!==-1||comp.indexOf("@")!==-1){/*var userdisplayname = comp.replace('@','');
               var query = new Parse.Query('_User');
               query.include("displayUsername");
               query.include("username");
               query.equalTo("displayUsername", userdisplayname);
               query.first().then(function(result){
                if(result){
                    let userdata=result;
                    let linkdatas='/user/'+userdata.get('displayUsername');
                    self.setState({linkdata:linkdatas}); 
                }
                })
                let linkdata='<a href ='+this.state.linkdata+'>'+comp+'</a>';
                  buffer.push(linkdata);  */var userdisplayname=comp.replace('@','');var linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';buffer.push(linkdata);}else{// buffer.push(<span>{comp} </span>);  
//buffer.push(comp+' ');  
buffer.push(comp);}}var content=buffer.join(' ');/* return ( <span className='cmt-txt'>
                {buffer}
                </span>
        );*/var _props=this.props,_props$showMoreText=_props.showMoreText,showMoreText=_props$showMoreText===undefined?'more':_props$showMoreText,_props$showLessText=_props.showLessText,showLessText=_props$showLessText===undefined?'less':_props$showLessText;var isExpanded=this.state.isExpanded;var expandedCommentId=this.state.expandedCommentId;// Determine whether to truncate the text
var shouldTruncate=content.length>maxLength&&!isExpanded;// Truncate the text if necessary  //expandedCommentId===comment_id
var displayText=shouldTruncate?content.slice(0,maxLength)+'...':content;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt',id:comment_id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:displayText}}),shouldTruncate&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{onClick:function onClick(){return _this6.toggleExpand(comment_id);},style:{color:'#868589',cursor:'pointer',border:'none',background:'none'}},isExpanded?showLessText:showMoreText));}},{key:'formatRenderComment_old',value:function formatRenderComment_old(origComment){var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,buffer);}var self=this;var stringSplit=origComment.split(" ");for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);if(firstChar=="#"){//buffer.push(<a href="/appstore">{comp} </a>);
buffer.push(comp);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){//link
// buffer.push(<a href={comp}>{comp} </a>);
buffer.push(comp);}else if(comp.indexOf("@")!==-1||comp.indexOf("@")!==-1){/*var userdisplayname = comp.replace('@','');
               var query = new Parse.Query('_User');
               query.include("displayUsername");
               query.include("username");
               query.equalTo("displayUsername", userdisplayname);
               query.first().then(function(result){
                if(result){
                    let userdata=result;
                    let linkdatas='/user/'+userdata.get('displayUsername');
                    self.setState({linkdata:linkdatas}); 
                }
                })
                let linkdata='<a href ='+this.state.linkdata+'>'+comp+'</a>';
                  buffer.push(linkdata); */var userdisplayname=comp.replace('@','');var linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';buffer.push(linkdata);}else{// buffer.push(<span>{comp} </span>);  
// buffer.push(comp+' ');  
buffer.push(comp);}}var content=buffer.join(' ');return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:content}}));}},{key:'getUsername',value:function getUsername(user){/*if ((!user) || (user == undefined))
            return "User";


          user.fetch();

          var username = user.get("displayUsername");

          if ((!username) || (username.length < 2)) 
          {
            username = user.get("firstName") + "_" + user.get("lastName");
            username = username.toLowerCase(username);
          }
          if ((!username) || (username.length < 2)) 
          {
            username = "facebook_user";
          }

          return username;*/}},{key:'getCommentProfilePic',value:function getCommentProfilePic(comment){var user=comment.get("fromUser");if(user&&user!=undefined){var pic=user.get("profilePictureSmall");if(pic&&pic!=undefined)return pic.url();}return"/images/default_userpic0.png";}},{key:'renderTitleURL',value:function renderTitleURL(){if(this.state.title||this.state.url){var urlDomain=this.state.url.replace('http://','').replace('https://','').split(/[/?#]/)[0];urlDomain=urlDomain.replace('www.','');if(!(this.state.url&&this.state.url.length>1)){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'titleURLContainer'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'titleText'},this.state.title)));}else{return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:this.state.url,target:'_blank'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'titleURLContainer'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'urlText'},urlDomain),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'titleText'},this.state.title))));}}else{//don't show this section
return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null);}}},{key:'formatRenderComments2main',value:function formatRenderComments2main(origComment){var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,buffer);}var stringSplit=origComment.split(" ");var maxLength=320;for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);if(comp.indexOf("#")!==-1){//buffer.push(<a href="/appstore">{comp} </a>);
//var userdisplayname = comp.replace('#','');
var linkdata='<a>'+comp+'</a>';buffer.push(linkdata);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){buffer.push('<a href='+comp+'>'+comp+'</a>');}else if(comp.indexOf("@")!==-1||comp.indexOf("@")!==-1){//var userdisplayname = comp.replace(/\s/g, "").replace('@','');
var regex=/@(\w+)/g;var linkedText=comp.replace(regex,'<a href="/user/$1">@$1</a>');//let linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';
// buffer.push(linkdata);  
buffer.push(linkedText);}else{buffer.push(comp);}}var content=buffer.join(' ');return{'a':__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt'},content)};//return <img src={"https:aaaa"} />
}},{key:'formatRenderComments2',value:function formatRenderComments2(origComment){var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,buffer);}var stringSplit=origComment.split(" ");var maxLength=320;for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);if(firstChar=="#"){//buffer.push(<a href="/appstore">{comp} </a>);
buffer.push(comp);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){buffer.push('<a href='+comp+'>'+comp+'</a>');}else{buffer.push(comp);}}var content=buffer.join(' ');return{'a':__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt'},content.length>maxLength?content.substring(0,maxLength).replace(/<[^>]+>/g,"")+'...':content,content.length>maxLength&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:this.state.postLink},'more'))};}},{key:'queryForSinglepost',value:function queryForSinglepost(){var post_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');query.equalTo('objectId',post_id);query.include("user");query.include("image");query.include("thumbnail");query.include("likeCountNew");query.include("saveCount");query.include("commentcount");query.include("_created_at");query.include("createdAt");query.exists("user");query.descending("createdAt");var self=this;query.find().then(function(result){if(result){self.setState({postData:result});self.setState({likeCount:result[0].get('likeCountNew')});}else{console.log("No post found");}},function(error){});}},{key:'popuprenderComments',value:function popuprenderComments(){var bufferpopup=[];if(this.state.popup_comments){for(var i=0;i<this.state.popup_comments.length;i++){var comment=this.state.popup_comments[i];var comment_activity_id="comment_"+comment.id;var _comment_id="comnt1_"+comment.id;var comment_fromuserid=comment.get("fromUser").id;bufferpopup.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{key:69*i,className:'cmt_wrap1'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usr_img_detail1'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usr_img1'}))));}}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_wrap_lists'},bufferpopup);}},{key:'renderCaption',value:function renderCaption(){if(this.props.showComments){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'commentsContainer sngl_post_cmt'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_wrap'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usr_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'userProfileImage',src:this.state.userImage})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_usr'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+this.state.getUsernamefetch},this.state.getUsernamefetch)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_cnt_full'},this.formatRenderComment_old(this.state.caption)))));}else{//don't show the user and timestamp on the main stream view
return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'commentsContainer'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'home_pg'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'cmt_box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_usr'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+this.state.getUsernamefetch},this.state.getUsernamefetch)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_cnt'},this.formatRenderComments(this.state.caption)))));}}},{key:'renderRecipeAndProduct',value:function renderRecipeAndProduct(){if(this.props.showComments){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null);}else{//don't show the user and timestamp on the main stream view
return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null);}}},{key:'renderUserHeaderSharedALinkOrCollab',value:function renderUserHeaderSharedALinkOrCollab(user,url,collabUser){var getLoggedinUsername=localStorage.getItem('username');if(collabUser&&collabUser!=undefined){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usernameText'},getLoggedinUsername===this.state.getUsernamefetch?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/my-profile'},this.state.getUsernamefetch):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+this.state.getUsernamefetch},this.state.getUsernamefetch),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'sharedA'},'\xA0and\xA0'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+collabUser},collabUser));}else if(url){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usernameText'},getLoggedinUsername===this.state.getUsernamefetch?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'my-profile'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usernameText'},this.state.getUsernamefetch,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'sharedA'},'\xA0shared a link'))):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+this.state.getUsernamefetch},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usernameText'},this.state.getUsernamefetch,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'sharedA'},'\xA0shared a link'))));}else{//don't show the user and timestamp on the main stream view
return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usernameText'},getLoggedinUsername===this.state.getUsernamefetch?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/my-profile'},this.state.getUsernamefetch):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+this.state.getUsernamefetch},this.state.getUsernamefetch));}}},{key:'singlePostModalClass',value:function singlePostModalClass(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").addClass("sngl_mdl_open");}},{key:'singlePostModalClose1',value:function singlePostModalClose1(){var self=this;this.setState({isPopupOpen:false,postDetails:null,postDetailscomment:null});__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").removeClass("sngl_mdl_open");__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").removeClass("modal-open1");__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").removeClass("modal-open");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val('');//tabopenarray.length = 0;
/*url update*/window.history.replaceState("","","/");/*url update*/}},{key:'singlePostModalClose',value:function singlePostModalClose(){var self=this;__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").removeClass("sngl_mdl_open");__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").removeClass("modal-open1");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val('');}},{key:'singlePostLikeModalLikes',value:function singlePostLikeModalLikes(main_activity_id){var post_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();this.singlegetUsersCommentLike(post_id,main_activity_id);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#large_challenge_like_list_likes').trigger('click');},500);__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").addClass("sngl_mdlpstlk_open");}},{key:'singlePostLikeModal',value:function singlePostLikeModal(){var post_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();this.singlegetUsersLike(post_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").addClass("sngl_mdlpstlk_open");}},{key:'singlePostLikeModalClose',value:function singlePostLikeModalClose(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").addClass("modal-open1");__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").removeClass("sngl_mdlpstlk_open");// console.log("Test");
}},{key:'render',value:function render(){var _this7=this;var _state=this.state,isPopupOpen=_state.isPopupOpen,loading=_state.loading,error=_state.error,postDetails=_state.postDetails,postDetailscomment=_state.postDetailscomment,loadingdata=_state.loadingdata;var likesWord="Likes";var savesWord="saves";var commentsWord="Comments";var imprWord="impressions";var page="home";var self=this;if(this.props.showComments){page='single';}var getLoggedinUsername=localStorage.getItem('username');if(this.state.likeCount==1)likesWord="Like";if(this.state.saveCount==1)savesWord="save";if(this.state.commentCount==1)commentsWord="Comment";if(this.state.imprCount==1)imprWord="impression";var post_id_m='save_'+this.state.postID;var follow_id_m='follow_'+this.state.user.id;var currentuserImage=this.state.currentuserImage;var post_like_id_m='like_'+this.state.postID;var currentUserId=this.state.currentUserId;var sameprofile=0;if(currentUserId===this.state.user.id){sameprofile=1;}//console.log(this.state.challengeStatus+'this.state.challengeStatus')
var getchallengeStatus=this.state.challengeStatus;var isChallengeEntry=this.state.isChallengeEntry;var isChallengeWinner=this.state.isChallengeWinner;var isHideEntry=this.state.isHideEntry;var isRecipe=this.state.isRecipe;var isChallengeWinnersel=0;var isRecipesel=0;if(isChallengeWinner===true){isChallengeWinnersel=1;}if(isRecipe===true){isRecipesel=1;}var ischallengeStatus=0;var isHideEntryStatus=0;var iconclass='';if(this.state.isChallengeEntry=="1"&&this.state.usertype===1&&this.state.challengeentrystatus=="Active"){iconclass='joinchallengein';}//getchallengeStatus==='Active' || 
if(this.state.isHideEntry=="1"){isHideEntryStatus=1;}if(getchallengeStatus==='Billed'||getchallengeStatus==='Pending'||getchallengeStatus==='Complete'||getchallengeStatus==='Active'){ischallengeStatus=1;}var isNotificationOpen=this.state.isNotificationOpen;var post_Notification_Ids=this.state.post_Notification_Id;var post_Notification_Msg=this.state.post_Notification_Msg;var post_Notification_Comment=this.state.post_Notification_Comment;if(ischallengeStatus==0||isChallengeEntry==1){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_details_section_main'},isNotificationOpen?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__saveNotification_jsx__["a" /* default */],{isOpen:isNotificationOpen,postNotificationid:post_Notification_Ids,postMsg:post_Notification_Msg,postPhotoid:this.state.postID,postActivityComment:post_Notification_Comment}):"",page==='single'?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('section',{className:'post_list',style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('nav',{className:'sidebar'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Leftsidebar_jsx__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('main',{className:'listing spd_page'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'spd_page_inner singlePostOverlayModal '},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner_post_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'img_leftSide'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:'lef_img',src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/c02b98ff933601a1ddd7930d8bd0f1bc_file.bin',alt:'Comment'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'right_side_content_post'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_top_row border_bottom'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_top_card'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'user_icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'popup_user_image',src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/599cddfce141ae7f0a7d86fd18168fd7_file.bin',alt:'img'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{className:'popup_user_name',href:'/user/rosslynmaria'},'rosslynmaria'))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'/images/dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);','aria-label':'Close',className:'dropdown-item',type:'button',title:'Cancel'},'Cancel'))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_listing_ul_wrap'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('ul',{className:'post_listing_ul'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{className:'post_listing_li'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'detail_bottom user_top_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_top_card'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inline_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_leftbar_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'user_icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'popup_display_userimage',src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/599cddfce141ae7f0a7d86fd18168fd7_file.bin',alt:'img'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name_wrapper'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/rosslynmaria',className:'popup_display_username'},'rosslynmaria'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_cnt'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt',id:'full_text'},'This Grilled Peach Arugula Salad is inspired by summer and a must-try! \uD83C\uDF51\uD83E\uDD57 The sweet, juicy peaches pair perfectly with peppery arugula, creamy vegan feta, and a drizzle of olive oil, balsamic vinegar, maple syrup and salt & pepper to taste. It\u2019s a quick and delicious way to celebrate the season! Recipe: \u2022 Grill Peaches: Slice 2 ripe peaches. Lightly brush with olive oil and grill for 2-3 minutes on each side until caramelized. \u2022 Prepare Salad: Toss a handful of fresh arugula with the grilled peaches and crumble vegan feta on top. \u2022 Make Dressing: Whisk together 2 tbsp olive oil, 1 tbsp balsamic vinegar, 1 tsp maple syrup, salt and pepper. Drizzle over the salad. \u2022 Serve & Enjoy: Toss everything gently, serve immediately, and enjoy!! \uD83C\uDF1E'))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'content-span'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_sidebar_heart'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'product_content_details'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'day box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'time_interval_new'},'5d'))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',id:'like_button_challenge',type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{id:'like_count_new'},'3 Likes'))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment box'}))))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{className:'post_listing_li'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_wrap'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'detail_bottom user_top_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_top_card'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inline_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_leftbar_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'user_icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/7dbb41bbd6e35056a861bd98d8786263_file.bin'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name_wrapper'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/joel'},'joel'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'content-span'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_cnt'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,'Grilled peaches are definitely a summer seasonal treat! Simple, delicious, and healthy. The perfect trifecta. Thanks so much for sharing, Rosslyn. \uD83E\uDD57'))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_sidebar_heart'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/like-fill.svg'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/cmt-like.svg'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like box maincomment'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'count'},'1'))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'product_content_details'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'day box'},'5d'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'reply_count'},'Reply'))))))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_wrap'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'detail_bottom user_top_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_top_card'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inline_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_leftbar_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'user_icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/389fcf7e78aba3f4f5abd39780c837e1_file.bin'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name_wrapper'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/joelskitchen'},'joelskitchen'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'content-span'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_cnt'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,'Super-duper, Rosslyn! Thanks so much for sharing. \uD83D\uDE4F'))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_sidebar_heart'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'liked_activity'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'activitydefault',src:'../images/cmt-like.svg'})),' ')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'product_content_details'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'day box'},'5d'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'reply_count'},'Reply')))))))))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_post_bottom_add'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_like_shere'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'wrapper d-flex flex-row flex-wrap align-items-center justify-content-between w-100'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action_grp'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'popup_post_id',name:'popup_post_id'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'popup_load_id',name:'popup_load_id'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'reply_id',name:'reply_id'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'activity_parent_id1',name:'activity_parent_id1'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'like-icon liked'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'default1',src:'../images/like-new.svg'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',className:'comment-icon home-comment'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/comment-bold.svg',alt:'Comment'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',className:'share-icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/cmt-share-bold.svg',alt:'Share'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_save1'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'savepost_link1'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'savedefault1',src:'../images/bookmark.svg',alt:'No BookMark'})))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'liked_others'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label',null,'Liked by ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/joel',id:'like_button_challenge',type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},' joel')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,' and ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{id:'like_button_challenge',type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},'2'),' others '))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'add_in_comment'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'emoji_icon_input_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'emogi_icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/add_reaction.svg',alt:'img'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'textarea_bottom active'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('textarea',{placeholder:'Add a comment...'})))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{disabled:true,className:'post_button_comment'},'Post')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'comment_message_alert'})))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'border_top_middle'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'spd_page_grid'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3',{className:'more_post_title'},'More posts from ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,'rosslynmarie')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{'class':'gridPostRow'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{'class':'gridPost'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/a27945920eebce7bb8ea450e0cb5fa04_thumbnail.jpg'})))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{'class':'gridPost'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6b4758a0861a27967ded810dca3000eb_thumbnail.jpg'})))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{'class':'gridPost'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6b4758a0861a27967ded810dca3000eb_thumbnail.jpg'})))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{'class':'gridPost'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6b4758a0861a27967ded810dca3000eb_thumbnail.jpg'})))))))))):"",__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post-card card'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'card_inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_card'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:this.state.userImage}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'name'},this.renderUserHeaderSharedALinkOrCollab(this.state.user,this.state.url,this.state.collabUsername))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action cta_btn d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'secondary-btn btn-wrp sml-btn'},sameprofile===0?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',id:follow_id_m,'data-id':this.state.user.id,style:{display:"block"},onClick:function onClick(){return _this7.handleFollowUser(_this7.state.user);},className:'followpost_link',title:'Follow'},'Follow')):"",__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__followersUser_jsx__["a" /* default */],{postData:this.state.user})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{type:'button',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'/images/dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},sameprofile===1?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button',id:'delete_post_with_discard','data-toggle':'modal','data-target':'#deletePostCloseModal',onClick:function onClick(e){return _this7.deletePostId(_this7.state.postID);}},'Delete'):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);','data-dismiss':'modal','aria-label':'Close',className:'dropdown-item',type:'button'},'Cancel'))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'hero_image'},page=="home"?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'image_icon_wrap chlng-icon'},this.state.isChallengeEntry=="1"&&this.state.usertype===1&&this.state.isHideEntry==="0"&&this.state.challengeentrystatus=="Active"?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'join_challange',style:{'backgroundColor':this.state.barcolor?'#'+this.state.barcolor:'#c13828'}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this7.hometaps(_this7.state.postID,_this7.state.challenge_id);},id:'large_challenge_image_challenge',className:'sinlg_post_over_mdl',type:'button'},'Join Challenge Now',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'/images/arrow_forward.svg',alt:'Join Arrow'}))):'',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:iconclass?'iconGrp '+iconclass:'iconGrp'},isRecipesel===1?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'recipe'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/recipe-icon-img.svg'})):"",isChallengeWinnersel===1?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'winner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/winner-icon-img.svg'})):""),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',onClick:function onClick(){return _this7.openPopup(_this7.state.postID);},id:'large_challenge_image_btn2',type:'button'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'img-thumbnail',src:this.state.postImage}))):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'image_icon_wrap chlng-icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'iconGrp'},this.state.isChallengeEntry=="1"&&this.state.usertype===1&&this.state.challengeentrystatus=="Active"?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'join_challange',style:{'backgroundColor':this.state.barcolor?'#'+this.state.barcolor:'#c13828'}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/challenge/'+this.state.challenge_id,id:'large_challenge_image_challenge',className:'sinlg_post_over_mdl',type:'button'},'Join Challenge Now',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'/images/arrow_forward.svg',alt:'Join Arrow'}))):'',isRecipesel===1?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'recipe'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/recipe-icon-img.svg'})):"",isChallengeWinnersel===1?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'winner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/winner-icon-img.svg'})):""),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',id:'large_challenge_image_btn2',type:'button','data-toggle':'modal'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'img-thumbnail',src:this.state.postImage}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',style:{display:"none"},'data-toggle':'modal','data-target':'#large_challenge_image3',id:'large_challenge_image_btn22',type:'button'},'modal')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_challange '},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cta_btn third-btn btn-wrp'},sameprofile===1&&this.state.isChallenge==0?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/create-challenge/'+this.state.postID,title:'Create Challenge'},'Create Challenge'):"")),this.renderTitleURL(),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_mn'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_action'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'wrapper d-flex flex-row flex-wrap align-items-center justify-content-between w-100'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action_grp'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'like-icon liked',id:post_like_id_m},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:post_like_id_m,onClick:function onClick(){return _this7.handlePhotoLike(_this7.state.postID,page);},className:'default',src:'../images/like.svg'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:post_like_id_m,onClick:function onClick(){return _this7.handlePhotoUnLike(_this7.state.postID,page);},className:'active',style:{display:"none"},src:'../images/like-fill.svg'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__getLikePostHome_jsx__["a" /* default */],{postIdData:this.state.postID})),getLoggedinUsername===null?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'comment-icon',onClick:function onClick(){return _this7.handleNotLoginClick();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/comment.svg',alt:'Comment'})):getLoggedinUsername!=null&&page==='home'?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'comment-icon home-comment',onClick:function onClick(){return _this7.openPopup(_this7.state.postID);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/comment.svg',alt:'Comment'})):getLoggedinUsername!=null&&page==='single'?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this7.handleCommentSingleClick();},className:'comment-icon single-comment '},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/comment.svg',alt:'Comment'})):"",__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'../appstore',className:'share-icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/cmt-share.svg',alt:'Share'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_save'},getLoggedinUsername!=null?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',style:{display:"block"},id:post_id_m,className:'savepost_link'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:post_id_m,style:{display:"block"},className:'savedefault',src:'../images/bookmark.svg',onClick:function onClick(){return _this7.handleSavePost(_this7.state.postID,page);},alt:'No BookMark'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:post_id_m,style:{display:"none"},className:'saveactive',src:'../images/bookmark-fill.svg',onClick:function onClick(){return _this7.handleRemoveSavePost(_this7.state.postID,page);},alt:'BookMark'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__postSaveUser_jsx__["a" /* default */],{postIdData:this.state.postID})):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this7.handleNotLoginClick();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{style:{display:"block"},className:'savedefault',src:'../images/bookmark.svg',alt:'No BookMark'}))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like-count comment_count d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',onClick:function onClick(){return _this7.openPopup(_this7.state.postID);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{id:'like_counts_'+this.state.postID},this.state.likeCount),'\xA0',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{id:'like_words_'+this.state.postID},likesWord)))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_list'},this.renderRecipeAndProduct(),this.renderCaption()),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_count d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',id:'large_challenge_image_btn2','data-id':this.state.postID,onClick:function onClick(){return _this7.openPopup(_this7.state.postID);},type:'button'},'View all ',this.state.commentCount,' ',commentsWord)))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_list_mn '},getLoggedinUsername!=null&&this.props.showComments?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_inpt_grp'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inptWrap'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usr_img'},currentuserImage!==null?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:currentuserImage,alt:'User Image'}):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'/images/default_userpic0.png'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inpt_box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_mentions__["b" /* MentionsInput */],{placeholder:'Add a comment...',id:'comment_box',value:this.state.singlementioned,onChange:this.updateInput,style:__WEBPACK_IMPORTED_MODULE_8__defaultStyle__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_mentions__["a" /* Mention */],{trigger:'@',data:this.state.singleget_allusers,markup:'@__display__ ',displayTransform:function displayTransform(id,display,displayName){return'@'+display;},appendSpaceOnAdd:true,style:__WEBPACK_IMPORTED_MODULE_9__defaultMentionStyle__["a" /* default */],renderSuggestion:this.singlerenderUserSuggestion,required:true,id:'comment_box',className:'mentions__mention',placeholder:'Add a comment...'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'comment_message_alert'},this.state.blank_comment_message)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_action_wrap'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{id:'cancelCommentPost',className:'cnlebtn',onClick:this.cancelText},'Cancel'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{id:'handleCommentPost',className:'postbtn',onClick:this.handleCommentPost},'Post'))):'',this.state.loadpage==='single'?this.renderComments():'','        ')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay deleteCommentCloseModal',id:'deleteCommentCloseModal','data-backdrop':'false','data-keyboard':'false',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h6',null,'Are you sure you want to delete?')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'delete_comment_id',name:'delete_comment_id'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn danger btn-post-discard','data-dismiss':'modal','aria-label':'Close',onClick:this.checkDeleteComment,title:'Discard'},'Delete'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel','data-dismiss':'modal','aria-label':'Close',title:'Cancel'},'Cancel'))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay deletePostCloseModal',id:'deletePostCloseModal','data-backdrop':'false','data-keyboard':'false',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h6',null,'Are you sure you want to delete this post?')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'delete_post_id',name:'delete_post_id'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn danger btn-post-discard','data-dismiss':'modal','aria-label':'Close',onClick:function onClick(e){return _this7.checkDeletePost();},title:'Delete'},'Delete'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel','data-dismiss':'modal','aria-label':'Close',title:'Cancel'},'Cancel'))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay singlePostOverlayModal createPostCloseModal large_challenge_image',id:'large_challenge_image2','data-backdrop':'false','data-keyboard':'false',role:'dialog','aria-labelledby':'createPostCloseTitle'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel',onClick:this.singlePostModalClose,'data-dismiss':'modal','aria-label':'Close',title:'Close'},'\u2715'))))),isPopupOpen&&loading?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',null):error?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',null,error):postDetails&&isPopupOpen&&postDetailscomment&&this.renderDetailPage(postDetails.id)));}else{return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null);}}}]);return SinglePost;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this8=this;this.onEmojiClick=function(event,emojiObject){_this8.setState(function(prevState){return{//inputText: prevState.inputText + emojiObject.emoji,
singlementioned_popup:prevState.singlementioned_popup+emojiObject.emoji,showPicker:false// Optional: hide the picker after selection
};});};this.togglePicker=function(){_this8.setState(function(prevState){return{showPicker:!prevState.showPicker};});};this.handleUnFollowMyProfileLike=function(e){var datapost_id=e.target.dataset.id;var self=_this8;var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('User');query.equalTo("objectId",datapost_id);query.first().then(function(result){if(result){var touser=result;var checksavequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');checksavequery.equalTo('type','follow');checksavequery.equalTo('toUser',touser);checksavequery.equalTo('fromUser',currentUser);checksavequery.first().then(function(object){if(object){return object.destroy();}}).then(function(deletedObject){setTimeout(function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style","display: block");self.singlegetUsersCommentLike(datapost_id);},1000);}).catch(function(error){console.error('Error deleting record:',error);});}});//setTimeout(() => {
//  self.singlegetUsersCommentLike(datapost_id);
// },2000);
}else{// $('#kitchenQrModal_btn').trigger('click');  
return false;}};this.handleUnFollowMyProfile=function(e){var self=_this8;var datapost_id=e.target.dataset.id;var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('User');query.equalTo("objectId",datapost_id);query.first().then(function(result){if(result){var touser=result;var checksavequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');checksavequery.equalTo('type','follow');checksavequery.equalTo('toUser',touser);checksavequery.equalTo('fromUser',currentUser);checksavequery.first().then(function(object){if(object){return object.destroy();}}).then(function(deletedObject){setTimeout(function(){self.singlegetUsersLike(datapost_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style","display: block");},1000);}).catch(function(error){console.error('Error deleting record:',error);});}});//setTimeout(() => {
// self.singlegetUsersLike(datapost_id);
//$('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style", "display: none");
//$('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style", "display: block");
//   },1000);
}else{// $('#kitchenQrModal_btn').trigger('click');  
return false;}};this.handleFollowMyProfile=function(e){var datapost_id=e.target.dataset.id;var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var self=_this8;if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('User');query.equalTo("objectId",datapost_id);query.first().then(function(result){if(result){var touser=result;var Activity=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Activity");var activity=new Activity();activity.set('fromUser',currentUser);activity.set('toUser',touser);activity.set('type','follow');activity.save().then(function(savedFile){setTimeout(function(){//$('a.unfollowpost_link#follow_'+datapost_id).attr("style", "display: block");
//$('a.followpost_link#follow_'+datapost_id).attr("style", "display: none");
self.singlegetUsersLike(datapost_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style","display: block");self.toggleNotification(touser,'started following you.','');self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});},1000);}).catch(function(error){});}});}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}};this.handleFollowMyProfileLike=function(e){var datapost_id=e.target.dataset.id;var self=_this8;var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('User');query.equalTo("objectId",datapost_id);query.first().then(function(result){if(result){var touser=result;var Activity=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Activity");var activity=new Activity();activity.set('fromUser',currentUser);activity.set('toUser',touser);activity.set('type','follow');activity.save().then(function(savedFile){setTimeout(function(){//$('a.unfollowpost_link#follow_'+datapost_id).attr("style", "display: block");
//$('a.followpost_link#follow_'+datapost_id).attr("style", "display: none");
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style","display: block");self.singlegetUsersCommentLike(datapost_id);},1000);}).catch(function(error){});}});// setTimeout(() => {
//self.singlegetUsersCommentLike(datapost_id);            
//},2000);
}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}};this.fetchData=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var photo_post_id,query,self;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:photo_post_id=_this8.state.postID;query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query.equalTo('photo',"Photo$"+photo_post_id);//query query1 = await query1.get(postId);
query.equalTo("type","comment");query.doesNotExist("activity");query.include("fromUser");query.include("photo");query.include("image");query.include("content");query.include("_created_at");query.include("createdAt");query.ascending("_created_at");//query.descending("_created_at");
self=_this8;query.find().then(function(result){if(result){self.setState({singlementioned_popup:''});self.setState({comments:result});self.setState({commentCount:result.length});var commentdataresults1=[];var _loop2=function _loop2(){var userActivitylist=[];comment=result[i];//console.log('comment comment');
// console.log(comment);
//console.log(comment[0]);
//var commentdata=comment;
/* const processedcommentData = comment.map((result) => {
                return {
                  id:result.id,
                  content:result.get('content'),
                  createdAt:result.get('createdAt'),
                  fromUser:result.get('fromUser'),
                  likeCount:result.get('likeCount'),
                  toUser:result.get('toUser'),
                  type:result.get('type'),
                  updatedAt:result.get('updatedAt'),
                };
              });*///console.log(commentdata);
replyQuery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');replyQuery.equalTo('photo',"Photo$"+photo_post_id);replyQuery.exists("activity");replyQuery.equalTo('activity',"Activity$"+comment.id);replyQuery.include("photo");replyQuery.ascending("_created_at");//replyQuery.descending("_created_at");
replyQuery.find().then(function(result){if(result){var processedData=result.map(function(result){return{id:result.id,content:result.get('content'),createdAt:result.get('createdAt'),fromUser:result.get('fromUser'),likeCount:result.get('likeCount'),toUser:result.get('toUser'),type:result.get('type'),updatedAt:result.get('updatedAt')};});userActivitylist.push(processedData);}});commentdataresults1.push({comments:comment,children:userActivitylist});};for(var i=0;i<result.length;i++){var comment;var replyQuery;_loop2();}//setTimeout(() => {
// self.setState({postDetailscomment: commentdataresults1,loadingdata:true});
//},500);   
//self.setState({comments: commentdataresults1});
//self.setState({isPopupOpen: true});
//isPopupOpen: true
//self.setState({postDetailscomment: result});
//self.renderDetailPage(photo_post_id);
}else{}},function(error){});case 14:case'end':return _context.stop();}}},_callee,_this8);}));this.fetchPostData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(postId){var Post,query,post,userlikelist,query1,self;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0://console.log('fetchPostData'+postId);
_this8.setState({loading:true,error:null});_context2.prev=1;Post=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend('Photo');query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query(Post);_context2.next=6;return query.get(postId);case 6:post=_context2.sent;userlikelist=[];query1=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query1.equalTo('photo',"Photo$"+postId);query1.equalTo("type","comment");query1.include("fromUser");query1.include("photo");query1.include("image");query1.include("content");query1.include("_created_at");query1.include("createdAt");query1.doesNotExist("activity");query1.ascending("_created_at");self=_this8;query1.find().then(function(result){if(result){var commentdataresults=[];var _loop3=function _loop3(){var userActivitylist=[];comment=result[i];replyQuery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');replyQuery.equalTo('photo',"Photo$"+postId);replyQuery.exists("activity");replyQuery.equalTo('activity',"Activity$"+comment.id);replyQuery.include("photo");replyQuery.ascending("_created_at");//replyQuery.descending("_created_at");
replyQuery.find().then(function(result){if(result){var processedData=result.map(function(result){return{id:result.id,content:result.get('content'),createdAt:result.get('createdAt'),fromUser:result.get('fromUser'),likeCount:result.get('likeCount'),toUser:result.get('toUser'),type:result.get('type'),updatedAt:result.get('updatedAt')};});userActivitylist.push(processedData);}});commentdataresults.push({comments:comment,children:userActivitylist});};for(var i=0;i<result.length;i++){var comment;var replyQuery;_loop3();}self.setState({postDetailscomment:commentdataresults,//result,
postDetails:post,loading:false,loadingdata:true});var obj=post.get('caption')!=''?self.formatRenderComments2main(post.get('caption')):self.formatRenderComments2main(post.get('caption'));var full_text=obj.a.props.children?obj.a.props.children:'';__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#full_text').html(full_text);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#lef_img').attr('src','../images/default_userpic0.png');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_user_image').attr('src','../images/default_userpic0.png');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_display_userimage').attr('src','../images/default_userpic0.png');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.user_name a.popup_user_name').html('');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.user_name a.popup_user_name').html(post.get('user').get('displayUsername'));__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.user_name a.popup_user_name').attr("href","/user/"+post.get('user').get('displayUsername'));__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_display_username').html(post.get('user').get('displayUsername'));__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_display_username').attr("href","/user/"+post.get('user').get('displayUsername'));var userprofileimage=post?post.get('user')?post.get('user').get('profilePictureSmall')?post.get('user').get('profilePictureSmall').url():'../images/default_userpic0.png':'../images/default_userpic0.png':'../images/default_userpic0.png';__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_user_image').attr('src',userprofileimage);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_display_userimage').attr('src',userprofileimage);var photo_img=post?post.get('image')?post.get('image')?post.get('image').url():'../images/default_userpic0.png':'../images/default_userpic0.png':'../images/default_userpic0.png';__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#lef_img').attr('src',photo_img);var likeCountNew=post.get('likeCountNew')?post.get('likeCountNew'):0;var likesWord="Likes";if(likeCountNew==1){likesWord="Like";}__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#like_count_new').html(likeCountNew+' '+likesWord);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.time_interval_new').html(time_ago(post.get('createdAt')));document.getElementById('large_challenge_image_btn22').click();self.singlegetAllUsersPopup();//
self.handleGetSavePost(post.id,'popup');self.singlegetUsersLike(post.id);self.handleGetLikeUser(postId);//count update
var postimpt=post?post.get('impr')+1:1;post.set('impr',postimpt);post.save().then(function(postupdated){});//count update
/*url update*///let stateObj = { postId: postId }; 
window.history.replaceState(window.history.state,"","/post/"+postId);/*url update*/}else{}//$('#large_challenge_image2').trigger('click');
},function(error){});//comment listing 
_context2.next=26;break;case 23:_context2.prev=23;_context2.t0=_context2['catch'](1);_this8.setState({//error: 'Failed to fetch post data',
loading:false});case 26:case'end':return _context2.stop();}}},_callee2,_this8,[[1,23]]);}));return function(_x){return _ref2.apply(this,arguments);};}();this.openPopup=function(postId){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val(postId);_this8.setState({isPopupOpen:true},function(){_this8.fetchPostData(postId);});};this.hometaps=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(postId,challengeId){var getPhotoquery;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:getPhotoquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');getPhotoquery.equalTo('objectId',postId);getPhotoquery.first().then(function(photo){if(photo){var homeCount=photo.get('homeCount')?photo.get('homeCount'):0;if(homeCount){var updated_comment_count=parseInt(homeCount)+1;}else{var updated_comment_count=1;}photo.set("homeCount",updated_comment_count.toString());photo.save().then(function(photodata){window.location.href='/challenge/'+challengeId;}).catch(function(error){console.log(error.message);});}});/* setTimeout(() => {
        
       }, 1500);*/case 3:case'end':return _context3.stop();}}},_callee3,_this8);}));return function(_x2,_x3){return _ref3.apply(this,arguments);};}();this.handleCommentPostUpdate=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var photo_post_id,reply_thread_id,self,query,reply_id,commentCountval,getPhotoquery;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0://$(".add_in_comment .emoji_icon_input_row .textarea_bottom.active").attr("style", "visibility: hidden");   
//$('.add_in_comment #comment_box_popup').attr("style", "color: transparent");
//$('.add_in_comment #comment_box_popup').attr('placeholder','Add a comment...');
photo_post_id=_this8.state.postID;reply_thread_id=_this8.state.reply_thread_id;self=_this8;query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');reply_id=_this8.state.reply_id;query.equalTo('photo',"Photo$"+photo_post_id);query.equalTo("type","comment");query.doesNotExist("activity");query.include("fromUser");query.include("photo");query.limit(999999999);query.include("image");query.include("content");query.include("_created_at");query.include("createdAt");//query.descending("_created_at");
query.ascending("_created_at");commentCountval=_this8.state.commentCount;query.find().then(function(result){var commentdataresults1=[];if(result){var totalcomment=result.length;var totalcommentchild=0;self.setState({singlementioned_popup:''});self.setState({comments:result});var _loop4=function _loop4(){var userActivitylist=[];comment=result[i];comment_idsval=comment.id;replyQuery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');replyQuery.equalTo('photo',"Photo$"+photo_post_id);replyQuery.exists("activity");replyQuery.equalTo('activity',"Activity$"+comment.id);replyQuery.include("photo");replyQuery.ascending("_created_at");// replyQuery.descending("_created_at");
replyQuery.find().then(function(result){if(result){//totalcommentchild=result.length;
var processedData=result.map(function(result){return{id:result.id,content:result.get('content'),createdAt:result.get('createdAt'),fromUser:result.get('fromUser'),likeCount:result.get('likeCount'),toUser:result.get('toUser'),type:result.get('type'),updatedAt:result.get('updatedAt')};});userActivitylist.push(processedData);}//self.handleGetActivityLikePostChild(comment_idsval) ; 
//self.handleGetActivityLikePost(result.id); 
});commentdataresults1.push({comments:comment,children:userActivitylist});/*setTimeout(() => {
                if(comment.id) {
                  // $('.comment_like  .comment.box a .reply_count#comnt_'+comment.id).trigger('click');
                    self.handleGetActivityLikePostChild(comment.id)
                }
              },1000); */};for(var i=0;i<result.length;i++){var comment;var comment_idsval;var replyQuery;_loop4();}setTimeout(function(){self.setState({postDetailscomment:commentdataresults1},function(){self.setState({loadingdata:true,loading:false,singlementioned_popup:'',loader:false,reply_id:''});});if(reply_thread_id){__WEBPACK_IMPORTED_MODULE_6_jquery___default()(' a.liked_activity_child .activitydefault#comment_'+reply_thread_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activityactive#comment_'+reply_thread_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box .count#childlike_'+reply_thread_id).html(0);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box .like_count#childlike_'+reply_thread_id).html('Likes');}self.setState({reply_thread_id:''});setTimeout(function(){self.handleCommentPostLikes();__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#activity_parent_id').val('');},500);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_button_comment#handleCommentPost_popup').attr("disabled",false);},3500);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#reply_id').val('');//self.setState({ reply_id: '' });
//self.setState({singlementioned_popup: ''});
//self.setState({commentCount:totalcomment});
//console.log('totalcomment'+totalcomment)
//self.setState({postDetailscomment: result});
//self.renderDetailPage(photo_post_id);
/*setTimeout(() => {
                if(commentdataresults1) {
                  for (var i = 0; i < commentdataresults1.length; i++) {
                    var commentdataresults1 = commentdataresults1[i]; 
                    let comment= commentdataresults1.comments; 
                    console.log('comment');
                    console.log(comment);
                    console.log('.comment_like  .comment.box a .reply_count#comnt_'+comment.id);
                    $('.comment_like  .comment.box a .reply_count#comnt_'+comment.id).trigger('click');
                  }
                }
              },1000); *//*setTimeout(() => {
              self.setState({reply_id: ''});
              $('#reply_id').val('');
              $(".add_in_comment #comment_box_popup").val('');
              self.setState({singlementioned_popup: ''});
                $('#clearInput').trigger('click');                 
              },2000); */}else{}},function(error){});getPhotoquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');getPhotoquery.equalTo('objectId',photo_post_id);self=_this8;getPhotoquery.find().then(function(photo){if(photo){var photo_ob=photo[0];var commentcount=photo_ob.get('commentcount')?photo_ob.get('commentcount'):0;self.setState({commentCount:commentcount});photo_ob.set("commentcount",commentcount.toString());photo_ob.save();}});case 22:case'end':return _context4.stop();}}},_callee4,_this8);}));this.handleCommentPostLikes=function(){var post_id=_this8.state.postID;var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var query_activityChild=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query_activityChild.equalTo('photo',"Photo$"+post_id);query_activityChild.exists("activity");query_activityChild.find().then(function(resultactivity){var resultactivitys=resultactivity;var _loop5=function _loop5(objects){setTimeout(function(){if(objects.get('likeCount')===0){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activityactive#comment_'+objects.id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activitydefault#comment_'+objects.id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box .count#childlike_'+objects.id).html(0);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box .like_count#childlike_'+objects.id).html('Likes');}},1000);};var _iteratorNormalCompletion7=true;var _didIteratorError7=false;var _iteratorError7=undefined;try{for(var _iterator7=resultactivitys[Symbol.iterator](),_step7;!(_iteratorNormalCompletion7=(_step7=_iterator7.next()).done);_iteratorNormalCompletion7=true){var objects=_step7.value;_loop5(objects);}}catch(err){_didIteratorError7=true;_iteratorError7=err;}finally{try{if(!_iteratorNormalCompletion7&&_iterator7.return){_iterator7.return();}}finally{if(_didIteratorError7){throw _iteratorError7;}}}});}};this.closePopup=function(){_this8.setState({isPopupOpen:false,postDetails:null,postDetailscomment:null,postDetailsReplycomment:null});};this.replyComment=function(commentId,activity_parent_id,event){var commentIds=commentId.split('comnt_');var commenUpdatedId=commentIds[1];__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#reply_id').val(commenUpdatedId);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#activity_parent_id').val(activity_parent_id);_this8.setState({reply_id:commenUpdatedId});var reply_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#reply_id').val();var query1=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query1.equalTo('objectId',commenUpdatedId);query1.equalTo("type","comment");query1.include("fromUser");var self=_this8;__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.add_in_comment #comment_box_popup').val('');var activity_parent_ids=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#activity_parent_id').val();query1.find().then(function(photo){if(photo){var photo_ob=photo[0];var displayusername=photo_ob?photo_ob.get('fromUser')?'@'+photo_ob.get('fromUser').get('displayUsername')+'  ':'':'';var displayusernameval=photo_ob?photo_ob.get('fromUser')?photo_ob.get('fromUser').get('displayUsername'):'':'';self.setState({singlementioned_popup:displayusername});}});setTimeout(function(){if(activity_parent_ids===''&&reply_id===''){self.setState({singlementioned_popup:''});__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#clearInput').trigger('click');}},2000);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.add_in_comment #comment_box_popup').focus();};this.renderDetailPage=function(post_id){var _state2=_this8.state,postDetails=_state2.postDetails,postDetailscomment=_state2.postDetailscomment,likeuserlist=_state2.likeuserlist,inputText=_state2.inputText,showPicker=_state2.showPicker,postDetailsReplycomment=_state2.postDetailsReplycomment,loadingdata=_state2.loadingdata,loader=_state2.loader;var othertext='';var bufferdata=[];var bufferdatacommentreply=[];var userlikeusername=[];var fetchuserlikeusername=[];var bufferfollowers=[];var bufferlikefollowers=[];var formatRenderCommentChild=function formatRenderCommentChild(origComment,comnt_id,comment_id){var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,buffer);}var stringSplit=origComment.split(" ");var maxLength=250;for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);var self=_this8;if(firstChar=="#"){buffer.push(comp);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){buffer.push(comp);}else if(comp.indexOf("@")!==-1||comp.indexOf("@")!==-1){var userdisplayname=comp.replace('@','');var linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';buffer.push(linkdata);}else{buffer.push(comp);}}var content=buffer.join(' ');var _props2=_this8.props,_props2$showMoreText=_props2.showMoreText,showMoreText=_props2$showMoreText===undefined?'more':_props2$showMoreText,_props2$showLessText=_props2.showLessText,showLessText=_props2$showLessText===undefined?'less':_props2$showLessText;var isExpanded=_this8.state.isExpanded;var expandedCommentId=_this8.state.expandedCommentId;var shouldTruncate=content.length>maxLength&&!isExpanded;var displayText=shouldTruncate?content.slice(0,maxLength)+'...':content;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt',id:comment_id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:displayText}}),shouldTruncate&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{onClick:function onClick(){return _this8.toggleExpand(comment_id);},style:{color:'#868589',cursor:'pointer',border:'none',background:'none'}},isExpanded?showLessText:showMoreText));};var clearInput=function clearInput(){var self=_this8;//this.setState({ inputValue: '' });
self.setState({singlementioned_popup:''});};var getCommentProfilePicChild=function getCommentProfilePicChild(comment){var user=comment.fromUser;if(user&&user!=undefined){var pic=user.get('profilePictureSmall');if(pic&&pic!=undefined)return pic.url();}return"/images/default_userpic0.png";};if(_this8.state.postDetailscomment){if(_this8.state.postDetailscomment.length>0){var buffercommentdata=[];var _loop6=function _loop6(){comment=_this8.state.postDetailscomment[i];var children=comment.children!==undefined?comment.children[0]:'';comment=comment.comments;var comment_activity_id="comment_"+comment.id;var comment_id="comnt_"+comment.id;var comment_par_id="comnt_"+comment.id;var likeCount=comment.get("likeCount")?comment.get("likeCount"):0;likesWord="Likes";if(likeCount==1)likesWord="Like";var comment_fromuserid=comment.get("fromUser")?comment.get("fromUser").id:'';var comment_currentUserId=_this8.state.currentUserId;var hasKey=comment.has('activity');//console.log(i);
self=_this8;var main_activity_id=comment.id;bufferdata.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{key:69*i,className:'cmt_wrap'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'detail_bottom user_top_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_top_card'},hasKey==false?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inline_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_leftbar_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'user_icon'},' ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:_this8.getCommentProfilePic(comment)}),'  ')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name_wrapper'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name'},comment.get("fromUser")?comment.get("fromUser").get('displayUsername')?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+comment.get("fromUser").get('displayUsername')},comment.get("fromUser").get('displayUsername')):'':'',hasKey==false?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'content-span'},'  ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_cnt',id:comment_id},_this8.formatRenderComment(comment.get("content"),comment_id,comment.id))):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,_this8.formatRenderComment(comment.get("content"),comment_id,comment.id),' ')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_sidebar_heart'},_this8.handleGetActivityLikePost(comment.id),likeCount==0?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'liked_activity',id:comment_activity_id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{'data-id':comment.id,id:comment_activity_id,onClick:function onClick(e){_this8.handlePhotoActivityLike(e);},className:'activitydefault',src:'../images/cmt-like.svg'})):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'liked_activity',id:comment_activity_id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{'data-id':comment.id,id:comment_activity_id,onClick:function onClick(e){_this8.handlePhotoActivityUnLike(e);},className:'activityactive',style:{display:"none"},src:'../images/like-fill.svg'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{'data-id':comment.id,id:comment_activity_id,onClick:function onClick(e){_this8.handlePhotoActivityLike(e);},className:'activitydefault',src:'../images/cmt-like.svg'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like box maincomment',id:comment.id,style:{display:likeCount===0?'none':'block'}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',id:'like_button_challenge',onClick:function onClick(e){_this8.singlePostLikeModalLikes(main_activity_id,false);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'count'},likeCount),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'like_count',style:{display:"none"}},likesWord))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'product_content_details'},hasKey==false?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center',id:comment_id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'day box'},time_ago(comment.get("createdAt"))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'reply_count',id:comment_id,onClick:function onClick(e){return _this8.replyComment(comment_id,main_activity_id,e);}},'Reply'))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment box',style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'/images/small_dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},comment_fromuserid===comment_currentUserId?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button',onClick:function onClick(e){return _this8.deleteCommentIdOverlay(comment_id);},id:'close_deleteCommentwithdiscard','aria-label':'Modal'},'Delete'):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report '),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item',type:'button'},'Cancel')))))):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null),children!==undefined&&children.length>0&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'view_replies_comment'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'faq-drawer'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{className:'faq-drawer__trigger',id:"faq-drawer-"+comment.id,type:'checkbox',title:comment_id,onClick:function onClick(e){return _this8.faqOpenClose(comment_id);}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label',{className:'faq-drawer__title',htmlFor:"faq-drawer-"+comment.id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{id:"faq-"+comment.id},'View Replies '),' ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'replies_count',id:"faqreply-"+comment.id},'(',children.length,')'),' '),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'faq-drawer__content-wrapper',id:"fq-"+comment.id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'faq-drawer__content'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('ul',{className:'ul_list_replay_user'},loadingdata&&children&&children.map(function(child,i,row){{var _comment_fromuserid=child.fromUser.id;var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var _comment_currentUserId='';if(currentUser){_comment_currentUserId=currentUser.id;}//console.log('child');
//console.log(child);
//self.state.singlementioned_popup='';
var comment_activity_id_child="comment_"+child.id;var comment_id_child="comnt_"+child.id;var likeCountChild=child.likeCount?child.likeCount:0;//this.state.singlelikeCountChild=child.likeCount?child.likeCount:0;
//console.log(likeCountChild+'likeCount children');
var likesWord="Likes";if(likeCountChild==1)likesWord="Like";return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{className:'li_list_replay_user',key:69*i},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_replay_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_replay_inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_userimg_inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:getCommentProfilePicChild(child)})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_content_inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'content_replay'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'title_userName'},' ',child.fromUser?child.fromUser.get('displayUsername')?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+child.fromUser.get('displayUsername')},child.fromUser.get('displayUsername')):'':'',' '),'  ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'content-span'},'  ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_cnt',id:comment_id_child},formatRenderCommentChild(child.content,comment_id_child,child.id)))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'day box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;'},time_ago(child.createdAt))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'reply_count',id:comment_id_child,onClick:function onClick(e){return self.replyComment(comment_id_child,main_activity_id,e);}},'Reply'))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment box',style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot dropup'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist1',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'/images/small_dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'dropdown-menu'},_comment_fromuserid===_comment_currentUserId?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button',onClick:function onClick(e){return self.deleteCommentIdOverlay(comment_id_child);},id:'close_deleteCommentwithdiscard','aria-label':'Modal'},'Delete'):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report '),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item',type:'button'},'Cancel'))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_user_content'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'liked_activity_child',id:comment_activity_id_child},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{'data-id':child.id,id:comment_activity_id_child,onClick:function onClick(e){self.handlePhotoActivityUnLikeChild(e);},className:'activityactive',style:{display:"none"},src:'../images/like-fill.svg'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{'data-id':child.id,id:comment_activity_id_child,onClick:function onClick(e){self.handlePhotoActivityLikeChild(e);},className:'activitydefault',src:'../images/cmt-like.svg',style:{display:"block"}})),self.handleGetActivityLikePostChild(child.id,child),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like box childcomment',id:"child_"+child.id,style:{display:likeCountChild===0?'none':'block'}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',id:'like_button_challenge',onClick:function onClick(e){self.singlePostLikeModalLikes(child.id,false);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'count',id:"childlike_"+child.id},likeCountChild),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'like_count',style:{display:"none"},id:"childlike_"+child.id},likesWord))))))));}})))))))))):''))));};for(var i=0;i<_this8.state.postDetailscomment.length;i++){var comment;var likesWord;var self;_loop6();}}}if(_this8.state.likeuserlist){var rows=_this8.state.likeuserlist.length;var other=0;for(var i=0;i<rows;i++){var likeuser=_this8.state.likeuserlist[i];if(rows>1){other=rows-1;}if(i==0){if(likeuser.get('fromUser')&&likeuser.get('fromUser').id!==undefined){userlikeusername.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{key:69*i},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+likeuser.get('fromUser').get("displayUsername"),id:'like_button_challenge',onClick:_this8.singlePostLikeModal,type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},'  ',likeuser.get('fromUser').get("displayUsername"))));}}}if(userlikeusername){fetchuserlikeusername.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{key:69*i},userlikeusername!=''?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'liked_others'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label',null,'Liked by  ',userlikeusername,' ',rows>1&&other?other==1?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,' and ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{id:'like_button_challenge',onClick:_this8.singlePostLikeModal,type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},other),'  other '):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,' and ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{id:'like_button_challenge',onClick:_this8.singlePostLikeModal,type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},other),'  others '):"",' ')):''));/**/}}if(_this8.state.followersListing){var followinguserid=_this8.state.followinguserid;var following_match_id=[];var rows=_this8.state.followersListing.length;if(rows!=undefined){for(var i=0;i<rows;i++){var followers=_this8.state.followersListing[i];var follow_id_ms='followpopup_'+followers.id;var userimage=null;if(followers.image){userimage=followers.image;}else{userimage="/images/default_userpic0.png";}var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUserid=currentUser.id;var chek=followinguserid.find(function(c){return c.id===followers.id;});//'K1iL8XNQOd'  
var followingresults=chek!=undefined?JSON.parse(JSON.stringify(chek)):"";bufferfollowers.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{key:69*i},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'img_like_li'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like_user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'mr-3',src:userimage,alt:'Generic placeholder image'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like_user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4',{className:'name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+followers.displayUsername},followers.displayName,' ')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5',{className:'name_tagline'},followers.displayUsername))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'followimg_button'},currentUserid===followers.id?"":followingresults.id===followers.id?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'following_user follow_button ',id:follow_id_ms,title:'UnFollow','data-id':followers.id,onClick:function onClick(e){return _this8.handleUnFollowMyProfile(e);}},'Unfollow'):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{id:follow_id_ms,title:followers.toUser,'data-id':followers.id,onClick:function onClick(e){return _this8.handleFollowMyProfile(e);},style:{display:"block"},href:'javascript:void(0);',className:'follow_user follow_button'},'Follow'))));}else{// var followingresults= chek!=undefined?JSON.parse(JSON.stringify(chek)):""; 
bufferfollowers.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{key:69*i},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'img_like_li'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like_user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'mr-3',src:userimage,alt:'Generic placeholder image'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like_user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4',{className:'name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+followers.displayUsername},followers.displayName,' ')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5',{className:'name_tagline'},followers.displayUsername))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'followimg_button'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{id:follow_id_ms,title:followers.toUser,'data-id':followers.id,onClick:function onClick(e){return _this8.handleFollowMyProfile(e);},style:{display:"block"},href:'javascript:void(0);',className:'follow_user follow_button'},'Follow'))));}}}}if(_this8.state.followerslikeListing){var _followinguserid=_this8.state.followinglikeuserid;var following_match_id=[];var rows=_this8.state.followerslikeListing.length;if(rows!=undefined){for(var i=0;i<rows;i++){var followers=_this8.state.followerslikeListing[i];var follow_id_ms='followpopup_'+followers.id;var _userimage=null;if(followers.image){_userimage=followers.image;}else{_userimage="/images/default_userpic0.png";}var _currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(_currentUser){var _currentUserid=_currentUser.id;var chek=_followinguserid.find(function(c){return c.id===followers.id;});//'K1iL8XNQOd'  
var followingresults=chek!=undefined?JSON.parse(JSON.stringify(chek)):"";bufferlikefollowers.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{key:69*i},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'img_like_li'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like_user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'mr-3',src:_userimage,alt:'Generic placeholder image'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like_user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4',{className:'name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+followers.displayUsername},followers.displayName,' ')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5',{className:'name_tagline'},followers.displayUsername))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'followimg_button'},_currentUserid===followers.id?"":followingresults.id===followers.id?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'following_user follow_button ',id:follow_id_ms,title:'UnFollow','data-id':followers.id,onClick:function onClick(e){return self.handleUnFollowMyProfileLike(e);}},'Unfollow'):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{id:follow_id_ms,title:followers.toUser,'data-id':followers.id,onClick:function onClick(e){return self.handleFollowMyProfileLike(e);},style:{display:"block"},href:'javascript:void(0);',className:'follow_user follow_button'},'Follow'))));}else{// var followingresults= chek!=undefined?JSON.parse(JSON.stringify(chek)):""; 
bufferlikefollowers.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{key:69*i},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'img_like_li'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like_user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'mr-3',src:_userimage,alt:'Generic placeholder image'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like_user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4',{className:'name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+followers.displayUsername},followers.displayName,' ')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5',{className:'name_tagline'},followers.displayUsername))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'followimg_button'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{id:follow_id_ms,title:followers.toUser,'data-id':followers.id,onClick:function onClick(e){return self.handleFollowMyProfileLike(e);},style:{display:"block"},href:'javascript:void(0);',className:'follow_user follow_button'},'Follow'))));}}}}var getLoggedinUsername=localStorage.getItem('username');var post_id_m='save_'+post_id;var follow_id_m='follow_'+_this8.state.user.id;var currentuserImage=_this8.state.currentuserImage;var post_like_id_m='like_'+post_id;var currentUserId=_this8.state.currentUserId;var sameprofile=0;if(currentUserId===_this8.state.user.id){sameprofile=1;}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay singlePostOverlayModal createPostCloseModal large_challenge_image',id:'large_challenge_image3','data-backdrop':'false','data-keyboard':'true',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel',onClick:_this8.singlePostModalClose1,'data-dismiss':'modal','aria-label':'Close',title:'Close'},'\u2715')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{style:{display:"none"},href:'javascript:void(0);',type:'button',className:'btn','data-toggle':'modal','data-target':'#large_challenge_like_list_likes1',id:'large_challenge_like_list_likes'},'get '),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner_post_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'img_leftSide'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:'lef_img',src:'../images/default_userpic0.png',alt:'Comment'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'right_side_content_post'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_top_row border_bottom'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_top_card'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'user_icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'popup_user_image',src:'../images/default_userpic0.png',alt:'img'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{className:'popup_user_name',href:'#'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'/images/dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},sameprofile===1?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_delete_cm'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button',id:'delete_post_with_discardpoup',onClick:function onClick(e){return _this8.deletePostId(post_id);},title:'Delete','data-toggle':'modal','data-target':'#deletePostCloseModalpopup'},'Delete')):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);','aria-label':'Close',className:'dropdown-item',type:'button',title:'Cancel'},'Cancel'))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_listing_ul_wrap'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('ul',{className:'post_listing_ul'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{className:'post_listing_li'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'detail_bottom user_top_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_top_card'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inline_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_leftbar_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'user_icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'popup_display_userimage',src:'../images/default_userpic0.png',alt:'img'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name_wrapper'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',className:'popup_display_username'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_cnt'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt',id:'full_text'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'content-span'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_sidebar_heart'},' ')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'product_content_details'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'day box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'time_interval_new'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',id:'like_button_challenge',onClick:_this8.singlePostLikeModal,type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{id:'like_count_new'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment box'}))))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{className:'post_listing_li'},bufferdata))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_post_bottom_add'},sameprofile===1&&_this8.state.isChallenge==0?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'create_challenge_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/create-challenge/'+_this8.state.postID,className:'create_button',title:'Create Challenge'},'Create Challenge')):"",__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_like_shere'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'wrapper d-flex flex-row flex-wrap align-items-center justify-content-between w-100'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action_grp'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'popup_post_id',name:'popup_post_id',value:post_id}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'popup_load_id',name:'popup_load_id',onClick:function onClick(){return _this8.handleLoadPopup(post_id);}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'reply_id',name:'reply_id'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'activity_parent_id',name:'activity_parent_id'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'like-icon liked1',id:post_like_id_m},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:post_like_id_m,onClick:function onClick(){return _this8.handlePhotoLike(post_id,'popup');},className:'default1',src:'../images/like-new.svg'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:post_like_id_m,onClick:function onClick(){return _this8.handlePhotoUnLike(post_id,'popup');},className:'active1',style:{display:"none"},src:'../images/like-fill.svg'}),_this8.handleGetLikePost(post_id)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',onClick:function onClick(){return _this8.handleCommentClick();},className:'comment-icon home-comment'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/comment-bold.svg',alt:'Comment'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',className:'share-icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/cmt-share-bold.svg',alt:'Share'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_save1'},getLoggedinUsername!=null?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',style:{display:"block"},id:post_id_m,className:'savepost_link1'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:post_id_m,style:{display:"block"},className:'savedefault1',src:'../images/bookmark.svg',onClick:function onClick(){return _this8.handleSavePost(post_id,'popup');},alt:'No BookMark'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:post_id_m,style:{display:"none"},className:'saveactive1',src:'../images/bookmark-fill.svg',onClick:function onClick(){return _this8.handleRemoveSavePost(post_id,'popup');},alt:'BookMark'}),_this8.handleGetSavePost(post_id,'popup')):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this8.handleNotLoginClick();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{style:{display:"block"},className:'savedefault1',src:'../images/bookmark.svg',alt:'No BookMark'})))),fetchuserlikeusername),showPicker&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_emoji_picker_react___default.a,{onEmojiClick:_this8.onEmojiClick}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'add_in_comment'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'emoji_icon_input_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'emogi_icon'},' ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/add_reaction.svg',alt:'img',onClick:_this8.togglePicker})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'textarea_bottom active'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_mentions__["b" /* MentionsInput */],{placeholder:'Add a comment...',value:_this8.state.singlementioned_popup,id:'comment_box_popup',onChange:_this8.updateInputPopup,style:__WEBPACK_IMPORTED_MODULE_8__defaultStyle__["a" /* default */],onKeyDown:_this8.handleSinglePostPopupEnter},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_mentions__["a" /* Mention */],{trigger:'@',data:_this8.state.singleget_allusers_popup,markup:'@__display__ ',displayTransform:function displayTransform(id,display,displayName){return'@'+display;},appendSpaceOnAdd:true,style:__WEBPACK_IMPORTED_MODULE_9__defaultMentionStyle__["a" /* default */],renderSuggestion:_this8.singlerenderUserSuggestionPopup,required:true,id:'comment_box_popup',className:'mentions__mention',placeholder:'Add a comment...'}))),_this8.state.singlementioned_popup===''?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{id:'handleCommentPost_popup',disabled:true,className:'post_button_comment',onClick:_this8.handleCommentPostPopup},'Post'):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{id:'handleCommentPost_popup',className:'post_button_comment',onClick:_this8.handleCommentPostPopup},'Post'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{style:{display:"none"},onClick:clearInput,id:'clearInput'},'Clear Input'),_this8.state.loader&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'loading_img',style:{'position':"absolute",'top':"50%",'left':"50%",'transform':"translate(-50%, -50%)"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{style:{'width':"40px"},src:'/images/loading-gif.gif'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'comment_message_alert'},_this8.state.blank_comment_message_popup))))))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal fade post_modal singlelikesModal createPostCloseModal large_challenge_image',id:'large_challenge_like_list',onKeyDown:_this8.singlePostLikeModalClose,'data-backdrop':'false','data-keyboard':'true',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel','data-dismiss':'modal','aria-label':'Close',onClick:_this8.singlePostLikeModalClose,title:'Close'},'\u2715')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'likes_user_model'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'likes_model_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h1',{className:'like_title'},'Likes')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'model_likes_main'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('ul',{className:'like_total_list'},bufferfollowers)))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal fade post_modal singlelikesModal createPostCloseModal large_challenge_image',id:'large_challenge_like_list_likes1',onKeyDown:_this8.singlePostLikeModalClose,'data-backdrop':'false','data-keyboard':'true',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel','data-dismiss':'modal','aria-label':'Close',onClick:_this8.singlePostLikeModalClose,title:'Close'},'\u2715')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'likes_user_model'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'likes_model_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h1',{className:'like_title'},'Likes')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'model_likes_main'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('ul',{className:'like_total_list'},bufferlikefollowers)))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay deletePostCloseModalpopup',id:'deletePostCloseModalpopup','data-backdrop':'false','data-keyboard':'false',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h6',null,'Are you sure you want to delete this post?')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'delete_post_id',name:'delete_post_id'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this8.checkDeletePost();},className:'btn danger btn-post-discard','data-dismiss':'modal','aria-label':'Close',title:'Delete'},'Delete'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel','data-dismiss':'modal','aria-label':'Close',title:'Cancel'},'Cancel'))))))));};this.singlerenderUserSuggestion=function(suggestion,search,highlightedDisplay){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user-suggestion'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:suggestion.avatar,alt:suggestion.display,className:'user-avatar'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'details'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'displayUserName'},highlightedDisplay),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'displayName'},suggestion.displayName)));};this.singlerenderUserSuggestionPopup=function(suggestion,search,highlightedDisplay){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user-suggestion'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:suggestion.avatar,alt:suggestion.display,className:'user-avatar'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'details'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'displayUserName'},highlightedDisplay),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'displayName'},suggestion.displayName)));};this.handleUnFollowUser=function(touser_id){var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var checksavequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');checksavequery.equalTo('type','follow');checksavequery.equalTo('toUser',"_User$"+touser_id.id);checksavequery.equalTo('fromUser',"_User$"+currentUser_id);checksavequery.find().then(function(resultAct){if(resultAct){var activityresult=resultAct[0];try{activityresult.destroy();setTimeout(function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.unfollowpost_link#follow_'+touser_id.id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.followpost_link#follow_'+touser_id.id).attr("style","display: block");},500);}catch(error){console.error('Error deleting activity:',error);}}});setTimeout(function(){_this8.handleGetFollowUser(touser_id);},1000);}else{//window.alert('You need to login for follow user.');
return false;}};this.handleFollowUser=function(touser_id){var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var Activity=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Activity");var activity=new Activity();activity.set('fromUser',currentUser);activity.set('toUser',touser_id);activity.set('type','follow');activity.save().then(function(savedFile){setTimeout(function(){//$('a.followpost_link#follow_'+touser_id.id).attr("style", "display: none");
//$('a.unfollowpost_link#follow_'+touser_id.id).attr("style", "display: block");
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.followpost_link#follow_'+touser_id.id).attr("style","display: none");_this8.handleGetFollowUser(touser_id);_this8.toggleNotification(touser_id,'started following you.','');_this8.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});},500);}).catch(function(error){});}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#login_popup_btn').trigger('click');// $('#kitchenQrModal_btn').trigger('click');  
return false;}};this.handleGetFollowUser=function(touser_id){var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultSavedid=0;var checksavequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');checksavequery.equalTo('type','follow');checksavequery.equalTo('toUser',"_User$"+touser_id.id);checksavequery.equalTo('fromUser',"_User$"+currentUser_id);checksavequery.find().then(function(resultSave){if(resultSave){var resultSaved=resultSave[0];resultSavedid=resultSaved.id;__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.followpost_link#follow_'+touser_id.id).attr("style","display: none");}else{}});}};this.handleGetSavePost=function(post_id,page){var posts_id='';if(page==='popup'){posts_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();post_id=posts_id;}//var check_value=0;
var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultSavedid=0;var checksavequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Save');checksavequery.equalTo('photo',"Photo$"+post_id);checksavequery.equalTo('fromUser',"_User$"+currentUser_id);checksavequery.find().then(function(resultSave){if(resultSave){var resultSaved=resultSave[0];resultSavedid=resultSaved.id;var photo_id=resultSaved.get('photo').id;if(resultSavedid){//$('.active#save_'+post_id).attr("style", "display: block"); 
//$('.default#save_'+post_id).attr("style", "display: none"); 
//$('a.savepost_link#save_'+post_id).attr("style", "display: none");  
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.savepost_link1#save_'+post_id).attr("style","pointer-events: auto");if(posts_id){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save1 a.savepost_link1 .savedefault1#save_'+posts_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save1 a.savepost_link1 .saveactive1#save_'+posts_id).attr("style","display: block");}}}});}};this.handleRemoveSavePost=function(post_id,page){var posts_id='';if(page==='popup'){posts_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();post_id=posts_id;}var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){//window.alert('You need to login to save post.');
return false;}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.savepost_link1#save_'+post_id).attr("style","pointer-events: none");var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');query.equalTo('objectId',post_id);query.find().then(function(photo){if(photo){var photo_ob=photo[0];var photoid=photo_ob.id;var saveCount=photo_ob.get('saveCount');if(saveCount==undefined||saveCount<0){saveCount=0;}else{saveCount=saveCount-1;}photo_ob.set("saveCount",saveCount);photo_ob.save();var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Save');checklikequery.equalTo('photo',photo_ob);checklikequery.equalTo('fromUser',currentUser);checklikequery.first().then(function(object){if(object){return object.destroy();}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save1 a.savepost_link1 .savedefault1#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save1 a.savepost_link1 .saveactive1#save_'+post_id).attr("style","display: none");}}).then(function(deletedObject){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save1 a.savepost_link1 .savedefault1#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save1 a.savepost_link1 .saveactive1#save_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.savepost_link1#save_'+post_id).attr("style","pointer-events: auto");}).catch(function(error){console.error('Error deleting record:',error);});}else{//console.log("No post found");
}},function(error){//   console.error("Error loading post Error: " + error);
//promise.error(error);
});setTimeout(function(){var self=_this8;self.handleGetSavePost(post_id,page);},1000);}};this.handleSavePost=function(post_id,page){var posts_id='';if(page==='popup'){posts_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();post_id=posts_id;}var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){//window.alert('You need to login to save post.');
return false;}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.savepost_link1#save_'+post_id).attr("style","pointer-events: none");var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');query.equalTo('objectId',post_id);var self=_this8;query.find().then(function(photo){//$('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style", "display: none"); 
if(photo){var photo_ob=photo[0];var photoid=photo_ob.id;var saveCount=photo_ob.get('saveCount');if(saveCount==undefined){saveCount=1;}else{saveCount=saveCount+1;}photo_ob.set("saveCount",saveCount);photo_ob.save();var Save=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Save");var save=new Save();var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var currentUser_id=currentUser.id;save.set('fromUser',currentUser);save.set('photo',photo_ob);save.set("_wperm",{"*":{"read":true,"write":true}});save.set("_rperm",{"*":{"read":true,"write":true}});save.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);//acl.setWriteAccess(photo_ob.get('user'), true); 
acl.setWriteAccess(currentUser,true);acl.setReadAccess(currentUser,true);save.setACL(acl);save.save().then(function(savedFile){//  window.alert('You Saved post.');
//  window.location.href = "/";
}).catch(function(error){});self.toggleNotification(post_id,'saved photo','');self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});}else{//console.log("No post found");
}},function(error){//   console.error("Error loading post Error: " + error);
//promise.error(error);
});setTimeout(function(){var self=_this8;self.handleGetSavePost(post_id,page);/*if(posts_id)
                          {
                            self.handleGetSavePost(post_id,'popup');
                          }*/},1500);}};this.handleGetLikePost=function(post_id){var check_value=0;var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultLikedid=0;var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequery.equalTo('photo',"Photo$"+post_id);//checklikequery.equalTo('fromUser',"_User$"+currentUser_id);
checklikequery.equalTo('fromUser',currentUser);//checklikequery.notContainedIn("activity");   
checklikequery.doesNotExist("activity");checklikequery.find().then(function(resultLike){if(resultLike){var resultLiked=resultLike[0];resultLikedid=resultLiked.id;if(resultLikedid!==undefined){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .active1#like_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .default1#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked1#like_'+post_id).attr("style","pointer-events: auto");}if(resultLikedid===undefined){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .active1#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .default1#like_'+post_id).attr("style","display: block");}}});}};this.handleCommentClick=function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.add_in_comment #comment_box_popup').focus();};this.handleCommentSingleClick=function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_list_mn  #comment_box').focus();};this.handlePhotoUnLike=function(post_id,page){var posts_id='';if(page==='popup'){//post_id=post_id;
//post_id=$('#popup_post_id').val();
//posts_id=$('#popup_post_id').val();
post_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();posts_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();}var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{//$('a.liked .active#like_'+post_id).attr("style", "display: none");
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked1#like_'+post_id).attr("style","pointer-events: none");var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');query.equalTo('objectId',post_id);//query.equalTo('user', currentUser);
var self=_this8;query.find().then(function(photo){if(photo){var photo_ob=photo[0];var photoid=photo_ob.id;var likeCount=photo_ob.get('likeCountNew');if(likeCount===undefined||likeCount===1){likeCount=0;}else{likeCount=likeCount-1;}photo_ob.set("likeCountNew",likeCount);photo_ob.save();var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequery.equalTo('photo',photo_ob);checklikequery.equalTo('fromUser',currentUser);checklikequery.first().then(function(object){if(object){return object.destroy();__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: block");if(posts_id){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style","display: block");}}else{/* $('a.liked .active#like_'+post_id).attr("style", "display: none"); 
                                    $('a.liked .default#like_'+post_id).attr("style", "display: block");
                                    if(posts_id)
                                    {
                                      $('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style", "display: none"); 
                                      $('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style", "display: block");
                                  }*/}}).then(function(deletedObject){self.handleGetLikeUser(post_id);self.handleGetLikePost(post_id);self.setState({likeCount:likeCount});//self.setState({likeCount1:likeCount}); 
//$('#home_fetch').trigger('click');
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: block");if(posts_id){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style","display: block");var likesWord="Likes";if(likeCount==1)likesWord="Like";__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_mn #like_counts_'+posts_id).html(likeCount);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_mn #like_words_'+posts_id).html(likesWord);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked1#like_'+post_id).attr("style","pointer-events: auto");/*if(likeCount==1)
                                  {
                                    likesWord = "Like";
                                   
                                  }*/}var likeCountNew=likeCount;__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#like_count_new').html(likeCountNew+' '+likesWord);//$('#popup_post_id').val(posts_id);  
}).catch(function(error){console.error('Error deleting record:',error);});__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#home_fetch').trigger('click');}});/*setTimeout(() => {
                            var self = this;
                           self.handleGetLikeUser(post_id);
                           if(posts_id)
                           {                            
                             self.handleGetLikeUser(posts_id); 
                           }                                                  
                      },1500);*//*  setTimeout(() => {
                          var self = this;
                          self.handleGetLikePost(post_id);
                          self.handleGetLikeUser(post_id);                          
                     },2000);*/}}};this.toggleNotification=function(postid,msg,comment){var self=_this8;self.setState(function(prevState){return{isNotificationOpen:!prevState.isNotificationOpen,post_Notification_Id:postid,post_Notification_Msg:msg,post_Notification_Comment:comment};});//self.setState({ post_Notification_Id: postid });        
};this.handleGetActivityLikePost=function(comment_id){var check_value=0;var post_id=_this8.state.postID;var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultLikedid=0;var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequery.include("activity");checklikequery.equalTo('photo',"Photo$"+post_id);checklikequery.equalTo('activity',"Activity$"+comment_id);checklikequery.equalTo('fromUser',currentUser);var self=_this8;checklikequery.find().then(function(resultLike){if(resultLike){var resultLiked=resultLike[0];resultLikedid=resultLiked.id;if(resultLikedid!==undefined){__WEBPACK_IMPORTED_MODULE_6_jquery___default()(' a.liked_activity .activitydefault#comment_'+comment_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity .activityactive#comment_'+comment_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_userimg_inner .like.box.maincomment#'+comment_id).attr("style","display: block");// $(' a.liked_activity#comment_'+comment_id).attr("disabled", false);
/*if ($('a.liked_activity#comment_'+comment_id).hasClass('disabled'))
                       {
                         $('a.liked_activity#comment_'+comment_id).removeClass('disabled'); 
                       }*/__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity#comment_'+comment_id).attr("style","pointer-events: auto");}if(resultLikedid===undefined){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity .activitydefault#comment_'+comment_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity .activityactive#comment_'+comment_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_userimg_inner .like.box.maincomment#'+comment_id).attr("style","display: none");}}});}};this.handlePhotoActivityUnLike=function(e){var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{var post_id=e.target.id;var datapost_id=e.target.dataset.id;//$('a.liked_activity .activityactive#comment_'+datapost_id).attr("style", "display: none");
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity#comment_'+datapost_id).attr("style","pointer-events: none");var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query.equalTo('objectId',datapost_id);var self=_this8;query.find().then(function(activity){if(activity){var activity_ob=activity[0];var likeCount=void 0;if(activity_ob){likeCount=activity_ob.get('likeCount');}else{likeCount=0;}if(likeCount===undefined||likeCount===0){likeCount=0;}else{likeCount=likeCount-1;}/*if(likeCount==undefined || likeCount < 0)
                              {
                                  likeCount=0;
                              }else
                              {
                                  likeCount=likeCount-1;
                              }*/var photo_ob=activity_ob.get('photo');activity_ob.set("likeCount",likeCount);activity_ob.save();//like 
var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var currentUser_id=currentUser.id;var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequery.equalTo('photo',photo_ob);checklikequery.equalTo('fromUser',currentUser);checklikequery.equalTo('activity',activity_ob);checklikequery.first().then(function(object){if(object){return object.destroy();}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity .activitydefault#comment_'+datapost_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity .activityactive#comment_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_userimg_inner .like.box.maincomment#'+datapost_id).attr("style","display: none");}}).then(function(deletedObject){//self.setState({likeCount:likeCount});  
//$('#home_fetch').trigger('click');
self.setState({singlelikeCount:likeCount});__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity .activityactive#comment_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity .activitydefault#comment_'+datapost_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity#comment_'+datapost_id).attr("style","pointer-events: auto");}).catch(function(error){console.error('Error deleting record:',error);});//like  
}});setTimeout(function(){var self=_this8;self.handleGetActivityLikePost(datapost_id);},500);}};this.handlePhotoActivityLike=function(e){var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{var post_id=e.target.id;var datapost_id=e.target.dataset.id;//$('a.liked_activity .activitydefault#comment_'+datapost_id).attr("style", "display: none");
//$('a.liked_activity .activitydefault#comment_'+datapost_id).attr("disabled", true);
//if(('a.liked_activity .activitydefault#comment_'+datapost_id).attr('disabled') === 'true'){  return;}
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity#comment_'+datapost_id).attr("style","pointer-events: none");//e.stopImmediatePropagation();
var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query.equalTo('objectId',datapost_id);var self=_this8;query.find().then(function(activity){if(activity){var activity_ob=activity[0];var likeCount=void 0;if(activity_ob){likeCount=activity_ob.get('likeCount');}else{likeCount=0;}if(likeCount==undefined){likeCount=1;}else{likeCount=likeCount+1;}var photo_ob=activity_ob.get('photo');activity_ob.set("likeCount",likeCount);activity_ob.save();//like 
var Like=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Like");var like=new Like();var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var currentUser_id=currentUser.id;like.set('fromUser',currentUser);like.set('photo',photo_ob);like.set('activity',activity_ob);like.set("_wperm",{"*":{"read":true,"write":true}});like.set("_rperm",{"*":{"read":true,"write":true}});like.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);acl.setWriteAccess(currentUser,true);acl.setReadAccess(currentUser,true);like.setACL(acl);var fromUserThumb=currentUser.get('profilePictureSmall');if(fromUserThumb!=undefined){like.set('fromUserThumb',fromUserThumb);}like.save().then(function(likeActivitySaved){//if ($('a.liked_activity#comment_'+datapost_id).hasClass('disabled')){ return false;}               
self.setState({singlelikeCount:likeCount});}).catch(function(error){});//like  
self.toggleNotification(post_id,'liked comment',activity_ob);self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});}});setTimeout(function(){var self=_this8;self.handleGetActivityLikePost(datapost_id);},500);}};this.handleGetActivityLikePostChild=function(comment_id){var check_value=0;var post_id=_this8.state.postID;var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultLikedid=0;var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequery.include("activity");checklikequery.equalTo('photo',"Photo$"+post_id);checklikequery.equalTo('activity',"Activity$"+comment_id);checklikequery.equalTo('fromUser',currentUser);checklikequery.find().then(function(resultLike){if(resultLike){var resultLiked=resultLike[0];resultLikedid=resultLiked.id;if(resultLikedid!==undefined){__WEBPACK_IMPORTED_MODULE_6_jquery___default()(' a.liked_activity_child .activitydefault#comment_'+comment_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activityactive#comment_'+comment_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box.childcomment#child_'+comment_id).attr("style","display: block");//$('.comment_like  .comment.box a .reply_count#comnt_'+comment_id).trigger('click');
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_user_content .liked_activity_child#comment_'+comment_id).attr("style","pointer-events: auto");}if(resultLikedid===undefined){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activitydefault#comment_'+comment_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activityactive#comment_'+comment_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box.childcomment#child_'+comment_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_user_content .liked_activity_child#comment_'+comment_id).attr("style","pointer-events: auto");}}});// this.state.singlementioned_popup='';
/*  var reply_id=$('#reply_id').val();
         if(reply_id==='')
          {
           this.state.singlementioned_popup='';
          }*///setTimeout(() => {
//  var self = this;
//  self.handleCommentPostUpdate();
// },1000);
}};this.handlePhotoActivityUnLikeChild=function(e){var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{var post_id=e.target.id;var datapost_id=e.target.dataset.id;//$('a.liked_activity .activityactive#comment_'+datapost_id).attr("style", "display: none");
//console.log('datapost_id'+datapost_id);
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_user_content .liked_activity_child#comment_'+datapost_id).attr("style","pointer-events: none");var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query.equalTo('objectId',datapost_id);var self=_this8;query.find().then(function(activity){if(activity){var activity_ob=activity[0];var likeCount=void 0;if(activity_ob){likeCount=activity_ob.get('likeCount');}else{likeCount=0;}if(likeCount===undefined||likeCount===0){likeCount=0;}else{likeCount=likeCount-1;}var photo_ob=activity_ob.get('photo');activity_ob.set("likeCount",likeCount);activity_ob.save();//like 
var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var currentUser_id=currentUser.id;var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequery.equalTo('photo',photo_ob);checklikequery.equalTo('fromUser',currentUser);checklikequery.equalTo('activity',activity_ob);checklikequery.first().then(function(object){if(object){return object.destroy();}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activitydefault#comment_'+datapost_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activityactive#comment_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box.childcomment#child_'+datapost_id).attr("style","display: none");}}).then(function(deletedObject){//self.setState({likeCount:likeCount});  
//$('#home_fetch').trigger('click');
self.setState({singlelikeCountChild:likeCount});var likesWord="Likes";if(likeCount==1){likesWord="Like";}__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box .count#childlike_'+datapost_id).html(likeCount);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box .like_count#childlike_'+datapost_id).html(likesWord);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box .like_count#childlike_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activityactive#comment_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activitydefault#comment_'+datapost_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_user_content .liked_activity_child#comment_'+datapost_id).attr("style","pointer-events: auto");if(likeCount===0){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box.childcomment#child_'+datapost_id).attr("style","display: none");}}).catch(function(error){console.error('Error deleting record:',error);});//like  
}});setTimeout(function(){var self=_this8;self.handleGetActivityLikePostChild(datapost_id);},2000);}};this.handlePhotoActivityLikeChild=function(e){var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{var post_id=e.target.id;var datapost_id=e.target.dataset.id;__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_user_content .liked_activity_child#comment_'+datapost_id).attr("style","pointer-events: none");var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query.equalTo('objectId',datapost_id);var self=_this8;query.find().then(function(activity){if(activity){var activity_ob=activity[0];var likeCount=void 0;if(activity_ob){likeCount=activity_ob.get('likeCount');}else{likeCount=0;}if(likeCount==undefined){likeCount=1;}else{likeCount=likeCount+1;}var photo_ob=activity_ob.get('photo');activity_ob.set("likeCount",likeCount);activity_ob.save();//like 
var Like=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Like");var like=new Like();var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var currentUser_id=currentUser.id;like.set('fromUser',currentUser);like.set('photo',photo_ob);like.set('activity',activity_ob);like.set("_wperm",{"*":{"read":true,"write":true}});like.set("_rperm",{"*":{"read":true,"write":true}});like.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);acl.setWriteAccess(currentUser,true);acl.setReadAccess(currentUser,true);like.setACL(acl);var fromUserThumb=currentUser.get('profilePictureSmall');if(fromUserThumb!=undefined){like.set('fromUserThumb',fromUserThumb);}like.save().then(function(likeActivitySaved){var likesWord="Likes";if(likeCount==1){likesWord="Like";}__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box .count#childlike_'+datapost_id).html(likeCount);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box .like_count#childlike_'+datapost_id).html(likesWord);if(likeCount===0){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box.childcomment#child_'+datapost_id).attr("style","display: none");}self.setState({singlelikeCountChild:likeCount});}).catch(function(error){});//like  
self.toggleNotification(post_id,'liked comment',activity_ob);self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});}});setTimeout(function(){var self=_this8;self.handleGetActivityLikePostChild(datapost_id);},2000);}};this.handleLoadPopup=function(post_id){//console.log('handleLoadPopup');
/*  setTimeout(() => {
                          var self = this;
                          self.handleGetLikePost(post_id);
                          self.handleGetLikeUser(post_id);                          
                     },1500);*/};this.handlePhotoLike=function(post_id,page){var posts_id='';if(page==='popup'){post_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();posts_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();}var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{//$('a.liked .default#like_'+post_id).attr("style", "display: none");
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked1#like_'+post_id).attr("style","pointer-events: none");var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');query.equalTo('objectId',post_id);var self=_this8;query.find().then(function(photo){if(photo){var photo_ob=photo[0];var photoid=photo_ob.id;var likeCount=photo_ob.get('likeCountNew');if(likeCount===undefined||likeCount===0){likeCount=1;}else{likeCount=likeCount+1;}photo_ob.set("likeCountNew",likeCount);photo_ob.save();var Like=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Like");var like=new Like();var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var currentUser_id=currentUser.id;like.set('fromUser',currentUser);like.set('photo',photo_ob);like.set("_wperm",{"*":{"read":true,"write":true}});like.set("_rperm",{"*":{"read":true,"write":true}});like.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);acl.setWriteAccess(currentUser,true);acl.setReadAccess(currentUser,true);like.setACL(acl);var fromUserThumb=currentUser.get('profilePictureSmall');if(fromUserThumb!=undefined){like.set('fromUserThumb',fromUserThumb);}like.save().then(function(likeSaved){self.setState({likeCount:likeCount});__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: block");if(posts_id){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_mn #like_counts_'+posts_id).html(likeCount);var likesWord="Likes";//if (likeCount == 1) likesWord = "Like";
if(likeCount==1){likesWord="Like";__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_mn #like_words_'+posts_id).html(likesWord);}}var likeCountNew=likeCount;__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#like_count_new').html(likeCountNew+' '+likesWord);//$('#home_fetch').trigger('click');
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val(posts_id);// this.handleGetLikePost(post_id);
self.handleGetLikePost(post_id);self.handleGetLikeUser(post_id);}).catch(function(error){});}else{}},function(error){});setTimeout(function(){var self=_this8;_this8.toggleNotification(post_id,'liked photo','');self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});},1000);}};this.handleCommentPost=function(e){var _this9=this;var Photo=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Photo");var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query(Photo);var photo_post_id=this.state.postID;var postcomment=this.state.postcomment;if(postcomment){query.include("user");query.include("image");query.include("thumbnail");query.include("likeCountNew");query.include("saveCount");query.include("commentcount");query.include("_created_at");query.include("createdAt");query.exists("user");query.descending("createdAt");query.find({success:function success(results){if(results.length>0){results.forEach(function(photo){if(photo.id===photo_post_id){var Activity=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Activity");var activity=new Activity();var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();activity.set('fromUser',currentUser);activity.set('toUser',photo.get("user"));activity.set('content',postcomment);activity.set('type','comment');activity.set('photo',photo);activity.set('likeCount',0);var currentUser_id=currentUser.id;activity.set("_wperm",{"*":{"write":true}});activity.set("_rperm",{"*":{"read":true}});activity.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);acl.setWriteAccess(photo.get('user'),true);acl.setWriteAccess(currentUser_id,true);acl.setReadAccess(currentUser_id,true);activity.setACL(acl);var self=this;try{activity.save().then(function(savedActivity){var activityId=savedActivity.id;setTimeout(function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity .activityactive#comment_'+activityId).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity .activitydefault#comment_'+activityId).attr("style","display: block");},1000);}).catch(function(error){});__WEBPACK_IMPORTED_MODULE_6_jquery___default()(".comment_box").val('');__WEBPACK_IMPORTED_MODULE_6_jquery___default()("#comment_box").val('');var updated_photo_id=photo.get('id');var Photo_single=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Photo");var Photoquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query(Photo_single);var photoId=photo.id;Photoquery.get(photoId).then(function(photo){var commentcount_val=parseInt(photo.get('commentcount'));if(isNaN(commentcount_val)){commentcount_val=0;}var updated_comment_count=commentcount_val+1;photo.set("commentcount",updated_comment_count.toString());photo.save();}).catch(function(error){});}catch(error){}}});}else{//console.log("No photos found.");
}},error:function error(_error){// console.error("Error fetching photos: " + error.code + " " + error.message);
}});setTimeout(function(){var self=_this9;self.handleCommentPostUpdate();_this9.state.postcomment='';_this9.state.singlementioned='';},1500);}//photo.id = "photo_object_id";
// console.log(photo.id);
var self=this;var post_id=this.state.postID;if(postcomment!=''){}else{self.setState({blank_comment_message:"Your message box is empty. Please write a message to continue."});// window.alert('Please write some comment first!');
}setTimeout(function(){self.setState({blank_comment_message:null});},3000);};this.handleCommentPostPopup=function(e){var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_button_comment#handleCommentPost_popup').attr("disabled",true);this.setState({loader:true});e.preventDefault();//$(".add_in_comment .emoji_icon_input_row .textarea_bottom.active").attr("style", "visibility: hidden");
var Photo=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Photo");var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query(Photo);var photo_post_id=this.state.postID;var postcomment=this.state.singlementioned_popup;//this.state.postcomment_popup;
var reply_id=this.state.reply_id;//$('#reply_id').val();
var activity_parent_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#activity_parent_id').val();var self=this;if(postcomment){query.include("user");query.include("image");query.include("thumbnail");query.include("likeCountNew");query.include("saveCount");query.include("commentcount");query.include("_created_at");query.include("createdAt");query.exists("user");query.descending("createdAt");query.find({success:function success(results){if(results.length>0){results.forEach(function(photo){if(photo.id===photo_post_id){var Activity=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Activity");var activity=new Activity();var _currentUser2=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();activity.set('fromUser',_currentUser2);activity.set('toUser',photo.get("user"));activity.set('content',postcomment);activity.set('type','comment');if(reply_id){activity.set('activity','Activity$'+activity_parent_id);}activity.set('photo',photo);activity.set('likeCount',0);var currentUser_id=_currentUser2.id;try{activity.save().then(function(savedActivity){var activityId=savedActivity.id;self.setState({reply_thread_id:activityId});// setTimeout(() => {
// $('a.liked_activity .activityactive#comment_'+activityId).attr("style", "display: none"); 
//$('a.liked_activity .activitydefault#comment_'+activityId).attr("style", "display: block"); 
// },1000); 
if(reply_id){self.toggleNotification(photo_post_id,'commented post reply',savedActivity);}else{self.toggleNotification(photo_post_id,'commented post',savedActivity);}self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});var captionusername='';var captionusernameupdated='';if(postcomment){captionusername=postcomment.match(/@\w+/);if(captionusername){captionusernameupdated=captionusername[0].substr(1);if(captionusernameupdated){//self.toggleNotification(photo_post_id,'tagged you in a comment',savedActivity);
self.toggleNotification(photo_post_id,'mentioned you in a comment',savedActivity);self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});}}}}).catch(function(error){});__WEBPACK_IMPORTED_MODULE_6_jquery___default()(".comment_box_popup").val('');__WEBPACK_IMPORTED_MODULE_6_jquery___default()("#comment_box_popup").val('');var updated_photo_id=photo.get('id');var Photo_single=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Photo");var Photoquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query(Photo_single);var photoId=photo.id;Photoquery.get(photoId).then(function(photo){var commentcount_val=parseInt(photo.get('commentcount'));if(isNaN(commentcount_val)){commentcount_val=0;}var updated_comment_count=commentcount_val+1;photo.set("commentcount",updated_comment_count.toString());self.setState({commentCount:updated_comment_count.toString()});photo.save();self.setState({singlementioned_popup:''});}).catch(function(error){});setTimeout(function(){self.setState({singlementioned_popup:'',reply_id:''});self.handleCommentPostUpdate();},500);}catch(error){}}});}else{}},error:function error(_error2){}});}var self=this;var post_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}};this.handlePostModelOpen1=function(post_id){_this8.setState({post_id:post_id});};this.handlePostModelOpen=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(post_id){var getLoggedinUsername,query,self,activity_data,query1;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#home_id').val(post_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val(post_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere .like-icon.liked1').attr('id','like_'+post_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere .like-icon.liked1 img.default1').attr('id','like_'+post_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere .like-icon.liked1 img.active1').attr('id','like_'+post_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save1 .savepost_link1 .savedefault1').attr('id','save_'+post_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save1 .savepost_link1 .saveactive1').attr('id','save_'+post_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save1 .savepost_link1').attr('id','save_'+post_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#full_text').html('');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#lef_img').attr('src','../images/default_userpic0.png');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_user_image').attr('src','../images/default_userpic0.png');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_display_userimage').attr('src','../images/default_userpic0.png');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.user_name a.popup_user_name').html('');getLoggedinUsername=localStorage.getItem('username');query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');query.include("likeCountNew");query.include("commentcount");query.equalTo('objectId',post_id);//await query.get(post_id);
self=_this8;self.setState({single_post_id:post_id});self.setState({singlemodalstates:true});//comment listing
activity_data=[];query1=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');// query1.equalTo('photo', photo[0]);
_context5.next=25;return query1.equalTo('photo',"Photo$"+post_id);case 25://await query1.get(postId);
query1.equalTo("type","comment");query1.include("fromUser");query1.include("image");query1.include("content");query1.include("_created_at");query1.include("createdAt");//query.ascending("_created_at");
query1.descending("_created_at");self=_this8;query1.find().then(function(result){if(result){activity_data.push(result);}else{}self.setState({commentsdatas:activity_data[0]});},function(error){});//comment listing  
query.find().then(function(photo){if(photo){//self.setState({popup_username:null});
var photo_img=photo[0].get('image').url()?photo[0].get('image').url():'';__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#lef_img').attr('src',photo_img);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.time_interval_new').html(time_ago(photo[0].get('createdAt')));var obj=self.formatRenderComments2main(photo[0].get('caption'));//console.log(photo_data+'photo_data');
var full_text=obj?obj.a?obj.a.props?obj.a.props.children?obj.a.props.children:'':'':'':'';__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#full_text').html(full_text);var photo_data=photo[0].get('caption');var likeCountNew=photo[0].get('likeCountNew')?photo[0].get('likeCountNew'):0;var likesWord="Likes";if(likeCountNew==1)likesWord="Like";__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#like_count_new').html(likeCountNew+' '+likesWord);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.user_name a.popup_user_name').html(photo[0].get('user').get('displayUsername'));__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.user_name a.popup_user_name').attr("href","/user/"+photo[0].get('user').get('displayUsername'));__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.user_name a.popup_display_username').html(photo[0].get('user').get('displayUsername'));__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.user_name a.popup_display_username').attr("href","/user/"+photo[0].get('user').get('displayUsername'));var user_image=photo[0].get('user')?photo[0].get('user').get('profilePictureSmall')?photo[0].get('user').get('profilePictureSmall').url():'../images/default_userpic0.png':'../images/default_userpic0.png';__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_user_image').attr('src',user_image);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_display_userimage').attr('src',user_image);}});return _context5.abrupt('return',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:''}));case 36:case'end':return _context5.stop();}}},_callee5,_this8);}));return function(_x4){return _ref5.apply(this,arguments);};}();this.handleNotLoginClick=function(){var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}};this.handleGetLikeUser=function(post_id){//var  posts_id=$('#popup_post_id').val();
if(post_id){var like=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');var self=_this8;like.equalTo('photo','Photo$'+post_id);like.doesNotExist('activity');like.find().then(function(result){if(result){self.setState({likeuserlist:result});}});}};};/* harmony default export */ __webpack_exports__["a"] = (SinglePost);

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(21);
var dPs = __webpack_require__(194);
var enumBugKeys = __webpack_require__(87);
var IE_PROTO = __webpack_require__(85)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(112)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(197).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(18).f;
var has = __webpack_require__(26);
var TAG = __webpack_require__(15)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(198);
var global = __webpack_require__(17);
var hide = __webpack_require__(24);
var Iterators = __webpack_require__(46);
var TO_STRING_TAG = __webpack_require__(15)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 62 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(16);
var core = __webpack_require__(5);
var fails = __webpack_require__(25);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _ParseGeoPoint = __webpack_require__(44);

var _ParseGeoPoint2 = _interopRequireDefault(_ParseGeoPoint);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Creates a new Polygon with any of the following forms:<br>
 *   <pre>
 *   new Polygon([[0,0],[0,1],[1,1],[1,0]])
 *   new Polygon([GeoPoint, GeoPoint, GeoPoint])
 *   </pre>
 *
 * <p>Represents a coordinates that may be associated
 * with a key in a ParseObject or used as a reference point for geo queries.
 * This allows proximity-based queries on the key.</p>
 *
 * <p>Example:<pre>
 *   var polygon = new Parse.Polygon([[0,0],[0,1],[1,1],[1,0]]);
 *   var object = new Parse.Object("PlaceObject");
 *   object.set("area", polygon);
 *   object.save();</pre></p>
 * @alias Parse.Polygon
 */
var ParsePolygon = function () {

  /**
   * @param {(Number[][]|Parse.GeoPoint[])} coordinates An Array of coordinate pairs
   */
  function ParsePolygon(arg1) {
    (0, _classCallCheck3.default)(this, ParsePolygon);

    this._coordinates = ParsePolygon._validate(arg1);
  }

  /**
   * Coordinates value for this Polygon.
   * Throws an exception if not valid type.
   * @property coordinates
   * @type Array
   */

  (0, _createClass3.default)(ParsePolygon, [{
    key: 'toJSON',

    /**
     * Returns a JSON representation of the Polygon, suitable for Parse.
     * @return {Object}
     */
    value: function () {
      ParsePolygon._validate(this._coordinates);
      return {
        __type: 'Polygon',
        coordinates: this._coordinates
      };
    }

    /**
     * Checks if two polygons are equal
     * @param {(Parse.Polygon|Object)} other
     * @returns {Boolean}
     */

  }, {
    key: 'equals',
    value: function (other) {
      if (!(other instanceof ParsePolygon) || this.coordinates.length !== other.coordinates.length) {
        return false;
      }
      var isEqual = true;

      for (var i = 1; i < this._coordinates.length; i += 1) {
        if (this._coordinates[i][0] != other.coordinates[i][0] || this._coordinates[i][1] != other.coordinates[i][1]) {
          isEqual = false;
          break;
        }
      }
      return isEqual;
    }

    /**
     *
     * @param {Parse.GeoPoint} point
     * @returns {Boolean} Returns if the point is contained in the polygon
     */

  }, {
    key: 'containsPoint',
    value: function (point) {
      var minX = this._coordinates[0][0];
      var maxX = this._coordinates[0][0];
      var minY = this._coordinates[0][1];
      var maxY = this._coordinates[0][1];

      for (var i = 1; i < this._coordinates.length; i += 1) {
        var p = this._coordinates[i];
        minX = Math.min(p[0], minX);
        maxX = Math.max(p[0], maxX);
        minY = Math.min(p[1], minY);
        maxY = Math.max(p[1], maxY);
      }

      var outside = point.latitude < minX || point.latitude > maxX || point.longitude < minY || point.longitude > maxY;
      if (outside) {
        return false;
      }

      var inside = false;
      for (var _i = 0, j = this._coordinates.length - 1; _i < this._coordinates.length; j = _i++) {
        var startX = this._coordinates[_i][0];
        var startY = this._coordinates[_i][1];
        var endX = this._coordinates[j][0];
        var endY = this._coordinates[j][1];

        var intersect = startY > point.longitude != endY > point.longitude && point.latitude < (endX - startX) * (point.longitude - startY) / (endY - startY) + startX;

        if (intersect) {
          inside = !inside;
        }
      }
      return inside;
    }

    /**
     * Validates that the list of coordinates can form a valid polygon
     * @param {Array} coords the list of coordinated to validate as a polygon
     * @throws {TypeError}
     */

  }, {
    key: 'coordinates',
    get: function () {
      return this._coordinates;
    },
    set: function (coords) {
      this._coordinates = ParsePolygon._validate(coords);
    }
  }], [{
    key: '_validate',
    value: function (coords) {
      if (!Array.isArray(coords)) {
        throw new TypeError('Coordinates must be an Array');
      }
      if (coords.length < 3) {
        throw new TypeError('Polygon must have at least 3 GeoPoints or Points');
      }
      var points = [];
      for (var i = 0; i < coords.length; i += 1) {
        var coord = coords[i];
        var geoPoint = void 0;
        if (coord instanceof _ParseGeoPoint2.default) {
          geoPoint = coord;
        } else if (Array.isArray(coord) && coord.length === 2) {
          geoPoint = new _ParseGeoPoint2.default(coord[0], coord[1]);
        } else {
          throw new TypeError('Coordinates must be an Array of GeoPoints or Points');
        }
        points.push([geoPoint.latitude, geoPoint.longitude]);
      }
      return points;
    }
  }]);
  return ParsePolygon;
}(); /**
      * Copyright (c) 2015-present, Parse, LLC.
      * All rights reserved.
      *
      * This source code is licensed under the BSD-style license found in the
      * LICENSE file in the root directory of this source tree. An additional grant
      * of patent rights can be found in the PATENTS file in the same directory.
      *
      * 
      */

exports.default = ParsePolygon;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _keys = __webpack_require__(49);

var _keys2 = _interopRequireDefault(_keys);

var _CoreManager = __webpack_require__(9);

var _CoreManager2 = _interopRequireDefault(_CoreManager);

var _encode = __webpack_require__(36);

var _encode2 = _interopRequireDefault(_encode);

var _ParseError = __webpack_require__(28);

var _ParseError2 = _interopRequireDefault(_ParseError);

var _ParseGeoPoint = __webpack_require__(44);

var _ParseGeoPoint2 = _interopRequireDefault(_ParseGeoPoint);

var _ParsePolygon = __webpack_require__(65);

var _ParsePolygon2 = _interopRequireDefault(_ParsePolygon);

var _ParseObject = __webpack_require__(8);

var _ParseObject2 = _interopRequireDefault(_ParseObject);

var _ParsePromise = __webpack_require__(7);

var _ParsePromise2 = _interopRequireDefault(_ParsePromise);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Converts a string into a regex that matches it.
 * Surrounding with \Q .. \E does this, we just need to escape any \E's in
 * the text separately.
 * @private
 */
function quote(s) {
  return '\\Q' + s.replace('\\E', '\\E\\\\E\\Q') + '\\E';
}

/**
 * Extracts the class name from queries. If not all queries have the same
 * class name an error will be thrown.
 */
/*
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function _getClassNameFromQueries(queries) {
  var className = null;
  queries.forEach(function (q) {
    if (!className) {
      className = q.className;
    }

    if (className !== q.className) {
      throw new Error('All queries must be for the same class.');
    }
  });
  return className;
}

/*
 * Handles pre-populating the result data of a query with select fields,
 * making sure that the data object contains keys for all objects that have
 * been requested with a select, so that our cached state updates correctly.
 */
function handleSelectResult(data, select) {
  var serverDataMask = {};

  select.forEach(function (field) {
    var hasSubObjectSelect = field.indexOf(".") !== -1;
    if (!hasSubObjectSelect && !data.hasOwnProperty(field)) {
      // this field was selected, but is missing from the retrieved data
      data[field] = undefined;
    } else if (hasSubObjectSelect) {
      // this field references a sub-object,
      // so we need to walk down the path components
      var pathComponents = field.split(".");
      var obj = data;
      var serverMask = serverDataMask;

      pathComponents.forEach(function (component, index, arr) {
        // add keys if the expected data is missing
        if (obj && !obj.hasOwnProperty(component)) {
          obj[component] = undefined;
        }
        if (obj !== undefined) {
          obj = obj[component];
        }

        //add this path component to the server mask so we can fill it in later if needed
        if (index < arr.length - 1) {
          if (!serverMask[component]) {
            serverMask[component] = {};
          }
          serverMask = serverMask[component];
        }
      });
    }
  });

  if ((0, _keys2.default)(serverDataMask).length > 0) {
    var copyMissingDataWithMask = function copyMissingDataWithMask(src, dest, mask, copyThisLevel) {
      //copy missing elements at this level
      if (copyThisLevel) {
        for (var key in src) {
          if (src.hasOwnProperty(key) && !dest.hasOwnProperty(key)) {
            dest[key] = src[key];
          }
        }
      }
      for (var key in mask) {
        if (dest[key] !== undefined && dest[key] !== null && src !== undefined && src !== null) {
          //traverse into objects as needed
          copyMissingDataWithMask(src[key], dest[key], mask[key], true);
        }
      }
    };

    // When selecting from sub-objects, we don't want to blow away the missing
    // information that we may have retrieved before. We've already added any
    // missing selected keys to sub-objects, but we still need to add in the
    // data for any previously retrieved sub-objects that were not selected.

    var serverData = _CoreManager2.default.getObjectStateController().getServerData({ id: data.objectId, className: data.className });

    copyMissingDataWithMask(serverData, data, serverDataMask, false);
  }
}

/**
 * Creates a new parse Parse.Query for the given Parse.Object subclass.
 *
 * <p>Parse.Query defines a query that is used to fetch Parse.Objects. The
 * most common use case is finding all objects that match a query through the
 * <code>find</code> method. for example, this sample code fetches all objects
 * of class <code>myclass</code>. it calls a different function depending on
 * whether the fetch succeeded or not.
 *
 * <pre>
 * var query = new parse.query(myclass);
 * query.find({
 *   success: function(results) {
 *     // results is an array of parse.object.
 *   },
 *
 *   error: function(error) {
 *     // error is an instance of parse.error.
 *   }
 * });</pre></p>
 *
 * <p>a parse.query can also be used to retrieve a single object whose id is
 * known, through the get method. for example, this sample code fetches an
 * object of class <code>myclass</code> and id <code>myid</code>. it calls a
 * different function depending on whether the fetch succeeded or not.
 *
 * <pre>
 * var query = new parse.query(myclass);
 * query.get(myid, {
 *   success: function(object) {
 *     // object is an instance of parse.object.
 *   },
 *
 *   error: function(object, error) {
 *     // error is an instance of parse.error.
 *   }
 * });</pre></p>
 *
 * <p>a parse.query can also be used to count the number of objects that match
 * the query without retrieving all of those objects. for example, this
 * sample code counts the number of objects of the class <code>myclass</code>
 * <pre>
 * var query = new parse.query(myclass);
 * query.count({
 *   success: function(number) {
 *     // there are number instances of myclass.
 *   },
 *
 *   error: function(error) {
 *     // error is an instance of Parse.Error.
 *   }
 * });</pre></p>
 * @alias Parse.Query
 */

var ParseQuery = function () {

  /**
   * @param {(String|Parse.Object)} objectClass An instance of a subclass of Parse.Object, or a Parse className string.
   */

  /**
   * @property className
   * @type String
   */
  function ParseQuery(objectClass) {
    (0, _classCallCheck3.default)(this, ParseQuery);

    if (typeof objectClass === 'string') {
      if (objectClass === 'User' && _CoreManager2.default.get('PERFORM_USER_REWRITE')) {
        this.className = '_User';
      } else {
        this.className = objectClass;
      }
    } else if (objectClass instanceof _ParseObject2.default) {
      this.className = objectClass.className;
    } else if (typeof objectClass === 'function') {
      if (typeof objectClass.className === 'string') {
        this.className = objectClass.className;
      } else {
        var obj = new objectClass();
        this.className = obj.className;
      }
    } else {
      throw new TypeError('A ParseQuery must be constructed with a ParseObject or class name.');
    }

    this._where = {};
    this._include = [];
    this._limit = -1; // negative limit is not sent in the server request
    this._skip = 0;
    this._extraOptions = {};
  }

  /**
   * Adds constraint that at least one of the passed in queries matches.
   * @param {Array} queries
   * @return {Parse.Query} Returns the query, so you can chain this call.
   */

  (0, _createClass3.default)(ParseQuery, [{
    key: '_orQuery',
    value: function (queries) {
      var queryJSON = queries.map(function (q) {
        return q.toJSON().where;
      });

      this._where.$or = queryJSON;
      return this;
    }

    /**
     * Adds constraint that all of the passed in queries match.
     * @method _andQuery
     * @param {Array} queries
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: '_andQuery',
    value: function (queries) {
      var queryJSON = queries.map(function (q) {
        return q.toJSON().where;
      });

      this._where.$and = queryJSON;
      return this;
    }

    /**
     * Helper for condition queries
     */

  }, {
    key: '_addCondition',
    value: function (key, condition, value) {
      if (!this._where[key] || typeof this._where[key] === 'string') {
        this._where[key] = {};
      }
      this._where[key][condition] = (0, _encode2.default)(value, false, true);
      return this;
    }

    /**
     * Returns a JSON representation of this query.
     * @return {Object} The JSON representation of the query.
     */

  }, {
    key: 'toJSON',
    value: function () {
      var params = {
        where: this._where
      };

      if (this._include.length) {
        params.include = this._include.join(',');
      }
      if (this._select) {
        params.keys = this._select.join(',');
      }
      if (this._limit >= 0) {
        params.limit = this._limit;
      }
      if (this._skip > 0) {
        params.skip = this._skip;
      }
      if (this._order) {
        params.order = this._order.join(',');
      }
      for (var key in this._extraOptions) {
        params[key] = this._extraOptions[key];
      }

      return params;
    }

    /**
     * Return a query with conditions from json, can be useful to send query from server side to client
     * Not static, all query conditions was set before calling this method will be deleted.
     * For example on the server side we have
     * var query = new Parse.Query("className");
     * query.equalTo(key: value);
     * query.limit(100);
     * ... (others queries)
     * Create JSON representation of Query Object
     * var jsonFromServer = query.fromJSON();
     *
     * On client side getting query:
     * var query = new Parse.Query("className");
     * query.fromJSON(jsonFromServer);
     *
     * and continue to query...
     * query.skip(100).find().then(...);
     * @param {QueryJSON} json from Parse.Query.toJSON() method
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'withJSON',
    value: function (json) {

      if (json.where) {
        this._where = json.where;
      }

      if (json.include) {
        this._include = json.include.split(",");
      }

      if (json.keys) {
        this._select = json.keys.split(",");
      }

      if (json.limit) {
        this._limit = json.limit;
      }

      if (json.skip) {
        this._skip = json.skip;
      }

      if (json.order) {
        this._order = json.order.split(",");
      }

      for (var _key in json) {
        if (json.hasOwnProperty(_key)) {
          if (["where", "include", "keys", "limit", "skip", "order"].indexOf(_key) === -1) {
            this._extraOptions[_key] = json[_key];
          }
        }
      }return this;
    }

    /**
     * Static method to restore Parse.Query by json representation
     * Internally calling Parse.Query.withJSON
     * @param {String} className
     * @param {QueryJSON} json from Parse.Query.toJSON() method
     * @returns {Parse.Query} new created query
     */

  }, {
    key: 'get',

    /**
     * Constructs a Parse.Object whose id is already known by fetching data from
     * the server.  Either options.success or options.error is called when the
     * find completes.
     *
     * @param {String} objectId The id of the object to be fetched.
     * @param {Object} options A Backbone-style options object.
     * Valid options are:<ul>
     *   <li>success: A Backbone-style success callback
     *   <li>error: An Backbone-style error callback.
     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
     *     be used for this request.
     *   <li>sessionToken: A valid session token, used for making a request on
     *       behalf of a specific user.
     * </ul>
     *
     * @return {Parse.Promise} A promise that is resolved with the result when
     * the query completes.
     */
    value: function (objectId, options) {
      this.equalTo('objectId', objectId);

      var firstOptions = {};
      if (options && options.hasOwnProperty('useMasterKey')) {
        firstOptions.useMasterKey = options.useMasterKey;
      }
      if (options && options.hasOwnProperty('sessionToken')) {
        firstOptions.sessionToken = options.sessionToken;
      }

      return this.first(firstOptions).then(function (response) {
        if (response) {
          return response;
        }

        var errorObject = new _ParseError2.default(_ParseError2.default.OBJECT_NOT_FOUND, 'Object not found.');
        return _ParsePromise2.default.error(errorObject);
      })._thenRunCallbacks(options, null);
    }

    /**
     * Retrieves a list of ParseObjects that satisfy this query.
     * Either options.success or options.error is called when the find
     * completes.
     *
     * @param {Object} options A Backbone-style options object. Valid options
     * are:<ul>
     *   <li>success: Function to call when the find completes successfully.
     *   <li>error: Function to call when the find fails.
     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
     *     be used for this request.
     *   <li>sessionToken: A valid session token, used for making a request on
     *       behalf of a specific user.
     * </ul>
     *
     * @return {Parse.Promise} A promise that is resolved with the results when
     * the query completes.
     */

  }, {
    key: 'find',
    value: function (options) {
      var _this = this;

      options = options || {};

      var findOptions = {};
      if (options.hasOwnProperty('useMasterKey')) {
        findOptions.useMasterKey = options.useMasterKey;
      }
      if (options.hasOwnProperty('sessionToken')) {
        findOptions.sessionToken = options.sessionToken;
      }

      var controller = _CoreManager2.default.getQueryController();

      var select = this._select;

      return controller.find(this.className, this.toJSON(), findOptions).then(function (response) {
        return response.results.map(function (data) {
          // In cases of relations, the server may send back a className
          // on the top level of the payload
          var override = response.className || _this.className;
          if (!data.className) {
            data.className = override;
          }

          // Make sure the data object contains keys for all objects that
          // have been requested with a select, so that our cached state
          // updates correctly.
          if (select) {
            handleSelectResult(data, select);
          }

          return _ParseObject2.default.fromJSON(data, !select);
        });
      })._thenRunCallbacks(options);
    }

    /**
     * Counts the number of objects that match this query.
     * Either options.success or options.error is called when the count
     * completes.
     *
     * @param {Object} options A Backbone-style options object. Valid options
     * are:<ul>
     *   <li>success: Function to call when the count completes successfully.
     *   <li>error: Function to call when the find fails.
     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
     *     be used for this request.
     *   <li>sessionToken: A valid session token, used for making a request on
     *       behalf of a specific user.
     * </ul>
     *
     * @return {Parse.Promise} A promise that is resolved with the count when
     * the query completes.
     */

  }, {
    key: 'count',
    value: function (options) {
      options = options || {};

      var findOptions = {};
      if (options.hasOwnProperty('useMasterKey')) {
        findOptions.useMasterKey = options.useMasterKey;
      }
      if (options.hasOwnProperty('sessionToken')) {
        findOptions.sessionToken = options.sessionToken;
      }

      var controller = _CoreManager2.default.getQueryController();

      var params = this.toJSON();
      params.limit = 0;
      params.count = 1;

      return controller.find(this.className, params, findOptions).then(function (result) {
        return result.count;
      })._thenRunCallbacks(options);
    }

    /**
     * Executes a distinct query and returns unique values
     *
     * @param {String} key A field to find distinct values
     * @param {Object} options A Backbone-style options object. Valid options
     * are:<ul>
     *   <li>success: Function to call when the count completes successfully.
     *   <li>error: Function to call when the find fails.
     *   <li>sessionToken: A valid session token, used for making a request on
     *       behalf of a specific user.
     * </ul>
     *
     * @return {Parse.Promise} A promise that is resolved with the query completes.
     */

  }, {
    key: 'distinct',
    value: function (key, options) {
      options = options || {};

      var distinctOptions = {
        useMasterKey: true
      };
      if (options.hasOwnProperty('sessionToken')) {
        distinctOptions.sessionToken = options.sessionToken;
      }
      var controller = _CoreManager2.default.getQueryController();
      var params = {
        distinct: key,
        where: this._where
      };

      return controller.aggregate(this.className, params, distinctOptions).then(function (results) {
        return results.results;
      })._thenRunCallbacks(options);
    }

    /**
    * Executes an aggregate query and returns aggregate results
    *
    * @param {Mixed} pipeline Array or Object of stages to process query
    * @param {Object} options A Backbone-style options object. Valid options
    * are:<ul>
    *   <li>success: Function to call when the count completes successfully.
    *   <li>error: Function to call when the find fails.
    *   <li>sessionToken: A valid session token, used for making a request on
    *       behalf of a specific user.
    * </ul>
    *
    * @return {Parse.Promise} A promise that is resolved with the query completes.
    */

  }, {
    key: 'aggregate',
    value: function (pipeline, options) {
      options = options || {};

      var aggregateOptions = {
        useMasterKey: true
      };
      if (options.hasOwnProperty('sessionToken')) {
        aggregateOptions.sessionToken = options.sessionToken;
      }
      var controller = _CoreManager2.default.getQueryController();
      var stages = {};

      if (Array.isArray(pipeline)) {
        pipeline.forEach(function (stage) {
          for (var op in stage) {
            stages[op] = stage[op];
          }
        });
      } else if (pipeline && (typeof pipeline === 'undefined' ? 'undefined' : (0, _typeof3.default)(pipeline)) === 'object') {
        stages = pipeline;
      } else {
        throw new Error('Invalid pipeline must be Array or Object');
      }

      return controller.aggregate(this.className, stages, aggregateOptions).then(function (results) {
        return results.results;
      })._thenRunCallbacks(options);
    }

    /**
     * Retrieves at most one Parse.Object that satisfies this query.
     *
     * Either options.success or options.error is called when it completes.
     * success is passed the object if there is one. otherwise, undefined.
     *
     * @param {Object} options A Backbone-style options object. Valid options
     * are:<ul>
     *   <li>success: Function to call when the find completes successfully.
     *   <li>error: Function to call when the find fails.
     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
     *     be used for this request.
     *   <li>sessionToken: A valid session token, used for making a request on
     *       behalf of a specific user.
     * </ul>
     *
     * @return {Parse.Promise} A promise that is resolved with the object when
     * the query completes.
     */

  }, {
    key: 'first',
    value: function (options) {
      var _this2 = this;

      options = options || {};

      var findOptions = {};
      if (options.hasOwnProperty('useMasterKey')) {
        findOptions.useMasterKey = options.useMasterKey;
      }
      if (options.hasOwnProperty('sessionToken')) {
        findOptions.sessionToken = options.sessionToken;
      }

      var controller = _CoreManager2.default.getQueryController();

      var params = this.toJSON();
      params.limit = 1;

      var select = this._select;

      return controller.find(this.className, params, findOptions).then(function (response) {
        var objects = response.results;
        if (!objects[0]) {
          return undefined;
        }
        if (!objects[0].className) {
          objects[0].className = _this2.className;
        }

        // Make sure the data object contains keys for all objects that
        // have been requested with a select, so that our cached state
        // updates correctly.
        if (select) {
          handleSelectResult(objects[0], select);
        }

        return _ParseObject2.default.fromJSON(objects[0], !select);
      })._thenRunCallbacks(options);
    }

    /**
     * Iterates over each result of a query, calling a callback for each one. If
     * the callback returns a promise, the iteration will not continue until
     * that promise has been fulfilled. If the callback returns a rejected
     * promise, then iteration will stop with that error. The items are
     * processed in an unspecified order. The query may not have any sort order,
     * and may not use limit or skip.
     * @param {Function} callback Callback that will be called with each result
     *     of the query.
     * @param {Object} options A Backbone-style options object. Valid options
     * are:<ul>
     *   <li>success: Function to call when the iteration completes successfully.
     *   <li>error: Function to call when the iteration fails.
     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
     *     be used for this request.
     *   <li>sessionToken: A valid session token, used for making a request on
     *       behalf of a specific user.
     * </ul>
     * @return {Parse.Promise} A promise that will be fulfilled once the
     *     iteration has completed.
     */

  }, {
    key: 'each',
    value: function (callback, options) {
      options = options || {};

      if (this._order || this._skip || this._limit >= 0) {
        return _ParsePromise2.default.error('Cannot iterate on a query with sort, skip, or limit.')._thenRunCallbacks(options);
      }

      new _ParsePromise2.default();


      var query = new ParseQuery(this.className);
      // We can override the batch size from the options.
      // This is undocumented, but useful for testing.
      query._limit = options.batchSize || 100;
      query._include = this._include.map(function (i) {
        return i;
      });
      if (this._select) {
        query._select = this._select.map(function (s) {
          return s;
        });
      }

      query._where = {};
      for (var attr in this._where) {
        var val = this._where[attr];
        if (Array.isArray(val)) {
          query._where[attr] = val.map(function (v) {
            return v;
          });
        } else if (val && (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object') {
          var conditionMap = {};
          query._where[attr] = conditionMap;
          for (var cond in val) {
            conditionMap[cond] = val[cond];
          }
        } else {
          query._where[attr] = val;
        }
      }

      query.ascending('objectId');

      var findOptions = {};
      if (options.hasOwnProperty('useMasterKey')) {
        findOptions.useMasterKey = options.useMasterKey;
      }
      if (options.hasOwnProperty('sessionToken')) {
        findOptions.sessionToken = options.sessionToken;
      }

      var finished = false;
      return _ParsePromise2.default._continueWhile(function () {
        return !finished;
      }, function () {
        return query.find(findOptions).then(function (results) {
          var callbacksDone = _ParsePromise2.default.as();
          results.forEach(function (result) {
            callbacksDone = callbacksDone.then(function () {
              return callback(result);
            });
          });

          return callbacksDone.then(function () {
            if (results.length >= query._limit) {
              query.greaterThan('objectId', results[results.length - 1].id);
            } else {
              finished = true;
            }
          });
        });
      })._thenRunCallbacks(options);
    }

    /** Query Conditions **/

    /**
     * Adds a constraint to the query that requires a particular key's value to
     * be equal to the provided value.
     * @param {String} key The key to check.
     * @param value The value that the Parse.Object must contain.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'equalTo',
    value: function (key, value) {
      if (typeof value === 'undefined') {
        return this.doesNotExist(key);
      }

      this._where[key] = (0, _encode2.default)(value, false, true);
      return this;
    }

    /**
     * Adds a constraint to the query that requires a particular key's value to
     * be not equal to the provided value.
     * @param {String} key The key to check.
     * @param value The value that must not be equalled.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'notEqualTo',
    value: function (key, value) {
      return this._addCondition(key, '$ne', value);
    }

    /**
     * Adds a constraint to the query that requires a particular key's value to
     * be less than the provided value.
     * @param {String} key The key to check.
     * @param value The value that provides an upper bound.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'lessThan',
    value: function (key, value) {
      return this._addCondition(key, '$lt', value);
    }

    /**
     * Adds a constraint to the query that requires a particular key's value to
     * be greater than the provided value.
     * @param {String} key The key to check.
     * @param value The value that provides an lower bound.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'greaterThan',
    value: function (key, value) {
      return this._addCondition(key, '$gt', value);
    }

    /**
     * Adds a constraint to the query that requires a particular key's value to
     * be less than or equal to the provided value.
     * @param {String} key The key to check.
     * @param value The value that provides an upper bound.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'lessThanOrEqualTo',
    value: function (key, value) {
      return this._addCondition(key, '$lte', value);
    }

    /**
     * Adds a constraint to the query that requires a particular key's value to
     * be greater than or equal to the provided value.
     * @param {String} key The key to check.
     * @param value The value that provides an lower bound.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'greaterThanOrEqualTo',
    value: function (key, value) {
      return this._addCondition(key, '$gte', value);
    }

    /**
     * Adds a constraint to the query that requires a particular key's value to
     * be contained in the provided list of values.
     * @param {String} key The key to check.
     * @param {Array} values The values that will match.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'containedIn',
    value: function (key, value) {
      return this._addCondition(key, '$in', value);
    }

    /**
     * Adds a constraint to the query that requires a particular key's value to
     * not be contained in the provided list of values.
     * @param {String} key The key to check.
     * @param {Array} values The values that will not match.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'notContainedIn',
    value: function (key, value) {
      return this._addCondition(key, '$nin', value);
    }

    /**
     * Adds a constraint to the query that requires a particular key's value to
     * contain each one of the provided list of values.
     * @param {String} key The key to check.  This key's value must be an array.
     * @param {Array} values The values that will match.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'containsAll',
    value: function (key, values) {
      return this._addCondition(key, '$all', values);
    }

    /**
     * Adds a constraint for finding objects that contain the given key.
     * @param {String} key The key that should exist.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'exists',
    value: function (key) {
      return this._addCondition(key, '$exists', true);
    }

    /**
     * Adds a constraint for finding objects that do not contain a given key.
     * @param {String} key The key that should not exist
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'doesNotExist',
    value: function (key) {
      return this._addCondition(key, '$exists', false);
    }

    /**
     * Adds a regular expression constraint for finding string values that match
     * the provided regular expression.
     * This may be slow for large datasets.
     * @param {String} key The key that the string to match is stored in.
     * @param {RegExp} regex The regular expression pattern to match.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'matches',
    value: function (key, regex, modifiers) {
      this._addCondition(key, '$regex', regex);
      if (!modifiers) {
        modifiers = '';
      }
      if (regex.ignoreCase) {
        modifiers += 'i';
      }
      if (regex.multiline) {
        modifiers += 'm';
      }
      if (modifiers.length) {
        this._addCondition(key, '$options', modifiers);
      }
      return this;
    }

    /**
     * Adds a constraint that requires that a key's value matches a Parse.Query
     * constraint.
     * @param {String} key The key that the contains the object to match the
     *                     query.
     * @param {Parse.Query} query The query that should match.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'matchesQuery',
    value: function (key, query) {
      var queryJSON = query.toJSON();
      queryJSON.className = query.className;
      return this._addCondition(key, '$inQuery', queryJSON);
    }

    /**
     * Adds a constraint that requires that a key's value not matches a
     * Parse.Query constraint.
     * @param {String} key The key that the contains the object to match the
     *                     query.
     * @param {Parse.Query} query The query that should not match.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'doesNotMatchQuery',
    value: function (key, query) {
      var queryJSON = query.toJSON();
      queryJSON.className = query.className;
      return this._addCondition(key, '$notInQuery', queryJSON);
    }

    /**
     * Adds a constraint that requires that a key's value matches a value in
     * an object returned by a different Parse.Query.
     * @param {String} key The key that contains the value that is being
     *                     matched.
     * @param {String} queryKey The key in the objects returned by the query to
     *                          match against.
     * @param {Parse.Query} query The query to run.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'matchesKeyInQuery',
    value: function (key, queryKey, query) {
      var queryJSON = query.toJSON();
      queryJSON.className = query.className;
      return this._addCondition(key, '$select', {
        key: queryKey,
        query: queryJSON
      });
    }

    /**
     * Adds a constraint that requires that a key's value not match a value in
     * an object returned by a different Parse.Query.
     * @param {String} key The key that contains the value that is being
     *                     excluded.
     * @param {String} queryKey The key in the objects returned by the query to
     *                          match against.
     * @param {Parse.Query} query The query to run.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'doesNotMatchKeyInQuery',
    value: function (key, queryKey, query) {
      var queryJSON = query.toJSON();
      queryJSON.className = query.className;
      return this._addCondition(key, '$dontSelect', {
        key: queryKey,
        query: queryJSON
      });
    }

    /**
     * Adds a constraint for finding string values that contain a provided
     * string.  This may be slow for large datasets.
     * @param {String} key The key that the string to match is stored in.
     * @param {String} substring The substring that the value must contain.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'contains',
    value: function (key, value) {
      if (typeof value !== 'string') {
        throw new Error('The value being searched for must be a string.');
      }
      return this._addCondition(key, '$regex', quote(value));
    }

    /**
    * Adds a constraint for finding string values that contain a provided
    * string. This may be slow for large datasets. Requires Parse-Server > 2.5.0
    *
    * In order to sort you must use select and ascending ($score is required)
    *  <pre>
    *   query.fullText('term');
    *   query.ascending('$score');
    *   query.select('$score');
    *  </pre>
    *
    * To retrieve the weight / rank
    *  <pre>
    *   object->get('score');
    *  </pre>
    *
    * @param {String} key The key that the string to match is stored in.
    * @param {String} value The string to search
    * @return {Parse.Query} Returns the query, so you can chain this call.
    */

  }, {
    key: 'fullText',
    value: function (key, value) {
      if (!key) {
        throw new Error('A key is required.');
      }
      if (!value) {
        throw new Error('A search term is required');
      }
      if (typeof value !== 'string') {
        throw new Error('The value being searched for must be a string.');
      }

      return this._addCondition(key, '$text', { $search: { $term: value } });
    }

    /**
     * Adds a constraint for finding string values that start with a provided
     * string.  This query will use the backend index, so it will be fast even
     * for large datasets.
     * @param {String} key The key that the string to match is stored in.
     * @param {String} prefix The substring that the value must start with.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'startsWith',
    value: function (key, value) {
      if (typeof value !== 'string') {
        throw new Error('The value being searched for must be a string.');
      }
      return this._addCondition(key, '$regex', '^' + quote(value));
    }

    /**
     * Adds a constraint for finding string values that end with a provided
     * string.  This will be slow for large datasets.
     * @param {String} key The key that the string to match is stored in.
     * @param {String} suffix The substring that the value must end with.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'endsWith',
    value: function (key, value) {
      if (typeof value !== 'string') {
        throw new Error('The value being searched for must be a string.');
      }
      return this._addCondition(key, '$regex', quote(value) + '$');
    }

    /**
     * Adds a proximity based constraint for finding objects with key point
     * values near the point given.
     * @param {String} key The key that the Parse.GeoPoint is stored in.
     * @param {Parse.GeoPoint} point The reference Parse.GeoPoint that is used.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'near',
    value: function (key, point) {
      if (!(point instanceof _ParseGeoPoint2.default)) {
        // Try to cast it as a GeoPoint
        point = new _ParseGeoPoint2.default(point);
      }
      return this._addCondition(key, '$nearSphere', point);
    }

    /**
     * Adds a proximity based constraint for finding objects with key point
     * values near the point given and within the maximum distance given.
     * @param {String} key The key that the Parse.GeoPoint is stored in.
     * @param {Parse.GeoPoint} point The reference Parse.GeoPoint that is used.
     * @param {Number} maxDistance Maximum distance (in radians) of results to
     *   return.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'withinRadians',
    value: function (key, point, distance) {
      this.near(key, point);
      return this._addCondition(key, '$maxDistance', distance);
    }

    /**
     * Adds a proximity based constraint for finding objects with key point
     * values near the point given and within the maximum distance given.
     * Radius of earth used is 3958.8 miles.
     * @param {String} key The key that the Parse.GeoPoint is stored in.
     * @param {Parse.GeoPoint} point The reference Parse.GeoPoint that is used.
     * @param {Number} maxDistance Maximum distance (in miles) of results to
     *     return.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'withinMiles',
    value: function (key, point, distance) {
      return this.withinRadians(key, point, distance / 3958.8);
    }

    /**
     * Adds a proximity based constraint for finding objects with key point
     * values near the point given and within the maximum distance given.
     * Radius of earth used is 6371.0 kilometers.
     * @param {String} key The key that the Parse.GeoPoint is stored in.
     * @param {Parse.GeoPoint} point The reference Parse.GeoPoint that is used.
     * @param {Number} maxDistance Maximum distance (in kilometers) of results
     *     to return.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'withinKilometers',
    value: function (key, point, distance) {
      return this.withinRadians(key, point, distance / 6371.0);
    }

    /**
     * Adds a constraint to the query that requires a particular key's
     * coordinates be contained within a given rectangular geographic bounding
     * box.
     * @param {String} key The key to be constrained.
     * @param {Parse.GeoPoint} southwest
     *     The lower-left inclusive corner of the box.
     * @param {Parse.GeoPoint} northeast
     *     The upper-right inclusive corner of the box.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'withinGeoBox',
    value: function (key, southwest, northeast) {
      if (!(southwest instanceof _ParseGeoPoint2.default)) {
        southwest = new _ParseGeoPoint2.default(southwest);
      }
      if (!(northeast instanceof _ParseGeoPoint2.default)) {
        northeast = new _ParseGeoPoint2.default(northeast);
      }
      this._addCondition(key, '$within', { '$box': [southwest, northeast] });
      return this;
    }

    /**
     * Adds a constraint to the query that requires a particular key's
     * coordinates be contained within and on the bounds of a given polygon.
     * Supports closed and open (last point is connected to first) paths
     *
     * Polygon must have at least 3 points
     *
     * @param {String} key The key to be constrained.
     * @param {Array} array of geopoints
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'withinPolygon',
    value: function (key, points) {
      return this._addCondition(key, '$geoWithin', { '$polygon': points });
    }

    /**
     * Add a constraint to the query that requires a particular key's
     * coordinates that contains a ParseGeoPoint
     *
     * @param {String} key The key to be constrained.
     * @param {Parse.GeoPoint} GeoPoint
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'polygonContains',
    value: function (key, point) {
      return this._addCondition(key, '$geoIntersects', { '$point': point });
    }

    /** Query Orderings **/

    /**
     * Sorts the results in ascending order by the given key.
     *
     * @param {(String|String[]|...String)} key The key to order by, which is a
     * string of comma separated values, or an Array of keys, or multiple keys.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'ascending',
    value: function () {
      this._order = [];

      for (var _len = arguments.length, keys = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
        keys[_key2] = arguments[_key2];
      }

      return this.addAscending.apply(this, keys);
    }

    /**
     * Sorts the results in ascending order by the given key,
     * but can also add secondary sort descriptors without overwriting _order.
     *
     * @param {(String|String[]|...String)} key The key to order by, which is a
     * string of comma separated values, or an Array of keys, or multiple keys.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'addAscending',
    value: function () {
      var _this3 = this;

      if (!this._order) {
        this._order = [];
      }

      for (var _len2 = arguments.length, keys = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
        keys[_key3] = arguments[_key3];
      }

      keys.forEach(function (key) {
        if (Array.isArray(key)) {
          key = key.join();
        }
        _this3._order = _this3._order.concat(key.replace(/\s/g, '').split(','));
      });

      return this;
    }

    /**
     * Sorts the results in descending order by the given key.
     *
     * @param {(String|String[]|...String)} key The key to order by, which is a
     * string of comma separated values, or an Array of keys, or multiple keys.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'descending',
    value: function () {
      this._order = [];

      for (var _len3 = arguments.length, keys = Array(_len3), _key4 = 0; _key4 < _len3; _key4++) {
        keys[_key4] = arguments[_key4];
      }

      return this.addDescending.apply(this, keys);
    }

    /**
     * Sorts the results in descending order by the given key,
     * but can also add secondary sort descriptors without overwriting _order.
     *
     * @param {(String|String[]|...String)} key The key to order by, which is a
     * string of comma separated values, or an Array of keys, or multiple keys.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'addDescending',
    value: function () {
      var _this4 = this;

      if (!this._order) {
        this._order = [];
      }

      for (var _len4 = arguments.length, keys = Array(_len4), _key5 = 0; _key5 < _len4; _key5++) {
        keys[_key5] = arguments[_key5];
      }

      keys.forEach(function (key) {
        if (Array.isArray(key)) {
          key = key.join();
        }
        _this4._order = _this4._order.concat(key.replace(/\s/g, '').split(',').map(function (k) {
          return '-' + k;
        }));
      });

      return this;
    }

    /** Query Options **/

    /**
     * Sets the number of results to skip before returning any results.
     * This is useful for pagination.
     * Default is to skip zero results.
     * @param {Number} n the number of results to skip.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'skip',
    value: function (n) {
      if (typeof n !== 'number' || n < 0) {
        throw new Error('You can only skip by a positive number');
      }
      this._skip = n;
      return this;
    }

    /**
     * Sets the limit of the number of results to return. The default limit is
     * 100, with a maximum of 1000 results being returned at a time.
     * @param {Number} n the number of results to limit to.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'limit',
    value: function (n) {
      if (typeof n !== 'number') {
        throw new Error('You can only set the limit to a numeric value');
      }
      this._limit = n;
      return this;
    }

    /**
     * Includes nested Parse.Objects for the provided key.  You can use dot
     * notation to specify which fields in the included object are also fetched.
     * @param {String} key The name of the key to include.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'include',
    value: function () {
      var _this5 = this;

      for (var _len5 = arguments.length, keys = Array(_len5), _key6 = 0; _key6 < _len5; _key6++) {
        keys[_key6] = arguments[_key6];
      }

      keys.forEach(function (key) {
        if (Array.isArray(key)) {
          _this5._include = _this5._include.concat(key);
        } else {
          _this5._include.push(key);
        }
      });
      return this;
    }

    /**
     * Restricts the fields of the returned Parse.Objects to include only the
     * provided keys.  If this is called multiple times, then all of the keys
     * specified in each of the calls will be included.
     * @param {Array} keys The names of the keys to include.
     * @return {Parse.Query} Returns the query, so you can chain this call.
     */

  }, {
    key: 'select',
    value: function () {
      var _this6 = this;

      if (!this._select) {
        this._select = [];
      }

      for (var _len6 = arguments.length, keys = Array(_len6), _key7 = 0; _key7 < _len6; _key7++) {
        keys[_key7] = arguments[_key7];
      }

      keys.forEach(function (key) {
        if (Array.isArray(key)) {
          _this6._select = _this6._select.concat(key);
        } else {
          _this6._select.push(key);
        }
      });
      return this;
    }

    /**
     * Subscribe this query to get liveQuery updates
     * @return {LiveQuerySubscription} Returns the liveQuerySubscription, it's an event emitter
     * which can be used to get liveQuery updates.
     */

  }, {
    key: 'subscribe',
    value: function () {
      var controller = _CoreManager2.default.getLiveQueryController();
      return controller.subscribe(this);
    }

    /**
     * Constructs a Parse.Query that is the OR of the passed in queries.  For
     * example:
     * <pre>var compoundQuery = Parse.Query.or(query1, query2, query3);</pre>
     *
     * will create a compoundQuery that is an or of the query1, query2, and
     * query3.
     * @param {...Parse.Query} var_args The list of queries to OR.
     * @static
     * @return {Parse.Query} The query that is the OR of the passed in queries.
     */

  }], [{
    key: 'fromJSON',
    value: function (className, json) {
      var query = new ParseQuery(className);
      return query.withJSON(json);
    }
  }, {
    key: 'or',
    value: function () {
      for (var _len7 = arguments.length, queries = Array(_len7), _key8 = 0; _key8 < _len7; _key8++) {
        queries[_key8] = arguments[_key8];
      }

      var className = _getClassNameFromQueries(queries);
      var query = new ParseQuery(className);
      query._orQuery(queries);
      return query;
    }

    /**
     * Constructs a Parse.Query that is the AND of the passed in queries.  For
     * example:
     * <pre>var compoundQuery = Parse.Query.and(query1, query2, query3);</pre>
     *
     * will create a compoundQuery that is an and of the query1, query2, and
     * query3.
     * @method and
     * @param {...Parse.Query} var_args The list of queries to AND.
     * @static
     * @return {Parse.Query} The query that is the AND of the passed in queries.
     */

  }, {
    key: 'and',
    value: function () {
      for (var _len8 = arguments.length, queries = Array(_len8), _key9 = 0; _key9 < _len8; _key9++) {
        queries[_key9] = arguments[_key9];
      }

      var className = _getClassNameFromQueries(queries);
      var query = new ParseQuery(className);
      query._andQuery(queries);
      return query;
    }
  }]);
  return ParseQuery;
}();

var DefaultController = {
  find: function (className, params, options) {
    var RESTController = _CoreManager2.default.getRESTController();

    return RESTController.request('GET', 'classes/' + className, params, options);
  },
  aggregate: function (className, params, options) {
    var RESTController = _CoreManager2.default.getRESTController();

    return RESTController.request('GET', 'aggregate/' + className, params, options);
  }
};

_CoreManager2.default.setQueryController(DefaultController);

exports.default = ParseQuery;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(42);

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty = __webpack_require__(93);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = __webpack_require__(27);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(34);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(119);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(35);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CoreManager = __webpack_require__(9);

var _CoreManager2 = _interopRequireDefault(_CoreManager);

var _isRevocableSession = __webpack_require__(133);

var _isRevocableSession2 = _interopRequireDefault(_isRevocableSession);

var _ParseError = __webpack_require__(28);

var _ParseError2 = _interopRequireDefault(_ParseError);

var _ParseObject2 = __webpack_require__(8);

var _ParseObject3 = _interopRequireDefault(_ParseObject2);

var _ParsePromise = __webpack_require__(7);

var _ParsePromise2 = _interopRequireDefault(_ParsePromise);

var _ParseSession = __webpack_require__(134);

var _ParseSession2 = _interopRequireDefault(_ParseSession);

var _Storage = __webpack_require__(51);

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var CURRENT_USER_KEY = 'currentUser'; /**
                                       * Copyright (c) 2015-present, Parse, LLC.
                                       * All rights reserved.
                                       *
                                       * This source code is licensed under the BSD-style license found in the
                                       * LICENSE file in the root directory of this source tree. An additional grant
                                       * of patent rights can be found in the PATENTS file in the same directory.
                                       *
                                       * 
                                       */

var canUseCurrentUser = !_CoreManager2.default.get('IS_NODE');
var currentUserCacheMatchesDisk = false;
var currentUserCache = null;

var authProviders = {};

/**
 * <p>A Parse.User object is a local representation of a user persisted to the
 * Parse cloud. This class is a subclass of a Parse.Object, and retains the
 * same functionality of a Parse.Object, but also extends it with various
 * user specific methods, like authentication, signing up, and validation of
 * uniqueness.</p>
 * @alias Parse.User
 * @extends Parse.Object
 */

var ParseUser = function (_ParseObject) {
  (0, _inherits3.default)(ParseUser, _ParseObject);

  /**
   * @param {Object} attributes The initial set of data to store in the user.
   */
  function ParseUser(attributes) {
    (0, _classCallCheck3.default)(this, ParseUser);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ParseUser.__proto__ || (0, _getPrototypeOf2.default)(ParseUser)).call(this, '_User'));

    if (attributes && (typeof attributes === 'undefined' ? 'undefined' : (0, _typeof3.default)(attributes)) === 'object') {
      if (!_this.set(attributes || {})) {
        throw new Error('Can\'t create an invalid Parse User');
      }
    }
    return _this;
  }

  /**
   * Request a revocable session token to replace the older style of token.
    * @param {Object} options A Backbone-style options object.
   * @return {Parse.Promise} A promise that is resolved when the replacement
   *   token has been fetched.
   */

  (0, _createClass3.default)(ParseUser, [{
    key: '_upgradeToRevocableSession',
    value: function (options) {
      options = options || {};

      var upgradeOptions = {};
      if (options.hasOwnProperty('useMasterKey')) {
        upgradeOptions.useMasterKey = options.useMasterKey;
      }

      var controller = _CoreManager2.default.getUserController();
      return controller.upgradeToRevocableSession(this, upgradeOptions)._thenRunCallbacks(options);
    }

    /**
     * Unlike in the Android/iOS SDKs, logInWith is unnecessary, since you can
     * call linkWith on the user (even if it doesn't exist yet on the server).
     */

  }, {
    key: '_linkWith',
    value: function (provider, options) {
      var _this2 = this;

      var authType;
      if (typeof provider === 'string') {
        authType = provider;
        provider = authProviders[provider];
      } else {
        authType = provider.getAuthType();
      }
      if (options && options.hasOwnProperty('authData')) {
        var authData = this.get('authData') || {};
        if ((typeof authData === 'undefined' ? 'undefined' : (0, _typeof3.default)(authData)) !== 'object') {
          throw new Error('Invalid type: authData field should be an object');
        }
        authData[authType] = options.authData;

        var controller = _CoreManager2.default.getUserController();
        return controller.linkWith(this, authData)._thenRunCallbacks(options, this);
      } else {
        var promise = new _ParsePromise2.default();
        provider.authenticate({
          success: function (provider, result) {
            var opts = {};
            opts.authData = result;
            if (options.success) {
              opts.success = options.success;
            }
            if (options.error) {
              opts.error = options.error;
            }
            _this2._linkWith(provider, opts).then(function () {
              promise.resolve(_this2);
            }, function (error) {
              promise.reject(error);
            });
          },
          error: function (provider, _error) {
            if (typeof options.error === 'function') {
              options.error(_this2, _error);
            }
            promise.reject(_error);
          }
        });
        return promise;
      }
    }

    /**
     * Synchronizes auth data for a provider (e.g. puts the access token in the
     * right place to be used by the Facebook SDK).
      */

  }, {
    key: '_synchronizeAuthData',
    value: function (provider) {
      if (!this.isCurrent() || !provider) {
        return;
      }
      var authType;
      if (typeof provider === 'string') {
        authType = provider;
        provider = authProviders[authType];
      } else {
        authType = provider.getAuthType();
      }
      var authData = this.get('authData');
      if (!provider || !authData || (typeof authData === 'undefined' ? 'undefined' : (0, _typeof3.default)(authData)) !== 'object') {
        return;
      }
      var success = provider.restoreAuthentication(authData[authType]);
      if (!success) {
        this._unlinkFrom(provider);
      }
    }

    /**
     * Synchronizes authData for all providers.
      */

  }, {
    key: '_synchronizeAllAuthData',
    value: function () {
      var authData = this.get('authData');
      if ((typeof authData === 'undefined' ? 'undefined' : (0, _typeof3.default)(authData)) !== 'object') {
        return;
      }

      for (var key in authData) {
        this._synchronizeAuthData(key);
      }
    }

    /**
     * Removes null values from authData (which exist temporarily for
     * unlinking)
      */

  }, {
    key: '_cleanupAuthData',
    value: function () {
      if (!this.isCurrent()) {
        return;
      }
      var authData = this.get('authData');
      if ((typeof authData === 'undefined' ? 'undefined' : (0, _typeof3.default)(authData)) !== 'object') {
        return;
      }

      for (var key in authData) {
        if (!authData[key]) {
          delete authData[key];
        }
      }
    }

    /**
     * Unlinks a user from a service.
      */

  }, {
    key: '_unlinkFrom',
    value: function (provider, options) {
      var _this3 = this;

      if (typeof provider === 'string') {
        provider = authProviders[provider];
      } else {
        provider.getAuthType();
      }
      return this._linkWith(provider, { authData: null }).then(function () {
        _this3._synchronizeAuthData(provider);
        return _ParsePromise2.default.as(_this3);
      })._thenRunCallbacks(options);
    }

    /**
     * Checks whether a user is linked to a service.
      */

  }, {
    key: '_isLinked',
    value: function (provider) {
      var authType;
      if (typeof provider === 'string') {
        authType = provider;
      } else {
        authType = provider.getAuthType();
      }
      var authData = this.get('authData') || {};
      if ((typeof authData === 'undefined' ? 'undefined' : (0, _typeof3.default)(authData)) !== 'object') {
        return false;
      }
      return !!authData[authType];
    }

    /**
     * Deauthenticates all providers.
      */

  }, {
    key: '_logOutWithAll',
    value: function () {
      var authData = this.get('authData');
      if ((typeof authData === 'undefined' ? 'undefined' : (0, _typeof3.default)(authData)) !== 'object') {
        return;
      }

      for (var key in authData) {
        this._logOutWith(key);
      }
    }

    /**
     * Deauthenticates a single provider (e.g. removing access tokens from the
     * Facebook SDK).
      */

  }, {
    key: '_logOutWith',
    value: function (provider) {
      if (!this.isCurrent()) {
        return;
      }
      if (typeof provider === 'string') {
        provider = authProviders[provider];
      }
      if (provider && provider.deauthenticate) {
        provider.deauthenticate();
      }
    }

    /**
     * Class instance method used to maintain specific keys when a fetch occurs.
     * Used to ensure that the session token is not lost.
     */

  }, {
    key: '_preserveFieldsOnFetch',
    value: function () {
      return {
        sessionToken: this.get('sessionToken')
      };
    }

    /**
     * Returns true if <code>current</code> would return this user.
      * @return {Boolean}
     */

  }, {
    key: 'isCurrent',
    value: function () {
      var current = ParseUser.current();
      return !!current && current.id === this.id;
    }

    /**
     * Returns get("username").
      * @return {String}
     */

  }, {
    key: 'getUsername',
    value: function () {
      var username = this.get('username');
      if (username == null || typeof username === 'string') {
        return username;
      }
      return '';
    }

    /**
     * Calls set("username", username, options) and returns the result.
      * @param {String} username
     * @param {Object} options A Backbone-style options object.
     * @return {Boolean}
     */

  }, {
    key: 'setUsername',
    value: function (username) {
      // Strip anonymity, even we do not support anonymous user in js SDK, we may
      // encounter anonymous user created by android/iOS in cloud code.
      var authData = this.get('authData');
      if (authData && (typeof authData === 'undefined' ? 'undefined' : (0, _typeof3.default)(authData)) === 'object' && authData.hasOwnProperty('anonymous')) {
        // We need to set anonymous to null instead of deleting it in order to remove it from Parse.
        authData.anonymous = null;
      }
      this.set('username', username);
    }

    /**
     * Calls set("password", password, options) and returns the result.
      * @param {String} password
     * @param {Object} options A Backbone-style options object.
     * @return {Boolean}
     */

  }, {
    key: 'setPassword',
    value: function (password) {
      this.set('password', password);
    }

    /**
     * Returns get("email").
      * @return {String}
     */

  }, {
    key: 'getEmail',
    value: function () {
      var email = this.get('email');
      if (email == null || typeof email === 'string') {
        return email;
      }
      return '';
    }

    /**
     * Calls set("email", email, options) and returns the result.
      * @param {String} email
     * @param {Object} options A Backbone-style options object.
     * @return {Boolean}
     */

  }, {
    key: 'setEmail',
    value: function (email) {
      this.set('email', email);
    }

    /**
     * Returns the session token for this user, if the user has been logged in,
     * or if it is the result of a query with the master key. Otherwise, returns
     * undefined.
      * @return {String} the session token, or undefined
     */

  }, {
    key: 'getSessionToken',
    value: function () {
      var token = this.get('sessionToken');
      if (token == null || typeof token === 'string') {
        return token;
      }
      return '';
    }

    /**
     * Checks whether this user is the current user and has been authenticated.
      * @return (Boolean) whether this user is the current user and is logged in.
     */

  }, {
    key: 'authenticated',
    value: function () {
      var current = ParseUser.current();
      return !!this.get('sessionToken') && !!current && current.id === this.id;
    }

    /**
     * Signs up a new user. You should call this instead of save for
     * new Parse.Users. This will create a new Parse.User on the server, and
     * also persist the session on disk so that you can access the user using
     * <code>current</code>.
     *
     * <p>A username and password must be set before calling signUp.</p>
     *
     * <p>Calls options.success or options.error on completion.</p>
     *
      * @param {Object} attrs Extra fields to set on the new user, or null.
     * @param {Object} options A Backbone-style options object.
     * @return {Parse.Promise} A promise that is fulfilled when the signup
     *     finishes.
     */

  }, {
    key: 'signUp',
    value: function (attrs, options) {
      options = options || {};

      var signupOptions = {};
      if (options.hasOwnProperty('useMasterKey')) {
        signupOptions.useMasterKey = options.useMasterKey;
      }
      if (options.hasOwnProperty('installationId')) {
        signupOptions.installationId = options.installationId;
      }

      var controller = _CoreManager2.default.getUserController();
      return controller.signUp(this, attrs, signupOptions)._thenRunCallbacks(options, this);
    }

    /**
     * Logs in a Parse.User. On success, this saves the session to disk,
     * so you can retrieve the currently logged in user using
     * <code>current</code>.
     *
     * <p>A username and password must be set before calling logIn.</p>
     *
     * <p>Calls options.success or options.error on completion.</p>
     *
      * @param {Object} options A Backbone-style options object.
     * @return {Parse.Promise} A promise that is fulfilled with the user when
     *     the login is complete.
     */

  }, {
    key: 'logIn',
    value: function (options) {
      options = options || {};

      var loginOptions = {};
      if (options.hasOwnProperty('useMasterKey')) {
        loginOptions.useMasterKey = options.useMasterKey;
      }
      if (options.hasOwnProperty('installationId')) {
        loginOptions.installationId = options.installationId;
      }

      var controller = _CoreManager2.default.getUserController();
      return controller.logIn(this, loginOptions)._thenRunCallbacks(options, this);
    }

    /**
     * Wrap the default save behavior with functionality to save to local
     * storage if this is current user.
     */

  }, {
    key: 'save',
    value: function () {
      var _this4 = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (0, _get3.default)(ParseUser.prototype.__proto__ || (0, _getPrototypeOf2.default)(ParseUser.prototype), 'save', this).apply(this, args).then(function () {
        if (_this4.isCurrent()) {
          return _CoreManager2.default.getUserController().updateUserOnDisk(_this4);
        }
        return _this4;
      });
    }

    /**
     * Wrap the default destroy behavior with functionality that logs out
     * the current user when it is destroyed
     */

  }, {
    key: 'destroy',
    value: function () {
      var _this5 = this;

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return (0, _get3.default)(ParseUser.prototype.__proto__ || (0, _getPrototypeOf2.default)(ParseUser.prototype), 'destroy', this).apply(this, args).then(function () {
        if (_this5.isCurrent()) {
          return _CoreManager2.default.getUserController().removeUserFromDisk();
        }
        return _this5;
      });
    }

    /**
     * Wrap the default fetch behavior with functionality to save to local
     * storage if this is current user.
     */

  }, {
    key: 'fetch',
    value: function () {
      var _this6 = this;

      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return (0, _get3.default)(ParseUser.prototype.__proto__ || (0, _getPrototypeOf2.default)(ParseUser.prototype), 'fetch', this).apply(this, args).then(function () {
        if (_this6.isCurrent()) {
          return _CoreManager2.default.getUserController().updateUserOnDisk(_this6);
        }
        return _this6;
      });
    }
  }], [{
    key: 'readOnlyAttributes',
    value: function () {
      return ['sessionToken'];
    }

    /**
     * Adds functionality to the existing Parse.User class
      * @param {Object} protoProps A set of properties to add to the prototype
     * @param {Object} classProps A set of static properties to add to the class
     * @static
     * @return {Class} The newly extended Parse.User class
     */

  }, {
    key: 'extend',
    value: function (protoProps, classProps) {
      if (protoProps) {
        for (var prop in protoProps) {
          if (prop !== 'className') {
            (0, _defineProperty2.default)(ParseUser.prototype, prop, {
              value: protoProps[prop],
              enumerable: false,
              writable: true,
              configurable: true
            });
          }
        }
      }

      if (classProps) {
        for (var prop in classProps) {
          if (prop !== 'className') {
            (0, _defineProperty2.default)(ParseUser, prop, {
              value: classProps[prop],
              enumerable: false,
              writable: true,
              configurable: true
            });
          }
        }
      }

      return ParseUser;
    }

    /**
     * Retrieves the currently logged in ParseUser with a valid session,
     * either from memory or localStorage, if necessary.
      * @static
     * @return {Parse.Object} The currently logged in Parse.User.
     */

  }, {
    key: 'current',
    value: function () {
      if (!canUseCurrentUser) {
        return null;
      }
      var controller = _CoreManager2.default.getUserController();
      return controller.currentUser();
    }

    /**
     * Retrieves the currently logged in ParseUser from asynchronous Storage.
      * @static
     * @return {Parse.Promise} A Promise that is resolved with the currently
     *   logged in Parse User
     */

  }, {
    key: 'currentAsync',
    value: function () {
      if (!canUseCurrentUser) {
        return _ParsePromise2.default.as(null);
      }
      var controller = _CoreManager2.default.getUserController();
      return controller.currentUserAsync();
    }

    /**
     * Signs up a new user with a username (or email) and password.
     * This will create a new Parse.User on the server, and also persist the
     * session in localStorage so that you can access the user using
     * {@link #current}.
     *
     * <p>Calls options.success or options.error on completion.</p>
     *
      * @param {String} username The username (or email) to sign up with.
     * @param {String} password The password to sign up with.
     * @param {Object} attrs Extra fields to set on the new user.
     * @param {Object} options A Backbone-style options object.
     * @static
     * @return {Parse.Promise} A promise that is fulfilled with the user when
     *     the signup completes.
     */

  }, {
    key: 'signUp',
    value: function (username, password, attrs, options) {
      attrs = attrs || {};
      attrs.username = username;
      attrs.password = password;
      var user = new ParseUser(attrs);
      return user.signUp({}, options);
    }

    /**
     * Logs in a user with a username (or email) and password. On success, this
     * saves the session to disk, so you can retrieve the currently logged in
     * user using <code>current</code>.
     *
     * <p>Calls options.success or options.error on completion.</p>
     *
      * @param {String} username The username (or email) to log in with.
     * @param {String} password The password to log in with.
     * @param {Object} options A Backbone-style options object.
     * @static
     * @return {Parse.Promise} A promise that is fulfilled with the user when
     *     the login completes.
     */

  }, {
    key: 'logIn',
    value: function (username, password, options) {
      if (typeof username !== 'string') {
        return _ParsePromise2.default.error(new _ParseError2.default(_ParseError2.default.OTHER_CAUSE, 'Username must be a string.'));
      } else if (typeof password !== 'string') {
        return _ParsePromise2.default.error(new _ParseError2.default(_ParseError2.default.OTHER_CAUSE, 'Password must be a string.'));
      }
      var user = new ParseUser();
      user._finishFetch({ username: username, password: password });
      return user.logIn(options);
    }

    /**
     * Logs in a user with a session token. On success, this saves the session
     * to disk, so you can retrieve the currently logged in user using
     * <code>current</code>.
     *
     * <p>Calls options.success or options.error on completion.</p>
     *
      * @param {String} sessionToken The sessionToken to log in with.
     * @param {Object} options A Backbone-style options object.
     * @static
     * @return {Parse.Promise} A promise that is fulfilled with the user when
     *     the login completes.
     */

  }, {
    key: 'become',
    value: function (sessionToken, options) {
      if (!canUseCurrentUser) {
        throw new Error('It is not memory-safe to become a user in a server environment');
      }
      options = options || {};

      var becomeOptions = {
        sessionToken: sessionToken
      };
      if (options.hasOwnProperty('useMasterKey')) {
        becomeOptions.useMasterKey = options.useMasterKey;
      }

      var controller = _CoreManager2.default.getUserController();
      return controller.become(becomeOptions)._thenRunCallbacks(options);
    }
  }, {
    key: 'logInWith',
    value: function (provider, options) {
      return ParseUser._logInWith(provider, options);
    }

    /**
     * Logs out the currently logged in user session. This will remove the
     * session from disk, log out of linked services, and future calls to
     * <code>current</code> will return <code>null</code>.
      * @static
     * @return {Parse.Promise} A promise that is resolved when the session is
     *   destroyed on the server.
     */

  }, {
    key: 'logOut',
    value: function () {
      if (!canUseCurrentUser) {
        throw new Error('There is no current user on a node.js server environment.');
      }

      var controller = _CoreManager2.default.getUserController();
      return controller.logOut();
    }

    /**
     * Requests a password reset email to be sent to the specified email address
     * associated with the user account. This email allows the user to securely
     * reset their password on the Parse site.
     *
     * <p>Calls options.success or options.error on completion.</p>
     *
      * @param {String} email The email address associated with the user that
     *     forgot their password.
     * @param {Object} options A Backbone-style options object.
     * @static
     * @returns {Parse.Promise}
     */

  }, {
    key: 'requestPasswordReset',
    value: function (email, options) {
      options = options || {};

      var requestOptions = {};
      if (options.hasOwnProperty('useMasterKey')) {
        requestOptions.useMasterKey = options.useMasterKey;
      }

      var controller = _CoreManager2.default.getUserController();
      return controller.requestPasswordReset(email, requestOptions)._thenRunCallbacks(options);
    }

    /**
     * Allow someone to define a custom User class without className
     * being rewritten to _User. The default behavior is to rewrite
     * User to _User for legacy reasons. This allows developers to
     * override that behavior.
     *
      * @param {Boolean} isAllowed Whether or not to allow custom User class
     * @static
     */

  }, {
    key: 'allowCustomUserClass',
    value: function (isAllowed) {
      _CoreManager2.default.set('PERFORM_USER_REWRITE', !isAllowed);
    }

    /**
     * Allows a legacy application to start using revocable sessions. If the
     * current session token is not revocable, a request will be made for a new,
     * revocable session.
     * It is not necessary to call this method from cloud code unless you are
     * handling user signup or login from the server side. In a cloud code call,
     * this function will not attempt to upgrade the current token.
      * @param {Object} options A Backbone-style options object.
     * @static
     * @return {Parse.Promise} A promise that is resolved when the process has
     *   completed. If a replacement session token is requested, the promise
     *   will be resolved after a new token has been fetched.
     */

  }, {
    key: 'enableRevocableSession',
    value: function (options) {
      options = options || {};
      _CoreManager2.default.set('FORCE_REVOCABLE_SESSION', true);
      if (canUseCurrentUser) {
        var current = ParseUser.current();
        if (current) {
          return current._upgradeToRevocableSession(options);
        }
      }
      return _ParsePromise2.default.as()._thenRunCallbacks(options);
    }

    /**
     * Enables the use of become or the current user in a server
     * environment. These features are disabled by default, since they depend on
     * global objects that are not memory-safe for most servers.
      * @static
     */

  }, {
    key: 'enableUnsafeCurrentUser',
    value: function () {
      canUseCurrentUser = true;
    }

    /**
     * Disables the use of become or the current user in any environment.
     * These features are disabled on servers by default, since they depend on
     * global objects that are not memory-safe for most servers.
      * @static
     */

  }, {
    key: 'disableUnsafeCurrentUser',
    value: function () {
      canUseCurrentUser = false;
    }
  }, {
    key: '_registerAuthenticationProvider',
    value: function (provider) {
      authProviders[provider.getAuthType()] = provider;
      // Synchronize the current user with the auth provider.
      ParseUser.currentAsync().then(function (current) {
        if (current) {
          current._synchronizeAuthData(provider.getAuthType());
        }
      });
    }
  }, {
    key: '_logInWith',
    value: function (provider, options) {
      var user = new ParseUser();
      return user._linkWith(provider, options);
    }
  }, {
    key: '_clearCache',
    value: function () {
      currentUserCache = null;
      currentUserCacheMatchesDisk = false;
    }
  }, {
    key: '_setCurrentUserCache',
    value: function (user) {
      currentUserCache = user;
    }
  }]);
  return ParseUser;
}(_ParseObject3.default);

_ParseObject3.default.registerSubclass('_User', ParseUser);

var DefaultController = {
  updateUserOnDisk: function (user) {
    var path = _Storage2.default.generatePath(CURRENT_USER_KEY);
    var json = user.toJSON();
    json.className = '_User';
    return _Storage2.default.setItemAsync(path, (0, _stringify2.default)(json)).then(function () {
      return user;
    });
  },
  removeUserFromDisk: function () {
    var path = _Storage2.default.generatePath(CURRENT_USER_KEY);
    currentUserCacheMatchesDisk = true;
    currentUserCache = null;
    return _Storage2.default.removeItemAsync(path);
  },
  setCurrentUser: function (user) {
    currentUserCache = user;
    user._cleanupAuthData();
    user._synchronizeAllAuthData();
    return DefaultController.updateUserOnDisk(user);
  },
  currentUser: function () {
    if (currentUserCache) {
      return currentUserCache;
    }
    if (currentUserCacheMatchesDisk) {
      return null;
    }
    if (_Storage2.default.async()) {
      throw new Error('Cannot call currentUser() when using a platform with an async ' + 'storage system. Call currentUserAsync() instead.');
    }
    var path = _Storage2.default.generatePath(CURRENT_USER_KEY);
    var userData = _Storage2.default.getItem(path);
    currentUserCacheMatchesDisk = true;
    if (!userData) {
      currentUserCache = null;
      return null;
    }
    userData = JSON.parse(userData);
    if (!userData.className) {
      userData.className = '_User';
    }
    if (userData._id) {
      if (userData.objectId !== userData._id) {
        userData.objectId = userData._id;
      }
      delete userData._id;
    }
    if (userData._sessionToken) {
      userData.sessionToken = userData._sessionToken;
      delete userData._sessionToken;
    }
    var current = _ParseObject3.default.fromJSON(userData);
    currentUserCache = current;
    current._synchronizeAllAuthData();
    return current;
  },
  currentUserAsync: function () {
    if (currentUserCache) {
      return _ParsePromise2.default.as(currentUserCache);
    }
    if (currentUserCacheMatchesDisk) {
      return _ParsePromise2.default.as(null);
    }
    var path = _Storage2.default.generatePath(CURRENT_USER_KEY);
    return _Storage2.default.getItemAsync(path).then(function (userData) {
      currentUserCacheMatchesDisk = true;
      if (!userData) {
        currentUserCache = null;
        return _ParsePromise2.default.as(null);
      }
      userData = JSON.parse(userData);
      if (!userData.className) {
        userData.className = '_User';
      }
      if (userData._id) {
        if (userData.objectId !== userData._id) {
          userData.objectId = userData._id;
        }
        delete userData._id;
      }
      if (userData._sessionToken) {
        userData.sessionToken = userData._sessionToken;
        delete userData._sessionToken;
      }
      var current = _ParseObject3.default.fromJSON(userData);
      currentUserCache = current;
      current._synchronizeAllAuthData();
      return _ParsePromise2.default.as(current);
    });
  },
  signUp: function (user, attrs, options) {
    var username = attrs && attrs.username || user.get('username');
    var password = attrs && attrs.password || user.get('password');

    if (!username || !username.length) {
      return _ParsePromise2.default.error(new _ParseError2.default(_ParseError2.default.OTHER_CAUSE, 'Cannot sign up user with an empty name.'));
    }
    if (!password || !password.length) {
      return _ParsePromise2.default.error(new _ParseError2.default(_ParseError2.default.OTHER_CAUSE, 'Cannot sign up user with an empty password.'));
    }

    return user.save(attrs, options).then(function () {
      // Clear the password field
      user._finishFetch({ password: undefined });

      if (canUseCurrentUser) {
        return DefaultController.setCurrentUser(user);
      }
      return user;
    });
  },
  logIn: function (user, options) {
    var RESTController = _CoreManager2.default.getRESTController();
    var stateController = _CoreManager2.default.getObjectStateController();
    var auth = {
      username: user.get('username'),
      password: user.get('password')
    };
    return RESTController.request('GET', 'login', auth, options).then(function (response) {
      user._migrateId(response.objectId);
      user._setExisted(true);
      stateController.setPendingOp(user._getStateIdentifier(), 'username', undefined);
      stateController.setPendingOp(user._getStateIdentifier(), 'password', undefined);
      response.password = undefined;
      user._finishFetch(response);
      if (!canUseCurrentUser) {
        // We can't set the current user, so just return the one we logged in
        return _ParsePromise2.default.as(user);
      }
      return DefaultController.setCurrentUser(user);
    });
  },
  become: function (options) {
    var user = new ParseUser();
    var RESTController = _CoreManager2.default.getRESTController();
    return RESTController.request('GET', 'users/me', {}, options).then(function (response) {
      user._finishFetch(response);
      user._setExisted(true);
      return DefaultController.setCurrentUser(user);
    });
  },
  logOut: function () {
    return DefaultController.currentUserAsync().then(function (currentUser) {
      var path = _Storage2.default.generatePath(CURRENT_USER_KEY);
      var promise = _Storage2.default.removeItemAsync(path);
      var RESTController = _CoreManager2.default.getRESTController();
      if (currentUser !== null) {
        var currentSession = currentUser.getSessionToken();
        if (currentSession && (0, _isRevocableSession2.default)(currentSession)) {
          promise = promise.then(function () {
            return RESTController.request('POST', 'logout', {}, { sessionToken: currentSession });
          });
        }
        currentUser._logOutWithAll();
        currentUser._finishFetch({ sessionToken: undefined });
      }
      currentUserCacheMatchesDisk = true;
      currentUserCache = null;

      return promise;
    });
  },
  requestPasswordReset: function (email, options) {
    var RESTController = _CoreManager2.default.getRESTController();
    return RESTController.request('POST', 'requestPasswordReset', { email: email }, options);
  },
  upgradeToRevocableSession: function (user, options) {
    var token = user.getSessionToken();
    if (!token) {
      return _ParsePromise2.default.error(new _ParseError2.default(_ParseError2.default.SESSION_MISSING, 'Cannot upgrade a user with no session token'));
    }

    options.sessionToken = token;

    var RESTController = _CoreManager2.default.getRESTController();
    return RESTController.request('POST', 'upgradeToRevocableSession', {}, options).then(function (result) {
      var session = new _ParseSession2.default();
      session._finishFetch(result);
      user._finishFetch({ sessionToken: session.getSessionToken() });
      if (user.isCurrent()) {
        return DefaultController.setCurrentUser(user);
      }
      return _ParsePromise2.default.as(user);
    });
  },
  linkWith: function (user, authData) {
    return user.save({ authData: authData }).then(function () {
      if (canUseCurrentUser) {
        return DefaultController.setCurrentUser(user);
      }
      return user;
    });
  }
};

_CoreManager2.default.setUserController(DefaultController);

exports.default = ParseUser;

/***/ }),
/* 69 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(157);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(74);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(192)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(79)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 77 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(56);
var $export = __webpack_require__(16);
var redefine = __webpack_require__(81);
var hide = __webpack_require__(24);
var Iterators = __webpack_require__(46);
var $iterCreate = __webpack_require__(193);
var setToStringTag = __webpack_require__(60);
var getPrototypeOf = __webpack_require__(114);
var ITERATOR = __webpack_require__(15)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(14);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(24);


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(83);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(77);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(86)('keys');
var uid = __webpack_require__(59);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(5);
var global = __webpack_require__(17);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(56) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 87 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(15);


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var core = __webpack_require__(5);
var LIBRARY = __webpack_require__(56);
var wksExt = __webpack_require__(88);
var defineProperty = __webpack_require__(18).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(62);
var createDesc = __webpack_require__(57);
var toIObject = __webpack_require__(33);
var toPrimitive = __webpack_require__(80);
var has = __webpack_require__(26);
var IE8_DOM_DEFINE = __webpack_require__(111);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(19) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 92 */
/***/ (function(module, exports) {



/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(209), __esModule: true };

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(39);
var IObject = __webpack_require__(82);
var toObject = __webpack_require__(48);
var toLength = __webpack_require__(84);
var asc = __webpack_require__(235);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(24);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * This is a simple wrapper to unify EventEmitter implementations across platforms.
 */

module.exports = __webpack_require__(255).EventEmitter;
var EventEmitter;

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warn;
function warn(s) {
  console.warn('[react-ga]', s);
}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*! For license information please see index.js.LICENSE.txt */
!function(f,e){ true?module.exports=e(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],e):"object"==typeof exports?exports.EmojiPicker=e(require("react")):f.EmojiPicker=e(f.react)}(global,(function(f){return function(f){var e={};function n(a){if(e[a])return e[a].exports;var d=e[a]={i:a,l:!1,exports:{}};return f[a].call(d.exports,d,d.exports,n),d.l=!0,d.exports}return n.m=f,n.c=e,n.d=function(f,e,a){n.o(f,e)||Object.defineProperty(f,e,{enumerable:!0,get:a})},n.r=function(f){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(f,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(f,"__esModule",{value:!0})},n.t=function(f,e){if(1&e&&(f=n(f)),8&e)return f;if(4&e&&"object"==typeof f&&f&&f.__esModule)return f;var a=Object.create(null);if(n.r(a),Object.defineProperty(a,"default",{enumerable:!0,value:f}),2&e&&"string"!=typeof f)for(var d in f)n.d(a,d,function(e){return f[e]}.bind(null,d));return a},n.n=function(f){var e=f&&f.__esModule?function(){return f.default}:function(){return f};return n.d(e,"a",e),e},n.o=function(f,e){return Object.prototype.hasOwnProperty.call(f,e)},n.p="",n(n.s=50)}([function(e,n){e.exports=f},function(f,e,n){f.exports=n(17)()},function(f,e){f.exports={EMOJI_PROPERTY_NAME:"n",EMOJI_PROPERTY_UNIFIED:"u",EMOJI_PROPERTY_SKIN_VARIATIONS:"v",EMOJI_PROPERTY_GROUP:"g",GROUP_NAME_PEOPLE:"smileys_people",GROUP_NAME_NATURE:"animals_nature",GROUP_NAME_FOOD:"food_drink",GROUP_NAME_TRAVEL:"travel_places",GROUP_NAME_ACTIVITIES:"activities",GROUP_NAME_OBJECTS:"objects",GROUP_NAME_SYMBOLS:"symbols",GROUP_NAME_FLAGS:"flags",GROUP_NAME_RECENTLY_USED:"recently_used"}},function(f,e){f.exports=function(f,e,n){return e in f?Object.defineProperty(f,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):f[e]=n,f},f.exports.__esModule=!0,f.exports.default=f.exports},function(f,e,n){var a=n(19),d=n(20),t=n(13),r=n(21);f.exports=function(f,e){return a(f)||d(f,e)||t(f,e)||r()},f.exports.__esModule=!0,f.exports.default=f.exports},function(f,e,n){var a=n(33),d=n(34),t=n(13),r=n(35);f.exports=function(f){return a(f)||d(f)||t(f)||r()},f.exports.__esModule=!0,f.exports.default=f.exports},function(f,e,n){"use strict";var a,d=function(){return void 0===a&&(a=Boolean(window&&document&&document.all&&!window.atob)),a},t=function(){var f={};return function(e){if(void 0===f[e]){var n=document.querySelector(e);if(window.HTMLIFrameElement&&n instanceof window.HTMLIFrameElement)try{n=n.contentDocument.head}catch(f){n=null}f[e]=n}return f[e]}}(),r=[];function o(f){for(var e=-1,n=0;n<r.length;n++)if(r[n].identifier===f){e=n;break}return e}function i(f,e){for(var n={},a=[],d=0;d<f.length;d++){var t=f[d],i=e.base?t[0]+e.base:t[0],c=n[i]||0,u="".concat(i," ").concat(c);n[i]=c+1;var l=o(u),s={css:t[1],media:t[2],sourceMap:t[3]};-1!==l?(r[l].references++,r[l].updater(s)):r.push({identifier:u,updater:p(s,e),references:1}),a.push(u)}return a}function c(f){var e=document.createElement("style"),a=f.attributes||{};if(void 0===a.nonce){var d=n.nc;d&&(a.nonce=d)}if(Object.keys(a).forEach((function(f){e.setAttribute(f,a[f])})),"function"==typeof f.insert)f.insert(e);else{var r=t(f.insert||"head");if(!r)throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");r.appendChild(e)}return e}var u,l=(u=[],function(f,e){return u[f]=e,u.filter(Boolean).join("\n")});function s(f,e,n,a){var d=n?"":a.media?"@media ".concat(a.media," {").concat(a.css,"}"):a.css;if(f.styleSheet)f.styleSheet.cssText=l(e,d);else{var t=document.createTextNode(d),r=f.childNodes;r[e]&&f.removeChild(r[e]),r.length?f.insertBefore(t,r[e]):f.appendChild(t)}}function b(f,e,n){var a=n.css,d=n.media,t=n.sourceMap;if(d?f.setAttribute("media",d):f.removeAttribute("media"),t&&"undefined"!=typeof btoa&&(a+="\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(t))))," */")),f.styleSheet)f.styleSheet.cssText=a;else{for(;f.firstChild;)f.removeChild(f.firstChild);f.appendChild(document.createTextNode(a))}}var g=null,m=0;function p(f,e){var n,a,d;if(e.singleton){var t=m++;n=g||(g=c(e)),a=s.bind(null,n,t,!1),d=s.bind(null,n,t,!0)}else n=c(e),a=b.bind(null,n,e),d=function(){!function(f){if(null===f.parentNode)return!1;f.parentNode.removeChild(f)}(n)};return a(f),function(e){if(e){if(e.css===f.css&&e.media===f.media&&e.sourceMap===f.sourceMap)return;a(f=e)}else d()}}f.exports=function(f,e){(e=e||{}).singleton||"boolean"==typeof e.singleton||(e.singleton=d());var n=i(f=f||[],e);return function(f){if(f=f||[],"[object Array]"===Object.prototype.toString.call(f)){for(var a=0;a<n.length;a++){var d=o(n[a]);r[d].references--}for(var t=i(f,e),c=0;c<n.length;c++){var u=o(n[c]);0===r[u].references&&(r[u].updater(),r.splice(u,1))}n=t}}}},function(f,e,n){"use strict";f.exports=function(f){var e=[];return e.toString=function(){return this.map((function(e){var n=function(f,e){var n=f[1]||"",a=f[3];if(!a)return n;if(e&&"function"==typeof btoa){var d=(r=a,o=btoa(unescape(encodeURIComponent(JSON.stringify(r)))),i="sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(o),"/*# ".concat(i," */")),t=a.sources.map((function(f){return"/*# sourceURL=".concat(a.sourceRoot||"").concat(f," */")}));return[n].concat(t).concat([d]).join("\n")}var r,o,i;return[n].join("\n")}(e,f);return e[2]?"@media ".concat(e[2]," {").concat(n,"}"):n})).join("")},e.i=function(f,n,a){"string"==typeof f&&(f=[[null,f,""]]);var d={};if(a)for(var t=0;t<this.length;t++){var r=this[t][0];null!=r&&(d[r]=!0)}for(var o=0;o<f.length;o++){var i=[].concat(f[o]);a&&d[i[0]]||(n&&(i[2]?i[2]="".concat(n," and ").concat(i[2]):i[2]=n),e.push(i))}},e}},function(f,e,n){var a;!function(){"use strict";var n={}.hasOwnProperty;function d(){for(var f=[],e=0;e<arguments.length;e++){var a=arguments[e];if(a){var t=typeof a;if("string"===t||"number"===t)f.push(a);else if(Array.isArray(a)&&a.length){var r=d.apply(null,a);r&&f.push(r)}else if("object"===t)for(var o in a)n.call(a,o)&&a[o]&&f.push(o)}}return f.join(" ")}f.exports?(d.default=d,f.exports=d):void 0===(a=function(){return d}.apply(e,[]))||(f.exports=a)}()},function(f,e){function n(){return f.exports=n=Object.assign||function(f){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(f[a]=n[a])}return f},f.exports.__esModule=!0,f.exports.default=f.exports,n.apply(this,arguments)}f.exports=n,f.exports.__esModule=!0,f.exports.default=f.exports},function(f){f.exports=JSON.parse('["smileys_people","animals_nature","food_drink","travel_places","activities","objects","symbols","flags"]')},function(f){f.exports=JSON.parse('{"smileys_people":[{"n":["grinning face","grinning"],"u":"1f600"},{"n":["smiling face with open mouth","smiley"],"u":"1f603"},{"n":["smiling face with open mouth and smiling eyes","smile"],"u":"1f604"},{"n":["grinning face with smiling eyes","grin"],"u":"1f601"},{"n":["smiling face with open mouth and tightly-closed eyes","laughing","satisfied"],"u":"1f606"},{"n":["smiling face with open mouth and cold sweat","sweat_smile"],"u":"1f605"},{"n":["rolling on the floor laughing","rolling_on_the_floor_laughing"],"u":"1f923"},{"n":["face with tears of joy","joy"],"u":"1f602"},{"n":["slightly smiling face","slightly_smiling_face"],"u":"1f642"},{"n":["upside-down face","upside_down_face"],"u":"1f643"},{"n":["winking face","wink"],"u":"1f609"},{"n":["smiling face with smiling eyes","blush"],"u":"1f60a"},{"n":["smiling face with halo","innocent"],"u":"1f607"},{"n":["smiling face with smiling eyes and three hearts","smiling_face_with_3_hearts"],"u":"1f970"},{"n":["smiling face with heart-shaped eyes","heart_eyes"],"u":"1f60d"},{"n":["grinning face with star eyes","star-struck","grinning_face_with_star_eyes"],"u":"1f929"},{"n":["face throwing a kiss","kissing_heart"],"u":"1f618"},{"n":["kissing face","kissing"],"u":"1f617"},{"n":["white smiling face","relaxed"],"u":"263a-fe0f"},{"n":["kissing face with closed eyes","kissing_closed_eyes"],"u":"1f61a"},{"n":["kissing face with smiling eyes","kissing_smiling_eyes"],"u":"1f619"},{"n":["smiling face with tear","smiling_face_with_tear"],"u":"1f972"},{"n":["face savouring delicious food","yum"],"u":"1f60b"},{"n":["face with stuck-out tongue","stuck_out_tongue"],"u":"1f61b"},{"n":["face with stuck-out tongue and winking eye","stuck_out_tongue_winking_eye"],"u":"1f61c"},{"n":["grinning face with one large and one small eye","zany_face","grinning_face_with_one_large_and_one_small_eye"],"u":"1f92a"},{"n":["face with stuck-out tongue and tightly-closed eyes","stuck_out_tongue_closed_eyes"],"u":"1f61d"},{"n":["money-mouth face","money_mouth_face"],"u":"1f911"},{"n":["hugging face","hugging_face"],"u":"1f917"},{"n":["smiling face with smiling eyes and hand covering mouth","face_with_hand_over_mouth","smiling_face_with_smiling_eyes_and_hand_covering_mouth"],"u":"1f92d"},{"n":["face with finger covering closed lips","shushing_face","face_with_finger_covering_closed_lips"],"u":"1f92b"},{"n":["thinking face","thinking_face"],"u":"1f914"},{"n":["zipper-mouth face","zipper_mouth_face"],"u":"1f910"},{"n":["face with one eyebrow raised","face_with_raised_eyebrow","face_with_one_eyebrow_raised"],"u":"1f928"},{"n":["neutral face","neutral_face"],"u":"1f610"},{"n":["expressionless face","expressionless"],"u":"1f611"},{"n":["face without mouth","no_mouth"],"u":"1f636"},{"n":["face in clouds","face_in_clouds"],"u":"1f636-200d-1f32b-fe0f"},{"n":["smirking face","smirk"],"u":"1f60f"},{"n":["unamused face","unamused"],"u":"1f612"},{"n":["face with rolling eyes","face_with_rolling_eyes"],"u":"1f644"},{"n":["grimacing face","grimacing"],"u":"1f62c"},{"n":["face exhaling","face_exhaling"],"u":"1f62e-200d-1f4a8"},{"n":["lying face","lying_face"],"u":"1f925"},{"n":["relieved face","relieved"],"u":"1f60c"},{"n":["pensive face","pensive"],"u":"1f614"},{"n":["sleepy face","sleepy"],"u":"1f62a"},{"n":["drooling face","drooling_face"],"u":"1f924"},{"n":["sleeping face","sleeping"],"u":"1f634"},{"n":["face with medical mask","mask"],"u":"1f637"},{"n":["face with thermometer","face_with_thermometer"],"u":"1f912"},{"n":["face with head-bandage","face_with_head_bandage"],"u":"1f915"},{"n":["nauseated face","nauseated_face"],"u":"1f922"},{"n":["face with open mouth vomiting","face_vomiting","face_with_open_mouth_vomiting"],"u":"1f92e"},{"n":["sneezing face","sneezing_face"],"u":"1f927"},{"n":["overheated face","hot_face"],"u":"1f975"},{"n":["freezing face","cold_face"],"u":"1f976"},{"n":["face with uneven eyes and wavy mouth","woozy_face"],"u":"1f974"},{"n":["dizzy face","dizzy_face"],"u":"1f635"},{"n":["face with spiral eyes","face_with_spiral_eyes"],"u":"1f635-200d-1f4ab"},{"n":["shocked face with exploding head","exploding_head","shocked_face_with_exploding_head"],"u":"1f92f"},{"n":["face with cowboy hat","face_with_cowboy_hat"],"u":"1f920"},{"n":["face with party horn and party hat","partying_face"],"u":"1f973"},{"n":["disguised face","disguised_face"],"u":"1f978"},{"n":["smiling face with sunglasses","sunglasses"],"u":"1f60e"},{"n":["nerd face","nerd_face"],"u":"1f913"},{"n":["face with monocle","face_with_monocle"],"u":"1f9d0"},{"n":["confused face","confused"],"u":"1f615"},{"n":["worried face","worried"],"u":"1f61f"},{"n":["slightly frowning face","slightly_frowning_face"],"u":"1f641"},{"n":["frowning face","white_frowning_face"],"u":"2639-fe0f"},{"n":["face with open mouth","open_mouth"],"u":"1f62e"},{"n":["hushed face","hushed"],"u":"1f62f"},{"n":["astonished face","astonished"],"u":"1f632"},{"n":["flushed face","flushed"],"u":"1f633"},{"n":["face with pleading eyes","pleading_face"],"u":"1f97a"},{"n":["frowning face with open mouth","frowning"],"u":"1f626"},{"n":["anguished face","anguished"],"u":"1f627"},{"n":["fearful face","fearful"],"u":"1f628"},{"n":["face with open mouth and cold sweat","cold_sweat"],"u":"1f630"},{"n":["disappointed but relieved face","disappointed_relieved"],"u":"1f625"},{"n":["crying face","cry"],"u":"1f622"},{"n":["loudly crying face","sob"],"u":"1f62d"},{"n":["face screaming in fear","scream"],"u":"1f631"},{"n":["confounded face","confounded"],"u":"1f616"},{"n":["persevering face","persevere"],"u":"1f623"},{"n":["disappointed face","disappointed"],"u":"1f61e"},{"n":["face with cold sweat","sweat"],"u":"1f613"},{"n":["weary face","weary"],"u":"1f629"},{"n":["tired face","tired_face"],"u":"1f62b"},{"n":["yawning face","yawning_face"],"u":"1f971"},{"n":["face with look of triumph","triumph"],"u":"1f624"},{"n":["pouting face","rage"],"u":"1f621"},{"n":["angry face","angry"],"u":"1f620"},{"n":["serious face with symbols covering mouth","face_with_symbols_on_mouth","serious_face_with_symbols_covering_mouth"],"u":"1f92c"},{"n":["smiling face with horns","smiling_imp"],"u":"1f608"},{"n":["imp"],"u":"1f47f"},{"n":["skull"],"u":"1f480"},{"n":["skull and crossbones","skull_and_crossbones"],"u":"2620-fe0f"},{"n":["pile of poo","hankey","poop","shit"],"u":"1f4a9"},{"n":["clown face","clown_face"],"u":"1f921"},{"n":["japanese ogre","japanese_ogre"],"u":"1f479"},{"n":["japanese goblin","japanese_goblin"],"u":"1f47a"},{"n":["ghost"],"u":"1f47b"},{"n":["extraterrestrial alien","alien"],"u":"1f47d"},{"n":["alien monster","space_invader"],"u":"1f47e"},{"n":["robot face","robot_face"],"u":"1f916"},{"n":["smiling cat face with open mouth","smiley_cat"],"u":"1f63a"},{"n":["grinning cat face with smiling eyes","smile_cat"],"u":"1f638"},{"n":["cat face with tears of joy","joy_cat"],"u":"1f639"},{"n":["smiling cat face with heart-shaped eyes","heart_eyes_cat"],"u":"1f63b"},{"n":["cat face with wry smile","smirk_cat"],"u":"1f63c"},{"n":["kissing cat face with closed eyes","kissing_cat"],"u":"1f63d"},{"n":["weary cat face","scream_cat"],"u":"1f640"},{"n":["crying cat face","crying_cat_face"],"u":"1f63f"},{"n":["pouting cat face","pouting_cat"],"u":"1f63e"},{"n":["see-no-evil monkey","see_no_evil"],"u":"1f648"},{"n":["hear-no-evil monkey","hear_no_evil"],"u":"1f649"},{"n":["speak-no-evil monkey","speak_no_evil"],"u":"1f64a"},{"n":["kiss mark","kiss"],"u":"1f48b"},{"n":["love letter","love_letter"],"u":"1f48c"},{"n":["heart with arrow","cupid"],"u":"1f498"},{"n":["heart with ribbon","gift_heart"],"u":"1f49d"},{"n":["sparkling heart","sparkling_heart"],"u":"1f496"},{"n":["growing heart","heartpulse"],"u":"1f497"},{"n":["beating heart","heartbeat"],"u":"1f493"},{"n":["revolving hearts","revolving_hearts"],"u":"1f49e"},{"n":["two hearts","two_hearts"],"u":"1f495"},{"n":["heart decoration","heart_decoration"],"u":"1f49f"},{"n":["heart exclamation","heavy_heart_exclamation_mark_ornament"],"u":"2763-fe0f"},{"n":["broken heart","broken_heart"],"u":"1f494"},{"n":["heart on fire","heart_on_fire"],"u":"2764-fe0f-200d-1f525"},{"n":["mending heart","mending_heart"],"u":"2764-fe0f-200d-1fa79"},{"n":["heavy black heart","heart"],"u":"2764-fe0f"},{"n":["orange heart","orange_heart"],"u":"1f9e1"},{"n":["yellow heart","yellow_heart"],"u":"1f49b"},{"n":["green heart","green_heart"],"u":"1f49a"},{"n":["blue heart","blue_heart"],"u":"1f499"},{"n":["purple heart","purple_heart"],"u":"1f49c"},{"n":["brown heart","brown_heart"],"u":"1f90e"},{"n":["black heart","black_heart"],"u":"1f5a4"},{"n":["white heart","white_heart"],"u":"1f90d"},{"n":["hundred points symbol","100"],"u":"1f4af"},{"n":["anger symbol","anger"],"u":"1f4a2"},{"n":["collision symbol","boom","collision"],"u":"1f4a5"},{"n":["dizzy symbol","dizzy"],"u":"1f4ab"},{"n":["splashing sweat symbol","sweat_drops"],"u":"1f4a6"},{"n":["dash symbol","dash"],"u":"1f4a8"},{"n":["hole"],"u":"1f573-fe0f"},{"n":["bomb"],"u":"1f4a3"},{"n":["speech balloon","speech_balloon"],"u":"1f4ac"},{"n":["eye in speech bubble","eye-in-speech-bubble"],"u":"1f441-fe0f-200d-1f5e8-fe0f"},{"n":["left speech bubble","left_speech_bubble"],"u":"1f5e8-fe0f"},{"n":["right anger bubble","right_anger_bubble"],"u":"1f5ef-fe0f"},{"n":["thought balloon","thought_balloon"],"u":"1f4ad"},{"n":["sleeping symbol","zzz"],"u":"1f4a4"},{"n":["waving hand sign","wave"],"u":"1f44b","v":["1f44b-1f3fb","1f44b-1f3fc","1f44b-1f3fd","1f44b-1f3fe","1f44b-1f3ff"]},{"n":["raised back of hand","raised_back_of_hand"],"u":"1f91a","v":["1f91a-1f3fb","1f91a-1f3fc","1f91a-1f3fd","1f91a-1f3fe","1f91a-1f3ff"]},{"n":["hand with fingers splayed","raised_hand_with_fingers_splayed"],"u":"1f590-fe0f","v":["1f590-1f3fb","1f590-1f3fc","1f590-1f3fd","1f590-1f3fe","1f590-1f3ff"]},{"n":["raised hand","hand","raised_hand"],"u":"270b","v":["270b-1f3fb","270b-1f3fc","270b-1f3fd","270b-1f3fe","270b-1f3ff"]},{"n":["raised hand with part between middle and ring fingers","spock-hand"],"u":"1f596","v":["1f596-1f3fb","1f596-1f3fc","1f596-1f3fd","1f596-1f3fe","1f596-1f3ff"]},{"n":["ok hand sign","ok_hand"],"u":"1f44c","v":["1f44c-1f3fb","1f44c-1f3fc","1f44c-1f3fd","1f44c-1f3fe","1f44c-1f3ff"]},{"n":["pinched fingers","pinched_fingers"],"u":"1f90c","v":["1f90c-1f3fb","1f90c-1f3fc","1f90c-1f3fd","1f90c-1f3fe","1f90c-1f3ff"]},{"n":["pinching hand","pinching_hand"],"u":"1f90f","v":["1f90f-1f3fb","1f90f-1f3fc","1f90f-1f3fd","1f90f-1f3fe","1f90f-1f3ff"]},{"n":["victory hand","v"],"u":"270c-fe0f","v":["270c-1f3fb","270c-1f3fc","270c-1f3fd","270c-1f3fe","270c-1f3ff"]},{"n":["hand with index and middle fingers crossed","crossed_fingers","hand_with_index_and_middle_fingers_crossed"],"u":"1f91e","v":["1f91e-1f3fb","1f91e-1f3fc","1f91e-1f3fd","1f91e-1f3fe","1f91e-1f3ff"]},{"n":["i love you hand sign","i_love_you_hand_sign"],"u":"1f91f","v":["1f91f-1f3fb","1f91f-1f3fc","1f91f-1f3fd","1f91f-1f3fe","1f91f-1f3ff"]},{"n":["sign of the horns","the_horns","sign_of_the_horns"],"u":"1f918","v":["1f918-1f3fb","1f918-1f3fc","1f918-1f3fd","1f918-1f3fe","1f918-1f3ff"]},{"n":["call me hand","call_me_hand"],"u":"1f919","v":["1f919-1f3fb","1f919-1f3fc","1f919-1f3fd","1f919-1f3fe","1f919-1f3ff"]},{"n":["white left pointing backhand index","point_left"],"u":"1f448","v":["1f448-1f3fb","1f448-1f3fc","1f448-1f3fd","1f448-1f3fe","1f448-1f3ff"]},{"n":["white right pointing backhand index","point_right"],"u":"1f449","v":["1f449-1f3fb","1f449-1f3fc","1f449-1f3fd","1f449-1f3fe","1f449-1f3ff"]},{"n":["white up pointing backhand index","point_up_2"],"u":"1f446","v":["1f446-1f3fb","1f446-1f3fc","1f446-1f3fd","1f446-1f3fe","1f446-1f3ff"]},{"n":["reversed hand with middle finger extended","middle_finger","reversed_hand_with_middle_finger_extended"],"u":"1f595","v":["1f595-1f3fb","1f595-1f3fc","1f595-1f3fd","1f595-1f3fe","1f595-1f3ff"]},{"n":["white down pointing backhand index","point_down"],"u":"1f447","v":["1f447-1f3fb","1f447-1f3fc","1f447-1f3fd","1f447-1f3fe","1f447-1f3ff"]},{"n":["white up pointing index","point_up"],"u":"261d-fe0f","v":["261d-1f3fb","261d-1f3fc","261d-1f3fd","261d-1f3fe","261d-1f3ff"]},{"n":["thumbs up sign","+1","thumbsup"],"u":"1f44d","v":["1f44d-1f3fb","1f44d-1f3fc","1f44d-1f3fd","1f44d-1f3fe","1f44d-1f3ff"]},{"n":["thumbs down sign","-1","thumbsdown"],"u":"1f44e","v":["1f44e-1f3fb","1f44e-1f3fc","1f44e-1f3fd","1f44e-1f3fe","1f44e-1f3ff"]},{"n":["raised fist","fist"],"u":"270a","v":["270a-1f3fb","270a-1f3fc","270a-1f3fd","270a-1f3fe","270a-1f3ff"]},{"n":["fisted hand sign","facepunch","punch"],"u":"1f44a","v":["1f44a-1f3fb","1f44a-1f3fc","1f44a-1f3fd","1f44a-1f3fe","1f44a-1f3ff"]},{"n":["left-facing fist","left-facing_fist"],"u":"1f91b","v":["1f91b-1f3fb","1f91b-1f3fc","1f91b-1f3fd","1f91b-1f3fe","1f91b-1f3ff"]},{"n":["right-facing fist","right-facing_fist"],"u":"1f91c","v":["1f91c-1f3fb","1f91c-1f3fc","1f91c-1f3fd","1f91c-1f3fe","1f91c-1f3ff"]},{"n":["clapping hands sign","clap"],"u":"1f44f","v":["1f44f-1f3fb","1f44f-1f3fc","1f44f-1f3fd","1f44f-1f3fe","1f44f-1f3ff"]},{"n":["person raising both hands in celebration","raised_hands"],"u":"1f64c","v":["1f64c-1f3fb","1f64c-1f3fc","1f64c-1f3fd","1f64c-1f3fe","1f64c-1f3ff"]},{"n":["open hands sign","open_hands"],"u":"1f450","v":["1f450-1f3fb","1f450-1f3fc","1f450-1f3fd","1f450-1f3fe","1f450-1f3ff"]},{"n":["palms up together","palms_up_together"],"u":"1f932","v":["1f932-1f3fb","1f932-1f3fc","1f932-1f3fd","1f932-1f3fe","1f932-1f3ff"]},{"n":["handshake"],"u":"1f91d"},{"n":["person with folded hands","pray"],"u":"1f64f","v":["1f64f-1f3fb","1f64f-1f3fc","1f64f-1f3fd","1f64f-1f3fe","1f64f-1f3ff"]},{"n":["writing hand","writing_hand"],"u":"270d-fe0f","v":["270d-1f3fb","270d-1f3fc","270d-1f3fd","270d-1f3fe","270d-1f3ff"]},{"n":["nail polish","nail_care"],"u":"1f485","v":["1f485-1f3fb","1f485-1f3fc","1f485-1f3fd","1f485-1f3fe","1f485-1f3ff"]},{"n":["selfie"],"u":"1f933","v":["1f933-1f3fb","1f933-1f3fc","1f933-1f3fd","1f933-1f3fe","1f933-1f3ff"]},{"n":["flexed biceps","muscle"],"u":"1f4aa","v":["1f4aa-1f3fb","1f4aa-1f3fc","1f4aa-1f3fd","1f4aa-1f3fe","1f4aa-1f3ff"]},{"n":["mechanical arm","mechanical_arm"],"u":"1f9be"},{"n":["mechanical leg","mechanical_leg"],"u":"1f9bf"},{"n":["leg"],"u":"1f9b5","v":["1f9b5-1f3fb","1f9b5-1f3fc","1f9b5-1f3fd","1f9b5-1f3fe","1f9b5-1f3ff"]},{"n":["foot"],"u":"1f9b6","v":["1f9b6-1f3fb","1f9b6-1f3fc","1f9b6-1f3fd","1f9b6-1f3fe","1f9b6-1f3ff"]},{"n":["ear"],"u":"1f442","v":["1f442-1f3fb","1f442-1f3fc","1f442-1f3fd","1f442-1f3fe","1f442-1f3ff"]},{"n":["ear with hearing aid","ear_with_hearing_aid"],"u":"1f9bb","v":["1f9bb-1f3fb","1f9bb-1f3fc","1f9bb-1f3fd","1f9bb-1f3fe","1f9bb-1f3ff"]},{"n":["nose"],"u":"1f443","v":["1f443-1f3fb","1f443-1f3fc","1f443-1f3fd","1f443-1f3fe","1f443-1f3ff"]},{"n":["brain"],"u":"1f9e0"},{"n":["anatomical heart","anatomical_heart"],"u":"1fac0"},{"n":["lungs"],"u":"1fac1"},{"n":["tooth"],"u":"1f9b7"},{"n":["bone"],"u":"1f9b4"},{"n":["eyes"],"u":"1f440"},{"n":["eye"],"u":"1f441-fe0f"},{"n":["tongue"],"u":"1f445"},{"n":["mouth","lips"],"u":"1f444"},{"n":["baby"],"u":"1f476","v":["1f476-1f3fb","1f476-1f3fc","1f476-1f3fd","1f476-1f3fe","1f476-1f3ff"]},{"n":["child"],"u":"1f9d2","v":["1f9d2-1f3fb","1f9d2-1f3fc","1f9d2-1f3fd","1f9d2-1f3fe","1f9d2-1f3ff"]},{"n":["boy"],"u":"1f466","v":["1f466-1f3fb","1f466-1f3fc","1f466-1f3fd","1f466-1f3fe","1f466-1f3ff"]},{"n":["girl"],"u":"1f467","v":["1f467-1f3fb","1f467-1f3fc","1f467-1f3fd","1f467-1f3fe","1f467-1f3ff"]},{"n":["adult"],"u":"1f9d1","v":["1f9d1-1f3fb","1f9d1-1f3fc","1f9d1-1f3fd","1f9d1-1f3fe","1f9d1-1f3ff"]},{"n":["person with blond hair","person_with_blond_hair"],"u":"1f471","v":["1f471-1f3fb","1f471-1f3fc","1f471-1f3fd","1f471-1f3fe","1f471-1f3ff"]},{"n":["man"],"u":"1f468","v":["1f468-1f3fb","1f468-1f3fc","1f468-1f3fd","1f468-1f3fe","1f468-1f3ff"]},{"n":["bearded person","bearded_person"],"u":"1f9d4","v":["1f9d4-1f3fb","1f9d4-1f3fc","1f9d4-1f3fd","1f9d4-1f3fe","1f9d4-1f3ff"]},{"n":["man: beard","man_with_beard"],"u":"1f9d4-200d-2642-fe0f","v":["1f9d4-1f3fb-200d-2642-fe0f","1f9d4-1f3fc-200d-2642-fe0f","1f9d4-1f3fd-200d-2642-fe0f","1f9d4-1f3fe-200d-2642-fe0f","1f9d4-1f3ff-200d-2642-fe0f"]},{"n":["woman: beard","woman_with_beard"],"u":"1f9d4-200d-2640-fe0f","v":["1f9d4-1f3fb-200d-2640-fe0f","1f9d4-1f3fc-200d-2640-fe0f","1f9d4-1f3fd-200d-2640-fe0f","1f9d4-1f3fe-200d-2640-fe0f","1f9d4-1f3ff-200d-2640-fe0f"]},{"n":["man: red hair","red_haired_man"],"u":"1f468-200d-1f9b0","v":["1f468-1f3fb-200d-1f9b0","1f468-1f3fc-200d-1f9b0","1f468-1f3fd-200d-1f9b0","1f468-1f3fe-200d-1f9b0","1f468-1f3ff-200d-1f9b0"]},{"n":["man: curly hair","curly_haired_man"],"u":"1f468-200d-1f9b1","v":["1f468-1f3fb-200d-1f9b1","1f468-1f3fc-200d-1f9b1","1f468-1f3fd-200d-1f9b1","1f468-1f3fe-200d-1f9b1","1f468-1f3ff-200d-1f9b1"]},{"n":["man: white hair","white_haired_man"],"u":"1f468-200d-1f9b3","v":["1f468-1f3fb-200d-1f9b3","1f468-1f3fc-200d-1f9b3","1f468-1f3fd-200d-1f9b3","1f468-1f3fe-200d-1f9b3","1f468-1f3ff-200d-1f9b3"]},{"n":["man: bald","bald_man"],"u":"1f468-200d-1f9b2","v":["1f468-1f3fb-200d-1f9b2","1f468-1f3fc-200d-1f9b2","1f468-1f3fd-200d-1f9b2","1f468-1f3fe-200d-1f9b2","1f468-1f3ff-200d-1f9b2"]},{"n":["woman"],"u":"1f469","v":["1f469-1f3fb","1f469-1f3fc","1f469-1f3fd","1f469-1f3fe","1f469-1f3ff"]},{"n":["woman: red hair","red_haired_woman"],"u":"1f469-200d-1f9b0","v":["1f469-1f3fb-200d-1f9b0","1f469-1f3fc-200d-1f9b0","1f469-1f3fd-200d-1f9b0","1f469-1f3fe-200d-1f9b0","1f469-1f3ff-200d-1f9b0"]},{"n":["person: red hair","red_haired_person"],"u":"1f9d1-200d-1f9b0","v":["1f9d1-1f3fb-200d-1f9b0","1f9d1-1f3fc-200d-1f9b0","1f9d1-1f3fd-200d-1f9b0","1f9d1-1f3fe-200d-1f9b0","1f9d1-1f3ff-200d-1f9b0"]},{"n":["woman: curly hair","curly_haired_woman"],"u":"1f469-200d-1f9b1","v":["1f469-1f3fb-200d-1f9b1","1f469-1f3fc-200d-1f9b1","1f469-1f3fd-200d-1f9b1","1f469-1f3fe-200d-1f9b1","1f469-1f3ff-200d-1f9b1"]},{"n":["person: curly hair","curly_haired_person"],"u":"1f9d1-200d-1f9b1","v":["1f9d1-1f3fb-200d-1f9b1","1f9d1-1f3fc-200d-1f9b1","1f9d1-1f3fd-200d-1f9b1","1f9d1-1f3fe-200d-1f9b1","1f9d1-1f3ff-200d-1f9b1"]},{"n":["woman: white hair","white_haired_woman"],"u":"1f469-200d-1f9b3","v":["1f469-1f3fb-200d-1f9b3","1f469-1f3fc-200d-1f9b3","1f469-1f3fd-200d-1f9b3","1f469-1f3fe-200d-1f9b3","1f469-1f3ff-200d-1f9b3"]},{"n":["person: white hair","white_haired_person"],"u":"1f9d1-200d-1f9b3","v":["1f9d1-1f3fb-200d-1f9b3","1f9d1-1f3fc-200d-1f9b3","1f9d1-1f3fd-200d-1f9b3","1f9d1-1f3fe-200d-1f9b3","1f9d1-1f3ff-200d-1f9b3"]},{"n":["woman: bald","bald_woman"],"u":"1f469-200d-1f9b2","v":["1f469-1f3fb-200d-1f9b2","1f469-1f3fc-200d-1f9b2","1f469-1f3fd-200d-1f9b2","1f469-1f3fe-200d-1f9b2","1f469-1f3ff-200d-1f9b2"]},{"n":["person: bald","bald_person"],"u":"1f9d1-200d-1f9b2","v":["1f9d1-1f3fb-200d-1f9b2","1f9d1-1f3fc-200d-1f9b2","1f9d1-1f3fd-200d-1f9b2","1f9d1-1f3fe-200d-1f9b2","1f9d1-1f3ff-200d-1f9b2"]},{"n":["woman: blond hair","blond-haired-woman"],"u":"1f471-200d-2640-fe0f","v":["1f471-1f3fb-200d-2640-fe0f","1f471-1f3fc-200d-2640-fe0f","1f471-1f3fd-200d-2640-fe0f","1f471-1f3fe-200d-2640-fe0f","1f471-1f3ff-200d-2640-fe0f"]},{"n":["man: blond hair","blond-haired-man"],"u":"1f471-200d-2642-fe0f","v":["1f471-1f3fb-200d-2642-fe0f","1f471-1f3fc-200d-2642-fe0f","1f471-1f3fd-200d-2642-fe0f","1f471-1f3fe-200d-2642-fe0f","1f471-1f3ff-200d-2642-fe0f"]},{"n":["older adult","older_adult"],"u":"1f9d3","v":["1f9d3-1f3fb","1f9d3-1f3fc","1f9d3-1f3fd","1f9d3-1f3fe","1f9d3-1f3ff"]},{"n":["older man","older_man"],"u":"1f474","v":["1f474-1f3fb","1f474-1f3fc","1f474-1f3fd","1f474-1f3fe","1f474-1f3ff"]},{"n":["older woman","older_woman"],"u":"1f475","v":["1f475-1f3fb","1f475-1f3fc","1f475-1f3fd","1f475-1f3fe","1f475-1f3ff"]},{"n":["person frowning","person_frowning"],"u":"1f64d","v":["1f64d-1f3fb","1f64d-1f3fc","1f64d-1f3fd","1f64d-1f3fe","1f64d-1f3ff"]},{"n":["man frowning","man-frowning"],"u":"1f64d-200d-2642-fe0f","v":["1f64d-1f3fb-200d-2642-fe0f","1f64d-1f3fc-200d-2642-fe0f","1f64d-1f3fd-200d-2642-fe0f","1f64d-1f3fe-200d-2642-fe0f","1f64d-1f3ff-200d-2642-fe0f"]},{"n":["woman frowning","woman-frowning"],"u":"1f64d-200d-2640-fe0f","v":["1f64d-1f3fb-200d-2640-fe0f","1f64d-1f3fc-200d-2640-fe0f","1f64d-1f3fd-200d-2640-fe0f","1f64d-1f3fe-200d-2640-fe0f","1f64d-1f3ff-200d-2640-fe0f"]},{"n":["person with pouting face","person_with_pouting_face"],"u":"1f64e","v":["1f64e-1f3fb","1f64e-1f3fc","1f64e-1f3fd","1f64e-1f3fe","1f64e-1f3ff"]},{"n":["man pouting","man-pouting"],"u":"1f64e-200d-2642-fe0f","v":["1f64e-1f3fb-200d-2642-fe0f","1f64e-1f3fc-200d-2642-fe0f","1f64e-1f3fd-200d-2642-fe0f","1f64e-1f3fe-200d-2642-fe0f","1f64e-1f3ff-200d-2642-fe0f"]},{"n":["woman pouting","woman-pouting"],"u":"1f64e-200d-2640-fe0f","v":["1f64e-1f3fb-200d-2640-fe0f","1f64e-1f3fc-200d-2640-fe0f","1f64e-1f3fd-200d-2640-fe0f","1f64e-1f3fe-200d-2640-fe0f","1f64e-1f3ff-200d-2640-fe0f"]},{"n":["face with no good gesture","no_good"],"u":"1f645","v":["1f645-1f3fb","1f645-1f3fc","1f645-1f3fd","1f645-1f3fe","1f645-1f3ff"]},{"n":["man gesturing no","man-gesturing-no"],"u":"1f645-200d-2642-fe0f","v":["1f645-1f3fb-200d-2642-fe0f","1f645-1f3fc-200d-2642-fe0f","1f645-1f3fd-200d-2642-fe0f","1f645-1f3fe-200d-2642-fe0f","1f645-1f3ff-200d-2642-fe0f"]},{"n":["woman gesturing no","woman-gesturing-no"],"u":"1f645-200d-2640-fe0f","v":["1f645-1f3fb-200d-2640-fe0f","1f645-1f3fc-200d-2640-fe0f","1f645-1f3fd-200d-2640-fe0f","1f645-1f3fe-200d-2640-fe0f","1f645-1f3ff-200d-2640-fe0f"]},{"n":["face with ok gesture","ok_woman"],"u":"1f646","v":["1f646-1f3fb","1f646-1f3fc","1f646-1f3fd","1f646-1f3fe","1f646-1f3ff"]},{"n":["man gesturing ok","man-gesturing-ok"],"u":"1f646-200d-2642-fe0f","v":["1f646-1f3fb-200d-2642-fe0f","1f646-1f3fc-200d-2642-fe0f","1f646-1f3fd-200d-2642-fe0f","1f646-1f3fe-200d-2642-fe0f","1f646-1f3ff-200d-2642-fe0f"]},{"n":["woman gesturing ok","woman-gesturing-ok"],"u":"1f646-200d-2640-fe0f","v":["1f646-1f3fb-200d-2640-fe0f","1f646-1f3fc-200d-2640-fe0f","1f646-1f3fd-200d-2640-fe0f","1f646-1f3fe-200d-2640-fe0f","1f646-1f3ff-200d-2640-fe0f"]},{"n":["information desk person","information_desk_person"],"u":"1f481","v":["1f481-1f3fb","1f481-1f3fc","1f481-1f3fd","1f481-1f3fe","1f481-1f3ff"]},{"n":["man tipping hand","man-tipping-hand"],"u":"1f481-200d-2642-fe0f","v":["1f481-1f3fb-200d-2642-fe0f","1f481-1f3fc-200d-2642-fe0f","1f481-1f3fd-200d-2642-fe0f","1f481-1f3fe-200d-2642-fe0f","1f481-1f3ff-200d-2642-fe0f"]},{"n":["woman tipping hand","woman-tipping-hand"],"u":"1f481-200d-2640-fe0f","v":["1f481-1f3fb-200d-2640-fe0f","1f481-1f3fc-200d-2640-fe0f","1f481-1f3fd-200d-2640-fe0f","1f481-1f3fe-200d-2640-fe0f","1f481-1f3ff-200d-2640-fe0f"]},{"n":["happy person raising one hand","raising_hand"],"u":"1f64b","v":["1f64b-1f3fb","1f64b-1f3fc","1f64b-1f3fd","1f64b-1f3fe","1f64b-1f3ff"]},{"n":["man raising hand","man-raising-hand"],"u":"1f64b-200d-2642-fe0f","v":["1f64b-1f3fb-200d-2642-fe0f","1f64b-1f3fc-200d-2642-fe0f","1f64b-1f3fd-200d-2642-fe0f","1f64b-1f3fe-200d-2642-fe0f","1f64b-1f3ff-200d-2642-fe0f"]},{"n":["woman raising hand","woman-raising-hand"],"u":"1f64b-200d-2640-fe0f","v":["1f64b-1f3fb-200d-2640-fe0f","1f64b-1f3fc-200d-2640-fe0f","1f64b-1f3fd-200d-2640-fe0f","1f64b-1f3fe-200d-2640-fe0f","1f64b-1f3ff-200d-2640-fe0f"]},{"n":["deaf person","deaf_person"],"u":"1f9cf","v":["1f9cf-1f3fb","1f9cf-1f3fc","1f9cf-1f3fd","1f9cf-1f3fe","1f9cf-1f3ff"]},{"n":["deaf man","deaf_man"],"u":"1f9cf-200d-2642-fe0f","v":["1f9cf-1f3fb-200d-2642-fe0f","1f9cf-1f3fc-200d-2642-fe0f","1f9cf-1f3fd-200d-2642-fe0f","1f9cf-1f3fe-200d-2642-fe0f","1f9cf-1f3ff-200d-2642-fe0f"]},{"n":["deaf woman","deaf_woman"],"u":"1f9cf-200d-2640-fe0f","v":["1f9cf-1f3fb-200d-2640-fe0f","1f9cf-1f3fc-200d-2640-fe0f","1f9cf-1f3fd-200d-2640-fe0f","1f9cf-1f3fe-200d-2640-fe0f","1f9cf-1f3ff-200d-2640-fe0f"]},{"n":["person bowing deeply","bow"],"u":"1f647","v":["1f647-1f3fb","1f647-1f3fc","1f647-1f3fd","1f647-1f3fe","1f647-1f3ff"]},{"n":["man bowing","man-bowing"],"u":"1f647-200d-2642-fe0f","v":["1f647-1f3fb-200d-2642-fe0f","1f647-1f3fc-200d-2642-fe0f","1f647-1f3fd-200d-2642-fe0f","1f647-1f3fe-200d-2642-fe0f","1f647-1f3ff-200d-2642-fe0f"]},{"n":["woman bowing","woman-bowing"],"u":"1f647-200d-2640-fe0f","v":["1f647-1f3fb-200d-2640-fe0f","1f647-1f3fc-200d-2640-fe0f","1f647-1f3fd-200d-2640-fe0f","1f647-1f3fe-200d-2640-fe0f","1f647-1f3ff-200d-2640-fe0f"]},{"n":["face palm","face_palm"],"u":"1f926","v":["1f926-1f3fb","1f926-1f3fc","1f926-1f3fd","1f926-1f3fe","1f926-1f3ff"]},{"n":["man facepalming","man-facepalming"],"u":"1f926-200d-2642-fe0f","v":["1f926-1f3fb-200d-2642-fe0f","1f926-1f3fc-200d-2642-fe0f","1f926-1f3fd-200d-2642-fe0f","1f926-1f3fe-200d-2642-fe0f","1f926-1f3ff-200d-2642-fe0f"]},{"n":["woman facepalming","woman-facepalming"],"u":"1f926-200d-2640-fe0f","v":["1f926-1f3fb-200d-2640-fe0f","1f926-1f3fc-200d-2640-fe0f","1f926-1f3fd-200d-2640-fe0f","1f926-1f3fe-200d-2640-fe0f","1f926-1f3ff-200d-2640-fe0f"]},{"n":["shrug"],"u":"1f937","v":["1f937-1f3fb","1f937-1f3fc","1f937-1f3fd","1f937-1f3fe","1f937-1f3ff"]},{"n":["man shrugging","man-shrugging"],"u":"1f937-200d-2642-fe0f","v":["1f937-1f3fb-200d-2642-fe0f","1f937-1f3fc-200d-2642-fe0f","1f937-1f3fd-200d-2642-fe0f","1f937-1f3fe-200d-2642-fe0f","1f937-1f3ff-200d-2642-fe0f"]},{"n":["woman shrugging","woman-shrugging"],"u":"1f937-200d-2640-fe0f","v":["1f937-1f3fb-200d-2640-fe0f","1f937-1f3fc-200d-2640-fe0f","1f937-1f3fd-200d-2640-fe0f","1f937-1f3fe-200d-2640-fe0f","1f937-1f3ff-200d-2640-fe0f"]},{"n":["health worker","health_worker"],"u":"1f9d1-200d-2695-fe0f","v":["1f9d1-1f3fb-200d-2695-fe0f","1f9d1-1f3fc-200d-2695-fe0f","1f9d1-1f3fd-200d-2695-fe0f","1f9d1-1f3fe-200d-2695-fe0f","1f9d1-1f3ff-200d-2695-fe0f"]},{"n":["man health worker","male-doctor"],"u":"1f468-200d-2695-fe0f","v":["1f468-1f3fb-200d-2695-fe0f","1f468-1f3fc-200d-2695-fe0f","1f468-1f3fd-200d-2695-fe0f","1f468-1f3fe-200d-2695-fe0f","1f468-1f3ff-200d-2695-fe0f"]},{"n":["woman health worker","female-doctor"],"u":"1f469-200d-2695-fe0f","v":["1f469-1f3fb-200d-2695-fe0f","1f469-1f3fc-200d-2695-fe0f","1f469-1f3fd-200d-2695-fe0f","1f469-1f3fe-200d-2695-fe0f","1f469-1f3ff-200d-2695-fe0f"]},{"n":["student"],"u":"1f9d1-200d-1f393","v":["1f9d1-1f3fb-200d-1f393","1f9d1-1f3fc-200d-1f393","1f9d1-1f3fd-200d-1f393","1f9d1-1f3fe-200d-1f393","1f9d1-1f3ff-200d-1f393"]},{"n":["man student","male-student"],"u":"1f468-200d-1f393","v":["1f468-1f3fb-200d-1f393","1f468-1f3fc-200d-1f393","1f468-1f3fd-200d-1f393","1f468-1f3fe-200d-1f393","1f468-1f3ff-200d-1f393"]},{"n":["woman student","female-student"],"u":"1f469-200d-1f393","v":["1f469-1f3fb-200d-1f393","1f469-1f3fc-200d-1f393","1f469-1f3fd-200d-1f393","1f469-1f3fe-200d-1f393","1f469-1f3ff-200d-1f393"]},{"n":["teacher"],"u":"1f9d1-200d-1f3eb","v":["1f9d1-1f3fb-200d-1f3eb","1f9d1-1f3fc-200d-1f3eb","1f9d1-1f3fd-200d-1f3eb","1f9d1-1f3fe-200d-1f3eb","1f9d1-1f3ff-200d-1f3eb"]},{"n":["man teacher","male-teacher"],"u":"1f468-200d-1f3eb","v":["1f468-1f3fb-200d-1f3eb","1f468-1f3fc-200d-1f3eb","1f468-1f3fd-200d-1f3eb","1f468-1f3fe-200d-1f3eb","1f468-1f3ff-200d-1f3eb"]},{"n":["woman teacher","female-teacher"],"u":"1f469-200d-1f3eb","v":["1f469-1f3fb-200d-1f3eb","1f469-1f3fc-200d-1f3eb","1f469-1f3fd-200d-1f3eb","1f469-1f3fe-200d-1f3eb","1f469-1f3ff-200d-1f3eb"]},{"n":["judge"],"u":"1f9d1-200d-2696-fe0f","v":["1f9d1-1f3fb-200d-2696-fe0f","1f9d1-1f3fc-200d-2696-fe0f","1f9d1-1f3fd-200d-2696-fe0f","1f9d1-1f3fe-200d-2696-fe0f","1f9d1-1f3ff-200d-2696-fe0f"]},{"n":["man judge","male-judge"],"u":"1f468-200d-2696-fe0f","v":["1f468-1f3fb-200d-2696-fe0f","1f468-1f3fc-200d-2696-fe0f","1f468-1f3fd-200d-2696-fe0f","1f468-1f3fe-200d-2696-fe0f","1f468-1f3ff-200d-2696-fe0f"]},{"n":["woman judge","female-judge"],"u":"1f469-200d-2696-fe0f","v":["1f469-1f3fb-200d-2696-fe0f","1f469-1f3fc-200d-2696-fe0f","1f469-1f3fd-200d-2696-fe0f","1f469-1f3fe-200d-2696-fe0f","1f469-1f3ff-200d-2696-fe0f"]},{"n":["farmer"],"u":"1f9d1-200d-1f33e","v":["1f9d1-1f3fb-200d-1f33e","1f9d1-1f3fc-200d-1f33e","1f9d1-1f3fd-200d-1f33e","1f9d1-1f3fe-200d-1f33e","1f9d1-1f3ff-200d-1f33e"]},{"n":["man farmer","male-farmer"],"u":"1f468-200d-1f33e","v":["1f468-1f3fb-200d-1f33e","1f468-1f3fc-200d-1f33e","1f468-1f3fd-200d-1f33e","1f468-1f3fe-200d-1f33e","1f468-1f3ff-200d-1f33e"]},{"n":["woman farmer","female-farmer"],"u":"1f469-200d-1f33e","v":["1f469-1f3fb-200d-1f33e","1f469-1f3fc-200d-1f33e","1f469-1f3fd-200d-1f33e","1f469-1f3fe-200d-1f33e","1f469-1f3ff-200d-1f33e"]},{"n":["cook"],"u":"1f9d1-200d-1f373","v":["1f9d1-1f3fb-200d-1f373","1f9d1-1f3fc-200d-1f373","1f9d1-1f3fd-200d-1f373","1f9d1-1f3fe-200d-1f373","1f9d1-1f3ff-200d-1f373"]},{"n":["man cook","male-cook"],"u":"1f468-200d-1f373","v":["1f468-1f3fb-200d-1f373","1f468-1f3fc-200d-1f373","1f468-1f3fd-200d-1f373","1f468-1f3fe-200d-1f373","1f468-1f3ff-200d-1f373"]},{"n":["woman cook","female-cook"],"u":"1f469-200d-1f373","v":["1f469-1f3fb-200d-1f373","1f469-1f3fc-200d-1f373","1f469-1f3fd-200d-1f373","1f469-1f3fe-200d-1f373","1f469-1f3ff-200d-1f373"]},{"n":["mechanic"],"u":"1f9d1-200d-1f527","v":["1f9d1-1f3fb-200d-1f527","1f9d1-1f3fc-200d-1f527","1f9d1-1f3fd-200d-1f527","1f9d1-1f3fe-200d-1f527","1f9d1-1f3ff-200d-1f527"]},{"n":["man mechanic","male-mechanic"],"u":"1f468-200d-1f527","v":["1f468-1f3fb-200d-1f527","1f468-1f3fc-200d-1f527","1f468-1f3fd-200d-1f527","1f468-1f3fe-200d-1f527","1f468-1f3ff-200d-1f527"]},{"n":["woman mechanic","female-mechanic"],"u":"1f469-200d-1f527","v":["1f469-1f3fb-200d-1f527","1f469-1f3fc-200d-1f527","1f469-1f3fd-200d-1f527","1f469-1f3fe-200d-1f527","1f469-1f3ff-200d-1f527"]},{"n":["factory worker","factory_worker"],"u":"1f9d1-200d-1f3ed","v":["1f9d1-1f3fb-200d-1f3ed","1f9d1-1f3fc-200d-1f3ed","1f9d1-1f3fd-200d-1f3ed","1f9d1-1f3fe-200d-1f3ed","1f9d1-1f3ff-200d-1f3ed"]},{"n":["man factory worker","male-factory-worker"],"u":"1f468-200d-1f3ed","v":["1f468-1f3fb-200d-1f3ed","1f468-1f3fc-200d-1f3ed","1f468-1f3fd-200d-1f3ed","1f468-1f3fe-200d-1f3ed","1f468-1f3ff-200d-1f3ed"]},{"n":["woman factory worker","female-factory-worker"],"u":"1f469-200d-1f3ed","v":["1f469-1f3fb-200d-1f3ed","1f469-1f3fc-200d-1f3ed","1f469-1f3fd-200d-1f3ed","1f469-1f3fe-200d-1f3ed","1f469-1f3ff-200d-1f3ed"]},{"n":["office worker","office_worker"],"u":"1f9d1-200d-1f4bc","v":["1f9d1-1f3fb-200d-1f4bc","1f9d1-1f3fc-200d-1f4bc","1f9d1-1f3fd-200d-1f4bc","1f9d1-1f3fe-200d-1f4bc","1f9d1-1f3ff-200d-1f4bc"]},{"n":["man office worker","male-office-worker"],"u":"1f468-200d-1f4bc","v":["1f468-1f3fb-200d-1f4bc","1f468-1f3fc-200d-1f4bc","1f468-1f3fd-200d-1f4bc","1f468-1f3fe-200d-1f4bc","1f468-1f3ff-200d-1f4bc"]},{"n":["woman office worker","female-office-worker"],"u":"1f469-200d-1f4bc","v":["1f469-1f3fb-200d-1f4bc","1f469-1f3fc-200d-1f4bc","1f469-1f3fd-200d-1f4bc","1f469-1f3fe-200d-1f4bc","1f469-1f3ff-200d-1f4bc"]},{"n":["scientist"],"u":"1f9d1-200d-1f52c","v":["1f9d1-1f3fb-200d-1f52c","1f9d1-1f3fc-200d-1f52c","1f9d1-1f3fd-200d-1f52c","1f9d1-1f3fe-200d-1f52c","1f9d1-1f3ff-200d-1f52c"]},{"n":["man scientist","male-scientist"],"u":"1f468-200d-1f52c","v":["1f468-1f3fb-200d-1f52c","1f468-1f3fc-200d-1f52c","1f468-1f3fd-200d-1f52c","1f468-1f3fe-200d-1f52c","1f468-1f3ff-200d-1f52c"]},{"n":["woman scientist","female-scientist"],"u":"1f469-200d-1f52c","v":["1f469-1f3fb-200d-1f52c","1f469-1f3fc-200d-1f52c","1f469-1f3fd-200d-1f52c","1f469-1f3fe-200d-1f52c","1f469-1f3ff-200d-1f52c"]},{"n":["technologist"],"u":"1f9d1-200d-1f4bb","v":["1f9d1-1f3fb-200d-1f4bb","1f9d1-1f3fc-200d-1f4bb","1f9d1-1f3fd-200d-1f4bb","1f9d1-1f3fe-200d-1f4bb","1f9d1-1f3ff-200d-1f4bb"]},{"n":["man technologist","male-technologist"],"u":"1f468-200d-1f4bb","v":["1f468-1f3fb-200d-1f4bb","1f468-1f3fc-200d-1f4bb","1f468-1f3fd-200d-1f4bb","1f468-1f3fe-200d-1f4bb","1f468-1f3ff-200d-1f4bb"]},{"n":["woman technologist","female-technologist"],"u":"1f469-200d-1f4bb","v":["1f469-1f3fb-200d-1f4bb","1f469-1f3fc-200d-1f4bb","1f469-1f3fd-200d-1f4bb","1f469-1f3fe-200d-1f4bb","1f469-1f3ff-200d-1f4bb"]},{"n":["singer"],"u":"1f9d1-200d-1f3a4","v":["1f9d1-1f3fb-200d-1f3a4","1f9d1-1f3fc-200d-1f3a4","1f9d1-1f3fd-200d-1f3a4","1f9d1-1f3fe-200d-1f3a4","1f9d1-1f3ff-200d-1f3a4"]},{"n":["man singer","male-singer"],"u":"1f468-200d-1f3a4","v":["1f468-1f3fb-200d-1f3a4","1f468-1f3fc-200d-1f3a4","1f468-1f3fd-200d-1f3a4","1f468-1f3fe-200d-1f3a4","1f468-1f3ff-200d-1f3a4"]},{"n":["woman singer","female-singer"],"u":"1f469-200d-1f3a4","v":["1f469-1f3fb-200d-1f3a4","1f469-1f3fc-200d-1f3a4","1f469-1f3fd-200d-1f3a4","1f469-1f3fe-200d-1f3a4","1f469-1f3ff-200d-1f3a4"]},{"n":["artist"],"u":"1f9d1-200d-1f3a8","v":["1f9d1-1f3fb-200d-1f3a8","1f9d1-1f3fc-200d-1f3a8","1f9d1-1f3fd-200d-1f3a8","1f9d1-1f3fe-200d-1f3a8","1f9d1-1f3ff-200d-1f3a8"]},{"n":["man artist","male-artist"],"u":"1f468-200d-1f3a8","v":["1f468-1f3fb-200d-1f3a8","1f468-1f3fc-200d-1f3a8","1f468-1f3fd-200d-1f3a8","1f468-1f3fe-200d-1f3a8","1f468-1f3ff-200d-1f3a8"]},{"n":["woman artist","female-artist"],"u":"1f469-200d-1f3a8","v":["1f469-1f3fb-200d-1f3a8","1f469-1f3fc-200d-1f3a8","1f469-1f3fd-200d-1f3a8","1f469-1f3fe-200d-1f3a8","1f469-1f3ff-200d-1f3a8"]},{"n":["pilot"],"u":"1f9d1-200d-2708-fe0f","v":["1f9d1-1f3fb-200d-2708-fe0f","1f9d1-1f3fc-200d-2708-fe0f","1f9d1-1f3fd-200d-2708-fe0f","1f9d1-1f3fe-200d-2708-fe0f","1f9d1-1f3ff-200d-2708-fe0f"]},{"n":["man pilot","male-pilot"],"u":"1f468-200d-2708-fe0f","v":["1f468-1f3fb-200d-2708-fe0f","1f468-1f3fc-200d-2708-fe0f","1f468-1f3fd-200d-2708-fe0f","1f468-1f3fe-200d-2708-fe0f","1f468-1f3ff-200d-2708-fe0f"]},{"n":["woman pilot","female-pilot"],"u":"1f469-200d-2708-fe0f","v":["1f469-1f3fb-200d-2708-fe0f","1f469-1f3fc-200d-2708-fe0f","1f469-1f3fd-200d-2708-fe0f","1f469-1f3fe-200d-2708-fe0f","1f469-1f3ff-200d-2708-fe0f"]},{"n":["astronaut"],"u":"1f9d1-200d-1f680","v":["1f9d1-1f3fb-200d-1f680","1f9d1-1f3fc-200d-1f680","1f9d1-1f3fd-200d-1f680","1f9d1-1f3fe-200d-1f680","1f9d1-1f3ff-200d-1f680"]},{"n":["man astronaut","male-astronaut"],"u":"1f468-200d-1f680","v":["1f468-1f3fb-200d-1f680","1f468-1f3fc-200d-1f680","1f468-1f3fd-200d-1f680","1f468-1f3fe-200d-1f680","1f468-1f3ff-200d-1f680"]},{"n":["woman astronaut","female-astronaut"],"u":"1f469-200d-1f680","v":["1f469-1f3fb-200d-1f680","1f469-1f3fc-200d-1f680","1f469-1f3fd-200d-1f680","1f469-1f3fe-200d-1f680","1f469-1f3ff-200d-1f680"]},{"n":["firefighter"],"u":"1f9d1-200d-1f692","v":["1f9d1-1f3fb-200d-1f692","1f9d1-1f3fc-200d-1f692","1f9d1-1f3fd-200d-1f692","1f9d1-1f3fe-200d-1f692","1f9d1-1f3ff-200d-1f692"]},{"n":["man firefighter","male-firefighter"],"u":"1f468-200d-1f692","v":["1f468-1f3fb-200d-1f692","1f468-1f3fc-200d-1f692","1f468-1f3fd-200d-1f692","1f468-1f3fe-200d-1f692","1f468-1f3ff-200d-1f692"]},{"n":["woman firefighter","female-firefighter"],"u":"1f469-200d-1f692","v":["1f469-1f3fb-200d-1f692","1f469-1f3fc-200d-1f692","1f469-1f3fd-200d-1f692","1f469-1f3fe-200d-1f692","1f469-1f3ff-200d-1f692"]},{"n":["police officer","cop"],"u":"1f46e","v":["1f46e-1f3fb","1f46e-1f3fc","1f46e-1f3fd","1f46e-1f3fe","1f46e-1f3ff"]},{"n":["man police officer","male-police-officer"],"u":"1f46e-200d-2642-fe0f","v":["1f46e-1f3fb-200d-2642-fe0f","1f46e-1f3fc-200d-2642-fe0f","1f46e-1f3fd-200d-2642-fe0f","1f46e-1f3fe-200d-2642-fe0f","1f46e-1f3ff-200d-2642-fe0f"]},{"n":["woman police officer","female-police-officer"],"u":"1f46e-200d-2640-fe0f","v":["1f46e-1f3fb-200d-2640-fe0f","1f46e-1f3fc-200d-2640-fe0f","1f46e-1f3fd-200d-2640-fe0f","1f46e-1f3fe-200d-2640-fe0f","1f46e-1f3ff-200d-2640-fe0f"]},{"n":["detective","sleuth_or_spy"],"u":"1f575-fe0f","v":["1f575-1f3fb","1f575-1f3fc","1f575-1f3fd","1f575-1f3fe","1f575-1f3ff"]},{"n":["man detective","male-detective"],"u":"1f575-fe0f-200d-2642-fe0f","v":["1f575-1f3fb-200d-2642-fe0f","1f575-1f3fc-200d-2642-fe0f","1f575-1f3fd-200d-2642-fe0f","1f575-1f3fe-200d-2642-fe0f","1f575-1f3ff-200d-2642-fe0f"]},{"n":["woman detective","female-detective"],"u":"1f575-fe0f-200d-2640-fe0f","v":["1f575-1f3fb-200d-2640-fe0f","1f575-1f3fc-200d-2640-fe0f","1f575-1f3fd-200d-2640-fe0f","1f575-1f3fe-200d-2640-fe0f","1f575-1f3ff-200d-2640-fe0f"]},{"n":["guardsman"],"u":"1f482","v":["1f482-1f3fb","1f482-1f3fc","1f482-1f3fd","1f482-1f3fe","1f482-1f3ff"]},{"n":["man guard","male-guard"],"u":"1f482-200d-2642-fe0f","v":["1f482-1f3fb-200d-2642-fe0f","1f482-1f3fc-200d-2642-fe0f","1f482-1f3fd-200d-2642-fe0f","1f482-1f3fe-200d-2642-fe0f","1f482-1f3ff-200d-2642-fe0f"]},{"n":["woman guard","female-guard"],"u":"1f482-200d-2640-fe0f","v":["1f482-1f3fb-200d-2640-fe0f","1f482-1f3fc-200d-2640-fe0f","1f482-1f3fd-200d-2640-fe0f","1f482-1f3fe-200d-2640-fe0f","1f482-1f3ff-200d-2640-fe0f"]},{"n":["ninja"],"u":"1f977","v":["1f977-1f3fb","1f977-1f3fc","1f977-1f3fd","1f977-1f3fe","1f977-1f3ff"]},{"n":["construction worker","construction_worker"],"u":"1f477","v":["1f477-1f3fb","1f477-1f3fc","1f477-1f3fd","1f477-1f3fe","1f477-1f3ff"]},{"n":["man construction worker","male-construction-worker"],"u":"1f477-200d-2642-fe0f","v":["1f477-1f3fb-200d-2642-fe0f","1f477-1f3fc-200d-2642-fe0f","1f477-1f3fd-200d-2642-fe0f","1f477-1f3fe-200d-2642-fe0f","1f477-1f3ff-200d-2642-fe0f"]},{"n":["woman construction worker","female-construction-worker"],"u":"1f477-200d-2640-fe0f","v":["1f477-1f3fb-200d-2640-fe0f","1f477-1f3fc-200d-2640-fe0f","1f477-1f3fd-200d-2640-fe0f","1f477-1f3fe-200d-2640-fe0f","1f477-1f3ff-200d-2640-fe0f"]},{"n":["prince"],"u":"1f934","v":["1f934-1f3fb","1f934-1f3fc","1f934-1f3fd","1f934-1f3fe","1f934-1f3ff"]},{"n":["princess"],"u":"1f478","v":["1f478-1f3fb","1f478-1f3fc","1f478-1f3fd","1f478-1f3fe","1f478-1f3ff"]},{"n":["man with turban","man_with_turban"],"u":"1f473","v":["1f473-1f3fb","1f473-1f3fc","1f473-1f3fd","1f473-1f3fe","1f473-1f3ff"]},{"n":["man wearing turban","man-wearing-turban"],"u":"1f473-200d-2642-fe0f","v":["1f473-1f3fb-200d-2642-fe0f","1f473-1f3fc-200d-2642-fe0f","1f473-1f3fd-200d-2642-fe0f","1f473-1f3fe-200d-2642-fe0f","1f473-1f3ff-200d-2642-fe0f"]},{"n":["woman wearing turban","woman-wearing-turban"],"u":"1f473-200d-2640-fe0f","v":["1f473-1f3fb-200d-2640-fe0f","1f473-1f3fc-200d-2640-fe0f","1f473-1f3fd-200d-2640-fe0f","1f473-1f3fe-200d-2640-fe0f","1f473-1f3ff-200d-2640-fe0f"]},{"n":["man with gua pi mao","man_with_gua_pi_mao"],"u":"1f472","v":["1f472-1f3fb","1f472-1f3fc","1f472-1f3fd","1f472-1f3fe","1f472-1f3ff"]},{"n":["person with headscarf","person_with_headscarf"],"u":"1f9d5","v":["1f9d5-1f3fb","1f9d5-1f3fc","1f9d5-1f3fd","1f9d5-1f3fe","1f9d5-1f3ff"]},{"n":["man in tuxedo","person_in_tuxedo"],"u":"1f935","v":["1f935-1f3fb","1f935-1f3fc","1f935-1f3fd","1f935-1f3fe","1f935-1f3ff"]},{"n":["man in tuxedo","man_in_tuxedo"],"u":"1f935-200d-2642-fe0f","v":["1f935-1f3fb-200d-2642-fe0f","1f935-1f3fc-200d-2642-fe0f","1f935-1f3fd-200d-2642-fe0f","1f935-1f3fe-200d-2642-fe0f","1f935-1f3ff-200d-2642-fe0f"]},{"n":["woman in tuxedo","woman_in_tuxedo"],"u":"1f935-200d-2640-fe0f","v":["1f935-1f3fb-200d-2640-fe0f","1f935-1f3fc-200d-2640-fe0f","1f935-1f3fd-200d-2640-fe0f","1f935-1f3fe-200d-2640-fe0f","1f935-1f3ff-200d-2640-fe0f"]},{"n":["bride with veil","bride_with_veil"],"u":"1f470","v":["1f470-1f3fb","1f470-1f3fc","1f470-1f3fd","1f470-1f3fe","1f470-1f3ff"]},{"n":["man with veil","man_with_veil"],"u":"1f470-200d-2642-fe0f","v":["1f470-1f3fb-200d-2642-fe0f","1f470-1f3fc-200d-2642-fe0f","1f470-1f3fd-200d-2642-fe0f","1f470-1f3fe-200d-2642-fe0f","1f470-1f3ff-200d-2642-fe0f"]},{"n":["woman with veil","woman_with_veil"],"u":"1f470-200d-2640-fe0f","v":["1f470-1f3fb-200d-2640-fe0f","1f470-1f3fc-200d-2640-fe0f","1f470-1f3fd-200d-2640-fe0f","1f470-1f3fe-200d-2640-fe0f","1f470-1f3ff-200d-2640-fe0f"]},{"n":["pregnant woman","pregnant_woman"],"u":"1f930","v":["1f930-1f3fb","1f930-1f3fc","1f930-1f3fd","1f930-1f3fe","1f930-1f3ff"]},{"n":["breast-feeding"],"u":"1f931","v":["1f931-1f3fb","1f931-1f3fc","1f931-1f3fd","1f931-1f3fe","1f931-1f3ff"]},{"n":["woman feeding baby","woman_feeding_baby"],"u":"1f469-200d-1f37c","v":["1f469-1f3fb-200d-1f37c","1f469-1f3fc-200d-1f37c","1f469-1f3fd-200d-1f37c","1f469-1f3fe-200d-1f37c","1f469-1f3ff-200d-1f37c"]},{"n":["man feeding baby","man_feeding_baby"],"u":"1f468-200d-1f37c","v":["1f468-1f3fb-200d-1f37c","1f468-1f3fc-200d-1f37c","1f468-1f3fd-200d-1f37c","1f468-1f3fe-200d-1f37c","1f468-1f3ff-200d-1f37c"]},{"n":["person feeding baby","person_feeding_baby"],"u":"1f9d1-200d-1f37c","v":["1f9d1-1f3fb-200d-1f37c","1f9d1-1f3fc-200d-1f37c","1f9d1-1f3fd-200d-1f37c","1f9d1-1f3fe-200d-1f37c","1f9d1-1f3ff-200d-1f37c"]},{"n":["baby angel","angel"],"u":"1f47c","v":["1f47c-1f3fb","1f47c-1f3fc","1f47c-1f3fd","1f47c-1f3fe","1f47c-1f3ff"]},{"n":["father christmas","santa"],"u":"1f385","v":["1f385-1f3fb","1f385-1f3fc","1f385-1f3fd","1f385-1f3fe","1f385-1f3ff"]},{"n":["mother christmas","mrs_claus","mother_christmas"],"u":"1f936","v":["1f936-1f3fb","1f936-1f3fc","1f936-1f3fd","1f936-1f3fe","1f936-1f3ff"]},{"n":["mx claus","mx_claus"],"u":"1f9d1-200d-1f384","v":["1f9d1-1f3fb-200d-1f384","1f9d1-1f3fc-200d-1f384","1f9d1-1f3fd-200d-1f384","1f9d1-1f3fe-200d-1f384","1f9d1-1f3ff-200d-1f384"]},{"n":["superhero"],"u":"1f9b8","v":["1f9b8-1f3fb","1f9b8-1f3fc","1f9b8-1f3fd","1f9b8-1f3fe","1f9b8-1f3ff"]},{"n":["man superhero","male_superhero"],"u":"1f9b8-200d-2642-fe0f","v":["1f9b8-1f3fb-200d-2642-fe0f","1f9b8-1f3fc-200d-2642-fe0f","1f9b8-1f3fd-200d-2642-fe0f","1f9b8-1f3fe-200d-2642-fe0f","1f9b8-1f3ff-200d-2642-fe0f"]},{"n":["woman superhero","female_superhero"],"u":"1f9b8-200d-2640-fe0f","v":["1f9b8-1f3fb-200d-2640-fe0f","1f9b8-1f3fc-200d-2640-fe0f","1f9b8-1f3fd-200d-2640-fe0f","1f9b8-1f3fe-200d-2640-fe0f","1f9b8-1f3ff-200d-2640-fe0f"]},{"n":["supervillain"],"u":"1f9b9","v":["1f9b9-1f3fb","1f9b9-1f3fc","1f9b9-1f3fd","1f9b9-1f3fe","1f9b9-1f3ff"]},{"n":["man supervillain","male_supervillain"],"u":"1f9b9-200d-2642-fe0f","v":["1f9b9-1f3fb-200d-2642-fe0f","1f9b9-1f3fc-200d-2642-fe0f","1f9b9-1f3fd-200d-2642-fe0f","1f9b9-1f3fe-200d-2642-fe0f","1f9b9-1f3ff-200d-2642-fe0f"]},{"n":["woman supervillain","female_supervillain"],"u":"1f9b9-200d-2640-fe0f","v":["1f9b9-1f3fb-200d-2640-fe0f","1f9b9-1f3fc-200d-2640-fe0f","1f9b9-1f3fd-200d-2640-fe0f","1f9b9-1f3fe-200d-2640-fe0f","1f9b9-1f3ff-200d-2640-fe0f"]},{"n":["mage"],"u":"1f9d9","v":["1f9d9-1f3fb","1f9d9-1f3fc","1f9d9-1f3fd","1f9d9-1f3fe","1f9d9-1f3ff"]},{"n":["man mage","male_mage"],"u":"1f9d9-200d-2642-fe0f","v":["1f9d9-1f3fb-200d-2642-fe0f","1f9d9-1f3fc-200d-2642-fe0f","1f9d9-1f3fd-200d-2642-fe0f","1f9d9-1f3fe-200d-2642-fe0f","1f9d9-1f3ff-200d-2642-fe0f"]},{"n":["woman mage","female_mage"],"u":"1f9d9-200d-2640-fe0f","v":["1f9d9-1f3fb-200d-2640-fe0f","1f9d9-1f3fc-200d-2640-fe0f","1f9d9-1f3fd-200d-2640-fe0f","1f9d9-1f3fe-200d-2640-fe0f","1f9d9-1f3ff-200d-2640-fe0f"]},{"n":["fairy"],"u":"1f9da","v":["1f9da-1f3fb","1f9da-1f3fc","1f9da-1f3fd","1f9da-1f3fe","1f9da-1f3ff"]},{"n":["man fairy","male_fairy"],"u":"1f9da-200d-2642-fe0f","v":["1f9da-1f3fb-200d-2642-fe0f","1f9da-1f3fc-200d-2642-fe0f","1f9da-1f3fd-200d-2642-fe0f","1f9da-1f3fe-200d-2642-fe0f","1f9da-1f3ff-200d-2642-fe0f"]},{"n":["woman fairy","female_fairy"],"u":"1f9da-200d-2640-fe0f","v":["1f9da-1f3fb-200d-2640-fe0f","1f9da-1f3fc-200d-2640-fe0f","1f9da-1f3fd-200d-2640-fe0f","1f9da-1f3fe-200d-2640-fe0f","1f9da-1f3ff-200d-2640-fe0f"]},{"n":["vampire"],"u":"1f9db","v":["1f9db-1f3fb","1f9db-1f3fc","1f9db-1f3fd","1f9db-1f3fe","1f9db-1f3ff"]},{"n":["man vampire","male_vampire"],"u":"1f9db-200d-2642-fe0f","v":["1f9db-1f3fb-200d-2642-fe0f","1f9db-1f3fc-200d-2642-fe0f","1f9db-1f3fd-200d-2642-fe0f","1f9db-1f3fe-200d-2642-fe0f","1f9db-1f3ff-200d-2642-fe0f"]},{"n":["woman vampire","female_vampire"],"u":"1f9db-200d-2640-fe0f","v":["1f9db-1f3fb-200d-2640-fe0f","1f9db-1f3fc-200d-2640-fe0f","1f9db-1f3fd-200d-2640-fe0f","1f9db-1f3fe-200d-2640-fe0f","1f9db-1f3ff-200d-2640-fe0f"]},{"n":["merperson"],"u":"1f9dc","v":["1f9dc-1f3fb","1f9dc-1f3fc","1f9dc-1f3fd","1f9dc-1f3fe","1f9dc-1f3ff"]},{"n":["merman"],"u":"1f9dc-200d-2642-fe0f","v":["1f9dc-1f3fb-200d-2642-fe0f","1f9dc-1f3fc-200d-2642-fe0f","1f9dc-1f3fd-200d-2642-fe0f","1f9dc-1f3fe-200d-2642-fe0f","1f9dc-1f3ff-200d-2642-fe0f"]},{"n":["mermaid"],"u":"1f9dc-200d-2640-fe0f","v":["1f9dc-1f3fb-200d-2640-fe0f","1f9dc-1f3fc-200d-2640-fe0f","1f9dc-1f3fd-200d-2640-fe0f","1f9dc-1f3fe-200d-2640-fe0f","1f9dc-1f3ff-200d-2640-fe0f"]},{"n":["elf"],"u":"1f9dd","v":["1f9dd-1f3fb","1f9dd-1f3fc","1f9dd-1f3fd","1f9dd-1f3fe","1f9dd-1f3ff"]},{"n":["man elf","male_elf"],"u":"1f9dd-200d-2642-fe0f","v":["1f9dd-1f3fb-200d-2642-fe0f","1f9dd-1f3fc-200d-2642-fe0f","1f9dd-1f3fd-200d-2642-fe0f","1f9dd-1f3fe-200d-2642-fe0f","1f9dd-1f3ff-200d-2642-fe0f"]},{"n":["woman elf","female_elf"],"u":"1f9dd-200d-2640-fe0f","v":["1f9dd-1f3fb-200d-2640-fe0f","1f9dd-1f3fc-200d-2640-fe0f","1f9dd-1f3fd-200d-2640-fe0f","1f9dd-1f3fe-200d-2640-fe0f","1f9dd-1f3ff-200d-2640-fe0f"]},{"n":["genie"],"u":"1f9de"},{"n":["man genie","male_genie"],"u":"1f9de-200d-2642-fe0f"},{"n":["woman genie","female_genie"],"u":"1f9de-200d-2640-fe0f"},{"n":["zombie"],"u":"1f9df"},{"n":["man zombie","male_zombie"],"u":"1f9df-200d-2642-fe0f"},{"n":["woman zombie","female_zombie"],"u":"1f9df-200d-2640-fe0f"},{"n":["face massage","massage"],"u":"1f486","v":["1f486-1f3fb","1f486-1f3fc","1f486-1f3fd","1f486-1f3fe","1f486-1f3ff"]},{"n":["man getting massage","man-getting-massage"],"u":"1f486-200d-2642-fe0f","v":["1f486-1f3fb-200d-2642-fe0f","1f486-1f3fc-200d-2642-fe0f","1f486-1f3fd-200d-2642-fe0f","1f486-1f3fe-200d-2642-fe0f","1f486-1f3ff-200d-2642-fe0f"]},{"n":["woman getting massage","woman-getting-massage"],"u":"1f486-200d-2640-fe0f","v":["1f486-1f3fb-200d-2640-fe0f","1f486-1f3fc-200d-2640-fe0f","1f486-1f3fd-200d-2640-fe0f","1f486-1f3fe-200d-2640-fe0f","1f486-1f3ff-200d-2640-fe0f"]},{"n":["haircut"],"u":"1f487","v":["1f487-1f3fb","1f487-1f3fc","1f487-1f3fd","1f487-1f3fe","1f487-1f3ff"]},{"n":["man getting haircut","man-getting-haircut"],"u":"1f487-200d-2642-fe0f","v":["1f487-1f3fb-200d-2642-fe0f","1f487-1f3fc-200d-2642-fe0f","1f487-1f3fd-200d-2642-fe0f","1f487-1f3fe-200d-2642-fe0f","1f487-1f3ff-200d-2642-fe0f"]},{"n":["woman getting haircut","woman-getting-haircut"],"u":"1f487-200d-2640-fe0f","v":["1f487-1f3fb-200d-2640-fe0f","1f487-1f3fc-200d-2640-fe0f","1f487-1f3fd-200d-2640-fe0f","1f487-1f3fe-200d-2640-fe0f","1f487-1f3ff-200d-2640-fe0f"]},{"n":["pedestrian","walking"],"u":"1f6b6","v":["1f6b6-1f3fb","1f6b6-1f3fc","1f6b6-1f3fd","1f6b6-1f3fe","1f6b6-1f3ff"]},{"n":["man walking","man-walking"],"u":"1f6b6-200d-2642-fe0f","v":["1f6b6-1f3fb-200d-2642-fe0f","1f6b6-1f3fc-200d-2642-fe0f","1f6b6-1f3fd-200d-2642-fe0f","1f6b6-1f3fe-200d-2642-fe0f","1f6b6-1f3ff-200d-2642-fe0f"]},{"n":["woman walking","woman-walking"],"u":"1f6b6-200d-2640-fe0f","v":["1f6b6-1f3fb-200d-2640-fe0f","1f6b6-1f3fc-200d-2640-fe0f","1f6b6-1f3fd-200d-2640-fe0f","1f6b6-1f3fe-200d-2640-fe0f","1f6b6-1f3ff-200d-2640-fe0f"]},{"n":["standing person","standing_person"],"u":"1f9cd","v":["1f9cd-1f3fb","1f9cd-1f3fc","1f9cd-1f3fd","1f9cd-1f3fe","1f9cd-1f3ff"]},{"n":["man standing","man_standing"],"u":"1f9cd-200d-2642-fe0f","v":["1f9cd-1f3fb-200d-2642-fe0f","1f9cd-1f3fc-200d-2642-fe0f","1f9cd-1f3fd-200d-2642-fe0f","1f9cd-1f3fe-200d-2642-fe0f","1f9cd-1f3ff-200d-2642-fe0f"]},{"n":["woman standing","woman_standing"],"u":"1f9cd-200d-2640-fe0f","v":["1f9cd-1f3fb-200d-2640-fe0f","1f9cd-1f3fc-200d-2640-fe0f","1f9cd-1f3fd-200d-2640-fe0f","1f9cd-1f3fe-200d-2640-fe0f","1f9cd-1f3ff-200d-2640-fe0f"]},{"n":["kneeling person","kneeling_person"],"u":"1f9ce","v":["1f9ce-1f3fb","1f9ce-1f3fc","1f9ce-1f3fd","1f9ce-1f3fe","1f9ce-1f3ff"]},{"n":["man kneeling","man_kneeling"],"u":"1f9ce-200d-2642-fe0f","v":["1f9ce-1f3fb-200d-2642-fe0f","1f9ce-1f3fc-200d-2642-fe0f","1f9ce-1f3fd-200d-2642-fe0f","1f9ce-1f3fe-200d-2642-fe0f","1f9ce-1f3ff-200d-2642-fe0f"]},{"n":["woman kneeling","woman_kneeling"],"u":"1f9ce-200d-2640-fe0f","v":["1f9ce-1f3fb-200d-2640-fe0f","1f9ce-1f3fc-200d-2640-fe0f","1f9ce-1f3fd-200d-2640-fe0f","1f9ce-1f3fe-200d-2640-fe0f","1f9ce-1f3ff-200d-2640-fe0f"]},{"n":["person with white cane","person_with_probing_cane"],"u":"1f9d1-200d-1f9af","v":["1f9d1-1f3fb-200d-1f9af","1f9d1-1f3fc-200d-1f9af","1f9d1-1f3fd-200d-1f9af","1f9d1-1f3fe-200d-1f9af","1f9d1-1f3ff-200d-1f9af"]},{"n":["man with white cane","man_with_probing_cane"],"u":"1f468-200d-1f9af","v":["1f468-1f3fb-200d-1f9af","1f468-1f3fc-200d-1f9af","1f468-1f3fd-200d-1f9af","1f468-1f3fe-200d-1f9af","1f468-1f3ff-200d-1f9af"]},{"n":["woman with white cane","woman_with_probing_cane"],"u":"1f469-200d-1f9af","v":["1f469-1f3fb-200d-1f9af","1f469-1f3fc-200d-1f9af","1f469-1f3fd-200d-1f9af","1f469-1f3fe-200d-1f9af","1f469-1f3ff-200d-1f9af"]},{"n":["person in motorized wheelchair","person_in_motorized_wheelchair"],"u":"1f9d1-200d-1f9bc","v":["1f9d1-1f3fb-200d-1f9bc","1f9d1-1f3fc-200d-1f9bc","1f9d1-1f3fd-200d-1f9bc","1f9d1-1f3fe-200d-1f9bc","1f9d1-1f3ff-200d-1f9bc"]},{"n":["man in motorized wheelchair","man_in_motorized_wheelchair"],"u":"1f468-200d-1f9bc","v":["1f468-1f3fb-200d-1f9bc","1f468-1f3fc-200d-1f9bc","1f468-1f3fd-200d-1f9bc","1f468-1f3fe-200d-1f9bc","1f468-1f3ff-200d-1f9bc"]},{"n":["woman in motorized wheelchair","woman_in_motorized_wheelchair"],"u":"1f469-200d-1f9bc","v":["1f469-1f3fb-200d-1f9bc","1f469-1f3fc-200d-1f9bc","1f469-1f3fd-200d-1f9bc","1f469-1f3fe-200d-1f9bc","1f469-1f3ff-200d-1f9bc"]},{"n":["person in manual wheelchair","person_in_manual_wheelchair"],"u":"1f9d1-200d-1f9bd","v":["1f9d1-1f3fb-200d-1f9bd","1f9d1-1f3fc-200d-1f9bd","1f9d1-1f3fd-200d-1f9bd","1f9d1-1f3fe-200d-1f9bd","1f9d1-1f3ff-200d-1f9bd"]},{"n":["man in manual wheelchair","man_in_manual_wheelchair"],"u":"1f468-200d-1f9bd","v":["1f468-1f3fb-200d-1f9bd","1f468-1f3fc-200d-1f9bd","1f468-1f3fd-200d-1f9bd","1f468-1f3fe-200d-1f9bd","1f468-1f3ff-200d-1f9bd"]},{"n":["woman in manual wheelchair","woman_in_manual_wheelchair"],"u":"1f469-200d-1f9bd","v":["1f469-1f3fb-200d-1f9bd","1f469-1f3fc-200d-1f9bd","1f469-1f3fd-200d-1f9bd","1f469-1f3fe-200d-1f9bd","1f469-1f3ff-200d-1f9bd"]},{"n":["runner","running"],"u":"1f3c3","v":["1f3c3-1f3fb","1f3c3-1f3fc","1f3c3-1f3fd","1f3c3-1f3fe","1f3c3-1f3ff"]},{"n":["man running","man-running"],"u":"1f3c3-200d-2642-fe0f","v":["1f3c3-1f3fb-200d-2642-fe0f","1f3c3-1f3fc-200d-2642-fe0f","1f3c3-1f3fd-200d-2642-fe0f","1f3c3-1f3fe-200d-2642-fe0f","1f3c3-1f3ff-200d-2642-fe0f"]},{"n":["woman running","woman-running"],"u":"1f3c3-200d-2640-fe0f","v":["1f3c3-1f3fb-200d-2640-fe0f","1f3c3-1f3fc-200d-2640-fe0f","1f3c3-1f3fd-200d-2640-fe0f","1f3c3-1f3fe-200d-2640-fe0f","1f3c3-1f3ff-200d-2640-fe0f"]},{"n":["dancer"],"u":"1f483","v":["1f483-1f3fb","1f483-1f3fc","1f483-1f3fd","1f483-1f3fe","1f483-1f3ff"]},{"n":["man dancing","man_dancing"],"u":"1f57a","v":["1f57a-1f3fb","1f57a-1f3fc","1f57a-1f3fd","1f57a-1f3fe","1f57a-1f3ff"]},{"n":["person in suit levitating","man_in_business_suit_levitating"],"u":"1f574-fe0f","v":["1f574-1f3fb","1f574-1f3fc","1f574-1f3fd","1f574-1f3fe","1f574-1f3ff"]},{"n":["woman with bunny ears","dancers"],"u":"1f46f"},{"n":["men with bunny ears","men-with-bunny-ears-partying","man-with-bunny-ears-partying"],"u":"1f46f-200d-2642-fe0f"},{"n":["women with bunny ears","women-with-bunny-ears-partying","woman-with-bunny-ears-partying"],"u":"1f46f-200d-2640-fe0f"},{"n":["person in steamy room","person_in_steamy_room"],"u":"1f9d6","v":["1f9d6-1f3fb","1f9d6-1f3fc","1f9d6-1f3fd","1f9d6-1f3fe","1f9d6-1f3ff"]},{"n":["man in steamy room","man_in_steamy_room"],"u":"1f9d6-200d-2642-fe0f","v":["1f9d6-1f3fb-200d-2642-fe0f","1f9d6-1f3fc-200d-2642-fe0f","1f9d6-1f3fd-200d-2642-fe0f","1f9d6-1f3fe-200d-2642-fe0f","1f9d6-1f3ff-200d-2642-fe0f"]},{"n":["woman in steamy room","woman_in_steamy_room"],"u":"1f9d6-200d-2640-fe0f","v":["1f9d6-1f3fb-200d-2640-fe0f","1f9d6-1f3fc-200d-2640-fe0f","1f9d6-1f3fd-200d-2640-fe0f","1f9d6-1f3fe-200d-2640-fe0f","1f9d6-1f3ff-200d-2640-fe0f"]},{"n":["person climbing","person_climbing"],"u":"1f9d7","v":["1f9d7-1f3fb","1f9d7-1f3fc","1f9d7-1f3fd","1f9d7-1f3fe","1f9d7-1f3ff"]},{"n":["man climbing","man_climbing"],"u":"1f9d7-200d-2642-fe0f","v":["1f9d7-1f3fb-200d-2642-fe0f","1f9d7-1f3fc-200d-2642-fe0f","1f9d7-1f3fd-200d-2642-fe0f","1f9d7-1f3fe-200d-2642-fe0f","1f9d7-1f3ff-200d-2642-fe0f"]},{"n":["woman climbing","woman_climbing"],"u":"1f9d7-200d-2640-fe0f","v":["1f9d7-1f3fb-200d-2640-fe0f","1f9d7-1f3fc-200d-2640-fe0f","1f9d7-1f3fd-200d-2640-fe0f","1f9d7-1f3fe-200d-2640-fe0f","1f9d7-1f3ff-200d-2640-fe0f"]},{"n":["fencer"],"u":"1f93a"},{"n":["horse racing","horse_racing"],"u":"1f3c7","v":["1f3c7-1f3fb","1f3c7-1f3fc","1f3c7-1f3fd","1f3c7-1f3fe","1f3c7-1f3ff"]},{"n":["skier"],"u":"26f7-fe0f"},{"n":["snowboarder"],"u":"1f3c2","v":["1f3c2-1f3fb","1f3c2-1f3fc","1f3c2-1f3fd","1f3c2-1f3fe","1f3c2-1f3ff"]},{"n":["person golfing","golfer"],"u":"1f3cc-fe0f","v":["1f3cc-1f3fb","1f3cc-1f3fc","1f3cc-1f3fd","1f3cc-1f3fe","1f3cc-1f3ff"]},{"n":["man golfing","man-golfing"],"u":"1f3cc-fe0f-200d-2642-fe0f","v":["1f3cc-1f3fb-200d-2642-fe0f","1f3cc-1f3fc-200d-2642-fe0f","1f3cc-1f3fd-200d-2642-fe0f","1f3cc-1f3fe-200d-2642-fe0f","1f3cc-1f3ff-200d-2642-fe0f"]},{"n":["woman golfing","woman-golfing"],"u":"1f3cc-fe0f-200d-2640-fe0f","v":["1f3cc-1f3fb-200d-2640-fe0f","1f3cc-1f3fc-200d-2640-fe0f","1f3cc-1f3fd-200d-2640-fe0f","1f3cc-1f3fe-200d-2640-fe0f","1f3cc-1f3ff-200d-2640-fe0f"]},{"n":["surfer"],"u":"1f3c4","v":["1f3c4-1f3fb","1f3c4-1f3fc","1f3c4-1f3fd","1f3c4-1f3fe","1f3c4-1f3ff"]},{"n":["man surfing","man-surfing"],"u":"1f3c4-200d-2642-fe0f","v":["1f3c4-1f3fb-200d-2642-fe0f","1f3c4-1f3fc-200d-2642-fe0f","1f3c4-1f3fd-200d-2642-fe0f","1f3c4-1f3fe-200d-2642-fe0f","1f3c4-1f3ff-200d-2642-fe0f"]},{"n":["woman surfing","woman-surfing"],"u":"1f3c4-200d-2640-fe0f","v":["1f3c4-1f3fb-200d-2640-fe0f","1f3c4-1f3fc-200d-2640-fe0f","1f3c4-1f3fd-200d-2640-fe0f","1f3c4-1f3fe-200d-2640-fe0f","1f3c4-1f3ff-200d-2640-fe0f"]},{"n":["rowboat"],"u":"1f6a3","v":["1f6a3-1f3fb","1f6a3-1f3fc","1f6a3-1f3fd","1f6a3-1f3fe","1f6a3-1f3ff"]},{"n":["man rowing boat","man-rowing-boat"],"u":"1f6a3-200d-2642-fe0f","v":["1f6a3-1f3fb-200d-2642-fe0f","1f6a3-1f3fc-200d-2642-fe0f","1f6a3-1f3fd-200d-2642-fe0f","1f6a3-1f3fe-200d-2642-fe0f","1f6a3-1f3ff-200d-2642-fe0f"]},{"n":["woman rowing boat","woman-rowing-boat"],"u":"1f6a3-200d-2640-fe0f","v":["1f6a3-1f3fb-200d-2640-fe0f","1f6a3-1f3fc-200d-2640-fe0f","1f6a3-1f3fd-200d-2640-fe0f","1f6a3-1f3fe-200d-2640-fe0f","1f6a3-1f3ff-200d-2640-fe0f"]},{"n":["swimmer"],"u":"1f3ca","v":["1f3ca-1f3fb","1f3ca-1f3fc","1f3ca-1f3fd","1f3ca-1f3fe","1f3ca-1f3ff"]},{"n":["man swimming","man-swimming"],"u":"1f3ca-200d-2642-fe0f","v":["1f3ca-1f3fb-200d-2642-fe0f","1f3ca-1f3fc-200d-2642-fe0f","1f3ca-1f3fd-200d-2642-fe0f","1f3ca-1f3fe-200d-2642-fe0f","1f3ca-1f3ff-200d-2642-fe0f"]},{"n":["woman swimming","woman-swimming"],"u":"1f3ca-200d-2640-fe0f","v":["1f3ca-1f3fb-200d-2640-fe0f","1f3ca-1f3fc-200d-2640-fe0f","1f3ca-1f3fd-200d-2640-fe0f","1f3ca-1f3fe-200d-2640-fe0f","1f3ca-1f3ff-200d-2640-fe0f"]},{"n":["person bouncing ball","person_with_ball"],"u":"26f9-fe0f","v":["26f9-1f3fb","26f9-1f3fc","26f9-1f3fd","26f9-1f3fe","26f9-1f3ff"]},{"n":["man bouncing ball","man-bouncing-ball"],"u":"26f9-fe0f-200d-2642-fe0f","v":["26f9-1f3fb-200d-2642-fe0f","26f9-1f3fc-200d-2642-fe0f","26f9-1f3fd-200d-2642-fe0f","26f9-1f3fe-200d-2642-fe0f","26f9-1f3ff-200d-2642-fe0f"]},{"n":["woman bouncing ball","woman-bouncing-ball"],"u":"26f9-fe0f-200d-2640-fe0f","v":["26f9-1f3fb-200d-2640-fe0f","26f9-1f3fc-200d-2640-fe0f","26f9-1f3fd-200d-2640-fe0f","26f9-1f3fe-200d-2640-fe0f","26f9-1f3ff-200d-2640-fe0f"]},{"n":["person lifting weights","weight_lifter"],"u":"1f3cb-fe0f","v":["1f3cb-1f3fb","1f3cb-1f3fc","1f3cb-1f3fd","1f3cb-1f3fe","1f3cb-1f3ff"]},{"n":["man lifting weights","man-lifting-weights"],"u":"1f3cb-fe0f-200d-2642-fe0f","v":["1f3cb-1f3fb-200d-2642-fe0f","1f3cb-1f3fc-200d-2642-fe0f","1f3cb-1f3fd-200d-2642-fe0f","1f3cb-1f3fe-200d-2642-fe0f","1f3cb-1f3ff-200d-2642-fe0f"]},{"n":["woman lifting weights","woman-lifting-weights"],"u":"1f3cb-fe0f-200d-2640-fe0f","v":["1f3cb-1f3fb-200d-2640-fe0f","1f3cb-1f3fc-200d-2640-fe0f","1f3cb-1f3fd-200d-2640-fe0f","1f3cb-1f3fe-200d-2640-fe0f","1f3cb-1f3ff-200d-2640-fe0f"]},{"n":["bicyclist"],"u":"1f6b4","v":["1f6b4-1f3fb","1f6b4-1f3fc","1f6b4-1f3fd","1f6b4-1f3fe","1f6b4-1f3ff"]},{"n":["man biking","man-biking"],"u":"1f6b4-200d-2642-fe0f","v":["1f6b4-1f3fb-200d-2642-fe0f","1f6b4-1f3fc-200d-2642-fe0f","1f6b4-1f3fd-200d-2642-fe0f","1f6b4-1f3fe-200d-2642-fe0f","1f6b4-1f3ff-200d-2642-fe0f"]},{"n":["woman biking","woman-biking"],"u":"1f6b4-200d-2640-fe0f","v":["1f6b4-1f3fb-200d-2640-fe0f","1f6b4-1f3fc-200d-2640-fe0f","1f6b4-1f3fd-200d-2640-fe0f","1f6b4-1f3fe-200d-2640-fe0f","1f6b4-1f3ff-200d-2640-fe0f"]},{"n":["mountain bicyclist","mountain_bicyclist"],"u":"1f6b5","v":["1f6b5-1f3fb","1f6b5-1f3fc","1f6b5-1f3fd","1f6b5-1f3fe","1f6b5-1f3ff"]},{"n":["man mountain biking","man-mountain-biking"],"u":"1f6b5-200d-2642-fe0f","v":["1f6b5-1f3fb-200d-2642-fe0f","1f6b5-1f3fc-200d-2642-fe0f","1f6b5-1f3fd-200d-2642-fe0f","1f6b5-1f3fe-200d-2642-fe0f","1f6b5-1f3ff-200d-2642-fe0f"]},{"n":["woman mountain biking","woman-mountain-biking"],"u":"1f6b5-200d-2640-fe0f","v":["1f6b5-1f3fb-200d-2640-fe0f","1f6b5-1f3fc-200d-2640-fe0f","1f6b5-1f3fd-200d-2640-fe0f","1f6b5-1f3fe-200d-2640-fe0f","1f6b5-1f3ff-200d-2640-fe0f"]},{"n":["person doing cartwheel","person_doing_cartwheel"],"u":"1f938","v":["1f938-1f3fb","1f938-1f3fc","1f938-1f3fd","1f938-1f3fe","1f938-1f3ff"]},{"n":["man cartwheeling","man-cartwheeling"],"u":"1f938-200d-2642-fe0f","v":["1f938-1f3fb-200d-2642-fe0f","1f938-1f3fc-200d-2642-fe0f","1f938-1f3fd-200d-2642-fe0f","1f938-1f3fe-200d-2642-fe0f","1f938-1f3ff-200d-2642-fe0f"]},{"n":["woman cartwheeling","woman-cartwheeling"],"u":"1f938-200d-2640-fe0f","v":["1f938-1f3fb-200d-2640-fe0f","1f938-1f3fc-200d-2640-fe0f","1f938-1f3fd-200d-2640-fe0f","1f938-1f3fe-200d-2640-fe0f","1f938-1f3ff-200d-2640-fe0f"]},{"n":["wrestlers"],"u":"1f93c"},{"n":["men wrestling","man-wrestling"],"u":"1f93c-200d-2642-fe0f"},{"n":["women wrestling","woman-wrestling"],"u":"1f93c-200d-2640-fe0f"},{"n":["water polo","water_polo"],"u":"1f93d","v":["1f93d-1f3fb","1f93d-1f3fc","1f93d-1f3fd","1f93d-1f3fe","1f93d-1f3ff"]},{"n":["man playing water polo","man-playing-water-polo"],"u":"1f93d-200d-2642-fe0f","v":["1f93d-1f3fb-200d-2642-fe0f","1f93d-1f3fc-200d-2642-fe0f","1f93d-1f3fd-200d-2642-fe0f","1f93d-1f3fe-200d-2642-fe0f","1f93d-1f3ff-200d-2642-fe0f"]},{"n":["woman playing water polo","woman-playing-water-polo"],"u":"1f93d-200d-2640-fe0f","v":["1f93d-1f3fb-200d-2640-fe0f","1f93d-1f3fc-200d-2640-fe0f","1f93d-1f3fd-200d-2640-fe0f","1f93d-1f3fe-200d-2640-fe0f","1f93d-1f3ff-200d-2640-fe0f"]},{"n":["handball"],"u":"1f93e","v":["1f93e-1f3fb","1f93e-1f3fc","1f93e-1f3fd","1f93e-1f3fe","1f93e-1f3ff"]},{"n":["man playing handball","man-playing-handball"],"u":"1f93e-200d-2642-fe0f","v":["1f93e-1f3fb-200d-2642-fe0f","1f93e-1f3fc-200d-2642-fe0f","1f93e-1f3fd-200d-2642-fe0f","1f93e-1f3fe-200d-2642-fe0f","1f93e-1f3ff-200d-2642-fe0f"]},{"n":["woman playing handball","woman-playing-handball"],"u":"1f93e-200d-2640-fe0f","v":["1f93e-1f3fb-200d-2640-fe0f","1f93e-1f3fc-200d-2640-fe0f","1f93e-1f3fd-200d-2640-fe0f","1f93e-1f3fe-200d-2640-fe0f","1f93e-1f3ff-200d-2640-fe0f"]},{"n":["juggling"],"u":"1f939","v":["1f939-1f3fb","1f939-1f3fc","1f939-1f3fd","1f939-1f3fe","1f939-1f3ff"]},{"n":["man juggling","man-juggling"],"u":"1f939-200d-2642-fe0f","v":["1f939-1f3fb-200d-2642-fe0f","1f939-1f3fc-200d-2642-fe0f","1f939-1f3fd-200d-2642-fe0f","1f939-1f3fe-200d-2642-fe0f","1f939-1f3ff-200d-2642-fe0f"]},{"n":["woman juggling","woman-juggling"],"u":"1f939-200d-2640-fe0f","v":["1f939-1f3fb-200d-2640-fe0f","1f939-1f3fc-200d-2640-fe0f","1f939-1f3fd-200d-2640-fe0f","1f939-1f3fe-200d-2640-fe0f","1f939-1f3ff-200d-2640-fe0f"]},{"n":["person in lotus position","person_in_lotus_position"],"u":"1f9d8","v":["1f9d8-1f3fb","1f9d8-1f3fc","1f9d8-1f3fd","1f9d8-1f3fe","1f9d8-1f3ff"]},{"n":["man in lotus position","man_in_lotus_position"],"u":"1f9d8-200d-2642-fe0f","v":["1f9d8-1f3fb-200d-2642-fe0f","1f9d8-1f3fc-200d-2642-fe0f","1f9d8-1f3fd-200d-2642-fe0f","1f9d8-1f3fe-200d-2642-fe0f","1f9d8-1f3ff-200d-2642-fe0f"]},{"n":["woman in lotus position","woman_in_lotus_position"],"u":"1f9d8-200d-2640-fe0f","v":["1f9d8-1f3fb-200d-2640-fe0f","1f9d8-1f3fc-200d-2640-fe0f","1f9d8-1f3fd-200d-2640-fe0f","1f9d8-1f3fe-200d-2640-fe0f","1f9d8-1f3ff-200d-2640-fe0f"]},{"n":["bath"],"u":"1f6c0","v":["1f6c0-1f3fb","1f6c0-1f3fc","1f6c0-1f3fd","1f6c0-1f3fe","1f6c0-1f3ff"]},{"n":["sleeping accommodation","sleeping_accommodation"],"u":"1f6cc","v":["1f6cc-1f3fb","1f6cc-1f3fc","1f6cc-1f3fd","1f6cc-1f3fe","1f6cc-1f3ff"]},{"n":["people holding hands","people_holding_hands"],"u":"1f9d1-200d-1f91d-200d-1f9d1","v":["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb","1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc","1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd","1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe","1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff","1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb","1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc","1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd","1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe","1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff","1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb","1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc","1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd","1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe","1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff","1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb","1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc","1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd","1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe","1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff","1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb","1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc","1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd","1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe","1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff"]},{"n":["two women holding hands","two_women_holding_hands","women_holding_hands"],"u":"1f46d","v":["1f46d-1f3fb","1f46d-1f3fc","1f46d-1f3fd","1f46d-1f3fe","1f46d-1f3ff","1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc","1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd","1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe","1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff","1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb","1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd","1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe","1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff","1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb","1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc","1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe","1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff","1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb","1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc","1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd","1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff","1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb","1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc","1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd","1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe"]},{"n":["man and woman holding hands","man_and_woman_holding_hands","woman_and_man_holding_hands","couple"],"u":"1f46b","v":["1f46b-1f3fb","1f46b-1f3fc","1f46b-1f3fd","1f46b-1f3fe","1f46b-1f3ff","1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc","1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd","1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe","1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff","1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb","1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd","1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe","1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff","1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb","1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc","1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe","1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff","1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb","1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc","1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd","1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff","1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb","1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc","1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd","1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe"]},{"n":["two men holding hands","two_men_holding_hands","men_holding_hands"],"u":"1f46c","v":["1f46c-1f3fb","1f46c-1f3fc","1f46c-1f3fd","1f46c-1f3fe","1f46c-1f3ff","1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc","1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd","1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe","1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff","1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb","1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd","1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe","1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff","1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb","1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc","1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe","1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff","1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb","1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc","1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd","1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff","1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb","1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc","1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd","1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe"]},{"n":["kiss","couplekiss"],"u":"1f48f","v":["1f48f-1f3fb","1f48f-1f3fc","1f48f-1f3fd","1f48f-1f3fe","1f48f-1f3ff","1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc","1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd","1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe","1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff","1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb","1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd","1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe","1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff","1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb","1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc","1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe","1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff","1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb","1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc","1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd","1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff","1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb","1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc","1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd","1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe"]},{"n":["kiss: woman, man","woman-kiss-man"],"u":"1f469-200d-2764-fe0f-200d-1f48b-200d-1f468","v":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb","1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc","1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd","1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe","1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff","1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb","1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc","1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd","1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe","1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff","1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb","1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc","1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd","1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe","1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff","1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb","1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc","1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd","1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe","1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff","1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb","1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc","1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd","1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe","1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"]},{"n":["kiss: man, man","man-kiss-man"],"u":"1f468-200d-2764-fe0f-200d-1f48b-200d-1f468","v":["1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb","1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc","1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd","1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe","1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff","1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb","1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc","1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd","1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe","1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff","1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb","1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc","1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd","1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe","1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff","1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb","1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc","1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd","1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe","1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff","1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb","1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc","1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd","1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe","1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"]},{"n":["kiss: woman, woman","woman-kiss-woman"],"u":"1f469-200d-2764-fe0f-200d-1f48b-200d-1f469","v":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb","1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc","1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd","1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe","1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff","1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb","1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc","1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd","1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe","1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff","1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb","1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc","1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd","1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe","1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff","1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb","1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc","1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd","1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe","1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff","1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb","1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc","1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd","1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe","1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff"]},{"n":["couple with heart","couple_with_heart"],"u":"1f491","v":["1f491-1f3fb","1f491-1f3fc","1f491-1f3fd","1f491-1f3fe","1f491-1f3ff","1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fc","1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fd","1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fe","1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3ff","1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fb","1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fd","1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fe","1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3ff","1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fb","1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fc","1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fe","1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3ff","1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fb","1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fc","1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fd","1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3ff","1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fb","1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fc","1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fd","1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fe"]},{"n":["couple with heart: woman, man","woman-heart-man"],"u":"1f469-200d-2764-fe0f-200d-1f468","v":["1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb","1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc","1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd","1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe","1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff","1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb","1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc","1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd","1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe","1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff","1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb","1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc","1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd","1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe","1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff","1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb","1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc","1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd","1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe","1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff","1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb","1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc","1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd","1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe","1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"]},{"n":["couple with heart: man, man","man-heart-man"],"u":"1f468-200d-2764-fe0f-200d-1f468","v":["1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb","1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc","1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd","1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe","1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff","1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb","1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc","1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd","1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe","1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff","1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb","1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc","1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd","1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe","1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff","1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb","1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc","1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd","1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe","1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff","1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb","1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc","1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd","1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe","1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"]},{"n":["couple with heart: woman, woman","woman-heart-woman"],"u":"1f469-200d-2764-fe0f-200d-1f469","v":["1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb","1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fc","1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fd","1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fe","1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3ff","1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fb","1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc","1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fd","1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fe","1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3ff","1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fb","1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fc","1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd","1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fe","1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3ff","1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fb","1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fc","1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fd","1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe","1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3ff","1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fb","1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fc","1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fd","1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fe","1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff"]},{"n":["family"],"u":"1f46a"},{"n":["family: man, woman, boy","man-woman-boy"],"u":"1f468-200d-1f469-200d-1f466"},{"n":["family: man, woman, girl","man-woman-girl"],"u":"1f468-200d-1f469-200d-1f467"},{"n":["family: man, woman, girl, boy","man-woman-girl-boy"],"u":"1f468-200d-1f469-200d-1f467-200d-1f466"},{"n":["family: man, woman, boy, boy","man-woman-boy-boy"],"u":"1f468-200d-1f469-200d-1f466-200d-1f466"},{"n":["family: man, woman, girl, girl","man-woman-girl-girl"],"u":"1f468-200d-1f469-200d-1f467-200d-1f467"},{"n":["family: man, man, boy","man-man-boy"],"u":"1f468-200d-1f468-200d-1f466"},{"n":["family: man, man, girl","man-man-girl"],"u":"1f468-200d-1f468-200d-1f467"},{"n":["family: man, man, girl, boy","man-man-girl-boy"],"u":"1f468-200d-1f468-200d-1f467-200d-1f466"},{"n":["family: man, man, boy, boy","man-man-boy-boy"],"u":"1f468-200d-1f468-200d-1f466-200d-1f466"},{"n":["family: man, man, girl, girl","man-man-girl-girl"],"u":"1f468-200d-1f468-200d-1f467-200d-1f467"},{"n":["family: woman, woman, boy","woman-woman-boy"],"u":"1f469-200d-1f469-200d-1f466"},{"n":["family: woman, woman, girl","woman-woman-girl"],"u":"1f469-200d-1f469-200d-1f467"},{"n":["family: woman, woman, girl, boy","woman-woman-girl-boy"],"u":"1f469-200d-1f469-200d-1f467-200d-1f466"},{"n":["family: woman, woman, boy, boy","woman-woman-boy-boy"],"u":"1f469-200d-1f469-200d-1f466-200d-1f466"},{"n":["family: woman, woman, girl, girl","woman-woman-girl-girl"],"u":"1f469-200d-1f469-200d-1f467-200d-1f467"},{"n":["family: man, boy","man-boy"],"u":"1f468-200d-1f466"},{"n":["family: man, boy, boy","man-boy-boy"],"u":"1f468-200d-1f466-200d-1f466"},{"n":["family: man, girl","man-girl"],"u":"1f468-200d-1f467"},{"n":["family: man, girl, boy","man-girl-boy"],"u":"1f468-200d-1f467-200d-1f466"},{"n":["family: man, girl, girl","man-girl-girl"],"u":"1f468-200d-1f467-200d-1f467"},{"n":["family: woman, boy","woman-boy"],"u":"1f469-200d-1f466"},{"n":["family: woman, boy, boy","woman-boy-boy"],"u":"1f469-200d-1f466-200d-1f466"},{"n":["family: woman, girl","woman-girl"],"u":"1f469-200d-1f467"},{"n":["family: woman, girl, boy","woman-girl-boy"],"u":"1f469-200d-1f467-200d-1f466"},{"n":["family: woman, girl, girl","woman-girl-girl"],"u":"1f469-200d-1f467-200d-1f467"},{"n":["speaking head","speaking_head_in_silhouette"],"u":"1f5e3-fe0f"},{"n":["bust in silhouette","bust_in_silhouette"],"u":"1f464"},{"n":["busts in silhouette","busts_in_silhouette"],"u":"1f465"},{"n":["people hugging","people_hugging"],"u":"1fac2"},{"n":["footprints"],"u":"1f463"}],"animals_nature":[{"n":["monkey face","monkey_face"],"u":"1f435"},{"n":["monkey"],"u":"1f412"},{"n":["gorilla"],"u":"1f98d"},{"n":["orangutan"],"u":"1f9a7"},{"n":["dog face","dog"],"u":"1f436"},{"n":["dog","dog2"],"u":"1f415"},{"n":["guide dog","guide_dog"],"u":"1f9ae"},{"n":["service dog","service_dog"],"u":"1f415-200d-1f9ba"},{"n":["poodle"],"u":"1f429"},{"n":["wolf face","wolf"],"u":"1f43a"},{"n":["fox face","fox_face"],"u":"1f98a"},{"n":["raccoon"],"u":"1f99d"},{"n":["cat face","cat"],"u":"1f431"},{"n":["cat","cat2"],"u":"1f408"},{"n":["black cat","black_cat"],"u":"1f408-200d-2b1b"},{"n":["lion face","lion_face"],"u":"1f981"},{"n":["tiger face","tiger"],"u":"1f42f"},{"n":["tiger","tiger2"],"u":"1f405"},{"n":["leopard"],"u":"1f406"},{"n":["horse face","horse"],"u":"1f434"},{"n":["horse","racehorse"],"u":"1f40e"},{"n":["unicorn face","unicorn_face"],"u":"1f984"},{"n":["zebra face","zebra_face"],"u":"1f993"},{"n":["deer"],"u":"1f98c"},{"n":["bison"],"u":"1f9ac"},{"n":["cow face","cow"],"u":"1f42e"},{"n":["ox"],"u":"1f402"},{"n":["water buffalo","water_buffalo"],"u":"1f403"},{"n":["cow","cow2"],"u":"1f404"},{"n":["pig face","pig"],"u":"1f437"},{"n":["pig","pig2"],"u":"1f416"},{"n":["boar"],"u":"1f417"},{"n":["pig nose","pig_nose"],"u":"1f43d"},{"n":["ram"],"u":"1f40f"},{"n":["sheep"],"u":"1f411"},{"n":["goat"],"u":"1f410"},{"n":["dromedary camel","dromedary_camel"],"u":"1f42a"},{"n":["bactrian camel","camel"],"u":"1f42b"},{"n":["llama"],"u":"1f999"},{"n":["giraffe face","giraffe_face"],"u":"1f992"},{"n":["elephant"],"u":"1f418"},{"n":["mammoth"],"u":"1f9a3"},{"n":["rhinoceros"],"u":"1f98f"},{"n":["hippopotamus"],"u":"1f99b"},{"n":["mouse face","mouse"],"u":"1f42d"},{"n":["mouse","mouse2"],"u":"1f401"},{"n":["rat"],"u":"1f400"},{"n":["hamster face","hamster"],"u":"1f439"},{"n":["rabbit face","rabbit"],"u":"1f430"},{"n":["rabbit","rabbit2"],"u":"1f407"},{"n":["chipmunk"],"u":"1f43f-fe0f"},{"n":["beaver"],"u":"1f9ab"},{"n":["hedgehog"],"u":"1f994"},{"n":["bat"],"u":"1f987"},{"n":["bear face","bear"],"u":"1f43b"},{"n":["polar bear","polar_bear"],"u":"1f43b-200d-2744-fe0f"},{"n":["koala"],"u":"1f428"},{"n":["panda face","panda_face"],"u":"1f43c"},{"n":["sloth"],"u":"1f9a5"},{"n":["otter"],"u":"1f9a6"},{"n":["skunk"],"u":"1f9a8"},{"n":["kangaroo"],"u":"1f998"},{"n":["badger"],"u":"1f9a1"},{"n":["paw prints","feet","paw_prints"],"u":"1f43e"},{"n":["turkey"],"u":"1f983"},{"n":["chicken"],"u":"1f414"},{"n":["rooster"],"u":"1f413"},{"n":["hatching chick","hatching_chick"],"u":"1f423"},{"n":["baby chick","baby_chick"],"u":"1f424"},{"n":["front-facing baby chick","hatched_chick"],"u":"1f425"},{"n":["bird"],"u":"1f426"},{"n":["penguin"],"u":"1f427"},{"n":["dove","dove_of_peace"],"u":"1f54a-fe0f"},{"n":["eagle"],"u":"1f985"},{"n":["duck"],"u":"1f986"},{"n":["swan"],"u":"1f9a2"},{"n":["owl"],"u":"1f989"},{"n":["dodo"],"u":"1f9a4"},{"n":["feather"],"u":"1fab6"},{"n":["flamingo"],"u":"1f9a9"},{"n":["peacock"],"u":"1f99a"},{"n":["parrot"],"u":"1f99c"},{"n":["frog face","frog"],"u":"1f438"},{"n":["crocodile"],"u":"1f40a"},{"n":["turtle"],"u":"1f422"},{"n":["lizard"],"u":"1f98e"},{"n":["snake"],"u":"1f40d"},{"n":["dragon face","dragon_face"],"u":"1f432"},{"n":["dragon"],"u":"1f409"},{"n":["sauropod"],"u":"1f995"},{"n":["t-rex"],"u":"1f996"},{"n":["spouting whale","whale"],"u":"1f433"},{"n":["whale","whale2"],"u":"1f40b"},{"n":["dolphin","flipper"],"u":"1f42c"},{"n":["seal"],"u":"1f9ad"},{"n":["fish"],"u":"1f41f"},{"n":["tropical fish","tropical_fish"],"u":"1f420"},{"n":["blowfish"],"u":"1f421"},{"n":["shark"],"u":"1f988"},{"n":["octopus"],"u":"1f419"},{"n":["spiral shell","shell"],"u":"1f41a"},{"n":["snail"],"u":"1f40c"},{"n":["butterfly"],"u":"1f98b"},{"n":["bug"],"u":"1f41b"},{"n":["ant"],"u":"1f41c"},{"n":["honeybee","bee"],"u":"1f41d"},{"n":["beetle"],"u":"1fab2"},{"n":["lady beetle","ladybug","lady_beetle"],"u":"1f41e"},{"n":["cricket"],"u":"1f997"},{"n":["cockroach"],"u":"1fab3"},{"n":["spider"],"u":"1f577-fe0f"},{"n":["spider web","spider_web"],"u":"1f578-fe0f"},{"n":["scorpion"],"u":"1f982"},{"n":["mosquito"],"u":"1f99f"},{"n":["fly"],"u":"1fab0"},{"n":["worm"],"u":"1fab1"},{"n":["microbe"],"u":"1f9a0"},{"n":["bouquet"],"u":"1f490"},{"n":["cherry blossom","cherry_blossom"],"u":"1f338"},{"n":["white flower","white_flower"],"u":"1f4ae"},{"n":["rosette"],"u":"1f3f5-fe0f"},{"n":["rose"],"u":"1f339"},{"n":["wilted flower","wilted_flower"],"u":"1f940"},{"n":["hibiscus"],"u":"1f33a"},{"n":["sunflower"],"u":"1f33b"},{"n":["blossom"],"u":"1f33c"},{"n":["tulip"],"u":"1f337"},{"n":["seedling"],"u":"1f331"},{"n":["potted plant","potted_plant"],"u":"1fab4"},{"n":["evergreen tree","evergreen_tree"],"u":"1f332"},{"n":["deciduous tree","deciduous_tree"],"u":"1f333"},{"n":["palm tree","palm_tree"],"u":"1f334"},{"n":["cactus"],"u":"1f335"},{"n":["ear of rice","ear_of_rice"],"u":"1f33e"},{"n":["herb"],"u":"1f33f"},{"n":["shamrock"],"u":"2618-fe0f"},{"n":["four leaf clover","four_leaf_clover"],"u":"1f340"},{"n":["maple leaf","maple_leaf"],"u":"1f341"},{"n":["fallen leaf","fallen_leaf"],"u":"1f342"},{"n":["leaf fluttering in wind","leaves"],"u":"1f343"}],"food_drink":[{"n":["grapes"],"u":"1f347"},{"n":["melon"],"u":"1f348"},{"n":["watermelon"],"u":"1f349"},{"n":["tangerine"],"u":"1f34a"},{"n":["lemon"],"u":"1f34b"},{"n":["banana"],"u":"1f34c"},{"n":["pineapple"],"u":"1f34d"},{"n":["mango"],"u":"1f96d"},{"n":["red apple","apple"],"u":"1f34e"},{"n":["green apple","green_apple"],"u":"1f34f"},{"n":["pear"],"u":"1f350"},{"n":["peach"],"u":"1f351"},{"n":["cherries"],"u":"1f352"},{"n":["strawberry"],"u":"1f353"},{"n":["blueberries"],"u":"1fad0"},{"n":["kiwifruit"],"u":"1f95d"},{"n":["tomato"],"u":"1f345"},{"n":["olive"],"u":"1fad2"},{"n":["coconut"],"u":"1f965"},{"n":["avocado"],"u":"1f951"},{"n":["aubergine","eggplant"],"u":"1f346"},{"n":["potato"],"u":"1f954"},{"n":["carrot"],"u":"1f955"},{"n":["ear of maize","corn"],"u":"1f33d"},{"n":["hot pepper","hot_pepper"],"u":"1f336-fe0f"},{"n":["bell pepper","bell_pepper"],"u":"1fad1"},{"n":["cucumber"],"u":"1f952"},{"n":["leafy green","leafy_green"],"u":"1f96c"},{"n":["broccoli"],"u":"1f966"},{"n":["garlic"],"u":"1f9c4"},{"n":["onion"],"u":"1f9c5"},{"n":["mushroom"],"u":"1f344"},{"n":["peanuts"],"u":"1f95c"},{"n":["chestnut"],"u":"1f330"},{"n":["bread"],"u":"1f35e"},{"n":["croissant"],"u":"1f950"},{"n":["baguette bread","baguette_bread"],"u":"1f956"},{"n":["flatbread"],"u":"1fad3"},{"n":["pretzel"],"u":"1f968"},{"n":["bagel"],"u":"1f96f"},{"n":["pancakes"],"u":"1f95e"},{"n":["waffle"],"u":"1f9c7"},{"n":["cheese wedge","cheese_wedge"],"u":"1f9c0"},{"n":["meat on bone","meat_on_bone"],"u":"1f356"},{"n":["poultry leg","poultry_leg"],"u":"1f357"},{"n":["cut of meat","cut_of_meat"],"u":"1f969"},{"n":["bacon"],"u":"1f953"},{"n":["hamburger"],"u":"1f354"},{"n":["french fries","fries"],"u":"1f35f"},{"n":["slice of pizza","pizza"],"u":"1f355"},{"n":["hot dog","hotdog"],"u":"1f32d"},{"n":["sandwich"],"u":"1f96a"},{"n":["taco"],"u":"1f32e"},{"n":["burrito"],"u":"1f32f"},{"n":["tamale"],"u":"1fad4"},{"n":["stuffed flatbread","stuffed_flatbread"],"u":"1f959"},{"n":["falafel"],"u":"1f9c6"},{"n":["egg"],"u":"1f95a"},{"n":["cooking","fried_egg"],"u":"1f373"},{"n":["shallow pan of food","shallow_pan_of_food"],"u":"1f958"},{"n":["pot of food","stew"],"u":"1f372"},{"n":["fondue"],"u":"1fad5"},{"n":["bowl with spoon","bowl_with_spoon"],"u":"1f963"},{"n":["green salad","green_salad"],"u":"1f957"},{"n":["popcorn"],"u":"1f37f"},{"n":["butter"],"u":"1f9c8"},{"n":["salt shaker","salt"],"u":"1f9c2"},{"n":["canned food","canned_food"],"u":"1f96b"},{"n":["bento box","bento"],"u":"1f371"},{"n":["rice cracker","rice_cracker"],"u":"1f358"},{"n":["rice ball","rice_ball"],"u":"1f359"},{"n":["cooked rice","rice"],"u":"1f35a"},{"n":["curry and rice","curry"],"u":"1f35b"},{"n":["steaming bowl","ramen"],"u":"1f35c"},{"n":["spaghetti"],"u":"1f35d"},{"n":["roasted sweet potato","sweet_potato"],"u":"1f360"},{"n":["oden"],"u":"1f362"},{"n":["sushi"],"u":"1f363"},{"n":["fried shrimp","fried_shrimp"],"u":"1f364"},{"n":["fish cake with swirl design","fish_cake"],"u":"1f365"},{"n":["moon cake","moon_cake"],"u":"1f96e"},{"n":["dango"],"u":"1f361"},{"n":["dumpling"],"u":"1f95f"},{"n":["fortune cookie","fortune_cookie"],"u":"1f960"},{"n":["takeout box","takeout_box"],"u":"1f961"},{"n":["crab"],"u":"1f980"},{"n":["lobster"],"u":"1f99e"},{"n":["shrimp"],"u":"1f990"},{"n":["squid"],"u":"1f991"},{"n":["oyster"],"u":"1f9aa"},{"n":["soft ice cream","icecream"],"u":"1f366"},{"n":["shaved ice","shaved_ice"],"u":"1f367"},{"n":["ice cream","ice_cream"],"u":"1f368"},{"n":["doughnut"],"u":"1f369"},{"n":["cookie"],"u":"1f36a"},{"n":["birthday cake","birthday"],"u":"1f382"},{"n":["shortcake","cake"],"u":"1f370"},{"n":["cupcake"],"u":"1f9c1"},{"n":["pie"],"u":"1f967"},{"n":["chocolate bar","chocolate_bar"],"u":"1f36b"},{"n":["candy"],"u":"1f36c"},{"n":["lollipop"],"u":"1f36d"},{"n":["custard"],"u":"1f36e"},{"n":["honey pot","honey_pot"],"u":"1f36f"},{"n":["baby bottle","baby_bottle"],"u":"1f37c"},{"n":["glass of milk","glass_of_milk"],"u":"1f95b"},{"n":["hot beverage","coffee"],"u":"2615"},{"n":["teapot"],"u":"1fad6"},{"n":["teacup without handle","tea"],"u":"1f375"},{"n":["sake bottle and cup","sake"],"u":"1f376"},{"n":["bottle with popping cork","champagne"],"u":"1f37e"},{"n":["wine glass","wine_glass"],"u":"1f377"},{"n":["cocktail glass","cocktail"],"u":"1f378"},{"n":["tropical drink","tropical_drink"],"u":"1f379"},{"n":["beer mug","beer"],"u":"1f37a"},{"n":["clinking beer mugs","beers"],"u":"1f37b"},{"n":["clinking glasses","clinking_glasses"],"u":"1f942"},{"n":["tumbler glass","tumbler_glass"],"u":"1f943"},{"n":["cup with straw","cup_with_straw"],"u":"1f964"},{"n":["bubble tea","bubble_tea"],"u":"1f9cb"},{"n":["beverage box","beverage_box"],"u":"1f9c3"},{"n":["mate drink","mate_drink"],"u":"1f9c9"},{"n":["ice cube","ice_cube"],"u":"1f9ca"},{"n":["chopsticks"],"u":"1f962"},{"n":["fork and knife with plate","knife_fork_plate"],"u":"1f37d-fe0f"},{"n":["fork and knife","fork_and_knife"],"u":"1f374"},{"n":["spoon"],"u":"1f944"},{"n":["hocho","knife"],"u":"1f52a"},{"n":["amphora"],"u":"1f3fa"}],"travel_places":[{"n":["earth globe europe-africa","earth_africa"],"u":"1f30d"},{"n":["earth globe americas","earth_americas"],"u":"1f30e"},{"n":["earth globe asia-australia","earth_asia"],"u":"1f30f"},{"n":["globe with meridians","globe_with_meridians"],"u":"1f310"},{"n":["world map","world_map"],"u":"1f5fa-fe0f"},{"n":["silhouette of japan","japan"],"u":"1f5fe"},{"n":["compass"],"u":"1f9ed"},{"n":["snow-capped mountain","snow_capped_mountain"],"u":"1f3d4-fe0f"},{"n":["mountain"],"u":"26f0-fe0f"},{"n":["volcano"],"u":"1f30b"},{"n":["mount fuji","mount_fuji"],"u":"1f5fb"},{"n":["camping"],"u":"1f3d5-fe0f"},{"n":["beach with umbrella","beach_with_umbrella"],"u":"1f3d6-fe0f"},{"n":["desert"],"u":"1f3dc-fe0f"},{"n":["desert island","desert_island"],"u":"1f3dd-fe0f"},{"n":["national park","national_park"],"u":"1f3de-fe0f"},{"n":["stadium"],"u":"1f3df-fe0f"},{"n":["classical building","classical_building"],"u":"1f3db-fe0f"},{"n":["building construction","building_construction"],"u":"1f3d7-fe0f"},{"n":["brick","bricks"],"u":"1f9f1"},{"n":["rock"],"u":"1faa8"},{"n":["wood"],"u":"1fab5"},{"n":["hut"],"u":"1f6d6"},{"n":["houses","house_buildings"],"u":"1f3d8-fe0f"},{"n":["derelict house","derelict_house_building"],"u":"1f3da-fe0f"},{"n":["house building","house"],"u":"1f3e0"},{"n":["house with garden","house_with_garden"],"u":"1f3e1"},{"n":["office building","office"],"u":"1f3e2"},{"n":["japanese post office","post_office"],"u":"1f3e3"},{"n":["european post office","european_post_office"],"u":"1f3e4"},{"n":["hospital"],"u":"1f3e5"},{"n":["bank"],"u":"1f3e6"},{"n":["hotel"],"u":"1f3e8"},{"n":["love hotel","love_hotel"],"u":"1f3e9"},{"n":["convenience store","convenience_store"],"u":"1f3ea"},{"n":["school"],"u":"1f3eb"},{"n":["department store","department_store"],"u":"1f3ec"},{"n":["factory"],"u":"1f3ed"},{"n":["japanese castle","japanese_castle"],"u":"1f3ef"},{"n":["european castle","european_castle"],"u":"1f3f0"},{"n":["wedding"],"u":"1f492"},{"n":["tokyo tower","tokyo_tower"],"u":"1f5fc"},{"n":["statue of liberty","statue_of_liberty"],"u":"1f5fd"},{"n":["church"],"u":"26ea"},{"n":["mosque"],"u":"1f54c"},{"n":["hindu temple","hindu_temple"],"u":"1f6d5"},{"n":["synagogue"],"u":"1f54d"},{"n":["shinto shrine","shinto_shrine"],"u":"26e9-fe0f"},{"n":["kaaba"],"u":"1f54b"},{"n":["fountain"],"u":"26f2"},{"n":["tent"],"u":"26fa"},{"n":["foggy"],"u":"1f301"},{"n":["night with stars","night_with_stars"],"u":"1f303"},{"n":["cityscape"],"u":"1f3d9-fe0f"},{"n":["sunrise over mountains","sunrise_over_mountains"],"u":"1f304"},{"n":["sunrise"],"u":"1f305"},{"n":["cityscape at dusk","city_sunset"],"u":"1f306"},{"n":["sunset over buildings","city_sunrise"],"u":"1f307"},{"n":["bridge at night","bridge_at_night"],"u":"1f309"},{"n":["hot springs","hotsprings"],"u":"2668-fe0f"},{"n":["carousel horse","carousel_horse"],"u":"1f3a0"},{"n":["ferris wheel","ferris_wheel"],"u":"1f3a1"},{"n":["roller coaster","roller_coaster"],"u":"1f3a2"},{"n":["barber pole","barber"],"u":"1f488"},{"n":["circus tent","circus_tent"],"u":"1f3aa"},{"n":["steam locomotive","steam_locomotive"],"u":"1f682"},{"n":["railway car","railway_car"],"u":"1f683"},{"n":["high-speed train","bullettrain_side"],"u":"1f684"},{"n":["high-speed train with bullet nose","bullettrain_front"],"u":"1f685"},{"n":["train","train2"],"u":"1f686"},{"n":["metro"],"u":"1f687"},{"n":["light rail","light_rail"],"u":"1f688"},{"n":["station"],"u":"1f689"},{"n":["tram"],"u":"1f68a"},{"n":["monorail"],"u":"1f69d"},{"n":["mountain railway","mountain_railway"],"u":"1f69e"},{"n":["tram car","train"],"u":"1f68b"},{"n":["bus"],"u":"1f68c"},{"n":["oncoming bus","oncoming_bus"],"u":"1f68d"},{"n":["trolleybus"],"u":"1f68e"},{"n":["minibus"],"u":"1f690"},{"n":["ambulance"],"u":"1f691"},{"n":["fire engine","fire_engine"],"u":"1f692"},{"n":["police car","police_car"],"u":"1f693"},{"n":["oncoming police car","oncoming_police_car"],"u":"1f694"},{"n":["taxi"],"u":"1f695"},{"n":["oncoming taxi","oncoming_taxi"],"u":"1f696"},{"n":["automobile","car","red_car"],"u":"1f697"},{"n":["oncoming automobile","oncoming_automobile"],"u":"1f698"},{"n":["recreational vehicle","blue_car"],"u":"1f699"},{"n":["pickup truck","pickup_truck"],"u":"1f6fb"},{"n":["delivery truck","truck"],"u":"1f69a"},{"n":["articulated lorry","articulated_lorry"],"u":"1f69b"},{"n":["tractor"],"u":"1f69c"},{"n":["racing car","racing_car"],"u":"1f3ce-fe0f"},{"n":["motorcycle","racing_motorcycle"],"u":"1f3cd-fe0f"},{"n":["motor scooter","motor_scooter"],"u":"1f6f5"},{"n":["manual wheelchair","manual_wheelchair"],"u":"1f9bd"},{"n":["motorized wheelchair","motorized_wheelchair"],"u":"1f9bc"},{"n":["auto rickshaw","auto_rickshaw"],"u":"1f6fa"},{"n":["bicycle","bike"],"u":"1f6b2"},{"n":["scooter"],"u":"1f6f4"},{"n":["skateboard"],"u":"1f6f9"},{"n":["roller skate","roller_skate"],"u":"1f6fc"},{"n":["bus stop","busstop"],"u":"1f68f"},{"n":["motorway"],"u":"1f6e3-fe0f"},{"n":["railway track","railway_track"],"u":"1f6e4-fe0f"},{"n":["oil drum","oil_drum"],"u":"1f6e2-fe0f"},{"n":["fuel pump","fuelpump"],"u":"26fd"},{"n":["police cars revolving light","rotating_light"],"u":"1f6a8"},{"n":["horizontal traffic light","traffic_light"],"u":"1f6a5"},{"n":["vertical traffic light","vertical_traffic_light"],"u":"1f6a6"},{"n":["octagonal sign","octagonal_sign"],"u":"1f6d1"},{"n":["construction sign","construction"],"u":"1f6a7"},{"n":["anchor"],"u":"2693"},{"n":["sailboat","boat"],"u":"26f5"},{"n":["canoe"],"u":"1f6f6"},{"n":["speedboat"],"u":"1f6a4"},{"n":["passenger ship","passenger_ship"],"u":"1f6f3-fe0f"},{"n":["ferry"],"u":"26f4-fe0f"},{"n":["motor boat","motor_boat"],"u":"1f6e5-fe0f"},{"n":["ship"],"u":"1f6a2"},{"n":["airplane"],"u":"2708-fe0f"},{"n":["small airplane","small_airplane"],"u":"1f6e9-fe0f"},{"n":["airplane departure","airplane_departure"],"u":"1f6eb"},{"n":["airplane arriving","airplane_arriving"],"u":"1f6ec"},{"n":["parachute"],"u":"1fa82"},{"n":["seat"],"u":"1f4ba"},{"n":["helicopter"],"u":"1f681"},{"n":["suspension railway","suspension_railway"],"u":"1f69f"},{"n":["mountain cableway","mountain_cableway"],"u":"1f6a0"},{"n":["aerial tramway","aerial_tramway"],"u":"1f6a1"},{"n":["satellite"],"u":"1f6f0-fe0f"},{"n":["rocket"],"u":"1f680"},{"n":["flying saucer","flying_saucer"],"u":"1f6f8"},{"n":["bellhop bell","bellhop_bell"],"u":"1f6ce-fe0f"},{"n":["luggage"],"u":"1f9f3"},{"n":["hourglass"],"u":"231b"},{"n":["hourglass with flowing sand","hourglass_flowing_sand"],"u":"23f3"},{"n":["watch"],"u":"231a"},{"n":["alarm clock","alarm_clock"],"u":"23f0"},{"n":["stopwatch"],"u":"23f1-fe0f"},{"n":["timer clock","timer_clock"],"u":"23f2-fe0f"},{"n":["mantelpiece clock","mantelpiece_clock"],"u":"1f570-fe0f"},{"n":["clock face twelve oclock","clock12"],"u":"1f55b"},{"n":["clock face twelve-thirty","clock1230"],"u":"1f567"},{"n":["clock face one oclock","clock1"],"u":"1f550"},{"n":["clock face one-thirty","clock130"],"u":"1f55c"},{"n":["clock face two oclock","clock2"],"u":"1f551"},{"n":["clock face two-thirty","clock230"],"u":"1f55d"},{"n":["clock face three oclock","clock3"],"u":"1f552"},{"n":["clock face three-thirty","clock330"],"u":"1f55e"},{"n":["clock face four oclock","clock4"],"u":"1f553"},{"n":["clock face four-thirty","clock430"],"u":"1f55f"},{"n":["clock face five oclock","clock5"],"u":"1f554"},{"n":["clock face five-thirty","clock530"],"u":"1f560"},{"n":["clock face six oclock","clock6"],"u":"1f555"},{"n":["clock face six-thirty","clock630"],"u":"1f561"},{"n":["clock face seven oclock","clock7"],"u":"1f556"},{"n":["clock face seven-thirty","clock730"],"u":"1f562"},{"n":["clock face eight oclock","clock8"],"u":"1f557"},{"n":["clock face eight-thirty","clock830"],"u":"1f563"},{"n":["clock face nine oclock","clock9"],"u":"1f558"},{"n":["clock face nine-thirty","clock930"],"u":"1f564"},{"n":["clock face ten oclock","clock10"],"u":"1f559"},{"n":["clock face ten-thirty","clock1030"],"u":"1f565"},{"n":["clock face eleven oclock","clock11"],"u":"1f55a"},{"n":["clock face eleven-thirty","clock1130"],"u":"1f566"},{"n":["new moon symbol","new_moon"],"u":"1f311"},{"n":["waxing crescent moon symbol","waxing_crescent_moon"],"u":"1f312"},{"n":["first quarter moon symbol","first_quarter_moon"],"u":"1f313"},{"n":["waxing gibbous moon symbol","moon","waxing_gibbous_moon"],"u":"1f314"},{"n":["full moon symbol","full_moon"],"u":"1f315"},{"n":["waning gibbous moon symbol","waning_gibbous_moon"],"u":"1f316"},{"n":["last quarter moon symbol","last_quarter_moon"],"u":"1f317"},{"n":["waning crescent moon symbol","waning_crescent_moon"],"u":"1f318"},{"n":["crescent moon","crescent_moon"],"u":"1f319"},{"n":["new moon with face","new_moon_with_face"],"u":"1f31a"},{"n":["first quarter moon with face","first_quarter_moon_with_face"],"u":"1f31b"},{"n":["last quarter moon with face","last_quarter_moon_with_face"],"u":"1f31c"},{"n":["thermometer"],"u":"1f321-fe0f"},{"n":["black sun with rays","sunny"],"u":"2600-fe0f"},{"n":["full moon with face","full_moon_with_face"],"u":"1f31d"},{"n":["sun with face","sun_with_face"],"u":"1f31e"},{"n":["ringed planet","ringed_planet"],"u":"1fa90"},{"n":["white medium star","star"],"u":"2b50"},{"n":["glowing star","star2"],"u":"1f31f"},{"n":["shooting star","stars"],"u":"1f320"},{"n":["milky way","milky_way"],"u":"1f30c"},{"n":["cloud"],"u":"2601-fe0f"},{"n":["sun behind cloud","partly_sunny"],"u":"26c5"},{"n":["cloud with lightning and rain","thunder_cloud_and_rain"],"u":"26c8-fe0f"},{"n":["sun behind small cloud","mostly_sunny","sun_small_cloud"],"u":"1f324-fe0f"},{"n":["sun behind large cloud","barely_sunny","sun_behind_cloud"],"u":"1f325-fe0f"},{"n":["sun behind rain cloud","partly_sunny_rain","sun_behind_rain_cloud"],"u":"1f326-fe0f"},{"n":["cloud with rain","rain_cloud"],"u":"1f327-fe0f"},{"n":["cloud with snow","snow_cloud"],"u":"1f328-fe0f"},{"n":["cloud with lightning","lightning","lightning_cloud"],"u":"1f329-fe0f"},{"n":["tornado","tornado_cloud"],"u":"1f32a-fe0f"},{"n":["fog"],"u":"1f32b-fe0f"},{"n":["wind face","wind_blowing_face"],"u":"1f32c-fe0f"},{"n":["cyclone"],"u":"1f300"},{"n":["rainbow"],"u":"1f308"},{"n":["closed umbrella","closed_umbrella"],"u":"1f302"},{"n":["umbrella"],"u":"2602-fe0f"},{"n":["umbrella with rain drops","umbrella_with_rain_drops"],"u":"2614"},{"n":["umbrella on ground","umbrella_on_ground"],"u":"26f1-fe0f"},{"n":["high voltage sign","zap"],"u":"26a1"},{"n":["snowflake"],"u":"2744-fe0f"},{"n":["snowman"],"u":"2603-fe0f"},{"n":["snowman without snow","snowman_without_snow"],"u":"26c4"},{"n":["comet"],"u":"2604-fe0f"},{"n":["fire"],"u":"1f525"},{"n":["droplet"],"u":"1f4a7"},{"n":["water wave","ocean"],"u":"1f30a"}],"activities":[{"n":["jack-o-lantern","jack_o_lantern"],"u":"1f383"},{"n":["christmas tree","christmas_tree"],"u":"1f384"},{"n":["fireworks"],"u":"1f386"},{"n":["firework sparkler","sparkler"],"u":"1f387"},{"n":["firecracker"],"u":"1f9e8"},{"n":["sparkles"],"u":"2728"},{"n":["balloon"],"u":"1f388"},{"n":["party popper","tada"],"u":"1f389"},{"n":["confetti ball","confetti_ball"],"u":"1f38a"},{"n":["tanabata tree","tanabata_tree"],"u":"1f38b"},{"n":["pine decoration","bamboo"],"u":"1f38d"},{"n":["japanese dolls","dolls"],"u":"1f38e"},{"n":["carp streamer","flags"],"u":"1f38f"},{"n":["wind chime","wind_chime"],"u":"1f390"},{"n":["moon viewing ceremony","rice_scene"],"u":"1f391"},{"n":["red gift envelope","red_envelope"],"u":"1f9e7"},{"n":["ribbon"],"u":"1f380"},{"n":["wrapped present","gift"],"u":"1f381"},{"n":["reminder ribbon","reminder_ribbon"],"u":"1f397-fe0f"},{"n":["admission tickets","admission_tickets"],"u":"1f39f-fe0f"},{"n":["ticket"],"u":"1f3ab"},{"n":["military medal","medal"],"u":"1f396-fe0f"},{"n":["trophy"],"u":"1f3c6"},{"n":["sports medal","sports_medal"],"u":"1f3c5"},{"n":["first place medal","first_place_medal"],"u":"1f947"},{"n":["second place medal","second_place_medal"],"u":"1f948"},{"n":["third place medal","third_place_medal"],"u":"1f949"},{"n":["soccer ball","soccer"],"u":"26bd"},{"n":["baseball"],"u":"26be"},{"n":["softball"],"u":"1f94e"},{"n":["basketball and hoop","basketball"],"u":"1f3c0"},{"n":["volleyball"],"u":"1f3d0"},{"n":["american football","football"],"u":"1f3c8"},{"n":["rugby football","rugby_football"],"u":"1f3c9"},{"n":["tennis racquet and ball","tennis"],"u":"1f3be"},{"n":["flying disc","flying_disc"],"u":"1f94f"},{"n":["bowling"],"u":"1f3b3"},{"n":["cricket bat and ball","cricket_bat_and_ball"],"u":"1f3cf"},{"n":["field hockey stick and ball","field_hockey_stick_and_ball"],"u":"1f3d1"},{"n":["ice hockey stick and puck","ice_hockey_stick_and_puck"],"u":"1f3d2"},{"n":["lacrosse stick and ball","lacrosse"],"u":"1f94d"},{"n":["table tennis paddle and ball","table_tennis_paddle_and_ball"],"u":"1f3d3"},{"n":["badminton racquet and shuttlecock","badminton_racquet_and_shuttlecock"],"u":"1f3f8"},{"n":["boxing glove","boxing_glove"],"u":"1f94a"},{"n":["martial arts uniform","martial_arts_uniform"],"u":"1f94b"},{"n":["goal net","goal_net"],"u":"1f945"},{"n":["flag in hole","golf"],"u":"26f3"},{"n":["ice skate","ice_skate"],"u":"26f8-fe0f"},{"n":["fishing pole and fish","fishing_pole_and_fish"],"u":"1f3a3"},{"n":["diving mask","diving_mask"],"u":"1f93f"},{"n":["running shirt with sash","running_shirt_with_sash"],"u":"1f3bd"},{"n":["ski and ski boot","ski"],"u":"1f3bf"},{"n":["sled"],"u":"1f6f7"},{"n":["curling stone","curling_stone"],"u":"1f94c"},{"n":["direct hit","dart"],"u":"1f3af"},{"n":["yo-yo"],"u":"1fa80"},{"n":["kite"],"u":"1fa81"},{"n":["billiards","8ball"],"u":"1f3b1"},{"n":["crystal ball","crystal_ball"],"u":"1f52e"},{"n":["magic wand","magic_wand"],"u":"1fa84"},{"n":["nazar amulet","nazar_amulet"],"u":"1f9ff"},{"n":["video game","video_game"],"u":"1f3ae"},{"n":["joystick"],"u":"1f579-fe0f"},{"n":["slot machine","slot_machine"],"u":"1f3b0"},{"n":["game die","game_die"],"u":"1f3b2"},{"n":["jigsaw puzzle piece","jigsaw"],"u":"1f9e9"},{"n":["teddy bear","teddy_bear"],"u":"1f9f8"},{"n":["pinata"],"u":"1fa85"},{"n":["nesting dolls","nesting_dolls"],"u":"1fa86"},{"n":["black spade suit","spades"],"u":"2660-fe0f"},{"n":["black heart suit","hearts"],"u":"2665-fe0f"},{"n":["black diamond suit","diamonds"],"u":"2666-fe0f"},{"n":["black club suit","clubs"],"u":"2663-fe0f"},{"n":["chess pawn","chess_pawn"],"u":"265f-fe0f"},{"n":["playing card black joker","black_joker"],"u":"1f0cf"},{"n":["mahjong tile red dragon","mahjong"],"u":"1f004"},{"n":["flower playing cards","flower_playing_cards"],"u":"1f3b4"},{"n":["performing arts","performing_arts"],"u":"1f3ad"},{"n":["framed picture","frame_with_picture"],"u":"1f5bc-fe0f"},{"n":["artist palette","art"],"u":"1f3a8"},{"n":["spool of thread","thread"],"u":"1f9f5"},{"n":["sewing needle","sewing_needle"],"u":"1faa1"},{"n":["ball of yarn","yarn"],"u":"1f9f6"},{"n":["knot"],"u":"1faa2"}],"objects":[{"n":["eyeglasses"],"u":"1f453"},{"n":["sunglasses","dark_sunglasses"],"u":"1f576-fe0f"},{"n":["goggles"],"u":"1f97d"},{"n":["lab coat","lab_coat"],"u":"1f97c"},{"n":["safety vest","safety_vest"],"u":"1f9ba"},{"n":["necktie"],"u":"1f454"},{"n":["t-shirt","shirt","tshirt"],"u":"1f455"},{"n":["jeans"],"u":"1f456"},{"n":["scarf"],"u":"1f9e3"},{"n":["gloves"],"u":"1f9e4"},{"n":["coat"],"u":"1f9e5"},{"n":["socks"],"u":"1f9e6"},{"n":["dress"],"u":"1f457"},{"n":["kimono"],"u":"1f458"},{"n":["sari"],"u":"1f97b"},{"n":["one-piece swimsuit","one-piece_swimsuit"],"u":"1fa71"},{"n":["briefs"],"u":"1fa72"},{"n":["shorts"],"u":"1fa73"},{"n":["bikini"],"u":"1f459"},{"n":["womans clothes","womans_clothes"],"u":"1f45a"},{"n":["purse"],"u":"1f45b"},{"n":["handbag"],"u":"1f45c"},{"n":["pouch"],"u":"1f45d"},{"n":["shopping bags","shopping_bags"],"u":"1f6cd-fe0f"},{"n":["school satchel","school_satchel"],"u":"1f392"},{"n":["thong sandal","thong_sandal"],"u":"1fa74"},{"n":["mans shoe","mans_shoe","shoe"],"u":"1f45e"},{"n":["athletic shoe","athletic_shoe"],"u":"1f45f"},{"n":["hiking boot","hiking_boot"],"u":"1f97e"},{"n":["flat shoe","womans_flat_shoe"],"u":"1f97f"},{"n":["high-heeled shoe","high_heel"],"u":"1f460"},{"n":["womans sandal","sandal"],"u":"1f461"},{"n":["ballet shoes","ballet_shoes"],"u":"1fa70"},{"n":["womans boots","boot"],"u":"1f462"},{"n":["crown"],"u":"1f451"},{"n":["womans hat","womans_hat"],"u":"1f452"},{"n":["top hat","tophat"],"u":"1f3a9"},{"n":["graduation cap","mortar_board"],"u":"1f393"},{"n":["billed cap","billed_cap"],"u":"1f9e2"},{"n":["military helmet","military_helmet"],"u":"1fa96"},{"n":["rescue worker’s helmet","helmet_with_white_cross"],"u":"26d1-fe0f"},{"n":["prayer beads","prayer_beads"],"u":"1f4ff"},{"n":["lipstick"],"u":"1f484"},{"n":["ring"],"u":"1f48d"},{"n":["gem stone","gem"],"u":"1f48e"},{"n":["speaker with cancellation stroke","mute"],"u":"1f507"},{"n":["speaker"],"u":"1f508"},{"n":["speaker with one sound wave","sound"],"u":"1f509"},{"n":["speaker with three sound waves","loud_sound"],"u":"1f50a"},{"n":["public address loudspeaker","loudspeaker"],"u":"1f4e2"},{"n":["cheering megaphone","mega"],"u":"1f4e3"},{"n":["postal horn","postal_horn"],"u":"1f4ef"},{"n":["bell"],"u":"1f514"},{"n":["bell with cancellation stroke","no_bell"],"u":"1f515"},{"n":["musical score","musical_score"],"u":"1f3bc"},{"n":["musical note","musical_note"],"u":"1f3b5"},{"n":["multiple musical notes","notes"],"u":"1f3b6"},{"n":["studio microphone","studio_microphone"],"u":"1f399-fe0f"},{"n":["level slider","level_slider"],"u":"1f39a-fe0f"},{"n":["control knobs","control_knobs"],"u":"1f39b-fe0f"},{"n":["microphone"],"u":"1f3a4"},{"n":["headphone","headphones"],"u":"1f3a7"},{"n":["radio"],"u":"1f4fb"},{"n":["saxophone"],"u":"1f3b7"},{"n":["accordion"],"u":"1fa97"},{"n":["guitar"],"u":"1f3b8"},{"n":["musical keyboard","musical_keyboard"],"u":"1f3b9"},{"n":["trumpet"],"u":"1f3ba"},{"n":["violin"],"u":"1f3bb"},{"n":["banjo"],"u":"1fa95"},{"n":["drum with drumsticks","drum_with_drumsticks"],"u":"1f941"},{"n":["long drum","long_drum"],"u":"1fa98"},{"n":["mobile phone","iphone"],"u":"1f4f1"},{"n":["mobile phone with rightwards arrow at left","calling"],"u":"1f4f2"},{"n":["black telephone","phone","telephone"],"u":"260e-fe0f"},{"n":["telephone receiver","telephone_receiver"],"u":"1f4de"},{"n":["pager"],"u":"1f4df"},{"n":["fax machine","fax"],"u":"1f4e0"},{"n":["battery"],"u":"1f50b"},{"n":["electric plug","electric_plug"],"u":"1f50c"},{"n":["personal computer","computer"],"u":"1f4bb"},{"n":["desktop computer","desktop_computer"],"u":"1f5a5-fe0f"},{"n":["printer"],"u":"1f5a8-fe0f"},{"n":["keyboard"],"u":"2328-fe0f"},{"n":["computer mouse","three_button_mouse"],"u":"1f5b1-fe0f"},{"n":["trackball"],"u":"1f5b2-fe0f"},{"n":["minidisc"],"u":"1f4bd"},{"n":["floppy disk","floppy_disk"],"u":"1f4be"},{"n":["optical disc","cd"],"u":"1f4bf"},{"n":["dvd"],"u":"1f4c0"},{"n":["abacus"],"u":"1f9ee"},{"n":["movie camera","movie_camera"],"u":"1f3a5"},{"n":["film frames","film_frames"],"u":"1f39e-fe0f"},{"n":["film projector","film_projector"],"u":"1f4fd-fe0f"},{"n":["clapper board","clapper"],"u":"1f3ac"},{"n":["television","tv"],"u":"1f4fa"},{"n":["camera"],"u":"1f4f7"},{"n":["camera with flash","camera_with_flash"],"u":"1f4f8"},{"n":["video camera","video_camera"],"u":"1f4f9"},{"n":["videocassette","vhs"],"u":"1f4fc"},{"n":["left-pointing magnifying glass","mag"],"u":"1f50d"},{"n":["right-pointing magnifying glass","mag_right"],"u":"1f50e"},{"n":["candle"],"u":"1f56f-fe0f"},{"n":["electric light bulb","bulb"],"u":"1f4a1"},{"n":["electric torch","flashlight"],"u":"1f526"},{"n":["izakaya lantern","izakaya_lantern","lantern"],"u":"1f3ee"},{"n":["diya lamp","diya_lamp"],"u":"1fa94"},{"n":["notebook with decorative cover","notebook_with_decorative_cover"],"u":"1f4d4"},{"n":["closed book","closed_book"],"u":"1f4d5"},{"n":["open book","book","open_book"],"u":"1f4d6"},{"n":["green book","green_book"],"u":"1f4d7"},{"n":["blue book","blue_book"],"u":"1f4d8"},{"n":["orange book","orange_book"],"u":"1f4d9"},{"n":["books"],"u":"1f4da"},{"n":["notebook"],"u":"1f4d3"},{"n":["ledger"],"u":"1f4d2"},{"n":["page with curl","page_with_curl"],"u":"1f4c3"},{"n":["scroll"],"u":"1f4dc"},{"n":["page facing up","page_facing_up"],"u":"1f4c4"},{"n":["newspaper"],"u":"1f4f0"},{"n":["rolled-up newspaper","rolled_up_newspaper"],"u":"1f5de-fe0f"},{"n":["bookmark tabs","bookmark_tabs"],"u":"1f4d1"},{"n":["bookmark"],"u":"1f516"},{"n":["label"],"u":"1f3f7-fe0f"},{"n":["money bag","moneybag"],"u":"1f4b0"},{"n":["coin"],"u":"1fa99"},{"n":["banknote with yen sign","yen"],"u":"1f4b4"},{"n":["banknote with dollar sign","dollar"],"u":"1f4b5"},{"n":["banknote with euro sign","euro"],"u":"1f4b6"},{"n":["banknote with pound sign","pound"],"u":"1f4b7"},{"n":["money with wings","money_with_wings"],"u":"1f4b8"},{"n":["credit card","credit_card"],"u":"1f4b3"},{"n":["receipt"],"u":"1f9fe"},{"n":["chart with upwards trend and yen sign","chart"],"u":"1f4b9"},{"n":["envelope","email"],"u":"2709-fe0f"},{"n":["e-mail symbol","e-mail"],"u":"1f4e7"},{"n":["incoming envelope","incoming_envelope"],"u":"1f4e8"},{"n":["envelope with downwards arrow above","envelope_with_arrow"],"u":"1f4e9"},{"n":["outbox tray","outbox_tray"],"u":"1f4e4"},{"n":["inbox tray","inbox_tray"],"u":"1f4e5"},{"n":["package"],"u":"1f4e6"},{"n":["closed mailbox with raised flag","mailbox"],"u":"1f4eb"},{"n":["closed mailbox with lowered flag","mailbox_closed"],"u":"1f4ea"},{"n":["open mailbox with raised flag","mailbox_with_mail"],"u":"1f4ec"},{"n":["open mailbox with lowered flag","mailbox_with_no_mail"],"u":"1f4ed"},{"n":["postbox"],"u":"1f4ee"},{"n":["ballot box with ballot","ballot_box_with_ballot"],"u":"1f5f3-fe0f"},{"n":["pencil","pencil2"],"u":"270f-fe0f"},{"n":["black nib","black_nib"],"u":"2712-fe0f"},{"n":["fountain pen","lower_left_fountain_pen"],"u":"1f58b-fe0f"},{"n":["pen","lower_left_ballpoint_pen"],"u":"1f58a-fe0f"},{"n":["paintbrush","lower_left_paintbrush"],"u":"1f58c-fe0f"},{"n":["crayon","lower_left_crayon"],"u":"1f58d-fe0f"},{"n":["memo","pencil"],"u":"1f4dd"},{"n":["briefcase"],"u":"1f4bc"},{"n":["file folder","file_folder"],"u":"1f4c1"},{"n":["open file folder","open_file_folder"],"u":"1f4c2"},{"n":["card index dividers","card_index_dividers"],"u":"1f5c2-fe0f"},{"n":["calendar","date"],"u":"1f4c5"},{"n":["tear-off calendar","calendar"],"u":"1f4c6"},{"n":["spiral notepad","spiral_note_pad"],"u":"1f5d2-fe0f"},{"n":["spiral calendar","spiral_calendar_pad"],"u":"1f5d3-fe0f"},{"n":["card index","card_index"],"u":"1f4c7"},{"n":["chart with upwards trend","chart_with_upwards_trend"],"u":"1f4c8"},{"n":["chart with downwards trend","chart_with_downwards_trend"],"u":"1f4c9"},{"n":["bar chart","bar_chart"],"u":"1f4ca"},{"n":["clipboard"],"u":"1f4cb"},{"n":["pushpin"],"u":"1f4cc"},{"n":["round pushpin","round_pushpin"],"u":"1f4cd"},{"n":["paperclip"],"u":"1f4ce"},{"n":["linked paperclips","linked_paperclips"],"u":"1f587-fe0f"},{"n":["straight ruler","straight_ruler"],"u":"1f4cf"},{"n":["triangular ruler","triangular_ruler"],"u":"1f4d0"},{"n":["black scissors","scissors"],"u":"2702-fe0f"},{"n":["card file box","card_file_box"],"u":"1f5c3-fe0f"},{"n":["file cabinet","file_cabinet"],"u":"1f5c4-fe0f"},{"n":["wastebasket"],"u":"1f5d1-fe0f"},{"n":["lock"],"u":"1f512"},{"n":["open lock","unlock"],"u":"1f513"},{"n":["lock with ink pen","lock_with_ink_pen"],"u":"1f50f"},{"n":["closed lock with key","closed_lock_with_key"],"u":"1f510"},{"n":["key"],"u":"1f511"},{"n":["old key","old_key"],"u":"1f5dd-fe0f"},{"n":["hammer"],"u":"1f528"},{"n":["axe"],"u":"1fa93"},{"n":["pick"],"u":"26cf-fe0f"},{"n":["hammer and pick","hammer_and_pick"],"u":"2692-fe0f"},{"n":["hammer and wrench","hammer_and_wrench"],"u":"1f6e0-fe0f"},{"n":["dagger","dagger_knife"],"u":"1f5e1-fe0f"},{"n":["crossed swords","crossed_swords"],"u":"2694-fe0f"},{"n":["pistol","gun"],"u":"1f52b"},{"n":["boomerang"],"u":"1fa83"},{"n":["bow and arrow","bow_and_arrow"],"u":"1f3f9"},{"n":["shield"],"u":"1f6e1-fe0f"},{"n":["carpentry saw","carpentry_saw"],"u":"1fa9a"},{"n":["wrench"],"u":"1f527"},{"n":["screwdriver"],"u":"1fa9b"},{"n":["nut and bolt","nut_and_bolt"],"u":"1f529"},{"n":["gear"],"u":"2699-fe0f"},{"n":["clamp","compression"],"u":"1f5dc-fe0f"},{"n":["balance scale","scales"],"u":"2696-fe0f"},{"n":["probing cane","probing_cane"],"u":"1f9af"},{"n":["link symbol","link"],"u":"1f517"},{"n":["chains"],"u":"26d3-fe0f"},{"n":["hook"],"u":"1fa9d"},{"n":["toolbox"],"u":"1f9f0"},{"n":["magnet"],"u":"1f9f2"},{"n":["ladder"],"u":"1fa9c"},{"n":["alembic"],"u":"2697-fe0f"},{"n":["test tube","test_tube"],"u":"1f9ea"},{"n":["petri dish","petri_dish"],"u":"1f9eb"},{"n":["dna double helix","dna"],"u":"1f9ec"},{"n":["microscope"],"u":"1f52c"},{"n":["telescope"],"u":"1f52d"},{"n":["satellite antenna","satellite_antenna"],"u":"1f4e1"},{"n":["syringe"],"u":"1f489"},{"n":["drop of blood","drop_of_blood"],"u":"1fa78"},{"n":["pill"],"u":"1f48a"},{"n":["adhesive bandage","adhesive_bandage"],"u":"1fa79"},{"n":["stethoscope"],"u":"1fa7a"},{"n":["door"],"u":"1f6aa"},{"n":["elevator"],"u":"1f6d7"},{"n":["mirror"],"u":"1fa9e"},{"n":["window"],"u":"1fa9f"},{"n":["bed"],"u":"1f6cf-fe0f"},{"n":["couch and lamp","couch_and_lamp"],"u":"1f6cb-fe0f"},{"n":["chair"],"u":"1fa91"},{"n":["toilet"],"u":"1f6bd"},{"n":["plunger"],"u":"1faa0"},{"n":["shower"],"u":"1f6bf"},{"n":["bathtub"],"u":"1f6c1"},{"n":["mouse trap","mouse_trap"],"u":"1faa4"},{"n":["razor"],"u":"1fa92"},{"n":["lotion bottle","lotion_bottle"],"u":"1f9f4"},{"n":["safety pin","safety_pin"],"u":"1f9f7"},{"n":["broom"],"u":"1f9f9"},{"n":["basket"],"u":"1f9fa"},{"n":["roll of paper","roll_of_paper"],"u":"1f9fb"},{"n":["bucket"],"u":"1faa3"},{"n":["bar of soap","soap"],"u":"1f9fc"},{"n":["toothbrush"],"u":"1faa5"},{"n":["sponge"],"u":"1f9fd"},{"n":["fire extinguisher","fire_extinguisher"],"u":"1f9ef"},{"n":["shopping trolley","shopping_trolley"],"u":"1f6d2"},{"n":["smoking symbol","smoking"],"u":"1f6ac"},{"n":["coffin"],"u":"26b0-fe0f"},{"n":["headstone"],"u":"1faa6"},{"n":["funeral urn","funeral_urn"],"u":"26b1-fe0f"},{"n":["moyai"],"u":"1f5ff"},{"n":["placard"],"u":"1faa7"}],"symbols":[{"n":["automated teller machine","atm"],"u":"1f3e7"},{"n":["put litter in its place symbol","put_litter_in_its_place"],"u":"1f6ae"},{"n":["potable water symbol","potable_water"],"u":"1f6b0"},{"n":["wheelchair symbol","wheelchair"],"u":"267f"},{"n":["mens symbol","mens"],"u":"1f6b9"},{"n":["womens symbol","womens"],"u":"1f6ba"},{"n":["restroom"],"u":"1f6bb"},{"n":["baby symbol","baby_symbol"],"u":"1f6bc"},{"n":["water closet","wc"],"u":"1f6be"},{"n":["passport control","passport_control"],"u":"1f6c2"},{"n":["customs"],"u":"1f6c3"},{"n":["baggage claim","baggage_claim"],"u":"1f6c4"},{"n":["left luggage","left_luggage"],"u":"1f6c5"},{"n":["warning sign","warning"],"u":"26a0-fe0f"},{"n":["children crossing","children_crossing"],"u":"1f6b8"},{"n":["no entry","no_entry"],"u":"26d4"},{"n":["no entry sign","no_entry_sign"],"u":"1f6ab"},{"n":["no bicycles","no_bicycles"],"u":"1f6b3"},{"n":["no smoking symbol","no_smoking"],"u":"1f6ad"},{"n":["do not litter symbol","do_not_litter"],"u":"1f6af"},{"n":["non-potable water symbol","non-potable_water"],"u":"1f6b1"},{"n":["no pedestrians","no_pedestrians"],"u":"1f6b7"},{"n":["no mobile phones","no_mobile_phones"],"u":"1f4f5"},{"n":["no one under eighteen symbol","underage"],"u":"1f51e"},{"n":["radioactive","radioactive_sign"],"u":"2622-fe0f"},{"n":["biohazard","biohazard_sign"],"u":"2623-fe0f"},{"n":["upwards black arrow","arrow_up"],"u":"2b06-fe0f"},{"n":["north east arrow","arrow_upper_right"],"u":"2197-fe0f"},{"n":["black rightwards arrow","arrow_right"],"u":"27a1-fe0f"},{"n":["south east arrow","arrow_lower_right"],"u":"2198-fe0f"},{"n":["downwards black arrow","arrow_down"],"u":"2b07-fe0f"},{"n":["south west arrow","arrow_lower_left"],"u":"2199-fe0f"},{"n":["leftwards black arrow","arrow_left"],"u":"2b05-fe0f"},{"n":["north west arrow","arrow_upper_left"],"u":"2196-fe0f"},{"n":["up down arrow","arrow_up_down"],"u":"2195-fe0f"},{"n":["left right arrow","left_right_arrow"],"u":"2194-fe0f"},{"n":["leftwards arrow with hook","leftwards_arrow_with_hook"],"u":"21a9-fe0f"},{"n":["rightwards arrow with hook","arrow_right_hook"],"u":"21aa-fe0f"},{"n":["arrow pointing rightwards then curving upwards","arrow_heading_up"],"u":"2934-fe0f"},{"n":["arrow pointing rightwards then curving downwards","arrow_heading_down"],"u":"2935-fe0f"},{"n":["clockwise downwards and upwards open circle arrows","arrows_clockwise"],"u":"1f503"},{"n":["anticlockwise downwards and upwards open circle arrows","arrows_counterclockwise"],"u":"1f504"},{"n":["back with leftwards arrow above","back"],"u":"1f519"},{"n":["end with leftwards arrow above","end"],"u":"1f51a"},{"n":["on with exclamation mark with left right arrow above","on"],"u":"1f51b"},{"n":["soon with rightwards arrow above","soon"],"u":"1f51c"},{"n":["top with upwards arrow above","top"],"u":"1f51d"},{"n":["place of worship","place_of_worship"],"u":"1f6d0"},{"n":["atom symbol","atom_symbol"],"u":"269b-fe0f"},{"n":["om","om_symbol"],"u":"1f549-fe0f"},{"n":["star of david","star_of_david"],"u":"2721-fe0f"},{"n":["wheel of dharma","wheel_of_dharma"],"u":"2638-fe0f"},{"n":["yin yang","yin_yang"],"u":"262f-fe0f"},{"n":["latin cross","latin_cross"],"u":"271d-fe0f"},{"n":["orthodox cross","orthodox_cross"],"u":"2626-fe0f"},{"n":["star and crescent","star_and_crescent"],"u":"262a-fe0f"},{"n":["peace symbol","peace_symbol"],"u":"262e-fe0f"},{"n":["menorah with nine branches","menorah_with_nine_branches"],"u":"1f54e"},{"n":["six pointed star with middle dot","six_pointed_star"],"u":"1f52f"},{"n":["aries"],"u":"2648"},{"n":["taurus"],"u":"2649"},{"n":["gemini"],"u":"264a"},{"n":["cancer"],"u":"264b"},{"n":["leo"],"u":"264c"},{"n":["virgo"],"u":"264d"},{"n":["libra"],"u":"264e"},{"n":["scorpius"],"u":"264f"},{"n":["sagittarius"],"u":"2650"},{"n":["capricorn"],"u":"2651"},{"n":["aquarius"],"u":"2652"},{"n":["pisces"],"u":"2653"},{"n":["ophiuchus"],"u":"26ce"},{"n":["twisted rightwards arrows","twisted_rightwards_arrows"],"u":"1f500"},{"n":["clockwise rightwards and leftwards open circle arrows","repeat"],"u":"1f501"},{"n":["clockwise rightwards and leftwards open circle arrows with circled one overlay","repeat_one"],"u":"1f502"},{"n":["black right-pointing triangle","arrow_forward"],"u":"25b6-fe0f"},{"n":["black right-pointing double triangle","fast_forward"],"u":"23e9"},{"n":["next track button","black_right_pointing_double_triangle_with_vertical_bar"],"u":"23ed-fe0f"},{"n":["play or pause button","black_right_pointing_triangle_with_double_vertical_bar"],"u":"23ef-fe0f"},{"n":["black left-pointing triangle","arrow_backward"],"u":"25c0-fe0f"},{"n":["black left-pointing double triangle","rewind"],"u":"23ea"},{"n":["last track button","black_left_pointing_double_triangle_with_vertical_bar"],"u":"23ee-fe0f"},{"n":["up-pointing small red triangle","arrow_up_small"],"u":"1f53c"},{"n":["black up-pointing double triangle","arrow_double_up"],"u":"23eb"},{"n":["down-pointing small red triangle","arrow_down_small"],"u":"1f53d"},{"n":["black down-pointing double triangle","arrow_double_down"],"u":"23ec"},{"n":["pause button","double_vertical_bar"],"u":"23f8-fe0f"},{"n":["stop button","black_square_for_stop"],"u":"23f9-fe0f"},{"n":["record button","black_circle_for_record"],"u":"23fa-fe0f"},{"n":["eject button","eject"],"u":"23cf-fe0f"},{"n":["cinema"],"u":"1f3a6"},{"n":["low brightness symbol","low_brightness"],"u":"1f505"},{"n":["high brightness symbol","high_brightness"],"u":"1f506"},{"n":["antenna with bars","signal_strength"],"u":"1f4f6"},{"n":["vibration mode","vibration_mode"],"u":"1f4f3"},{"n":["mobile phone off","mobile_phone_off"],"u":"1f4f4"},{"n":["female sign","female_sign"],"u":"2640-fe0f"},{"n":["male sign","male_sign"],"u":"2642-fe0f"},{"n":["transgender symbol","transgender_symbol"],"u":"26a7-fe0f"},{"n":["heavy multiplication x","heavy_multiplication_x"],"u":"2716-fe0f"},{"n":["heavy plus sign","heavy_plus_sign"],"u":"2795"},{"n":["heavy minus sign","heavy_minus_sign"],"u":"2796"},{"n":["heavy division sign","heavy_division_sign"],"u":"2797"},{"n":["infinity"],"u":"267e-fe0f"},{"n":["double exclamation mark","bangbang"],"u":"203c-fe0f"},{"n":["exclamation question mark","interrobang"],"u":"2049-fe0f"},{"n":["black question mark ornament","question"],"u":"2753"},{"n":["white question mark ornament","grey_question"],"u":"2754"},{"n":["white exclamation mark ornament","grey_exclamation"],"u":"2755"},{"n":["heavy exclamation mark symbol","exclamation","heavy_exclamation_mark"],"u":"2757"},{"n":["wavy dash","wavy_dash"],"u":"3030-fe0f"},{"n":["currency exchange","currency_exchange"],"u":"1f4b1"},{"n":["heavy dollar sign","heavy_dollar_sign"],"u":"1f4b2"},{"n":["medical symbol","medical_symbol","staff_of_aesculapius"],"u":"2695-fe0f"},{"n":["black universal recycling symbol","recycle"],"u":"267b-fe0f"},{"n":["fleur-de-lis","fleur_de_lis"],"u":"269c-fe0f"},{"n":["trident emblem","trident"],"u":"1f531"},{"n":["name badge","name_badge"],"u":"1f4db"},{"n":["japanese symbol for beginner","beginner"],"u":"1f530"},{"n":["heavy large circle","o"],"u":"2b55"},{"n":["white heavy check mark","white_check_mark"],"u":"2705"},{"n":["ballot box with check","ballot_box_with_check"],"u":"2611-fe0f"},{"n":["heavy check mark","heavy_check_mark"],"u":"2714-fe0f"},{"n":["cross mark","x"],"u":"274c"},{"n":["negative squared cross mark","negative_squared_cross_mark"],"u":"274e"},{"n":["curly loop","curly_loop"],"u":"27b0"},{"n":["double curly loop","loop"],"u":"27bf"},{"n":["part alternation mark","part_alternation_mark"],"u":"303d-fe0f"},{"n":["eight spoked asterisk","eight_spoked_asterisk"],"u":"2733-fe0f"},{"n":["eight pointed black star","eight_pointed_black_star"],"u":"2734-fe0f"},{"n":["sparkle"],"u":"2747-fe0f"},{"n":["copyright sign","copyright"],"u":"00a9-fe0f"},{"n":["registered sign","registered"],"u":"00ae-fe0f"},{"n":["trade mark sign","tm"],"u":"2122-fe0f"},{"n":["hash key","hash"],"u":"0023-fe0f-20e3"},{"n":["keycap: *","keycap_star"],"u":"002a-fe0f-20e3"},{"n":["keycap 0","zero"],"u":"0030-fe0f-20e3"},{"n":["keycap 1","one"],"u":"0031-fe0f-20e3"},{"n":["keycap 2","two"],"u":"0032-fe0f-20e3"},{"n":["keycap 3","three"],"u":"0033-fe0f-20e3"},{"n":["keycap 4","four"],"u":"0034-fe0f-20e3"},{"n":["keycap 5","five"],"u":"0035-fe0f-20e3"},{"n":["keycap 6","six"],"u":"0036-fe0f-20e3"},{"n":["keycap 7","seven"],"u":"0037-fe0f-20e3"},{"n":["keycap 8","eight"],"u":"0038-fe0f-20e3"},{"n":["keycap 9","nine"],"u":"0039-fe0f-20e3"},{"n":["keycap ten","keycap_ten"],"u":"1f51f"},{"n":["input symbol for latin capital letters","capital_abcd"],"u":"1f520"},{"n":["input symbol for latin small letters","abcd"],"u":"1f521"},{"n":["input symbol for numbers","1234"],"u":"1f522"},{"n":["input symbol for symbols","symbols"],"u":"1f523"},{"n":["input symbol for latin letters","abc"],"u":"1f524"},{"n":["negative squared latin capital letter a","a"],"u":"1f170-fe0f"},{"n":["negative squared ab","ab"],"u":"1f18e"},{"n":["negative squared latin capital letter b","b"],"u":"1f171-fe0f"},{"n":["squared cl","cl"],"u":"1f191"},{"n":["squared cool","cool"],"u":"1f192"},{"n":["squared free","free"],"u":"1f193"},{"n":["information source","information_source"],"u":"2139-fe0f"},{"n":["squared id","id"],"u":"1f194"},{"n":["circled latin capital letter m","m"],"u":"24c2-fe0f"},{"n":["squared new","new"],"u":"1f195"},{"n":["squared ng","ng"],"u":"1f196"},{"n":["negative squared latin capital letter o","o2"],"u":"1f17e-fe0f"},{"n":["squared ok","ok"],"u":"1f197"},{"n":["negative squared latin capital letter p","parking"],"u":"1f17f-fe0f"},{"n":["squared sos","sos"],"u":"1f198"},{"n":["squared up with exclamation mark","up"],"u":"1f199"},{"n":["squared vs","vs"],"u":"1f19a"},{"n":["squared katakana koko","koko"],"u":"1f201"},{"n":["squared katakana sa","sa"],"u":"1f202-fe0f"},{"n":["squared cjk unified ideograph-6708","u6708"],"u":"1f237-fe0f"},{"n":["squared cjk unified ideograph-6709","u6709"],"u":"1f236"},{"n":["squared cjk unified ideograph-6307","u6307"],"u":"1f22f"},{"n":["circled ideograph advantage","ideograph_advantage"],"u":"1f250"},{"n":["squared cjk unified ideograph-5272","u5272"],"u":"1f239"},{"n":["squared cjk unified ideograph-7121","u7121"],"u":"1f21a"},{"n":["squared cjk unified ideograph-7981","u7981"],"u":"1f232"},{"n":["circled ideograph accept","accept"],"u":"1f251"},{"n":["squared cjk unified ideograph-7533","u7533"],"u":"1f238"},{"n":["squared cjk unified ideograph-5408","u5408"],"u":"1f234"},{"n":["squared cjk unified ideograph-7a7a","u7a7a"],"u":"1f233"},{"n":["circled ideograph congratulation","congratulations"],"u":"3297-fe0f"},{"n":["circled ideograph secret","secret"],"u":"3299-fe0f"},{"n":["squared cjk unified ideograph-55b6","u55b6"],"u":"1f23a"},{"n":["squared cjk unified ideograph-6e80","u6e80"],"u":"1f235"},{"n":["large red circle","red_circle"],"u":"1f534"},{"n":["large orange circle","large_orange_circle"],"u":"1f7e0"},{"n":["large yellow circle","large_yellow_circle"],"u":"1f7e1"},{"n":["large green circle","large_green_circle"],"u":"1f7e2"},{"n":["large blue circle","large_blue_circle"],"u":"1f535"},{"n":["large purple circle","large_purple_circle"],"u":"1f7e3"},{"n":["large brown circle","large_brown_circle"],"u":"1f7e4"},{"n":["medium black circle","black_circle"],"u":"26ab"},{"n":["medium white circle","white_circle"],"u":"26aa"},{"n":["large red square","large_red_square"],"u":"1f7e5"},{"n":["large orange square","large_orange_square"],"u":"1f7e7"},{"n":["large yellow square","large_yellow_square"],"u":"1f7e8"},{"n":["large green square","large_green_square"],"u":"1f7e9"},{"n":["large blue square","large_blue_square"],"u":"1f7e6"},{"n":["large purple square","large_purple_square"],"u":"1f7ea"},{"n":["large brown square","large_brown_square"],"u":"1f7eb"},{"n":["black large square","black_large_square"],"u":"2b1b"},{"n":["white large square","white_large_square"],"u":"2b1c"},{"n":["black medium square","black_medium_square"],"u":"25fc-fe0f"},{"n":["white medium square","white_medium_square"],"u":"25fb-fe0f"},{"n":["black medium small square","black_medium_small_square"],"u":"25fe"},{"n":["white medium small square","white_medium_small_square"],"u":"25fd"},{"n":["black small square","black_small_square"],"u":"25aa-fe0f"},{"n":["white small square","white_small_square"],"u":"25ab-fe0f"},{"n":["large orange diamond","large_orange_diamond"],"u":"1f536"},{"n":["large blue diamond","large_blue_diamond"],"u":"1f537"},{"n":["small orange diamond","small_orange_diamond"],"u":"1f538"},{"n":["small blue diamond","small_blue_diamond"],"u":"1f539"},{"n":["up-pointing red triangle","small_red_triangle"],"u":"1f53a"},{"n":["down-pointing red triangle","small_red_triangle_down"],"u":"1f53b"},{"n":["diamond shape with a dot inside","diamond_shape_with_a_dot_inside"],"u":"1f4a0"},{"n":["radio button","radio_button"],"u":"1f518"},{"n":["white square button","white_square_button"],"u":"1f533"},{"n":["black square button","black_square_button"],"u":"1f532"}],"flags":[{"n":["chequered flag","checkered_flag"],"u":"1f3c1"},{"n":["triangular flag on post","triangular_flag_on_post"],"u":"1f6a9"},{"n":["crossed flags","crossed_flags"],"u":"1f38c"},{"n":["waving black flag","waving_black_flag"],"u":"1f3f4"},{"n":["white flag","waving_white_flag"],"u":"1f3f3-fe0f"},{"n":["rainbow flag","rainbow-flag"],"u":"1f3f3-fe0f-200d-1f308"},{"n":["transgender flag","transgender_flag"],"u":"1f3f3-fe0f-200d-26a7-fe0f"},{"n":["pirate flag","pirate_flag"],"u":"1f3f4-200d-2620-fe0f"},{"n":["ascension island flag","flag-ac"],"u":"1f1e6-1f1e8"},{"n":["andorra flag","flag-ad"],"u":"1f1e6-1f1e9"},{"n":["united arab emirates flag","flag-ae"],"u":"1f1e6-1f1ea"},{"n":["afghanistan flag","flag-af"],"u":"1f1e6-1f1eb"},{"n":["antigua & barbuda flag","flag-ag"],"u":"1f1e6-1f1ec"},{"n":["anguilla flag","flag-ai"],"u":"1f1e6-1f1ee"},{"n":["albania flag","flag-al"],"u":"1f1e6-1f1f1"},{"n":["armenia flag","flag-am"],"u":"1f1e6-1f1f2"},{"n":["angola flag","flag-ao"],"u":"1f1e6-1f1f4"},{"n":["antarctica flag","flag-aq"],"u":"1f1e6-1f1f6"},{"n":["argentina flag","flag-ar"],"u":"1f1e6-1f1f7"},{"n":["american samoa flag","flag-as"],"u":"1f1e6-1f1f8"},{"n":["austria flag","flag-at"],"u":"1f1e6-1f1f9"},{"n":["australia flag","flag-au"],"u":"1f1e6-1f1fa"},{"n":["aruba flag","flag-aw"],"u":"1f1e6-1f1fc"},{"n":["åland islands flag","flag-ax"],"u":"1f1e6-1f1fd"},{"n":["azerbaijan flag","flag-az"],"u":"1f1e6-1f1ff"},{"n":["bosnia & herzegovina flag","flag-ba"],"u":"1f1e7-1f1e6"},{"n":["barbados flag","flag-bb"],"u":"1f1e7-1f1e7"},{"n":["bangladesh flag","flag-bd"],"u":"1f1e7-1f1e9"},{"n":["belgium flag","flag-be"],"u":"1f1e7-1f1ea"},{"n":["burkina faso flag","flag-bf"],"u":"1f1e7-1f1eb"},{"n":["bulgaria flag","flag-bg"],"u":"1f1e7-1f1ec"},{"n":["bahrain flag","flag-bh"],"u":"1f1e7-1f1ed"},{"n":["burundi flag","flag-bi"],"u":"1f1e7-1f1ee"},{"n":["benin flag","flag-bj"],"u":"1f1e7-1f1ef"},{"n":["st. barthélemy flag","flag-bl"],"u":"1f1e7-1f1f1"},{"n":["bermuda flag","flag-bm"],"u":"1f1e7-1f1f2"},{"n":["brunei flag","flag-bn"],"u":"1f1e7-1f1f3"},{"n":["bolivia flag","flag-bo"],"u":"1f1e7-1f1f4"},{"n":["caribbean netherlands flag","flag-bq"],"u":"1f1e7-1f1f6"},{"n":["brazil flag","flag-br"],"u":"1f1e7-1f1f7"},{"n":["bahamas flag","flag-bs"],"u":"1f1e7-1f1f8"},{"n":["bhutan flag","flag-bt"],"u":"1f1e7-1f1f9"},{"n":["bouvet island flag","flag-bv"],"u":"1f1e7-1f1fb"},{"n":["botswana flag","flag-bw"],"u":"1f1e7-1f1fc"},{"n":["belarus flag","flag-by"],"u":"1f1e7-1f1fe"},{"n":["belize flag","flag-bz"],"u":"1f1e7-1f1ff"},{"n":["canada flag","flag-ca"],"u":"1f1e8-1f1e6"},{"n":["cocos (keeling) islands flag","flag-cc"],"u":"1f1e8-1f1e8"},{"n":["congo - kinshasa flag","flag-cd"],"u":"1f1e8-1f1e9"},{"n":["central african republic flag","flag-cf"],"u":"1f1e8-1f1eb"},{"n":["congo - brazzaville flag","flag-cg"],"u":"1f1e8-1f1ec"},{"n":["switzerland flag","flag-ch"],"u":"1f1e8-1f1ed"},{"n":["côte d’ivoire flag","flag-ci"],"u":"1f1e8-1f1ee"},{"n":["cook islands flag","flag-ck"],"u":"1f1e8-1f1f0"},{"n":["chile flag","flag-cl"],"u":"1f1e8-1f1f1"},{"n":["cameroon flag","flag-cm"],"u":"1f1e8-1f1f2"},{"n":["china flag","cn","flag-cn"],"u":"1f1e8-1f1f3"},{"n":["colombia flag","flag-co"],"u":"1f1e8-1f1f4"},{"n":["clipperton island flag","flag-cp"],"u":"1f1e8-1f1f5"},{"n":["costa rica flag","flag-cr"],"u":"1f1e8-1f1f7"},{"n":["cuba flag","flag-cu"],"u":"1f1e8-1f1fa"},{"n":["cape verde flag","flag-cv"],"u":"1f1e8-1f1fb"},{"n":["curaçao flag","flag-cw"],"u":"1f1e8-1f1fc"},{"n":["christmas island flag","flag-cx"],"u":"1f1e8-1f1fd"},{"n":["cyprus flag","flag-cy"],"u":"1f1e8-1f1fe"},{"n":["czechia flag","flag-cz"],"u":"1f1e8-1f1ff"},{"n":["germany flag","de","flag-de"],"u":"1f1e9-1f1ea"},{"n":["diego garcia flag","flag-dg"],"u":"1f1e9-1f1ec"},{"n":["djibouti flag","flag-dj"],"u":"1f1e9-1f1ef"},{"n":["denmark flag","flag-dk"],"u":"1f1e9-1f1f0"},{"n":["dominica flag","flag-dm"],"u":"1f1e9-1f1f2"},{"n":["dominican republic flag","flag-do"],"u":"1f1e9-1f1f4"},{"n":["algeria flag","flag-dz"],"u":"1f1e9-1f1ff"},{"n":["ceuta & melilla flag","flag-ea"],"u":"1f1ea-1f1e6"},{"n":["ecuador flag","flag-ec"],"u":"1f1ea-1f1e8"},{"n":["estonia flag","flag-ee"],"u":"1f1ea-1f1ea"},{"n":["egypt flag","flag-eg"],"u":"1f1ea-1f1ec"},{"n":["western sahara flag","flag-eh"],"u":"1f1ea-1f1ed"},{"n":["eritrea flag","flag-er"],"u":"1f1ea-1f1f7"},{"n":["spain flag","es","flag-es"],"u":"1f1ea-1f1f8"},{"n":["ethiopia flag","flag-et"],"u":"1f1ea-1f1f9"},{"n":["european union flag","flag-eu"],"u":"1f1ea-1f1fa"},{"n":["finland flag","flag-fi"],"u":"1f1eb-1f1ee"},{"n":["fiji flag","flag-fj"],"u":"1f1eb-1f1ef"},{"n":["falkland islands flag","flag-fk"],"u":"1f1eb-1f1f0"},{"n":["micronesia flag","flag-fm"],"u":"1f1eb-1f1f2"},{"n":["faroe islands flag","flag-fo"],"u":"1f1eb-1f1f4"},{"n":["france flag","fr","flag-fr"],"u":"1f1eb-1f1f7"},{"n":["gabon flag","flag-ga"],"u":"1f1ec-1f1e6"},{"n":["united kingdom flag","gb","uk","flag-gb"],"u":"1f1ec-1f1e7"},{"n":["grenada flag","flag-gd"],"u":"1f1ec-1f1e9"},{"n":["georgia flag","flag-ge"],"u":"1f1ec-1f1ea"},{"n":["french guiana flag","flag-gf"],"u":"1f1ec-1f1eb"},{"n":["guernsey flag","flag-gg"],"u":"1f1ec-1f1ec"},{"n":["ghana flag","flag-gh"],"u":"1f1ec-1f1ed"},{"n":["gibraltar flag","flag-gi"],"u":"1f1ec-1f1ee"},{"n":["greenland flag","flag-gl"],"u":"1f1ec-1f1f1"},{"n":["gambia flag","flag-gm"],"u":"1f1ec-1f1f2"},{"n":["guinea flag","flag-gn"],"u":"1f1ec-1f1f3"},{"n":["guadeloupe flag","flag-gp"],"u":"1f1ec-1f1f5"},{"n":["equatorial guinea flag","flag-gq"],"u":"1f1ec-1f1f6"},{"n":["greece flag","flag-gr"],"u":"1f1ec-1f1f7"},{"n":["south georgia & south sandwich islands flag","flag-gs"],"u":"1f1ec-1f1f8"},{"n":["guatemala flag","flag-gt"],"u":"1f1ec-1f1f9"},{"n":["guam flag","flag-gu"],"u":"1f1ec-1f1fa"},{"n":["guinea-bissau flag","flag-gw"],"u":"1f1ec-1f1fc"},{"n":["guyana flag","flag-gy"],"u":"1f1ec-1f1fe"},{"n":["hong kong sar china flag","flag-hk"],"u":"1f1ed-1f1f0"},{"n":["heard & mcdonald islands flag","flag-hm"],"u":"1f1ed-1f1f2"},{"n":["honduras flag","flag-hn"],"u":"1f1ed-1f1f3"},{"n":["croatia flag","flag-hr"],"u":"1f1ed-1f1f7"},{"n":["haiti flag","flag-ht"],"u":"1f1ed-1f1f9"},{"n":["hungary flag","flag-hu"],"u":"1f1ed-1f1fa"},{"n":["canary islands flag","flag-ic"],"u":"1f1ee-1f1e8"},{"n":["indonesia flag","flag-id"],"u":"1f1ee-1f1e9"},{"n":["ireland flag","flag-ie"],"u":"1f1ee-1f1ea"},{"n":["israel flag","flag-il"],"u":"1f1ee-1f1f1"},{"n":["isle of man flag","flag-im"],"u":"1f1ee-1f1f2"},{"n":["india flag","flag-in"],"u":"1f1ee-1f1f3"},{"n":["british indian ocean territory flag","flag-io"],"u":"1f1ee-1f1f4"},{"n":["iraq flag","flag-iq"],"u":"1f1ee-1f1f6"},{"n":["iran flag","flag-ir"],"u":"1f1ee-1f1f7"},{"n":["iceland flag","flag-is"],"u":"1f1ee-1f1f8"},{"n":["italy flag","it","flag-it"],"u":"1f1ee-1f1f9"},{"n":["jersey flag","flag-je"],"u":"1f1ef-1f1ea"},{"n":["jamaica flag","flag-jm"],"u":"1f1ef-1f1f2"},{"n":["jordan flag","flag-jo"],"u":"1f1ef-1f1f4"},{"n":["japan flag","jp","flag-jp"],"u":"1f1ef-1f1f5"},{"n":["kenya flag","flag-ke"],"u":"1f1f0-1f1ea"},{"n":["kyrgyzstan flag","flag-kg"],"u":"1f1f0-1f1ec"},{"n":["cambodia flag","flag-kh"],"u":"1f1f0-1f1ed"},{"n":["kiribati flag","flag-ki"],"u":"1f1f0-1f1ee"},{"n":["comoros flag","flag-km"],"u":"1f1f0-1f1f2"},{"n":["st. kitts & nevis flag","flag-kn"],"u":"1f1f0-1f1f3"},{"n":["north korea flag","flag-kp"],"u":"1f1f0-1f1f5"},{"n":["south korea flag","kr","flag-kr"],"u":"1f1f0-1f1f7"},{"n":["kuwait flag","flag-kw"],"u":"1f1f0-1f1fc"},{"n":["cayman islands flag","flag-ky"],"u":"1f1f0-1f1fe"},{"n":["kazakhstan flag","flag-kz"],"u":"1f1f0-1f1ff"},{"n":["laos flag","flag-la"],"u":"1f1f1-1f1e6"},{"n":["lebanon flag","flag-lb"],"u":"1f1f1-1f1e7"},{"n":["st. lucia flag","flag-lc"],"u":"1f1f1-1f1e8"},{"n":["liechtenstein flag","flag-li"],"u":"1f1f1-1f1ee"},{"n":["sri lanka flag","flag-lk"],"u":"1f1f1-1f1f0"},{"n":["liberia flag","flag-lr"],"u":"1f1f1-1f1f7"},{"n":["lesotho flag","flag-ls"],"u":"1f1f1-1f1f8"},{"n":["lithuania flag","flag-lt"],"u":"1f1f1-1f1f9"},{"n":["luxembourg flag","flag-lu"],"u":"1f1f1-1f1fa"},{"n":["latvia flag","flag-lv"],"u":"1f1f1-1f1fb"},{"n":["libya flag","flag-ly"],"u":"1f1f1-1f1fe"},{"n":["morocco flag","flag-ma"],"u":"1f1f2-1f1e6"},{"n":["monaco flag","flag-mc"],"u":"1f1f2-1f1e8"},{"n":["moldova flag","flag-md"],"u":"1f1f2-1f1e9"},{"n":["montenegro flag","flag-me"],"u":"1f1f2-1f1ea"},{"n":["st. martin flag","flag-mf"],"u":"1f1f2-1f1eb"},{"n":["madagascar flag","flag-mg"],"u":"1f1f2-1f1ec"},{"n":["marshall islands flag","flag-mh"],"u":"1f1f2-1f1ed"},{"n":["north macedonia flag","flag-mk"],"u":"1f1f2-1f1f0"},{"n":["mali flag","flag-ml"],"u":"1f1f2-1f1f1"},{"n":["myanmar (burma) flag","flag-mm"],"u":"1f1f2-1f1f2"},{"n":["mongolia flag","flag-mn"],"u":"1f1f2-1f1f3"},{"n":["macao sar china flag","flag-mo"],"u":"1f1f2-1f1f4"},{"n":["northern mariana islands flag","flag-mp"],"u":"1f1f2-1f1f5"},{"n":["martinique flag","flag-mq"],"u":"1f1f2-1f1f6"},{"n":["mauritania flag","flag-mr"],"u":"1f1f2-1f1f7"},{"n":["montserrat flag","flag-ms"],"u":"1f1f2-1f1f8"},{"n":["malta flag","flag-mt"],"u":"1f1f2-1f1f9"},{"n":["mauritius flag","flag-mu"],"u":"1f1f2-1f1fa"},{"n":["maldives flag","flag-mv"],"u":"1f1f2-1f1fb"},{"n":["malawi flag","flag-mw"],"u":"1f1f2-1f1fc"},{"n":["mexico flag","flag-mx"],"u":"1f1f2-1f1fd"},{"n":["malaysia flag","flag-my"],"u":"1f1f2-1f1fe"},{"n":["mozambique flag","flag-mz"],"u":"1f1f2-1f1ff"},{"n":["namibia flag","flag-na"],"u":"1f1f3-1f1e6"},{"n":["new caledonia flag","flag-nc"],"u":"1f1f3-1f1e8"},{"n":["niger flag","flag-ne"],"u":"1f1f3-1f1ea"},{"n":["norfolk island flag","flag-nf"],"u":"1f1f3-1f1eb"},{"n":["nigeria flag","flag-ng"],"u":"1f1f3-1f1ec"},{"n":["nicaragua flag","flag-ni"],"u":"1f1f3-1f1ee"},{"n":["netherlands flag","flag-nl"],"u":"1f1f3-1f1f1"},{"n":["norway flag","flag-no"],"u":"1f1f3-1f1f4"},{"n":["nepal flag","flag-np"],"u":"1f1f3-1f1f5"},{"n":["nauru flag","flag-nr"],"u":"1f1f3-1f1f7"},{"n":["niue flag","flag-nu"],"u":"1f1f3-1f1fa"},{"n":["new zealand flag","flag-nz"],"u":"1f1f3-1f1ff"},{"n":["oman flag","flag-om"],"u":"1f1f4-1f1f2"},{"n":["panama flag","flag-pa"],"u":"1f1f5-1f1e6"},{"n":["peru flag","flag-pe"],"u":"1f1f5-1f1ea"},{"n":["french polynesia flag","flag-pf"],"u":"1f1f5-1f1eb"},{"n":["papua new guinea flag","flag-pg"],"u":"1f1f5-1f1ec"},{"n":["philippines flag","flag-ph"],"u":"1f1f5-1f1ed"},{"n":["pakistan flag","flag-pk"],"u":"1f1f5-1f1f0"},{"n":["poland flag","flag-pl"],"u":"1f1f5-1f1f1"},{"n":["st. pierre & miquelon flag","flag-pm"],"u":"1f1f5-1f1f2"},{"n":["pitcairn islands flag","flag-pn"],"u":"1f1f5-1f1f3"},{"n":["puerto rico flag","flag-pr"],"u":"1f1f5-1f1f7"},{"n":["palestinian territories flag","flag-ps"],"u":"1f1f5-1f1f8"},{"n":["portugal flag","flag-pt"],"u":"1f1f5-1f1f9"},{"n":["palau flag","flag-pw"],"u":"1f1f5-1f1fc"},{"n":["paraguay flag","flag-py"],"u":"1f1f5-1f1fe"},{"n":["qatar flag","flag-qa"],"u":"1f1f6-1f1e6"},{"n":["réunion flag","flag-re"],"u":"1f1f7-1f1ea"},{"n":["romania flag","flag-ro"],"u":"1f1f7-1f1f4"},{"n":["serbia flag","flag-rs"],"u":"1f1f7-1f1f8"},{"n":["russia flag","ru","flag-ru"],"u":"1f1f7-1f1fa"},{"n":["rwanda flag","flag-rw"],"u":"1f1f7-1f1fc"},{"n":["saudi arabia flag","flag-sa"],"u":"1f1f8-1f1e6"},{"n":["solomon islands flag","flag-sb"],"u":"1f1f8-1f1e7"},{"n":["seychelles flag","flag-sc"],"u":"1f1f8-1f1e8"},{"n":["sudan flag","flag-sd"],"u":"1f1f8-1f1e9"},{"n":["sweden flag","flag-se"],"u":"1f1f8-1f1ea"},{"n":["singapore flag","flag-sg"],"u":"1f1f8-1f1ec"},{"n":["st. helena flag","flag-sh"],"u":"1f1f8-1f1ed"},{"n":["slovenia flag","flag-si"],"u":"1f1f8-1f1ee"},{"n":["svalbard & jan mayen flag","flag-sj"],"u":"1f1f8-1f1ef"},{"n":["slovakia flag","flag-sk"],"u":"1f1f8-1f1f0"},{"n":["sierra leone flag","flag-sl"],"u":"1f1f8-1f1f1"},{"n":["san marino flag","flag-sm"],"u":"1f1f8-1f1f2"},{"n":["senegal flag","flag-sn"],"u":"1f1f8-1f1f3"},{"n":["somalia flag","flag-so"],"u":"1f1f8-1f1f4"},{"n":["suriname flag","flag-sr"],"u":"1f1f8-1f1f7"},{"n":["south sudan flag","flag-ss"],"u":"1f1f8-1f1f8"},{"n":["são tomé & príncipe flag","flag-st"],"u":"1f1f8-1f1f9"},{"n":["el salvador flag","flag-sv"],"u":"1f1f8-1f1fb"},{"n":["sint maarten flag","flag-sx"],"u":"1f1f8-1f1fd"},{"n":["syria flag","flag-sy"],"u":"1f1f8-1f1fe"},{"n":["eswatini flag","flag-sz"],"u":"1f1f8-1f1ff"},{"n":["tristan da cunha flag","flag-ta"],"u":"1f1f9-1f1e6"},{"n":["turks & caicos islands flag","flag-tc"],"u":"1f1f9-1f1e8"},{"n":["chad flag","flag-td"],"u":"1f1f9-1f1e9"},{"n":["french southern territories flag","flag-tf"],"u":"1f1f9-1f1eb"},{"n":["togo flag","flag-tg"],"u":"1f1f9-1f1ec"},{"n":["thailand flag","flag-th"],"u":"1f1f9-1f1ed"},{"n":["tajikistan flag","flag-tj"],"u":"1f1f9-1f1ef"},{"n":["tokelau flag","flag-tk"],"u":"1f1f9-1f1f0"},{"n":["timor-leste flag","flag-tl"],"u":"1f1f9-1f1f1"},{"n":["turkmenistan flag","flag-tm"],"u":"1f1f9-1f1f2"},{"n":["tunisia flag","flag-tn"],"u":"1f1f9-1f1f3"},{"n":["tonga flag","flag-to"],"u":"1f1f9-1f1f4"},{"n":["turkey flag","flag-tr"],"u":"1f1f9-1f1f7"},{"n":["trinidad & tobago flag","flag-tt"],"u":"1f1f9-1f1f9"},{"n":["tuvalu flag","flag-tv"],"u":"1f1f9-1f1fb"},{"n":["taiwan flag","flag-tw"],"u":"1f1f9-1f1fc"},{"n":["tanzania flag","flag-tz"],"u":"1f1f9-1f1ff"},{"n":["ukraine flag","flag-ua"],"u":"1f1fa-1f1e6"},{"n":["uganda flag","flag-ug"],"u":"1f1fa-1f1ec"},{"n":["u.s. outlying islands flag","flag-um"],"u":"1f1fa-1f1f2"},{"n":["united nations flag","flag-un"],"u":"1f1fa-1f1f3"},{"n":["united states flag","us","flag-us"],"u":"1f1fa-1f1f8"},{"n":["uruguay flag","flag-uy"],"u":"1f1fa-1f1fe"},{"n":["uzbekistan flag","flag-uz"],"u":"1f1fa-1f1ff"},{"n":["vatican city flag","flag-va"],"u":"1f1fb-1f1e6"},{"n":["st. vincent & grenadines flag","flag-vc"],"u":"1f1fb-1f1e8"},{"n":["venezuela flag","flag-ve"],"u":"1f1fb-1f1ea"},{"n":["british virgin islands flag","flag-vg"],"u":"1f1fb-1f1ec"},{"n":["u.s. virgin islands flag","flag-vi"],"u":"1f1fb-1f1ee"},{"n":["vietnam flag","flag-vn"],"u":"1f1fb-1f1f3"},{"n":["vanuatu flag","flag-vu"],"u":"1f1fb-1f1fa"},{"n":["wallis & futuna flag","flag-wf"],"u":"1f1fc-1f1eb"},{"n":["samoa flag","flag-ws"],"u":"1f1fc-1f1f8"},{"n":["kosovo flag","flag-xk"],"u":"1f1fd-1f1f0"},{"n":["yemen flag","flag-ye"],"u":"1f1fe-1f1ea"},{"n":["mayotte flag","flag-yt"],"u":"1f1fe-1f1f9"},{"n":["south africa flag","flag-za"],"u":"1f1ff-1f1e6"},{"n":["zambia flag","flag-zm"],"u":"1f1ff-1f1f2"},{"n":["zimbabwe flag","flag-zw"],"u":"1f1ff-1f1fc"},{"n":["england flag","flag-england"],"u":"1f3f4-e0067-e0062-e0065-e006e-e0067-e007f"},{"n":["scotland flag","flag-scotland"],"u":"1f3f4-e0067-e0062-e0073-e0063-e0074-e007f"},{"n":["wales flag","flag-wales"],"u":"1f3f4-e0067-e0062-e0077-e006c-e0073-e007f"}]}')},function(f){f.exports=JSON.parse('["neutral","1f3fb","1f3fc","1f3fd","1f3fe","1f3ff"]')},function(f,e,n){var a=n(14);f.exports=function(f,e){if(f){if("string"==typeof f)return a(f,e);var n=Object.prototype.toString.call(f).slice(8,-1);return"Object"===n&&f.constructor&&(n=f.constructor.name),"Map"===n||"Set"===n?Array.from(f):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?a(f,e):void 0}},f.exports.__esModule=!0,f.exports.default=f.exports},function(f,e){f.exports=function(f,e){(null==e||e>f.length)&&(e=f.length);for(var n=0,a=new Array(e);n<e;n++)a[n]=f[n];return a},f.exports.__esModule=!0,f.exports.default=f.exports},function(f,e,n){var a=n(16);f.exports=function(f,e){if(null==f)return{};var n,d,t=a(f,e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(f);for(d=0;d<r.length;d++)n=r[d],e.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(f,n)&&(t[n]=f[n])}return t},f.exports.__esModule=!0,f.exports.default=f.exports},function(f,e){f.exports=function(f,e){if(null==f)return{};var n,a,d={},t=Object.keys(f);for(a=0;a<t.length;a++)n=t[a],e.indexOf(n)>=0||(d[n]=f[n]);return d},f.exports.__esModule=!0,f.exports.default=f.exports},function(f,e,n){"use strict";var a=n(18);function d(){}function t(){}t.resetWarningCache=d,f.exports=function(){function f(f,e,n,d,t,r){if(r!==a){var o=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw o.name="Invariant Violation",o}}function e(){return f}f.isRequired=f;var n={array:f,bool:f,func:f,number:f,object:f,string:f,symbol:f,any:f,arrayOf:e,element:f,elementType:f,instanceOf:e,node:f,objectOf:e,oneOf:e,oneOfType:e,shape:e,exact:e,checkPropTypes:t,resetWarningCache:d};return n.PropTypes=n,n}},function(f,e,n){"use strict";f.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(f,e){f.exports=function(f){if(Array.isArray(f))return f},f.exports.__esModule=!0,f.exports.default=f.exports},function(f,e){f.exports=function(f,e){var n=null==f?null:"undefined"!=typeof Symbol&&f[Symbol.iterator]||f["@@iterator"];if(null!=n){var a,d,t=[],r=!0,o=!1;try{for(n=n.call(f);!(r=(a=n.next()).done)&&(t.push(a.value),!e||t.length!==e);r=!0);}catch(f){o=!0,d=f}finally{try{r||null==n.return||n.return()}finally{if(o)throw d}}return t}},f.exports.__esModule=!0,f.exports.default=f.exports},function(f,e){f.exports=function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")},f.exports.__esModule=!0,f.exports.default=f.exports},function(f,e,n){var a=n(6),d=n(23);"string"==typeof(d=d.__esModule?d.default:d)&&(d=[[f.i,d,""]]);var t={insert:"head",singleton:!1};a(d,t);f.exports=d.locals||{}},function(f,e,n){var a=n(7),d=n(24),t=n(25),r=n(26),o=n(27),i=n(28),c=n(29),u=n(30),l=n(31),s=n(32);e=a(!1);var b=d(t),g=d(r),m=d(o),p=d(i),h=d(c),_=d(u),w=d(l),v=d(s);e.push([f.i,".emoji-picker-react .emoji-categories button {\n  height: 40px;\n  width: 30px;\n  padding: 5px 0;\n  background-repeat: no-repeat;\n  background-size: 20px;\n  background-position: 50% 50%;\n  cursor: pointer;\n  opacity: 0.5;\n  transition: opacity 0.1s;\n}\n\n.emoji-picker-react .emoji-categories button:focus-visible,\n.emoji-picker-react .emoji-categories button:focus:where(:not(.active)) {\n  background-color: #99c2f160;\n}\n\n.emoji-picker-react .active-category-indicator-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.emoji-picker-react\n  .active-category-indicator-wrapper\n  .active-category-indicator {\n  background: #99c2f1;\n  height: 3px;\n  width: 5px;\n  position: absolute;\n  bottom: 3px;\n  border-radius: 5px;\n  transition: 0.3s;\n  width: 30px;\n}\n\n.emoji-picker-react .emoji-categories button.icn-activities {\n  background-image: url("+b+");\n}\n.emoji-picker-react .emoji-categories button.icn-animals_nature {\n  background-image: url("+g+");\n}\n.emoji-picker-react .emoji-categories button.icn-flags {\n  background-image: url("+m+");\n}\n.emoji-picker-react .emoji-categories button.icn-food_drink {\n  background-image: url("+p+");\n}\n.emoji-picker-react .emoji-categories button.icn-objects {\n  background-image: url("+h+");\n}\n.emoji-picker-react .emoji-categories button.icn-smileys_people {\n  background-image: url("+_+");\n}\n.emoji-picker-react .emoji-categories button.icn-symbols {\n  background-image: url("+w+");\n}\n.emoji-picker-react .emoji-categories button.icn-travel_places {\n  background-image: url("+v+");\n}\n\n.emoji-picker-react .emoji-categories {\n  padding: 0 15px;\n  display: flex;\n  justify-content: space-between;\n  box-sizing: border-box;\n}\n\n.emoji-picker-react .emoji-categories.inactive button,\n.emoji-picker-react .emoji-categories.inactive button.active,\n.emoji-picker-react .emoji-categories.inactive button:hover {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.emoji-picker-react .emoji-categories button.active {\n  opacity: 1;\n}\n\n.emoji-picker-react .emoji-categories button:hover {\n  opacity: 0.7;\n}\n",""]),f.exports=e},function(f,e,n){"use strict";f.exports=function(f,e){return e||(e={}),"string"!=typeof(f=f&&f.__esModule?f.default:f)?f:(/^['"].*['"]$/.test(f)&&(f=f.slice(1,-1)),e.hash&&(f+=e.hash),/["'() \t\n]/.test(f)||e.needQuotes?'"'.concat(f.replace(/"/g,'\\"').replace(/\n/g,"\\n"),'"'):f)}},function(f,e){f.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Cpath d='M32 0C14.355 0 0 14.355 0 32s14.355 32 32 32 32-14.355 32-32S49.645 0 32 0zm29.624 36.731l-3.885-6.439 2.681-7.88a29.867 29.867 0 0 1 1.204 14.319zm-7.558 15.567a.994.994 0 0 0-.408-.02L43.98 53.83a.993.993 0 0 0-.123-.345l-5.502-9.17 8.896-13.7h8.428a.992.992 0 0 0 .105.312l5.236 8.678a29.956 29.956 0 0 1-6.954 12.693zm-10.085 3.557l7.688-1.232a29.958 29.958 0 0 1-11.706 6.296l4.018-5.064zM12.65 9.1a29.858 29.858 0 0 1 18.628-7.082.982.982 0 0 0 .24.376l5.525 5.214-2.185 8.156-14.237 5.465c-.052-.042-.093-.094-.154-.126l-8.87-4.701L12.65 9.1zm25.736-2.976l-4.283-4.042a29.763 29.763 0 0 1 10.989 2.931l-6.706 1.111zM21.93 38.737l-.816-15.554L35.655 17.6l9.803 12.106-8.483 13.063-15.045-4.032zm37.375-19.141c-.031.054-.072.098-.093.159l-3.015 8.86h-9.048L36.882 15.937l2.113-7.887 8.27-1.371a.979.979 0 0 0 .453-.218 30.2 30.2 0 0 1 11.587 13.135zm-48.994-8.289l-.802 5.561-5.349 3.975a30.035 30.035 0 0 1 6.151-9.536zm-7.255 12.82c.044-.023.09-.037.131-.068l7.737-5.751 8.158 4.323.888 16.936c.002.025.013.048.016.073l-7.71 7.629c-.066.065-.105.145-.149.222L4.734 44.32c-.028-.012-.057-.009-.085-.018A29.822 29.822 0 0 1 2 32c0-2.725.372-5.362 1.056-7.873zm3.022 22.945l5.415 2.322 4.141 7.729a30.222 30.222 0 0 1-9.556-10.051zm12.759 11.879c-.019-.064-.025-.131-.058-.192l-5.317-9.924c.076-.043.155-.08.22-.145l8.027-7.942 14.507 3.888 5.927 9.879c.05.083.11.154.178.217l-5.449 6.867c-1.587.26-3.213.401-4.872.401-4.72 0-9.186-1.099-13.163-3.049z'/%3E%3C/svg%3E"},function(f,e){f.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 470 470'%3E%3Cpath d='M401.17 68.83C356.784 24.444 297.771 0 235 0S113.216 24.444 68.83 68.83 0 172.229 0 235s24.444 121.784 68.83 166.17S172.229 470 235 470s121.784-24.444 166.17-68.83S470 297.771 470 235s-24.444-121.784-68.83-166.17zM235 455c-121.309 0-220-98.691-220-220S113.691 15 235 15s220 98.691 220 220-98.691 220-220 220z'/%3E%3Cpath d='M382.5 173.979c3.532 0 6.735 1.824 8.568 4.879a7.499 7.499 0 0 0 12.864 0c1.833-3.055 5.036-4.879 8.568-4.879 4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5c-5.461 0-10.724 1.829-15 5.039-4.276-3.21-9.539-5.039-15-5.039-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5zM322.5 135.459c3.532 0 6.735 1.824 8.568 4.879a7.499 7.499 0 0 0 12.864 0c1.833-3.055 5.036-4.879 8.568-4.879 4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5c-5.461 0-10.724 1.829-15 5.039-4.276-3.21-9.539-5.039-15-5.039-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5zM117.5 173.979c3.532 0 6.735 1.824 8.568 4.879a7.499 7.499 0 0 0 12.864 0c1.833-3.055 5.036-4.879 8.568-4.879 4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5c-5.461 0-10.724 1.829-15 5.039-4.276-3.21-9.539-5.039-15-5.039-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5zM436.826 253.173a7.5 7.5 0 0 0-5.443-2.6c-12.664-.4-24.343-7.548-32.041-19.608a7.5 7.5 0 0 0-12.643-.001c-7.974 12.489-20.074 19.652-33.2 19.652-13.089 0-25.177-7.164-33.162-19.656a7.502 7.502 0 0 0-12.635-.004c-8 12.494-20.098 19.66-33.192 19.66-13.098 0-25.189-7.164-33.175-19.656a7.5 7.5 0 0 0-12.64.004c-7.974 12.489-20.069 19.652-33.187 19.652-13.098 0-25.19-7.164-33.176-19.656a7.502 7.502 0 0 0-12.635-.004c-8 12.494-20.098 19.66-33.191 19.66-13.099 0-25.19-7.164-33.175-19.655a7.5 7.5 0 0 0-12.64.004c-7.699 12.061-19.389 19.207-32.07 19.608a7.494 7.494 0 0 0-5.443 2.6 7.497 7.497 0 0 0-1.769 5.767c5.786 49.506 29.545 95.215 66.901 128.706C135.964 421.407 184.509 440 235 440c45.241 0 88.17-14.518 124.145-41.982a7.498 7.498 0 0 0 1.41-10.512 7.496 7.496 0 0 0-10.512-1.41C316.705 411.547 276.924 425 235 425c-93.882 0-173.276-68.424-187.68-160.366 11.265-2.217 21.561-8.215 29.707-17.284 10.49 11.584 24.673 18.267 39.476 18.267 14.808 0 29.002-6.691 39.505-18.291 10.493 11.6 24.685 18.291 39.498 18.291 14.828 0 29.022-6.689 39.511-18.284 10.493 11.595 24.682 18.284 39.491 18.284 14.808 0 29.002-6.691 39.505-18.291 10.493 11.6 24.679 18.291 39.485 18.291 14.826 0 29.018-6.681 39.505-18.264 8.14 9.065 18.422 15.061 29.671 17.278-6.044 38.177-24.008 74.246-51.068 102.269a7.5 7.5 0 1 0 10.791 10.419c31.08-32.185 51.038-74.226 56.198-118.38a7.495 7.495 0 0 0-1.769-5.766z'/%3E%3Cpath d='M289.513 310.616c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h10c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-10zM358.49 280.616h-10c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h10c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5zM111.503 280.616c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h10c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-10zM235 191.25c30.327 0 55-24.673 55-55s-24.673-55-55-55-55 24.673-55 55 24.673 55 55 55zm0-95c22.056 0 40 17.944 40 40s-17.944 40-40 40-40-17.944-40-40 17.944-40 40-40z'/%3E%3C/svg%3E"},function(f,e){f.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 502 502'%3E%3Cpath d='M428.484 73.516C381.076 26.108 318.044 0 251 0S120.924 26.108 73.516 73.516 0 183.956 0 251s26.108 130.076 73.516 177.484S183.956 502 251 502s130.076-26.108 177.484-73.516C475.892 381.076 502 318.044 502 251s-26.108-130.076-73.516-177.484zM283.829 39h58.868c58.354 25.338 104.274 74.079 125.849 134.317h-41.725a21.139 21.139 0 0 0-19.587 13.087 21.139 21.139 0 0 0 4.595 23.104l3.3 3.3c4.638 4.637 4.638 12.184 0 16.821a11.42 11.42 0 0 1-8.13 3.368 11.422 11.422 0 0 1-8.13-3.368l-7.969-7.969c-13.135-13.135-30.599-20.369-49.175-20.369h-6.397v-8.036c0-19.265-7.502-37.376-21.124-50.999l-9.952-9.952c-10.216-10.216-23.799-15.843-38.247-15.843h-19.931c-7.721 0-14.98 3.007-20.439 8.466l-5.17 5.169c-5.459 5.459-8.466 12.718-8.466 20.439a4.736 4.736 0 0 1-4.73 4.73h-8.66v-12.154c0-8.648 3.368-16.78 9.483-22.895l5.849-5.849c5.244-5.243 8.131-12.214 8.131-19.629V92.71c0-.394.32-.713.713-.713H320.5c12.407 0 22.5-10.093 22.5-22.5S332.907 47 320.5 47h-36.671c-2.206 0-4-1.794-4-4s1.794-4 4-4zm74.893 252.437l-5.452 5.484a155.066 155.066 0 0 0-22.913 29.41l-9.918 16.5-12.403 20.492a48.673 48.673 0 0 0-7.036 25.21v.615a.857.857 0 0 1-.856.856h-.004a8.78 8.78 0 0 1-6.247-2.586 8.776 8.776 0 0 1-2.589-6.25c0-12.58-4.899-24.407-13.794-33.303l-4.591-4.591c-6.947-6.947-10.773-16.183-10.773-26.007v-29.475c0-14.806-12.045-26.851-26.852-26.851H231.8c-8.349 0-15.142-6.792-15.142-15.142v-15.343c0-9.034 7.35-16.384 16.384-16.384h79.886l24.099 24.1c6.003 6.003 9.309 13.984 9.309 22.473v11.464c0 8.56 5.082 15.955 12.386 19.328zM20 251c0-9.444.583-18.752 1.69-27.902h30.619c10.153 0 19.698 3.954 26.876 11.133l8.781 8.78c7.527 7.527 17.534 11.672 28.179 11.672 5.65 0 10.962 2.2 14.957 6.195l.193.193c7.233 7.233 11.217 16.851 11.217 27.081v17.886c0 13.63-5.308 26.444-14.945 36.082l-19.15 19.15c-13.442 13.443-21.939 30.512-24.58 49.002C44.303 368.799 20 312.684 20 251zm231 231c-56.288 0-107.93-20.247-148.049-53.827v-5.423c0-17.881 6.963-34.693 19.607-47.337l19.15-19.15c13.415-13.416 20.803-31.252 20.803-50.224v-17.886c0-15.573-6.064-30.213-17.075-41.224l-.193-.192c-7.772-7.772-18.106-12.053-29.099-12.053a19.72 19.72 0 0 1-14.036-5.814l-8.781-8.781c-10.957-10.956-25.524-16.99-41.019-16.99h-27.3C47.126 98.635 140.047 20 251 20c7.743 0 15.396.39 22.946 1.138-8.316 3.774-14.117 12.151-14.117 21.862 0 13.234 10.766 24 24 24H320.5c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5h-97.713c-11.421 0-20.713 9.292-20.713 20.713v2.028a7.706 7.706 0 0 1-2.273 5.486l-5.85 5.85c-9.893 9.893-15.341 23.047-15.341 37.037v13.574c0 10.245 8.334 18.58 18.579 18.58h10.081c13.636 0 24.73-11.094 24.73-24.73 0-2.379.926-4.615 2.608-6.297l5.169-5.169c.203-.203.414-.393.632-.574.167.195.334.389.518.574l19.932 19.932c-3.833 3.911-3.813 10.186.068 14.068 1.953 1.953 4.512 2.929 7.071 2.929s5.119-.976 7.071-2.929l7-7c3.905-3.905 3.905-10.237 0-14.143l-15.45-15.45c8.875.156 17.197 3.677 23.489 9.97l9.953 9.952c9.844 9.844 15.266 22.934 15.266 36.856v.817H233.04c-20.062 0-36.384 16.322-36.384 36.384V245.8c0 19.377 15.765 35.142 35.142 35.142h3.493a6.86 6.86 0 0 1 6.852 6.851v29.475c0 15.167 5.906 29.425 16.63 40.15l4.591 4.591c5.118 5.118 7.937 11.923 7.937 19.161 0 7.705 3.001 14.948 8.451 20.396 5.446 5.443 12.685 8.44 20.384 8.44h.015C311.648 410 321 400.644 321 389.149v-.614a28.68 28.68 0 0 1 4.146-14.854l12.409-20.502a.226.226 0 0 1 .016-.026l9.928-16.517a135.064 135.064 0 0 1 19.955-25.613l11.147-11.213c4.428-4.455 5.731-11.08 3.319-16.879s-8.029-9.546-14.31-9.546a1.274 1.274 0 0 1-1.273-1.273v-11.464c0-13.832-5.386-26.835-15.167-36.616l-2.215-2.215c10.49 1.524 20.173 6.357 27.804 13.988l7.969 7.969c6.141 6.141 14.207 9.211 22.272 9.211s16.132-3.07 22.272-9.211c6.024-6.024 9.341-14.033 9.341-22.553 0-8.519-3.317-16.528-9.341-22.553l-3.3-3.3c-.198-.198-.567-.567-.26-1.308.307-.741.829-.741 1.109-.741h47.888C479.468 211.761 482 231.09 482 251c0 127.374-103.626 231-231 231z'/%3E%3Cpath d='M184 85c5.523 0 10-4.477 10-10V54.494c0-5.523-4.477-10-10-10s-10 4.477-10 10V75c0 5.523 4.477 10 10 10zM450.39 314.63c-5.176-1.93-10.935.702-12.863 5.877C408.652 397.961 333.692 450 251 450c-5.523 0-10 4.477-10 10s4.477 10 10 10c45.543 0 89.207-13.849 126.272-40.048 36.24-25.617 63.556-61.046 78.995-102.458 1.929-5.175-.702-10.934-5.877-12.864zM202.433 444.034a198.232 198.232 0 0 1-28.554-9.526c-5.092-2.144-10.954.249-13.096 5.339-2.142 5.09.249 10.954 5.339 13.096a218.202 218.202 0 0 0 31.445 10.491c.817.205 1.635.303 2.44.303 4.478 0 8.554-3.03 9.692-7.57 1.344-5.358-1.909-10.79-7.266-12.133z'/%3E%3C/svg%3E"},function(f,e){f.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath d='M337.502 61.244c-46.267-19.341-98.094-21.573-145.933-6.282-5.497 1.758-8.528 7.638-6.772 13.134 1.758 5.497 7.64 8.528 13.134 6.772 43.115-13.782 89.819-11.772 131.51 5.657 1.317.55 2.682.811 4.026.811 4.087 0 7.969-2.415 9.644-6.422 2.228-5.324-.284-11.445-5.609-13.67zM368.323 77.252a11.31 11.31 0 0 0-.375-.239c-4.925-3.009-11.356-1.458-14.364 3.467-2.984 4.884-1.483 11.249 3.346 14.29a10.398 10.398 0 0 0 5.587 1.626c3.377 0 6.69-1.633 8.704-4.654 3.201-4.801 1.904-11.289-2.898-14.49zM447.293 161.884c-4.081-4.08-10.698-4.08-14.778 0l-14.629 14.629c-4.08 4.081-4.08 10.698 0 14.778 2.04 2.041 4.715 3.06 7.388 3.06s5.349-1.02 7.389-3.06l14.629-14.629c4.081-4.081 4.081-10.698.001-14.778zM83.999 214.617c-4.081-4.08-10.698-4.08-14.778 0l-14.629 14.629c-4.08 4.081-4.08 10.698 0 14.778 2.04 2.041 4.715 3.06 7.388 3.06s5.349-1.02 7.39-3.06l14.629-14.629c4.081-4.082 4.081-10.698 0-14.778zM115.508 100.235c-4.081-4.08-10.698-4.08-14.778 0l-14.629 14.629c-4.08 4.081-4.08 10.698 0 14.778 2.04 2.041 4.715 3.06 7.388 3.06s5.348-1.02 7.39-3.06l14.629-14.629c4.081-4.081 4.081-10.698 0-14.778zM386.754 116.24h-20.688c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449h20.688c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449zM151.326 161.908l-14.618-14.618c-4.081-4.08-10.698-4.081-14.778 0s-4.08 10.698 0 14.778l14.618 14.618a10.413 10.413 0 0 0 7.388 3.06c2.674 0 5.349-1.02 7.39-3.06 4.081-4.081 4.081-10.698 0-14.778zM411.753 229.241l-14.618-14.617c-4.08-4.081-10.696-4.08-14.777 0s-4.08 10.697 0 14.777l14.618 14.617c2.041 2.041 4.715 3.06 7.388 3.06s5.348-1.021 7.388-3.06c4.083-4.08 4.082-10.696.001-14.777zM318.326 126.607l-14.617-14.617c-4.081-4.08-10.698-4.081-14.778 0s-4.08 10.698 0 14.778l14.617 14.617a10.414 10.414 0 0 0 7.388 3.061 10.42 10.42 0 0 0 7.39-3.061c4.08-4.081 4.08-10.698 0-14.778zM195.194 97.387c-3.904-4.25-10.515-4.528-14.763-.622l-15.22 13.989c-4.249 3.905-4.527 10.515-.622 14.763a10.42 10.42 0 0 0 7.696 3.378c2.528 0 5.063-.911 7.068-2.756l15.22-13.989c4.248-3.905 4.526-10.515.621-14.763zM256.153 145.241H255.865c-5.762 0-10.437 4.665-10.449 10.429-.011 5.771 4.658 10.457 10.429 10.469H256.134c5.762 0 10.438-4.664 10.449-10.429.01-5.771-4.659-10.458-10.43-10.469z'/%3E%3Cpath d='M437.019 74.981C388.668 26.628 324.38 0 256 0S123.332 26.628 74.981 74.981C26.629 123.333 0 187.62 0 256c0 68.38 26.628 132.668 74.981 181.019C123.333 485.371 187.62 512 256 512c68.38 0 132.668-26.628 181.019-74.981C485.371 388.667 512 324.38 512 256s-26.628-132.668-74.981-181.019zM256 491.102c-94.256 0-175.718-55.763-213.173-136.024 6.781-.56 13.126-3.458 18.112-8.35 5.756-5.647 9.057-13.495 9.057-21.531v-9.364c0-7.449 6.027-13.624 13.435-13.767 3.561-.079 6.976 1.322 9.617 3.913 2.77 2.718 4.359 6.484 4.359 10.332v23.709c0 18.754 15.222 34.302 33.932 34.66.221.004.442.006.664.006 8.973 0 17.47-3.499 23.989-9.895 6.751-6.623 10.623-15.826 10.623-25.25v-18.215c20.172 27.524 52.723 45.432 89.384 45.432 52.209 0 96.09-36.312 107.73-85.007a10.027 10.027 0 0 1 2.18 6.23v25.773c0 19.673 15.968 35.984 35.596 36.361.233.004.464.006.696.006 9.409 0 18.321-3.671 25.161-10.38 7.086-6.951 11.149-16.61 11.149-26.5v-24.856c0-2.83 1.17-5.6 3.21-7.602 1.927-1.889 4.429-2.882 6.986-2.854 5.403.104 9.8 4.612 9.8 10.05v2.721c0 14.409 10.071 26.69 23.526 30.04C453.848 418.996 363.189 491.102 256 491.102zm223.405-200.399v-2.721c0-16.741-13.591-30.624-30.297-30.944-8.235-.159-16.057 2.978-22.022 8.829-6.021 5.906-9.473 14.113-9.473 22.52v24.856c0 4.314-1.782 8.536-4.886 11.582-2.97 2.912-6.846 4.462-10.82 4.397-8.326-.16-15.099-7.098-15.099-15.468v-25.773c0-13.154-8.392-24.538-20.091-28.971.027-1.001.043-2.004.043-3.011 0-46.06-29.007-87.788-72.182-103.836-5.411-2.01-11.425.745-13.434 6.154-2.01 5.409.745 11.424 6.154 13.434 35.027 13.021 58.562 46.877 58.562 84.248 0 49.549-40.312 89.861-89.861 89.861-49.549 0-89.861-40.312-89.861-89.861 0-37.372 23.535-71.228 58.565-84.246 5.409-2.01 8.164-8.026 6.154-13.434s-8.022-8.165-13.434-6.154C174.248 168.21 145.239 209.938 145.239 256a110.22 110.22 0 0 0 7.085 38.971 30.145 30.145 0 0 0-6.607 18.808v25.763c0 3.848-1.589 7.614-4.359 10.332-2.642 2.591-6.036 3.973-9.617 3.913-7.407-.142-13.434-6.317-13.434-13.766v-23.709c0-9.424-3.872-18.627-10.623-25.251-6.681-6.554-15.435-10.081-24.652-9.889-18.71.358-33.932 15.907-33.932 34.66v9.364c0 2.461-1.019 4.871-2.794 6.613-1.668 1.635-3.808 2.506-6.034 2.47-3.374-.065-6.387-2.139-7.733-5.21-7.543-23.011-11.64-47.569-11.64-73.07C20.898 126.365 126.365 20.898 256 20.898S491.102 126.365 491.102 256c0 15.182-1.464 30.026-4.227 44.414-4.281-1.138-7.47-5.083-7.47-9.711z'/%3E%3C/svg%3E"},function(f,e){f.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 58.153 58.153'%3E%3Cpath d='M40.076 29.153h-7.142a3.995 3.995 0 0 0-2.858-2.858V16.153a1 1 0 1 0-2 0v10.142c-1.72.447-3 1.999-3 3.858 0 2.206 1.794 4 4 4 1.858 0 3.411-1.28 3.858-3h7.142a1 1 0 1 0 0-2zm-11 3c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z'/%3E%3Cpath d='M50.188 9.764l4.096 4.096a1 1 0 0 0 1.414 0c3.167-3.166 3.167-8.319 0-11.485s-8.319-3.166-11.485 0a.997.997 0 0 0 0 1.414l4.561 4.561-1.699 1.699c-4.78-4.284-11.089-6.896-17.998-6.896s-13.218 2.612-17.998 6.896l-1.7-1.699 4.561-4.561a.997.997 0 0 0 0-1.414c-3.166-3.166-8.318-3.166-11.485 0s-3.167 8.319 0 11.485a1 1 0 0 0 1.414 0l4.096-4.096 1.676 1.676c-4.679 4.857-7.565 11.453-7.565 18.713 0 9.898 5.357 18.564 13.321 23.265l-3.028 3.028a.999.999 0 1 0 1.414 1.414l3.45-3.45c3.578 1.754 7.597 2.743 11.843 2.743s8.265-.989 11.843-2.743l3.45 3.45a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-3.028-3.028c7.964-4.701 13.321-13.367 13.321-23.265 0-7.26-2.886-13.856-7.565-18.713l1.677-1.676zm4.095-5.975c2.146 2.146 2.362 5.502.649 7.893L46.391 3.14a6.13 6.13 0 0 1 7.892.649zM3.22 11.681c-1.713-2.39-1.497-5.746.649-7.892s5.502-2.361 7.892-.649L3.22 11.681zm25.856 43.472c-13.785 0-25-11.215-25-25s11.215-25 25-25 25 11.215 25 25-11.214 25-25 25z'/%3E%3Cpath d='M29.076 10.032a1 1 0 0 0 1-1v-1a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1zM29.076 50.032a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0v-1a1 1 0 0 0-1-1zM50.076 31.032h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2zM8.076 29.032h-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zM43.926 13.768l-.707.707a.999.999 0 1 0 1.414 1.414l.707-.707a.999.999 0 1 0-1.414-1.414zM13.52 44.174l-.707.707a.999.999 0 1 0 1.414 1.414l.707-.707a.999.999 0 1 0-1.414-1.414zM44.633 44.174a.999.999 0 1 0-1.414 1.414l.707.707a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-.707-.707zM14.227 13.768a.999.999 0 1 0-1.414 1.414l.707.707a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-.707-.707z'/%3E%3C/svg%3E"},function(f,e){f.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 33 33'%3E%3Cpath d='M16.5 33C7.402 33 0 25.598 0 16.5S7.402 0 16.5 0 33 7.402 33 16.5 25.598 33 16.5 33zm0-32C7.953 1 1 7.953 1 16.5S7.953 32 16.5 32 32 25.047 32 16.5 25.047 1 16.5 1z'/%3E%3Cpath d='M16.5 33a16.38 16.38 0 0 1-9.549-3.06.5.5 0 1 1 .116-.876c4.146-1.535 4.815-2.781 4.815-5.169 0-.631-.142-.838-.398-1.214-.339-.494-.803-1.171-1.129-2.939-.048-.254-.089-.274-.316-.384-.606-.292-1.163-.712-1.309-2.628 0-.928.32-1.441.585-1.708-.058-.33-.153-.899-.242-1.519-.453-2.777-.473-6.178 3.433-7.759 3.404-1.38 6.121-.626 6.974.273.604.019 2.162.177 3.246 1.438 1.668 1.94 1.137 6.363.955 7.562.266.261.589.767.589 1.675-.146 1.954-.703 2.375-1.31 2.666-.228.11-.269.129-.316.384-.326 1.768-.789 2.445-1.128 2.939-.257.375-.398.583-.398 1.214 0 2.388.669 3.634 4.815 5.169a.498.498 0 0 1 .116.876A16.38 16.38 0 0 1 16.5 33zm-8.183-3.349C10.779 31.191 13.589 32 16.5 32s5.721-.809 8.183-2.349c-3.474-1.426-4.565-2.864-4.565-5.755 0-.941.278-1.348.573-1.779.304-.444.682-.996.971-2.556.139-.754.576-.964.865-1.103.311-.149.631-.303.744-1.803-.001-.764-.344-.972-.358-.98a.533.533 0 0 1-.264-.537c.248-1.329.656-5.474-.681-7.031-.913-1.062-2.352-1.091-2.626-1.08-.046-.004-.091-.005-.134-.016-.13-.033-.35-.146-.417-.262-.272-.466-2.641-1.403-5.91-.08-3.231 1.308-3.238 4.112-2.819 6.682.138.957.289 1.784.29 1.788a.5.5 0 0 1-.283.544c.003 0-.339.209-.339 1.008.112 1.461.433 1.616.743 1.765.289.139.727.349.866 1.103.288 1.56.666 2.112.97 2.556.296.431.574.838.574 1.779 0 2.894-1.091 4.332-4.566 5.757z'/%3E%3C/svg%3E"},function(f,e){f.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 490.4 490.4'%3E%3Cpath d='M229 381.2c4.4 4.4 10.1 6.8 16.3 6.8 6.2 0 12-2.4 16.3-6.8l96.3-96.3c15.7-15.7 24.4-36.6 24.4-58.7 0-22.2-8.6-43.1-24.3-58.8-15.7-15.7-36.6-24.3-58.7-24.3-20 0-38.9 7-54 19.9-15.1-13-34.1-20-54.1-20-22.2 0-43 8.6-58.7 24.3s-24.3 36.6-24.3 58.8 8.7 43 24.4 58.7l96.4 96.4zm-79.3-196.7c11.1-11.1 25.7-17.1 41.4-17.1s30.4 6.1 41.5 17.2l4 4c4.8 4.8 12.5 4.8 17.3 0l3.9-3.9c11.1-11.1 25.8-17.2 41.5-17.2 15.6 0 30.3 6.1 41.4 17.2 11.1 11.1 17.2 25.8 17.1 41.4 0 15.7-6.1 30.4-17.2 41.5l-95.3 95.3-95.5-95.5c-11.1-11.1-17.2-25.8-17.2-41.4 0-15.7 6.1-30.4 17.1-41.5z'/%3E%3Cpath d='M245.2 490.4c135.2 0 245.2-110 245.2-245.2S380.4 0 245.2 0 0 110 0 245.2s110 245.2 245.2 245.2zm0-465.9c121.7 0 220.7 99 220.7 220.7s-99 220.7-220.7 220.7-220.7-99-220.7-220.7 99-220.7 220.7-220.7z'/%3E%3C/svg%3E"},function(f,e){f.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 470 470'%3E%3Cpath d='M401.17 68.83C356.784 24.444 297.771 0 235 0S113.216 24.444 68.83 68.83C24.444 113.215 0 172.229 0 235s24.444 121.785 68.83 166.17C113.216 445.556 172.229 470 235 470s121.784-24.444 166.17-68.83C445.556 356.785 470 297.771 470 235s-24.444-121.785-68.83-166.17zM235 455c-121.309 0-220-98.691-220-220S113.691 15 235 15s220 98.691 220 220-98.691 220-220 220z'/%3E%3Ccircle cx='235' cy='97.5' r='7.5'/%3E%3Cpath d='M437.56 242.365a7.501 7.501 0 0 0-5.467-2.365h-26.046v-22.5c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5V240H372.5v-52.5a7.5 7.5 0 0 0-3.525-6.36L292.5 133.343V97.5A7.5 7.5 0 0 0 285 90h-13.253C268.262 72.905 253.109 60 235 60s-33.262 12.905-36.747 30H185a7.5 7.5 0 0 0-7.5 7.5V130h-25v-22.5c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5V130H105a7.5 7.5 0 0 0-7.5 7.5v102.499l-59.593-.01a7.504 7.504 0 0 0-7.487 7.969c3.523 56.171 29.666 105.984 69.187 140.798.281.291.587.556.911.799 23.389 20.362 51.39 35.496 82.128 43.638.307.102.622.184.946.246A204.258 204.258 0 0 0 235 440c17.409 0 34.679-2.229 51.386-6.558a7.297 7.297 0 0 0 1.002-.262 203.842 203.842 0 0 0 50.574-20.966c30.222-17.629 55.631-42.86 73.479-72.965a7.5 7.5 0 0 0-12.902-7.65 189.49 189.49 0 0 1-26.039 34.299V255h51.438a188.457 188.457 0 0 1-12.616 50.728 7.499 7.499 0 0 0 4.156 9.758 7.498 7.498 0 0 0 9.758-4.157 203.511 203.511 0 0 0 14.342-63.359 7.499 7.499 0 0 0-2.018-5.605zM192.5 175h85v215h-85V175zm0-70H205a7.5 7.5 0 0 0 7.5-7.5c0-12.407 10.094-22.5 22.5-22.5s22.5 10.093 22.5 22.5a7.5 7.5 0 0 0 7.5 7.5h12.5v55h-85v-55zM46.059 254.99l51.441.009V307.5c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5V145h65v245H175c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h2.5v11.078c-24.056-7.668-46.091-20.018-65-35.997V337.5c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v28.458c-28.127-29.492-46.937-68.033-51.441-110.968zM192.5 420.179V405h85v15.106A187.644 187.644 0 0 1 235 425a189.427 189.427 0 0 1-42.5-4.821zm100-4.235V405h2.5c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-2.5V151.032l65 40.625v188.307a191.989 191.989 0 0 1-65 35.98z'/%3E%3Cpath d='M325 320a7.5 7.5 0 0 0-7.5 7.5v10c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-10a7.5 7.5 0 0 0-7.5-7.5zM325 280a7.5 7.5 0 0 0-7.5 7.5v10c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-10a7.5 7.5 0 0 0-7.5-7.5zM325 240a7.5 7.5 0 0 0-7.5 7.5v10c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-10a7.5 7.5 0 0 0-7.5-7.5zM325 200a7.5 7.5 0 0 0-7.5 7.5v10c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-10a7.5 7.5 0 0 0-7.5-7.5zM145 345a7.5 7.5 0 0 0 7.5-7.5v-10c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v10a7.5 7.5 0 0 0 7.5 7.5zM145 305a7.5 7.5 0 0 0 7.5-7.5v-10c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v10a7.5 7.5 0 0 0 7.5 7.5zM145 265a7.5 7.5 0 0 0 7.5-7.5v-10c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v10a7.5 7.5 0 0 0 7.5 7.5zM145 185a7.5 7.5 0 0 0 7.5-7.5v-10c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v10a7.5 7.5 0 0 0 7.5 7.5zM145 225a7.5 7.5 0 0 0 7.5-7.5v-10c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v10a7.5 7.5 0 0 0 7.5 7.5zM235 350a7.5 7.5 0 0 0-7.5 7.5v10c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-10a7.5 7.5 0 0 0-7.5-7.5zM235 310a7.5 7.5 0 0 0-7.5 7.5v10c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-10a7.5 7.5 0 0 0-7.5-7.5zM235 270a7.5 7.5 0 0 0-7.5 7.5v10c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-10a7.5 7.5 0 0 0-7.5-7.5zM235 230a7.5 7.5 0 0 0-7.5 7.5v10c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-10a7.5 7.5 0 0 0-7.5-7.5zM235 190a7.5 7.5 0 0 0-7.5 7.5v10c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-10a7.5 7.5 0 0 0-7.5-7.5zM215 145h40c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-40c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5z'/%3E%3C/svg%3E"},function(f,e,n){var a=n(14);f.exports=function(f){if(Array.isArray(f))return a(f)},f.exports.__esModule=!0,f.exports.default=f.exports},function(f,e){f.exports=function(f){if("undefined"!=typeof Symbol&&null!=f[Symbol.iterator]||null!=f["@@iterator"])return Array.from(f)},f.exports.__esModule=!0,f.exports.default=f.exports},function(f,e){f.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")},f.exports.__esModule=!0,f.exports.default=f.exports},function(f,e,n){var a=n(6),d=n(37);"string"==typeof(d=d.__esModule?d.default:d)&&(d=[[f.i,d,""]]);var t={insert:"head",singleton:!1};a(d,t);f.exports=d.locals||{}},function(f,e,n){(e=n(7)(!1)).push([f.i,".emoji-picker-react img.emoji-img {\n  height: 25px;\n  width: 25px;\n  margin: 5px;\n}\n\n.emoji-picker-react .native {\n  height: 25px;\n  width: 25px;\n  margin: 5px;\n  font-size: 25px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-family: 'Noto Color Emoji', 'Apple Color Emoji', 'Segoe UI Emoji', Times,\n    Symbola, Aegyptus, Code2000, Code2001, Code2002, Musica, serif, LastResort;\n}\n",""]),f.exports=e},function(f,e,n){var a=n(6),d=n(39);"string"==typeof(d=d.__esModule?d.default:d)&&(d=[[f.i,d,""]]);var t={insert:"head",singleton:!1};a(d,t);f.exports=d.locals||{}},function(f,e,n){(e=n(7)(!1)).push([f.i,".emoji-picker-react .emoji {\n  position: relative;\n}\n\n.emoji-picker-react .emoji.has-skin-variation button:before {\n  content: '';\n  display: block;\n  width: 0;\n  height: 0;\n  right: -2px;\n  bottom: 0px;\n  position: absolute;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-bottom: 4px solid rgba(0, 0, 0, 0.1);\n  transform: rotate(135deg);\n  z-index: 1;\n}\n\n.emoji-picker-react .emoji.has-skin-variation button:hover:before,\n.emoji-picker-react .emoji.has-skin-variation button:focus-visible:before {\n  border-bottom: 4px solid rgba(0, 0, 0, 0.4);\n}\n\n.emoji-picker-react .emoji button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: inherit;\n  border-radius: 5px;\n  transition: 0.1s background;\n  padding: 0;\n  margin: 0;\n}\n\n.emoji-picker-react .emoji button:hover,\n.emoji-picker-react .emoji button:focus-visible,\n.emoji-picker-react .emoji button:focus {\n  background-color: currentColor;\n}\n",""]),f.exports=e},function(f,e,n){var a=n(6),d=n(41);"string"==typeof(d=d.__esModule?d.default:d)&&(d=[[f.i,d,""]]);var t={insert:"head",singleton:!1};a(d,t);f.exports=d.locals||{}},function(f,e,n){(e=n(7)(!1)).push([f.i,".emoji-picker-react .emoji-group {\n  clear: both;\n  padding: 0 15px;\n  list-style: none;\n  margin: 0;\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n}\n\n.emoji-picker-react .emoji-group:before {\n  content: attr(data-display-name);\n  color: #aaa;\n  font-size: 14px;\n  position: sticky;\n  background: rgba(255, 255, 255, 0.95);\n  width: 100%;\n  z-index: 1;\n  top: 0;\n  text-transform: uppercase;\n  line-height: 45px;\n  font-weight: 700;\n}\n\n.emoji-picker-react .emoji-group:after {\n  content: '';\n  flex: 1000;\n  order: 99999;\n  flex-basis: 25px;\n}\n",""]),f.exports=e},function(f,e,n){var a=n(6),d=n(43);"string"==typeof(d=d.__esModule?d.default:d)&&(d=[[f.i,d,""]]);var t={insert:"head",singleton:!1};a(d,t);f.exports=d.locals||{}},function(f,e,n){(e=n(7)(!1)).push([f.i,".emoji-picker-react div.skin-tones-list {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n  position: absolute;\n  top: 13px;\n  right: 40px;\n}\n\n.emoji-picker-react div.skin-tones-list button {\n  background-color: currentColor;\n  position: absolute;\n  border-radius: 2px;\n  transition: transform 0.3s ease;\n}\n.emoji-picker-react div.skin-tones-list button:focus {\n  border: 1px solid #a6a6a6;\n  border-radius: 3px;\n  height: 14px;\n  width: 14px;\n  top: -2px;\n  left: -2px;\n}\n\n.emoji-picker-react div.skin-tones-list button {\n  height: 10px;\n  width: 10px;\n  padding: 0;\n  display: block;\n}\n\n.emoji-picker-react div.skin-tones-list button:focus {\n  padding: 2px;\n}\n\n.emoji-picker-react div.skin-tones-list button#tneutral {\n  color: #ffd225;\n}\n.emoji-picker-react div.skin-tones-list button#t1f3fb {\n  color: #ffdfbd;\n}\n.emoji-picker-react div.skin-tones-list button#t1f3fc {\n  color: #e9c197;\n}\n.emoji-picker-react div.skin-tones-list button#t1f3fd {\n  color: #c88e62;\n}\n.emoji-picker-react div.skin-tones-list button#t1f3fe {\n  color: #a86637;\n}\n.emoji-picker-react div.skin-tones-list button#t1f3ff {\n  color: #60463a;\n}\n",""]),f.exports=e},function(f,e,n){var a=n(6),d=n(45);"string"==typeof(d=d.__esModule?d.default:d)&&(d=[[f.i,d,""]]);var t={insert:"head",singleton:!1};a(d,t);f.exports=d.locals||{}},function(f,e,n){(e=n(7)(!1)).push([f.i,".emoji-picker-react input.emoji-search {\n  width: calc(100% - 30px);\n  margin-left: 15px;\n  outline: none;\n  box-shadow: none;\n  padding: 10px;\n  box-sizing: border-box;\n  border: 1px solid #efefef;\n  border-radius: 3px;\n  transition: border 0.1s;\n}\n\n.emoji-picker-react input.emoji-search:focus {\n  border: 1px solid #d6d6d6;\n}\n",""]),f.exports=e},function(f,e,n){var a=n(6),d=n(47);"string"==typeof(d=d.__esModule?d.default:d)&&(d=[[f.i,d,""]]);var t={insert:"head",singleton:!1};a(d,t);f.exports=d.locals||{}},function(f,e,n){(e=n(7)(!1)).push([f.i,".emoji-picker-react .variation-wrapper {\n  position: relative;\n}\n\n.emoji-picker-react .variation-list {\n  background: #f4f4f4;\n  border-bottom: 1px solid #efefef;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 10;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  justify-content: space-evenly;\n  list-style-type: none;\n  transition: transform 0.1s;\n  transform: translateY(-100%);\n}\n\n.emoji-picker-react .variation-list.visible {\n  transform: translateY(0);\n}\n\n.emoji-picker-react .variation-list button {\n  display: flex;\n}\n\n.emoji-picker-react .variation-list button {\n  border-radius: 5px;\n  transition: background 0.1s;\n  background: none;\n  padding: 0;\n}\n\n.emoji-picker-react .variation-list button:hover {\n  background-color: #dbdbdb;\n}\n",""]),f.exports=e},function(f,e,n){var a=n(6),d=n(49);"string"==typeof(d=d.__esModule?d.default:d)&&(d=[[f.i,d,""]]);var t={insert:"head",singleton:!1};a(d,t);f.exports=d.locals||{}},function(f,e,n){(e=n(7)(!1)).push([f.i,"aside.emoji-picker-react {\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  height: 320px;\n  width: 280px;\n  font-family: sans-serif;\n  border: 1px solid #efefef;\n  border-radius: 5px;\n  box-sizing: border-box;\n  box-shadow: 0 5px 10px #efefef;\n  overflow: hidden;\n  position: relative;\n}\n\naside.emoji-picker-react .content-wrapper-epr {\n  flex: 1;\n  overflow-y: hidden;\n  position: relative;\n}\n\n.emoji-picker-react .emoji-scroll-wrapper {\n  overflow-y: scroll;\n  position: relative;\n  height: 100%;\n  box-sizing: border-box;\n}\n\naside.emoji-picker-react .content-wrapper-epr:before {\n  content: attr(data-name);\n  color: #aaa;\n  font-size: 11px;\n  display: block;\n  position: absolute;\n  right: 8%;\n  z-index: 10;\n  line-height: 45px;\n  max-height: 45px;\n  overflow: hidden;\n  max-width: 100px;\n  text-overflow: ellipsis;\n  text-align: right;\n}\n\naside.emoji-picker-react button {\n  border: none;\n  cursor: pointer;\n  outline: none;\n  background: none;\n}\n",""]),f.exports=e},function(f,e,n){"use strict";n.r(e),n.d(e,"SKIN_TONE_NEUTRAL",(function(){return Nf})),n.d(e,"SKIN_TONE_LIGHT",(function(){return Af})),n.d(e,"SKIN_TONE_MEDIUM_LIGHT",(function(){return qf})),n.d(e,"SKIN_TONE_MEDIUM",(function(){return Lf})),n.d(e,"SKIN_TONE_MEDIUM_DARK",(function(){return Uf})),n.d(e,"SKIN_TONE_DARK",(function(){return Df}));var a,d=n(3),t=n.n(d),r=n(15),o=n.n(r),i=n(1),c=n.n(i),u=n(0),l=n.n(u),s=n(8),b=n.n(s),g=n(2);function m(f,e){var n=Object.keys(f);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(f);e&&(a=a.filter((function(e){return Object.getOwnPropertyDescriptor(f,e).enumerable}))),n.push.apply(n,a)}return n}var p,h=c.a.shape((a={},t()(a,g.EMOJI_PROPERTY_NAME,c.a.arrayOf(c.a.string)),t()(a,g.EMOJI_PROPERTY_UNIFIED,c.a.string),t()(a,g.EMOJI_PROPERTY_SKIN_VARIATIONS,c.a.arrayOf(c.a.string)),t()(a,g.EMOJI_PROPERTY_GROUP,c.a.string),a)),_=c.a.shape({smileys_people:c.a.string,animals_nature:c.a.string,food_drink:c.a.string,travel_places:c.a.string,activities:c.a.string,objects:c.a.string,symbols:c.a.string,flags:c.a.string,recently_used:c.a.string}),w=c.a.shape(function(f){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?m(Object(n),!0).forEach((function(e){t()(f,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(f,Object.getOwnPropertyDescriptors(n)):m(Object(n)).forEach((function(e){Object.defineProperty(f,e,Object.getOwnPropertyDescriptor(n,e))}))}return f}({},v)),v={emojiUrl:c.a.string,preload:c.a.bool,skinTone:c.a.string,groupNames:_,native:c.a.bool,groupVisibility:c.a.objectOf(c.a.bool),disableAutoFocus:c.a.bool,disableSearchBar:c.a.bool,disableSkinTonePicker:c.a.bool,searchPlaceholder:c.a.string},y={customGroups:c.a.arrayOf(c.a.shape({name:c.a.string,icon:c.a.string,emojis:{name:c.a.string,url:c.a.string}}))},k=n(10),j=(p={},t()(p,g.GROUP_NAME_PEOPLE,"smileys & people"),t()(p,g.GROUP_NAME_NATURE,"animals & nature"),t()(p,g.GROUP_NAME_FOOD,"food & drink"),t()(p,g.GROUP_NAME_TRAVEL,"travel & places"),t()(p,g.GROUP_NAME_OBJECTS,g.GROUP_NAME_OBJECTS),t()(p,g.GROUP_NAME_ACTIVITIES,g.GROUP_NAME_ACTIVITIES),t()(p,g.GROUP_NAME_SYMBOLS,g.GROUP_NAME_SYMBOLS),t()(p,g.GROUP_NAME_FLAGS,g.GROUP_NAME_FLAGS),t()(p,g.GROUP_NAME_RECENTLY_USED,"Recently Used"),p),x=n(4),O=n.n(x);function E(f,e){var n=Object.keys(f);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(f);e&&(a=a.filter((function(e){return Object.getOwnPropertyDescriptor(f,e).enumerable}))),n.push.apply(n,a)}return n}function S(f){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?E(Object(n),!0).forEach((function(e){t()(f,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(f,Object.getOwnPropertyDescriptors(n)):E(Object(n)).forEach((function(e){Object.defineProperty(f,e,Object.getOwnPropertyDescriptor(n,e))}))}return f}var M=Object(u.createContext)({});function R(f){var e=f.children,n=f.config,a=f.onEmojiClick,d=Object(u.useState)(null),r=Object(u.useState)([]),o=Object(u.useState)(null),i=Object(u.useState)(t()({},g.GROUP_NAME_PEOPLE,!0)),c=Object(u.useState)({}),l=Object(u.useState)(null),s=Object(u.useState)(!1),b=Object(u.useState)(n.skinTone);return u.createElement(M.Provider,{value:{activeCategoryState:d,filterState:r,filterResult:o,seenGroupsState:i,missingEmojiState:c,variationMenuState:l,skinToneSpreadState:s,activeSkinToneState:b,config:n,onEmojiClick:a}},e)}function P(){return O()(Object(u.useContext)(M).activeCategoryState,1)[0]}function z(){var f=O()(Object(u.useContext)(M).activeCategoryState,2)[1],e=I();return function(n){f(n),e(n)}}function C(){return O()(Object(u.useContext)(M).filterState,1)[0]}function T(){return O()(Object(u.useContext)(M).filterResult,1)[0]}function I(){var f=O()(Object(u.useContext)(M).seenGroupsState,2)[1];return function(e){f((function(){var f=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return f[e]?f:S(S({},f),{},t()({},e,!0))}))}}function N(){return O()(Object(u.useContext)(M).missingEmojiState,1)[0]}function A(){return O()(Object(u.useContext)(M).variationMenuState,1)[0]}function q(){var f=O()(Object(u.useContext)(M).variationMenuState,2)[1];return function(){f((function(f){if(f)return null}))}}function L(){return O()(Object(u.useContext)(M).skinToneSpreadState,1)[0]}function U(){var f=O()(Object(u.useContext)(M).skinToneSpreadState,2),e=f[0],n=f[1];return function(){e&&n(!1)}}function D(){return O()(Object(u.useContext)(M).activeSkinToneState,1)[0]}function V(){return Object(u.useContext)(M).config}function Y(){return Object(u.useContext)(M).onEmojiClick}R.propTypes={children:c.a.node},R.propTypes={children:c.a.node,config:w,onEmojiClick:c.a.func};n(22);function G(f,e){var n=Object.keys(f);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(f);e&&(a=a.filter((function(e){return Object.getOwnPropertyDescriptor(f,e).enumerable}))),n.push.apply(n,a)}return n}function J(f){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?G(Object(n),!0).forEach((function(e){t()(f,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(f,Object.getOwnPropertyDescriptors(n)):G(Object(n)).forEach((function(e){Object.defineProperty(f,e,Object.getOwnPropertyDescriptor(n,e))}))}return f}var F=function(f){var e=f.emojiListRef,n=f.categoriesNavRef,a=f.customGroups,d=I(),t=C(),r=V().groupVisibility,o=P(),i=z(),c=!1;t&&t.length&&(c=!0);var u,s=0,g=0,m="0";return n&&n.current&&((u=n.current.querySelector("[".concat("data-name",'="').concat(o,'"]')))?(s=u&&u.offsetLeft||n.current.firstChild.offsetLeft,m="1"):(s=n.current.firstChild.offsetLeft,m="0")),l.a.createElement(l.a.Fragment,null,l.a.createElement("nav",{onClick:function(f){var n=f.target;if(!c){var a=n.getAttribute("data-name");if(e&&e.current&&a){i(a),d(a);var t=e.current,r=t.querySelector("[".concat("data-name",'="').concat(a,'"]'));t.scrollTop=r.offsetTop}}},className:b()("emoji-categories",{inactive:c}),ref:n},k.map((function(f,e){if(!1===r[f])return null;var n=o===f;return n&&(g=e),l.a.createElement("button",{key:f,type:"button",className:b()("icn-".concat(f),{active:n}),"data-name":f,"aria-label":f.replace("_","/")})})),Array.isArray(a)&&a.length?a.map((function(f,e){if(!1===r[f.name])return null;var n=o===f.name;n&&(g=e);var a=f.name.replace(" ","-").toLowerCase();return l.a.createElement("button",{key:a,type:"button",className:b()("icn-".concat(a),{active:n}),style:{backgroundImage:"url(".concat(f.icon,")")},"data-name":a})})):null),l.a.createElement("div",{className:"active-category-indicator-wrapper"},l.a.createElement("div",{className:"active-category-indicator",style:J({transform:"translateX(".concat(Math.max(s+g/2,s),"px)"),opacity:m},c&&{display:"none",opacity:"0",transform:"translateX(0)"})})))},B=F;F.propTypes=J({emojiListRef:c.a.shape({current:c.a.instanceOf(Element)}),categoriesNavRef:c.a.shape({current:c.a.instanceOf(Element)})},y);var K,H=n(9),W=n.n(H),X=n(11),$=function(f){var e={groups:{},emojis:{}},n=function(n){f[n].reduce((function(f,e){var a=e[g.EMOJI_PROPERTY_UNIFIED];return e[g.EMOJI_PROPERTY_GROUP]=n,f.emojis[a]=e,f.groups[n]=f.groups[n]||[],f.groups[n].push(a),f}),e)};for(var a in f)n(a);return e}(X),Q=n(5),Z=n.n(Q);try{K=window}catch(f){K={}}var ff=K,ef=function(f,e,n,a){var d=Object(u.useRef)(null),t=z(),r=I();Object(u.useEffect)((function(){var o=e.current;if(void 0===ff.IntersectionObserver||!f.current||n.current||a||(d.current=new IntersectionObserver((function(f){f.forEach((function(f){var e=f.target.getAttribute("data-name");0!==f.intersectionRatio&&(r(e),o||t(e))}))}),{root:f.current.parentElement})),d.current)return Z()(f.current.querySelectorAll(".emoji-group")).forEach((function(f){d.current.observe(f,{threshold:1})})),function(){d.current.disconnect()}}),[f.current,a])},nf=function(f,e){var n=Object(u.useRef)();return Object(u.useEffect)((function(){e&&e.current&&(e.current.scrollTop=0),n.current=f}),[f]),n.current},af=function(){var f=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",e=arguments.length>1?arguments[1]:void 0,n=".content-wrapper-epr",a=e&&e.current?e.current.closest("".concat(n)):document.querySelector(".emoji-picker-react ".concat(n));a.setAttribute("data-name",f)},df=function(f){var e=V();return f?"".concat(e.emojiUrl,"/").concat(f,".png"):e.emojiUrl},tf=function(f){return{src:df(f)}},rf=(n(36),function(f){var e=f.unified,n=f.shouldLoad,a=void 0===n||n,d=f.native;return void 0!==d&&d?l.a.createElement("div",{className:"native"},e.split("-").map((function(f){return parseInt(f,16)})).map((function(f){return String.fromCodePoint(f)})).join("")):l.a.createElement(of,{shouldLoad:a,unified:e})});function of(f){var e=f.unified,n=f.shouldLoad,a=function(){var f=O()(Object(u.useContext)(M).missingEmojiState,2)[1];return function(e){f((function(f){return S(S({},f),{},t()({},e,!0))}))}}(),d=tf(e);return l.a.createElement("img",W()({className:"emoji-img",onError:function(){return a(e)}},n&&d))}var cf=rf;of.propTypes={unified:c.a.string,shouldLoad:c.a.bool},rf.propTypes={unified:c.a.string,shouldLoad:c.a.bool,native:c.a.bool};n(38);function uf(f,e){var n=Object.keys(f);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(f);e&&(a=a.filter((function(e){return Object.getOwnPropertyDescriptor(f,e).enumerable}))),n.push.apply(n,a)}return n}function lf(f){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?uf(Object(n),!0).forEach((function(e){t()(f,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(f,Object.getOwnPropertyDescriptors(n)):uf(Object(n)).forEach((function(e){Object.defineProperty(f,e,Object.getOwnPropertyDescriptor(n,e))}))}return f}var sf=["#aeeff0","#ffe0e0","#d6f8b8","#c6cfff","#f1f0d1"],bf=null,gf=function(){return clearTimeout(bf)},mf=function(f){var e,n,a=f.emoji,d=f.shouldLoad,t=f.hidden,r=f.activeSkinTone,o=f.openVariationMenu,i=f.variationMenuOpenRef,c=f.handleMouseEnter,u=f.handleMouseLeave,s=f.onEmojiClick,m=f.index,p=f.native,h=void 0!==p&&p,_=a[g.EMOJI_PROPERTY_SKIN_VARIATIONS],w=lf(lf({},t&&{display:"none"}),{},{color:(n=m,sf[n%sf.length])});_&&a[g.EMOJI_PROPERTY_SKIN_VARIATIONS]&&(e=a[g.EMOJI_PROPERTY_SKIN_VARIATIONS].find((function(f){return f.indexOf(r)>=0}))),e||(e=a[g.EMOJI_PROPERTY_UNIFIED]);return l.a.createElement("li",{style:w,className:b()("emoji",{"has-skin-variation":_&&o})},l.a.createElement("button",{onMouseDown:function(){_&&o&&(bf=setTimeout((function(){o(a)}),500))},onMouseEnter:c,onMouseLeave:u,onMouseUp:gf,type:"button",onClick:function(f){i&&i.current||s(f,e,a,r)},"aria-label":a.n[0]},l.a.createElement(cf,{unified:e,shouldLoad:d,native:h})))},pf=mf;mf.propTypes={emoji:h,shouldLoad:c.a.bool,hidden:c.a.bool,activeSkinTone:c.a.string,openVariationMenu:c.a.func,variationMenuOpenRef:c.a.shape({current:c.a.bool}),handleMouseEnter:c.a.func,handleMouseLeave:c.a.func,onEmojiClick:c.a.func,index:c.a.number,native:c.a.bool};n(40);function hf(f,e){var n=Object.keys(f);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(f);e&&(a=a.filter((function(e){return Object.getOwnPropertyDescriptor(f,e).enumerable}))),n.push.apply(n,a)}return n}var _f=function(f,e){var n,a=e.emojiListRef,d=T(),t=N(),r=(n=O()(Object(u.useContext)(M).variationMenuState,2)[1],function(f){n((function(e){return e===f?e:f}))}),o=A(),i=D(),c=Y(),s=V(),b=O()(Object(u.useContext)(M).seenGroupsState,1)[0],m=Object(u.useRef)(!!o),p=Object(u.useCallback)((function(){return af("",a)}));Object(u.useEffect)((function(){m.current=!!o}),[o]);var h=s.preload||!(!b[f]&&!d&&"function"==typeof ff.IntersectionObserver);return Object(u.useMemo)((function(){var e=d?Object.keys(d[f]||{}):$.groups[f];return e.reduce((function(f,n,d){if(t&&t[n])return f;var o=$.emojis[n],u=!e.length;return f.shown||u||(f.shown=!0),f.list.push(l.a.createElement(pf,{emoji:o,openVariationMenu:r,activeSkinTone:i,handleMouseLeave:p,variationMenuOpenRef:m,handleMouseEnter:function(){return af(o[g.EMOJI_PROPERTY_NAME][0],a)},hidden:u,shouldLoad:h,onEmojiClick:c,index:d,key:o[g.EMOJI_PROPERTY_UNIFIED],native:s.native})),f}),{list:[],shown:!1})}),[i,d,h,t,s.native])},wf=function(f){var e=f.emojiListRef,n=P(),a=V().groupNames,d=T(),t=C(),r=Object(u.useRef)(n),o=Object(u.useRef)(d),i=Object(u.useState)(!0),c=O()(i,2),s=c[0],b=c[1],g=null!=t&&t.length?t[t.length-1].value:"";Object(u.useEffect)((function(){g||requestAnimationFrame((function(){b(!0)}))}),[g]),Object(u.useEffect)((function(){s&&requestAnimationFrame((function(){b(!1)}))}),[s]),ef(e,r,o,s),nf(d,e);var m={emojiListRef:e,searchTerm:g,groupNames:a};return l.a.createElement(l.a.Fragment,null,l.a.createElement(vf,W()({name:k[0]},m)),!s&&k.slice(1).map((function(f){return l.a.createElement(vf,W()({key:f,name:f},m))})))},vf=l.a.memo((function(f){var e=f.name,n=f.emojiListRef,a=f.groupNames;if(!1===V().groupVisibility[e])return null;var d=_f(e,{emojiListRef:n}),r=d.list,o=function(f){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?hf(Object(n),!0).forEach((function(e){t()(f,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(f,Object.getOwnPropertyDescriptors(n)):hf(Object(n)).forEach((function(e){Object.defineProperty(f,e,Object.getOwnPropertyDescriptor(n,e))}))}return f}({},!d.shown&&{display:"none"});return l.a.createElement("ul",{className:"emoji-group","data-name":e,"data-display-name":a[e],"aria-label":a[e],key:e,style:o},r)})),yf=wf;function kf(f,e){var n=Object.keys(f);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(f);e&&(a=a.filter((function(e){return Object.getOwnPropertyDescriptor(f,e).enumerable}))),n.push.apply(n,a)}return n}function jf(f){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?kf(Object(n),!0).forEach((function(e){t()(f,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(f,Object.getOwnPropertyDescriptors(n)):kf(Object(n)).forEach((function(e){Object.defineProperty(f,e,Object.getOwnPropertyDescriptor(n,e))}))}return f}wf.propTypes={emojiListRef:c.a.shape({current:c.a.instanceOf(Element)}),unsetEmojiName:c.a.func},vf.propTypes={name:c.a.string,searchTerm:c.a.string,emojiListRef:c.a.shape({current:c.a.instanceOf(Element)}),groupNames:_};var xf=function(){try{if(!ff.localStorage)return[];var f=ff.localStorage.getItem("epr_ru");return f?JSON.parse(f):[]}catch(f){return[]}},Of=function(f){var e=f.unified,n=f.originalUnified;try{if(!ff.localStorage)return;var a=e.split("-"),d="";e!==n&&a.length>1&&(d=a[1]);var r=[jf(t()({},g.EMOJI_PROPERTY_UNIFIED,n),d&&t()({},g.EMOJI_PROPERTY_SKIN_VARIATIONS,d))].concat(Z()(xf().filter((function(f){return f[g.EMOJI_PROPERTY_UNIFIED]!==n})))).splice(0,14);ff.localStorage.setItem("epr_ru",JSON.stringify(r))}catch(f){return}},Ef=function(f){var e=f.emojiListRef,n=T(),a=N(),d=Y(),t=V(),r=xf(),o=Object(u.useCallback)((function(){return af("",e)}));return!r.length||n||!1===t.groupVisibility[g.GROUP_NAME_RECENTLY_USED]?null:l.a.createElement("ul",{className:"emoji-group","data-display-name":t.groupNames[g.GROUP_NAME_RECENTLY_USED],"aria-label":t.groupNames[g.GROUP_NAME_RECENTLY_USED],"data-name":g.GROUP_NAME_RECENTLY_USED},r.map((function(f,n){var r=f[g.EMOJI_PROPERTY_UNIFIED],i=$.emojis[r];return a[r]||!i?null:l.a.createElement(pf,W()({key:n,emoji:i},f[g.EMOJI_PROPERTY_SKIN_VARIATIONS]&&{activeSkinTone:f[g.EMOJI_PROPERTY_SKIN_VARIATIONS]},{index:n,native:t.native,handleMouseLeave:o,onEmojiClick:d,handleMouseEnter:function(){return af(i[g.EMOJI_PROPERTY_NAME][0],e)},shouldLoad:!0}))})))},Sf=Ef;Ef.propTypes={unsetEmojiName:c.a.func,emojiListRef:c.a.shape({current:c.a.instanceOf(Element)})};var Mf=function(f,e,n){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:100,d=n;return new Promise((function(n){var t=0;!function r(){for(var o=t;o<t+a&&o<f.length;o++)d=e(d,f[o],o,f);if(!((t+=a)<f.length))return n(d);setTimeout((function(){r()}))}()}))},Rf=Array.prototype.concat.apply([],Object.values(X)),Pf=Mf(Rf,(function(f,e){return e?e[g.EMOJI_PROPERTY_NAME].reduce((function(f,e){return[].concat(Z()(f),Z()((e||"").split(/[- _]/))).filter(Boolean)}),[]).reduce((function(f,n){var a=n.toLowerCase();return f[a]=f[a]||new Set,f[a].add(e[g.EMOJI_PROPERTY_UNIFIED]),f}),f):f}),{}).then((function(f){return Mf(Object.keys(f),(function(f,e){return e?(e.split("").filter(Boolean)||[]).reduce((function(f,n){return f[n]=f[n]||[],f[n].includes(e)||f[n].push(e),f}),f):f}),{}).then((function(e){return{searchTerms:f,mappedSearchTerms:e}}))})),zf={},Cf={};Pf.then((function(f){zf=f.searchTerms,Cf=f.mappedSearchTerms}));var Tf=function(){var f,e,n=C(),a=(f=O()(Object(u.useContext)(M).filterState,2)[1],e=O()(Object(u.useContext)(M).filterResult,2)[1],function(n){var a=n.filter,d=n.filterResult;f(a),e(d)});return function(f){var e,d=f.target.value,t=n[n.length-1];if(d=d.trim().toLowerCase(),!t||t.value!==d){if(1===d.length)e=[{value:d,terms:Cf[d]||[]}];else if(t&&d.length>t.value.length&&d.includes(t.value))e=[].concat(Z()(n),[{value:d,terms:t.terms.filter((function(f){return f.includes(d)}))}]);else if(t&&d.length<t.value.length&&t.value.includes(d)){for(var r=0,o=n.length;o>0;o--)if(d.includes(n[o-1].value)){r=o;break}n.length=r,e=Z()(n)}else 0!==n.length&&d.includes(t.value)||(e=[{value:d,terms:(Cf[d[0]]||[]).filter((function(f){return f.includes(d)}))}]);var i=e&&e[e.length-1];!(!i||!i.value)?Mf(i&&i.terms||[],(function(f,e){return zf[e]?Z()(zf[e]||[]).reduce((function(f,e){var n=$.emojis[e][g.EMOJI_PROPERTY_GROUP];return f[n]=f[n]||{},f[n][e]=!0,f}),f):f}),{}).then((function(f){a({filter:e,filterResult:f})})):a({filter:e,filterResult:null})}}},If=n(12),Nf="neutral",Af="1f3fb",qf="1f3fc",Lf="1f3fe",Uf="1f3ff",Df="1f3fd",Vf=(n(42),function(f){var e,n=f.skinToneSpreadRef,a=L(),d=function(){var f=O()(Object(u.useContext)(M).activeSkinToneState,2)[1];return function(e){f(e)}}(),t=D(),r=U(),o=(e=O()(Object(u.useContext)(M).skinToneSpreadState,2)[1],function(){return e(!0)});return Object(u.useEffect)((function(){r()}),[t]),l.a.createElement("div",{className:"skin-tones-list",ref:n},If.map((function(f,e){var n=f===t;return l.a.createElement("button",{key:f,id:"t".concat(f),tabIndex:e+1,style:{transform:"translateX(-".concat(a?20*e:0,"px) scale(").concat(n?"1.5":1,")"),zIndex:n?2:1},"aria-label":"Choose skin tone ".concat(e+1),"aria-pressed":t===f,onClick:function(){a?d(f):o()}})})))}),Yf=Vf;Vf.propTypes={skinToneSpreadRef:c.a.shape({current:c.a.instanceOf(Element)})};n(44);function Gf(f){var e=f.searchPlaceholder,n=void 0===e?null:e,a=f.emojiSearchRef,d=f.skinToneSpreadRef,t=V(),r=Tf();return t.disableSearchBar?null:l.a.createElement("div",{style:{position:"relative"}},l.a.createElement("input",{placeholder:n,className:"emoji-search",onChange:r,autoFocus:!t.disableAutoFocus,ref:a,"aria-label":"Type to search for emoji"}),t.disableSkinTonePicker?null:l.a.createElement(Yf,{skinToneSpreadRef:d}))}var Jf=Gf;Gf.propTypes={searchPlaceholder:c.a.string,emojiSearchRef:c.a.shape({current:c.a.instanceOf(Element)}),skinToneSpreadRef:c.a.shape({current:c.a.instanceOf(Element)})};n(46);var Ff=function(){var f=Object(u.useState)(!1),e=O()(f,2),n=e[0],a=e[1],d=q(),t=A(),r=D(),o=Y(),i=V();if(Object(u.useEffect)((function(){return t&&!n&&a(!0),function(){a(!1)}}),[t]),!t)return null;var c=b()("variation-list",{visible:n});return l.a.createElement("div",{className:"variations-wrapper"},l.a.createElement("ul",{className:c},If.map((function(f){var e=t[g.EMOJI_PROPERTY_SKIN_VARIATIONS].find((function(e){return e.includes(f)}))||t[g.EMOJI_PROPERTY_UNIFIED];return l.a.createElement("li",{key:e},l.a.createElement("button",{onClick:function(f){return d(f),o(f,e,t,r)},onMouseDown:function(f){return f.stopPropagation()}},l.a.createElement(cf,{native:i.native,unified:e})))}))))},Bf=Ff;Ff.propTypes={closeVariations:c.a.func};var Kf=["Shift","Meta","Alt","Control"],Hf="object"==typeof navigator&&/Mac|iPod|iPhone|iPad/.test(navigator.platform)?"Meta":"Control";function Wf(f,e){return"function"==typeof f.getModifierState&&f.getModifierState(e)}function Xf(f){return f.trim().split(" ").map((function(f){var e=f.split(/\b\+/),n=e.pop();return[e=e.map((function(f){return"$mod"===f?Hf:f})),n]}))}function $f(f,e){var n;void 0===e&&(e={});var a=null!=(n=e.timeout)?n:1e3,d=Object.keys(f).map((function(e){return[Xf(e),f[e]]})),t=new Map,r=null;return function(f){f instanceof KeyboardEvent&&(d.forEach((function(e){var n=e[0],a=e[1],d=t.get(n)||n;!function(f,e){return!(e[1].toUpperCase()!==f.key.toUpperCase()&&e[1]!==f.code||e[0].find((function(e){return!Wf(f,e)}))||Kf.find((function(n){return!e[0].includes(n)&&e[1]!==n&&Wf(f,n)})))}(f,d[0])?Wf(f,f.key)||t.delete(n):d.length>1?t.set(n,d.slice(1)):(t.delete(n),a(f))})),r&&clearTimeout(r),r=setTimeout(t.clear.bind(t),a))}}var Qf=function(f,e,n){var a;void 0===n&&(n={});var d=null!=(a=n.event)?a:"keydown",t=$f(e,n);return f.addEventListener(d,t),function(){f.removeEventListener(d,t)}},Zf=function(f){return function(){try{f.apply(void 0,arguments)}catch(f){}}},fe=function(){return document.activeElement},ee=function(){return fe().closest(".emoji-group")},ne=function(){return fe().closest(".emoji")},ae=Zf((function(f){f&&requestAnimationFrame((function(){return f.focus()}))})),de=function(){var f,e=null===(f=fe())||void 0===f?void 0:f.previousElementSibling;ae(e)},te=function(){var f,e=null===(f=fe())||void 0===f?void 0:f.nextElementSibling;ae(e)},re=function(f){return f.getAttribute("data-name")},oe=function(f){var e,n=f.categoriesNavRef,a=f.emojiSearchRef,d=f.emojiListRef,t=f.skinToneSpreadRef,r=z(),o=(e=O()(Object(u.useContext)(M).skinToneSpreadState,2)[1],function(){return e((function(f){return!f}))}),i=D(),c=L();function l(){w(),E()}Object(u.useEffect)((function(){return ue(n.current,{ArrowLeft:de,ArrowRight:te,ArrowDown:S,Escape:l})}),[]),Object(u.useEffect)((function(){if(a.current)return ue(a.current,{ArrowRight:j,ArrowUp:R,ArrowDown:S})}),[i]),Object(u.useEffect)((function(){if(a.current)return ue(t.current,{ArrowLeft:c?y:_,ArrowRight:v,Escape:_,Enter:_})}),[i,c]),Object(u.useEffect)((function(){return ue(d.current,{ArrowRight:ce((function(){return b("right")})),ArrowLeft:ce((function(){return b("left")})),ArrowUp:ce((function(){return b("up")})),ArrowDown:ce((function(){return b("down")})),Escape:l})}),[]);var s=function(f){ae(null==f?void 0:f.firstChild)},b=Zf((function(f){var e,n=function(){var f=ee(),e=fe().parentElement,n=Array.prototype.indexOf.call(f.children,e),a=f.children.length,d=f.children[0].offsetTop,t=Array.prototype.findIndex.call(f.children,(function(f){return f.offsetTop>d})),r=-1===t?a:t;return{activeIndex:n,itemsPerRow:r,numOfItems:a,currentColumn:n%r,gridChildren:f.children}}(),a=n.activeIndex,d=n.itemsPerRow,t=n.numOfItems,r=n.currentColumn,o=n.gridChildren,i=function(f){var e=f.activeIndex,n=f.itemsPerRow,a=f.numOfItems;return{isTopRow:e<=n-1,isBottomRow:e>=a-n,isLeftColumn:e%n==0,isRightColumn:e%n==n-1||e===a-1,isLastRow:e>=a-a%n||a%n==0}}({activeIndex:a,itemsPerRow:d,numOfItems:t}),c=i.isTopRow,u=i.isBottomRow,l=i.isLastRow,b=i.isLeftColumn,g=i.isRightColumn;switch(f){case"up":c&&!h(r,d)?R():s(o[a-d]);break;case"down":u?l?m(r):s(o[t-1]):s(o[a+d]);break;case"left":var _=(e=ne().previousElementSibling)?e.firstChild:null;b?_?ae(_):p():ae(_);break;case"right":var w=function(){var f=ne().nextElementSibling;return f?f.firstChild:null}();g?w?ae(w):m():ae(w)}})),g=[];Object(u.useEffect)((function(){g=[{focus:function(){return ae(n.current.firstChild)},rootElement:n},a.current&&{focus:function(){return ae(a.current)},rootElement:a},{focus:function(){var f=d.current.querySelector(".emoji");ae(null==f?void 0:f.firstChild)},rootElement:d}].filter(Boolean)}),[i,c]);var m=function(){var f=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=ee(),n=e.nextSibling;if(n){ae(n.children[f].firstChild);var a=re(n);r(a)}},p=function(){var f,e=ee().previousSibling;return ae(null==e||null===(f=e.lastChild)||void 0===f?void 0:f.firstChild),e},h=function(f,e){var n=ee().previousSibling;if(n){for(var a,d=n.children.length,t=d-1;t>=0;t--)if(t%e===f){a=t;break}a>=d-d%e||d%e==0||(a=d-1),ae(n.children[a].firstChild);var o=re(n);r(o)}return n},_=Zf((function(){w()})),w=Zf((function(){a.current&&ae(a.current)})),v=function(){var f=fe();if(f){var e=f.previousSibling;ae(e)}},y=function(){var f=fe();if(f){var e=f.nextSibling;ae(e)}},k=function(){return t.current.querySelector("#t".concat(i))},j=Zf((function(){t.current&&(o(),ae(k()))})),x=function(){var f=fe();return g.findIndex((function(e){return e.rootElement.current.contains(f)}))},E=Zf((function(){requestAnimationFrame((function(){d.current.scrollTop=0}))})),S=ce(Zf((function(){var f=x();f<g.length&&(ae(g[f+=1]),E())}))),R=Zf((function(){var f=x();0!==f&&(ae(g[f-=1]),E())}))},ie=oe;function ce(f){return function(e){return e.preventDefault(),f(e)}}function ue(){try{return Qf.apply(void 0,arguments)}catch(f){return function(){}}}oe.propTypes={categoriesNavRef:c.a.shape({current:c.a.instanceOf(Element)}),emojiSearchRef:c.a.shape({current:c.a.instanceOf(Element)}),emojiListRef:c.a.shape({current:c.a.instanceOf(Element)}),skinToneSpreadRef:c.a.shape({current:c.a.instanceOf(Element)})};var le=function(f,e,n){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};return Object.assign({unified:f,emoji:f.split("-").map((function(f){return parseInt(f,16)})).map((function(f){return String.fromCodePoint(f)})).join(""),originalUnified:e[g.EMOJI_PROPERTY_UNIFIED],names:e[g.EMOJI_PROPERTY_NAME],activeSkinTone:n},a)},se=function(){var f=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return function(e,n,a,d){var t=le(n,a,d);return Of(t),f.current&&f.current(e,t)}},be=(n(48),["emojiUrl","onEmojiClick","preload","native","skinTone","disableAutoFocus","disableSearchBar","disableSkinTonePicker","groupNames","groupVisibility"]);function ge(f,e){var n=Object.keys(f);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(f);e&&(a=a.filter((function(e){return Object.getOwnPropertyDescriptor(f,e).enumerable}))),n.push.apply(n,a)}return n}function me(f){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?ge(Object(n),!0).forEach((function(e){t()(f,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(f,Object.getOwnPropertyDescriptors(n)):ge(Object(n)).forEach((function(e){Object.defineProperty(f,e,Object.getOwnPropertyDescriptor(n,e))}))}return f}var pe=function(f){var e=f.emojiUrl,n=void 0===e?"https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64":e,a=f.onEmojiClick,d=f.preload,t=void 0!==d&&d,r=f.native,i=void 0!==r&&r,c=f.skinTone,s=void 0===c?Nf:c,b=f.disableAutoFocus,g=void 0!==b&&b,m=f.disableSearchBar,p=void 0!==m&&m,h=f.disableSkinTonePicker,_=void 0!==h&&h,w=f.groupNames,v=void 0===w?{}:w,y=f.groupVisibility,k=void 0===y?{}:y,x=o()(f,be),O=Object(u.useRef)(a);return O.current=a,l.a.createElement(R,{config:{skinTone:s,emojiUrl:n,preload:t,native:i,groupNames:Object.assign(j,v),groupVisibility:k,disableSearchBar:p,disableAutoFocus:g,disableSkinTonePicker:_},onEmojiClick:se(O)},l.a.createElement(he,x))},he=function(f){var e=f.pickerStyle,n=void 0===e?{}:e,a=f.searchPlaceholder,d=void 0===a?null:a,t=Object(u.useRef)(null),r=Object(u.useRef)(null),o=Object(u.useRef)(null),i=Object(u.useRef)(null),c=Object(u.useRef)(null);return ie({categoriesNavRef:c,emojiSearchRef:o,emojiListRef:r,skinToneSpreadRef:i}),l.a.createElement(_e,{pickerStyle:n,emojiPickerAsideRef:t,skinToneSpreadRef:i},l.a.createElement(B,{emojiListRef:r,categoriesNavRef:c}),l.a.createElement(Jf,{searchPlaceholder:d,emojiSearchRef:o,skinToneSpreadRef:i}),l.a.createElement("div",{className:"content-wrapper-epr"},l.a.createElement(Bf,null),l.a.createElement("section",{className:"emoji-scroll-wrapper",ref:r},l.a.createElement(Sf,{emojiListRef:r}),l.a.createElement(yf,{emojiListRef:r}))))};function _e(f){var e=f.children,n=f.pickerStyle,a=f.emojiPickerAsideRef,d=f.skinToneSpreadRef,t=q(),r=U();return l.a.createElement("aside",{className:"emoji-picker-react",style:n,onScroll:function(){t(),r()},onMouseDown:function(f){var e;t(),null!==(e=d.current)&&void 0!==e&&e.contains(f.target)||r()},ref:a},e)}_e.propTypes={children:c.a.node,pickerStyle:c.a.object,emojiPickerAsideRef:c.a.shape({current:c.a.instanceOf(Element)}),skinToneSpreadRef:c.a.shape({current:c.a.instanceOf(Element)})},he.propTypes={pickerStyle:c.a.objectOf(c.a.string),searchPlaceholder:c.a.string};e.default=pe;pe.propTypes=me(me({onEmojiClick:c.a.func,pickerStyle:c.a.objectOf(c.a.string)},y),v)}])}));
//# sourceMappingURL=index.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pickStyles__ = __webpack_require__(141);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


// many css-in-js libs process keyframes objects as the value for `animationName`
var defaultObjectPropsWhitelist = ['animationName'];

var defaultPropsDecorator = function defaultPropsDecorator(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _objectSpread(_objectSpread({}, style ? {
    style: Object(__WEBPACK_IMPORTED_MODULE_1__pickStyles__["b" /* pickDirectStyles */])(style, defaultObjectPropsWhitelist)
  } : {}), className ? {
    className: className
  } : {});
};

/* harmony default export */ __webpack_exports__["a"] = (defaultPropsDecorator);

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return keys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return merge; });
/* unused harmony export identity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return omit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isPlainObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return compact; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);

var keys = function keys(obj) {
  return obj === Object(obj) ? Object.keys(obj) : [];
};
var values = function values(obj) {
  return obj === Object(obj) ? Object.values(obj) : [];
};

function mergeDeep(target, source) {
  var output = Object.assign({}, target);

  if (isPlainObject(target) && isPlainObject(source)) {
    keys(source).forEach(function (key) {
      if (isPlainObject(source[key])) {
        if (!(key in target)) Object.assign(output, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, key, source[key]));else output[key] = mergeDeep(target[key], source[key]);
      } else {
        Object.assign(output, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, key, source[key]));
      }
    });
  }

  return output;
}

var merge = function merge(target) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  return sources.reduce(function (t, s) {
    return mergeDeep(t, s);
  }, target);
};
var identity = function identity(value) {
  return value;
};
var omit = function omit(obj, keys) {
  var other = Object.assign({}, obj);

  if (keys) {
    for (var i = 0; i < keys.length; i++) {
      delete other[keys[i]];
    }
  }

  return other;
};
var isPlainObject = function isPlainObject(obj) {
  return obj === Object(obj) && !(obj instanceof Date) && !Array.isArray(obj);
};
var compact = function compact(arr) {
  return (arr || []).filter(Boolean);
};

/***/ }),
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(152);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(107);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(75);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(172)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(19) && !__webpack_require__(25)(function () {
  return Object.defineProperty(__webpack_require__(112)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var document = __webpack_require__(17).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(26);
var toIObject = __webpack_require__(33);
var arrayIndexOf = __webpack_require__(195)(false);
var IE_PROTO = __webpack_require__(85)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(26);
var toObject = __webpack_require__(48);
var IE_PROTO = __webpack_require__(85)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(83);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(113);
var hiddenKeys = __webpack_require__(87).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(27);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(34);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(119);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(35);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ParseACL = __webpack_require__(41);

var _ParseACL2 = _interopRequireDefault(_ParseACL);

var _ParseError = __webpack_require__(28);

var _ParseError2 = _interopRequireDefault(_ParseError);

var _ParseObject2 = __webpack_require__(8);

var _ParseObject3 = _interopRequireDefault(_ParseObject2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Represents a Role on the Parse server. Roles represent groupings of
 * Users for the purposes of granting permissions (e.g. specifying an ACL
 * for an Object). Roles are specified by their sets of child users and
 * child roles, all of which are granted any permissions that the parent
 * role has.
 *
 * <p>Roles must have a name (which cannot be changed after creation of the
 * role), and must specify an ACL.</p>
 * @alias Parse.Role
 * @extends Parse.Object
 */
var ParseRole = function (_ParseObject) {
  (0, _inherits3.default)(ParseRole, _ParseObject);

  /**
   * @param {String} name The name of the Role to create.
   * @param {Parse.ACL} acl The ACL for this role. Roles must have an ACL.
   * A Parse.Role is a local representation of a role persisted to the Parse
   * cloud.
   */
  function ParseRole(name, acl) {
    (0, _classCallCheck3.default)(this, ParseRole);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ParseRole.__proto__ || (0, _getPrototypeOf2.default)(ParseRole)).call(this, '_Role'));

    if (typeof name === 'string' && acl instanceof _ParseACL2.default) {
      _this.setName(name);
      _this.setACL(acl);
    }
    return _this;
  }

  /**
   * Gets the name of the role.  You can alternatively call role.get("name")
   *
    * @return {String} the name of the role.
   */

  (0, _createClass3.default)(ParseRole, [{
    key: 'getName',
    value: function () {
      var name = this.get('name');
      if (name == null || typeof name === 'string') {
        return name;
      }
      return '';
    }

    /**
     * Sets the name for a role. This value must be set before the role has
     * been saved to the server, and cannot be set once the role has been
     * saved.
     *
     * <p>
     *   A role's name can only contain alphanumeric characters, _, -, and
     *   spaces.
     * </p>
     *
     * <p>This is equivalent to calling role.set("name", name)</p>
     *
      * @param {String} name The name of the role.
     * @param {Object} options Standard options object with success and error
     *     callbacks.
     */

  }, {
    key: 'setName',
    value: function (name, options) {
      return this.set('name', name, options);
    }

    /**
     * Gets the Parse.Relation for the Parse.Users that are direct
     * children of this role. These users are granted any privileges that this
     * role has been granted (e.g. read or write access through ACLs). You can
     * add or remove users from the role through this relation.
     *
     * <p>This is equivalent to calling role.relation("users")</p>
     *
      * @return {Parse.Relation} the relation for the users belonging to this
     *     role.
     */

  }, {
    key: 'getUsers',
    value: function () {
      return this.relation('users');
    }

    /**
     * Gets the Parse.Relation for the Parse.Roles that are direct
     * children of this role. These roles' users are granted any privileges that
     * this role has been granted (e.g. read or write access through ACLs). You
     * can add or remove child roles from this role through this relation.
     *
     * <p>This is equivalent to calling role.relation("roles")</p>
     *
      * @return {Parse.Relation} the relation for the roles belonging to this
     *     role.
     */

  }, {
    key: 'getRoles',
    value: function () {
      return this.relation('roles');
    }
  }, {
    key: 'validate',
    value: function (attrs, options) {
      var isInvalid = (0, _get3.default)(ParseRole.prototype.__proto__ || (0, _getPrototypeOf2.default)(ParseRole.prototype), 'validate', this).call(this, attrs, options);
      if (isInvalid) {
        return isInvalid;
      }

      if ('name' in attrs && attrs.name !== this.getName()) {
        var newName = attrs.name;
        if (this.id && this.id !== attrs.objectId) {
          // Check to see if the objectId being set matches this.id
          // This happens during a fetch -- the id is set before calling fetch
          // Let the name be set in this case
          return new _ParseError2.default(_ParseError2.default.OTHER_CAUSE, 'A role\'s name can only be set before it has been saved.');
        }
        if (typeof newName !== 'string') {
          return new _ParseError2.default(_ParseError2.default.OTHER_CAUSE, 'A role\'s name must be a String.');
        }
        if (!/^[0-9a-zA-Z\-_ ]+$/.test(newName)) {
          return new _ParseError2.default(_ParseError2.default.OTHER_CAUSE, 'A role\'s name can be only contain alphanumeric characters, _, ' + '-, and spaces.');
        }
      }
      return false;
    }
  }]);
  return ParseRole;
}(_ParseObject3.default); /**
                           * Copyright (c) 2015-present, Parse, LLC.
                           * All rights reserved.
                           *
                           * This source code is licensed under the BSD-style license found in the
                           * LICENSE file in the root directory of this source tree. An additional grant
                           * of patent rights can be found in the PATENTS file in the same directory.
                           *
                           * 
                           */

_ParseObject3.default.registerSubclass('_Role', ParseRole);

exports.default = ParseRole;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(27);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(213);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(220), __esModule: true };

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(227), __esModule: true };

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(123);
var ITERATOR = __webpack_require__(15)('iterator');
var Iterators = __webpack_require__(46);
module.exports = __webpack_require__(5).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(83);
var TAG = __webpack_require__(15)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = arrayContainsObject;

var _ParseObject = __webpack_require__(8);

var _ParseObject2 = _interopRequireDefault(_ParseObject);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function arrayContainsObject(array, object) {
  if (array.indexOf(object) > -1) {
    return true;
  }
  for (var i = 0; i < array.length; i++) {
    if (array[i] instanceof _ParseObject2.default && array[i].className === object.className && array[i]._getId() === object._getId()) {
      return true;
    }
  }
  return false;
} /**
   * Copyright (c) 2015-present, Parse, LLC.
   * All rights reserved.
   *
   * This source code is licensed under the BSD-style license found in the
   * LICENSE file in the root directory of this source tree. An additional grant
   * of patent rights can be found in the PATENTS file in the same directory.
   *
   * 
   */

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = unique;

var _arrayContainsObject = __webpack_require__(124);

var _arrayContainsObject2 = _interopRequireDefault(_arrayContainsObject);

var _ParseObject = __webpack_require__(8);

var _ParseObject2 = _interopRequireDefault(_ParseObject);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function unique(arr) {
  var uniques = [];
  arr.forEach(function (value) {
    if (value instanceof _ParseObject2.default) {
      if (!(0, _arrayContainsObject2.default)(uniques, value)) {
        uniques.push(value);
      }
    } else {
      if (uniques.indexOf(value) < 0) {
        uniques.push(value);
      }
    }
  });
  return uniques;
}

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = escape;
/*
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var encoded = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '/': '&#x2F;',
  '\'': '&#x27;',
  '"': '&quot;'
};

function escape(str) {
  return str.replace(/[&<>\/'"]/g, function (char) {
    return encoded[char];
  });
}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseDate;
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function parseDate(iso8601) {
  var regexp = new RegExp('^([0-9]{1,4})-([0-9]{1,2})-([0-9]{1,2})' + 'T' + '([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})' + '(.([0-9]+))?' + 'Z$');
  var match = regexp.exec(iso8601);
  if (!match) {
    return null;
  }

  var year = match[1] || 0;
  var month = (match[2] || 1) - 1;
  var day = match[3] || 0;
  var hour = match[4] || 0;
  var minute = match[5] || 0;
  var second = match[6] || 0;
  var milli = match[8] || 0;

  return new Date(Date.UTC(year, month, day, hour, minute, second, milli));
}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(42);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.defaultState = defaultState;
exports.setServerData = setServerData;
exports.setPendingOp = setPendingOp;
exports.pushPendingState = pushPendingState;
exports.popPendingState = popPendingState;
exports.mergeFirstPendingState = mergeFirstPendingState;
exports.estimateAttribute = estimateAttribute;
exports.estimateAttributes = estimateAttributes;
exports.commitServerChanges = commitServerChanges;

var _encode = __webpack_require__(36);

var _encode2 = _interopRequireDefault(_encode);

var _ParseFile = __webpack_require__(29);

var _ParseFile2 = _interopRequireDefault(_ParseFile);

var _ParseObject = __webpack_require__(8);

var _ParseObject2 = _interopRequireDefault(_ParseObject);

var _ParsePromise = __webpack_require__(7);

var _ParsePromise2 = _interopRequireDefault(_ParsePromise);

var _ParseRelation = __webpack_require__(30);

var _ParseRelation2 = _interopRequireDefault(_ParseRelation);

var _TaskQueue = __webpack_require__(129);

var _TaskQueue2 = _interopRequireDefault(_TaskQueue);

var _ParseOp = __webpack_require__(43);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function defaultState() {
  return {
    serverData: {},
    pendingOps: [{}],
    objectCache: {},
    tasks: new _TaskQueue2.default(),
    existed: false
  };
} /**
   * Copyright (c) 2015-present, Parse, LLC.
   * All rights reserved.
   *
   * This source code is licensed under the BSD-style license found in the
   * LICENSE file in the root directory of this source tree. An additional grant
   * of patent rights can be found in the PATENTS file in the same directory.
   *
   * 
   */

function setServerData(serverData, attributes) {
  for (var _attr in attributes) {
    if (typeof attributes[_attr] !== 'undefined') {
      serverData[_attr] = attributes[_attr];
    } else {
      delete serverData[_attr];
    }
  }
}

function setPendingOp(pendingOps, attr, op) {
  var last = pendingOps.length - 1;
  if (op) {
    pendingOps[last][attr] = op;
  } else {
    delete pendingOps[last][attr];
  }
}

function pushPendingState(pendingOps) {
  pendingOps.push({});
}

function popPendingState(pendingOps) {
  var first = pendingOps.shift();
  if (!pendingOps.length) {
    pendingOps[0] = {};
  }
  return first;
}

function mergeFirstPendingState(pendingOps) {
  var first = popPendingState(pendingOps);
  var next = pendingOps[0];
  for (var _attr2 in first) {
    if (next[_attr2] && first[_attr2]) {
      var merged = next[_attr2].mergeWith(first[_attr2]);
      if (merged) {
        next[_attr2] = merged;
      }
    } else {
      next[_attr2] = first[_attr2];
    }
  }
}

function estimateAttribute(serverData, pendingOps, className, id, attr) {
  var value = serverData[attr];
  for (var i = 0; i < pendingOps.length; i++) {
    if (pendingOps[i][attr]) {
      if (pendingOps[i][attr] instanceof _ParseOp.RelationOp) {
        if (id) {
          value = pendingOps[i][attr].applyTo(value, { className: className, id: id }, attr);
        }
      } else {
        value = pendingOps[i][attr].applyTo(value);
      }
    }
  }
  return value;
}

function estimateAttributes(serverData, pendingOps, className, id) {
  var data = {};
  var attr = void 0;
  for (attr in serverData) {
    data[attr] = serverData[attr];
  }
  for (var i = 0; i < pendingOps.length; i++) {
    for (attr in pendingOps[i]) {
      if (pendingOps[i][attr] instanceof _ParseOp.RelationOp) {
        if (id) {
          data[attr] = pendingOps[i][attr].applyTo(data[attr], { className: className, id: id }, attr);
        }
      } else {
        data[attr] = pendingOps[i][attr].applyTo(data[attr]);
      }
    }
  }
  return data;
}

function commitServerChanges(serverData, objectCache, changes) {
  for (var _attr3 in changes) {
    var val = changes[_attr3];
    serverData[_attr3] = val;
    if (val && (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object' && !(val instanceof _ParseObject2.default) && !(val instanceof _ParseFile2.default) && !(val instanceof _ParseRelation2.default)) {
      var json = (0, _encode2.default)(val, false, true);
      objectCache[_attr3] = (0, _stringify2.default)(json);
    }
  }
}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _ParsePromise = __webpack_require__(7);

var _ParsePromise2 = _interopRequireDefault(_ParsePromise);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var TaskQueue = function () {
  function TaskQueue() {
    (0, _classCallCheck3.default)(this, TaskQueue);

    this.queue = [];
  }

  (0, _createClass3.default)(TaskQueue, [{
    key: 'enqueue',
    value: function (task) {
      var _this = this;

      var taskComplete = new _ParsePromise2.default();
      this.queue.push({
        task: task,
        _completion: taskComplete
      });
      if (this.queue.length === 1) {
        task().then(function () {
          _this._dequeue();
          taskComplete.resolve();
        }, function (error) {
          _this._dequeue();
          taskComplete.reject(error);
        });
      }
      return taskComplete;
    }
  }, {
    key: '_dequeue',
    value: function () {
      var _this2 = this;

      this.queue.shift();
      if (this.queue.length) {
        var next = this.queue[0];
        next.task().then(function () {
          _this2._dequeue();
          next._completion.resolve();
        }, function (error) {
          _this2._dequeue();
          next._completion.reject(error);
        });
      }
    }
  }]);
  return TaskQueue;
}(); /**
      * Copyright (c) 2015-present, Parse, LLC.
      * All rights reserved.
      *
      * This source code is licensed under the BSD-style license found in the
      * LICENSE file in the root directory of this source tree. An additional grant
      * of patent rights can be found in the PATENTS file in the same directory.
      *
      * 
      */

module.exports = TaskQueue;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var $export = __webpack_require__(16);
var meta = __webpack_require__(40);
var fails = __webpack_require__(25);
var hide = __webpack_require__(24);
var redefineAll = __webpack_require__(95);
var forOf = __webpack_require__(50);
var anInstance = __webpack_require__(96);
var isObject = __webpack_require__(14);
var setToStringTag = __webpack_require__(60);
var dP = __webpack_require__(18).f;
var each = __webpack_require__(94)(0);
var DESCRIPTORS = __webpack_require__(19);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(16);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(16);
var aFunction = __webpack_require__(110);
var ctx = __webpack_require__(39);
var forOf = __webpack_require__(50);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRevocableSession;
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function isRevocableSession(token) {
  return token.indexOf('r:') > -1;
}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = __webpack_require__(27);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(34);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(35);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CoreManager = __webpack_require__(9);

var _CoreManager2 = _interopRequireDefault(_CoreManager);

var _isRevocableSession = __webpack_require__(133);

var _isRevocableSession2 = _interopRequireDefault(_isRevocableSession);

var _ParseObject2 = __webpack_require__(8);

var _ParseObject3 = _interopRequireDefault(_ParseObject2);

var _ParsePromise = __webpack_require__(7);

var _ParsePromise2 = _interopRequireDefault(_ParsePromise);

var _ParseUser = __webpack_require__(68);

var _ParseUser2 = _interopRequireDefault(_ParseUser);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * <p>A Parse.Session object is a local representation of a revocable session.
 * This class is a subclass of a Parse.Object, and retains the same
 * functionality of a Parse.Object.</p>
 * @alias Parse.Session
 * @extends Parse.Object
 */
var ParseSession = function (_ParseObject) {
  (0, _inherits3.default)(ParseSession, _ParseObject);

  /**
   * 
   * @param {Object} attributes The initial set of data to store in the user.
   */
  function ParseSession(attributes) {
    (0, _classCallCheck3.default)(this, ParseSession);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ParseSession.__proto__ || (0, _getPrototypeOf2.default)(ParseSession)).call(this, '_Session'));

    if (attributes && (typeof attributes === 'undefined' ? 'undefined' : (0, _typeof3.default)(attributes)) === 'object') {
      if (!_this.set(attributes || {})) {
        throw new Error('Can\'t create an invalid Session');
      }
    }
    return _this;
  }

  /**
   * Returns the session token string.
    * @return {String}
   */

  (0, _createClass3.default)(ParseSession, [{
    key: 'getSessionToken',
    value: function () {
      var token = this.get('sessionToken');
      if (typeof token === 'string') {
        return token;
      }
      return '';
    }
  }], [{
    key: 'readOnlyAttributes',
    value: function () {
      return ['createdWith', 'expiresAt', 'installationId', 'restricted', 'sessionToken', 'user'];
    }

    /**
     * Retrieves the Session object for the currently logged in session.
      * @static
     * @return {Parse.Promise} A promise that is resolved with the Parse.Session
     *   object after it has been fetched. If there is no current user, the
     *   promise will be rejected.
     */

  }, {
    key: 'current',
    value: function (options) {
      options = options || {};
      var controller = _CoreManager2.default.getSessionController();

      var sessionOptions = {};
      if (options.hasOwnProperty('useMasterKey')) {
        sessionOptions.useMasterKey = options.useMasterKey;
      }
      return _ParseUser2.default.currentAsync().then(function (user) {
        if (!user) {
          return _ParsePromise2.default.error('There is no current user.');
        }
        user.getSessionToken();

        sessionOptions.sessionToken = user.getSessionToken();
        return controller.getSession(sessionOptions);
      });
    }

    /**
     * Determines whether the current session token is revocable.
     * This method is useful for migrating Express.js or Node.js web apps to
     * use revocable sessions. If you are migrating an app that uses the Parse
     * SDK in the browser only, please use Parse.User.enableRevocableSession()
     * instead, so that sessions can be automatically upgraded.
      * @static
     * @return {Boolean}
     */

  }, {
    key: 'isCurrentSessionRevocable',
    value: function () {
      var currentUser = _ParseUser2.default.current();
      if (currentUser) {
        return (0, _isRevocableSession2.default)(currentUser.getSessionToken() || '');
      }
      return false;
    }
  }]);
  return ParseSession;
}(_ParseObject3.default); /**
                           * Copyright (c) 2015-present, Parse, LLC.
                           * All rights reserved.
                           *
                           * This source code is licensed under the BSD-style license found in the
                           * LICENSE file in the root directory of this source tree. An additional grant
                           * of patent rights can be found in the PATENTS file in the same directory.
                           *
                           * 
                           */

_ParseObject3.default.registerSubclass('_Session', ParseSession);

var DefaultController = {
  getSession: function (options) {
    var RESTController = _CoreManager2.default.getRESTController();
    var session = new ParseSession();

    return RESTController.request('GET', 'sessions/me', {}, options).then(function (sessionData) {
      session._finishFetch(sessionData);
      session._setExisted(true);
      return session;
    });
  }
};

_CoreManager2.default.setSessionController(DefaultController);

exports.default = ParseSession;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getIterator2 = __webpack_require__(121);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = __webpack_require__(42);

var _stringify2 = _interopRequireDefault(_stringify);

var _map = __webpack_require__(256);

var _map2 = _interopRequireDefault(_map);

var _getPrototypeOf = __webpack_require__(27);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(34);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(35);

var _inherits3 = _interopRequireDefault(_inherits2);

var _EventEmitter2 = __webpack_require__(97);

var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);

var _ParsePromise = __webpack_require__(7);

var _ParsePromise2 = _interopRequireDefault(_ParsePromise);

var _ParseObject = __webpack_require__(8);

var _ParseObject2 = _interopRequireDefault(_ParseObject);

var _LiveQuerySubscription = __webpack_require__(266);

var _LiveQuerySubscription2 = _interopRequireDefault(_LiveQuerySubscription);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// The LiveQuery client inner state
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

var CLIENT_STATE = {
  INITIALIZED: 'initialized',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  CLOSED: 'closed',
  RECONNECTING: 'reconnecting',
  DISCONNECTED: 'disconnected'
};

// The event type the LiveQuery client should sent to server
var OP_TYPES = {
  CONNECT: 'connect',
  SUBSCRIBE: 'subscribe',
  UNSUBSCRIBE: 'unsubscribe',
  ERROR: 'error'
};

// The event we get back from LiveQuery server
var OP_EVENTS = {
  CONNECTED: 'connected',
  SUBSCRIBED: 'subscribed',
  UNSUBSCRIBED: 'unsubscribed',
  ERROR: 'error',
  CREATE: 'create',
  UPDATE: 'update',
  ENTER: 'enter',
  LEAVE: 'leave',
  DELETE: 'delete'
};

// The event the LiveQuery client should emit
var CLIENT_EMMITER_TYPES = {
  CLOSE: 'close',
  ERROR: 'error',
  OPEN: 'open'
};

// The event the LiveQuery subscription should emit
var SUBSCRIPTION_EMMITER_TYPES = {
  OPEN: 'open',
  CLOSE: 'close',
  ERROR: 'error',
  CREATE: 'create',
  UPDATE: 'update',
  ENTER: 'enter',
  LEAVE: 'leave',
  DELETE: 'delete'
};

var generateInterval = function (k) {
  return Math.random() * Math.min(30, Math.pow(2, k) - 1) * 1000;
};

/**
 * Creates a new LiveQueryClient.
 * Extends events.EventEmitter
 * <a href="https://nodejs.org/api/events.html#events_class_eventemitter">cloud functions</a>.
 * 
 * A wrapper of a standard WebSocket client. We add several useful methods to 
 * help you connect/disconnect to LiveQueryServer, subscribe/unsubscribe a ParseQuery easily.
 *
 * javascriptKey and masterKey are used for verifying the LiveQueryClient when it tries
 * to connect to the LiveQuery server
 *
 * We expose three events to help you monitor the status of the LiveQueryClient.
 *
 * <pre>
 * let Parse = require('parse/node');
 * let LiveQueryClient = Parse.LiveQueryClient;
 * let client = new LiveQueryClient({
 *   applicationId: '',
 *   serverURL: '',
 *   javascriptKey: '',
 *   masterKey: ''
 *  });
 * </pre>
 * 
 * Open - When we establish the WebSocket connection to the LiveQuery server, you'll get this event.
 * <pre>
 * client.on('open', () => {
 * 
 * });</pre>
 *
 * Close - When we lose the WebSocket connection to the LiveQuery server, you'll get this event.
 * <pre>
 * client.on('close', () => {
 * 
 * });</pre>
 *
 * Error - When some network error or LiveQuery server error happens, you'll get this event.
 * <pre>
 * client.on('error', (error) => {
 * 
 * });</pre>
 * @alias Parse.LiveQueryClient
 */

var LiveQueryClient = function (_EventEmitter) {
  (0, _inherits3.default)(LiveQueryClient, _EventEmitter);

  /**
   * @param {Object} options
   * @param {string} options.applicationId - applicationId of your Parse app
   * @param {string} options.serverURL - <b>the URL of your LiveQuery server</b>
   * @param {string} options.javascriptKey (optional)
   * @param {string} options.masterKey (optional) Your Parse Master Key. (Node.js only!)
   * @param {string} options.sessionToken (optional)
   */
  function LiveQueryClient(_ref) {
    var applicationId = _ref.applicationId,
        serverURL = _ref.serverURL,
        javascriptKey = _ref.javascriptKey,
        masterKey = _ref.masterKey,
        sessionToken = _ref.sessionToken;
    (0, _classCallCheck3.default)(this, LiveQueryClient);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LiveQueryClient.__proto__ || (0, _getPrototypeOf2.default)(LiveQueryClient)).call(this));

    if (!serverURL || serverURL.indexOf('ws') !== 0) {
      throw new Error('You need to set a proper Parse LiveQuery server url before using LiveQueryClient');
    }

    _this.reconnectHandle = null;
    _this.attempts = 1;
    _this.id = 0;
    _this.requestId = 1;
    _this.serverURL = serverURL;
    _this.applicationId = applicationId;
    _this.javascriptKey = javascriptKey;
    _this.masterKey = masterKey;
    _this.sessionToken = sessionToken;
    _this.connectPromise = new _ParsePromise2.default();
    _this.subscriptions = new _map2.default();
    _this.state = CLIENT_STATE.INITIALIZED;
    return _this;
  }

  (0, _createClass3.default)(LiveQueryClient, [{
    key: 'shouldOpen',
    value: function () {
      return this.state === CLIENT_STATE.INITIALIZED || this.state === CLIENT_STATE.DISCONNECTED;
    }

    /**
     * Subscribes to a ParseQuery
     * 
     * If you provide the sessionToken, when the LiveQuery server gets ParseObject's 
     * updates from parse server, it'll try to check whether the sessionToken fulfills 
     * the ParseObject's ACL. The LiveQuery server will only send updates to clients whose 
     * sessionToken is fit for the ParseObject's ACL. You can check the LiveQuery protocol
     * <a href="https://github.com/ParsePlatform/parse-server/wiki/Parse-LiveQuery-Protocol-Specification">here</a> for more details. The subscription you get is the same subscription you get 
     * from our Standard API.
     * 
     * @param {Object} query - the ParseQuery you want to subscribe to
     * @param {string} sessionToken (optional) 
     * @return {Object} subscription
     */

  }, {
    key: 'subscribe',
    value: function (query, sessionToken) {
      var _this2 = this;

      if (!query) {
        return;
      }
      var className = query.className;
      var queryJSON = query.toJSON();
      var where = queryJSON.where;
      var fields = queryJSON.keys ? queryJSON.keys.split(',') : undefined;
      var subscribeRequest = {
        op: OP_TYPES.SUBSCRIBE,
        requestId: this.requestId,
        query: {
          className: className,
          where: where,
          fields: fields
        }
      };

      if (sessionToken) {
        subscribeRequest.sessionToken = sessionToken;
      }

      var subscription = new _LiveQuerySubscription2.default(this.requestId, query, sessionToken);
      this.subscriptions.set(this.requestId, subscription);
      this.requestId += 1;
      this.connectPromise.then(function () {
        _this2.socket.send((0, _stringify2.default)(subscribeRequest));
      });

      // adding listener so process does not crash
      // best practice is for developer to register their own listener
      subscription.on('error', function () {});

      return subscription;
    }

    /**
     * After calling unsubscribe you'll stop receiving events from the subscription object.
     * 
     * @param {Object} subscription - subscription you would like to unsubscribe from.
     */

  }, {
    key: 'unsubscribe',
    value: function (subscription) {
      var _this3 = this;

      if (!subscription) {
        return;
      }

      this.subscriptions.delete(subscription.id);
      var unsubscribeRequest = {
        op: OP_TYPES.UNSUBSCRIBE,
        requestId: subscription.id
      };
      this.connectPromise.then(function () {
        _this3.socket.send((0, _stringify2.default)(unsubscribeRequest));
      });
    }

    /**
     * After open is called, the LiveQueryClient will try to send a connect request
     * to the LiveQuery server.
     * 
     */

  }, {
    key: 'open',
    value: function () {
      var _this4 = this;

      var WebSocketImplementation = this._getWebSocketImplementation();
      if (!WebSocketImplementation) {
        this.emit(CLIENT_EMMITER_TYPES.ERROR, 'Can not find WebSocket implementation');
        return;
      }

      if (this.state !== CLIENT_STATE.RECONNECTING) {
        this.state = CLIENT_STATE.CONNECTING;
      }

      // Get WebSocket implementation
      this.socket = new WebSocketImplementation(this.serverURL);

      // Bind WebSocket callbacks
      this.socket.onopen = function () {
        _this4._handleWebSocketOpen();
      };

      this.socket.onmessage = function (event) {
        _this4._handleWebSocketMessage(event);
      };

      this.socket.onclose = function () {
        _this4._handleWebSocketClose();
      };

      this.socket.onerror = function (error) {
        _this4._handleWebSocketError(error);
      };
    }
  }, {
    key: 'resubscribe',
    value: function () {
      var _this5 = this;

      this.subscriptions.forEach(function (subscription, requestId) {
        var query = subscription.query;
        var queryJSON = query.toJSON();
        var where = queryJSON.where;
        var fields = queryJSON.keys ? queryJSON.keys.split(',') : undefined;
        var className = query.className;
        var sessionToken = subscription.sessionToken;
        var subscribeRequest = {
          op: OP_TYPES.SUBSCRIBE,
          requestId: requestId,
          query: {
            className: className,
            where: where,
            fields: fields
          }
        };

        if (sessionToken) {
          subscribeRequest.sessionToken = sessionToken;
        }

        _this5.connectPromise.then(function () {
          _this5.socket.send((0, _stringify2.default)(subscribeRequest));
        });
      });
    }

    /**
     * This method will close the WebSocket connection to this LiveQueryClient, 
     * cancel the auto reconnect and unsubscribe all subscriptions based on it.
     * 
     */

  }, {
    key: 'close',
    value: function () {
      if (this.state === CLIENT_STATE.INITIALIZED || this.state === CLIENT_STATE.DISCONNECTED) {
        return;
      }
      this.state = CLIENT_STATE.DISCONNECTED;
      this.socket.close();
      // Notify each subscription about the close
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.subscriptions.values()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var subscription = _step.value;

          subscription.emit(SUBSCRIPTION_EMMITER_TYPES.CLOSE);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this._handleReset();
      this.emit(CLIENT_EMMITER_TYPES.CLOSE);
    }
  }, {
    key: '_getWebSocketImplementation',
    value: function () {
      return typeof WebSocket === 'function' || (typeof WebSocket === 'undefined' ? 'undefined' : (0, _typeof3.default)(WebSocket)) === 'object' ? WebSocket : null;
    }

    // ensure we start with valid state if connect is called again after close

  }, {
    key: '_handleReset',
    value: function () {
      this.attempts = 1;
      this.id = 0;
      this.requestId = 1;
      this.connectPromise = new _ParsePromise2.default();
      this.subscriptions = new _map2.default();
    }
  }, {
    key: '_handleWebSocketOpen',
    value: function () {
      this.attempts = 1;
      var connectRequest = {
        op: OP_TYPES.CONNECT,
        applicationId: this.applicationId,
        javascriptKey: this.javascriptKey,
        masterKey: this.masterKey,
        sessionToken: this.sessionToken
      };
      this.socket.send((0, _stringify2.default)(connectRequest));
    }
  }, {
    key: '_handleWebSocketMessage',
    value: function (event) {
      var data = event.data;
      if (typeof data === 'string') {
        data = JSON.parse(data);
      }
      var subscription = null;
      if (data.requestId) {
        subscription = this.subscriptions.get(data.requestId);
      }
      switch (data.op) {
        case OP_EVENTS.CONNECTED:
          if (this.state === CLIENT_STATE.RECONNECTING) {
            this.resubscribe();
          }
          this.emit(CLIENT_EMMITER_TYPES.OPEN);
          this.id = data.clientId;
          this.connectPromise.resolve();
          this.state = CLIENT_STATE.CONNECTED;
          break;
        case OP_EVENTS.SUBSCRIBED:
          if (subscription) {
            subscription.emit(SUBSCRIPTION_EMMITER_TYPES.OPEN);
          }
          break;
        case OP_EVENTS.ERROR:
          if (data.requestId) {
            if (subscription) {
              subscription.emit(SUBSCRIPTION_EMMITER_TYPES.ERROR, data.error);
            }
          } else {
            this.emit(CLIENT_EMMITER_TYPES.ERROR, data.error);
          }
          break;
        case OP_EVENTS.UNSUBSCRIBED:
          // We have already deleted subscription in unsubscribe(), do nothing here
          break;
        default:
          // create, update, enter, leave, delete cases
          var className = data.object.className;
          // Delete the extrea __type and className fields during transfer to full JSON
          delete data.object.__type;
          delete data.object.className;
          var parseObject = new _ParseObject2.default(className);
          parseObject._finishFetch(data.object);
          if (!subscription) {
            break;
          }
          subscription.emit(data.op, parseObject);
      }
    }
  }, {
    key: '_handleWebSocketClose',
    value: function () {
      if (this.state === CLIENT_STATE.DISCONNECTED) {
        return;
      }
      this.state = CLIENT_STATE.CLOSED;
      this.emit(CLIENT_EMMITER_TYPES.CLOSE);
      // Notify each subscription about the close
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(this.subscriptions.values()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var subscription = _step2.value;

          subscription.emit(SUBSCRIPTION_EMMITER_TYPES.CLOSE);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this._handleReconnect();
    }
  }, {
    key: '_handleWebSocketError',
    value: function (error) {
      this.emit(CLIENT_EMMITER_TYPES.ERROR, error);
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = (0, _getIterator3.default)(this.subscriptions.values()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var subscription = _step3.value;

          subscription.emit(SUBSCRIPTION_EMMITER_TYPES.ERROR);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this._handleReconnect();
    }
  }, {
    key: '_handleReconnect',
    value: function () {
      var _this6 = this;

      // if closed or currently reconnecting we stop attempting to reconnect
      if (this.state === CLIENT_STATE.DISCONNECTED) {
        return;
      }

      this.state = CLIENT_STATE.RECONNECTING;
      var time = generateInterval(this.attempts);

      // handle case when both close/error occur at frequent rates we ensure we do not reconnect unnecessarily.
      // we're unable to distinguish different between close/error when we're unable to reconnect therefore
      // we try to reonnect in both cases
      // server side ws and browser WebSocket behave differently in when close/error get triggered

      if (this.reconnectHandle) {
        clearTimeout(this.reconnectHandle);
      }

      this.reconnectHandle = setTimeout(function () {
        _this6.attempts++;
        _this6.connectPromise = new _ParsePromise2.default();
        _this6.open();
      }.bind(this), time);
    }
  }]);
  return LiveQueryClient;
}(_EventEmitter3.default);

exports.default = LiveQueryClient;

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trim;
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return commonLogoutFunction; });
/* unused harmony export commonVariable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_parse__);
var commonLogoutFunction=function commonLogoutFunction(){__WEBPACK_IMPORTED_MODULE_0_parse___default.a.User.logOut();localStorage.removeItem('username');localStorage.removeItem('useremail');localStorage.removeItem('sessionToken');localStorage.removeItem('isLoggedin');localStorage.removeItem('ispicture_popup');window.location.href="/";};var commonVariable='common variable';

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__global_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Leftsidebar_jsx__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CommonPopup_jsx__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Popup from "./Popup.jsx";
var SearchPage=function(_React$Component){_inherits(SearchPage,_React$Component);function SearchPage(props){_classCallCheck(this,SearchPage);var _this=_possibleConstructorReturn(this,(SearchPage.__proto__||Object.getPrototypeOf(SearchPage)).call(this,props));_this.backHome=function(event){window.location.href="/";};_this.state={searchResultsPhoto:[],SearchTitles:'',isPopupOpen:false,post_common_id:''};var queryString=window.location.href;var queryStrings=queryString?queryString.split("/")[3]:'';var part=queryStrings?queryStrings.split('='):'';var searchtext=part?part[1]:'';_this.searchTitle=searchtext;_this.getSearchResults();localStorage.setItem('storestreamtabValue',_this.searchTitle);localStorage.setItem('storestreampagepath','searchresult');return _this;}_createClass(SearchPage,[{key:'getSearchResults',value:function getSearchResults(){var self=this;//loop
var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('User');query.equalTo('isSuggested',1);query.descending('_created_at');var SearchTitle=this.searchTitle;var self=this;query.find().then(function(result){if(result){var userSuggdataresult1=[];if(result.length>0){for(var i=0;i<result.length;i++){var user=result[i];userSuggdataresult1[i]='_User$'+user.id;}//loop
var queryphoto=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');queryphoto.include("user");queryphoto.limit(99999999999);var jointuser=userSuggdataresult1;//["_User$5CJeW8oA1k","_User$lT8FObMmNn"];
//queryphoto.containedIn('user', jointuser);//commente
queryphoto.descending("createdAt");if(SearchTitle){queryphoto.contains('caption',SearchTitle);}queryphoto.find().then(function(photo){self.setState({searchResultsPhoto:photo});self.setState({SearchTitles:SearchTitle});});//loop
}}else{//console.log("No user found");
}},function(error){console.error("Error loading post Error: "+error);});}},{key:'render',value:function render(){var _this2=this;var searchResultsPhoto=this.state.searchResultsPhoto;var isPopupOpen=this.state.isPopupOpen;var postcommonid=this.state.post_common_id;var togglePopup=function togglePopup(postid){_this2.setState(function(prevState){return{isPopupOpen:!prevState.isPopupOpen};});_this2.setState({post_common_id:postid});__WEBPACK_IMPORTED_MODULE_5_jquery___default()("body").addClass("modal-open-search");};var streamid=function streamid(postid){localStorage.setItem('storestreamid',postid);};var self=this;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('section',{className:'post_list'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('nav',{className:'sidebar'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Leftsidebar_jsx__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('main',{className:'listing search-listing'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'search-grid'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tlt-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:this.backHome},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/back-arrow.svg',alt:'Close'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h1',null,this.searchTitle?this.searchTitle:'')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'grid-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{'class':'gridPostRow'},searchResultsPhoto&&searchResultsPhoto.map(function(photo,i){var photoimage='';if(photo.get("image")&&photo.get("image").url()!==undefined){photoimage=photo.get("image").url();}else{photoimage="/images/default_userpic0.png";}{return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{'class':'gridPost',key:i+100},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/stream',onClick:function onClick(e){streamid(photo.id);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:photoimage}))));}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CommonPopup_jsx__["a" /* default */],{isOpen:isPopupOpen,onClose:function onClose(e){togglePopup(_this2.state.post_common_id);},postcommonid:this.state.post_common_id}))))))));}}]);return SearchPage;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/*class Myprofiles extends React.Component {
    render() {
    return (
        <div className="App">
        <div className="mainProfileWrapper">
          <div className="mainProfileColumn">adaffa

         

            <center>


            </center>
          </div>
        </div>
       
         
        </div>

    );
  }
}*//* harmony default export */ __webpack_exports__["a"] = (SearchPage);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PropsDecoratorContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultPropsDecorator__ = __webpack_require__(100);


var PropsDecoratorContext = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(__WEBPACK_IMPORTED_MODULE_1__defaultPropsDecorator__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (PropsDecoratorContext.Provider);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pickDirectStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pickNestedStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hoistModifierStylesRecursive; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filterKeys__ = __webpack_require__(143);




var camelize = function camelize(key) {
  return key.replace(/-(\w)/g, function (m, c) {
    return c.toUpperCase();
  });
};

var pickDirectStyles = function pickDirectStyles(style) {
  var objectPropertiesWhitelist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var styleKeys = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* keys */])(style);
  var result = {};

  for (var i = 0, l = styleKeys.length; i < l; i += 1) {
    var key = styleKeys[i];
    var isDirect = Object.prototype.toString.call(style[key]) !== '[object Object]' || // style defs
    key[0] === ':' || // pseudo selectors
    key[0] === '@' || // @media / @keyframes / @supports / @font-face
    objectPropertiesWhitelist.indexOf(key) >= 0; // whitelisted object-type properties

    if (isDirect) {
      result[key] = style[key];
    }
  }

  return result;
};
var pickNestedStyles = function pickNestedStyles(style, keysToPick) {
  var camelizedKeysToPick = keysToPick.map(camelize);
  var styleKeys = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* keys */])(style);
  var result = {};

  for (var i = 0, l = styleKeys.length; i < l; i += 1) {
    var key = styleKeys[i];

    if (keysToPick.indexOf(key) >= 0 || camelizedKeysToPick.indexOf(camelize(key)) >= 0) {
      result[key] = style[key];
    }
  }

  return result;
}; // breadth-first hoisting of selected modifier style subtrees
// does not traverse into element, :pseudo-selector or @directive subtrees

var hoistModifierStylesRecursive = function hoistModifierStylesRecursive(style, modifierKeysToPick) {
  // hoist styles for selected modifiers on current level
  var result = __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* merge */].apply(void 0, [{}, Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* omit */])(style, modifierKeysToPick)].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* values */])(pickNestedStyles(style, modifierKeysToPick))))); // traverse nested styled for ALL modifiers

  var modifierKeys = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* keys */])(result).filter(__WEBPACK_IMPORTED_MODULE_2__filterKeys__["b" /* isModifier */]);

  for (var i = 0, l = modifierKeys.length; i < l; i += 1) {
    var key = modifierKeys[i];
    var subresult = hoistModifierStylesRecursive(result[key], modifierKeysToPick);

    if (modifierKeysToPick.indexOf(key) >= 0) {
      // selected modifier: hoist subresult
      delete result[key];
      result = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* merge */])({}, result, subresult);
    } else {
      // non-selected modifier: replace with subresult
      result[key] = subresult;
    }
  }

  return result;
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(302);

var iterableToArray = __webpack_require__(303);

var nonIterableSpread = __webpack_require__(304);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isModifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isElement; });
var isModifier = function isModifier(key) {
  return key[0] === '&';
};
var isElement = function isElement(key) {
  return !isModifier(key);
};

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__coerceSelection__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultPropsDecorator__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filterKeys__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__memoize__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pickStyles__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(101);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var guessBaseClassName = function guessBaseClassName(classNames) {
  // all class names must start with the same prefix: the component's base class name
  // which will finally go to the container element
  var firstKey = classNames && Object(__WEBPACK_IMPORTED_MODULE_8__utils__["c" /* keys */])(classNames)[0];
  return firstKey && firstKey.split('__')[0].split('--')[0];
};

var deriveClassNames = function deriveClassNames(className, elementKeys, modifierKeys) {
  // do not derive class names, if the user did not specify any class name
  if (!className) {
    return undefined;
  } // derive class names based using the passed modifier/element keys


  var firstClassName = className.split(' ')[0];
  var derivedClassNames = [].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(elementKeys.length === 0 ? modifierKeys.map(function (key) {
    return "".concat(firstClassName, "--").concat(key.substring(1));
  }) : []), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(elementKeys.map(function (key) {
    return "".concat(firstClassName, "__").concat(key);
  }))); // also use the provided `className` if there is no sub-element selection

  return elementKeys.length === 0 ? [className].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(derivedClassNames)) : derivedClassNames;
};

function createSubstyle(_ref) {
  var style = _ref.style,
      className = _ref.className,
      classNames = _ref.classNames;
  var propsDecorator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_4__defaultPropsDecorator__["a" /* default */];
  var baseClassName = className || guessBaseClassName(classNames) || (style === null || style === void 0 ? void 0 : style.className);
  var substyle = typeof style === 'function' ? style : Object(__WEBPACK_IMPORTED_MODULE_6__memoize__["a" /* default */])(function (select, defaultStyle) {
    var selectedKeys = Object(__WEBPACK_IMPORTED_MODULE_3__coerceSelection__["a" /* default */])(select);
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(Array.isArray(selectedKeys), 'First parameter must be a string, an array of strings, ' + 'a plain object with boolean values, or a falsy value.');
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(!defaultStyle || Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* isPlainObject */])(defaultStyle), 'Optional second parameter must be a plain object.');
    var modifierKeys = selectedKeys.filter(__WEBPACK_IMPORTED_MODULE_5__filterKeys__["b" /* isModifier */]);
    var elementKeys = selectedKeys.filter(__WEBPACK_IMPORTED_MODULE_5__filterKeys__["a" /* isElement */]);
    var collectElementStyles = elementKeys.length > 0 ? function (fromStyle) {
      return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["f" /* values */])(Object(__WEBPACK_IMPORTED_MODULE_7__pickStyles__["c" /* pickNestedStyles */])(fromStyle, elementKeys));
    } : function (fromStyle) {
      return [fromStyle];
    };

    var collectSelectedStyles = function collectSelectedStyles() {
      var fromStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return collectElementStyles(Object(__WEBPACK_IMPORTED_MODULE_7__pickStyles__["a" /* hoistModifierStylesRecursive */])(fromStyle, modifierKeys));
    };

    var derivedClassNames = deriveClassNames(baseClassName, elementKeys, modifierKeys);
    return createSubstyle(_objectSpread(_objectSpread(_objectSpread({}, (style || defaultStyle) && {
      style: __WEBPACK_IMPORTED_MODULE_8__utils__["d" /* merge */].apply(void 0, [{}].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(collectSelectedStyles(defaultStyle)), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(collectSelectedStyles(style))))
    }), derivedClassNames && {
      className: derivedClassNames.join(' ')
    }), classNames && {
      classNames: classNames
    }), propsDecorator);
  });

  var styleProps = _objectSpread({}, typeof style === 'function' ? style : {
    style: style
  });

  var classNameSplit = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(new Set([].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(styleProps.className ? styleProps.className.split(' ') : []), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(baseClassName ? baseClassName.split(' ') : []))));

  var mappedClassNames = classNames ? Object(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* compact */])(classNameSplit.map(function (singleClassName) {
    return classNames[singleClassName];
  })) : classNameSplit;
  var propsForSpread = propsDecorator(_objectSpread(_objectSpread({}, styleProps), mappedClassNames.length > 0 ? {
    className: mappedClassNames.join(' ')
  } : {})); // assign `style`, `className`, and/or any props added by the decorator to the return function object

  Object.assign(substyle, propsForSpread);
  return substyle;
}

/* harmony default export */ __webpack_exports__["a"] = (createSubstyle);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(101);


var coerceSelection = function coerceSelection(select) {
  if (!select) {
    return [];
  } else if (typeof select === 'string') {
    return [select];
  } else if (!Array.isArray(select)) {
    var objSelect = select; // workaround for https://github.com/facebook/flow/issues/5781

    return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* keys */])(select).reduce(function (acc, key) {
      return acc.concat(objSelect[key] ? [key] : []);
    }, []);
  }

  return select;
};

/* harmony default export */ __webpack_exports__["a"] = (coerceSelection);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var followersUser=function(_React$Component){_inherits(followersUser,_React$Component);function followersUser(props){_classCallCheck(this,followersUser);var _this=_possibleConstructorReturn(this,(followersUser.__proto__||Object.getPrototypeOf(followersUser)).call(this,props));var currentUser=__WEBPACK_IMPORTED_MODULE_0_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultSavedid=0;var checksavequery=new __WEBPACK_IMPORTED_MODULE_0_parse___default.a.Query('Activity');checksavequery.equalTo('type','follow');checksavequery.equalTo('toUser',"_User$"+props.postData.id);checksavequery.equalTo('fromUser',"_User$"+currentUser_id);checksavequery.find().then(function(resultSave){if(resultSave){var resultSaved=resultSave[0];resultSavedid=resultSaved.id;__WEBPACK_IMPORTED_MODULE_2_jquery___default()('a.followpost_link#follow_'+props.postData.id).attr("style","display: none");}else{}});}return _this;}_createClass(followersUser,[{key:'render',value:function render(){return'';}}]);return followersUser;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (followersUser);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var postSaveUser=function(_React$Component){_inherits(postSaveUser,_React$Component);function postSaveUser(props){_classCallCheck(this,postSaveUser);var _this=_possibleConstructorReturn(this,(postSaveUser.__proto__||Object.getPrototypeOf(postSaveUser)).call(this,props));var posts_id='';var post_id=props.postIdData;var currentUser=__WEBPACK_IMPORTED_MODULE_0_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultSavedid=0;var checksavequery=new __WEBPACK_IMPORTED_MODULE_0_parse___default.a.Query('Save');checksavequery.equalTo('photo',"Photo$"+props.postIdData);checksavequery.equalTo('fromUser',"_User$"+currentUser_id);checksavequery.find().then(function(resultSave){if(resultSave){var resultSaved=resultSave[0];resultSavedid=resultSaved.id;var photo_id=resultSaved.get('photo').id;if(resultSavedid){__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_2_jquery___default()('a.savepost_link1#save_'+post_id).attr("style","pointer-events: auto");if(posts_id){__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.post_save1 a.savepost_link1 .savedefault1#save_'+posts_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.post_save1 a.savepost_link1 .saveactive1#save_'+posts_id).attr("style","display: block");}}}});}return _this;}_createClass(postSaveUser,[{key:'render',value:function render(){return'';}}]);return postSaveUser;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (postSaveUser);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var getLikePostHome=function(_React$Component){_inherits(getLikePostHome,_React$Component);function getLikePostHome(props){_classCallCheck(this,getLikePostHome);var _this=_possibleConstructorReturn(this,(getLikePostHome.__proto__||Object.getPrototypeOf(getLikePostHome)).call(this,props));var currentUser=__WEBPACK_IMPORTED_MODULE_0_parse___default.a.User.current();var post_id=props.postIdData;if(currentUser){var currentUser_id=currentUser.id;var resultLikedid=0;var checklikequery=new __WEBPACK_IMPORTED_MODULE_0_parse___default.a.Query('Like');checklikequery.equalTo('photo',"Photo$"+post_id);checklikequery.equalTo('fromUser',currentUser);checklikequery.doesNotExist("activity");checklikequery.find().then(function(resultLike){if(resultLike){var resultLiked=resultLike[0];resultLikedid=resultLiked.id;if(resultLikedid!==undefined){__WEBPACK_IMPORTED_MODULE_2_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_2_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.comment_like_shere a.liked1 .active1#like_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.comment_like_shere a.liked1 .default1#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_2_jquery___default()('a.liked1#like_'+post_id).attr("style","pointer-events: auto");}if(resultLikedid===undefined){__WEBPACK_IMPORTED_MODULE_2_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_2_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.comment_like_shere a.liked1 .active1#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.comment_like_shere a.liked1 .default1#like_'+post_id).attr("style","display: block");}}});}return _this;}_createClass(getLikePostHome,[{key:'render',value:function render(){return'';}}]);return getLikePostHome;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (getLikePostHome);

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(150);
module.exports = __webpack_require__(155);


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(151).enable();
  window.Promise = __webpack_require__(153);
}

// fetch() polyfill for making API calls.
__webpack_require__(154);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(71);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(103);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(103);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 154 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__posts_jsx__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__postsone_jsx__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__userprofile_jsx__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Editprofile_jsx__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__notfound__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appstore_jsx__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__creatorlist_jsx__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__homestream_jsx__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CreateChallenge_jsx__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ExploreListing_jsx__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ExploreChallengeDetail_jsx__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ChallengeDetail_jsx__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SearchPage_jsx__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__footer_jsx__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__contact_jsx__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__UserRegistration_jsx__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Photo_jsx__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__registerServiceWorker__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__user_Myprofile_jsx__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__explorer_jsx__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__NotificationComponent_jsx__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__gridstream_jsx__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Messages_jsx__ = __webpack_require__(336);
//import Signup from "./signup.js";
// before routing version
//ReactDOM.render(<App />, document.getElementById('root'));
//
// // <Route path="/signup" component={()=>(<div><App/><Signup/><Footer/></div>)} />
//<Route path="/profile" component={()=>(<div><App/><UserProfiles/><Footer/></div>)} />
var routing=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{exact:true,path:'/',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'onboarding_mn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero_top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/onboar_screen.jpg',alt:'Joel\'s Kitchen'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero_bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'circle-logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/circle-logo.png',alt:'Joel\'s Circle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'middle-part'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/landing-page_logo.png',alt:'Joel\'s Kitchen'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detail'},'Download Joel\'s Kitchen app to start creating posts, connecting with friends, sharing recipes, and competing in challenges for cash prizes.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom-part'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://apps.apple.com/us/app/joels-kitchen/id1151259671',target:'_blank',title:'Apple Store'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/app-store.png',alt:'Apple Store'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'homestream_mn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ExploreListing_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null)));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/create-challenge/:id?',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__CreateChallenge_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/post',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__posts_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/explorer',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__explorer_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/posts',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__posts_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/postsone',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__postsone_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/signup',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__UserRegistration_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/user',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__userprofile_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/my-profile',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__user_Myprofile_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/users',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__userprofile_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/photo',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Photo_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/edit-profile',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Editprofile_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/contact',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__contact_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/appstore',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__appstore_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/creatordirectory',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__creatorlist_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/notification',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__NotificationComponent_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/explore',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ExploreListing_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/challenge/:id?',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ChallengeDetail_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/explore-detail',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ExploreChallengeDetail_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/search/:q?',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__SearchPage_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/stream',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__gridstream_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/messages',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__Messages_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/terms',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content cf'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Terms of Use'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'questions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'These Terms of Use are effective on August 28, 2015.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'By accessing or using the Joel\'s Kitchen website, the Joel\'s Kitchen service, or any applications (including mobile applications) made available by Joel\'s Kitchen (together, the "Service"), however accessed, you agree to be bound by these terms of use ("Terms of Use"). The Service is owned or controlled by Joel\'s Kitchen ("Joel\'s Kitchen"). These Terms of Use affect your legal rights and obligations. If you do not agree to be bound by all of these Terms of Use, do not access or use the Service.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'There may be times when we offer a special feature that has its own terms and conditions that apply in addition to these Terms of Use. In those cases, the terms specific to the special feature control to the extent there is a conflict with these Terms of Use.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'ARBITRATION NOTICE: EXCEPT IF YOU OPT-OUT AND EXCEPT FOR CERTAIN TYPES OF DISPUTES DESCRIBED IN THE ARBITRATION SECTION BELOW, YOU AGREE THAT DISPUTES BETWEEN YOU AND Joel\'s Kitchen WILL BE RESOLVED BY BINDING, INDIVIDUAL ARBITRATION AND YOU WAIVE YOUR RIGHT TO PARTICIPATE IN A CLASS ACTION LAWSUIT OR CLASS-WIDE ARBITRATION.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Basic Terms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You must be at least 13 years old to use the Service.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You may not post violent, nude, partially nude, discriminatory, unlawful, infringing, hateful, pornographic or sexually suggestive photos or other content via the Service.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You are responsible for any activity that occurs through your account and you agree you will not sell, transfer, license or assign your account, followers, username, or any account rights. With the exception of people or businesses that are expressly authorized to create accounts on behalf of their employers or clients, Joel\'s Kitchen prohibits the creation of and you agree that you will not create an account for anyone other than yourself. You also represent that all information you provide or provided to Joel\'s Kitchen upon registration and at all other times will be true, accurate, current and complete and you agree to update your information as necessary to maintain its truth and accuracy.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You agree that you will not solicit, collect or use the login credentials of other Joel\'s Kitchen users.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You are responsible for keeping your password secret and secure.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You must not defame, stalk, bully, abuse, harass, threaten, impersonate or intimidate people or entities and you must not post private or confidential information via the Service, including, without limitation, your or any other person\'s credit card information, social security or alternate national identity numbers, non-public phone numbers or non-public email addresses.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You may not use the Service for any illegal or unauthorized purpose. You agree to comply with all laws, rules and regulations (for example, federal, state, local and provincial) applicable to your use of the Service and your Content (defined below), including but not limited to, copyright laws.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You are solely responsible for your conduct and any data, text, files, information, usernames, images, graphics, photos, profiles, audio and video clips, sounds, musical works, works of authorship, applications, links and other content or materials (collectively, "Content") that you submit, post or display on or via the Service.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You must not change, modify, adapt or alter the Service or change, modify or alter another website so as to falsely imply that it is associated with the Service or Joel\'s Kitchen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You must not access Joel\'s Kitchen\u2019 private API by means other than those permitted by Joel\'s Kitchen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You must not create or submit unwanted email, comments, likes or other forms of commercial or harassing communications (a/k/a "spam") to any Joel\'s Kitchen users.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You must not use domain names or web URLs in your username without prior written consent from Joel\'s Kitchen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You must not interfere or disrupt the Service or servers or networks connected to the Service, including by transmitting any worms, viruses, spyware, malware or any other code of a destructive or disruptive nature. You may not inject content or code or otherwise alter or interfere with the way any Joel\'s Kitchen page is rendered or displayed in a user\'s browser or device.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You must not create accounts with the Service through unauthorized means, including but not limited to, by using an automated device, script, bot, spider, crawler or scraper.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You must not attempt to restrict another user from using or enjoying the Service and you must not encourage or facilitate violations of these Terms of Use or any other Joel\'s Kitchen terms.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Violation of these Terms of Use may, in Joel\'s Kitchen\u2019 sole discretion, result in termination of your Joel\'s Kitchen account. You understand and agree that Joel\'s Kitchen cannot and will not be responsible for the Content posted on the Service and you use the Service at your own risk. If you violate the letter or spirit of these Terms of Use, or otherwise create risk or possible legal exposure for Joel\'s Kitchen, we can stop providing all or part of the Service to you.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'General Conditions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'We reserve the right to modify or terminate the Service or your access to the Service for any reason, without notice, at any time, and without liability to you. If we terminate your access to the Service or you use the form detailed above to deactivate your account, your photos, comments, likes, friendships, and all other data will no longer be accessible through your account (e.g., users will not be able to navigate to your username and view your photos), but those materials and data may persist and appear within the Service (e.g., if your Content has been reshared by others).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Upon termination, all licenses and other rights granted to you in these Terms of Use will immediately cease.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'We reserve the right, in our sole discretion, to change these Terms of Use ("Updated Terms") from time to time. Unless we make a change for legal or administrative reasons, we will provide reasonable advance notice before the Updated Terms become effective. You agree that we may notify you of the Updated Terms by posting them on the Service, and that your use of the Service after the effective date of the Updated Terms (or engaging in such other conduct as we may reasonably specify) constitutes your agreement to the Updated Terms. Therefore, you should review these Terms of Use and any Updated Terms before using the Service. The Updated Terms will be effective as of the time of posting, or such later date as may be specified in the Updated Terms, and will apply to your use of the Service from that point forward. These Terms of Use will govern any disputes arising before the effective date of the Updated Terms.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'We reserve the right to refuse access to the Service to anyone for any reason at any time.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'We reserve the right to force forfeiture of any username for any reason.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'We may, but have no obligation to, remove, edit, block, and/or monitor Content or accounts containing Content that we determine in our sole discretion violates these Terms of Use.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You are solely responsible for your interaction with other users of the Service, whether online or offline. You agree that Joel\'s Kitchen is not responsible or liable for the conduct of any user. Joel\'s Kitchen reserves the right, but has no obligation, to monitor or become involved in disputes between you and other users. Exercise common sense and your best judgment when interacting with others, including when you submit or post Content or any personal or other information.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'There may be links from the Service, or from communications you receive from the Service, to third-party web sites or features. There may also be links to third-party web sites or features in images or comments within the Service. The Service also includes third-party content that we do not control, maintain or endorse. Functionality on the Service may also permit interactions between the Service and a third-party web site or feature, including applications that connect the Service or your profile on the Service with a third-party web site or feature. For example, the Service may include a feature that enables you to share Content from the Service or your Content with a third party, which may be publicly posted on that third party\'s service or application. Using this functionality typically requires you to login to your account on the third-party service and you do so at your own risk. Joel\'s Kitchen does not control any of these third-party web services or any of their content. You expressly acknowledge and agree that Joel\'s Kitchen is in no way responsible or liable for any such third-party services or features. YOUR CORRESPONDENCE AND BUSINESS DEALINGS WITH THIRD PARTIES FOUND THROUGH THE SERVICE ARE SOLELY BETWEEN YOU AND THE THIRD PARTY. You may choose, at your sole and absolute discretion and risk, to use applications that connect the Service or your profile on the Service with a third-party service (each, an "Application") and such Application may interact with, connect to or gather and/or pull information from and to your Service profile. By using such Applications, you acknowledge and agree to the following: (i) if you use an Application to share information, you are consenting to information about your profile on the Service being shared; (ii) your use of an Application may cause personally identifying information to be publicly disclosed and/or associated with you, even if Joel\'s Kitchen has not itself provided such information; and (iii) your use of an Application is at your own option and risk, and you will hold the Joel\'s Kitchen Parties (defined below) harmless for activity related to the Application.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You agree that you are responsible for all data charges you incur through use of the Service.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'We prohibit crawling, scraping, caching or otherwise accessing any content on the Service via automated means, including but not limited to, user profiles and photos (except as may be the result of standard search engine protocols or technologies used by a search engine with Joel\'s Kitchen\' express consent).',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Rights'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Joel\'s Kitchen does not claim ownership of any Content that you post on or through the Service. Instead, you hereby grant to Joel\'s Kitchen a non-exclusive, fully paid and royalty-free, transferable, sub-licensable, worldwide license to use the Content that you post on or through the Service.  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Some of the Service is supported by advertising revenue and may display advertisements and promotions, and you hereby agree that Joel\'s Kitchen may place such advertising and promotions on the Service or on, about, or in conjunction with your Content. The manner, mode and extent of such advertising and promotions are subject to change without specific notice to you.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You acknowledge that we may not always identify paid services, sponsored content, or commercial communications as such.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You represent and warrant that: (i) you own the Content posted by you on or through the Service or otherwise have the right to grant the rights and licenses set forth in these Terms of Use; (ii) the posting and use of your Content on or through the Service does not violate, misappropriate or infringe on the rights of any third party, including, without limitation, privacy rights, publicity rights, copyrights, trademark and/or other intellectual property rights; (iii) you agree to pay for all royalties, fees, and any other monies owed by reason of Content you post on or through the Service; and (iv) you have the legal right and capacity to enter into these Terms of Use in your jurisdiction.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'The Service contains content owned or licensed by Joel\'s Kitchen. Joel\'s Kitchen Content is protected by copyright, trademark, patent, trade secret and other laws, and, as between you and Joel\'s Kitchen, Joel\'s Kitchen owns and retains all rights in the Joel\'s Kitchen Content and the Service. You will not remove, alter or conceal any copyright, trademark, service mark or other proprietary rights notices incorporated in or accompanying the Joel\'s Kitchen Content and you will not reproduce, modify, adapt, prepare derivative works based on, perform, display, publish, distribute, transmit, broadcast, sell, license or otherwise exploit the Joel\'s Kitchen Content.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'The Joel\'s Kitchen name and logo are trademarks of Joel\'s Kitchen, and may not be copied, imitated or used, in whole or in part, without the prior written permission of Joel\'s Kitchen. In addition, all page headers, custom graphics, button icons and scripts are service marks, trademarks and/or trade dress of Joel\'s Kitchen, and may not be copied, imitated or used, in whole or in part, without prior written permission from Joel\'s Kitchen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Although it is Joel\'s Kitchen\u2019 intention for the Service to be available as much as possible, there will be occasions when the Service may be interrupted, including, without limitation, for scheduled maintenance or upgrades, for emergency repairs, or due to failure of telecommunications links and/or equipment. Also, Joel\'s Kitchen reserves the right to remove any Content from the Service for any reason, without prior notice. Content removed from the Service may continue to be stored by Joel\'s Kitchen, including, without limitation, in order to comply with certain legal obligations, but may not be retrievable without a valid court order. Consequently, Joel\'s Kitchen encourages you to maintain your own backup of your Content. In other words, Joel\'s Kitchen is not a backup service and you agree that you will not rely on the Service for the purposes of Content backup or storage. Joel\'s Kitchen will not be liable to you for any modification, suspension, or discontinuation of the Services, or the loss of any Content. You also acknowledge that the Internet may be subject to breaches of security and that the submission of Content or other information may not be secure. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'You agree that Joel\'s Kitchen is not responsible for, and does not endorse, Content posted within the Service. Joel\'s Kitchen does not have any obligation to prescreen, monitor, edit, or remove any Content. If your Content violates these Terms of Use, you may bear legal responsibility for that Content.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Except as otherwise described in the Service\'s Privacy Policy, as between you and Joel\'s Kitchen, any Content will be non-confidential and nonproprietary and we will not be liable for any use or disclosure of Content. You acknowledge and agree that your relationship with Joel\'s Kitchen is not a confidential, fiduciary, or other type of special relationship, and that your decision to submit any Content does not place Joel\'s Kitchen in a position that is any different from the position held by members of the general public, including with regard to your Content. None of your Content will be subject to any obligation of confidence on the part of Joel\'s Kitchen, and Joel\'s Kitchen will not be liable for any use or disclosure of any Content you provide.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'It is Joel\'s Kitchen\' policy not to accept or consider content, information, ideas, suggestions or other materials other than those we have specifically requested and to which certain specific terms, conditions and requirements may apply. This is to avoid any misunderstandings if your ideas are similar to those we have developed or are developing independently. Accordingly, Joel\'s Kitchen does not accept unsolicited materials or ideas, and takes no responsibility for any materials or ideas so transmitted. If, despite our policy, you choose to send us content, information, ideas, suggestions, or other materials, you further agree that Joel\'s Kitchen is free to use any such content, information, ideas, suggestions or other materials, for any purposes whatsoever, including, without limitation, developing and marketing products and services, without any liability or payment of any kind to you.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Reporting Copyright and Other IP Violations'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'We respect other people\'s rights, and expect you to do the same.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'If you repeatedly infringe other people\'s intellectual property rights, we will disable your account when appropriate.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Disclaimer of Warranties'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'THE SERVICE, INCLUDING, WITHOUT LIMITATION, Joel\'s Kitchen CONTENT, IS PROVIDED ON AN "AS IS", "AS AVAILABLE" AND "WITH ALL FAULTS" BASIS. TO THE FULLEST EXTENT PERMISSIBLE BY LAW, NEITHER Joel\'s Kitchen NOR ITS PARENT COMPANY NOR ANY OF THEIR EMPLOYEES, MANAGERS, OFFICERS OR AGENTS (COLLECTIVELY, THE "Joel\'s Kitchen PARTIES") MAKE ANY REPRESENTATIONS OR WARRANTIES OR ENDORSEMENTS OF ANY KIND WHATSOEVER, EXPRESS OR IMPLIED, AS TO: (A) THE SERVICE; (B) THE Joel\'s Kitchen CONTENT; (C) USER CONTENT; OR (D) SECURITY ASSOCIATED WITH THE TRANSMISSION OF INFORMATION TO Joel\'s Kitchen OR VIA THE SERVICE. IN ADDITION, THE Joel\'s Kitchen PARTIES HEREBY DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, TITLE, CUSTOM, TRADE, QUIET ENJOYMENT, SYSTEM INTEGRATION AND FREEDOM FROM COMPUTER VIRUS. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'THE Joel\'s Kitchen PARTIES DO NOT REPRESENT OR WARRANT THAT THE SERVICE WILL BE ERROR-FREE OR UNINTERRUPTED; THAT DEFECTS WILL BE CORRECTED; OR THAT THE SERVICE OR THE SERVER THAT MAKES THE SERVICE AVAILABLE IS FREE FROM ANY HARMFUL COMPONENTS, INCLUDING, WITHOUT LIMITATION, VIRUSES. THE Joel\'s Kitchen PARTIES DO NOT MAKE ANY REPRESENTATIONS OR WARRANTIES THAT THE INFORMATION (INCLUDING ANY INSTRUCTIONS) ON THE SERVICE IS ACCURATE, COMPLETE, OR USEFUL. YOU ACKNOWLEDGE THAT YOUR USE OF THE SERVICE IS AT YOUR SOLE RISK. THE Joel\'s Kitchen PARTIES DO NOT WARRANT THAT YOUR USE OF THE SERVICE IS LAWFUL IN ANY PARTICULAR JURISDICTION, AND THE Joel\'s Kitchen PARTIES SPECIFICALLY DISCLAIM SUCH WARRANTIES. SOME JURISDICTIONS LIMIT OR DO NOT ALLOW THE DISCLAIMER OF IMPLIED OR OTHER WARRANTIES SO THE ABOVE DISCLAIMER MAY NOT APPLY TO YOU TO THE EXTENT SUCH JURISDICTION\'S LAW IS APPLICABLE TO YOU AND THESE TERMS OF USE. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'BY ACCESSING OR USING THE SERVICE YOU REPRESENT AND WARRANT THAT YOUR ACTIVITIES ARE LAWFUL IN EVERY JURISDICTION WHERE YOU ACCESS OR USE THE SERVICE. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'THE Joel\'s Kitchen PARTIES DO NOT ENDORSE CONTENT AND SPECIFICALLY DISCLAIM ANY RESPONSIBILITY OR LIABILITY TO ANY PERSON OR ENTITY FOR ANY LOSS, DAMAGE (WHETHER ACTUAL, CONSEQUENTIAL, PUNITIVE OR OTHERWISE), INJURY, CLAIM, LIABILITY OR OTHER CAUSE OF ANY KIND OR CHARACTER BASED UPON OR RESULTING FROM ANY CONTENT.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Limitation of Liability; Waiver'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'UNDER NO CIRCUMSTANCES WILL THE Joel\'s Kitchen PARTIES BE LIABLE TO YOU FOR ANY LOSS OR DAMAGES OF ANY KIND (INCLUDING, WITHOUT LIMITATION, FOR ANY DIRECT, INDIRECT, ECONOMIC, EXEMPLARY, SPECIAL, PUNITIVE, INCIDENTAL OR CONSEQUENTIAL LOSSES OR DAMAGES) THAT ARE DIRECTLY OR INDIRECTLY RELATED TO: (A) THE SERVICE; (B) THE Joel\'s Kitchen CONTENT; (C) USER CONTENT; (D) YOUR USE OF, INABILITY TO USE, OR THE PERFORMANCE OF THE SERVICE; (E) ANY ACTION TAKEN IN CONNECTION WITH AN INVESTIGATION BY THE Joel\'s Kitchen PARTIES OR LAW ENFORCEMENT AUTHORITIES REGARDING YOUR OR ANY OTHER PARTY\'S USE OF THE SERVICE; (F) ANY ACTION TAKEN IN CONNECTION WITH COPYRIGHT OR OTHER INTELLECTUAL PROPERTY OWNERS; (G) ANY ERRORS OR OMISSIONS IN THE SERVICE\'S OPERATION; OR (H) ANY DAMAGE TO ANY USER\'S COMPUTER, MOBILE DEVICE, OR OTHER EQUIPMENT OR TECHNOLOGY INCLUDING, WITHOUT LIMITATION, DAMAGE FROM ANY SECURITY BREACH OR FROM ANY VIRUS, BUGS, TAMPERING, FRAUD, ERROR, OMISSION, INTERRUPTION, DEFECT, DELAY IN OPERATION OR TRANSMISSION, COMPUTER LINE OR NETWORK FAILURE OR ANY OTHER TECHNICAL OR OTHER MALFUNCTION, INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOST PROFITS, LOSS OF GOODWILL, LOSS OF DATA, WORK STOPPAGE, ACCURACY OF RESULTS, OR COMPUTER FAILURE OR MALFUNCTION, EVEN IF FORESEEABLE OR EVEN IF THE Joel\'s Kitchen PARTIES HAVE BEEN ADVISED OF OR SHOULD HAVE KNOWN OF THE POSSIBILITY OF SUCH DAMAGES, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE, STRICT LIABILITY OR TORT (INCLUDING, WITHOUT LIMITATION, WHETHER CAUSED IN WHOLE OR IN PART BY NEGLIGENCE, ACTS OF GOD, TELECOMMUNICATIONS FAILURE, OR THEFT OR DESTRUCTION OF THE SERVICE). IN NO EVENT WILL THE Joel\'s Kitchen PARTIES BE LIABLE TO YOU OR ANYONE ELSE FOR LOSS, DAMAGE OR INJURY, INCLUDING, WITHOUT LIMITATION, DEATH OR PERSONAL INJURY. SOME STATES DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU. IN NO EVENT WILL THE Joel\'s Kitchen PARTIES TOTAL LIABILITY TO YOU FOR ALL DAMAGES, LOSSES OR CAUSES OR ACTION EXCEED ONE HUNDRED UNITED STATES DOLLARS ($100.00). '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'YOU AGREE THAT IN THE EVENT YOU INCUR ANY DAMAGES, LOSSES OR INJURIES THAT ARISE OUT OF Joel\'s Kitchen\' ACTS OR OMISSIONS, THE DAMAGES, IF ANY, CAUSED TO YOU ARE NOT IRREPARABLE OR SUFFICIENT TO ENTITLE YOU TO AN INJUNCTION PREVENTING ANY EXPLOITATION OF ANY WEB SITE, SERVICE, PROPERTY, PRODUCT OR OTHER CONTENT OWNED OR CONTROLLED BY THE Joel\'s Kitchen PARTIES, AND YOU WILL HAVE NO RIGHTS TO ENJOIN OR RESTRAIN THE DEVELOPMENT, PRODUCTION, DISTRIBUTION, ADVERTISING, EXHIBITION OR EXPLOITATION OF ANY WEBSITE, PROPERTY, PRODUCT, SERVICE, OR OTHER CONTENT OWNED OR CONTROLLED BY THE Joel\'s Kitchen PARTIES. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'BY ACCESSING THE SERVICE, YOU UNDERSTAND THAT YOU MAY BE WAIVING RIGHTS WITH RESPECT TO CLAIMS THAT ARE AT THIS TIME UNKNOWN OR UNSUSPECTED, AND IN ACCORDANCE WITH SUCH WAIVER, YOU ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTAND, AND HEREBY EXPRESSLY WAIVE, THE BENEFITS OF SECTION 1542 OF THE CIVIL CODE OF CALIFORNIA, AND ANY SIMILAR LAW OF ANY STATE OR TERRITORY, WHICH PROVIDES AS FOLLOWS: "A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS FAVOR AT THE TIME OF EXECUTING THE RELEASE, WHICH IF KNOWN BY HIM MUST HAVE MATERIALLY AFFECTED HIS SETTLEMENT WITH THE DEBTOR." '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Joel\'s Kitchen IS NOT RESPONSIBLE FOR THE ACTIONS, CONTENT, INFORMATION, OR DATA OF THIRD PARTIES, AND YOU RELEASE US, OUR DIRECTORS, OFFICERS, EMPLOYEES, AND AGENTS FROM ANY CLAIMS AND DAMAGES, KNOWN AND UNKNOWN, ARISING OUT OF OR IN ANY WAY CONNECTED WITH ANY CLAIM YOU HAVE AGAINST ANY SUCH THIRD PARTIES.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Indemnification'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You (and also any third party for whom you operate an account or activity on the Service) agree to defend (at Joel\'s Kitchen\'s request), indemnify and hold the Joel\'s Kitchen Parties harmless from and against any claims, liabilities, damages, losses, and expenses, including without limitation, reasonable attorney\'s fees and costs, arising out of or in any way connected with any of the following (including as a result of your direct activities on the Service or those conducted on your behalf): (i) your Content or your access to or use of the Service; (ii) your breach or alleged breach of these Terms of Use; (iii) your violation of any third-party right, including without limitation, any intellectual property right, publicity, confidentiality, property or privacy right; (iv) your violation of any laws, rules, regulations, codes, statutes, ordinances or orders of any governmental and quasi-governmental authorities, including, without limitation, all regulatory, administrative and legislative authorities; or (v) any misrepresentation made by you. You will cooperate as fully required by Joel\'s Kitchen in the defense of any claim. Joel\'s Kitchen reserves the right to assume the exclusive defense and control of any matter subject to indemnification by you, and you will not in any event settle any claim without the prior written consent of Joel\'s Kitchen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Arbitration'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Except if you opt-out or for disputes relating to: (1) your or Joel\'s Kitchen\'s intellectual property (such as trademarks, trade dress, domain names, trade secrets, copyrights and patents); (2) violations of the API Terms; or (3) violations of provisions 13 or 15 of the Basic Terms, above ("Excluded Disputes"), you agree that all disputes between you and Joel\'s Kitchen (whether or not such dispute involves a third party) with regard to your relationship with Joel\'s Kitchen, including without limitation disputes related to these Terms of Use, your use of the Service, and/or rights of privacy and/or publicity, will be resolved by binding, individual arbitration under the American Arbitration Association\'s rules for arbitration of consumer-related disputes and you and Joel\'s Kitchen hereby expressly waive trial by jury. As an alternative, you may bring your claim in your local "small claims" court, if permitted by that small claims court\'s rules. You may bring claims only on your own behalf. Neither you nor Joel\'s Kitchen will participate in a class action or class-wide arbitration for any claims covered by this agreement. You also agree not to participate in claims brought in a private attorney general or representative capacity, or consolidated claims involving another person\'s account, if Joel\'s Kitchen is a party to the proceeding. This dispute resolution provision will be governed by the Federal Arbitration Act. In the event the American Arbitration Association is unwilling or unable to set a hearing date within one hundred and sixty (160) days of filing the case, then either Joel\'s Kitchen or you can elect to have the arbitration administered instead by the Judicial Arbitration and Mediation Services. Judgment on the award rendered by the arbitrator may be entered in any court having competent jurisdiction. Any provision of applicable law notwithstanding, the arbitrator will not have authority to award damages, remedies or awards that conflict with these Terms of Use.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You may opt out of this agreement to arbitrate. If you do so, neither you nor Joel\'s Kitchen can require the other to participate in an arbitration proceeding. To opt out, you must notify Joel\'s Kitchen in writing within 30 days of the date that you first became subject to this arbitration provision. You must use this address to opt out: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Joel\'s Kitchen, ATTN: Arbitration Opt-out, 2525 Ocean Park Blvd., Santa Monica, CA 90405'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You must include your name and residence address, the email address you use for your Joel\'s Kitchen account, and a clear statement that you want to opt out of this arbitration agreement. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If the prohibition against class actions and other claims brought on behalf of third parties contained above is found to be unenforceable, then all of the preceding language in this Arbitration section will be null and void. This arbitration agreement will survive the termination of your relationship with Joel\'s Kitchen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Time Limitation on Claims'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You agree that any claim you may have arising out of or related to your relationship with Joel\'s Kitchen must be filed within one year after such claim arose; otherwise, your claim is permanently barred.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Governing Law & Venue'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'These Terms of Use are governed by and construed in accordance with the laws of the State of California, without giving effect to any principles of conflicts of law AND WILL SPECIFICALLY NOT BE GOVERNED BY THE UNITED NATIONS CONVENTIONS ON CONTRACTS FOR THE INTERNATIONAL SALE OF GOODS, IF OTHERWISE APPLICABLE. For any action at law or in equity relating to the arbitration provision of these Terms of Use, the Excluded Disputes or if you opt out of the agreement to arbitrate, you agree to resolve any dispute you have with Joel\'s Kitchen exclusively in a state or federal court located in Santa Monica, California, and to submit to the personal jurisdiction of the courts located in Santa Monica for the purpose of litigating all such disputes.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If any provision of these Terms of Use is held to be unlawful, void, or for any reason unenforceable during arbitration or by a court of competent jurisdiction, then that provision will be deemed severable from these Terms of Use and will not affect the validity and enforceability of any remaining provisions. Joel\'s Kitchen failure to insist upon or enforce strict performance of any provision of these Terms will not be construed as a waiver of any provision or right. No waiver of any of these Terms will be deemed a further or continuing waiver of such term or condition or any other term or condition. Joel\'s Kitchen reserves the right to change this dispute resolution provision, but any such changes will not apply to disputes arising before the effective date of the amendment. This dispute resolution provision will survive the termination of any or all of your transactions with Joel\'s Kitchen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Entire Agreement'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you are using the Service on behalf of a legal entity, you represent that you are authorized to enter into an agreement on behalf of that legal entity. These Terms of Use constitute the entire agreement between you and Joel\'s Kitchen and governs your use of the Service, superseding any prior agreements between you and Joel\'s Kitchen. You will not assign the Terms of Use or assign any rights or delegate any obligations hereunder, in whole or in part, whether voluntarily or by operation of law, without the prior written consent of Joel\'s Kitchen. Any purported assignment or delegation by you without the appropriate prior written consent of Joel\'s Kitchen will be null and void. Joel\'s Kitchen may assign these Terms of Use or any rights hereunder without your consent. If any provision of these Terms of Use is found by a court of competent jurisdiction to be invalid or otherwise unenforceable, the parties nevertheless agree that such portion will be deemed severable from these Terms of Use and will not affect the validity and enforceability of the remaining provisions, and the remaining provisions of the Terms of Use remain in full force and effect. Neither the course of conduct between the parties nor trade practice will act to modify the Terms of Use. These Terms of Use do not confer any third-party beneficiary rights.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Territorial Restrictions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The information provided within the Service is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to law or regulation or which would subject Joel\'s Kitchen to any registration requirement within such jurisdiction or country. We reserve the right to limit the availability of the Service or any portion of the Service, to any person, geographic area, or jurisdiction, at any time and in our sole discretion, and to limit the quantities of any content, program, product, service or other feature that Joel\'s Kitchen provides.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Software related to or made available by the Service may be subject to United States export controls. Thus, no software from the Service may be downloaded, exported or re-exported: (a) into (or to a national or resident of) any country to which the United States has embargoed goods; or (b) to anyone on the U.S. Treasury Department\'s list of Specially Designated Nationals or the U.S. Commerce Department\'s Table of Deny Orders. By downloading any software related to the Service, you represent and warrant that you are not located in, under the control of, or a national or resident of, any such country or on any such list. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The effective date of these Terms of Use is August 28, 2015. These Terms of Use were written in English (US). To the extent any translated version of these Terms of Use conflicts with the English version, the English version controls.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/privacy',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content cf'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Privacy Policy'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'questions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Effective date: August 28, 2015',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Welcome to Joel\'s Kitchen. ("Joel\'s Kitchen," "we," "us" or "our"). Joel\'s Kitchen provides a fast, beautiful and fun way for you to share media through our content-sharing platform. Just snap a photo, add comments and share!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Our Privacy Policy explains how we and some of the companies we work with collect, use, share and protect information in relation to our mobile services, web site, and any software provided on or in connection with Joel\'s Kitchen services (collectively, the "Service"), and your choices about the collection and use of your information.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'By using our Service you understand and agree that we are providing a platform for you to post content, including photos, comments and other materials ("User Content"), to the Service and to share User Content publicly. This means that other Users may search for, see, use, or share any of your User Content that you make publicly available through the Service, consistent with the terms and conditions of this Privacy Policy and our Terms of Use.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Our Policy applies to all visitors, users, and others who access the Service ("Users").')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Click on the links below to jump to each section of this Policy:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Information We Collect'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'How We Use Your Information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Sharing of Your Information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'How We Store Your Information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Your Choices About Your Information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Children\'s Privacy'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Other Websites and Services'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'How to Contact Us About a Deceased User'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'How to Contact Us'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Changes to Our Privacy Policy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1. INFORMATION WE COLLECT',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'We collect the following types of information.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Information you provide us directly:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Your username, password and email address when you register for a Joel\'s Kitchen account.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Profile information that you provide for your user profile. This information allows us to help you or others be "found" on Joel\'s Kitchen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'User Content (e.g., photos, comments, and other materials) that you post to the Service.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Communications between you and Joel\'s Kitchen. For example, we may send you Service-related emails (e.g., account verification, changes/updates to features of the Service, technical and security notices). Note that you may not opt out of Service-related e-mails.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Finding your friends on Joel\'s Kitchen:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'If you choose, you can use our "Find friends" feature to locate other people with Joel\'s Kitchen accounts either through (i) your contacts list, (ii) third-party social media sites or (iii) through a search of names and usernames on Joel\'s Kitchen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'If you choose to find your friends through (i) your device\'s contacts list, then Joel\'s Kitchen will access your contacts list to determine whether or not someone associated with your contact is using Joel\'s Kitchen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'If you choose to find your friends through a (ii) third-party social media site, then you will be prompted to set up a link to the third-party service and you understand that any information that such service may provide to us will be governed by this Privacy Policy.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'If you choose to find your friends (iii) through a search of names or usernames on Joel\'s Kitchen then simply type a name to search and we will perform a search on our Service.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Note about "Invite Friends" feature: If you choose to invite someone to the Service through our "Invite friends" feature, you may select a person directly from the contacts list on your device and send a text or email from your personal account. You understand and agree that you are responsible for any charges that apply to communications sent from your device, and because this invitation is coming directly from your personal account, Joel\'s Kitchen does not have access to or control this communication.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Analytics information:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'We use third-party analytics tools to help us measure traffic and usage trends for the Service. These tools collect information sent by your device or our Service, including the web pages you visit, add-ons, and other information that assists us in improving the Service. We collect and use this analytics information with analytics information from other Users so that it cannot reasonably be used to identify any particular individual User.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Cookies and similar technologies:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'When you visit the Service, we may use cookies and similar technologies like pixels, web beacons, and local storage to collect information about how you use Joel\'s Kitchen and provide features to you.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'We may ask advertisers or other partners to serve ads or services to your devices, which may use cookies or similar technologies placed by us or the third party.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Log file information:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Log file information is automatically reported by your browser each time you make a request to access (i.e., visit) a web page or app. It can also be provided when the content of the webpage or app is downloaded to your browser or device.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'When you use our Service, our servers automatically record certain log file information, including your web request, Internet Protocol ("IP") address, browser type, referring / exit pages and URLs, number of clicks and how you interact with links on the Service, domain names, landing pages, pages viewed, and other such information. We may also collect similar information from emails sent to our Users which then help us track which emails are opened and which links are clicked by recipients. The information allows for more accurate reporting and improvement of the Service.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Device identifiers:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'When you use a mobile device like a tablet or phone to access our Service, we may access, collect, monitor, store on your device, and/or remotely store one or more "device identifiers." Device identifiers are small data files or similar data structures stored on or associated with your mobile device, which uniquely identify your mobile device. A device identifier may be data stored in connection with the device hardware, data stored in connection with the device\'s operating system or other software, or data sent to the device by Joel\'s Kitchen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'A device identifier may deliver information to us or to a third party partner about how you browse and use the Service and may help us or others provide reports or personalized content and ads. Some features of the Service may not function properly if use or availability of device identifiers is impaired or disabled.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Metadata:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Metadata is usually technical data that is associated with User Content. For example, Metadata can describe how, when and by whom a piece of User Content was collected and how that content is formatted.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Users can add or may have Metadata added to their User Content including a hashtag (e.g., to mark keywords when you post a photo), geotag (e.g., to mark your location to a photo), comments or other data. This makes your User Content more searchable by others and more interactive. If you geotag your photo or tag your photo using other\'s APIs then, your latitude and longitude will be stored with the photo and searchable (e.g., through a location or map feature) if your photo is made public by you in accordance with your privacy settings.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2. HOW WE USE YOUR INFORMATION',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'In addition to some of the specific uses of information we describe in this Privacy Policy, we may use information that we receive to:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'help you efficiently access your information after you sign in'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'remember information so you will not have to re-enter it during your visit or the next time you visit the Service;'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'provide personalized content and information to you and others, which could include online ads or other forms of marketing'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'provide, improve, test, and monitor the effectiveness of our Service'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'develop and test new products and features'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'monitor metrics such as total number of visitors, traffic, and demographic patterns'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'diagnose or fix technology problems'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'automatically update the Joel\'s Kitchen application on your device Joel\'s Kitchen or other Users may run contests, special offers or other events or activities ("Events") on the Service. If you do not want to participate in an Event, do not use the particular Metadata (i.e. hashtag or geotag) associated with that Event.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3. SHARING OF YOUR INFORMATION',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'We will not rent or sell your information to third parties outside Joel\'s Kitchen (or the group of companies of which Joel\'s Kitchen is a part) without your consent, except as noted in this Policy.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Parties with whom we may share your information:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'We may share User Content and your information (including but not limited to, information from cookies, log files, device identifiers, location data, and usage data) with businesses that are legally part of the same group of companies that Joel\'s Kitchen is part of, or that become part of that group ("Affiliates"). Affiliates may use this information to help provide, understand, and improve the Service (including by providing analytics) and Affiliates\' own services (including by providing you with better and more relevant experiences). But these Affiliates will honor the choices you make about who can see your photos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'We also may share your information as well as information from tools like cookies, log files, and device identifiers and location data, with third-party organizations that help us provide the Service to you ("Service Providers"). Our Service Providers will be given access to your information as is reasonably necessary to provide the Service under reasonable confidentiality terms.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'We may also share certain information such as cookie data with third-party advertising partners. This information would allow third-party ad networks to, among other things, deliver targeted advertisements that they believe will be of most interest to you.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'We may remove parts of data that can identify you and share anonymized data with other parties. We may also combine your information with other information in a way that it is no longer associated with you and share that aggregated information.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Parties with whom you may choose to share your User Content:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Any information or content that you voluntarily disclose for posting to the Service, such as User Content, becomes available to the public, as controlled by any applicable privacy settings that you set. To change your privacy settings on the Service, please change your profile setting. Once you have shared User Content or made it public, that User Content may be re-shared by others.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Subject to your profile and privacy settings, any User Content that you make public is searchable by other Users and subject to use under our Joel\'s Kitchen API.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'If you remove information that you posted to the Service, copies may remain viewable in cached and archived pages of the Service, or if other Users or third parties using the Joel\'s Kitchen API have copied or saved that information.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'What happens in the event of a change of control:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'If we sell or otherwise transfer part or the whole of Joel\'s Kitchen or our assets to another organization (e.g., in the course of a transaction like a merger, acquisition, bankruptcy, dissolution, liquidation), your information such as name and email address, User Content and any other information collected through the Service may be among the items sold or transferred. You will continue to own your User Content. The buyer or transferee will have to honor the commitments we have made in this Privacy Policy.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Responding to legal requests and preventing harm:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'We may access, preserve and share your information in response to a legal request (like a search warrant, court order or subpoena) if we have a good faith belief that the law requires us to do so. This may include responding to legal requests from jurisdictions outside of the United States where we have a good faith belief that the response is required by law in that jurisdiction, affects users in that jurisdiction, and is consistent with internationally recognized standards. We may also access, preserve and share information when we have a good faith belief it is necessary to: detect, prevent and address fraud and other illegal activity; to protect ourselves, you and others, including as part of investigations; and to prevent death or imminent bodily harm. Information we receive about you may be accessed, processed and retained for an extended period of time when it is the subject of a legal request or obligation, governmental investigation, or investigations concerning possible violations of our terms or policies, or otherwise to prevent harm.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4. HOW WE STORE YOUR INFORMATION',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Storage and Processing:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Your information collected through the Service may be stored and processed in the United States or any other country in which Joel\'s Kitchen, its Affiliates or Service Providers maintain facilities.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Joel\'s Kitchen, its Affiliates, or Service Providers may transfer information that we collect about you, including personal information across borders and from your country or jurisdiction to other countries or jurisdictions around the world. If you are located in the European Union or other regions with laws governing data collection and use that may differ from U.S. law, please note that we may transfer information, including personal information, to a country and jurisdiction that does not have the same data protection laws as your jurisdiction.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'By registering for and using the Service you consent to the transfer of information to the U.S. or to any other country in which Joel\'s Kitchen, its Affiliates or Service Providers maintain facilities and the use and disclosure of information about you as described in this Privacy Policy.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'We use commercially reasonable safeguards to help keep the information collected through the Service secure and take reasonable steps (such as requesting a unique password) to verify your identity before granting you access to your account. However, Joel\'s Kitchen cannot ensure the security of any information you transmit to Joel\'s Kitchen or guarantee that information on the Service may not be accessed, disclosed, altered, or destroyed.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Please do your part to help us. You are responsible for maintaining the secrecy of your unique password and account information, and for controlling access to emails between you and Joel\'s Kitchen, at all times. Your privacy settings may also be affected by changes the social media services you connect to Joel\'s Kitchen make to their services. We are not responsible for the functionality, privacy, or security measures of any other organization.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'5. YOUR CHOICES ABOUT YOUR INFORMATION',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Your account information and profile/privacy settings:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Update your account at any time by logging in and changing your profile settings.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Unsubscribe from email communications from us by clicking on the "unsubscribe link" provided in such communications. As noted above, you may not opt out of Service-related communications (e.g., account verification, purchase and billing confirmations and reminders, changes/updates to features of the Service, technical and security notices).')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'How long we keep your User Content:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Following termination or deactivation of your account, Joel\'s Kitchen, its Affiliates, or its Service Providers may retain information (including your profile information) and User Content for a commercially reasonable time for backup, archival, and/or audit purposes.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'6. CHILDREN\'S PRIVACY',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Joel\'s Kitchen does not knowingly collect or solicit any information from anyone under the age of 13 or knowingly allow such persons to register for the Service. The Service and its content are not directed at children under the age of 13. In the event that we learn that we have collected personal information from a child under age 13 without parental consent, we will delete that information as quickly as possible.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'7. OTHER WEB SITES AND SERVICES',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'We are not responsible for the practices employed by any websites or services linked to or from our Service, including the information or content contained within them. Please remember that when you use a link to go from our Service to another website or service, our Privacy Policy does not apply to those third-party websites or services. Your browsing and interaction on any third-party website or service, including those that have a link on our website, are subject to that third party\'s own rules and policies. In addition, you agree that we are not responsible and do not have control over any third-parties that you authorize to access your User Content. If you are using a third-party website or service and you allow them to access your User Content you do so at your own risk.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'8. HOW TO CONTACT US ABOUT A DECEASED USER',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Please contact us in the event of the death of a Joel\'s Kitchen User. We will usually conduct our communication via email; should we require any other information, we will contact you at the email address you have provided in your request.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'9. HOW TO CONTACT US',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'If you have any questions about this Privacy Policy or the Service, please contact us at ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:joel@joelskitchen.com'},'joel@joelskitchen.com'),'.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'10. CHANGES TO OUR PRIVACY POLICY',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Joel\'s Kitchen may modify or update this Privacy Policy from time to time, so please review it periodically. We may provide you additional forms of notice of modifications or updates as appropriate under the circumstances. Your continued use of Joel\'s Kitchen or the Service after any modification to this Privacy Policy will constitute your acceptance of such modification.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__footer_jsx__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_9__notfound__["a" /* default */]})));__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(routing,document.getElementById("root"));Object(__WEBPACK_IMPORTED_MODULE_22__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(71),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(71),r=__webpack_require__(158);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(159);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(73);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(163);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(73);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(170);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(74);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(105);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(174);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(176);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(109);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(178);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(74);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(180);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(75);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(109);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(75);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(184);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(107);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_ga__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_sticky__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_sticky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_sticky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_css__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SearchPage_jsx__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CommonPopup_jsx__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Popup from "./Popup.jsx";
function time_ago(time){switch(typeof time==='undefined'?'undefined':_typeof(time)){case'number':break;case'string':time=+new Date(time);break;case'object':if(time.constructor===Date)time=time.getTime();break;default:time=+new Date();}var time_formats=[[60,'s',1],// 60
[120,'1m','1 minute from now'],// 60*2
[3600,'m',60],// 60*60, 60
[7200,'1h','1 hour from now'],// 60*60*2
[86400,'h',3600],// 60*60*24, 60*60
[172800,'1d','Tomorrow'],// 60*60*24*2
[604800,'d',86400],// 60*60*24*7, 60*60*24
[1209600,'1w','Next week'],// 60*60*24*7*4*2
[2419200,'w',604800],// 60*60*24*7*4, 60*60*24*7
[4838400,'1m','Next month'],// 60*60*24*7*4*2
[29030400,'m',2419200],// 60*60*24*7*4*12, 60*60*24*7*4
[58060800,'1y','Next year'],// 60*60*24*7*4*12*2
[2903040000,'y',29030400],// 60*60*24*7*4*12*100, 60*60*24*7*4*12
[5806080000,'Last century','Next century'],// 60*60*24*7*4*12*100*2
[58060800000,'centuries',2903040000]// 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
];var seconds=(+new Date()-time)/1000,token='',list_choice=1;if(seconds==0){return'';}if(seconds<0){seconds=Math.abs(seconds);//token = 'from now';
token='';list_choice=2;}var i=0,format;while(format=time_formats[i++]){if(seconds<format[0]){if(typeof format[2]=='string')return format[list_choice];else return Math.floor(seconds/format[2])+''+format[1]+''+token;}}return time;}var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);// TODO don't forget to add your app and js ids
var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_initialiseProps.call(_this);__WEBPACK_IMPORTED_MODULE_3_parse___default.a.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5","sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw");//PASTE HERE YOUR Back4App APPLICATION ID AND YOUR JavaScript KEY
__WEBPACK_IMPORTED_MODULE_3_parse___default.a.serverURL="https://parse.joelskitchen.com/parse";//Parse.serverURL = "https://parsetest.joelskitchen.com/parse";
//console.log(Parse.serverURL);
__WEBPACK_IMPORTED_MODULE_5_react_ga__["a" /* default */].initialize('UA-60526992-2');__WEBPACK_IMPORTED_MODULE_5_react_ga__["a" /* default */].pageview(window.location.pathname+window.location.search);// this.handlemenu = this.handlemenu.bind(this);
_this.selectSection=_this.selectSection.bind(_this);_this.handleLogoutfunc=_this.handleLogoutfunc.bind(_this);_this.searchHistory=_this.searchHistory.bind(_this);_this.handleDeleteAccount=_this.handleDeleteAccount.bind(_this);//  useEffect(() => {
var getUsername=localStorage.getItem('username');var getUseremail=localStorage.getItem('useremail');var ispicture_popup=localStorage.getItem('ispicture_popup');setTimeout(function(){if(ispicture_popup=='true'){//window.alert('Signed up! Account created! If you want, you can add a profile picture and other info later.');
localStorage.setItem('ispicture_popup',false);}},1000);var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var displayUsername='';if(currentUser){displayUsername=currentUser.get("displayUsername");}_this.usernameParam=displayUsername;_this.state={getUsername:getUsername,getUseremail:getUseremail,userImage:null,searchusers:[],searchloading:false,filterSearchTitle:'',searchSuggestedUserId:[],searchSuggestedPhoto:[],searchloading1:false,filterSearchTitle1:'',searchHistoryData:[],/* isPopupOpenCommon: false,
            loading_common: false,
            error_common: null,
            post_common_id:'',
            postDetailscomment_common: null,
            postDetails_common: null,
            loadingdata_common:false,
            showPopup:false*/isPopupOpen1:false,post_common_id1:''};_this.queryForUserRecordData();_this.searchSuggestion();_this.searchSuggestionCloase();_this.topAccounts();_this.getSuggestedUserId();//this.handleSearchFilterChange();
_this.handleSearchFilterChange1();_this.getSearchHistory();//localStorage.setItem('storestreamtabValue', '');
return _this;}_createClass(App,[{key:'getSearchHistory',value:function getSearchHistory(){var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var searchquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Searchhistory');searchquery.equalTo('user',currentUser);searchquery.descending("_created_at");var self=this;searchquery.find().then(function(result){if(result){self.setState({searchHistoryData:result});}});}}},{key:'getSuggestedUserId',value:function getSuggestedUserId(){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('User');query.equalTo('isSuggested',1);query.descending('_created_at');query.limit(10);var _state=this.state,filterSearchTitle=_state.filterSearchTitle,filterSearchTitle1=_state.filterSearchTitle1;var self=this;query.find().then(function(result){if(result){var userSuggdataresult1=[];if(result.length>0){for(var i=0;i<result.length;i++){var user=result[i];userSuggdataresult1[i]='_User$'+user.id;}//loop
var queryphoto=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');queryphoto.include("user");queryphoto.limit(6);var jointuser=userSuggdataresult1;//["_User$5CJeW8oA1k","_User$lT8FObMmNn"];
// queryphoto.containedIn('user', jointuser);
queryphoto.descending("createdAt");if(filterSearchTitle){queryphoto.contains('caption',filterSearchTitle);}/*if (filterSearchTitle1) {
                        queryphoto.contains('caption', filterSearchTitle1);
                      }*/queryphoto.find().then(function(photo){self.setState({searchSuggestedPhoto:photo,searchloading1:true});});//loop
}// self.setState({users: result});
}else{//console.log("No user found");
}},function(error){console.error("Error loading post Error: "+error);});}},{key:'componentDidMount',value:function componentDidMount(){this.fetchSearchData();//this.createEntry();
}},{key:'queryForUserRecordData',value:function queryForUserRecordData(){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('User');query.equalTo("displayUsername",this.usernameParam);query.include("image");query.include("thumbnail");var self=this;query.first().then(function(result){if(result){self.setState({userImage:result.get("profilePictureSmall").url()});}else{}},function(error){console.error("Error loading post Error: "+error);});}},{key:'searchSuggestionCloase',value:function searchSuggestionCloase(){var _this2=this;this.setState({filterSearchTitle:''},function(){_this2.setState({searchloading:true},function(){_this2.fetchSearchData();});});__WEBPACK_IMPORTED_MODULE_4_jquery___default()("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn .search_inpt_inner").siblings(".search_rstl_mn").removeClass("active");__WEBPACK_IMPORTED_MODULE_4_jquery___default()("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn button.close-btn").addClass("hide");}},{key:'accountRemove',value:function accountRemove(){__WEBPACK_IMPORTED_MODULE_4_jquery___default()(".sugested_acunt ul li a.cls-btn").closest("li").hide(200);}},{key:'topAccounts',value:function topAccounts(){__WEBPACK_IMPORTED_MODULE_4_jquery___default()("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn>.search_rstl_mn>.inner aside.search_recent_box").hide("slow");__WEBPACK_IMPORTED_MODULE_4_jquery___default()("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn>.search_rstl_mn>.inner aside.all-acunts").show("slow");}},{key:'backAccounts',value:function backAccounts(){__WEBPACK_IMPORTED_MODULE_4_jquery___default()("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn>.search_rstl_mn>.inner aside.search_recent_box").show("slow");__WEBPACK_IMPORTED_MODULE_4_jquery___default()("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn>.search_rstl_mn>.inner aside.all-acunts").hide("slow");}},{key:'searchHistory',value:function searchHistory(e){e.preventDefault();//console.log('userid');
}},{key:'render',value:function render(){var _this3=this;var fetchUsername=this.state.getUsername;var fetchEmail=this.state.getUseremail;var searchusers=this.state.searchusers;var filterSearchTitle=this.state.filterSearchTitle;var searchSuggestedPhoto=this.state.searchSuggestedPhoto;var filterSearchTitle1=this.state.filterSearchTitle1;var searchHistoryData=this.state.searchHistoryData;var filterSearchTitleCommon='';var searchloading1=this.state.searchloading1;var searchloading=this.state.searchloading;if(filterSearchTitle){filterSearchTitleCommon=filterSearchTitle;}if(filterSearchTitle1!==''&&filterSearchTitle===''){filterSearchTitleCommon=filterSearchTitle1;}var togglePopup1=function togglePopup1(postid){_this3.setState(function(prevState){return{isPopupOpen1:!prevState.isPopupOpen1};});_this3.setState({post_common_id1:postid});__WEBPACK_IMPORTED_MODULE_4_jquery___default()("body").addClass("modelopenexplore");};var streamid=function streamid(postid){localStorage.setItem('storestreampagepath','search');localStorage.setItem('storestreamid',postid);localStorage.setItem('storestreamtabValue',filterSearchTitle);window.location.href="/stream";};var searchAccountRemoveData=function searchAccountRemoveData(searchid){var checkSearchquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Searchhistory');checkSearchquery.equalTo('objectId',searchid);checkSearchquery.find().then(function(object){if(object){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=object[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var objects=_step.value;objects.destroy();}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}}).then(function(deletedObject){_this3.getSearchHistory();}).catch(function(error){//console.error('Error deleting record:', error);
});};var handleClickUserHistory=function handleClickUserHistory(userid,displayUsername,userimage,searchtext,displayName){var displayUsernames=displayUsername?displayUsername:'';var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var Searchhistory=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Searchhistory");var searchhistory=new Searchhistory();searchhistory.set('objectid',userid);searchhistory.set('displayUsername',displayUsernames);searchhistory.set('displayName',displayName);searchhistory.set('profilePictureSmall',userimage);searchhistory.set('customtext',searchtext);searchhistory.set('type','user');searchhistory.set('user',currentUser);searchhistory.save().then(function(savedhistory){window.location.href="/user/"+displayUsernames;}).catch(function(error){});}};//const { isPopupOpenCommon, loading_common, error_common,post_common_id,postDetails_common} = this.state;
var isPopupOpen1=this.state.isPopupOpen1;var postcommonid=this.state.post_common_id1;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('header',{className:'header-mn'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CommonPopup_jsx__["a" /* default */],{isOpen:isPopupOpen1,onClose:function onClose(e){togglePopup1(postcommonid);},postcommonid:postcommonid}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('nav',{id:'navbarnew',className:'navbar'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner d-flex flex-row flex-wrap align-items-md-center align-items-center justify-content-lg-between '},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{id:'logo',rel:'home',href:'/'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/logo.png',alt:'Joel\'s Kitchen',className:'dt_logo'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/Joel_mb_logo.png',alt:'Joel\'s Kitchen',className:'mb_logo'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'menu-search-wrap menu-search-mn d-flex flex-row flex-wrap align-items-md-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'search_wrap'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('form',{className:'form-mn d-flex flex-row flex-wrap',onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'search_inpt_inner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{id:'search_txt_box',autoComplete:'off',className:'form-control',type:'search',onClick:this.searchSuggestion,placeholder:'Search','aria-label':'Search',value:filterSearchTitleCommon,onChange:this.handleSearchFilterChange}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{type:'submit'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/search.svg',alt:'Search',onClick:this.searchClear})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{type:'button',className:'close-btn hide',onClick:this.searchClear},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/srch-close.svg',alt:'Close'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'search_rstl_mn'},filterSearchTitleCommon?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('aside',{className:'search_box sugested_acunt all-acunts',style:{"display":"none"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tlt-part d-flex flex-row flex-wrap align-items-center justify-content-between '},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'#',title:'All Accounts',onClick:this.backAccounts},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/back_top.svg',alt:'Back to Top'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h2',null,'All accounts')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'cnt-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'list_grp'},searchloading&&searchusers.map(function(user,i){var userimage='';if(user.get("profilePictureSmall")&&user.get("profilePictureSmall").url()!==undefined){userimage=user.get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}{{/*href={user.get("displayUsername")?"/user/"+user.get("displayUsername"):''}*/}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'menu',key:i+100},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);',title:user.get("displayUsername")?user.get("displayUsername"):'',className:'media',onClick:function onClick(e){handleClickUserHistory(user.id,user.get("displayUsername"),userimage,filterSearchTitleCommon,user.get("displayName"));}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-left'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:userimage,width:'40px',height:'40px',alt:user.get("displayUsername")?user.get("displayUsername"):''})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-body'},user.get("displayName")?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h6',{className:'mt-0'},user.get("displayName")):'',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,user.get("displayUsername")?user.get("displayUsername"):''))));}})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('aside',{className:'search_box recent_box recent_search sugested_acunt',style:{"display":"none"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h2',null,'Recent'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'list_grp'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{className:'cls-btn',onClick:this.accountRemove},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',width:'11',height:'11',viewBox:'0 0 11 11',fill:'none'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('path',{d:'M1.90372 10.2268L0.903723 9.27106L4.90372 5.44818L0.903718 1.6253L1.90372 0.669587L5.90372 4.49246L9.90372 0.669592L10.9037 1.62531L6.90372 5.44818L10.9037 9.27106L9.90372 10.2268L5.90372 6.4039L1.90372 10.2268Z',fill:'#1C1B1F'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/user/orchidsnsweettea',title:'orchidsnsweettea',className:'media'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-left'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/be32f00c681ba0887e6220be0e301b28_file.bin',width:'40px',height:'40px',alt:'itsallgoodvegan'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h6',{className:'mt-0'},'orchidsnsweettea'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,'Orchids + Sweet Tea')))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{className:'cls-btn'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',width:'11',height:'11',viewBox:'0 0 11 11',fill:'none'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('path',{d:'M1.90372 10.2268L0.903723 9.27106L4.90372 5.44818L0.903718 1.6253L1.90372 0.669587L5.90372 4.49246L9.90372 0.669592L10.9037 1.62531L6.90372 5.44818L10.9037 9.27106L9.90372 10.2268L5.90372 6.4039L1.90372 10.2268Z',fill:'#1C1B1F'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/user/itsallgoodvegan',title:'itsallgoodvegan',className:'media'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-left'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/012f10ac9cba7b5211b1229b9e453b2b_file.bin',width:'40px',height:'40px',alt:'itsallgoodvegan'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h6',{className:'mt-0'},'itsallgoodvegan'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,'Marissa Wong')))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'menu'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{className:'cls-btn'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',width:'11',height:'11',viewBox:'0 0 11 11',fill:'none'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('path',{d:'M1.90372 10.2268L0.903723 9.27106L4.90372 5.44818L0.903718 1.6253L1.90372 0.669587L5.90372 4.49246L9.90372 0.669592L10.9037 1.62531L6.90372 5.44818L10.9037 9.27106L9.90372 10.2268L5.90372 6.4039L1.90372 10.2268Z',fill:'#1C1B1F'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/user/cheerfulchoices',title:'cheerfulchoices',className:'media'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-left'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6c7c3c80ecd4eac86050b504aa6bc8bb_file.bin',width:'40px',height:'40px',alt:'itsallgoodvegan'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h6',{className:'mt-0'},'cheerfulchoices'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,'Mackenzie Burgess')))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('aside',{className:'search_box recent_box recomnd_you img_post_grid',style:{"display":"none"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h2',null,'Recommended for you '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'list_grp'},searchSuggestedPhoto.map(function(photo,i){var photoimage='';if(photo.get("image")&&photo.get("image").url()!==undefined){photoimage=photo.get("image").url();}else{photoimage="/images/default_userpic0.png";}{return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{key:i+100},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){togglePopup1(photo.id);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{className:'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:photoimage}))));}}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('aside',{className:'search_box search_recent_box top_account sugested_acunt'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tlt-part d-flex flex-row flex-wrap align-items-center justify-content-between '},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h2',null,'Top accounts'),searchloading&&searchusers&&searchusers.length>4?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'#',title:'See more',className:'see-link',onClick:this.topAccounts},'See more...'):""),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'cnt-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'list_grp'},searchloading&&searchusers.map(function(user,i){if(i<3){var userimage='';if(user.get("profilePictureSmall")&&user.get("profilePictureSmall").url()!==undefined){userimage=user.get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}{return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'menu',key:i+100},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);',className:'media',onClick:function onClick(e){handleClickUserHistory(user.id,user.get("displayUsername"),userimage,filterSearchTitleCommon,user.get("displayName"));}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-left'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:userimage,width:'40px',height:'40px',alt:user.get("displayUsername")?user.get("displayUsername"):''})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-body'},user.get("displayName")?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h6',{className:'mt-0'},user.get("displayName")):'',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,user.get("displayUsername")?user.get("displayUsername"):''))));}}})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('aside',{className:'search_box search_recent_box top_post img_post_grid'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tlt-part d-flex flex-row flex-wrap align-items-center justify-content-between '},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h2',null,'Top posts '),searchloading1&&searchSuggestedPhoto&&searchSuggestedPhoto.length>4?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:filterSearchTitle?'/search?q='+filterSearchTitle:'',title:'See more',className:'see-link'},'See more...'):""),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'cnt-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'list_grp'},searchSuggestedPhoto.map(function(photo,i){if(i<4){var photoimage='';if(photo.get("image")&&photo.get("image").url()!==undefined){photoimage=photo.get("image").url();}else{photoimage="/images/default_userpic0.png";}{/*href='javascript:void(0);' onClick={(e) => {togglePopup1(photo.id);}}*/}{return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{key:i+100},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);',id:photo.id,onClick:function onClick(e){streamid(photo.id);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{className:'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:photoimage}))));}}}))))):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('aside',{className:'search_box sugested_acunt all-acunts',style:{"display":"none"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tlt-part d-flex flex-row flex-wrap align-items-center justify-content-between '},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'#',title:'All Accounts',onClick:this.backAccounts},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/back_top.svg',alt:'Back to Top'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h2',null,'All accounts')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'cnt-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'list_grp'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('aside',{className:'search_box recent_box recomnd_you img_post_grid',style:{"display":"none"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h2',null,'Recommended for you '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'list_grp'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('aside',{className:'search_box search_recent_box top_account sugested_acunt'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tlt-part d-flex flex-row flex-wrap align-items-center justify-content-between '},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h2',null,'Recent')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'cnt-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'list_grp'},searchHistoryData.map(function(user,i){if(i<3){var userimage='';if(user.get("profilePictureSmall")&&user.get("profilePictureSmall")!==undefined){userimage=user.get("profilePictureSmall");}else{userimage="/images/default_userpic0.png";}{return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'menu',key:i+100},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{className:'cls-btn',onClick:function onClick(e){searchAccountRemoveData(user.id);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',width:'11',height:'11',viewBox:'0 0 11 11',fill:'none'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('path',{d:'M1.90372 10.2268L0.903723 9.27106L4.90372 5.44818L0.903718 1.6253L1.90372 0.669587L5.90372 4.49246L9.90372 0.669592L10.9037 1.62531L6.90372 5.44818L10.9037 9.27106L9.90372 10.2268L5.90372 6.4039L1.90372 10.2268Z',fill:'#1C1B1F'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',_defineProperty({href:'javascript:void(0);',className:'media',onClick:function onClick(e){handleClickUserHistory(user.id,user.get("displayUsername"),userimage,filterSearchTitleCommon,user.get("displayName"));},title:user.get("displayUsername")?user.get("displayUsername"):''},'className','media'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-left'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:userimage,width:'40px',height:'40px',alt:user.get("displayUsername")?user.get("displayUsername"):''})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-body'},user.get("displayName")?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h6',{className:'mt-0'},user.get("displayName")):'',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,user.get("displayUsername")?user.get("displayUsername"):''))));}}})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('aside',{className:'search_box search_recent_box top_post img_post_grid'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tlt-part d-flex flex-row flex-wrap align-items-center justify-content-between '},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h2',null,'Recommended for you ')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'cnt-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'list_grp'},searchSuggestedPhoto.map(function(photo,i){if(i<4){var photoimage='';if(photo.get("image")&&photo.get("image").url()!==undefined){photoimage=photo.get("image").url();}else{photoimage="/images/default_userpic0.png";}{return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{key:i+100},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){streamid(photo.id);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{className:'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:photoimage}))));}}}))))))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'menu-search-wrap menu-search-social d-flex flex-row flex-wrap align-items-md-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'menu_nav d-flex flex-row flex-wrap'},fetchUsername!=""&&fetchUsername!=null?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'signup_nav user_prfl_nav btn-group'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'signup_nav_grp'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{type:'button',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},this.state.userImage!==null?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{height:'150',width:'150',className:'userProfileImageLarge',src:this.state.userImage,alt:fetchUsername}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{height:'150',width:'150',src:'/images/default_userpic0.png',alt:'Profile Picture'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'dropdown-item',onClick:this.handleDeleteAccount,type:'button'},'Delete Account'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'dropdown-item',onClick:this.handleLogoutfunc,type:'button'},'Log Out'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{style:{display:"none"},href:'javascript:void(0);',type:'button',className:'btn','data-toggle':'modal','data-target':'#deleteaccount',id:'deleteaccountid'},'get '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{style:{display:"none"},href:'javascript:void(0);',type:'button',className:'btn','data-toggle':'modal','data-target':'#deleteaccountMsg',id:'deleteaccountidMsg'},'get ')))):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'signup_nav cta_btn d-flex flex-row flex-wrap'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'secondary-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{type:'button',className:'btn','data-toggle':'modal','data-target':'#loginModal',id:'login_popup_btn'},'Log in '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{style:{display:"none"},href:'javascript:void(0);',type:'button',className:'btn','data-toggle':'modal','data-target':'#kitchenQrModal',id:'kitchenQrModal_btn'},'get ')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'primary-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{type:'button',className:'btn','data-toggle':'modal','data-target':'#registrationModal',id:'register_popup_btn'},'Sign up '))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{id:'handlemenu',style:{display:"none"},className:'btn btn-primary',onClick:this.selectSection},'menu')))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{type:'hidden',name:'current_weburl',id:'current_weburl',value:window.location.pathname})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay createPostCloseModal',id:'deleteaccount',tabIndex:'-1',role:'dialog','data-backdrop':'true','data-keyboard':'true','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h6',null,'Are you sure you want to delete account?')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn danger btn-post-discard','data-dismiss':'modal','aria-label':'Close',title:'Yes',onClick:this.deleteUserAccount},'Yes'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel',onClick:this.checkCancel,'data-dismiss':'modal','aria-label':'Close',title:'No'},'No'))))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay createPostCloseModal',id:'deleteaccountMsg',tabIndex:'-1',role:'dialog','data-backdrop':'true','data-keyboard':'true','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h6',null,'Account Deleted')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'action-part'})))))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this4=this;this.fetchSearchData=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _state2,filterSearchTitle,filterSearchTitle1,query,results;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_state2=_this4.state,filterSearchTitle=_state2.filterSearchTitle,filterSearchTitle1=_state2.filterSearchTitle1;query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('_User');query.limit(100);query.include("profilePictureSmall");query.include("displayName");query.include("displayUsername");query.descending("createdAt");if(filterSearchTitle){query.contains('displayUsername',filterSearchTitle);//query.matches('displayUsername',  '/^'+filterSearchTitle+'/i');
//query.containedIn('displayUsername', [filterSearchTitle]);
}/*if (filterSearchTitle1) {
      query.contains('displayUsername', filterSearchTitle1);
    }*/_context.prev=8;_context.next=11;return query.find();case 11:results=_context.sent;_this4.setState({searchusers:results,searchloading:true});_context.next=18;break;case 15:_context.prev=15;_context.t0=_context['catch'](8);console.error('Error while fetching books:',_context.t0);case 18:/*await query.find()
      .then(results => { console.log(results);
        this.setState({
          searchusers: results,
          searchloading: true
        });
      })*//*.catch(error => {
        console.error('Error fetching data:', error);
        this.setState({ searchloading: false });
      });*/_this4.getSuggestedUserId();case 19:case'end':return _context.stop();}}},_callee,_this4,[[8,15]]);}));this.searchClear=function(event){_this4.setState({filterSearchTitle:''},function(){_this4.setState({searchloading:true},function(){_this4.fetchSearchData();});__WEBPACK_IMPORTED_MODULE_4_jquery___default()("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn .search_inpt_inner").siblings(".search_rstl_mn").removeClass("active");__WEBPACK_IMPORTED_MODULE_4_jquery___default()("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn button.close-btn").addClass("hide");});_this4.backAccounts();};this.handleSearchFilterChange1=function(event){var queryString=window.location.href;var challenge_id=queryString?queryString.split("/")[3]:'';var part=challenge_id?challenge_id.split('='):'';var searchtext=part?part[1]:'';var self=_this4;_this4.state.filterSearchTitle1=searchtext;_this4.state.filterSearchTitle='';_this4.setState({searchloading:true},function(){_this4.fetchSearchData();});};this.handleSearchFilterChange=function(event){var queryString=window.location.href;var challenge_id=queryString?queryString.split("/")[4]:'';var part=challenge_id?challenge_id.split('='):'';var searchtext=part?part[1]:'';var searchval='';if(event&&event.target.value){searchval=event.target.value;}/* if(searchtext){
             searchval=searchtext;
     }*/// var searchval=searchval;
//console.log(searchval+'searchval 111');
localStorage.setItem('storestreamtabValue',event.target.value);_this4.setState({filterSearchTitle:event.target.value,filterSearchTitle1:''},function(){_this4.setState({searchloading:true},function(){_this4.fetchSearchData();});});/*return ( <div className=''><SearchPage  postData={event.target.value}/>   
                </div>
        );*/};this.handleLogoutfunc=function(e){Object(__WEBPACK_IMPORTED_MODULE_8__common__["a" /* commonLogoutFunction */])();};this.handleDeleteAccount=function(e){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#deleteaccountid').click();};this.deleteUserAccount=function(e){var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var photoquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');photoquery.equalTo('user',currentUser);var self=this;photoquery.find().then(function(photo){if(photo){var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=photo[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var photos=_step2.value;//like
var photoid=photos.id;var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');// checklikequery.equalTo('photo', "Photo$"+photos.id); console.log(photos.id+'photo.id');
checklikequery.equalTo('fromUser',currentUser);checklikequery.find().then(function(object){if(object){var _loop=function _loop(objects){objects.destroy();if(photoid!==objects.get('photo').id){checklikequerycount=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequerycount.equalTo('photo',"Photo$"+objects.get('photo').id);checklikequerycount.doesNotExist("activity");checklikequerycount.find().then(function(objectlike){if(objectlike.length){console.log('objectlike');console.log(objectlike);var likeCountNew=objectlike.length?objectlike.length:0;var getPhotoquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');getPhotoquery.equalTo('objectId',objects.get('photo').id);getPhotoquery.find().then(function(photo){if(photo){var photo_ob=photo[0];//var commentcount= totalcomment?totalcomment:0;
photo_ob.set("likeCountNew",likeCountNew);photo_ob.save();}});}});}};var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=object[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var objects=_step3.value;var checklikequerycount;_loop(objects);}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});//like
//activity
var checkActivityquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');//checklikequery.equalTo('photo', "Photo$"+photos.id); 
checkActivityquery.equalTo('fromUser',currentUser);checkActivityquery.find().then(function(object){if(object){var _loop2=function _loop2(objects){objects.destroy();if(photoid!==objects.get('photo').id){checkActivityquerynew=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');checkActivityquerynew.equalTo('photo',"Photo$"+objects.get('photo').id);checkActivityquerynew.find().then(function(object){if(object){var commentcount=object.length?object.length:0;var getPhotoquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');getPhotoquery.equalTo('objectId',objects.get('photo').id);getPhotoquery.find().then(function(photo){if(photo){var photo_ob=photo[0];//var commentcount= totalcomment?totalcomment:0;
photo_ob.set("commentcount",commentcount.toString());photo_ob.save();}});//like count check
var checkActivityquerynewcount=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');//checkActivityquerynewcount.equalTo('photo', "Photo$"+objects.get('photo').id); 
// console.log(object[0].id+'DDD');
var newactivity_id=object[0].id;checkActivityquerynewcount.equalTo('activity',"Activity$"+newactivity_id);checkActivityquerynewcount.find().then(function(objectdata){if(objectdata){if(objectdata.length){var likecount=objectdata.length?objectdata.length:0;var queryActivitydata=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');queryActivitydata.equalTo('objectId',newactivity_id);queryActivitydata.find().then(function(activityUpdate){if(activityUpdate){var activity_ob=activityUpdate[0];activity_ob.set("likeCount",likecount);activity_ob.save();}});}}});//like count check
}});//save
//save
checkSavequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Save');checkSavequery.equalTo('photo',"Photo$"+objects.get('photo').id);checkSavequery.find().then(function(object){if(object){var _iteratorNormalCompletion5=true;var _didIteratorError5=false;var _iteratorError5=undefined;try{for(var _iterator5=object[Symbol.iterator](),_step5;!(_iteratorNormalCompletion5=(_step5=_iterator5.next()).done);_iteratorNormalCompletion5=true){var _objects=_step5.value;_objects.destroy();}}catch(err){_didIteratorError5=true;_iteratorError5=err;}finally{try{if(!_iteratorNormalCompletion5&&_iterator5.return){_iterator5.return();}}finally{if(_didIteratorError5){throw _iteratorError5;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});//save
//save
}};var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=object[Symbol.iterator](),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){var objects=_step4.value;var checkActivityquerynew;var checkSavequery;_loop2(objects);}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});//activity
//save
var checkSavequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Save');checkSavequery.equalTo('photo',"Photo$"+photoid);checkSavequery.find().then(function(object){if(object){var _iteratorNormalCompletion6=true;var _didIteratorError6=false;var _iteratorError6=undefined;try{for(var _iterator6=object[Symbol.iterator](),_step6;!(_iteratorNormalCompletion6=(_step6=_iterator6.next()).done);_iteratorNormalCompletion6=true){var objects=_step6.value;objects.destroy();}}catch(err){_didIteratorError6=true;_iteratorError6=err;}finally{try{if(!_iteratorNormalCompletion6&&_iterator6.return){_iterator6.return();}}finally{if(_didIteratorError6){throw _iteratorError6;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});//save
//notification
var checkSavequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Notification');checkSavequery.equalTo('photo',"Photo$"+photoid);checkSavequery.find().then(function(object){if(object){var _iteratorNormalCompletion7=true;var _didIteratorError7=false;var _iteratorError7=undefined;try{for(var _iterator7=object[Symbol.iterator](),_step7;!(_iteratorNormalCompletion7=(_step7=_iterator7.next()).done);_iteratorNormalCompletion7=true){var objects=_step7.value;objects.destroy();}}catch(err){_didIteratorError7=true;_iteratorError7=err;}finally{try{if(!_iteratorNormalCompletion7&&_iterator7.return){_iterator7.return();}}finally{if(_didIteratorError7){throw _iteratorError7;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});//notification
photos.destroy();//delete photo
}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}});//like 
var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');// checklikequery.equalTo('photo', "Photo$"+photos.id); console.log(photos.id+'photo.id');
checklikequery.equalTo('fromUser',currentUser);checklikequery.find().then(function(object){if(object){var _loop3=function _loop3(objects){console.log('out ');console.log(objects);objects.destroy();if(objects.get('photo').id){checklikequerycount=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequerycount.equalTo('photo',"Photo$"+objects.get('photo').id);checklikequerycount.doesNotExist("activity");checklikequerycount.find().then(function(objectlike){if(objectlike.length){console.log('objectlike');console.log(objectlike);var likeCountNew=objectlike.length?objectlike.length:0;var getPhotoquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');getPhotoquery.equalTo('objectId',objects.get('photo').id);getPhotoquery.find().then(function(photo){if(photo){console.log(likeCountNew);var photo_ob=photo[0];//var commentcount= totalcomment?totalcomment:0;
photo_ob.set("likeCountNew",likeCountNew);photo_ob.save();}});}});//new
checkActivityquerynew=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');checkActivityquerynew.equalTo('photo',"Photo$"+objects.get('photo').id);checkActivityquerynew.find().then(function(object){if(object){/*var commentcount= object.length?object.length:0;
                                  var getPhotoquery = new Parse.Query('Photo');  
                                  getPhotoquery.equalTo('objectId', objects.get('photo').id);
                                  getPhotoquery.find().then(function(photo){
                                  if(photo)
                                  {
                                      let photo_ob=photo[0];
                                     
                                        photo_ob.set("commentcount", commentcount.toString()); 
                                        photo_ob.save();
                                      }
                                  });*///like count check
var checkActivityquerynewcount=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');var newactivity_id=object[0].id;checkActivityquerynewcount.equalTo('activity',"Activity$"+newactivity_id);checkActivityquerynewcount.find().then(function(objectdata){if(objectdata){if(objectdata.length){var likecount=objectdata.length?objectdata.length:0;var queryActivitydata=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');queryActivitydata.equalTo('objectId',newactivity_id);queryActivitydata.find().then(function(activityUpdate){if(activityUpdate){var activity_ob=activityUpdate[0];activity_ob.set("likeCount",likecount);activity_ob.save();}});}}});//like count check
}});//new
}};var _iteratorNormalCompletion8=true;var _didIteratorError8=false;var _iteratorError8=undefined;try{for(var _iterator8=object[Symbol.iterator](),_step8;!(_iteratorNormalCompletion8=(_step8=_iterator8.next()).done);_iteratorNormalCompletion8=true){var objects=_step8.value;var checklikequerycount;var checkActivityquerynew;_loop3(objects);}}catch(err){_didIteratorError8=true;_iteratorError8=err;}finally{try{if(!_iteratorNormalCompletion8&&_iterator8.return){_iterator8.return();}}finally{if(_didIteratorError8){throw _iteratorError8;}}}}});//like
setTimeout(function(){currentUser.destroy().then(function(){console.log('User account deleted successfully');Object(__WEBPACK_IMPORTED_MODULE_8__common__["a" /* commonLogoutFunction */])();}).catch(function(error){console.error('Error while deleting user account:',error);});},5000);}};this.selectSection=function(e){// $('#navbarinner .loggedin_nav').attr("style", "display: block");
//$('#navbarinner .signup_nav').attr("style", "display: none");
};this.searchSuggestion=function(event){_this4.setState({searchloading:true},function(){_this4.getSuggestedUserId();_this4.fetchSearchData();});/*this.state.filterSearchTitle1=searchtext;
       this.state.filterSearchTitle='';
       this.setState({ searchloading: true }, () => {
        this.fetchSearchData();
        });*/__WEBPACK_IMPORTED_MODULE_4_jquery___default()("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn .search_inpt_inner").siblings(".search_rstl_mn").addClass("active");__WEBPACK_IMPORTED_MODULE_4_jquery___default()("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn button.close-btn").removeClass("hide");};this.saveSearchHistory=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(SearchTitle){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:case'end':return _context2.stop();}}},_callee2,_this4);}));return function(_x){return _ref2.apply(this,arguments);};}();this.handleSearch=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(SearchTitle){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:console.log('handleSearch');//const fetchedResults = await this.performSearch(term);
// this.setState({ results: fetchedResults });
//await this.saveSearchHistory(SearchTitle);
case 1:case'end':return _context3.stop();}}},_callee3,_this4);}));return function(_x2){return _ref3.apply(this,arguments);};}();this.handleSubmit=function(e){e.preventDefault();//self.handleSearch(this.state.filterSearchTitle);
//console.log(this.state.filterSearchTitle);
//window.location.href = "/search?q="+this.state.filterSearchTitle;
var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var Searchhistory=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Searchhistory");var searchhistory=new Searchhistory();searchhistory.set('objectid','');searchhistory.set('displayUsername',_this4.state.filterSearchTitle);searchhistory.set('displayName',_this4.state.filterSearchTitle);searchhistory.set('profilePictureSmall','');searchhistory.set('customtext',_this4.state.filterSearchTitle);searchhistory.set('type','search');searchhistory.set('user',currentUser);searchhistory.save().then(function(savedhistory){// window.location.href = "/user/"+displayUsernames;
window.location.href="/search?q="+_this4.state.filterSearchTitle;}).catch(function(error){});}};};/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(188);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 188 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _decode = __webpack_require__(45);

var _decode2 = _interopRequireDefault(_decode);

var _encode = __webpack_require__(36);

var _encode2 = _interopRequireDefault(_encode);

var _CoreManager = __webpack_require__(9);

var _CoreManager2 = _interopRequireDefault(_CoreManager);

var _InstallationController = __webpack_require__(245);

var _InstallationController2 = _interopRequireDefault(_InstallationController);

var _ParseOp = __webpack_require__(43);

var ParseOp = _interopRequireWildcard(_ParseOp);

var _RESTController = __webpack_require__(246);

var _RESTController2 = _interopRequireDefault(_RESTController);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Contains all Parse API classes and functions.
 * @static
 * @global
 * @class
 * @hideconstructor
 */
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

var Parse = {
  /**
   * Call this method first to set up your authentication tokens for Parse.
   * You can get your keys from the Data Browser on parse.com.
   * @param {String} applicationId Your Parse Application ID.
   * @param {String} javaScriptKey (optional) Your Parse JavaScript Key (Not needed for parse-server)
   * @param {String} masterKey (optional) Your Parse Master Key. (Node.js only!)
   * @static
   */
  initialize: function (applicationId, javaScriptKey) {
    if ('browser' === 'browser' && _CoreManager2.default.get('IS_NODE') && !undefined) {
      console.log('It looks like you\'re using the browser version of the SDK in a ' + 'node.js environment. You should require(\'parse/node\') instead.');
    }
    Parse._initialize(applicationId, javaScriptKey);
  },
  _initialize: function (applicationId, javaScriptKey, masterKey) {
    _CoreManager2.default.set('APPLICATION_ID', applicationId);
    _CoreManager2.default.set('JAVASCRIPT_KEY', javaScriptKey);
    _CoreManager2.default.set('MASTER_KEY', masterKey);
    _CoreManager2.default.set('USE_MASTER_KEY', false);
  },

  /**
   * Call this method to set your AsyncStorage engine
   * Starting Parse@1.11, the ParseSDK do not provide a React AsyncStorage as the ReactNative module
   * is not provided at a stable path and changes over versions.
   * @param {AsyncStorage} storage a react native async storage.
   * @static
   */
  setAsyncStorage: function (storage) {
    _CoreManager2.default.setAsyncStorage(storage);
  }
};

/** These legacy setters may eventually be deprecated **/
/** 
 * @member Parse.applicationId
 * @type string
 * @static
 */
Object.defineProperty(Parse, 'applicationId', {
  get: function () {
    return _CoreManager2.default.get('APPLICATION_ID');
  },
  set: function (value) {
    _CoreManager2.default.set('APPLICATION_ID', value);
  }
});

/** 
 * @member Parse.javaScriptKey
 * @type string
 * @static
 */
Object.defineProperty(Parse, 'javaScriptKey', {
  get: function () {
    return _CoreManager2.default.get('JAVASCRIPT_KEY');
  },
  set: function (value) {
    _CoreManager2.default.set('JAVASCRIPT_KEY', value);
  }
});

/** 
 * @member Parse.masterKey
 * @type string
 * @static
 */
Object.defineProperty(Parse, 'masterKey', {
  get: function () {
    return _CoreManager2.default.get('MASTER_KEY');
  },
  set: function (value) {
    _CoreManager2.default.set('MASTER_KEY', value);
  }
});

/** 
 * @member Parse.serverURL
 * @type string
 * @static
 */
Object.defineProperty(Parse, 'serverURL', {
  get: function () {
    return _CoreManager2.default.get('SERVER_URL');
  },
  set: function (value) {
    _CoreManager2.default.set('SERVER_URL', value);
  }
});
/** 
 * @member Parse.liveQueryServerURL
 * @type string
 * @static
 */
Object.defineProperty(Parse, 'liveQueryServerURL', {
  get: function () {
    return _CoreManager2.default.get('LIVEQUERY_SERVER_URL');
  },
  set: function (value) {
    _CoreManager2.default.set('LIVEQUERY_SERVER_URL', value);
  }
});
/* End setters */

Parse.ACL = __webpack_require__(41).default;
Parse.Analytics = __webpack_require__(247);
Parse.Cloud = __webpack_require__(248);
Parse.CoreManager = __webpack_require__(9);
Parse.Config = __webpack_require__(249).default;
Parse.Error = __webpack_require__(28).default;
Parse.FacebookUtils = __webpack_require__(250).default;
Parse.File = __webpack_require__(29).default;
Parse.GeoPoint = __webpack_require__(44).default;
Parse.Polygon = __webpack_require__(65).default;
Parse.Installation = __webpack_require__(251).default;
Parse.Object = __webpack_require__(8).default;
Parse.Op = {
  Set: ParseOp.SetOp,
  Unset: ParseOp.UnsetOp,
  Increment: ParseOp.IncrementOp,
  Add: ParseOp.AddOp,
  Remove: ParseOp.RemoveOp,
  AddUnique: ParseOp.AddUniqueOp,
  Relation: ParseOp.RelationOp
};
Parse.Promise = __webpack_require__(7).default;
Parse.Push = __webpack_require__(252);
Parse.Query = __webpack_require__(66).default;
Parse.Relation = __webpack_require__(30).default;
Parse.Role = __webpack_require__(118).default;
Parse.Schema = __webpack_require__(253).default;
Parse.Session = __webpack_require__(134).default;
Parse.Storage = __webpack_require__(51);
Parse.User = __webpack_require__(68).default;
Parse.LiveQuery = __webpack_require__(254).default;
Parse.LiveQueryClient = __webpack_require__(135).default;

Parse._request = function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return _CoreManager2.default.getRESTController().request.apply(null, args);
};
Parse._ajax = function () {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return _CoreManager2.default.getRESTController().ajax.apply(null, args);
};
// We attempt to match the signatures of the legacy versions of these methods
Parse._decode = function (_, value) {
  return (0, _decode2.default)(value);
};
Parse._encode = function (value, _, disallowObjects) {
  return (0, _encode2.default)(value, disallowObjects);
};
Parse._getInstallationId = function () {
  return _CoreManager2.default.getInstallationController().currentInstallationId();
};

_CoreManager2.default.setInstallationController(_InstallationController2.default);
_CoreManager2.default.setRESTController(_RESTController2.default);

// For legacy requires, of the form `var Parse = require('parse').Parse`
Parse.Parse = Parse;

module.exports = Parse;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(191), __esModule: true };

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(76);
__webpack_require__(61);
module.exports = __webpack_require__(88).f('iterator');


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(77);
var defined = __webpack_require__(78);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(58);
var descriptor = __webpack_require__(57);
var setToStringTag = __webpack_require__(60);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(24)(IteratorPrototype, __webpack_require__(15)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(18);
var anObject = __webpack_require__(21);
var getKeys = __webpack_require__(47);

module.exports = __webpack_require__(19) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(33);
var toLength = __webpack_require__(84);
var toAbsoluteIndex = __webpack_require__(196);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(77);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(17).document;
module.exports = document && document.documentElement;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(199);
var step = __webpack_require__(115);
var Iterators = __webpack_require__(46);
var toIObject = __webpack_require__(33);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(79)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(201), __esModule: true };

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(202);
__webpack_require__(92);
__webpack_require__(205);
__webpack_require__(206);
module.exports = __webpack_require__(5).Symbol;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(17);
var has = __webpack_require__(26);
var DESCRIPTORS = __webpack_require__(19);
var $export = __webpack_require__(16);
var redefine = __webpack_require__(81);
var META = __webpack_require__(40).KEY;
var $fails = __webpack_require__(25);
var shared = __webpack_require__(86);
var setToStringTag = __webpack_require__(60);
var uid = __webpack_require__(59);
var wks = __webpack_require__(15);
var wksExt = __webpack_require__(88);
var wksDefine = __webpack_require__(89);
var enumKeys = __webpack_require__(203);
var isArray = __webpack_require__(116);
var anObject = __webpack_require__(21);
var isObject = __webpack_require__(14);
var toIObject = __webpack_require__(33);
var toPrimitive = __webpack_require__(80);
var createDesc = __webpack_require__(57);
var _create = __webpack_require__(58);
var gOPNExt = __webpack_require__(204);
var $GOPD = __webpack_require__(91);
var $DP = __webpack_require__(18);
var $keys = __webpack_require__(47);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(117).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(62).f = $propertyIsEnumerable;
  __webpack_require__(90).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(56)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(24)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(47);
var gOPS = __webpack_require__(90);
var pIE = __webpack_require__(62);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(33);
var gOPN = __webpack_require__(117).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(89)('asyncIterator');


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(89)('observable');


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(208);
module.exports = __webpack_require__(5).Object.keys;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(48);
var $keys = __webpack_require__(47);

__webpack_require__(63)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(210);
var $Object = __webpack_require__(5).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(16);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(19), 'Object', { defineProperty: __webpack_require__(18).f });


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(212);
module.exports = __webpack_require__(5).Object.getPrototypeOf;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(48);
var $getPrototypeOf = __webpack_require__(114);

__webpack_require__(63)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(214), __esModule: true };

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(215);
var $Object = __webpack_require__(5).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(33);
var $getOwnPropertyDescriptor = __webpack_require__(91).f;

__webpack_require__(63)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(217), __esModule: true };

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(218);
module.exports = __webpack_require__(5).Object.setPrototypeOf;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(16);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(219).set });


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(14);
var anObject = __webpack_require__(21);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(39)(Function.call, __webpack_require__(91).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(221);
var $Object = __webpack_require__(5).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(16);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(58) });


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(223), __esModule: true };

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(224);
module.exports = __webpack_require__(5).Object.freeze;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(14);
var meta = __webpack_require__(40).onFreeze;

__webpack_require__(63)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(5);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = canBeSerialized;

var _ParseFile = __webpack_require__(29);

var _ParseFile2 = _interopRequireDefault(_ParseFile);

var _ParseObject = __webpack_require__(8);

var _ParseObject2 = _interopRequireDefault(_ParseObject);

var _ParseRelation = __webpack_require__(30);

var _ParseRelation2 = _interopRequireDefault(_ParseRelation);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function canBeSerialized(obj) {
  if (!(obj instanceof _ParseObject2.default)) {
    return true;
  }
  var attributes = obj.attributes;
  for (var attr in attributes) {
    var val = attributes[attr];
    if (!canBeSerializedHelper(val)) {
      return false;
    }
  }
  return true;
} /**
   * Copyright (c) 2015-present, Parse, LLC.
   * All rights reserved.
   *
   * This source code is licensed under the BSD-style license found in the
   * LICENSE file in the root directory of this source tree. An additional grant
   * of patent rights can be found in the PATENTS file in the same directory.
   *
   * 
   */

function canBeSerializedHelper(value) {
  if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) !== 'object') {
    return true;
  }
  if (value instanceof _ParseRelation2.default) {
    return true;
  }
  if (value instanceof _ParseObject2.default) {
    return !!value.id;
  }
  if (value instanceof _ParseFile2.default) {
    if (value.url()) {
      return true;
    }
    return false;
  }
  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      if (!canBeSerializedHelper(value[i])) {
        return false;
      }
    }
    return true;
  }
  for (var k in value) {
    if (!canBeSerializedHelper(value[k])) {
      return false;
    }
  }
  return true;
}

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61);
__webpack_require__(76);
module.exports = __webpack_require__(228);


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(21);
var get = __webpack_require__(122);
module.exports = __webpack_require__(5).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(49);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = equals;

var _ParseACL = __webpack_require__(41);

var _ParseACL2 = _interopRequireDefault(_ParseACL);

var _ParseFile = __webpack_require__(29);

var _ParseFile2 = _interopRequireDefault(_ParseFile);

var _ParseGeoPoint = __webpack_require__(44);

var _ParseGeoPoint2 = _interopRequireDefault(_ParseGeoPoint);

var _ParseObject = __webpack_require__(8);

var _ParseObject2 = _interopRequireDefault(_ParseObject);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

function equals(a, b) {
  if ((typeof a === 'undefined' ? 'undefined' : (0, _typeof3.default)(a)) !== (typeof b === 'undefined' ? 'undefined' : (0, _typeof3.default)(b))) {
    return false;
  }

  if (!a || (typeof a === 'undefined' ? 'undefined' : (0, _typeof3.default)(a)) !== 'object') {
    // a is a primitive
    return a === b;
  }

  if (Array.isArray(a) || Array.isArray(b)) {
    if (!Array.isArray(a) || !Array.isArray(b)) {
      return false;
    }
    if (a.length !== b.length) {
      return false;
    }
    for (var i = a.length; i--;) {
      if (!equals(a[i], b[i])) {
        return false;
      }
    }
    return true;
  }

  if (a instanceof _ParseACL2.default || a instanceof _ParseFile2.default || a instanceof _ParseGeoPoint2.default || a instanceof _ParseObject2.default) {
    return a.equals(b);
  }

  if ((0, _keys2.default)(a).length !== (0, _keys2.default)(b).length) {
    return false;
  }
  for (var k in a) {
    if (!equals(a[k], b[k])) {
      return false;
    }
  }
  return true;
}

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getState = getState;
exports.initializeState = initializeState;
exports.removeState = removeState;
exports.getServerData = getServerData;
exports.setServerData = setServerData;
exports.getPendingOps = getPendingOps;
exports.setPendingOp = setPendingOp;
exports.pushPendingState = pushPendingState;
exports.popPendingState = popPendingState;
exports.mergeFirstPendingState = mergeFirstPendingState;
exports.getObjectCache = getObjectCache;
exports.estimateAttribute = estimateAttribute;
exports.estimateAttributes = estimateAttributes;
exports.commitServerChanges = commitServerChanges;
exports.enqueueTask = enqueueTask;
exports.clearAllState = clearAllState;
exports.duplicateState = duplicateState;

var _ObjectStateMutations = __webpack_require__(128);

var ObjectStateMutations = _interopRequireWildcard(_ObjectStateMutations);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

var objectState = {}; /**
                       * Copyright (c) 2015-present, Parse, LLC.
                       * All rights reserved.
                       *
                       * This source code is licensed under the BSD-style license found in the
                       * LICENSE file in the root directory of this source tree. An additional grant
                       * of patent rights can be found in the PATENTS file in the same directory.
                       *
                       * 
                       */

function getState(obj) {
  var classData = objectState[obj.className];
  if (classData) {
    return classData[obj.id] || null;
  }
  return null;
}

function initializeState(obj, initial) {
  var state = getState(obj);
  if (state) {
    return state;
  }
  if (!objectState[obj.className]) {
    objectState[obj.className] = {};
  }
  if (!initial) {
    initial = ObjectStateMutations.defaultState();
  }
  state = objectState[obj.className][obj.id] = initial;
  return state;
}

function removeState(obj) {
  var state = getState(obj);
  if (state === null) {
    return null;
  }
  delete objectState[obj.className][obj.id];
  return state;
}

function getServerData(obj) {
  var state = getState(obj);
  if (state) {
    return state.serverData;
  }
  return {};
}

function setServerData(obj, attributes) {
  var serverData = initializeState(obj).serverData;
  ObjectStateMutations.setServerData(serverData, attributes);
}

function getPendingOps(obj) {
  var state = getState(obj);
  if (state) {
    return state.pendingOps;
  }
  return [{}];
}

function setPendingOp(obj, attr, op) {
  var pendingOps = initializeState(obj).pendingOps;
  ObjectStateMutations.setPendingOp(pendingOps, attr, op);
}

function pushPendingState(obj) {
  var pendingOps = initializeState(obj).pendingOps;
  ObjectStateMutations.pushPendingState(pendingOps);
}

function popPendingState(obj) {
  var pendingOps = initializeState(obj).pendingOps;
  return ObjectStateMutations.popPendingState(pendingOps);
}

function mergeFirstPendingState(obj) {
  var pendingOps = getPendingOps(obj);
  ObjectStateMutations.mergeFirstPendingState(pendingOps);
}

function getObjectCache(obj) {
  var state = getState(obj);
  if (state) {
    return state.objectCache;
  }
  return {};
}

function estimateAttribute(obj, attr) {
  var serverData = getServerData(obj);
  var pendingOps = getPendingOps(obj);
  return ObjectStateMutations.estimateAttribute(serverData, pendingOps, obj.className, obj.id, attr);
}

function estimateAttributes(obj) {
  var serverData = getServerData(obj);
  var pendingOps = getPendingOps(obj);
  return ObjectStateMutations.estimateAttributes(serverData, pendingOps, obj.className, obj.id);
}

function commitServerChanges(obj, changes) {
  var state = initializeState(obj);
  ObjectStateMutations.commitServerChanges(state.serverData, state.objectCache, changes);
}

function enqueueTask(obj, task) {
  var state = initializeState(obj);
  return state.tasks.enqueue(task);
}

function clearAllState() {
  objectState = {};
}

function duplicateState(source, dest) {
  dest.id = source.id;
}

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _weakMap = __webpack_require__(232);

var _weakMap2 = _interopRequireDefault(_weakMap);

exports.getState = getState;
exports.initializeState = initializeState;
exports.removeState = removeState;
exports.getServerData = getServerData;
exports.setServerData = setServerData;
exports.getPendingOps = getPendingOps;
exports.setPendingOp = setPendingOp;
exports.pushPendingState = pushPendingState;
exports.popPendingState = popPendingState;
exports.mergeFirstPendingState = mergeFirstPendingState;
exports.getObjectCache = getObjectCache;
exports.estimateAttribute = estimateAttribute;
exports.estimateAttributes = estimateAttributes;
exports.commitServerChanges = commitServerChanges;
exports.enqueueTask = enqueueTask;
exports.duplicateState = duplicateState;
exports.clearAllState = clearAllState;

var _ObjectStateMutations = __webpack_require__(128);

var ObjectStateMutations = _interopRequireWildcard(_ObjectStateMutations);

var _TaskQueue = __webpack_require__(129);

var _TaskQueue2 = _interopRequireDefault(_TaskQueue);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var objectState = new _weakMap2.default();

function getState(obj) {
  var classData = objectState.get(obj);
  return classData || null;
}

function initializeState(obj, initial) {
  var state = getState(obj);
  if (state) {
    return state;
  }
  if (!initial) {
    initial = {
      serverData: {},
      pendingOps: [{}],
      objectCache: {},
      tasks: new _TaskQueue2.default(),
      existed: false
    };
  }
  state = initial;
  objectState.set(obj, state);
  return state;
}

function removeState(obj) {
  var state = getState(obj);
  if (state === null) {
    return null;
  }
  objectState.delete(obj);
  return state;
}

function getServerData(obj) {
  var state = getState(obj);
  if (state) {
    return state.serverData;
  }
  return {};
}

function setServerData(obj, attributes) {
  var serverData = initializeState(obj).serverData;
  ObjectStateMutations.setServerData(serverData, attributes);
}

function getPendingOps(obj) {
  var state = getState(obj);
  if (state) {
    return state.pendingOps;
  }
  return [{}];
}

function setPendingOp(obj, attr, op) {
  var pendingOps = initializeState(obj).pendingOps;
  ObjectStateMutations.setPendingOp(pendingOps, attr, op);
}

function pushPendingState(obj) {
  var pendingOps = initializeState(obj).pendingOps;
  ObjectStateMutations.pushPendingState(pendingOps);
}

function popPendingState(obj) {
  var pendingOps = initializeState(obj).pendingOps;
  return ObjectStateMutations.popPendingState(pendingOps);
}

function mergeFirstPendingState(obj) {
  var pendingOps = getPendingOps(obj);
  ObjectStateMutations.mergeFirstPendingState(pendingOps);
}

function getObjectCache(obj) {
  var state = getState(obj);
  if (state) {
    return state.objectCache;
  }
  return {};
}

function estimateAttribute(obj, attr) {
  var serverData = getServerData(obj);
  var pendingOps = getPendingOps(obj);
  return ObjectStateMutations.estimateAttribute(serverData, pendingOps, obj.className, obj.id, attr);
}

function estimateAttributes(obj) {
  var serverData = getServerData(obj);
  var pendingOps = getPendingOps(obj);
  return ObjectStateMutations.estimateAttributes(serverData, pendingOps, obj.className, obj.id);
}

function commitServerChanges(obj, changes) {
  var state = initializeState(obj);
  ObjectStateMutations.commitServerChanges(state.serverData, state.objectCache, changes);
}

function enqueueTask(obj, task) {
  var state = initializeState(obj);
  return state.tasks.enqueue(task);
}

function duplicateState(source, dest) {
  var oldState = initializeState(source);
  var newState = initializeState(dest);
  for (var key in oldState.serverData) {
    newState.serverData[key] = oldState.serverData[key];
  }
  for (var index = 0; index < oldState.pendingOps.length; index++) {
    for (var _key in oldState.pendingOps[index]) {
      newState.pendingOps[index][_key] = oldState.pendingOps[index][_key];
    }
  }
  for (var _key2 in oldState.objectCache) {
    newState.objectCache[_key2] = oldState.objectCache[_key2];
  }
  newState.existed = oldState.existed;
}

function clearAllState() {
  objectState = new _weakMap2.default();
}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(233), __esModule: true };

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(92);
__webpack_require__(61);
__webpack_require__(234);
__webpack_require__(241);
__webpack_require__(242);
module.exports = __webpack_require__(5).WeakMap;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(94)(0);
var redefine = __webpack_require__(81);
var meta = __webpack_require__(40);
var assign = __webpack_require__(237);
var weak = __webpack_require__(238);
var isObject = __webpack_require__(14);
var fails = __webpack_require__(25);
var validate = __webpack_require__(67);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(130)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(236);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var isArray = __webpack_require__(116);
var SPECIES = __webpack_require__(15)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(47);
var gOPS = __webpack_require__(90);
var pIE = __webpack_require__(62);
var toObject = __webpack_require__(48);
var IObject = __webpack_require__(82);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(25)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(95);
var getWeak = __webpack_require__(40).getWeak;
var anObject = __webpack_require__(21);
var isObject = __webpack_require__(14);
var anInstance = __webpack_require__(96);
var forOf = __webpack_require__(50);
var createArrayMethod = __webpack_require__(94);
var $has = __webpack_require__(26);
var validate = __webpack_require__(67);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(21);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(46);
var ITERATOR = __webpack_require__(15)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(131)('WeakMap');


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(132)('WeakMap');


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = unsavedChildren;

var _ParseFile = __webpack_require__(29);

var _ParseFile2 = _interopRequireDefault(_ParseFile);

var _ParseObject = __webpack_require__(8);

var _ParseObject2 = _interopRequireDefault(_ParseObject);

var _ParseRelation = __webpack_require__(30);

var _ParseRelation2 = _interopRequireDefault(_ParseRelation);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Return an array of unsaved children, which are either Parse Objects or Files.
 * If it encounters any dirty Objects without Ids, it will throw an exception.
 */
function unsavedChildren(obj, allowDeepUnsaved) {
  var encountered = {
    objects: {},
    files: []
  };
  var identifier = obj.className + ':' + obj._getId();
  encountered.objects[identifier] = obj.dirty() ? obj : true;
  var attributes = obj.attributes;
  for (var attr in attributes) {
    if ((0, _typeof3.default)(attributes[attr]) === 'object') {
      traverse(attributes[attr], encountered, false, !!allowDeepUnsaved);
    }
  }
  var unsaved = [];
  for (var id in encountered.objects) {
    if (id !== identifier && encountered.objects[id] !== true) {
      unsaved.push(encountered.objects[id]);
    }
  }
  return unsaved.concat(encountered.files);
} /**
   * Copyright (c) 2015-present, Parse, LLC.
   * All rights reserved.
   *
   * This source code is licensed under the BSD-style license found in the
   * LICENSE file in the root directory of this source tree. An additional grant
   * of patent rights can be found in the PATENTS file in the same directory.
   *
   * 
   */

function traverse(obj, encountered, shouldThrow, allowDeepUnsaved) {
  if (obj instanceof _ParseObject2.default) {
    if (!obj.id && shouldThrow) {
      throw new Error('Cannot create a pointer to an unsaved Object.');
    }
    var identifier = obj.className + ':' + obj._getId();
    if (!encountered.objects[identifier]) {
      encountered.objects[identifier] = obj.dirty() ? obj : true;
      var attributes = obj.attributes;
      for (var attr in attributes) {
        if ((0, _typeof3.default)(attributes[attr]) === 'object') {
          traverse(attributes[attr], encountered, !allowDeepUnsaved, allowDeepUnsaved);
        }
      }
    }
    return;
  }
  if (obj instanceof _ParseFile2.default) {
    if (!obj.url() && encountered.files.indexOf(obj) < 0) {
      encountered.files.push(obj);
    }
    return;
  }
  if (obj instanceof _ParseRelation2.default) {
    return;
  }
  if (Array.isArray(obj)) {
    obj.forEach(function (el) {
      if ((typeof el === 'undefined' ? 'undefined' : (0, _typeof3.default)(el)) === 'object') {
        traverse(el, encountered, shouldThrow, allowDeepUnsaved);
      }
    });
  }
  for (var k in obj) {
    if ((0, _typeof3.default)(obj[k]) === 'object') {
      traverse(obj[k], encountered, shouldThrow, allowDeepUnsaved);
    }
  }
}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ParsePromise = __webpack_require__(7);

var _ParsePromise2 = _interopRequireDefault(_ParsePromise);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var StorageController = {
  async: 0,

  getItem: function (path) {
    return localStorage.getItem(path);
  },
  setItem: function (path, value) {
    try {
      localStorage.setItem(path, value);
    } catch (e) {
      // Quota exceeded, possibly due to Safari Private Browsing mode
    }
  },
  removeItem: function (path) {
    localStorage.removeItem(path);
  },
  clear: function () {
    localStorage.clear();
  }
}; /**
    * Copyright (c) 2015-present, Parse, LLC.
    * All rights reserved.
    *
    * This source code is licensed under the BSD-style license found in the
    * LICENSE file in the root directory of this source tree. An additional grant
    * of patent rights can be found in the PATENTS file in the same directory.
    *
    * 
    */

module.exports = StorageController;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CoreManager = __webpack_require__(9);

var _CoreManager2 = _interopRequireDefault(_CoreManager);

var _ParsePromise = __webpack_require__(7);

var _ParsePromise2 = _interopRequireDefault(_ParsePromise);

var _Storage = __webpack_require__(51);

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var iidCache = null; /**
                      * Copyright (c) 2015-present, Parse, LLC.
                      * All rights reserved.
                      *
                      * This source code is licensed under the BSD-style license found in the
                      * LICENSE file in the root directory of this source tree. An additional grant
                      * of patent rights can be found in the PATENTS file in the same directory.
                      *
                      * 
                      */

function hexOctet() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}

function generateId() {
  return hexOctet() + hexOctet() + '-' + hexOctet() + '-' + hexOctet() + '-' + hexOctet() + '-' + hexOctet() + hexOctet() + hexOctet();
}

var InstallationController = {
  currentInstallationId: function () {
    if (typeof iidCache === 'string') {
      return _ParsePromise2.default.as(iidCache);
    }
    var path = _Storage2.default.generatePath('installationId');
    return _Storage2.default.getItemAsync(path).then(function (iid) {
      if (!iid) {
        iid = generateId();
        return _Storage2.default.setItemAsync(path, iid).then(function () {
          iidCache = iid;
          return iid;
        });
      }
      iidCache = iid;
      return iid;
    });
  },
  _clearCache: function () {
    iidCache = null;
  },
  _setInstallationIdCache: function (iid) {
    iidCache = iid;
  }
};

module.exports = InstallationController;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = __webpack_require__(42);

var _stringify2 = _interopRequireDefault(_stringify);

var _CoreManager = __webpack_require__(9);

var _CoreManager2 = _interopRequireDefault(_CoreManager);

var _ParseError = __webpack_require__(28);

var _ParseError2 = _interopRequireDefault(_ParseError);

var _ParsePromise = __webpack_require__(7);

var _ParsePromise2 = _interopRequireDefault(_ParsePromise);

var _Storage = __webpack_require__(51);

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var XHR = null;
if (typeof XMLHttpRequest !== 'undefined') {
  XHR = XMLHttpRequest;
}


var useXDomainRequest = false;
if (typeof XDomainRequest !== 'undefined' && !('withCredentials' in new XMLHttpRequest())) {
  useXDomainRequest = true;
}

function ajaxIE9(method, url, data) {
  var promise = new _ParsePromise2.default();
  var xdr = new XDomainRequest();
  xdr.onload = function () {
    var response;
    try {
      response = JSON.parse(xdr.responseText);
    } catch (e) {
      promise.reject(e);
    }
    if (response) {
      promise.resolve(response);
    }
  };
  xdr.onerror = xdr.ontimeout = function () {
    // Let's fake a real error message.
    var fakeResponse = {
      responseText: (0, _stringify2.default)({
        code: _ParseError2.default.X_DOMAIN_REQUEST,
        error: 'IE\'s XDomainRequest does not supply error info.'
      })
    };
    promise.reject(fakeResponse);
  };
  xdr.onprogress = function () {};
  xdr.open(method, url);
  xdr.send(data);
  return promise;
}

var RESTController = {
  ajax: function (method, url, data, headers) {
    if (useXDomainRequest) {
      return ajaxIE9(method, url, data, headers);
    }

    var promise = new _ParsePromise2.default();
    var attempts = 0;

    (function dispatch() {
      if (XHR == null) {
        throw new Error('Cannot make a request: No definition of XMLHttpRequest was found.');
      }
      var handled = false;
      var xhr = new XHR();

      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4 || handled) {
          return;
        }
        handled = true;

        if (xhr.status >= 200 && xhr.status < 300) {
          var response;
          try {
            response = JSON.parse(xhr.responseText);
          } catch (e) {
            promise.reject(e.toString());
          }
          if (response) {
            promise.resolve(response, xhr.status, xhr);
          }
        } else if (xhr.status >= 500 || xhr.status === 0) {
          // retry on 5XX or node-xmlhttprequest error
          if (++attempts < _CoreManager2.default.get('REQUEST_ATTEMPT_LIMIT')) {
            // Exponentially-growing random delay
            var delay = Math.round(Math.random() * 125 * Math.pow(2, attempts));
            setTimeout(dispatch, delay);
          } else if (xhr.status === 0) {
            promise.reject('Unable to connect to the Parse API');
          } else {
            // After the retry limit is reached, fail
            promise.reject(xhr);
          }
        } else {
          promise.reject(xhr);
        }
      };

      headers = headers || {};
      if (typeof headers['Content-Type'] !== 'string') {
        headers['Content-Type'] = 'text/plain'; // Avoid pre-flight
      }
      if (_CoreManager2.default.get('IS_NODE')) {
        headers['User-Agent'] = 'Parse/' + _CoreManager2.default.get('VERSION') + ' (NodeJS ' + process.versions.node + ')';
      }

      xhr.open(method, url, true);
      for (var h in headers) {
        xhr.setRequestHeader(h, headers[h]);
      }
      xhr.send(data);
    })();

    return promise;
  },
  request: function (method, path, data, options) {
    options = options || {};
    var url = _CoreManager2.default.get('SERVER_URL');
    if (url[url.length - 1] !== '/') {
      url += '/';
    }
    url += path;

    var payload = {};
    if (data && (typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object') {
      for (var k in data) {
        payload[k] = data[k];
      }
    }

    if (method !== 'POST') {
      payload._method = method;
      method = 'POST';
    }

    payload._ApplicationId = _CoreManager2.default.get('APPLICATION_ID');
    var jsKey = _CoreManager2.default.get('JAVASCRIPT_KEY');
    if (jsKey) {
      payload._JavaScriptKey = jsKey;
    }
    payload._ClientVersion = _CoreManager2.default.get('VERSION');

    var useMasterKey = options.useMasterKey;
    if (typeof useMasterKey === 'undefined') {
      useMasterKey = _CoreManager2.default.get('USE_MASTER_KEY');
    }
    if (useMasterKey) {
      if (_CoreManager2.default.get('MASTER_KEY')) {
        delete payload._JavaScriptKey;
        payload._MasterKey = _CoreManager2.default.get('MASTER_KEY');
      } else {
        throw new Error('Cannot use the Master Key, it has not been provided.');
      }
    }

    if (_CoreManager2.default.get('FORCE_REVOCABLE_SESSION')) {
      payload._RevocableSession = '1';
    }

    var installationId = options.installationId;
    var installationIdPromise;
    if (installationId && typeof installationId === 'string') {
      installationIdPromise = _ParsePromise2.default.as(installationId);
    } else {
      var installationController = _CoreManager2.default.getInstallationController();
      installationIdPromise = installationController.currentInstallationId();
    }

    return installationIdPromise.then(function (iid) {
      payload._InstallationId = iid;
      var userController = _CoreManager2.default.getUserController();
      if (options && typeof options.sessionToken === 'string') {
        return _ParsePromise2.default.as(options.sessionToken);
      } else if (userController) {
        return userController.currentUserAsync().then(function (user) {
          if (user) {
            return _ParsePromise2.default.as(user.getSessionToken());
          }
          return _ParsePromise2.default.as(null);
        });
      }
      return _ParsePromise2.default.as(null);
    }).then(function (token) {
      if (token) {
        payload._SessionToken = token;
      }

      var payloadString = (0, _stringify2.default)(payload);

      return RESTController.ajax(method, url, payloadString);
    }).then(null, function (response) {
      // Transform the error into an instance of ParseError by trying to parse
      // the error string as JSON
      var error;
      if (response && response.responseText) {
        try {
          var errorJSON = JSON.parse(response.responseText);
          error = new _ParseError2.default(errorJSON.code, errorJSON.error);
        } catch (e) {
          // If we fail to parse the error text, that's okay.
          error = new _ParseError2.default(_ParseError2.default.INVALID_JSON, 'Received an error with invalid JSON from Parse: ' + response.responseText);
        }
      } else {
        error = new _ParseError2.default(_ParseError2.default.CONNECTION_FAILED, 'XMLHttpRequest failed: ' + (0, _stringify2.default)(response));
      }

      return _ParsePromise2.default.error(error);
    });
  },
  _setXHR: function (xhr) {
    XHR = xhr;
  }
};

module.exports = RESTController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)))

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.track = track;

var _CoreManager = __webpack_require__(9);

var _CoreManager2 = _interopRequireDefault(_CoreManager);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Parse.Analytics provides an interface to Parse's logging and analytics
 * backend.
 *
 * @class Parse.Analytics
 * @static
 * @hideconstructor
 */

/**
 * Tracks the occurrence of a custom event with additional dimensions.
 * Parse will store a data point at the time of invocation with the given
 * event name.
 *
 * Dimensions will allow segmentation of the occurrences of this custom
 * event. Keys and values should be {@code String}s, and will throw
 * otherwise.
 *
 * To track a user signup along with additional metadata, consider the
 * following:
 * <pre>
 * var dimensions = {
 *  gender: 'm',
 *  source: 'web',
 *  dayType: 'weekend'
 * };
 * Parse.Analytics.track('signup', dimensions);
 * </pre>
 *
 * There is a default limit of 8 dimensions per event tracked.
 *
 * @method track
 * @name Parse.Analytics.track
 * @param {String} name The name of the custom event to report to Parse as
 * having happened.
 * @param {Object} dimensions The dictionary of information by which to
 * segment this event.
 * @param {Object} options A Backbone-style callback object.
 * @return {Parse.Promise} A promise that is resolved when the round-trip
 * to the server completes.
 */
function track(name, dimensions, options) {
  name = name || '';
  name = name.replace(/^\s*/, '');
  name = name.replace(/\s*$/, '');
  if (name.length === 0) {
    throw new TypeError('A name for the custom event must be provided');
  }

  for (var key in dimensions) {
    if (typeof key !== 'string' || typeof dimensions[key] !== 'string') {
      throw new TypeError('track() dimensions expects keys and values of type "string".');
    }
  }

  options = options || {};
  return _CoreManager2.default.getAnalyticsController().track(name, dimensions)._thenRunCallbacks(options);
} /**
   * Copyright (c) 2015-present, Parse, LLC.
   * All rights reserved.
   *
   * This source code is licensed under the BSD-style license found in the
   * LICENSE file in the root directory of this source tree. An additional grant
   * of patent rights can be found in the PATENTS file in the same directory.
   *
   * 
   */

var DefaultController = {
  track: function (name, dimensions) {
    var RESTController = _CoreManager2.default.getRESTController();
    return RESTController.request('POST', 'events/' + name, { dimensions: dimensions });
  }
};

_CoreManager2.default.setAnalyticsController(DefaultController);

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.run = run;

var _CoreManager = __webpack_require__(9);

var _CoreManager2 = _interopRequireDefault(_CoreManager);

var _decode = __webpack_require__(45);

var _decode2 = _interopRequireDefault(_decode);

var _encode = __webpack_require__(36);

var _encode2 = _interopRequireDefault(_encode);

var _ParseError = __webpack_require__(28);

var _ParseError2 = _interopRequireDefault(_ParseError);

var _ParsePromise = __webpack_require__(7);

var _ParsePromise2 = _interopRequireDefault(_ParsePromise);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Contains functions for calling and declaring
 * <a href="/docs/cloud_code_guide#functions">cloud functions</a>.
 * <p><strong><em>
 *   Some functions are only available from Cloud Code.
 * </em></strong></p>
 *
 * @class Parse.Cloud
 * @static
 * @hideconstructor
 */

/**
 * Makes a call to a cloud function.
 * @method run
 * @name Parse.Cloud.run
 * @param {String} name The function name.
 * @param {Object} data The parameters to send to the cloud function.
 * @param {Object} options A Backbone-style options object
 * options.success, if set, should be a function to handle a successful
 * call to a cloud function.  options.error should be a function that
 * handles an error running the cloud function.  Both functions are
 * optional.  Both functions take a single argument.
 * @return {Parse.Promise} A promise that will be resolved with the result
 * of the function.
 */
function run(name, data, options) {
  options = options || {};

  if (typeof name !== 'string' || name.length === 0) {
    throw new TypeError('Cloud function name must be a string.');
  }

  var requestOptions = {};
  if (options.useMasterKey) {
    requestOptions.useMasterKey = options.useMasterKey;
  }
  if (options.sessionToken) {
    requestOptions.sessionToken = options.sessionToken;
  }

  return _CoreManager2.default.getCloudController().run(name, data, requestOptions)._thenRunCallbacks(options);
} /**
   * Copyright (c) 2015-present, Parse, LLC.
   * All rights reserved.
   *
   * This source code is licensed under the BSD-style license found in the
   * LICENSE file in the root directory of this source tree. An additional grant
   * of patent rights can be found in the PATENTS file in the same directory.
   *
   * 
   */

var DefaultController = {
  run: function (name, data, options) {
    var RESTController = _CoreManager2.default.getRESTController();

    var payload = (0, _encode2.default)(data, true);

    var requestOptions = {};
    if (options.hasOwnProperty('useMasterKey')) {
      requestOptions.useMasterKey = options.useMasterKey;
    }
    if (options.hasOwnProperty('sessionToken')) {
      requestOptions.sessionToken = options.sessionToken;
    }

    var request = RESTController.request('POST', 'functions/' + name, payload, requestOptions);

    return request.then(function (res) {
      var decoded = (0, _decode2.default)(res);
      if (decoded && decoded.hasOwnProperty('result')) {
        return _ParsePromise2.default.as(decoded.result);
      }
      return _ParsePromise2.default.error(new _ParseError2.default(_ParseError2.default.INVALID_JSON, 'The server returned an invalid response.'));
    })._thenRunCallbacks(options);
  }
};

_CoreManager2.default.setCloudController(DefaultController);

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(42);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _CoreManager = __webpack_require__(9);

var _CoreManager2 = _interopRequireDefault(_CoreManager);

var _decode = __webpack_require__(45);

var _decode2 = _interopRequireDefault(_decode);

var _encode = __webpack_require__(36);

var _encode2 = _interopRequireDefault(_encode);

var _escape2 = __webpack_require__(126);

var _escape3 = _interopRequireDefault(_escape2);

var _ParseError = __webpack_require__(28);

var _ParseError2 = _interopRequireDefault(_ParseError);

var _ParsePromise = __webpack_require__(7);

var _ParsePromise2 = _interopRequireDefault(_ParsePromise);

var _Storage = __webpack_require__(51);

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Parse.Config is a local representation of configuration data that
 * can be set from the Parse dashboard.
 *
 * @alias Parse.Config
 */

var ParseConfig = function () {
  function ParseConfig() {
    (0, _classCallCheck3.default)(this, ParseConfig);

    this.attributes = {};
    this._escapedAttributes = {};
  }

  /**
   * Gets the value of an attribute.
   * @param {String} attr The name of an attribute.
   */

  (0, _createClass3.default)(ParseConfig, [{
    key: 'get',
    value: function (attr) {
      return this.attributes[attr];
    }

    /**
     * Gets the HTML-escaped value of an attribute.
     * @param {String} attr The name of an attribute.
     */

  }, {
    key: 'escape',
    value: function (attr) {
      var html = this._escapedAttributes[attr];
      if (html) {
        return html;
      }
      var val = this.attributes[attr];
      var escaped = '';
      if (val != null) {
        escaped = (0, _escape3.default)(val.toString());
      }
      this._escapedAttributes[attr] = escaped;
      return escaped;
    }

    /**
     * Retrieves the most recently-fetched configuration object, either from
     * memory or from local storage if necessary.
     *
     * @static
     * @return {Config} The most recently-fetched Parse.Config if it
     *     exists, else an empty Parse.Config.
     */

  }], [{
    key: 'current',
    value: function () {
      var controller = _CoreManager2.default.getConfigController();
      return controller.current();
    }

    /**
     * Gets a new configuration object from the server.
     * @static
     * @param {Object} options A Backbone-style options object.
     * Valid options are:<ul>
     *   <li>success: Function to call when the get completes successfully.
     *   <li>error: Function to call when the get fails.
     * </ul>
     * @return {Parse.Promise} A promise that is resolved with a newly-created
     *     configuration object when the get completes.
     */

  }, {
    key: 'get',
    value: function (options) {
      options = options || {};

      var controller = _CoreManager2.default.getConfigController();
      return controller.get()._thenRunCallbacks(options);
    }
  }]);
  return ParseConfig;
}(); /**
      * Copyright (c) 2015-present, Parse, LLC.
      * All rights reserved.
      *
      * This source code is licensed under the BSD-style license found in the
      * LICENSE file in the root directory of this source tree. An additional grant
      * of patent rights can be found in the PATENTS file in the same directory.
      *
      * 
      */

var currentConfig = null;

var CURRENT_CONFIG_KEY = 'currentConfig';

function decodePayload(data) {
  try {
    var json = JSON.parse(data);
    if (json && (typeof json === 'undefined' ? 'undefined' : (0, _typeof3.default)(json)) === 'object') {
      return (0, _decode2.default)(json);
    }
  } catch (e) {
    return null;
  }
}

var DefaultController = {
  current: function () {
    if (currentConfig) {
      return currentConfig;
    }

    var config = new ParseConfig();
    var storagePath = _Storage2.default.generatePath(CURRENT_CONFIG_KEY);
    var configData;
    if (!_Storage2.default.async()) {
      configData = _Storage2.default.getItem(storagePath);

      if (configData) {
        var attributes = decodePayload(configData);
        if (attributes) {
          config.attributes = attributes;
          currentConfig = config;
        }
      }
      return config;
    }
    // Return a promise for async storage controllers
    return _Storage2.default.getItemAsync(storagePath).then(function (configData) {
      if (configData) {
        var attributes = decodePayload(configData);
        if (attributes) {
          config.attributes = attributes;
          currentConfig = config;
        }
      }
      return config;
    });
  },
  get: function () {
    var RESTController = _CoreManager2.default.getRESTController();

    return RESTController.request('GET', 'config', {}, {}).then(function (response) {
      if (!response || !response.params) {
        var error = new _ParseError2.default(_ParseError2.default.INVALID_JSON, 'Config JSON response invalid.');
        return _ParsePromise2.default.error(error);
      }

      var config = new ParseConfig();
      config.attributes = {};
      for (var attr in response.params) {
        config.attributes[attr] = (0, _decode2.default)(response.params[attr]);
      }
      currentConfig = config;
      return _Storage2.default.setItemAsync(_Storage2.default.generatePath(CURRENT_CONFIG_KEY), (0, _stringify2.default)(response.params)).then(function () {
        return config;
      });
    });
  }
};

_CoreManager2.default.setConfigController(DefaultController);

exports.default = ParseConfig;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parseDate = __webpack_require__(127);

var _parseDate2 = _interopRequireDefault(_parseDate);

var _ParseUser = __webpack_require__(68);

var _ParseUser2 = _interopRequireDefault(_ParseUser);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * -weak
 */

var PUBLIC_KEY = "*";

var initialized = false;
var requestedPermissions;
var initOptions;
var provider = {
  authenticate: function (options) {
    var _this = this;

    if (typeof FB === 'undefined') {
      options.error(this, 'Facebook SDK not found.');
    }
    FB.login(function (response) {
      if (response.authResponse) {
        if (options.success) {
          options.success(_this, {
            id: response.authResponse.userID,
            access_token: response.authResponse.accessToken,
            expiration_date: new Date(response.authResponse.expiresIn * 1000 + new Date().getTime()).toJSON()
          });
        }
      } else {
        if (options.error) {
          options.error(_this, response);
        }
      }
    }, {
      scope: requestedPermissions
    });
  },
  restoreAuthentication: function (authData) {
    if (authData) {
      var expiration = (0, _parseDate2.default)(authData.expiration_date);
      var expiresIn = expiration ? (expiration.getTime() - new Date().getTime()) / 1000 : 0;

      var authResponse = {
        userID: authData.id,
        accessToken: authData.access_token,
        expiresIn: expiresIn
      };
      var newOptions = {};
      if (initOptions) {
        for (var key in initOptions) {
          newOptions[key] = initOptions[key];
        }
      }
      newOptions.authResponse = authResponse;

      // Suppress checks for login status from the browser.
      newOptions.status = false;

      // If the user doesn't match the one known by the FB SDK, log out.
      // Most of the time, the users will match -- it's only in cases where
      // the FB SDK knows of a different user than the one being restored
      // from a Parse User that logged in with username/password.
      var existingResponse = FB.getAuthResponse();
      if (existingResponse && existingResponse.userID !== authResponse.userID) {
        FB.logout();
      }

      FB.init(newOptions);
    }
    return true;
  },
  getAuthType: function () {
    return 'facebook';
  },
  deauthenticate: function () {
    this.restoreAuthentication(null);
  }
};

/**
 * Provides a set of utilities for using Parse with Facebook.
 * @class Parse.FacebookUtils
 * @static
 * @hideconstructor
 */
var FacebookUtils = {
  /**
   * Initializes Parse Facebook integration.  Call this function after you
   * have loaded the Facebook Javascript SDK with the same parameters
   * as you would pass to<code>
   * <a href=
   * "https://developers.facebook.com/docs/reference/javascript/FB.init/">
   * FB.init()</a></code>.  Parse.FacebookUtils will invoke FB.init() for you
   * with these arguments.
   *
   * @method init
   * @name Parse.FacebookUtils.init
   * @param {Object} options Facebook options argument as described here:
   *   <a href=
   *   "https://developers.facebook.com/docs/reference/javascript/FB.init/">
   *   FB.init()</a>. The status flag will be coerced to 'false' because it
   *   interferes with Parse Facebook integration. Call FB.getLoginStatus()
   *   explicitly if this behavior is required by your application.
   */
  init: function (options) {
    if (typeof FB === 'undefined') {
      throw new Error('The Facebook JavaScript SDK must be loaded before calling init.');
    }
    initOptions = {};
    if (options) {
      for (var key in options) {
        initOptions[key] = options[key];
      }
    }
    if (initOptions.status && typeof console !== 'undefined') {
      var warn = console.warn || console.log || function () {};
      warn.call(console, 'The "status" flag passed into' + ' FB.init, when set to true, can interfere with Parse Facebook' + ' integration, so it has been suppressed. Please call' + ' FB.getLoginStatus() explicitly if you require this behavior.');
    }
    initOptions.status = false;
    FB.init(initOptions);
    _ParseUser2.default._registerAuthenticationProvider(provider);
    initialized = true;
  },

  /**
   * Gets whether the user has their account linked to Facebook.
   *
   * @method isLinked
   * @name Parse.FacebookUtils.isLinked
   * @param {Parse.User} user User to check for a facebook link.
   *     The user must be logged in on this device.
   * @return {Boolean} <code>true</code> if the user has their account
   *     linked to Facebook.
   */
  isLinked: function (user) {
    return user._isLinked('facebook');
  },

  /**
   * Logs in a user using Facebook. This method delegates to the Facebook
   * SDK to authenticate the user, and then automatically logs in (or
   * creates, in the case where it is a new user) a Parse.User.
   *
   * @method logIn
   * @name Parse.FacebookUtils.logIn
   * @param {(String|Object)} permissions The permissions required for Facebook
   *    log in.  This is a comma-separated string of permissions.
   *    Alternatively, supply a Facebook authData object as described in our
   *    REST API docs if you want to handle getting facebook auth tokens
   *    yourself.
   * @param {Object} options Standard options object with success and error
   *    callbacks.
   * @returns {Parse.Promise}
   */
  logIn: function (permissions, options) {
    if (!permissions || typeof permissions === 'string') {
      if (!initialized) {
        throw new Error('You must initialize FacebookUtils before calling logIn.');
      }
      requestedPermissions = permissions;
      return _ParseUser2.default._logInWith('facebook', options);
    } else {
      var newOptions = {};
      if (options) {
        for (var key in options) {
          newOptions[key] = options[key];
        }
      }
      newOptions.authData = permissions;
      return _ParseUser2.default._logInWith('facebook', newOptions);
    }
  },

  /**
   * Links Facebook to an existing PFUser. This method delegates to the
   * Facebook SDK to authenticate the user, and then automatically links
   * the account to the Parse.User.
   *
   * @method link
   * @name Parse.FacebookUtils.link
   * @param {Parse.User} user User to link to Facebook. This must be the
   *     current user.
   * @param {(String|Object)} permissions The permissions required for Facebook
   *    log in.  This is a comma-separated string of permissions.
   *    Alternatively, supply a Facebook authData object as described in our
   *    REST API docs if you want to handle getting facebook auth tokens
   *    yourself.
   * @param {Object} options Standard options object with success and error
   *    callbacks.
   * @returns {Parse.Promise}
   */
  link: function (user, permissions, options) {
    if (!permissions || typeof permissions === 'string') {
      if (!initialized) {
        throw new Error('You must initialize FacebookUtils before calling link.');
      }
      requestedPermissions = permissions;
      return user._linkWith('facebook', options);
    } else {
      var newOptions = {};
      if (options) {
        for (var key in options) {
          newOptions[key] = options[key];
        }
      }
      newOptions.authData = permissions;
      return user._linkWith('facebook', newOptions);
    }
  },

  /**
   * Unlinks the Parse.User from a Facebook account.
   *
   * @method unlink
   * @name Parse.FacebookUtils.unlink
   * @param {Parse.User} user User to unlink from Facebook. This must be the
   *     current user.
   * @param {Object} options Standard options object with success and error
   *    callbacks.
   * @returns {Parse.Promise}
   */
  unlink: function (user, options) {
    if (!initialized) {
      throw new Error('You must initialize FacebookUtils before calling unlink.');
    }
    return user._unlinkFrom('facebook', options);
  }
};

exports.default = FacebookUtils;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = __webpack_require__(27);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(34);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(35);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ParseObject2 = __webpack_require__(8);

var _ParseObject3 = _interopRequireDefault(_ParseObject2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Installation = function (_ParseObject) {
  (0, _inherits3.default)(Installation, _ParseObject);

  function Installation(attributes) {
    (0, _classCallCheck3.default)(this, Installation);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Installation.__proto__ || (0, _getPrototypeOf2.default)(Installation)).call(this, '_Installation'));

    if (attributes && (typeof attributes === 'undefined' ? 'undefined' : (0, _typeof3.default)(attributes)) === 'object') {
      if (!_this.set(attributes || {})) {
        throw new Error('Can\'t create an invalid Session');
      }
    }
    return _this;
  }

  return Installation;
}(_ParseObject3.default); /**
                           * Copyright (c) 2015-present, Parse, LLC.
                           * All rights reserved.
                           *
                           * This source code is licensed under the BSD-style license found in the
                           * LICENSE file in the root directory of this source tree. An additional grant
                           * of patent rights can be found in the PATENTS file in the same directory.
                           *
                           * 
                           */

exports.default = Installation;

_ParseObject3.default.registerSubclass('_Installation', Installation);

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.send = send;

var _CoreManager = __webpack_require__(9);

var _CoreManager2 = _interopRequireDefault(_CoreManager);

var _ParseQuery = __webpack_require__(66);

var _ParseQuery2 = _interopRequireDefault(_ParseQuery);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Contains functions to deal with Push in Parse.
 * @class Parse.Push
 * @static
 * @hideconstructor
 */

/**
 * Sends a push notification.
 * @method send
 * @name Parse.Push.send
 * @param {Object} data -  The data of the push notification.  Valid fields
 * are:
 *   <ol>
 *     <li>channels - An Array of channels to push to.</li>
 *     <li>push_time - A Date object for when to send the push.</li>
 *     <li>expiration_time -  A Date object for when to expire
 *         the push.</li>
 *     <li>expiration_interval - The seconds from now to expire the push.</li>
 *     <li>where - A Parse.Query over Parse.Installation that is used to match
 *         a set of installations to push to.</li>
 *     <li>data - The data to send as part of the push</li>
 *   <ol>
 * @param {Object} options An object that has an optional success function,
 * that takes no arguments and will be called on a successful push, and
 * an error function that takes a Parse.Error and will be called if the push
 * failed.
 * @return {Parse.Promise} A promise that is fulfilled when the push request
 *     completes.
 */
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function send(data, options) {
  options = options || {};

  if (data.where && data.where instanceof _ParseQuery2.default) {
    data.where = data.where.toJSON().where;
  }

  if (data.push_time && (0, _typeof3.default)(data.push_time) === 'object') {
    data.push_time = data.push_time.toJSON();
  }

  if (data.expiration_time && (0, _typeof3.default)(data.expiration_time) === 'object') {
    data.expiration_time = data.expiration_time.toJSON();
  }

  if (data.expiration_time && data.expiration_interval) {
    throw new Error('expiration_time and expiration_interval cannot both be set.');
  }

  return _CoreManager2.default.getPushController().send(data, {
    useMasterKey: options.useMasterKey
  })._thenRunCallbacks(options);
}

var DefaultController = {
  send: function (data, options) {
    var RESTController = _CoreManager2.default.getRESTController();

    var request = RESTController.request('POST', 'push', data, { useMasterKey: !!options.useMasterKey });

    return request._thenRunCallbacks(options);
  }
};

_CoreManager2.default.setPushController(DefaultController);

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _CoreManager = __webpack_require__(9);

var _CoreManager2 = _interopRequireDefault(_CoreManager);

var _ParsePromise = __webpack_require__(7);

var _ParsePromise2 = _interopRequireDefault(_ParsePromise);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var FIELD_TYPES = ['String', 'Number', 'Boolean', 'Date', 'File', 'GeoPoint', 'Polygon', 'Array', 'Object', 'Pointer', 'Relation'];

/**
 * A Parse.Schema object is for handling schema data from Parse.
 * <p>All the schemas methods require MasterKey.
 *
 * <pre>
 * const schema = new Parse.Schema('MyClass');
 * schema.addString('field');
 * schema.addIndex('index_name', {'field', 1});
 * schema.save();
 * </pre>
 * </p>
 * @alias Parse.Schema
 */

var ParseSchema = function () {

  /**
   * @param {String} className Parse Class string.
   */
  function ParseSchema(className) {
    (0, _classCallCheck3.default)(this, ParseSchema);

    if (typeof className === 'string') {
      if (className === 'User' && _CoreManager2.default.get('PERFORM_USER_REWRITE')) {
        this.className = '_User';
      } else {
        this.className = className;
      }
    }

    this._fields = {};
    this._indexes = {};
  }

  /**
   * Static method to get all schemas
   *
   * @param {Object} options A Backbone-style options object.
   * Valid options are:<ul>
   *   <li>success: A Backbone-style success callback
   *   <li>error: An Backbone-style error callback.
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   *   <li>sessionToken: A valid session token, used for making a request on
   *       behalf of a specific user.
   * </ul>
   *
   * @return {Parse.Promise} A promise that is resolved with the result when
   * the query completes.
   */

  (0, _createClass3.default)(ParseSchema, [{
    key: 'get',

    /**
     * Get the Schema from Parse
     *
     * @param {Object} options A Backbone-style options object.
     * Valid options are:<ul>
     *   <li>success: A Backbone-style success callback
     *   <li>error: An Backbone-style error callback.
     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
     *     be used for this request.
     *   <li>sessionToken: A valid session token, used for making a request on
     *       behalf of a specific user.
     * </ul>
     *
     * @return {Parse.Promise} A promise that is resolved with the result when
     * the query completes.
     */
    value: function (options) {
      this.assertClassName();

      options = options || {};
      var controller = _CoreManager2.default.getSchemaController();

      return controller.get(this.className, options).then(function (response) {
        if (!response) {
          throw new Error('Schema not found.');
        }
        return response;
      })._thenRunCallbacks(options);
    }

    /**
     * Create a new Schema on Parse
     *
     * @param {Object} options A Backbone-style options object.
     * Valid options are:<ul>
     *   <li>success: A Backbone-style success callback
     *   <li>error: An Backbone-style error callback.
     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
     *     be used for this request.
     *   <li>sessionToken: A valid session token, used for making a request on
     *       behalf of a specific user.
     * </ul>
     *
     * @return {Parse.Promise} A promise that is resolved with the result when
     * the query completes.
     */

  }, {
    key: 'save',
    value: function (options) {
      this.assertClassName();

      options = options || {};
      var controller = _CoreManager2.default.getSchemaController();
      var params = {
        className: this.className,
        fields: this._fields,
        indexes: this._indexes
      };

      return controller.create(this.className, params, options).then(function (response) {
        return response;
      })._thenRunCallbacks(options);
    }

    /**
     * Update a Schema on Parse
     *
     * @param {Object} options A Backbone-style options object.
     * Valid options are:<ul>
     *   <li>success: A Backbone-style success callback
     *   <li>error: An Backbone-style error callback.
     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
     *     be used for this request.
     *   <li>sessionToken: A valid session token, used for making a request on
     *       behalf of a specific user.
     * </ul>
     *
     * @return {Parse.Promise} A promise that is resolved with the result when
     * the query completes.
     */

  }, {
    key: 'update',
    value: function (options) {
      this.assertClassName();

      options = options || {};
      var controller = _CoreManager2.default.getSchemaController();
      var params = {
        className: this.className,
        fields: this._fields,
        indexes: this._indexes
      };

      this._fields = {};
      this._indexes = {};

      return controller.update(this.className, params, options).then(function (response) {
        return response;
      })._thenRunCallbacks(options);
    }

    /**
     * Removing a Schema from Parse
     * Can only be used on Schema without objects
     *
     * @param {Object} options A Backbone-style options object.
     * Valid options are:<ul>
     *   <li>success: A Backbone-style success callback
     *   <li>error: An Backbone-style error callback.
     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
     *     be used for this request.
     *   <li>sessionToken: A valid session token, used for making a request on
     *       behalf of a specific user.
     * </ul>
     *
     * @return {Parse.Promise} A promise that is resolved with the result when
     * the query completes.
     */

  }, {
    key: 'delete',
    value: function (options) {
      this.assertClassName();

      options = options || {};
      var controller = _CoreManager2.default.getSchemaController();

      return controller.delete(this.className, options).then(function (response) {
        return response;
      })._thenRunCallbacks(options);
    }

    /**
     * Removes all objects from a Schema (class) in Parse.
     * EXERCISE CAUTION, running this will delete all objects for this schema and cannot be reversed
     *
     * @param {Object} options A Backbone-style options object.
     * Valid options are:<ul>
     *   <li>success: A Backbone-style success callback
     *   <li>error: An Backbone-style error callback.
     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
     *     be used for this request.
     *   <li>sessionToken: A valid session token, used for making a request on
     *       behalf of a specific user.
     * </ul>
     *
     * @return {Parse.Promise} A promise that is resolved with the result when
     * the query completes.
     */

  }, {
    key: 'purge',
    value: function (options) {
      this.assertClassName();

      var controller = _CoreManager2.default.getSchemaController();

      return controller.purge(this.className).then(function (response) {
        return response;
      })._thenRunCallbacks(options);
    }

    /**
     * Assert if ClassName has been filled
     * @private
     */

  }, {
    key: 'assertClassName',
    value: function () {
      if (!this.className) {
        throw new Error('You must set a Class Name before making any request.');
      }
    }

    /**
     * Adding a Field to Create / Update a Schema
     *
     * @param {String} name Name of the field that will be created on Parse
     * @param {String} type TheCan be a (String|Number|Boolean|Date|Parse.File|Parse.GeoPoint|Array|Object|Pointer|Parse.Relation)
     * @return {Parse.Schema} Returns the schema, so you can chain this call.
     */

  }, {
    key: 'addField',
    value: function (name, type) {
      type = type || 'String';

      if (!name) {
        throw new Error('field name may not be null.');
      }
      if (FIELD_TYPES.indexOf(type) === -1) {
        throw new Error(type + ' is not a valid type.');
      }

      this._fields[name] = { type: type };

      return this;
    }

    /**
     * Adding an Index to Create / Update a Schema
     *
     * @param {String} name Name of the field that will be created on Parse
     * @param {String} type Can be a (String|Number|Boolean|Date|Parse.File|Parse.GeoPoint|Array|Object|Pointer|Parse.Relation)
     * @return {Parse.Schema} Returns the schema, so you can chain this call.
     */

  }, {
    key: 'addIndex',
    value: function (name, index) {
      if (!name) {
        throw new Error('index name may not be null.');
      }
      if (!index) {
        throw new Error('index may not be null.');
      }

      this._indexes[name] = index;

      return this;
    }

    /**
     * Adding String Field
     *
     * @param {String} name Name of the field that will be created on Parse
     * @return {Parse.Schema} Returns the schema, so you can chain this call.
     */

  }, {
    key: 'addString',
    value: function (name) {
      return this.addField(name, 'String');
    }

    /**
     * Adding Number Field
     *
     * @param {String} name Name of the field that will be created on Parse
     * @return {Parse.Schema} Returns the schema, so you can chain this call.
     */

  }, {
    key: 'addNumber',
    value: function (name) {
      return this.addField(name, 'Number');
    }

    /**
     * Adding Boolean Field
     *
     * @param {String} name Name of the field that will be created on Parse
     * @return {Parse.Schema} Returns the schema, so you can chain this call.
     */

  }, {
    key: 'addBoolean',
    value: function (name) {
      return this.addField(name, 'Boolean');
    }

    /**
     * Adding Date Field
     *
     * @param {String} name Name of the field that will be created on Parse
     * @return {Parse.Schema} Returns the schema, so you can chain this call.
     */

  }, {
    key: 'addDate',
    value: function (name) {
      return this.addField(name, 'Date');
    }

    /**
     * Adding File Field
     *
     * @param {String} name Name of the field that will be created on Parse
     * @return {Parse.Schema} Returns the schema, so you can chain this call.
     */

  }, {
    key: 'addFile',
    value: function (name) {
      return this.addField(name, 'File');
    }

    /**
     * Adding GeoPoint Field
     *
     * @param {String} name Name of the field that will be created on Parse
     * @return {Parse.Schema} Returns the schema, so you can chain this call.
     */

  }, {
    key: 'addGeoPoint',
    value: function (name) {
      return this.addField(name, 'GeoPoint');
    }

    /**
     * Adding Polygon Field
     *
     * @param {String} name Name of the field that will be created on Parse
     * @return {Parse.Schema} Returns the schema, so you can chain this call.
     */

  }, {
    key: 'addPolygon',
    value: function (name) {
      return this.addField(name, 'Polygon');
    }

    /**
     * Adding Array Field
     *
     * @param {String} name Name of the field that will be created on Parse
     * @return {Parse.Schema} Returns the schema, so you can chain this call.
     */

  }, {
    key: 'addArray',
    value: function (name) {
      return this.addField(name, 'Array');
    }

    /**
     * Adding Object Field
     *
     * @param {String} name Name of the field that will be created on Parse
     * @return {Parse.Schema} Returns the schema, so you can chain this call.
     */

  }, {
    key: 'addObject',
    value: function (name) {
      return this.addField(name, 'Object');
    }

    /**
     * Adding Pointer Field
     *
     * @param {String} name Name of the field that will be created on Parse
     * @param {String} targetClass Name of the target Pointer Class
     * @return {Parse.Schema} Returns the schema, so you can chain this call.
     */

  }, {
    key: 'addPointer',
    value: function (name, targetClass) {
      if (!name) {
        throw new Error('field name may not be null.');
      }
      if (!targetClass) {
        throw new Error('You need to set the targetClass of the Pointer.');
      }

      this._fields[name] = {
        type: 'Pointer',
        targetClass: targetClass
      };

      return this;
    }

    /**
     * Adding Relation Field
     *
     * @param {String} name Name of the field that will be created on Parse
     * @param {String} targetClass Name of the target Pointer Class
     * @return {Parse.Schema} Returns the schema, so you can chain this call.
     */

  }, {
    key: 'addRelation',
    value: function (name, targetClass) {
      if (!name) {
        throw new Error('field name may not be null.');
      }
      if (!targetClass) {
        throw new Error('You need to set the targetClass of the Relation.');
      }

      this._fields[name] = {
        type: 'Relation',
        targetClass: targetClass
      };

      return this;
    }

    /**
     * Deleting a Field to Update on a Schema
     *
     * @param {String} name Name of the field that will be created on Parse
     * @param {String} targetClass Name of the target Pointer Class
     * @return {Parse.Schema} Returns the schema, so you can chain this call.
     */

  }, {
    key: 'deleteField',
    value: function (name) {
      this._fields[name] = { __op: 'Delete' };
    }

    /**
    * Deleting an Index to Update on a Schema
    *
    * @param {String} name Name of the field that will be created on Parse
    * @param {String} targetClass Name of the target Pointer Class
    * @return {Parse.Schema} Returns the schema, so you can chain this call.
    */

  }, {
    key: 'deleteIndex',
    value: function (name) {
      this._indexes[name] = { __op: 'Delete' };
    }
  }], [{
    key: 'all',
    value: function (options) {
      options = options || {};
      var controller = _CoreManager2.default.getSchemaController();

      return controller.get('', options).then(function (response) {
        if (response.results.length === 0) {
          throw new Error('Schema not found.');
        }
        return response.results;
      })._thenRunCallbacks(options);
    }
  }]);
  return ParseSchema;
}();

var DefaultController = {
  send: function (className, method, params, options) {
    var RESTController = _CoreManager2.default.getRESTController();
    var requestOptions = { useMasterKey: true };
    if (options.hasOwnProperty('sessionToken')) {
      requestOptions.sessionToken = options.sessionToken;
    }
    return RESTController.request(method, 'schemas/' + className, params, requestOptions);
  },
  get: function (className, options) {
    return this.send(className, 'GET', {}, options);
  },
  create: function (className, params, options) {
    return this.send(className, 'POST', params, options);
  },
  update: function (className, params, options) {
    return this.send(className, 'PUT', params, options);
  },
  delete: function (className, options) {
    return this.send(className, 'DELETE', {}, options);
  },
  purge: function (className) {
    var RESTController = _CoreManager2.default.getRESTController();
    return RESTController.request('DELETE', 'purge/' + className, {}, { useMasterKey: true });
  }
};

_CoreManager2.default.setSchemaController(DefaultController);

exports.default = ParseSchema;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EventEmitter = __webpack_require__(97);

var _EventEmitter2 = _interopRequireDefault(_EventEmitter);

var _LiveQueryClient = __webpack_require__(135);

var _LiveQueryClient2 = _interopRequireDefault(_LiveQueryClient);

var _CoreManager = __webpack_require__(9);

var _CoreManager2 = _interopRequireDefault(_CoreManager);

var _ParsePromise = __webpack_require__(7);

var _ParsePromise2 = _interopRequireDefault(_ParsePromise);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function open() {
  var LiveQueryController = _CoreManager2.default.getLiveQueryController();
  LiveQueryController.open();
}

function close() {
  var LiveQueryController = _CoreManager2.default.getLiveQueryController();
  LiveQueryController.close();
}

/**
 *
 * We expose three events to help you monitor the status of the WebSocket connection:
 *
 * <p>Open - When we establish the WebSocket connection to the LiveQuery server, you'll get this event.
 * 
 * <pre>
 * Parse.LiveQuery.on('open', () => {
 * 
 * });</pre></p>
 *
 * <p>Close - When we lose the WebSocket connection to the LiveQuery server, you'll get this event.
 * 
 * <pre>
 * Parse.LiveQuery.on('close', () => {
 * 
 * });</pre></p>
 *
 * <p>Error - When some network error or LiveQuery server error happens, you'll get this event.
 * 
 * <pre>
 * Parse.LiveQuery.on('error', (error) => {
 * 
 * });</pre></p>
 * 
 * @class Parse.LiveQuery
 * @static
 * 
 */
var LiveQuery = new _EventEmitter2.default();

/**
 * After open is called, the LiveQuery will try to send a connect request
 * to the LiveQuery server.
 * 

 */
LiveQuery.open = open;

/**
 * When you're done using LiveQuery, you can call Parse.LiveQuery.close().
 * This function will close the WebSocket connection to the LiveQuery server,
 * cancel the auto reconnect, and unsubscribe all subscriptions based on it.
 * If you call query.subscribe() after this, we'll create a new WebSocket
 * connection to the LiveQuery server.
 * 

 */

LiveQuery.close = close;
// Register a default onError callback to make sure we do not crash on error
LiveQuery.on('error', function () {});

exports.default = LiveQuery;

function getSessionToken() {
  var controller = _CoreManager2.default.getUserController();
  return controller.currentUserAsync().then(function (currentUser) {
    return currentUser ? currentUser.getSessionToken() : undefined;
  });
}

function getLiveQueryClient() {
  return _CoreManager2.default.getLiveQueryController().getDefaultLiveQueryClient();
}

var defaultLiveQueryClient = void 0;
var DefaultLiveQueryController = {
  setDefaultLiveQueryClient: function (liveQueryClient) {
    defaultLiveQueryClient = liveQueryClient;
  },
  getDefaultLiveQueryClient: function () {
    if (defaultLiveQueryClient) {
      return _ParsePromise2.default.as(defaultLiveQueryClient);
    }

    return getSessionToken().then(function (sessionToken) {
      var liveQueryServerURL = _CoreManager2.default.get('LIVEQUERY_SERVER_URL');

      if (liveQueryServerURL && liveQueryServerURL.indexOf('ws') !== 0) {
        throw new Error('You need to set a proper Parse LiveQuery server url before using LiveQueryClient');
      }

      // If we can not find Parse.liveQueryServerURL, we try to extract it from Parse.serverURL
      if (!liveQueryServerURL) {
        var tempServerURL = _CoreManager2.default.get('SERVER_URL');
        var protocol = 'ws://';
        // If Parse is being served over SSL/HTTPS, ensure LiveQuery Server uses 'wss://' prefix
        if (tempServerURL.indexOf('https') === 0) {
          protocol = 'wss://';
        }
        var host = tempServerURL.replace(/^https?:\/\//, '');
        liveQueryServerURL = protocol + host;
        _CoreManager2.default.set('LIVEQUERY_SERVER_URL', liveQueryServerURL);
      }

      var applicationId = _CoreManager2.default.get('APPLICATION_ID');
      var javascriptKey = _CoreManager2.default.get('JAVASCRIPT_KEY');
      var masterKey = _CoreManager2.default.get('MASTER_KEY');
      // Get currentUser sessionToken if possible
      defaultLiveQueryClient = new _LiveQueryClient2.default({
        applicationId: applicationId,
        serverURL: liveQueryServerURL,
        javascriptKey: javascriptKey,
        masterKey: masterKey,
        sessionToken: sessionToken
      });
      // Register a default onError callback to make sure we do not crash on error
      // Cannot create these events on a nested way because of EventEmiiter from React Native
      defaultLiveQueryClient.on('error', function (error) {
        LiveQuery.emit('error', error);
      });
      defaultLiveQueryClient.on('open', function () {
        LiveQuery.emit('open');
      });
      defaultLiveQueryClient.on('close', function () {
        LiveQuery.emit('close');
      });

      return defaultLiveQueryClient;
    });
  },
  open: function () {
    var _this = this;

    getLiveQueryClient().then(function (liveQueryClient) {
      _this.resolve(liveQueryClient.open());
    });
  },
  close: function () {
    var _this2 = this;

    getLiveQueryClient().then(function (liveQueryClient) {
      _this2.resolve(liveQueryClient.close());
    });
  },
  subscribe: function (query) {
    var _this3 = this;

    var subscriptionWrap = new _EventEmitter2.default();

    getLiveQueryClient().then(function (liveQueryClient) {
      if (liveQueryClient.shouldOpen()) {
        liveQueryClient.open();
      }
      var promiseSessionToken = getSessionToken();
      // new event emitter
      return promiseSessionToken.then(function (sessionToken) {

        var subscription = liveQueryClient.subscribe(query, sessionToken);
        // enter, leave create, etc

        subscriptionWrap.id = subscription.id;
        subscriptionWrap.query = subscription.query;
        subscriptionWrap.sessionToken = subscription.sessionToken;
        subscriptionWrap.unsubscribe = subscription.unsubscribe;
        // Cannot create these events on a nested way because of EventEmiiter from React Native
        subscription.on('open', function () {
          subscriptionWrap.emit('open');
        });
        subscription.on('create', function (object) {
          subscriptionWrap.emit('create', object);
        });
        subscription.on('update', function (object) {
          subscriptionWrap.emit('update', object);
        });
        subscription.on('enter', function (object) {
          subscriptionWrap.emit('enter', object);
        });
        subscription.on('leave', function (object) {
          subscriptionWrap.emit('leave', object);
        });
        subscription.on('delete', function (object) {
          subscriptionWrap.emit('delete', object);
        });
        subscription.on('close', function (object) {
          subscriptionWrap.emit('close', object);
        });
        subscription.on('error', function (object) {
          subscriptionWrap.emit('error', object);
        });

        _this3.resolve();
      });
    });
    return subscriptionWrap;
  },
  unsubscribe: function (subscription) {
    var _this4 = this;

    getLiveQueryClient().then(function (liveQueryClient) {
      _this4.resolve(liveQueryClient.unsubscribe(subscription));
    });
  },
  _clearCachedDefaultClient: function () {
    defaultLiveQueryClient = null;
  }
};

_CoreManager2.default.setLiveQueryController(DefaultLiveQueryController);

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(257), __esModule: true };

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(92);
__webpack_require__(76);
__webpack_require__(61);
__webpack_require__(258);
__webpack_require__(261);
__webpack_require__(264);
__webpack_require__(265);
module.exports = __webpack_require__(5).Map;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(259);
var validate = __webpack_require__(67);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(130)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(18).f;
var create = __webpack_require__(58);
var redefineAll = __webpack_require__(95);
var ctx = __webpack_require__(39);
var anInstance = __webpack_require__(96);
var forOf = __webpack_require__(50);
var $iterDefine = __webpack_require__(79);
var step = __webpack_require__(115);
var setSpecies = __webpack_require__(260);
var DESCRIPTORS = __webpack_require__(19);
var fastKey = __webpack_require__(40).fastKey;
var validate = __webpack_require__(67);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var core = __webpack_require__(5);
var dP = __webpack_require__(18);
var DESCRIPTORS = __webpack_require__(19);
var SPECIES = __webpack_require__(15)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(16);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(262)('Map') });


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(123);
var from = __webpack_require__(263);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(50);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(131)('Map');


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(132)('Map');


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(27);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(34);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(35);

var _inherits3 = _interopRequireDefault(_inherits2);

var _EventEmitter2 = __webpack_require__(97);

var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);

var _CoreManager = __webpack_require__(9);

var _CoreManager2 = _interopRequireDefault(_CoreManager);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Creates a new LiveQuery Subscription.
 * Extends events.EventEmitter
 * <a href="https://nodejs.org/api/events.html#events_class_eventemitter">cloud functions</a>.
 * 
 *
 * <p>Open Event - When you call query.subscribe(), we send a subscribe request to 
 * the LiveQuery server, when we get the confirmation from the LiveQuery server,
 * this event will be emitted. When the client loses WebSocket connection to the
 * LiveQuery server, we will try to auto reconnect the LiveQuery server. If we
 * reconnect the LiveQuery server and successfully resubscribe the ParseQuery,
 * you'll also get this event.
 * 
 * <pre>
 * subscription.on('open', () => {
 * 
 * });</pre></p>
 *
 * <p>Create Event - When a new ParseObject is created and it fulfills the ParseQuery you subscribe,
 * you'll get this event. The object is the ParseObject which is created.
 * 
 * <pre>
 * subscription.on('create', (object) => {
 * 
 * });</pre></p>
 *
 * <p>Update Event - When an existing ParseObject which fulfills the ParseQuery you subscribe 
 * is updated (The ParseObject fulfills the ParseQuery before and after changes),
 * you'll get this event. The object is the ParseObject which is updated.
 * Its content is the latest value of the ParseObject.
 * 
 * <pre>
 * subscription.on('update', (object) => {
 * 
 * });</pre></p>
 * 
 * <p>Enter Event - When an existing ParseObject's old value doesn't fulfill the ParseQuery
 * but its new value fulfills the ParseQuery, you'll get this event. The object is the
 * ParseObject which enters the ParseQuery. Its content is the latest value of the ParseObject.
 * 
 * <pre>
 * subscription.on('enter', (object) => {
 * 
 * });</pre></p>
 *
 *
 * <p>Update Event - When an existing ParseObject's old value fulfills the ParseQuery but its new value
 * doesn't fulfill the ParseQuery, you'll get this event. The object is the ParseObject
 * which leaves the ParseQuery. Its content is the latest value of the ParseObject.
 * 
 * <pre>
 * subscription.on('leave', (object) => {
 * 
 * });</pre></p>
 *
 *
 * <p>Delete Event - When an existing ParseObject which fulfills the ParseQuery is deleted, you'll
 * get this event. The object is the ParseObject which is deleted.
 * 
 * <pre>
 * subscription.on('delete', (object) => {
 * 
 * });</pre></p>
 *
 *
 * <p>Close Event - When the client loses the WebSocket connection to the LiveQuery
 * server and we stop receiving events, you'll get this event.
 * 
 * <pre>
 * subscription.on('close', () => {
 * 
 * });</pre></p>
 *
 * @alias Parse.LiveQuerySubscription
 */
/*
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

var Subscription = function (_EventEmitter) {
  (0, _inherits3.default)(Subscription, _EventEmitter);

  /*
   * @param {string} id - subscription id
   * @param {string} query - query to subscribe to
   * @param {string} sessionToken - optional session token
   */
  function Subscription(id, query, sessionToken) {
    (0, _classCallCheck3.default)(this, Subscription);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (Subscription.__proto__ || (0, _getPrototypeOf2.default)(Subscription)).call(this));

    _this2.id = id;
    _this2.query = query;
    _this2.sessionToken = sessionToken;
    return _this2;
  }

  /**
   * closes the subscription
   */

  (0, _createClass3.default)(Subscription, [{
    key: 'unsubscribe',
    value: function () {
      var _this3 = this;

      var _this = this;
      _CoreManager2.default.getLiveQueryController().getDefaultLiveQueryClient().then(function (liveQueryClient) {
        liveQueryClient.unsubscribe(_this);
        _this.emit('close');
        _this3.resolve();
      });
    }
  }]);
  return Subscription;
}(_EventEmitter3.default);

exports.default = Subscription;

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialize */
/* unused harmony export ga */
/* unused harmony export set */
/* unused harmony export send */
/* unused harmony export pageview */
/* unused harmony export modalview */
/* unused harmony export timing */
/* unused harmony export event */
/* unused harmony export exception */
/* unused harmony export plugin */
/* unused harmony export outboundLink */
/* unused harmony export testModeAPI */
/* unused harmony export OutboundLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(269);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialize = __WEBPACK_IMPORTED_MODULE_1__core__["initialize"];
var ga = __WEBPACK_IMPORTED_MODULE_1__core__["ga"];
var set = __WEBPACK_IMPORTED_MODULE_1__core__["set"];
var send = __WEBPACK_IMPORTED_MODULE_1__core__["send"];
var pageview = __WEBPACK_IMPORTED_MODULE_1__core__["pageview"];
var modalview = __WEBPACK_IMPORTED_MODULE_1__core__["modalview"];
var timing = __WEBPACK_IMPORTED_MODULE_1__core__["timing"];
var event = __WEBPACK_IMPORTED_MODULE_1__core__["event"];
var exception = __WEBPACK_IMPORTED_MODULE_1__core__["exception"];
var plugin = __WEBPACK_IMPORTED_MODULE_1__core__["plugin"];
var outboundLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];
var testModeAPI = __WEBPACK_IMPORTED_MODULE_1__core__["testModeAPI"];
__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].origTrackLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].trackLink;
__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].trackLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];
var OutboundLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__core__, {
  OutboundLink: OutboundLink
}));

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OutboundLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_console_warn__ = __webpack_require__(98);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink =
/*#__PURE__*/
function (_Component) {
  _inherits(OutboundLink, _Component);

  function OutboundLink() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick,
          trackerNames = _this$props.trackerNames;
      var eventMeta = {
        label: eventLabel
      };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        }, trackerNames);
      } else {
        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
      }

      if (onClick) {
        onClick(event);
      }
    });

    return _this;
  }

  _createClass(OutboundLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.to,
          oldProps = _objectWithoutProperties(_this$props2, ["to"]);

      var props = _objectSpread({}, oldProps, {
        href: href,
        onClick: this.handleClick
      });

      if (this.props.target === NEWTAB) {
        props.rel = 'noopener noreferrer';
      }

      delete props.eventLabel;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(OutboundLink, "trackLink", function () {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils_console_warn__["a" /* default */])('ga tracking not enabled');
});

_defineProperty(OutboundLink, "propTypes", {
  eventLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  trackerNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
});

_defineProperty(OutboundLink, "defaultProps", {
  target: null,
  to: null,
  onClick: null,
  trackerNames: null
});



/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["initialize"] = initialize;
/* harmony export (immutable) */ __webpack_exports__["ga"] = ga;
/* harmony export (immutable) */ __webpack_exports__["set"] = set;
/* harmony export (immutable) */ __webpack_exports__["send"] = send;
/* harmony export (immutable) */ __webpack_exports__["pageview"] = pageview;
/* harmony export (immutable) */ __webpack_exports__["modalview"] = modalview;
/* harmony export (immutable) */ __webpack_exports__["timing"] = timing;
/* harmony export (immutable) */ __webpack_exports__["event"] = event;
/* harmony export (immutable) */ __webpack_exports__["exception"] = exception;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "plugin", function() { return plugin; });
/* harmony export (immutable) */ __webpack_exports__["outboundLink"] = outboundLink;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "testModeAPI", function() { return testModeAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_format__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_trim__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_loadGA__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_console_warn__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_console_log__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__ = __webpack_require__(276);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * React Google Analytics Module
 *
 * @package react-ga
 * @author  Adam Lofting <adam@mozillafoundation.org>
 *          Atul Varma <atul@mozillafoundation.org>
 */

/**
 * Utilities
 */








var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';

var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */].ga.apply(__WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */], arguments);
  if (_isNotBrowser) return false;
  if (!window.ga) return Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_format__["a" /* default */])(s, _titleCase);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];

  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);

    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (_isNotBrowser) {
      return false;
    }

    if (!options || options.standardImplementation !== true) Object(__WEBPACK_IMPORTED_MODULE_3__utils_loadGA__["a" /* default */])(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;

  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if (_typeof(config) !== 'object') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('All configs must be an object');
        return;
      }

      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }

  return true;
}
/**
 * ga:
 * Returns the original GA object.
 */

function ga() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(void 0, args);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'arguments\');');
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with arguments: ".concat(JSON.stringify(args)));
    }
  }

  return window.ga;
}
/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`fieldsObject` is required in .set()');
    return;
  }

  if (_typeof(fieldsObject) !== 'object') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'set\', fieldsObject);');
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
  }
}
/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', fieldObject);');
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with trackers: ".concat(JSON.stringify(trackerNames)));
  }
}
/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */

function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path is required in .pageview()');
    return;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawPath);

  if (path === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};

  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', _objectSpread({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', \'pageview\', path);');
      var extraLog = '';

      if (title) {
        extraLog = " and title: ".concat(title);
      }

      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path).concat(extraLog));
    }
  }
}
/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = Object(__WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawModalName));

  if (modalName === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = "/modal/".concat(modalName);

    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', \'pageview\', path);');
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path));
    }
  }
}
/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    if (!category || !variable || !value || typeof value !== 'number') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}
/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category AND args.action are required in event()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    }; // Optional Fields

    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });
    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    }); // Send to GA

    send(fieldObject, trackerNames);
  }
}
/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    }; // Optional Fields

    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    } // Send to GA


    send(fieldObject, trackerNames);
  }
}
var plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   */
  require: function require(rawName, options) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` is required in .require()');
        return;
      }

      var name = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawName);

      if (name === '') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` cannot be an empty string in .require()');
        return;
      } // Optional Fields


      if (options) {
        if (_typeof(options) !== 'object') {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Empty `options` given to .require()');
        }

        ga('require', name, options);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
        }
      } else {
        ga('require', name);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "');"));
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload;
    var actionType;

    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
      payload = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      actionType = arguments.length <= 2 ? undefined : arguments[2];
      payload = arguments.length <= 3 ? undefined : arguments[3];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `action` arg to be a String.');
      } else {
        var command = "".concat(pluginName, ":").concat(action);
        payload = payload || null;

        if (actionType && payload) {
          ga(command, actionType, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
          }
        } else if (payload) {
          ga(command, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with payload: ".concat(JSON.stringify(payload)));
          }
        } else {
          ga(command);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
          }
        }
      }
    }
  }
};
/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */

function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.label is required in outboundLink()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };
    var safetyCallbackCalled = false;

    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;
      hitCallback();
    }; // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data
    // register safety net timeout:


    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);

      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA

    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}
var testModeAPI = __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */];
/* harmony default export */ __webpack_exports__["default"] = ({
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  testModeAPI: __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */]
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mightBeEmail__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toTitleCase__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__console_warn__ = __webpack_require__(98);



var redacted = 'REDACTED (Potential Email Address)';
function format(s, titleCase) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__mightBeEmail__["a" /* default */])(s)) {
    Object(__WEBPACK_IMPORTED_MODULE_2__console_warn__["a" /* default */])('This arg looks like an email address, redacting.');
    return redacted;
  }

  if (titleCase) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__toTitleCase__["a" /* default */])(s);
  }

  return s;
}

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mightBeEmail;
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return /[^@]+@[^@]+/.test(s);
}

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toTitleCase;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trim__ = __webpack_require__(136);
/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__trim__["a" /* default */])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeLeadingSlash;
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  var gaAddress = 'https://www.google-analytics.com/analytics.js';

  if (options && options.gaAddress) {
    gaAddress = options.gaAddress;
  } else if (options && options.debug) {
    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  /* eslint-disable */


  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', gaAddress, 'ga');
  /* eslint-enable */

});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
function log(s) {
  console.info('[react-ga]', s);
}

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gaCalls */
var gaCalls = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
});

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StickyContainer = exports.Sticky = undefined;

var _Sticky = __webpack_require__(278);

var _Sticky2 = _interopRequireDefault(_Sticky);

var _Container = __webpack_require__(279);

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Sticky = _Sticky2.default;
exports.StickyContainer = _Container2.default;
exports.default = _Sticky2.default;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(72);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(11);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Sticky = function (_Component) {
  _inherits(Sticky, _Component);

  function Sticky() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Sticky);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isSticky: false,
      wasSticky: false,
      style: {}
    }, _this.handleContainerEvent = function (_ref2) {
      var distanceFromTop = _ref2.distanceFromTop,
          distanceFromBottom = _ref2.distanceFromBottom,
          eventSource = _ref2.eventSource;

      var parent = _this.context.getParent();

      var preventingStickyStateChanges = false;
      if (_this.props.relative) {
        preventingStickyStateChanges = eventSource !== parent;
        distanceFromTop = -(eventSource.scrollTop + eventSource.offsetTop) + _this.placeholder.offsetTop;
      }

      var placeholderClientRect = _this.placeholder.getBoundingClientRect();
      var contentClientRect = _this.content.getBoundingClientRect();
      var calculatedHeight = contentClientRect.height;

      var bottomDifference = distanceFromBottom - _this.props.bottomOffset - calculatedHeight;

      var wasSticky = !!_this.state.isSticky;
      var isSticky = preventingStickyStateChanges ? wasSticky : distanceFromTop <= -_this.props.topOffset && distanceFromBottom > -_this.props.bottomOffset;

      distanceFromBottom = (_this.props.relative ? parent.scrollHeight - parent.scrollTop : distanceFromBottom) - calculatedHeight;

      var style = !isSticky ? {} : {
        position: "fixed",
        top: bottomDifference > 0 ? _this.props.relative ? parent.offsetTop - parent.offsetParent.scrollTop : 0 : bottomDifference,
        left: placeholderClientRect.left,
        width: placeholderClientRect.width
      };

      if (!_this.props.disableHardwareAcceleration) {
        style.transform = "translateZ(0)";
      }

      _this.setState({
        isSticky: isSticky,
        wasSticky: wasSticky,
        distanceFromTop: distanceFromTop,
        distanceFromBottom: distanceFromBottom,
        calculatedHeight: calculatedHeight,
        style: style
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Sticky, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (!this.context.subscribe) throw new TypeError("Expected Sticky to be mounted within StickyContainer");

      this.context.subscribe(this.handleContainerEvent);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.context.unsubscribe(this.handleContainerEvent);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.placeholder.style.paddingBottom = this.props.disableCompensation ? 0 : (this.state.isSticky ? this.state.calculatedHeight : 0) + "px";
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var element = _react2.default.cloneElement(this.props.children({
        isSticky: this.state.isSticky,
        wasSticky: this.state.wasSticky,
        distanceFromTop: this.state.distanceFromTop,
        distanceFromBottom: this.state.distanceFromBottom,
        calculatedHeight: this.state.calculatedHeight,
        style: this.state.style
      }), {
        ref: function ref(content) {
          _this2.content = _reactDom2.default.findDOMNode(content);
        }
      });

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement("div", { ref: function ref(placeholder) {
            return _this2.placeholder = placeholder;
          } }),
        element
      );
    }
  }]);

  return Sticky;
}(_react.Component);

Sticky.propTypes = {
  topOffset: _propTypes2.default.number,
  bottomOffset: _propTypes2.default.number,
  relative: _propTypes2.default.bool,
  children: _propTypes2.default.func.isRequired
};
Sticky.defaultProps = {
  relative: false,
  topOffset: 0,
  bottomOffset: 0,
  disableCompensation: false,
  disableHardwareAcceleration: false
};
Sticky.contextTypes = {
  subscribe: _propTypes2.default.func,
  unsubscribe: _propTypes2.default.func,
  getParent: _propTypes2.default.func
};
exports.default = Sticky;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(11);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _raf = __webpack_require__(280);

var _raf2 = _interopRequireDefault(_raf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Container = function (_PureComponent) {
  _inherits(Container, _PureComponent);

  function Container() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Container);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Container.__proto__ || Object.getPrototypeOf(Container)).call.apply(_ref, [this].concat(args))), _this), _this.events = ["resize", "scroll", "touchstart", "touchmove", "touchend", "pageshow", "load"], _this.subscribers = [], _this.rafHandle = null, _this.subscribe = function (handler) {
      _this.subscribers = _this.subscribers.concat(handler);
    }, _this.unsubscribe = function (handler) {
      _this.subscribers = _this.subscribers.filter(function (current) {
        return current !== handler;
      });
    }, _this.notifySubscribers = function (evt) {
      if (!_this.framePending) {
        var currentTarget = evt.currentTarget;


        _this.rafHandle = (0, _raf2.default)(function () {
          _this.framePending = false;

          var _this$node$getBoundin = _this.node.getBoundingClientRect(),
              top = _this$node$getBoundin.top,
              bottom = _this$node$getBoundin.bottom;

          _this.subscribers.forEach(function (handler) {
            return handler({
              distanceFromTop: top,
              distanceFromBottom: bottom,
              eventSource: currentTarget === window ? document.body : _this.node
            });
          });
        });
        _this.framePending = true;
      }
    }, _this.getParent = function () {
      return _this.node;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Container, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        subscribe: this.subscribe,
        unsubscribe: this.unsubscribe,
        getParent: this.getParent
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.events.forEach(function (event) {
        return window.addEventListener(event, _this2.notifySubscribers);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (this.rafHandle) {
        _raf2.default.cancel(this.rafHandle);
        this.rafHandle = null;
      }

      this.events.forEach(function (event) {
        return window.removeEventListener(event, _this3.notifySubscribers);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement("div", _extends({}, this.props, {
        ref: function ref(node) {
          return _this4.node = node;
        },
        onScroll: this.notifySubscribers,
        onTouchStart: this.notifySubscribers,
        onTouchMove: this.notifySubscribers,
        onTouchEnd: this.notifySubscribers
      }));
    }
  }]);

  return Container;
}(_react.PureComponent);

Container.childContextTypes = {
  subscribe: _propTypes2.default.func,
  unsubscribe: _propTypes2.default.func,
  getParent: _propTypes2.default.func
};
exports.default = Container;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(281)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)))

/***/ }),
/* 282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__ = __webpack_require__(286);



function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__["a" /* default */])();
}

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__ = __webpack_require__(290);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__ = __webpack_require__(139);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__["a" /* default */])(self);
}

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableRest__ = __webpack_require__(298);



function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__nonIterableRest__["a" /* default */])();
}

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose__ = __webpack_require__(300);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose__["a" /* default */])(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PropsDecoratorProvider__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createSubstyle__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultPropsDecorator__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inline__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useStyles__ = __webpack_require__(307);
/* unused harmony reexport createSubstyle */
/* unused harmony reexport PropsDecoratorProvider */
/* unused harmony reexport PropsDecoratorContext */
/* unused harmony reexport defaultPropsDecorator */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__inline__["a"]; });






/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4__useStyles__["a" /* default */]);

/***/ }),
/* 302 */
/***/ (function(module, exports) {

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 303 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 304 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coerceSelection__ = __webpack_require__(145);

var EMPTY = {};

var memoize = function memoize(substyle) {
  return function (select, defaultStyle) {
    var cacheKey = defaultStyle || EMPTY;
    substyle.memoize = substyle.memoize || new WeakMap();
    var mapEntry;

    if (!substyle.memoize.has(cacheKey)) {
      mapEntry = {};
      substyle.memoize.set(cacheKey, mapEntry);
    } else {
      mapEntry = substyle.memoize.get(cacheKey);
    }

    var selectHash = Object(__WEBPACK_IMPORTED_MODULE_0__coerceSelection__["a" /* default */])(select).join(' ');
    return selectHash in mapEntry ? mapEntry[selectHash] : mapEntry[selectHash] = substyle(select || [], defaultStyle);
  };
};

/* harmony default export */ __webpack_exports__["a"] = (memoize);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var inline = function inline() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.reduce(function (result, arg) {
    return _objectSpread(_objectSpread(_objectSpread({}, result), typeof arg === 'function' ? arg : {}), {}, {
      style: _objectSpread(_objectSpread({}, result.style), typeof arg === 'function' ? arg.style : arg)
    });
  }, {});
};

/* harmony default export */ __webpack_exports__["a"] = (inline);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PropsDecoratorProvider__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createSubstyle__ = __webpack_require__(144);




var useStyles = function useStyles(defaultStyle, _ref, modifiers) {
  var style = _ref.style,
      className = _ref.className,
      classNames = _ref.classNames;
  var propsDecorator = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__PropsDecoratorProvider__["a" /* PropsDecoratorContext */]);
  var substyle = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_2__createSubstyle__["a" /* default */])({
      style: style,
      className: className,
      classNames: classNames
    }, propsDecorator);
  }, [style, className, classNames, propsDecorator]);
  return substyle(modifiers, defaultStyle);
};

/* harmony default export */ __webpack_exports__["a"] = (useStyles);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__global_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__singlepost_jsx__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//const Post = ({ match }) => <p>Bloop {match.params.id}</p>;
/*
class Post extends React.Component {
    render() {
    return (
        <div>
          <p>Bloop {this.props.match.params.id}</p>
        </div>

    );
  }
}*/var Post=function(_React$Component){_inherits(Post,_React$Component);function Post(props){_classCallCheck(this,Post);var _this=_possibleConstructorReturn(this,(Post.__proto__||Object.getPrototypeOf(Post)).call(this,props));__WEBPACK_IMPORTED_MODULE_1_parse___default.a.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5","sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw");//PASTE HERE YOUR Back4App APPLICATION ID AND YOUR JavaScript KEY
__WEBPACK_IMPORTED_MODULE_1_parse___default.a.serverURL="https://parse.joelskitchen.com/parse";//Parse.serverURL = "https://parsetest.joelskitchen.com/parse";
var now=new Date();_this.state={postID:0,postData:null,created_at:now.getTime(),comments:null,postImage:null,userImage:null,user:null,caption:null,likeCount:0,saveCount:0,commentCount:0};_this.setState({postID:_this.props.match.params.id});_this.postID=_this.props.match.params.id;_this.queryForPostData();return _this;}_createClass(Post,[{key:'queryForPostData',value:function queryForPostData(){console.log("QueryForPostData");var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');/*
        var isAdmin = false;
        if (Parse.User.current())
            isAdmin = Parse.User.current().get("isAdmin");

       //TEMP -- see all recipes
        if (!isAdmin)
          */query.equalTo("objectId",this.postID);query.include("user");query.include("image");query.include("thumbnail");query.include("likeCountNew");query.include("saveCount");query.include("commentcount");query.include("_created_at");query.include("createdAt");query.include("recipe");query.include("product");query.include("collabUser");query.include("collabUser.displayUsername");query.ascending("name");var self=this;query.first().then(function(result){if(result){console.log("Query found something");console.log(result);self.setState({postData:result});console.log("User: ",result.get("user"));console.log("Username: ",result.get("user").get("displayUsername"));console.log("User image: ",result.get("user").get("profilePictureSmall").url());console.log("Image: ",result.get("image").url());self.setState({user:result.get("user")});self.setState({userImage:result.get("user").get("profilePictureSmall").url()});self.setState({username:result.get("user").get("displayUsername")});self.setState({postImage:result.get("image").url()});self.setState({caption:result.get("caption")});self.setState({created_at:result.get("createdAt")});var likeCount=result.get("likeCountNew");var saveCount=result.get("saveCount");var commentCount=result.get("commentcount");if(!likeCount)likeCount=0;if(!saveCount)saveCount=0;if(!commentCount)commentCount=0;self.setState({likeCount:likeCount});self.setState({saveCount:saveCount});self.setState({commentCount:commentCount});self.queryForComments();// If result was defined, the object with this objectID was found
//promise.resolve(result);
}else{console.log("No post found");// promise.resolve(null);
}},function(error){console.error("Error loading post Error: "+error);//promise.error(error);
});}},{key:'render',value:function render(){var likesWord="likes";var savesWord="saves";var commentsWord="comments";if(this.state.likeCount==1)likesWord="like";if(this.state.saveCount==1)savesWord="save";if(this.state.commentCount==1)commentsWord="comment";if(!this.state.postData){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null);}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('main',{className:'single_card_wrapper'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner sticky_app_btn'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'single_card'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__singlepost_jsx__["a" /* default */],{postData:this.state.postData,showComments:'true'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'get-app cta_btn'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'secondary-btn btn-wrp sml-btn'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);',type:'button','data-toggle':'modal','data-target':'#kitchenQrModal',title:'Get app'},'Get app'))))));}}]);return Post;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);var Posts=function(_React$Component2){_inherits(Posts,_React$Component2);function Posts(){_classCallCheck(this,Posts);return _possibleConstructorReturn(this,(Posts.__proto__||Object.getPrototypeOf(Posts)).apply(this,arguments));}_createClass(Posts,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Route */],{path:'/post/:id',component:Post}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Route */],{path:'/posts/:id',component:Post}));}}]);return Posts;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Posts);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__global_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Singlepostoverly_jsx__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//const Post = ({ match }) => <p>Bloop {match.params.id}</p>;
/*
class Post extends React.Component {
    render() {
    return (
        <div>
          <p>Bloop {this.props.match.params.id}</p>
        </div>

    );
  }
}*/var Postsone=function(_React$Component){_inherits(Postsone,_React$Component);function Postsone(props){_classCallCheck(this,Postsone);var _this=_possibleConstructorReturn(this,(Postsone.__proto__||Object.getPrototypeOf(Postsone)).call(this,props));__WEBPACK_IMPORTED_MODULE_1_parse___default.a.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5","sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw");//PASTE HERE YOUR Back4App APPLICATION ID AND YOUR JavaScript KEY
__WEBPACK_IMPORTED_MODULE_1_parse___default.a.serverURL="https://parse.joelskitchen.com/parse";//Parse.serverURL = "https://parsetest.joelskitchen.com/parse";
var now=new Date();_this.state={postID:0,postData:null,created_at:now.getTime(),comments:null,postImage:null,userImage:null,user:null,caption:null,likeCount:0,saveCount:0,commentCount:0};_this.setState({postID:_this.props.match.params.id});_this.postID=_this.props.match.params.id;_this.queryForPostData();return _this;}_createClass(Postsone,[{key:'queryForPostData',value:function queryForPostData(){console.log("QueryForPostData");var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');/*
        var isAdmin = false;
        if (Parse.User.current())
            isAdmin = Parse.User.current().get("isAdmin");

       //TEMP -- see all recipes
        if (!isAdmin)
          */query.equalTo("objectId",this.postID);query.include("user");query.include("image");query.include("thumbnail");query.include("likeCountNew");query.include("saveCount");query.include("commentcount");query.include("_created_at");query.include("createdAt");query.include("recipe");query.include("product");query.include("collabUser");query.include("collabUser.displayUsername");query.ascending("name");var self=this;query.first().then(function(result){if(result){console.log("Query found something");console.log(result);self.setState({postData:result});console.log("User: ",result.get("user"));console.log("Username: ",result.get("user").get("displayUsername"));console.log("User image: ",result.get("user").get("profilePictureSmall").url());console.log("Image: ",result.get("image").url());self.setState({user:result.get("user")});self.setState({userImage:result.get("user").get("profilePictureSmall").url()});self.setState({username:result.get("user").get("displayUsername")});self.setState({postImage:result.get("image").url()});self.setState({caption:result.get("caption")});self.setState({created_at:result.get("createdAt")});var likeCount=result.get("likeCountNew");var saveCount=result.get("saveCount");var commentCount=result.get("commentcount");if(!likeCount)likeCount=0;if(!saveCount)saveCount=0;if(!commentCount)commentCount=0;self.setState({likeCount:likeCount});self.setState({saveCount:saveCount});self.setState({commentCount:commentCount});self.queryForComments();// If result was defined, the object with this objectID was found
//promise.resolve(result);
}else{console.log("No post found");// promise.resolve(null);
}},function(error){console.error("Error loading post Error: "+error);//promise.error(error);
});}},{key:'render',value:function render(){var likesWord="likes";var savesWord="saves";var commentsWord="comments";if(this.state.likeCount==1)likesWord="like";if(this.state.saveCount==1)savesWord="save";if(this.state.commentCount==1)commentsWord="comment";if(!this.state.postData){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null);}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('main',{className:'single_card_wrapper'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner sticky_app_btn'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'single_card'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Singlepostoverly_jsx__["a" /* default */],{postData:this.state.postData,showComments:'true'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'get-app cta_btn'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'secondary-btn btn-wrp sml-btn'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);',type:'button','data-toggle':'modal','data-target':'#kitchenQrModal',title:'Get app'},'Get app'))))));}}]);return Postsone;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);var Posts1=function(_React$Component2){_inherits(Posts1,_React$Component2);function Posts1(){_classCallCheck(this,Posts1);return _possibleConstructorReturn(this,(Posts1.__proto__||Object.getPrototypeOf(Posts1)).apply(this,arguments));}_createClass(Posts1,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Route */],{path:'/postsone/:id',component:Postsone}));}}]);return Posts1;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Posts1);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__global_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__singlepost_css__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__singlepost_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__singlepost_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__recipe_jsx__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__product_jsx__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_mentions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__defaultStyle__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__defaultMentionStyle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MentionTextarea_css__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MentionTextarea_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__MentionTextarea_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Leftsidebar_jsx__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function time_ago(time){switch(typeof time==='undefined'?'undefined':_typeof(time)){case'number':break;case'string':time=+new Date(time);break;case'object':if(time.constructor===Date)time=time.getTime();break;default:time=+new Date();}var time_formats=[[60,'s',1],// 60
[120,'1m','1 minute from now'],// 60*2
[3600,'m',60],// 60*60, 60
[7200,'1h','1 hour from now'],// 60*60*2
[86400,'h',3600],// 60*60*24, 60*60
[172800,'1d','Tomorrow'],// 60*60*24*2
[604800,'d',86400],// 60*60*24*7, 60*60*24
[1209600,'1w','Next week'],// 60*60*24*7*4*2
[2419200,'w',604800],// 60*60*24*7*4, 60*60*24*7
[4838400,'1m','Next month'],// 60*60*24*7*4*2
[29030400,'m',2419200],// 60*60*24*7*4*12, 60*60*24*7*4
[58060800,'1y','Next year'],// 60*60*24*7*4*12*2
[2903040000,'y',29030400],// 60*60*24*7*4*12*100, 60*60*24*7*4*12
[5806080000,'Last century','Next century'],// 60*60*24*7*4*12*100*2
[58060800000,'centuries',2903040000]// 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
/* [60, 'seconds', 1], // 60
      [120, '1 minute ago', '1 minute from now'], // 60*2
      [3600, 'minutes', 60], // 60*60, 60
      [7200, '1 hour ago', '1 hour from now'], // 60*60*2
      [86400, 'hours', 3600], // 60*60*24, 60*60
      [172800, 'Yesterday', 'Tomorrow'], // 60*60*24*2
      [604800, 'days', 86400], // 60*60*24*7, 60*60*24
      [1209600, 'Last week', 'Next week'], // 60*60*24*7*4*2
      [2419200, 'weeks', 604800], // 60*60*24*7*4, 60*60*24*7
      [4838400, 'Last month', 'Next month'], // 60*60*24*7*4*2
      [29030400, 'months', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
      [58060800, 'Last year', 'Next year'], // 60*60*24*7*4*12*2
      [2903040000, 'years', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
      [5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
      [58060800000, 'centuries', 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100*/];var seconds=(+new Date()-time)/1000,// token = 'ago',
token='',list_choice=1;if(seconds==0){// return 'Just now'
return'';}if(seconds<0){seconds=Math.abs(seconds);//token = 'from now';
token='';list_choice=2;}var i=0,format;while(format=time_formats[i++]){if(seconds<format[0]){if(typeof format[2]=='string')return format[list_choice];else// return Math.floor(seconds / format[2]) + ' ' + format[1] + ' ' + token;
return Math.floor(seconds/format[2])+''+format[1]+''+token;}}return time;}var Singlepostoverly=function(_React$Component){_inherits(Singlepostoverly,_React$Component);function Singlepostoverly(props){_classCallCheck(this,Singlepostoverly);var _this=_possibleConstructorReturn(this,(Singlepostoverly.__proto__||Object.getPrototypeOf(Singlepostoverly)).call(this,props));_initialiseProps.call(_this);__WEBPACK_IMPORTED_MODULE_2_parse___default.a.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5","sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw");//PASTE HERE YOUR Back4App APPLICATION ID AND YOUR JavaScript KEY
__WEBPACK_IMPORTED_MODULE_2_parse___default.a.serverURL="https://parse.joelskitchen.com/parse";//Parse.serverURL = "https://parsetest.joelskitchen.com/parse";
var now=new Date();_this.state={postID:0,postData:null,created_at:now.getTime(),comments:null,postImage:null,userImage:null,user:null,caption:null,likeCount:0,saveCount:0,commentCount:0,recipe:null,product:null,city:null,postcomment:'',isChallenge:"0",CurrentSaveCount:0,currentuserImage:null,currentUserId:null,singlelikeCount:0,isExpanded:false,expandedCommentId:null,blank_comment_message:null,challengeStatus:null,singlementioned:'',singleget_allusers:[],linkdata:'',loadpage:'home',getUsernamefetch:null,usertype:0,popup_username:null,popup_comments:null,comments_data:null,likeCount1:0,likeuserlist:[]};//load vals from post objects
//temp cheese
var result=props.postData;//console.log("********************************");
// console.log("RESULT: ", JSON.stringify(result));
// console.log("USER: ", JSON.stringify(result.get("user")));
// console.log("================================");
// if (result.get("user") != undefined)
//  console.log("Username: ", result.get("user").get("displayUsername"));
// else
//   console.log("UNDEFINED USER");
if(result.get("image")){//console.log("Image: ", result.get("image").url());
_this.state.postImage=result.get("image").url();}if(result.get("isChallenge")){//console.log("Image: ", result.get("image").url());
_this.state.isChallenge=result.get("isChallenge");}_this.state.user=result.get("user");var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser!=null){if(currentUser.get("isCreator")!==undefined&&currentUser.get("isCreator")===1||currentUser.get("isBusiness")!==undefined&&currentUser.get("isBusiness")===1||currentUser.get("isAdmin")!==undefined&&currentUser.get("isAdmin")==="1"){_this.state.usertype=1;}}_this.state.username=result.get("user").get("displayUsername");//new code
if(_this.state.user){_this.state.getUsernamefetch=_this.state.username;if(!_this.state.getUsernamefetch||_this.state.getUsernamefetch.length<2){_this.state.getUsernamefetch=_this.state.user.get("firstName")+"_"+_this.state.user.get("lastName");_this.state.getUsernamefetch=_this.state.getUsernamefetch.toLowerCase(_this.state.getUsernamefetch);}}//new code
if(result.get("user").get("profilePictureSmall")){//console.log("User image: ", result.get("user").get("profilePictureSmall").url());
_this.state.userImage=result.get("user").get("profilePictureSmall").url();//console.log('profile  pic small');
// console.log(result.get("user").get("profilePictureSmall").url());
}else{_this.state.userImage="/images/default_userpic0.png";}_this.state.caption=result.get("caption");_this.state.created_at=result.get("createdAt");_this.state.city=result.get("user").get("city");var likeCount=result.get("likeCountNew");//var likeCount1 = result.get("likeCountNew");
var saveCount=result.get("saveCount");var commentCount=result.get("commentcount");var imprCount=result.get("impr");_this.state.title=result.get("title");_this.state.url=result.get("url");_this.state.collabUser=result.get("collabUser");_this.state.collabUsername=result.get("collabUsername");if(_this.state.collabUser){result.get("collabUser").fetch();}if(!likeCount)likeCount=0;if(!saveCount)saveCount=0;if(!commentCount)commentCount=0;if(!imprCount)imprCount=1;_this.state.likeCount=likeCount;_this.state.saveCount=saveCount;_this.state.commentCount=commentCount;_this.state.imprCount=imprCount;_this.state.postID=result.id;_this.state.challengeStatus=result.get("challengeStatus");_this.state.postLink="/postsone/"+_this.state.postID;_this.state.recipe=result.get("recipeV2");_this.state.product=result.get("productV2");if(_this.props.showComments&&_this.state.recipe)_this.state.recipe.fetch();if(_this.props.showComments&&_this.state.product)_this.state.product.fetch();if(_this.props.showComments)//detail view only
{_this.queryForComments();_this.props.postData.increment("impr");_this.props.postData.save();_this.state.loadpage='single';_this.singlegetAllUsers();//imprCount++;
//this.props.postData.set("imprcount", imprCount);
//this.props.postData.save();
}//this.popuprenderComments()
_this.updateInput=_this.updateInput.bind(_this);_this.handleCommentPost=_this.handleCommentPost.bind(_this);_this.handleCommentPostUpdate=_this.handleCommentPostUpdate.bind(_this);_this.handleSavePost=_this.handleSavePost.bind(_this);_this.handleGetSavePost=_this.handleGetSavePost.bind(_this);_this.handleFollowUser=_this.handleFollowUser.bind(_this);_this.handleUnFollowUser=_this.handleUnFollowUser.bind(_this);_this.handleGetFollowUser=_this.handleGetFollowUser.bind(_this);_this.cancelText=_this.cancelText.bind(_this);_this.getUserProfileImage();_this.handlePhotoLike=_this.handlePhotoLike.bind(_this);_this.formatRenderComments=_this.formatRenderComments.bind(_this);_this.handlePostModelOpen=_this.handlePostModelOpen.bind(_this);_this.handleGetLikePost=_this.handleGetLikePost.bind(_this);_this.handlePhotoUnLike=_this.handlePhotoUnLike.bind(_this);_this.handlePhotoActivityLike=_this.handlePhotoActivityLike.bind(_this);_this.handleGetActivityLikePost=_this.handleGetActivityLikePost.bind(_this);_this.handlePhotoActivityUnLike=_this.handlePhotoActivityUnLike.bind(_this);_this.handleRemoveSavePost=_this.handleRemoveSavePost.bind(_this);_this.handleNotLoginClick=_this.handleNotLoginClick.bind(_this);_this.singlePostModalClass=_this.singlePostModalClass.bind(_this);_this.singlePostLikeModal=_this.singlePostLikeModal.bind(_this);_this.singlePostLikeModalClose=_this.singlePostLikeModalClose.bind(_this);_this.toggleExpand=_this.toggleExpand.bind(_this);_this.deleteCommentId=_this.deleteCommentId.bind(_this);_this.checkDeleteComment=_this.checkDeleteComment.bind(_this);_this.deletePostId=_this.deletePostId.bind(_this);_this.checkDeletePost=_this.checkDeletePost.bind(_this);_this.handleGetLikeUser=_this.handleGetLikeUser.bind(_this);// this.addBodyClass = this.addBodyClass.bind(this);  
return _this;}//  addBodyClass()
//  {
//     setTimeout(() => {
//            if (!$("body").hasClass("modal-open")) {
//              $("body").addClass("modal-open");
//            }
//     },500);
//  }
_createClass(Singlepostoverly,[{key:'singlegetAllUsers',value:function singlegetAllUsers(){var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('_User');query.limit(999999999);query.include("profilePictureSmall");query.include("displayUsername");query.include("name");var self=this;query.find().then(function(result){var userdataresult1=[];if(result){for(var i=0;i<result.length;i++){var user=result[i];var userimage='';if(user.get("profilePictureSmall")&&user.get("profilePictureSmall").url()!==undefined){userimage=user.get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}//userdataresult1.push({'id':user.id,'display':user.get("displayName"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
//self.state.singleget_allusers.push({'id':user.id,'display':user.get("displayName"),'username':user.get("username"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
userdataresult1.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage});self.state.singleget_allusers.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage});}this.state.singleget_allusers=userdataresult1;}else{// console.log("No users found");
}},function(error){});}},{key:'getUserProfileImage',value:function getUserProfileImage(){var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var profile_picture=currentUser.get("profilePictureSmall");if(profile_picture){this.state.currentuserImage=profile_picture.url();}this.state.currentUserId=currentUser.id;}}},{key:'renderComments',value:function renderComments(){var _this2=this;console.log('renderComments');//console.log("renderIngredients");
//return      <span key="66"><h4> ingredType  <a onClick={() => this.handleAdd(0)} >Add</a></h4></span>;
var buffer=[];if(this.state.comments&&this.props.showComments){var _loop=function _loop(){comment=_this2.state.comments[i];var comment_activity_id="comment_"+comment.id;var comment_id="comnt_"+comment.id;_this2.state.singlelikeCount=comment.get("likeCount")?comment.get("likeCount"):0;likesWord="Likes";if(_this2.state.singlelikeCount==1)likesWord="Like";var comment_fromuserid=comment.get("fromUser").id;var comment_currentUserId=_this2.state.currentUserId;// if (ingredType != undefined)
//console.log(comment.get('Photo').id);
buffer.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{key:69*i,className:'cmt_wrap'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'usr_img_detail'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'usr_img'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:_this2.getCommentProfilePic(comment)})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'cmt_usr'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'name'},comment.get("fromUser").get('displayUsername')!=undefined?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'/user/'+comment.get("fromUser").get('displayUsername')},comment.get("fromUser").get('displayUsername')):"",__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',null,time_ago(comment.get("createdAt")))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'/images/dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},comment_fromuserid===comment_currentUserId?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button','data-toggle':'modal','data-target':'#deleteCommentCloseModal',onClick:function onClick(e){return _this2.deleteCommentId(comment_id);},id:'close_deleteCommentwithdiscard','aria-label':'Modal'},'Delete'):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item',type:'button'},'Cancel')))))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'cmt_box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'cmt_cnt',id:comment_id},_this2.formatRenderComment(comment.get("content"),comment_id,comment.id)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_mn '},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'post_action d-flex flex-column flex-wrap align-items-start w-100'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'action_grp'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:void(0);',className:'liked_activity',id:comment_activity_id},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{'data-id':comment.id,id:comment_activity_id,onClick:function onClick(e){_this2.handlePhotoActivityLike(e);},className:'activitydefault',src:'../images/cmt-like.svg'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{'data-id':comment.id,id:comment_activity_id,onClick:function onClick(e){_this2.handlePhotoActivityUnLike(e);},className:'activityactive',style:{display:"none"},src:'../images/like-fill.svg'}),_this2.handleGetActivityLikePost(comment.id))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_count'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'like box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'#'},' ',' ',_this2.state.singlelikeCount,' ',likesWord))))))));};for(var i=0;i<this.state.comments.length;i++){var comment;var likesWord;_loop();}}return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'cmt_wrap_list'},buffer);}},{key:'renderlikeuserlist',value:function renderlikeuserlist(){var userlikeusername=[];var othertext='';if(this.state.likeuserlist){var rows=this.state.likeuserlist.length;var other=0;for(var i=0;i<rows;i++){var likeuser=this.state.likeuserlist[i];if(rows>2){other=rows-1;}if(i==0){if(likeuser.get('fromUser')&&likeuser.get('fromUser').id!==undefined){userlikeusername.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{key:69*i},likeuser.get('fromUser').get("displayUsername")));}}}if(rows>2&&other){if(other==1){othertext=' and '+other+' other ';}else{othertext=' and '+other+' others ';}}return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'user_people'},userlikeusername!=''?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('label',null,'Liked by  ',userlikeusername,' ',othertext?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('label',null,' ',othertext):""):'');}}},{key:'updateInput',value:function updateInput(event){this.setState({singlementioned:event.target.value});this.setState({postcomment:event.target.value});}},{key:'postHeaderText',value:function postHeaderText(){var headerText="";//disable timestamp 5/29/19 //time_ago(this.state.created_at);
if(this.state.city){//var city = this.state.postData.get("city");
headerText+=this.state.city;}/*
        if (this.state.product)
        {
            headerText += " * " + "PRODUCT";
        }
        if (this.state.recipe)
        {
            headerText += " * " + "RECIPE";
        }*/return headerText;}},{key:'queryForComments',value:function queryForComments(){console.log('queryForComments');var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');query.equalTo("photo",this.props.postData);query.equalTo("type","comment");query.include("fromUser");query.include("image");query.include("content");query.include("_created_at");query.include("createdAt");//query.ascending("_created_at");
query.descending("_created_at");var self=this;query.find().then(function(result){if(result){self.setState({comments:result});//promise.resolve(result);
}else{// console.log("No comments found");
// promise.resolve(null);
}},function(error){//console.error("Error loading comments Error: " + error);
//promise.error(error);
});}},{key:'queryForCommentspopup',value:function queryForCommentspopup(photo_ob){//console.log('queryForCommentspopup');
var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');query.equalTo("photo",photo_ob);query.equalTo("type","comment");query.include("fromUser");query.include("image");query.include("content");query.include("_created_at");query.include("createdAt");//query.ascending("_created_at");
query.descending("_created_at");var self=this;query.find().then(function(result){if(result){self.setState({comments_data:result});}else{}},function(error){});}//handleCommentPostUpdate = function(e){
},{key:'cancelText',value:function cancelText(event){var _this3=this;var postcomment=this.state.postcomment;setTimeout(function(){_this3.state.postcomment='';__WEBPACK_IMPORTED_MODULE_7_jquery___default()(".comment_box").val('');},500);}},{key:'toggleExpand',value:function toggleExpand(commentId){this.setState(function(prevState){return{isExpanded:!prevState.isExpanded};});this.setState(function(prevStates){return{expandedCommentId:commentId};});}},{key:'deleteCommentId',value:function deleteCommentId(commentId){var commentIds=commentId.split('comnt_');var commenUpdatedId=commentIds[1];__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#delete_comment_id').val(commenUpdatedId);}},{key:'checkDeleteComment',value:function checkDeleteComment(){var _this4=this;var delete_comment_id=__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#delete_comment_id').val();var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var query_activity=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');query_activity.equalTo('objectId',delete_comment_id);query_activity.equalTo('fromUser',currentUser);query_activity.first().then(function(object){if(object){var photo_obj_id=object.get('photo').id;/*photo*/var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Photo');query.equalTo('objectId',photo_obj_id);query.find().then(function(photo){if(photo){var photo_ob=photo[0];var photoid=photo_ob.id;var commentcount=photo_ob.get('commentcount');if(commentcount==undefined||commentcount===1||commentcount<0){commentcount=0;}else{commentcount=commentcount-1;}photo_ob.set("commentcount",commentcount.toString());photo_ob.save();}});/*photo*/return object.destroy();}}).then(function(deletedObject){setTimeout(function(){var self=_this4;self.handleCommentPostUpdate();},500);}).catch(function(error){console.error('Error deleting record:',error);});}}},{key:'deletePostId',value:function deletePostId(post_id){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#delete_post_id').val(post_id);}},{key:'checkDeletePost',value:function checkDeletePost(page){var delete_post_id=__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#delete_post_id').val();var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Photo');query.equalTo('objectId',delete_post_id);var self=this;query.find().then(function(photo){if(photo){var photo_ob=photo[0];//like
var checklikequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');checklikequery.equalTo('photo',"Photo$"+delete_post_id);checklikequery.find().then(function(object){if(object){//return object.destroy();
var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=object[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var objects=_step.value;objects.destroy();}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});//like
//activity
var checkActivityquery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');checkActivityquery.equalTo('photo',"Photo$"+delete_post_id);checkActivityquery.find().then(function(object){if(object){var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=object[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var objects=_step2.value;objects.destroy();}//return object.destroy();
}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});//activity
//save
var checkSavequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Save');checkSavequery.equalTo('photo',"Photo$"+delete_post_id);checkSavequery.find().then(function(object){if(object){//return object.destroy();  
var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=object[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var objects=_step3.value;objects.destroy();}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});//activity 
if(photo_ob){photo_ob.destroy();}setTimeout(function(){window.location.href="/";},500);/*if(page=='single')
                    {
                    console.log(page);
                      window.location.href = "/";
                    }else
                    {
                      console.log(page);
                      $('#home_fetch').trigger('click');
                    }*/}});}}},{key:'formatComment',value:function formatComment(origComment){if(!origComment)return"";var stringSplit=origComment.split(" ");var result="";for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);if(firstChar=="#"){result+='<a href="/appstore">'+comp+'</a> ';}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){//link
result+='<a href="'+comp+'"">'+comp+'</a>';}else{result+=comp;}result+=" ";}return result;}},{key:'renderComment',value:function renderComment(comment){//console.log("renderIngredients");
//return      <span key="66"><h4> ingredType  <a onClick={() => this.handleAdd(0)} >Add</a></h4></span>;
var buffer=[];var cmt=this.formatComment(comment);buffer.push(cmt);return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,buffer);}},{key:'formatRenderComments',value:function formatRenderComments(origComment){var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,buffer);}var self=this;var stringSplit=origComment.split(" ");var maxLength=320;for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);if(firstChar=="#"){//buffer.push(<a href="/appstore">{comp} </a>);
buffer.push(comp);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){//link
//buffer.push(<a href={comp}>{comp} </a>);
buffer.push('<a href='+comp+'>'+comp+'</a>');}else if(comp.indexOf("@")!==-1||comp.indexOf("@")!==-1){//console.log(followersListing);
//console.log(self.state.singleget_allusers);
/*if(self.state.singleget_allusers.includes(comp))
               {
                console.log(self.state.singleget_allusers);
               }*//*if (self.state.singleget_allusers) {
                for (var i = 0; i < self.state.singleget_allusers.length; i++) {
                  var display = self.state.singleget_allusers[i];
                  let displayid=display.id;
                  console.log(displayid);

                }
              }*//*let linkdatas = singleget_alluserss.display.find(function(ele) {
                   ele.display === comp;
                   console.log(comp+'comp');
                   console.log(ele.display+'ele.display');
              });*//*const index = singleget_allusers.display.findIndex((el) => el === comp)
              arr[index] = 0;
              if(self.state.singleget_allusers.display.includes(comp))
              {
                linkdata= self.state.singleget_allusers.display;
              }*///let linkdatas='';
/*var userdisplayname = comp.replace('@','');
               var query = new Parse.Query('_User');
               query.include("displayUsername");
               query.equalTo("displayUsername", userdisplayname);
               query.first().then(function(result){
                if(result){
                    let userdata=result;
                    let linkdatas='/user/'+userdata.get('displayUsername');
                    self.setState({linkdata:linkdatas}); 
                }
                })*/// let linkdata='<a href ='+this.state.linkdata+'>'+comp+'</a>';
var userdisplayname=comp.replace('@','');var linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';buffer.push(linkdata);}else{buffer.push(comp);}}// Replace the item at the found index
// The new array with the replaced item
var content=buffer.join(' ');// var data=content.length > maxLength ? `${content.substring(0, maxLength).replace(/<[^>]+>/g, "")}...` : content;
var data=content.length>maxLength?content.substring(0,maxLength)+'...':content;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'cmt-txt'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:data}}),content.length>maxLength&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:this.state.postLink},'more'));}},{key:'formatRenderComment',value:function formatRenderComment(origComment,comnt_id,comment_id){var _this5=this;var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,buffer);}var stringSplit=origComment.split(" ");var maxLength=250;for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);var self=this;if(firstChar=="#"){//buffer.push(<a href="/appstore">{comp} </a>);
buffer.push(comp);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){//link
// buffer.push(<a href={comp}>{comp} </a>);
buffer.push(comp);}else if(comp.indexOf("@")!==-1||comp.indexOf("@")!==-1){/*var userdisplayname = comp.replace('@','');
               var query = new Parse.Query('_User');
               query.include("displayUsername");
               query.include("username");
               query.equalTo("displayUsername", userdisplayname);
               query.first().then(function(result){
                if(result){
                    let userdata=result;
                    let linkdatas='/user/'+userdata.get('displayUsername');
                    self.setState({linkdata:linkdatas}); 
                }
                })
                let linkdata='<a href ='+this.state.linkdata+'>'+comp+'</a>';
                  buffer.push(linkdata);  */var userdisplayname=comp.replace('@','');var linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';buffer.push(linkdata);}else{// buffer.push(<span>{comp} </span>);  
//buffer.push(comp+' ');  
buffer.push(comp);}}var content=buffer.join(' ');/* return ( <span className='cmt-txt'>
                {buffer}
                </span>
        );*/var _props=this.props,_props$showMoreText=_props.showMoreText,showMoreText=_props$showMoreText===undefined?'more':_props$showMoreText,_props$showLessText=_props.showLessText,showLessText=_props$showLessText===undefined?'less':_props$showLessText;var isExpanded=this.state.isExpanded;var expandedCommentId=this.state.expandedCommentId;// Determine whether to truncate the text
var shouldTruncate=content.length>maxLength&&!isExpanded;// Truncate the text if necessary  //expandedCommentId===comment_id
var displayText=shouldTruncate?content.slice(0,maxLength)+'...':content;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'cmt-txt',id:comment_id},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:displayText}}),shouldTruncate&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{onClick:function onClick(){return _this5.toggleExpand(comment_id);},style:{color:'#868589',cursor:'pointer',border:'none',background:'none'}},isExpanded?showLessText:showMoreText));}},{key:'formatRenderComment_old',value:function formatRenderComment_old(origComment){var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,buffer);}var self=this;var stringSplit=origComment.split(" ");for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);if(firstChar=="#"){//buffer.push(<a href="/appstore">{comp} </a>);
buffer.push(comp);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){//link
// buffer.push(<a href={comp}>{comp} </a>);
buffer.push(comp);}else if(comp.indexOf("@")!==-1||comp.indexOf("@")!==-1){/*var userdisplayname = comp.replace('@','');
               var query = new Parse.Query('_User');
               query.include("displayUsername");
               query.include("username");
               query.equalTo("displayUsername", userdisplayname);
               query.first().then(function(result){
                if(result){
                    let userdata=result;
                    let linkdatas='/user/'+userdata.get('displayUsername');
                    self.setState({linkdata:linkdatas}); 
                }
                })
                let linkdata='<a href ='+this.state.linkdata+'>'+comp+'</a>';
                  buffer.push(linkdata); */var userdisplayname=comp.replace('@','');var linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';buffer.push(linkdata);}else{// buffer.push(<span>{comp} </span>);  
// buffer.push(comp+' ');  
buffer.push(comp);}}var content=buffer.join(' ');return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'cmt-txt'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:content}}));}},{key:'getUsername',value:function getUsername(user){/*if ((!user) || (user == undefined))
            return "User";


          user.fetch();

          var username = user.get("displayUsername");

          if ((!username) || (username.length < 2)) 
          {
            username = user.get("firstName") + "_" + user.get("lastName");
            username = username.toLowerCase(username);
          }
          if ((!username) || (username.length < 2)) 
          {
            username = "facebook_user";
          }

          return username;*/}},{key:'getCommentProfilePic',value:function getCommentProfilePic(comment){var user=comment.get("fromUser");if(user&&user!=undefined){var pic=user.get("profilePictureSmall");if(pic&&pic!=undefined)return pic.url();}return"/images/default_userpic0.png";}},{key:'renderTitleURL',value:function renderTitleURL(){if(this.state.title||this.state.url){var urlDomain=this.state.url.replace('http://','').replace('https://','').split(/[/?#]/)[0];urlDomain=urlDomain.replace('www.','');if(!(this.state.url&&this.state.url.length>1)){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'titleURLContainer'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'titleText'},this.state.title)));}else{return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:this.state.url,target:'_blank'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'titleURLContainer'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'urlText'},urlDomain),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'titleText'},this.state.title))));}}else{//don't show this section
return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null);}}},{key:'formatRenderComments2main',value:function formatRenderComments2main(origComment){var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,buffer);}var stringSplit=origComment.split(" ");var maxLength=320;for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);if(firstChar=="#"){//buffer.push(<a href="/appstore">{comp} </a>);
buffer.push(comp);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){buffer.push('<a href='+comp+'>'+comp+'</a>');}else if(comp.indexOf("@")!==-1||comp.indexOf("@")!==-1){var userdisplayname=comp.replace('@','');var linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';buffer.push(linkdata);}else{buffer.push(comp);}}var content=buffer.join(' ');return{'a':__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'cmt-txt'},content)};//return <img src={"https:aaaa"} />
}},{key:'formatRenderComments2',value:function formatRenderComments2(origComment){var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,buffer);}var stringSplit=origComment.split(" ");var maxLength=320;for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);if(firstChar=="#"){//buffer.push(<a href="/appstore">{comp} </a>);
buffer.push(comp);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){//link
//buffer.push(<a href={comp}>{comp} </a>);
buffer.push('<a href='+comp+'>'+comp+'</a>');}else{buffer.push(comp);}}var content=buffer.join(' ');//return ({'a':<span className='cmt-txt'>{content}</span>});
//return '';
return{'a':__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'cmt-txt'},content.length>maxLength?content.substring(0,maxLength).replace(/<[^>]+>/g,"")+'...':content,content.length>maxLength&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:this.state.postLink},'more'))};//return <img src={"https:aaaa"} />
}},{key:'queryForSinglepost',value:function queryForSinglepost(){var post_id=__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#popup_post_id').val();var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Photo');query.equalTo('objectId',post_id);query.include("user");query.include("image");query.include("thumbnail");query.include("likeCountNew");query.include("saveCount");query.include("commentcount");query.include("_created_at");query.include("createdAt");query.exists("user");query.descending("createdAt");var self=this;query.find().then(function(result){if(result){console.log(result);self.setState({postData:result});self.setState({likeCount:result[0].get('likeCountNew')});}else{console.log("No post found");}},function(error){});}},{key:'popuprenderComments',value:function popuprenderComments(){var bufferpopup=[];console.log('popuprenderComments');if(this.state.popup_comments){for(var i=0;i<this.state.popup_comments.length;i++){var comment=this.state.popup_comments[i];var comment_activity_id="comment_"+comment.id;var _comment_id="comnt1_"+comment.id;console.log(comment_activity_id+'comment_activity_id');console.log(_comment_id+'comment_id');var comment_fromuserid=comment.get("fromUser").id;// const currentUser = Parse.User.current();
//let comment_currentUserId= currentUser.id;
//console.log(comment_currentUserId);
// let full_text=comment!=undefined?comment.a!=undefined?comment.a.props.children!=undefined?comment.a.props.children:'':'':'';
//console.log('full_text');console.log(full_text);
bufferpopup.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{key:69*i,className:'cmt_wrap1'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'usr_img_detail1'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'usr_img1'},' ddddd'))));}}return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'cmt_wrap_lists'},bufferpopup);}},{key:'renderCaption',value:function renderCaption(){if(this.props.showComments){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'commentsContainer sngl_post_cmt'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'cmt_wrap'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'usr_img'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{className:'userProfileImage',src:this.state.userImage})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'cmt_box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'cmt_usr'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'/user/'+this.state.getUsernamefetch},this.state.getUsernamefetch)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'cmt_cnt_full'},this.formatRenderComment_old(this.state.caption)))));}else{//don't show the user and timestamp on the main stream view
return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'commentsContainer'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'home_pg'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('p',{className:'cmt_box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'cmt_usr'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'/user/'+this.state.getUsernamefetch},this.state.getUsernamefetch)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'cmt_cnt'},this.formatRenderComments(this.state.caption)))));}}},{key:'renderRecipeAndProduct',value:function renderRecipeAndProduct(){if(this.props.showComments){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__recipe_jsx__["a" /* default */],{recipe:this.state.recipe}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__product_jsx__["a" /* default */],{product:this.state.product}));}else{//don't show the user and timestamp on the main stream view
return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null);}}},{key:'renderUserHeaderSharedALinkOrCollab',value:function renderUserHeaderSharedALinkOrCollab(user,url,collabUser){var getLoggedinUsername=localStorage.getItem('username');if(collabUser&&collabUser!=undefined){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'usernameText'},getLoggedinUsername===this.state.getUsernamefetch?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'/my-profile'},this.state.getUsernamefetch):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'/user/'+this.state.getUsernamefetch},this.state.getUsernamefetch),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'sharedA'},'\xA0and\xA0'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'/user/'+collabUser},collabUser));}else if(url){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'usernameText'},getLoggedinUsername===this.state.getUsernamefetch?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'my-profile'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'usernameText'},this.state.getUsernamefetch,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'sharedA'},'\xA0shared a link'))):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'/user/'+this.state.getUsernamefetch},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'usernameText'},this.state.getUsernamefetch,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'sharedA'},'\xA0shared a link'))));}else{//don't show the user and timestamp on the main stream view
return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'usernameText'},getLoggedinUsername===this.state.getUsernamefetch?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'/my-profile'},this.state.getUsernamefetch):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'/user/'+this.state.getUsernamefetch},this.state.getUsernamefetch));}}},{key:'singlePostModalClass',value:function singlePostModalClass(){__WEBPACK_IMPORTED_MODULE_7_jquery___default()("body").addClass("sngl_mdl_open");}},{key:'singlePostModalClose',value:function singlePostModalClose(){__WEBPACK_IMPORTED_MODULE_7_jquery___default()("body").removeClass("sngl_mdl_open");__WEBPACK_IMPORTED_MODULE_7_jquery___default()("body").removeClass("modal-open1");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#popup_post_id').val('');}},{key:'singlePostLikeModal',value:function singlePostLikeModal(){__WEBPACK_IMPORTED_MODULE_7_jquery___default()("body").addClass("sngl_mdlpstlk_open");}},{key:'singlePostLikeModalClose',value:function singlePostLikeModalClose(){__WEBPACK_IMPORTED_MODULE_7_jquery___default()("body").addClass("modal-open1");__WEBPACK_IMPORTED_MODULE_7_jquery___default()("body").removeClass("sngl_mdlpstlk_open");}},{key:'componentDidMount',value:function componentDidMount(){var _this6=this;document.addEventListener('keyup',function(e){if(__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#large_challenge_like_list').hasClass('show')==false){if(e.keyCode===27)_this6.singlePostModalClose();}if(__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#large_challenge_image4').hasClass('show')==true){if(e.keyCode===27)_this6.singlePostLikeModalClose();}});}},{key:'render',value:function render(){var bufferdata=[];//obj.a.props.children?obj.a.props.children:'';
if(this.state.comments_data){for(var i=0;i<this.state.comments_data.length;i++){var comment=this.state.comments_data[i];var comment_activity_id="comment_"+comment.id;var _comment_id2="comnt_"+comment.id;this.state.singlelikeCount=comment.get("likeCount")?comment.get("likeCount"):0;var likesWord="Likes";if(this.state.singlelikeCount==1)likesWord="Like";var comment_fromuserid=comment.get("fromUser").id;var comment_currentUserId=this.state.currentUserId;bufferdata.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{key:69*i,className:'cmt_wrap'},comment.get('content'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'usr_img_detail'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'usr_img'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:this.getCommentProfilePic(comment)}),'}'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'cmt_usr'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'name'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'/user/'+this.getUsername(comment.get("fromUser"))},this.getUsername(comment.get("fromUser"))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',null,time_ago(comment.get("createdAt")))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'/images/dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'}))))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'cmt_box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'cmt_cnt',id:_comment_id2},this.formatRenderComment(comment.get("content"),_comment_id2,comment.id)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_mn '},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'post_action d-flex flex-column flex-wrap align-items-start w-100'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'action_grp'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_count'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'like box'})))))));}}var likesWord="Likes";var savesWord="saves";var commentsWord="Comments";var imprWord="impressions";var page="home";var self=this;if(this.props.showComments){page='single';}var getLoggedinUsername=localStorage.getItem('username');if(this.state.likeCount==1)likesWord="Like";if(this.state.saveCount==1)savesWord="save";if(this.state.commentCount==1)commentsWord="Comment";if(this.state.imprCount==1)imprWord="impression";var post_id_m='save_'+this.state.postID;var follow_id_m='follow_'+this.state.user.id;var currentuserImage=this.state.currentuserImage;var post_like_id_m='like_'+this.state.postID;var currentUserId=this.state.currentUserId;var sameprofile=0;if(currentUserId===this.state.user.id){sameprofile=1;}//console.log(this.state.challengeStatus+'this.state.challengeStatus')
var getchallengeStatus=this.state.challengeStatus;var ischallengeStatus=0;/*if(getchallengeStatus==='Active' || getchallengeStatus==='Billed')
        {
            ischallengeStatus=1;
        }*///getchallengeStatus==='Active' || 
if(getchallengeStatus==='Billed'||getchallengeStatus==='Pending'||getchallengeStatus==='Complete'){ischallengeStatus=1;}if(ischallengeStatus==0){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('section',{className:'post_list non_singlepost_top'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('nav',{className:'sidebar'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Leftsidebar_jsx__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('main',{className:'single_post_page_listing listing myprofile-listing'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'non_single_post_main'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'post_modal_overlay singlePostOverlayModal createPostCloseModal large_challenge_image'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'non_single_post_inner'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'inner_post_row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'img_leftSide'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'../images/default_userpic0.png',alt:'Comment'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'right_side_content_post'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'user_top_row border_bottom'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'user_top_card'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'user_icon'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'../images/default_userpic0.png',alt:'img'}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'user_name'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'#'},'rosslynmarie'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'/images/dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item',type:'button'},'Cancel'))))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('ul',{className:'post_listing_ul'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'post_listing_li'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'detail_bottom user_top_row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'user_top_card'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'user_inline_row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'user_leftbar_img'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'user_icon'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'../images/default_userpic0.png',alt:'img'}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'user_name'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'#'},'rosslynmarie'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'content-span'},' Blueberry Cinnamon Rolls = Best Weekend Breakfast \uD83D\uDE0B '))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'user_sidebar_heart'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'product_content_details'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'product_ul'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h3',{className:'title'},'INGREDIENTS'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('ul',{className:'ul_list'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},'1 cup oat milk (warmed to bath water temp)')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},'1/4 cup melted vegan butter')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},'2 cups flour')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},'1/4 cup sugar')))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'breakfast_tag_add'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('ul',{className:'tag_ul'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},'#breakfast')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},'#vegan')))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'day box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'count'},'6'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'days'},'d'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'like box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;',id:'like_button_challenge',onClick:this.singlePostLikeModal,type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'count'},'6'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'like_count'},'Likes'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'reply_count'},'Reply'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'/images/small_dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item',type:'button'},'Cancel')))))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'view_replies_comment'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{'class':'faq-drawer'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input',{'class':'faq-drawer__trigger',id:'faq-drawer',type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('label',{'class':'faq-drawer__title','for':'faq-drawer'},'View Replies ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'replies_count'},'(3)')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{'class':'faq-drawer__content-wrapper'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{'class':'faq-drawer__content'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('ul',{className:'ul_list_replay_user'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'li_list_replay_user'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_replay_row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_user_img'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'../images/default_userpic0.png',alt:'user'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h4',{className:'content_replay'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'title_userName'},'laurencatino'),' this looks like a great option for a rainy weekend morning')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_user_content'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{className:'default',src:'../images/cmt-like.svg'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{className:'active',src:'../images/like-fill.svg',style:{display:"none"}})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'day box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'count'},'6'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'days'},'d'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'like box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'count'},'6'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'like_count'},'Likes'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'reply_count'},'Reply'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist1',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'/images/small_dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item',type:'button'},'Cancel'))))))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'li_list_replay_user'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_replay_row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_user_img'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'../images/default_userpic0.png',alt:'user'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h4',{className:'content_replay'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'title_userName'},'laurencatino'),' this looks like a great option for a rainy weekend morning')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_user_content'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{className:'default',src:'../images/cmt-like.svg'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{className:'active',src:'../images/like-fill.svg',style:{display:"none"}})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'day box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'count'},'6'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'days'},'d'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'like box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'count'},'6'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'like_count'},'Likes'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'reply_count'},'Reply'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist1',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'/images/small_dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item',type:'button'},'Cancel')))))))))))))))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'post_listing_li'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'detail_bottom user_top_row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'user_top_card'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'user_inline_row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'user_leftbar_img'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'user_icon'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'../images/default_userpic0.png',alt:'img'}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'user_name'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'#'},'JoelsKitchen'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'content-span'},' Lorem ipsum dolor sit amet! '))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'user_sidebar_heart'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{className:'default',src:'../images/cmt-like.svg'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{className:'active',src:'../images/like-fill.svg',style:{display:"none"}})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'product_content_details'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'day box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'count'},'6'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'days'},'d'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'like box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'count'},'6'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'like_count'},'Likes'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'reply_count'},'Reply'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'/images/small_dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item',type:'button'},'Cancel')))))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'view_replies_comment'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{'class':'faq-drawer'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input',{'class':'faq-drawer__trigger',id:'faq-drawer_new',type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('label',{'class':'faq-drawer__title','for':'faq-drawer_new'},'View Replies ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'replies_count'},'(3)')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{'class':'faq-drawer__content-wrapper'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{'class':'faq-drawer__content'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('ul',{className:'ul_list_replay_user'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'li_list_replay_user'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_replay_row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_user_img'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'../images/default_userpic0.png',alt:'user'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h4',{className:'content_replay'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'title_userName'},'laurencatino'),' this looks like a great option for a rainy weekend morning')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_user_content'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{className:'default',src:'../images/cmt-like.svg'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{className:'active',src:'../images/like-fill.svg',style:{display:"none"}})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'day box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'count'},'6'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'days'},'d'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'like box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'count'},'6'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'like_count'},'Likes'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'reply_count'},'Reply'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist1',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'/images/small_dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item',type:'button'},'Cancel'))))))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'li_list_replay_user'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_replay_row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_user_img'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'../images/default_userpic0.png',alt:'user'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h4',{className:'content_replay'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'title_userName'},'laurencatino'),' this looks like a great option for a rainy weekend morning')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_user_content'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{className:'default',src:'../images/cmt-like.svg'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{className:'active',src:'../images/like-fill.svg',style:{display:"none"}})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'day box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'count'},'6'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'days'},'d'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'like box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'count'},'6'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'like_count'},'Likes'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'reply_count'},'Reply'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist1',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'/images/small_dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item',type:'button'},'Cancel'))))))))))))))))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_post_bottom_add'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'create_challenge_row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{className:'create_button'},'Create Challenge')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'comment_like_shere'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{'class':'wrapper d-flex flex-row flex-wrap align-items-center justify-content-between w-100'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{'class':'action_grp'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;','class':'like-icon liked'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{'class':'default',src:'../images/like-bold.svg'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{'class':'active',src:'../images/like-fill.svg',style:{display:"none"}})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;','class':'comment-icon home-comment'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'../images/comment-bold.svg',alt:'Comment'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;','class':'share-icon'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'../images/cmt-share-bold.svg',alt:'Share'}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{'class':'post_save'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;','class':'savepost_link'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{'class':'savedefault',src:'../images/bookmark-bold.png',alt:'No BookMark'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{'class':'saveactive',src:'../images/bookmark-fill.svg',alt:'No BookMark',style:{display:"none"}})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('p',{className:'liked_others'},'Liked by ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},'laurencatino'),' and ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;',id:'like_button_challenge',onClick:this.singlePostLikeModal,type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},'99 others'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'add_in_comment'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'emoji_icon_input_row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'emogi_icon'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'../images/add_reaction.svg',alt:'img'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input',{type:'text',placeholder:'Add a comment...',name:'text'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{className:'post_button_comment'},'Post')))))))))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('hr',{className:'border_hr'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'border_hr'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'more_post_section'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h3',{className:'more_post_title'},'More posts from ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{className:'username',href:'javascript:;'},'rosslynmarie')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'more_post_list'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'grid_post_row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'grid_post'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'/images/slider_one.jpg'})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'grid_post'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'/images/slider_one.jpg'})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'grid_post'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'/images/slider_one.jpg'})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'grid_post'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'/images/slider_one.jpg'})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'grid_post'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'/images/slider_one.jpg'})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'grid_post'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'/images/slider_one.jpg'})))))))))))));}else{return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',null);}}}]);return Singlepostoverly;}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this7=this;this.singlerenderUserSuggestion=function(suggestion,search,highlightedDisplay){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'user-suggestion'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:suggestion.avatar,alt:suggestion.display,className:'user-avatar'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',null,highlightedDisplay));};this.handleUnFollowUser=function(touser_id){var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var checksavequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');checksavequery.equalTo('type','follow');checksavequery.equalTo('toUser',"_User$"+touser_id.id);checksavequery.equalTo('fromUser',"_User$"+currentUser_id);checksavequery.find().then(function(resultAct){if(resultAct){var activityresult=resultAct[0];try{activityresult.destroy();setTimeout(function(){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.unfollowpost_link#follow_'+touser_id.id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.followpost_link#follow_'+touser_id.id).attr("style","display: block");},500);}catch(error){console.error('Error deleting activity:',error);}}});setTimeout(function(){_this7.handleGetFollowUser(touser_id);},1000);}else{//window.alert('You need to login for follow user.');
return false;}};this.handleFollowUser=function(touser_id){var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var Activity=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend("Activity");var activity=new Activity();activity.set('fromUser',currentUser);activity.set('toUser',touser_id);activity.set('type','follow');activity.save().then(function(savedFile){setTimeout(function(){//$('a.followpost_link#follow_'+touser_id.id).attr("style", "display: none");
//$('a.unfollowpost_link#follow_'+touser_id.id).attr("style", "display: block");
__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.followpost_link#follow_'+touser_id.id).attr("style","display: none");_this7.handleGetFollowUser(touser_id);},500);}).catch(function(error){});}else{__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#login_popup_btn').trigger('click');// $('#kitchenQrModal_btn').trigger('click');  
return false;}};this.handleGetFollowUser=function(touser_id){var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultSavedid=0;var checksavequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');checksavequery.equalTo('type','follow');checksavequery.equalTo('toUser',"_User$"+touser_id.id);checksavequery.equalTo('fromUser',"_User$"+currentUser_id);checksavequery.find().then(function(resultSave){if(resultSave){var resultSaved=resultSave[0];resultSavedid=resultSaved.id;__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.followpost_link#follow_'+touser_id.id).attr("style","display: none");/*let resultSaved=resultSave[0];
                      resultSavedid= resultSaved.id;
                      $('a.followpost_link#follow_'+touser_id.id).attr("style", "display: none");
                      $('a.unfollowpost_link#follow_'+touser_id.id).attr("style", "display: block");*/}else{/*$('a.followpost_link#follow_'+touser_id.id).attr("style", "display: block");
                      $('a.unfollowpost_link#follow_'+touser_id.id).attr("style", "display: none");*/}});}};this.handleGetSavePost=function(post_id,page){var posts_id='';if(page==='popup'){posts_id=__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#popup_post_id').val();post_id=posts_id;}var check_value=0;var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultSavedid=0;var checksavequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Save');checksavequery.equalTo('photo',"Photo$"+post_id);checksavequery.equalTo('fromUser',"_User$"+currentUser_id);checksavequery.find().then(function(resultSave){if(resultSave){var resultSaved=resultSave[0];resultSavedid=resultSaved.id;var photo_id=resultSaved.get('photo').id;if(resultSavedid){//$('.active#save_'+post_id).attr("style", "display: block"); 
//$('.default#save_'+post_id).attr("style", "display: none"); 
//$('a.savepost_link#save_'+post_id).attr("style", "display: none");  
__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style","display: block");if(posts_id){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.post_save1 a.savepost_link1 .savedefault1#save_'+posts_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.post_save1 a.savepost_link1 .saveactive1#save_'+posts_id).attr("style","display: block");}}}});}};this.handleRemoveSavePost=function(post_id,page){var posts_id='';if(page==='popup'){posts_id=__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#popup_post_id').val();post_id=posts_id;}var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){//window.alert('You need to login to save post.');
return false;}else{var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Photo');query.equalTo('objectId',post_id);query.find().then(function(photo){if(photo){var photo_ob=photo[0];var photoid=photo_ob.id;var saveCount=photo_ob.get('saveCount');if(saveCount==undefined||saveCount<0){saveCount=0;}else{saveCount=saveCount-1;}photo_ob.set("saveCount",saveCount);photo_ob.save();var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var checklikequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Save');checklikequery.equalTo('photo',photo_ob);checklikequery.equalTo('fromUser',currentUser);checklikequery.first().then(function(object){if(object){return object.destroy();}else{__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.post_save1 a.savepost_link1 .savedefault1#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.post_save1 a.savepost_link1 .saveactive1#save_'+post_id).attr("style","display: none");}}).then(function(deletedObject){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.post_save1 a.savepost_link1 .savedefault1#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.post_save1 a.savepost_link1 .saveactive1#save_'+post_id).attr("style","display: none");}).catch(function(error){console.error('Error deleting record:',error);});}else{//console.log("No post found");
}},function(error){//   console.error("Error loading post Error: " + error);
//promise.error(error);
});setTimeout(function(){var self=_this7;self.handleGetSavePost(post_id,page);},1000);}};this.handleSavePost=function(post_id,page){var posts_id='';if(page==='popup'){posts_id=__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#popup_post_id').val();post_id=posts_id;}var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){//window.alert('You need to login to save post.');
return false;}else{var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Photo');query.equalTo('objectId',post_id);query.find().then(function(photo){//$('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style", "display: none"); 
if(photo){var photo_ob=photo[0];var photoid=photo_ob.id;var saveCount=photo_ob.get('saveCount');if(saveCount==undefined){saveCount=1;}else{saveCount=saveCount+1;}photo_ob.set("saveCount",saveCount);photo_ob.save();var Save=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend("Save");var save=new Save();var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var currentUser_id=currentUser.id;save.set('fromUser',currentUser);save.set('photo',photo_ob);save.set("_wperm",{"*":{"read":true,"write":true}});save.set("_rperm",{"*":{"read":true,"write":true}});save.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);//acl.setWriteAccess(photo_ob.get('user'), true); 
acl.setWriteAccess(currentUser,true);acl.setReadAccess(currentUser,true);save.setACL(acl);save.save().then(function(savedFile){//  window.alert('You Saved post.');
//  window.location.href = "/";
}).catch(function(error){});}else{//console.log("No post found");
}},function(error){//   console.error("Error loading post Error: " + error);
//promise.error(error);
});setTimeout(function(){var self=_this7;self.handleGetSavePost(post_id,page);if(posts_id){self.handleGetSavePost(post_id,'popup');}},1500);}};this.handleGetLikeUser=function(post_id){var like=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');var self=_this7;like.equalTo('photo','Photo$'+post_id);like.find().then(function(result){if(result){self.setState({likeuserlist:result});}});};this.handleGetLikePost=function(post_id){var check_value=0;var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultLikedid=0;var checklikequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');checklikequery.equalTo('photo',"Photo$"+post_id);//checklikequery.equalTo('fromUser',"_User$"+currentUser_id);
checklikequery.equalTo('fromUser',currentUser);//checklikequery.notContainedIn("activity");   
checklikequery.doesNotExist("activity");checklikequery.find().then(function(resultLike){if(resultLike){var resultLiked=resultLike[0];resultLikedid=resultLiked.id;if(resultLikedid!==undefined){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked1 .active1#like_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked1 .default1#like_'+post_id).attr("style","display: none");}if(resultLikedid===undefined){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked1 .active1#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked1 .default1#like_'+post_id).attr("style","display: block");}}});}};this.handlePhotoUnLike=function(post_id,page){var posts_id='';if(page==='popup'){post_id=__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#popup_post_id').val();posts_id=__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#popup_post_id').val();}var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{//$('a.liked .active#like_'+post_id).attr("style", "display: none");
var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Photo');query.equalTo('objectId',post_id);//query.equalTo('user', currentUser);
var self=_this7;query.find().then(function(photo){if(photo){var photo_ob=photo[0];var photoid=photo_ob.id;var likeCount=photo_ob.get('likeCountNew');if(likeCount==undefined||likeCount==1){likeCount=0;}else{likeCount=likeCount-1;}photo_ob.set("likeCountNew",likeCount);photo_ob.save();var checklikequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');checklikequery.equalTo('photo',photo_ob);checklikequery.equalTo('fromUser',currentUser);checklikequery.first().then(function(object){if(object){return object.destroy();__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: block");if(posts_id){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked1 .active1#like_'+posts_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked1 .default1#like_'+posts_id).attr("style","display: block");}}else{__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: block");if(posts_id){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked1 .active1#like_'+posts_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked1 .default1#like_'+posts_id).attr("style","display: block");}}}).then(function(deletedObject){self.setState({likeCount:likeCount});//self.setState({likeCount1:likeCount}); 
//$('#home_fetch').trigger('click');
__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: block");if(posts_id){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked1 .active1#like_'+posts_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked1 .default1#like_'+posts_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#popup_post_id').val(posts_id);var likesWord="Likes";if(likeCountNew==1)likesWord="Like";__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#like_counts_'+posts_id).html(likeCount);if(likeCount==1){likesWord="Like";__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#like_words_'+posts_id).html(likesWord);}}var likeCountNew=likeCount;__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#like_count_new').html(likeCountNew+' '+likesWord);}).catch(function(error){console.error('Error deleting record:',error);});__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#home_fetch').trigger('click');}});setTimeout(function(){var self=_this7;self.handleGetLikeUser(posts_id);},1000);}}};this.handleGetActivityLikePost=function(comment_id){var check_value=0;var post_id=_this7.state.postID;var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultLikedid=0;var checklikequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');checklikequery.include("activity");checklikequery.equalTo('photo',"Photo$"+post_id);checklikequery.equalTo('activity',"Activity$"+comment_id);checklikequery.equalTo('fromUser',currentUser);checklikequery.find().then(function(resultLike){if(resultLike){var resultLiked=resultLike[0];resultLikedid=resultLiked.id;if(resultLikedid!==undefined){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.comment_list_mn  a.liked_activity .activitydefault#comment_'+comment_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.comment_list_mn a.liked_activity .activityactive#comment_'+comment_id).attr("style","display: block");}if(resultLikedid===undefined){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.comment_list_mn a.liked_activity .activitydefault#comment_'+comment_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.comment_list_mn a.liked_activity .activityactive#comment_'+comment_id).attr("style","display: none");}}});}};this.handlePhotoActivityUnLike=function(e){var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{var post_id=e.target.id;var datapost_id=e.target.dataset.id;__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.comment_list_mn a.liked_activity .activityactive#comment_'+datapost_id).attr("style","display: none");var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');query.equalTo('objectId',datapost_id);var self=_this7;query.find().then(function(activity){if(activity){var activity_ob=activity[0];var likeCount=void 0;if(activity_ob){likeCount=activity_ob.get('likeCount');}else{likeCount=0;}if(likeCount==undefined||likeCount<0){likeCount=0;}else{likeCount=likeCount-1;}var photo_ob=activity_ob.get('photo');activity_ob.set("likeCount",likeCount);activity_ob.save();//like 
var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var currentUser_id=currentUser.id;var checklikequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Like');checklikequery.equalTo('photo',photo_ob);checklikequery.equalTo('fromUser',currentUser);checklikequery.equalTo('activity',activity_ob);checklikequery.first().then(function(object){if(object){return object.destroy();}else{__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.comment_list_mn a.liked_activity .activitydefault#comment_'+datapost_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.comment_list_mn a.liked_activity .activityactive#comment_'+datapost_id).attr("style","display: none");}}).then(function(deletedObject){//self.setState({likeCount:likeCount});  
//$('#home_fetch').trigger('click');
self.setState({singlelikeCount:likeCount});__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.comment_list_mn a.liked_activity .activityactive#comment_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.comment_list_mn a.liked_activity .activitydefault#comment_'+datapost_id).attr("style","display: block");}).catch(function(error){console.error('Error deleting record:',error);});//like  
}});setTimeout(function(){var self=_this7;self.handleGetActivityLikePost(datapost_id);},1000);}};this.handlePhotoActivityLike=function(e){var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{var post_id=e.target.id;var datapost_id=e.target.dataset.id;__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.comment_list_mn a.liked_activity .activitydefault#comment_'+datapost_id).attr("style","display: none");var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');query.equalTo('objectId',datapost_id);var self=_this7;query.find().then(function(activity){if(activity){var activity_ob=activity[0];var likeCount=void 0;if(activity_ob){likeCount=activity_ob.get('likeCount');}else{likeCount=0;}if(likeCount==undefined){likeCount=1;}else{likeCount=likeCount+1;}var photo_ob=activity_ob.get('photo');activity_ob.set("likeCount",likeCount);activity_ob.save();//like 
var Like=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend("Like");var like=new Like();var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var currentUser_id=currentUser.id;like.set('fromUser',currentUser);like.set('photo',photo_ob);like.set('activity',activity_ob);like.set("_wperm",{"*":{"read":true,"write":true}});like.set("_rperm",{"*":{"read":true,"write":true}});like.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);acl.setWriteAccess(currentUser,true);acl.setReadAccess(currentUser,true);like.setACL(acl);var fromUserThumb=currentUser.get('profilePictureSmall');if(fromUserThumb!=undefined){like.set('fromUserThumb',fromUserThumb);}like.save().then(function(likeActivitySaved){self.setState({singlelikeCount:likeCount});}).catch(function(error){});//like  
}});setTimeout(function(){var self=_this7;self.handleGetActivityLikePost(datapost_id);},1000);}};this.handlePhotoLike=function(post_id,page){var posts_id='';if(page==='popup'){post_id=__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#popup_post_id').val();posts_id=__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#popup_post_id').val();}var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{//$('a.liked .default#like_'+post_id).attr("style", "display: none");
var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Photo');query.equalTo('objectId',post_id);var self=_this7;query.find().then(function(photo){if(photo){var photo_ob=photo[0];var photoid=photo_ob.id;var likeCount=photo_ob.get('likeCountNew');if(likeCount==undefined){likeCount=1;}else{likeCount=likeCount+1;}photo_ob.set("likeCountNew",likeCount);photo_ob.save();var Like=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend("Like");var like=new Like();var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var currentUser_id=currentUser.id;like.set('fromUser',currentUser);like.set('photo',photo_ob);like.set("_wperm",{"*":{"read":true,"write":true}});like.set("_rperm",{"*":{"read":true,"write":true}});like.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);acl.setWriteAccess(currentUser,true);acl.setReadAccess(currentUser,true);like.setACL(acl);var fromUserThumb=currentUser.get('profilePictureSmall');if(fromUserThumb!=undefined){like.set('fromUserThumb',fromUserThumb);}//this.state.likeCount=likeCount;                
like.save().then(function(likeSaved){self.setState({likeCount:likeCount});// self.setState({likeCount1:likeCount}); 
//window.alert('You Like post.');
/*if(page=='single')
                                   {
                                      window.location.href = "/posts/"+post_id;
                                   }else
                                   {
                                      window.location.href = "/";
                                   }*/__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: block");if(posts_id){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked1 .default1#like_'+posts_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked1 .active1#like_'+posts_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#popup_post_id').val(posts_id);__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#like_counts_'+posts_id).html(likeCount);var likesWord="Likes";if(likeCountNew==1)likesWord="Like";if(likeCount==1){likesWord="Like";__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#like_words_'+posts_id).html(likesWord);}}var likeCountNew=likeCount;__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#like_count_new').html(likeCountNew+' '+likesWord);__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#home_fetch').trigger('click');// this.handleGetLikePost(post_id);
}).catch(function(error){});}else{}},function(error){});setTimeout(function(){var self=_this7;self.handleGetLikePost(post_id);self.handleGetLikeUser(post_id);if(posts_id){//self.handleGetLikePost(posts_id);
//self.queryForSinglepost(); 
}},1500);}};this.handleCommentPostUpdate=function(){var photo_post_id=_this7.state.postID;var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');query.equalTo("photo",'Photo$'+photo_post_id);query.equalTo("type","comment");query.include("fromUser");query.include("image");query.include("content");query.include("_created_at");query.include("createdAt");// query.ascending("_created_at");
query.descending("_created_at");var self=_this7;query.find().then(function(result){if(result){self.setState({comments:result});self.setState({commentCount:result.length});}else{}},function(error){});};this.handleCommentPost=function(e){var _this8=this;var Photo=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend("Photo");var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query(Photo);var photo_post_id=this.state.postID;var postcomment=this.state.postcomment;if(postcomment){query.include("user");query.include("image");query.include("thumbnail");query.include("likeCountNew");query.include("saveCount");query.include("commentcount");query.include("_created_at");query.include("createdAt");query.exists("user");query.descending("createdAt");query.find({success:function success(results){if(results.length>0){results.forEach(function(photo){if(photo.id===photo_post_id){var Activity=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend("Activity");var activity=new Activity();var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();activity.set('fromUser',currentUser);activity.set('toUser',photo.get("user"));activity.set('content',postcomment);activity.set('type','comment');activity.set('photo',photo);activity.set('likeCount',0);var currentUser_id=currentUser.id;//this.state.commentCount ="5";
// $('#handleCommentPostupdate').trigger('click');
activity.set("_wperm",{"*":{"write":true// Allow write access to all users
}});// Set the read permission (_rperm) for the Activity object
activity.set("_rperm",{"*":{"read":true// Allow read access to all users
}});// Set the ACL (_acl) for the Activity object
activity.set("_acl",{"*":{"read":true,// Allow read access to all users
"write":true// Allow write access to all users
}});var acl=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);acl.setWriteAccess(photo.get('user'),true);acl.setWriteAccess(currentUser_id,true);acl.setReadAccess(currentUser_id,true);activity.setACL(acl);var self=this;try{activity.save().then(function(savedActivity){var activityId=savedActivity.id;setTimeout(function(){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked_activity .activityactive#comment_'+activityId).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_7_jquery___default()('a.liked_activity .activitydefault#comment_'+activityId).attr("style","display: block");},1000);}).catch(function(error){//console.error('Error saving activity:', error);
});__WEBPACK_IMPORTED_MODULE_7_jquery___default()(".comment_box").val('');__WEBPACK_IMPORTED_MODULE_7_jquery___default()("#comment_box").val('');var updated_photo_id=photo.get('id');var Photo_single=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend("Photo");var Photoquery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query(Photo_single);var photoId=photo.id;Photoquery.get(photoId).then(function(photo){var commentcount_val=parseInt(photo.get('commentcount'));if(isNaN(commentcount_val)){commentcount_val=0;}var updated_comment_count=commentcount_val+1;photo.set("commentcount",updated_comment_count.toString());photo.save();}).catch(function(error){//  console.error("Error retrieving photo:", error);
});}catch(error){//console.log(error.message);
}}});}else{//console.log("No photos found.");
}},error:function error(_error){// console.error("Error fetching photos: " + error.code + " " + error.message);
}});setTimeout(function(){var self=_this8;self.handleCommentPostUpdate();_this8.state.postcomment='';_this8.state.singlementioned='';},1000);}//photo.id = "photo_object_id";
// console.log(photo.id);
var self=this;var post_id=this.state.postID;if(postcomment!=''){}else{self.setState({blank_comment_message:"Your message box is empty. Please write a message to continue."});// window.alert('Please write some comment first!');
}setTimeout(function(){self.setState({blank_comment_message:null});},3000);};this.handlePostModelOpen1=function(post_id){_this7.setState({post_id:post_id});};this.handlePostModelOpen=function(post_id){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#popup_post_id').val(post_id);__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.like-icon.liked1').attr('id','like_'+post_id);__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.like-icon.liked1 img.default1').attr('id','like_'+post_id);__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.like-icon.liked1 img.active1').attr('id','like_'+post_id);__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.post_save1 .savepost_link1 .savedefault1').attr('id','save_'+post_id);__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.post_save1 .savepost_link1 .saveactive1').attr('id','save_'+post_id);__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.post_save1 .savepost_link1').attr('id','save_'+post_id);//$('.like-icon.liked1 img.active1').attr('id','like_'+post_id);
__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#full_text').html('');__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#lef_img').attr('src','../images/default_userpic0.png');__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.popup_user_image').attr('src','../images/default_userpic0.png');__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.popup_display_userimage').attr('src','../images/default_userpic0.png');__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.user_name a.popup_user_name').html('');//$(' a.popup_display_username').html('');
var getLoggedinUsername=localStorage.getItem('username');/*if(!getLoggedinUsername)
        {
            $('#kitchenQrModal_btn').trigger('click');    
            return false;
        }else
        {*/var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Photo');query.include("likeCountNew");query.include("commentcount");query.equalTo('objectId',post_id);var self=_this7;query.find().then(function(photo){if(photo){//self.setState({popup_username:null});
var photo_data=photo[0].get('caption');var photo_ob=photo[0];var _likeCountNew=photo[0].get('likeCountNew')?photo[0].get('likeCountNew'):0;var likesWord="Likes";if(_likeCountNew==1)likesWord="Like";__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#like_count_new').html(_likeCountNew+' '+likesWord);//setTimeout(() => {
self.setState({likeCount:_likeCountNew});// },500);
__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.user_name a.popup_user_name').html(photo_ob.get('user').get('displayUsername'));__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.user_name a.popup_user_name').attr("href","/user/"+photo_ob.get('user').get('displayUsername'));__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.popup_display_username').html(photo_ob.get('user').get('displayUsername'));__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.popup_display_username').attr("href","/user/"+photo_ob.get('user').get('displayUsername'));var user_image=photo_ob.get('user').get('profilePictureSmall').url()?photo_ob.get('user').get('profilePictureSmall').url():'';__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.popup_user_image').attr('src',user_image);__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.popup_display_userimage').attr('src',user_image);var photo_img=photo_ob.get('image').url()?photo_ob.get('image').url():'';__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#lef_img').attr('src',photo_img);var popup_display_username=photo_ob.get('user').get('displayUsername');var captiondata='';if(photo_ob.get('caption')!=''){captiondata=photo_ob.get('caption');}if(captiondata===''){captiondata=photo_data;}//console.log(photo_ob.get('caption')+'photo_');
//console.log(photo_data+'captiondata');
var obj=captiondata!=''?self.formatRenderComments2main(captiondata):self.formatRenderComments2main(photo_data);//console.log(photo_data+'photo_data');
//console.log(obj+'obj');
var full_text=obj.a.props.children?obj.a.props.children:'';__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#full_text').html(full_text);__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.time_interval_new').html(time_ago(photo_ob.get('createdAt')));self.queryForCommentspopup(photo_ob);self.handleGetLikeUser(photo_ob.id);this.renderlikeuserlist();// console.log(photo_ob.get('likeCountNew')+'likeCountNew');
// console.log(photo_ob.get('commentcount')+'commentcount');
//this.setState({likeCount1:likeCountNew}); 
//this.state.likeCount1=likeCountNew;
// $('#comment_count_new').html(commentcount+' Comments')
//this.state.popup_username=photo_ob.get('user').get('displayUsername');
// this.setState({popup_username:photo_ob.get('user').get('displayUsername')}); 
/* $('#large_challenge_image2').addClass('show');
                      $('#large_challenge_image2').attr('style','display:block');
                        
                         let photo_img = photo_ob['attributes']['image']._url;
                         $('#lef_img').attr('src',photo_img);
                         let obj = self.formatRenderComments2(photo_ob['attributes'].caption);
                         //console.log(obj.a.props.children[0]);
                         
                         $('#full_text').html(obj.a.props.children);
                         $('.display_username').html(photo_ob['attributes']['user']['attributes'].displayUsername);
                         let likeCountNew=photo_ob['attributes'].likeCountNew;
                         let commentcount=photo_ob['attributes'].commentcount;
                         if(likeCountNew===undefined)
                         {
                          likeCountNew=0;
                         }
                         if(commentcount===undefined)
                         {
                          commentcount=0;
                         }
                         $('#like_count').html(likeCountNew+' Likes')
                         $('#comment_count').html(commentcount+' Comments');*/// this.popuprenderComments();
var query1=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');query1.equalTo("photo",photo[0]);query1.equalTo("type","comment");query1.include("fromUser");query1.include("image");query1.include("content");query1.include("_created_at");query1.include("createdAt");query1.descending("_created_at");var buffer=[];var vals='';query1.find().then(function(result1){if(result1){//console.log('result...................');
//console.log(result1);
self.setState({popup_comments:result1});for(var i=0;i<result1.length;i++){var comment=result1[i];var comment_activity_id="comment_"+comment.id;var _comment_id3="comnt_"+comment.id;var comment_fromuserid=comment.get("fromUser").id;//const currentUser = Parse.User.current();
//let comment_currentUserId= currentUser.id;
buffer.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{key:69*i,className:'cmt_wrap'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'usr_img_detail'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'usr_img'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'cmt_usr'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'name'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:'/images/dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item',type:'button'},'Cancel'))))))));}__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#comment_show').html(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'cmt_wrap_list'},buffer));}},function(error){console.error("Error loading comments Error: "+error);//promise.error(error);
});}});//}
};this.handleNotLoginClick=function(){var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}};};/* harmony default export */ __webpack_exports__["a"] = (Singlepostoverly);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ingredTypeCount=8;var Recipe=function(_React$Component){_inherits(Recipe,_React$Component);function Recipe(props){_classCallCheck(this,Recipe);var _this=_possibleConstructorReturn(this,(Recipe.__proto__||Object.getPrototypeOf(Recipe)).call(this,props));_this.state={recipes:{},curRecipe:null,ingredTypes:["🥦 VEGGIES","🍓 FRUITS","🌱 BEANS","🍚 GRAINS","🥜 SEEDS & NUTS","🌶 SPICES","🥫 PRODUCTS","✔️ INSTRUCTIONS"],ingredFields:["veggiesData","fruitsData","beansData","grainsData","seedsData","spicesData","productsData","instructionsData"],ingredImages:["veggies.png","fruits.png","beans.png","grains.png","seeds.png","spices.png","products.png","instructions.png"],curRecipeName:"Default",ingredArr:[]};// Creates all lines:
for(var i=0;i<ingredTypeCount;i++){// Creates an empty line
_this.state.ingredArr.push([]);//this.state.ingredArr[i].push( []);
// Adds cols to the empty line:
//   this.state.ingredArr[i].push( new Array());
/*
          for(var j=0; j < cols; j++){
            // Initializes:
            arr[i][j] = defaultValue;
          }*/}//this.state.curRecipe = this.props.recipe;
console.log("this.props.recipe "+_this.props.recipe);//do this to load the items
_this.selectRecipe(_this.props.recipe);_this.getRecipes=_this.getRecipes.bind(_this);_this.getCurRecipe=_this.getCurRecipe.bind(_this);return _this;}_createClass(Recipe,[{key:'selectRecipe',value:function selectRecipe(recipe){//this.setState({curRecipe:recipe});
if(recipe)console.log('Select recipe '+recipe.get("name"));if(this.state.curRecipe!=recipe){this.state.curRecipe=recipe;this.state.curRecipeName=recipe.get("name");console.log("CurRecipe "+JSON.stringify(recipe));//load the itemArr
var newIngredArr=[];for(var i=0;i<ingredTypeCount;i++){var curIngredType=this.state.ingredTypes[i].toLowerCase();var fieldName=this.state.ingredFields[i];///curIngredType + "Data";
var serData=recipe.get(fieldName);if(serData){console.log("Parsing serial data "+fieldName+" "+serData);var serObj=JSON.parse(serData);newIngredArr.push(serObj);}else newIngredArr.push([]);}this.state.ingredArr=newIngredArr;}//this.state.curRecipe = recipe;
}},{key:'getCurRecipe',value:function getCurRecipe(){return this.curRecipe;}},{key:'getRecipes',value:function getRecipes(event){event.preventDefault();this.getRecipesAux();}},{key:'renderIngredientType',value:function renderIngredientType(ingredType,i){var buffer=[];//console.log("renderIngredientType " + i + " ingredArr len " + this.state.ingredArr[i].length)
for(var k=0;k<this.state.ingredArr[i].length;k++){var ingred=this.state.ingredArr[i][k];// console.log("ingredArr " + i + " " + ingred.name);
/* ======================== INGREDIENT COMPONENTS =========================== */if(i!=7){buffer.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipeIngred'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,this.state.ingredArr[i][k].amount),'\xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/appstore/'},this.state.ingredArr[i][k].name),'\xA0'),'\xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,this.state.ingredArr[i][k].description)));}else{//instructions
var stepText="Step ";//**/
buffer.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipeIngred',key:500+(i+1)*(k+1)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,k+1,'.\xA0\xA0'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,this.state.ingredArr[i][k].description)));}}//console.log("ingredArr length " + this.state.ingredArr[i].length);
if(this.state.ingredArr[i].length==0&&i!=7){buffer.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipePostamble'},'None this meal.'));}else//if (i != 7)
{/* *
            buffer.unshift( <table><tbody>
                            <tr class = "ingredRow" key={499+(i+1)}>
                           <td class = "ingredAmountHeader">

                                Amount

                           </td>
                           <td class = "ingredNameHeader">

                               Name

                           </td>
                           <td class = "ingredDescripHeader">

                               Description

                           </td>
                           <td class = "ingredDeleteHeader">
                            ..

                           </td>
                        </tr>
                    </tbody></table>
                        );*/}var ingredImage="images/"+this.state.ingredImages[i];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,ingredType),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),buffer);}},{key:'renderIngredients',value:function renderIngredients(){//console.log("renderIngredients");
//return      <span key="66"><h4> ingredType  <a onClick={() => this.handleAdd(0)} >Add</a></h4></span>;
var buffer=[];for(var i=0;i<this.state.ingredTypes.length;i++){var ingredType=this.state.ingredTypes[i];if(ingredType!=undefined)buffer.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipeSectionHeader',key:69*i},this.renderIngredientType(ingredType,i)));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'11'},buffer);/*
        console.log("map" + ingredType + i);
            return (
               <div>
               <span key={i+100}><h4> {ingredType}  <a onClick={() => this.handleAdd(i)} >Add</a></h4></span>
               </div>
            );

            
        });*/}},{key:'renderRecipeV2',value:function renderRecipeV2(){//console.log("renderIngredients");
//return      <span key="66"><h4> ingredType  <a onClick={() => this.handleAdd(0)} >Add</a></h4></span>;
var buffer=[];var formatIngred=this.formatComment(this.state.curRecipe.get("ingredients"));var formatInstruc=this.formatComment(this.state.curRecipe.get("instructions"));var formatNotes=this.formatComment(this.state.curRecipe.get("notes"));console.log("Recipe: "+JSON.stringify(this.state.curRecipe));buffer.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipeSectionHeader',key:69*1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipeHeaderLabel'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'Ingredients')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipeIngred'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:formatIngred}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipeSectionHeader',key:69*1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipeHeaderLabel'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'Instructions')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipeIngred'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:formatInstruc}})))));return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'11'},buffer);/*
        console.log("map" + ingredType + i);
            return (
               <div>
               <span key={i+100}><h4> {ingredType}  <a onClick={() => this.handleAdd(i)} >Add</a></h4></span>
               </div>
            );

            
        });*/}},{key:'formatComment',value:function formatComment(origComment){if(!origComment)return"";var stringSplit=origComment.split(" ");var result="";for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);if(firstChar=="#"){result+='<a href="/appstore">'+comp+'</a>';}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){//link
result+='<a href="'+comp+'"">'+comp+'</a>';}else{result+=comp;}result+=" ";}//replace newlines with breaks
result=result.split("\n").join("<br>");return result;}},{key:'renderPostamble',value:function renderPostamble(){var buffer=[];var result;if(!this.state.curRecipe){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null);}var formatWS=this.formatComment(this.state.curRecipe.get("website"));var formatHash=this.formatComment(this.state.curRecipe.get("hashtags"));result=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipePostamble',key:'-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:formatWS}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:formatHash}}));return result;}},{key:'render',value:function render(){//console.log("Rendering recipe list");
var result=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null);{var self=this;if(this.state.curRecipe!=null){result=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipeDiv',key:'-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'\xA0',this.state.curRecipe.get("name")),this.renderRecipeV2(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null));}}return result;/* 
                    <label className="checkbox">
                        <input type="checkbox" value="remember-me" onChange={this.handleRememberMeClick}/>
                        &nbsp; Remember me
                    </label>
                    */}}]);return Recipe;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Recipe);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ingredTypeCount=3;var Product=function(_React$Component){_inherits(Product,_React$Component);function Product(props){_classCallCheck(this,Product);var _this=_possibleConstructorReturn(this,(Product.__proto__||Object.getPrototypeOf(Product)).call(this,props));_this.state={curProduct:null,ingredTypes:["🥦 Whole Plants","🥫 Processed","🔬 Additives"],ingredFields:["plantsData","processedData","additivesData"],ingredEmojis:["🥦","🥫","🔬"],ingredImages:["plants.png","processed.png","additives.png","grains.png","seeds.png","spices.png","products.png","instructions.png"],curProductName:"Default",ingredArr:[]};// Creates all lines:
for(var i=0;i<ingredTypeCount;i++){// Creates an empty line
_this.state.ingredArr.push([]);}//this.state.curRecipe = this.props.recipe;
console.log("this.props.product "+_this.props.product);//do this to load the items
_this.selectProduct(_this.props.product);return _this;}_createClass(Product,[{key:'selectProduct',value:function selectProduct(product){//this.setState({curProduct:product});
if(product)console.log('Select product '+product.get("name"));else return;if(this.state.curProduct!=product){this.state.curProduct=product;global.curProduct=product;this.state.curProductName=product.get("name");console.log("CurProduct "+JSON.stringify(product));//load the itemArr
var newIngredArr=[];for(var i=0;i<ingredTypeCount;i++){var curIngredType=this.state.ingredTypes[i].toLowerCase();var fieldName=this.state.ingredFields[i];///curIngredType + "Data";
var serData=product.get(fieldName);if(serData){console.log("Parsing serial data "+fieldName+" "+serData);var serObj=JSON.parse(serData);newIngredArr.push(serObj);}else newIngredArr.push([]);}this.state.ingredArr=newIngredArr;this.forceUpdate();}//this.state.curProduct = product;
}},{key:'getProducts',value:function getProducts(event){event.preventDefault();this.getProductsAux();}},{key:'renderIngredientType',value:function renderIngredientType(ingredType,i){var buffer=[];//console.log("renderIngredientType " + i + " ingredArr len " + this.state.ingredArr[i].length)
for(var k=0;k<this.state.ingredArr[i].length;k++){var ingred=this.state.ingredArr[i][k];// console.log("ingredArr " + i + " " + ingred.name);
/* ======================== INGREDIENT COMPONENTS =========================== */{//instructions
var stepText="Ingredient";//**/
buffer.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipeIngred'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/appstore/'},this.state.ingredArr[i][k].name),','),'\xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,this.state.ingredArr[i][k].description)));}}//console.log("ingredArr length " + this.state.ingredArr[i].length);
if(this.state.ingredArr[i].length==0&&i!=3){if(i==0){buffer.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipePostamble'},'No whole plants were added to this product.'));}else if(i==1){buffer.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipePostamble'},'No processed foods were added to this product.'));}else if(i==2){buffer.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipePostamble'},'No additives were added to this product.'));}}else if(i!=3){}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,ingredType),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),buffer);}},{key:'renderIngredients',value:function renderIngredients(){//console.log("renderIngredients");
//return      <span key="66"><h4> ingredType  <a onClick={() => this.handleAdd(0)} >Add</a></h4></span>;
var buffer=[];for(var i=0;i<this.state.ingredTypes.length;i++){var ingredType=this.state.ingredTypes[i];if(ingredType!=undefined)buffer.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipeSectionHeader',key:69*i},this.renderIngredientType(ingredType,i)));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'11'},buffer);/*
        console.log("map" + ingredType + i);
            return (
               <div>
               <span key={i+100}><h4> {ingredType}  <a onClick={() => this.handleAdd(i)} >Add</a></h4></span>
               </div>
            );

            
        });*/}},{key:'renderProductV2',value:function renderProductV2(){//console.log("renderIngredients");
//return      <span key="66"><h4> ingredType  <a onClick={() => this.handleAdd(0)} >Add</a></h4></span>;
var buffer=[];var formatIngred=this.formatComment(this.state.curProduct.get("ingredients"));var formatWebsite=this.formatComment(this.state.curProduct.get("website"));var formatNotes=this.formatComment(this.state.curProduct.get("notes"));console.log("curProduct: "+JSON.stringify(this.state.curProduct));buffer.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipeSectionHeader',key:69*1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'Ingredients'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipeIngred'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:formatIngred}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipeSectionHeader',key:69*1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'Notes'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipeIngred'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:formatNotes}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipeSectionHeader',key:69*1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'Website'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipeIngred'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:formatWebsite}})))));return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'11'},buffer);/*
        console.log("map" + ingredType + i);
            return (
               <div>
               <span key={i+100}><h4> {ingredType}  <a onClick={() => this.handleAdd(i)} >Add</a></h4></span>
               </div>
            );

            
        });*/}},{key:'formatComment',value:function formatComment(origComment){if(!origComment)return"";var stringSplit=origComment.split(" ");var result="";for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);if(firstChar=="#"){result+='<a href="/appstore">'+comp+'</a>';}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){//link
result+='<a href="'+comp+'"">'+comp+'</a>';}else{result+=comp;}result+=" ";}//replace newlines with breaks
result=result.split("\n").join("<br>");return result;}},{key:'renderPostamble',value:function renderPostamble(){var buffer=[];var result;if(!this.state.curProduct){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null);}var formatWS=this.formatComment(this.state.curProduct.get("website"));var formatHash=this.formatComment(this.state.curProduct.get("hashtags"));result=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipePostamble',key:'-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:formatWS}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:formatHash}}));return result;}},{key:'render',value:function render(){// console.log("Rendering recipe list");
var result=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null);{var self=this;if(this.state.curProduct!=null){result=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipeDiv',key:'-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'\xA0',this.state.curProduct.get("name")),this.renderProductV2(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null));}}return result;/* 
                    <label className="checkbox">
                        <input type="checkbox" value="remember-me" onChange={this.handleRememberMeClick}/>
                        &nbsp; Remember me
                    </label>
                    */}}]);return Product;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Product);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(37)))

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__global_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__singlepost_jsx__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Leftsidebar_jsx__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CommonPopup_jsx__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__saveNotification_jsx__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserProfile=function(_React$Component){_inherits(UserProfile,_React$Component);function UserProfile(props){_classCallCheck(this,UserProfile);var _this=_possibleConstructorReturn(this,(UserProfile.__proto__||Object.getPrototypeOf(UserProfile)).call(this,props));_this.toggleNotification=function(postid,msg,comment){//console.log('toggleNotification'+postid);
var self=_this;self.setState(function(prevState){return{isNotificationOpen:!prevState.isNotificationOpen,post_Notification_Id:postid,post_Notification_Msg:msg,post_Notification_Comment:comment};});//self.setState({ post_Notification_Id: postid });        
};_this.handleSearch=function(event){var searchTerm=event.target.value;var followersListings=_this.state.followersListing;var searchfollowersListing=_this.state.searchfollowersListing;var followersListing=searchfollowersListing.filter(function(item){return item.get('fromUser').get('displayName').toLowerCase().includes(searchTerm.toLowerCase());}//item.get('fromUser').get('displayUsername').toLowerCase().includes(searchTerm.toLowerCase())
);_this.setState({searchTerm:searchTerm});_this.setState({followersListing:followersListing});_this.setState({followersCountPopup:followersListing.length});//followingImages1
var followingListings=_this.state.followingImages1;var searchfollowingListing=_this.state.searchfollowingListing;var followingListing=searchfollowingListing.filter(function(item){return item.displayName.toLowerCase().includes(searchTerm.toLowerCase());}// item.displayUsername.toLowerCase().includes(searchTerm.toLowerCase())
);_this.setState({followingImages1:followingListing});_this.setState({followingCountPopup:followingListing.length});//searchfollowingListing
if(searchTerm===''){_this.queryGetFollowersFollowing();}};_this.checktabActive=function(e){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.modal-backdrop').remove();var activetab=e.target.dataset.id;if(activetab==='#usrFlwrsTabs'){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#follwerModal li.nav-item a.nav-link#usrFlwrsTabs').addClass('active show');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#follwerModal li.nav-item a.nav-link#usrFlwingTabs').removeClass('active show');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#follwerModal #usrfollwerPanel #usrFlwrsPane').addClass('active show');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#follwerModal #usrfollwerPanel #usrFlwingPane').removeClass('active show');}if(activetab==='#usrFlwingTabs'){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#follwerModal li.nav-item a.nav-link#usrFlwingTabs').addClass('active show');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#follwerModal li.nav-item a.nav-link#usrFlwrsTabs').removeClass('active show');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#follwerModal #usrfollwerPanel #usrFlwrsPane').removeClass('active show');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#follwerModal #usrfollwerPanel #usrFlwingPane').addClass('active show');}};_this.handleUnFollowUser=function(touser_id){console.log('handleUnFollowUser');var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var checksavequery=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Activity');checksavequery.equalTo('type','follow');checksavequery.equalTo('toUser',"_User$"+touser_id.id);checksavequery.equalTo('fromUser',"_User$"+currentUser_id);checksavequery.find().then(function(resultAct){if(resultAct){var activityresult=resultAct[0];try{console.log('unfollow');activityresult.destroy();//window.alert('You unfollow.');
setTimeout(function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.unfollowpost_link#follow_'+touser_id.id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.followpost_link#follow_'+touser_id.id).attr("style","display: block");},500);}catch(error){console.error('Error deleting activity:',error);}}});setTimeout(function(){console.log('unfollow setTimeout');_this.queryGetFollowersFollowing();},1000);}else{//window.alert('You need to login for follow user.');
return false;}};_this.handleUnFollowUserProfile=function(e){var datapost_id=e.target.dataset.id;var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('User');query.equalTo("objectId",datapost_id);query.first().then(function(result){if(result){var touser=result;var checksavequery=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Activity');checksavequery.equalTo('type','follow');checksavequery.equalTo('toUser',"_User$"+touser.id);checksavequery.equalTo('fromUser',currentUser);checksavequery.first().then(function(object){if(object){//return object.destroy();
}}).then(function(deletedObject){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#follwerModal a.followpost_linkpopup#followpopup_'+touser.id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#follwerModal a.unfollowpost_linkpopup#followpopup_'+touser.id).attr("style","display: none");}).catch(function(error){console.error('Error deleting record:',error);});}});setTimeout(function(){_this.queryGetFollowersFollowing();},1000);}else{// $('#kitchenQrModal_btn').trigger('click');  
return false;}};_this.handleFollowUserProfile=function(e){var datapost_id=e.target.dataset.id;var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();if(currentUser){var self=_this;var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('User');query.equalTo("objectId",datapost_id);query.first().then(function(result){if(result){var touser=result;var Activity=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.Object.extend("Activity");var activity=new Activity();activity.set('fromUser',currentUser);activity.set('toUser',touser);activity.set('type','follow');activity.save().then(function(savedFile){setTimeout(function(){// $('a.unfollowpost_link#follow_'+touser_id.id).attr("style", "display: block");
// $('a.followpost_link#follow_'+touser_id.id).attr("style", "display: none");
},500);self.toggleNotification(touser,'started following you.','');self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});/*setTimeout(() => {
                         this.queryGetFollowersFollowing();
                      },500);*/}).catch(function(error){});}});setTimeout(function(){_this.queryGetFollowersFollowing();},1000);}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}};_this.handleFollowUser=function(touser_id){var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();if(currentUser){var self=_this;var currentUser_id=currentUser.id;var Activity=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.Object.extend("Activity");var activity=new Activity();activity.set('fromUser',currentUser);activity.set('toUser',touser_id);activity.set('type','follow');activity.save().then(function(savedFile){setTimeout(function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.unfollowpost_link#follow_'+touser_id.id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.followpost_link#follow_'+touser_id.id).attr("style","display: none");self.toggleNotification(touser_id,'started following you.','');self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});},500);setTimeout(function(){_this.queryGetFollowersFollowing();},500);}).catch(function(error){});}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}};_this.handleGetFollowUserProfile=function(touser_id){var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultSavedid=0;var checksavequery=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Activity');checksavequery.equalTo('type','follow');checksavequery.equalTo('toUser',"_User$"+touser_id.id);checksavequery.equalTo('fromUser',"_User$"+currentUser_id);checksavequery.find().then(function(resultSave){if(resultSave){var resultSaved=resultSave[0];resultSavedid=resultSaved.id;__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.followpost_link#follow_'+touser_id.id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.unfollowpost_link#follow_'+touser_id.id).attr("style","display: block");}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.followpost_link#follow_'+touser_id.id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.unfollowpost_link#follow_'+touser_id.id).attr("style","display: none");}});}};_this.updateTabValue=function(newValue){localStorage.setItem('storestreamtabValue',newValue);localStorage.setItem('storestreampagepath','user');};__WEBPACK_IMPORTED_MODULE_1_parse___default.a.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5","sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw");//PASTE HERE YOUR Back4App APPLICATION ID AND YOUR JavaScript KEY
__WEBPACK_IMPORTED_MODULE_1_parse___default.a.serverURL="https://parse.joelskitchen.com/parse";//Parse.serverURL = "https://parsetest.joelskitchen.com/parse";
var now=new Date();_this.state={usernameParam:0,userData:null,created_at:now.getTime(),comments:null,userImage:null,user:null,caption:null,likeCount:0,saveCount:0,commentCount:0,posts:{},width:0,height:0,saveposts:{},recipeposts:{},userEmail:null,postsCount:0,followingCount:0,followersCount:0,followingImages:{},followersListing:{},challenges:{},followingImages1:{},followinguserid:[],followingmyuserid:[],searchTerm:'',searchfollowersListing:{},searchfollowingListing:{},followersCountPopup:0,followingCountPopup:0,isPopupOpen:false,post_common_id:'',isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:'',streamtabValue:'posts',streampagepath:'user'};_this.updateWindowDimensions=_this.updateWindowDimensions.bind(_this);_this.handleGetFollowUserProfile=_this.handleGetFollowUserProfile.bind(_this);_this.handleFollowUser=_this.handleFollowUser.bind(_this);_this.handleUnFollowUser=_this.handleUnFollowUser.bind(_this);_this.checktabActive=_this.checktabActive.bind(_this);//this.setState({usernameParam: this.props.match.params.id});
_this.handleFollowUserProfile=_this.handleFollowUserProfile.bind(_this);_this.handleUnFollowUserProfile=_this.handleUnFollowUserProfile.bind(_this);_this.handleSearch=_this.handleSearch.bind(_this);_this.usernameParam=_this.props.match.params.id.toLowerCase();localStorage.setItem('storestreamtabValue','posts');localStorage.setItem('storestreampagepath','user');_this.queryForUserData();return _this;}_createClass(UserProfile,[{key:'queryForChallenges',value:function queryForChallenges(){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('User');query.equalTo("displayUsername",this.usernameParam);query.include("user");var self=this;query.first().then(function(user){if(user){var getChallengequery=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');getChallengequery.exists('isChallengeWinner');//getChallengequery.exists('isChallengeEntry');
getChallengequery.include('isChallengeWinner');getChallengequery.equalTo('isChallengeWinner',true);getChallengequery.equalTo('user',user);getChallengequery.find().then(function(challenge){if(challenge){self.setState({challenges:challenge});}});}});/*let currentUser = Parse.User.current();
        var self = this;   
        if(currentUser)
        {
             var getChallengequery = new Parse.Query('Photo');  
              getChallengequery.exists('isChallenge');
              getChallengequery.equalTo('user',currentUser);
              getChallengequery.find().then(function(challenge){
              if(challenge)
              {     
                  self.setState({challenges: challenge});
              }
             })          
        }*/}},{key:'componentDidMount',value:function componentDidMount(){this.updateWindowDimensions();window.addEventListener('resize',this.updateWindowDimensions);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.updateWindowDimensions);}},{key:'updateWindowDimensions',value:function updateWindowDimensions(){this.setState({width:window.innerWidth,height:window.innerHeight});}},{key:'queryForPosts',value:function queryForPosts(){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');query.include("user");query.include("image");query.include("thumbnail");query.include("likeCountNew");query.include("saveCount");query.include("commentcount");query.include("_created_at");query.include("createdAt");query.exists("user");query.exists("image");//added
query.exists("thumbnail");//added
query.doesNotExist("isChallenge");//added
query.descending("createdAt");query.limit(99999999999999999999999999);query.equalTo("user",this.state.userData);var self=this;query.find().then(function(result){if(result){console.log(result);var resultcount=result.length;if(resultcount!==undefined){self.setState({postsCount:resultcount});}self.setState({posts:result});}else{console.log("No post found");// promise.resolve(null);
}},function(error){console.error("Error loading post Error: "+error);//promise.error(error);
});}},{key:'queryForPostsRecipe',value:function queryForPostsRecipe(){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('User');query.equalTo("displayUsername",this.usernameParam);query.include("user");var self=this;query.first().then(function(user){if(user){var getRecipequery=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');//getRecipequery.exists('recipeV2');
getRecipequery.exists('isRecipe');getRecipequery.equalTo('user',user);getRecipequery.doesNotExist("isChallenge");getRecipequery.descending("_created_at");getRecipequery.find().then(function(recipe){if(recipe){self.setState({recipeposts:recipe});}});}});}},{key:'queryForPostsSave',value:function queryForPostsSave(){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('User');query.equalTo("displayUsername",this.usernameParam);query.include("user");var self=this;query.first().then(function(user){if(user){var getSavequery=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Save');/*getSavequery.exists('photo');
                getSavequery.doesNotExist("isChallenge");//added
                getSavequery.include('photo');
                getSavequery.select("photo.image");
                getSavequery.select("photo.isChallengeWinner");
                getSavequery.select("photo.isChallengeEntry");
                getSavequery.select("photo.isRecipe");*/getSavequery.exists('photo');//getSavequery.exists('image');
getSavequery.include('photo');getSavequery.include("image");getSavequery.doesNotExist("isChallenge");//added
getSavequery.descending("_created_at");getSavequery.equalTo('fromUser',user);getSavequery.find().then(function(resultSave){if(resultSave){self.setState({saveposts:resultSave});}});}});}},{key:'queryGetFollowersFollowing',value:function queryGetFollowersFollowing(){//my userid
var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Activity');query.include("user");query.include("image");query.include("toUser");query.include("thumbnail");query.equalTo("type","follow");query.equalTo("fromUser",currentUser);var self=this;query.find().then(function(result){if(result){var resultmycount=result.length;var followingmydataresult1=[];if(resultmycount>0){var usermydataresult1=[];for(var i=0;i<resultmycount;i++){var user=result[i];var userimage='';if(user.get("toUser").get("profilePictureSmall")&&user.get("toUser").get("profilePictureSmall").url()!==undefined){userimage=user.get("toUser").get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}usermydataresult1.push({'id':user.get("toUser").id,'displayName':user.get("toUser").get("displayName"),'displayUsername':user.get("toUser").get("displayUsername"),'image':userimage,'fromUser':user.get("fromUser").id});followingmydataresult1.push({'id':user.get("toUser").id,'name':user.get("toUser").id});self.setState({followingmyuserid:followingmydataresult1});}}else{self.setState({followingmyuserid:[]});}}});}//my userid
var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Activity');query.include("toUser");query.include("image");query.include("thumbnail");query.equalTo("type","follow");query.equalTo("fromUser",this.state.userData);var self=this;query.find().then(function(result){if(result){var resultcount=result.length;var userdataresult1=[];var followingdataresult1=[];if(resultcount!=undefined){self.setState({followingCount:resultcount});self.setState({followingCountPopup:resultcount});}if(resultcount>0){for(var i=0;i<resultcount;i++){var user=result[i];var userimage='';if(user.get("toUser").get("profilePictureSmall")&&user.get("toUser").get("profilePictureSmall").url()!==undefined){userimage=user.get("toUser").get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}userdataresult1.push({'id':user.get("toUser").id,'displayName':user.get("toUser").get("displayName"),'displayUsername':user.get("toUser").get("displayUsername"),'image':userimage});self.setState({followingImages1:userdataresult1});self.setState({searchfollowingListing:userdataresult1});followingdataresult1.push({'id':user.get("toUser").id,'name':user.get("toUser").id});self.setState({followinguserid:followingdataresult1});}}else{self.setState({followingImages1:[]});self.setState({followingCount:0});self.setState({followinguserid:[]});self.setState({followingCountPopup:0});}}});//followingImages
//followers
var followersquery=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Activity');followersquery.include("fromUser");followersquery.include("image");followersquery.include("thumbnail");followersquery.equalTo("type","follow");followersquery.equalTo("toUser",this.state.userData);var self=this;followersquery.find().then(function(followerresult){if(followerresult){var resultcount=followerresult.length;if(resultcount){self.setState({followersCount:resultcount});self.setState({followersCountPopup:resultcount});}if(resultcount){self.setState({followingImages:followerresult});self.setState({followersListing:followerresult});self.setState({searchfollowersListing:followerresult});}}});}},{key:'queryForUserData',value:function queryForUserData(){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('User');query.equalTo("displayUsername",this.usernameParam);query.include("user");query.include('objectId');query.include("image");query.include("thumbnail");query.include("likeCountNew");query.include("saveCount");query.include("commentcount");query.include("_created_at");query.include("createdAt");query.include("recipe");query.include("product");query.include("collabUser");query.include("collabUser.displayUsername");query.ascending("name");var self=this;query.first().then(function(result){if(result){self.setState({userData:result});self.setState({user:result});localStorage.setItem('streampagepathuser',result.id);var profilePictureSmall='';if(result.get("profilePictureSmall")){self.setState({userImage:result.get("profilePictureSmall").url()});}//userEmail
self.queryForPosts();self.queryForPostsSave();self.queryForPostsRecipe();self.queryGetFollowersFollowing();self.queryForChallenges();var userId=result.id;/*  var querydata = new Parse.Query('User');
                    querydata.select('email');
                    querydata.equalTo("id",userId);                    
                    querydata.find().then(function(results){
                       if(results)
                       {
                        console.log('resultS');
                        console.log(results);
                        const email = result.get('email');
                        const username = result.get('username');
                        console.log(email+'email');
                        console.log(username+'username');
                       }
                   })*/var userQuery=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query(result);//query.include("email");
userQuery.get(userId).then(function(user){var username=user.get('username');if(username){self.setState({userEmail:username});}///useremail
}).catch(function(error){console.error('Error fetching user:',error);});}else{console.log("No post found");// promise.resolve(null);
}},function(error){console.error("Error loading post Error: "+error);//promise.error(error);
});}},{key:'getWebsite',value:function getWebsite(){var website=this.state.userData.get("website");if(!website)return"";else if(website.includes("http://"))return website;else if(website.includes("https://"))return website;else return"https://"+website;}},{key:'renderFollowingImages',value:function renderFollowingImages(){var userfollowingimages=[];var userfollowingusername=[];var othertext='';var getLoggedinUsername=localStorage.getItem('username');if(this.state.followingImages){var rows=this.state.followingImages.length;var other=0;for(var i=0;i<rows;i++){if(i<4){var followimage=this.state.followingImages[i];if(followimage!==undefined&&followimage.get('fromUser')&&followimage.get('fromUser').get("profilePictureSmall")!==undefined){userfollowingimages.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{key:69*i},getLoggedinUsername===followimage.get('fromUser').get("displayUsername")?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/my-profile',title:followimage.get('fromUser').get("displayUsername")},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:followimage.get('fromUser').get("profilePictureSmall").url(),alt:'user image'})):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/user/'+followimage.get('fromUser').get("displayUsername"),title:followimage.get('fromUser').get("displayUsername")},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:followimage.get('fromUser').get("profilePictureSmall").url(),alt:'user image'}))));}else{if(followimage!==undefined&&followimage.get('fromUser')&&followimage.get('fromUser').get("profilePictureSmall")!==undefined){userfollowingimages.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{key:69*i},followimage.get('fromUser')&&followimage.get('fromUser').get("displayUsername")&&getLoggedinUsername===followimage.get('fromUser').get("displayUsername")?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/my-profile',title:followimage.get('fromUser').get("displayUsername")},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/default_userpic0.png',alt:'user image'})):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/user/'+followimage.get('fromUser')&&followimage.get('fromUser').get("displayUsername"),title:followimage.get('fromUser').get("displayUsername")},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/default_userpic0.png',alt:'user image'}))));}}if(rows>2){other=rows-2;}if(i==0){if(followimage.get('fromUser')&&followimage.get('fromUser').id!==undefined){userfollowingusername.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{key:69*i},followimage.get('fromUser').get("displayUsername")));}}if(i==1){if(followimage.get('fromUser')&&followimage.get('fromUser').id!==undefined){userfollowingusername.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{key:69*i},', \xA0',followimage.get('fromUser').get("displayUsername")));}}}}if(rows>2&&other){if(other==1){othertext=' and '+other+' other ';}else{othertext=' and '+other+' others ';}}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'followed_people'},userfollowingusername!=''?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label',null,' Followed by ',userfollowingusername,' ',othertext?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label',null,' ',othertext):""):'',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',null,userfollowingimages));}}},{key:'renderPosts',value:function renderPosts(){var _this2=this;var buffer=[];var savebuffer=[];var recipebuffer=[];var bufferfollowers=[];var challengebuffer=[];var bufferfollowing=[];var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();var isPopupOpen=this.state.isPopupOpen;var postcommonid=this.state.post_common_id;var isNotificationOpen=this.state.isNotificationOpen;var post_Notification_Ids=this.state.post_Notification_Id;var post_Notification_Msg=this.state.post_Notification_Msg;var post_Notification_Comment=this.state.post_Notification_Comment;var togglePopup=function togglePopup(postid){_this2.setState(function(prevState){return{isPopupOpen:!prevState.isPopupOpen};});_this2.setState({post_common_id:postid});};var streamid=function streamid(postid){localStorage.setItem('storestreamid',postid);};/*new code*/var postRecord=[];if(this.state.posts){var _loop=function _loop(){post=_this2.state.posts[i];var postdata_id=post&&post.id;var postdata_image=post&&post.get("image")&&post.get("image").url();// if(postdata_image) {
{/*href = "javascript:void(0);" id={postdata_id} onClick={(e) => {togglePopup(postdata_id);}}*/}postRecord.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPost',key:69*3*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{id:postdata_id,href:'/stream',onClick:function onClick(e){streamid(postdata_id);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'chlng-icon'},post&&post.get("isChallengeWinner")&&post.get("isChallengeWinner")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'winner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/winner-icon-img.svg'})),post&&post.get("isRecipe")&&post.get("isRecipe")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'recipe'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/recipe-icon-img.svg'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{className:'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:postdata_image})))));// }
};for(var i=0;i<this.state.posts.length;i++){var post;_loop();}}/*new code*//*if (this.state.posts)
        {
           
             var rows = Math.floor(this.state.posts.length / 3) + 1;

            for (var i = 0; i < rows; i++)
            {
              
                var post = this.state.posts[i * 3];
                var post2 = this.state.posts[(i * 3)+1];
                var post3 = this.state.posts[(i * 3)+2];
                var post4 = this.state.posts[(i * 3)+3];


                if ((post !== undefined   && post.get('image')) && 
                    (post2 !== undefined   && post2.get('image'))  && 
                    (post3 !== undefined   && post3.get('image')) 
                    )
                {
                    buffer.push(<div className="gridPostRow" key={69*i}>
 
                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+post.id}>
                                <div className='chlng-icon'>
                                 
                                {post.get("isChallengeWinner") && post.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                            
                                {post.get("isRecipe") && post.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={post.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                                <a href={"/post/"+post2.id}>
                                  <div className='chlng-icon'>
                               
                                {post2.get("isChallengeWinner") && post2.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                              
                                {post2.get("isRecipe") && post2.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={post2.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                               <a href={"/post/"+post3.id}>
                               <div className='chlng-icon'>
                                
                                {post3.get("isChallengeWinner") && post3.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                              
                                {post3.get("isRecipe") && post3.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={post3.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                        

                            </div>);
                }
                else if ((post != undefined) && (post.get("image")) &&
                    (post2 != undefined) && (post2.get("image")))
                {
                    buffer.push(<div className="gridPostRow" key={69*i}>
                        <div className="gridPost" key={69*3*i}>
                            <a href={"/post/"+post.id}>
                            <div className='chlng-icon'>
                                
                                {post.get("isChallengeWinner") && post.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                            
                                {post.get("isRecipe") && post.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src={post.get("image").url()}/>
                                </figure>
                            </a>
                        </div>
                        <div className="gridPost" key={69*3*(i+1)}>
                            <a href={"/post/"+post2.id}>
                             <div className='chlng-icon'>
                              
                                {post2.get("isChallengeWinner") && post2.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                              
                                {post2.get("isRecipe") && post2.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src={post2.get("image").url()}/>
                                </figure>
                            </a>
                        </div>
                        <div className="gridPost" key={69*3*(i+2)}>
                            <figure className='thumbnail'>
                                <img className="gridPost" src="/images/emptygrid.png"/>
                            </figure>
                        </div>
                    
                    </div>);
                }
                else if ((post != undefined) && (post.get("image")))
                {
                    buffer.push(<div className="gridPostRow" key={69*i}>

                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+post.id}>
                                 <div className='chlng-icon'>
                               
                                {post.get("isChallengeWinner") && post.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                            
                                {post.get("isRecipe") && post.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img className="gridPost" src={post.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                                </div>
                          

                            </div>);
                }              
            }
        }*//*new code*/var saveRecord=[];if(this.state.saveposts){var _loop2=function _loop2(){post=_this2.state.saveposts[i];var postdata_id=post.get('photo')&&post.get('photo').id;var postdata_image=post.get("photo")&&post.get('photo').get("image").url();{/*href = "javascript:void(0);" id={postdata_id} onClick={(e) => {togglePopup(postdata_id);}}*/}if(postdata_image){saveRecord.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPost',key:69*3*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{id:postdata_id,href:'/stream',onClick:function onClick(e){streamid(postdata_id);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'chlng-icon'},post.get('photo')&&post.get('photo').get("isChallengeWinner")&&post.get('photo').get("isChallengeWinner")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'winner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/winner-icon-img.svg'})),post.get('photo')&&post.get('photo').get("isRecipe")&&post.get('photo').get("isRecipe")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'recipe'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/recipe-icon-img.svg'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{className:'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:postdata_image})))));}};for(var i=0;i<this.state.saveposts.length;i++){var post;_loop2();}}/*new code*//*if (this.state.saveposts)
        { 
           
            var rows = Math.floor(this.state.saveposts.length / 3) + 1;
            for (var i = 0; i < rows; i++)
            {
                
                var savepost = this.state.saveposts[i * 3];
                var savepost2 = this.state.saveposts[(i * 3)+1];
                var savepost3 = this.state.saveposts[(i * 3)+2];
                var savepost4 = this.state.saveposts[(i * 3)+3];

               if ((savepost && savepost.get('photo') && savepost.get('photo')!=='undefined') && (savepost2 && savepost2.get('photo') && savepost2.get('photo')!=='undefined') && (savepost3 && savepost3.get('photo') && savepost3.get('photo')!=='undefined') ) 
                {
                    var savepost_id=savepost.get('photo').id;
                    var savepost2_id=savepost2.get('photo').id;
                     var savepost3_id=savepost3.get('photo').id;
                    savebuffer.push(<div className="gridPostRow" key={69*i}>
 
                            <div className="gridPost" key={69*3*i}>
                        
                                <a href = "javascript:void(0);" id={savepost_id} onClick={(e) => {togglePopup(savepost_id);}}>
                                  <div className='chlng-icon'>
                                {savepost.get('photo').get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                           
                                {savepost.get('photo').get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={savepost.get('photo').get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                                <a href = "javascript:void(0);" id={savepost2_id} onClick={(e) => {togglePopup(savepost2_id);}}>
                                <div className='chlng-icon'>
                                {savepost2.get('photo').get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                            
                                 {savepost2.get('photo').get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={savepost2.get('photo').get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                               <a href = "javascript:void(0);" id={savepost3_id} onClick={(e) => {togglePopup(savepost3_id);}}>
                               <div className='chlng-icon'>
                                {savepost3.get('photo').get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                             
                                 {savepost3.get('photo').get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={savepost3.get('photo').get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                         

                            </div>);
                }
                else if ((savepost && savepost.get('photo') && savepost.get('photo')!=='undefined') && (savepost2 && savepost2.get('photo') && savepost2.get('photo')!=='undefined'))
                {
                    savebuffer.push(<div className="gridPostRow" key={69*i}>

                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+savepost.get('photo').id}>
                                  <div className='chlng-icon'>
                                {savepost.get('photo').get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                            
                                 {savepost.get('photo').get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={savepost.get('photo').get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                               <a href={"/post/"+savepost2.get('photo').id}>
                                <div className='chlng-icon'>
                                {savepost2.get('photo').get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                           
                                 {savepost2.get('photo').get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={savepost2.get('photo').get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>
                            </div>
                        

                            </div>);
                }
                else if ((savepost && savepost.get('photo') && savepost.get('photo')!=='undefined'))
                {
                    savebuffer.push(<div className="gridPostRow" key={69*i}>
                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+savepost.get('photo').id}>
                                 <div className='chlng-icon'>
                                {savepost.get('photo').get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                      
                                {savepost.get('photo').get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img className="gridPost" src={savepost.get('photo').get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>
                         
                            </div>);
                }
            }  
        }*//*new code*/var recipeRecord=[];if(this.state.recipeposts){var _loop3=function _loop3(){post=_this2.state.recipeposts[i];var postdata_id=post&&post.id;var postdata_image=post&&post.get("image")&&post.get("image").url();{/*href = "javascript:void(0);" id={postdata_id} onClick={(e) => {togglePopup(postdata_id);}}*/}recipeRecord.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPost',key:69*3*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{id:postdata_id,href:'/stream',onClick:function onClick(e){streamid(postdata_id);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'chlng-icon'},post&&post.get("isChallengeWinner")&&post.get("isChallengeWinner")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'winner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/winner-icon-img.svg'})),post&&post.get("isRecipe")&&post.get("isRecipe")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'recipe'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/recipe-icon-img.svg'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{className:'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:postdata_image})))));};for(var i=0;i<this.state.recipeposts.length;i++){var post;_loop3();}}/*new code*//*if (this.state.recipeposts)
        { 
            
          
            var reciperows = Math.floor(this.state.recipeposts.length / 3) + 1;
            for (var i = 0; i < reciperows; i++)
            {
              
                var recipepost = this.state.recipeposts[i * 3];
                var recipepost2 = this.state.recipeposts[(i * 3)+1];
                var recipepost3 = this.state.recipeposts[(i * 3)+2];
                var recipepost4 = this.state.recipeposts[(i * 3)+3];

               if ((recipepost !== undefined   && recipepost.get('image')) && 
                    (recipepost2 !== undefined   && recipepost2.get('image'))  && 
                    (recipepost3 !== undefined   && recipepost3.get('image')) 
                    )
                {
                    recipebuffer.push(<div className="gridPostRow" key={69*i}>

                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+recipepost.id}>
                                 <div className='chlng-icon'>
                                {recipepost.get("isChallengeWinner")!==undefined && recipepost.get("isChallengeWinner")===true && <div className='winner'><img src='/images/chlng-wnr.png' className='chlng-wnr' /></div>}
                            
                                {recipepost.get("isRecipe")!==undefined && recipepost.get("isRecipe")===true && <div className='recipe'><img src='/images/recipe-icon-img.svg' className='chlng-wnr' /></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={recipepost.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                                <a href={"/post/"+recipepost2.id}>
                                 <div className='chlng-icon'>
                                {recipepost2.get("isChallengeWinner")===true && <div className='winner'><img src='/images/chlng-wnr.png' className='chlng-wnr' /></div>}
                            
                                {recipepost2.get("isRecipe")===true && <div className='recipe'><img src='/images/recipe-icon-img.svg' className='chlng-wnr' /></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={recipepost2.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                               <a href={"/post/"+recipepost3.id}>
                                 <div className='chlng-icon'>
                                {recipepost3.get("isChallengeWinner")===true && <div className='winner'><img src='/images/chlng-wnr.png' className='chlng-wnr' /></div>}
                             
                                {recipepost3.get("isRecipe")===true && <div className='recipe'><img src='/images/recipe-icon-img.svg' className='chlng-wnr' /></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={recipepost3.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                        

                            </div>);
                }
                else if ((recipepost !== undefined  && recipepost.get('image'))  &&
                    (recipepost2!== undefined  && recipepost2.get('image')))
                {
                    recipebuffer.push(<div className="gridPostRow" key={69*i}>

                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+recipepost.id}>
                                 <div className='chlng-icon'>
                                {recipepost.get("isChallengeWinner")===true && <div className='winner'><img src='/images/chlng-wnr.png' className='chlng-wnr' /></div>}
                            
                                {recipepost.get("isRecipe")===true && <div className='recipe'><img src='/images/recipe-icon-img.svg' className='chlng-wnr' /></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={recipepost.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                               <a href={"/post/"+recipepost2.id}>
                                 <div className='chlng-icon'>
                                {recipepost2.get("isChallengeWinner")===true && <div className='winner'><img src='/images/chlng-wnr.png' className='chlng-wnr' /></div>}
                            
                                {recipepost2.get("isRecipe")===true && <div className='recipe'><img src='/images/recipe-icon-img.svg' className='chlng-wnr' /></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={recipepost2.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>
                            </div>
                       

                            </div>);
                }
                else if (recipepost !== undefined && recipepost.get('image'))
                {
                    recipebuffer.push(<div className="gridPostRow" key={69*i}>
                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+recipepost.id}>
                                 <div className='chlng-icon'>
                                {recipepost.get("isChallengeWinner")===true && <div className='winner'><img src='/images/chlng-wnr.png' className='chlng-wnr' /></div>}
                           
                                {recipepost.get("isRecipe")===true && <div className='recipe'><img src='/images/recipe-icon-img.svg' className='chlng-wnr' /></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img className="gridPost" src={recipepost.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>
                            
                            </div>);
                }
            }  
        }*/if(this.state.followersListing){var usernameParams=this.usernameParam;var rows=this.state.followersListing.length;var followinguserid=this.state.followinguserid;var followingmyuserid=this.state.followingmyuserid;for(var i=0;i<rows;i++){var followers=this.state.followersListing[i];var userimage=null;var currentUserid=null;//console.log(this.state.userData.id+'login id ');
var follow_id_ms=followers.get("fromUser")&&followers.get("fromUser").id?'followpopup_'+followers.get("fromUser").id:'';if(followers.get("fromUser")&&followers.get("fromUser").get("profilePictureSmall")&&followers.get("fromUser").get("profilePictureSmall").url()!==undefined){userimage=followers.get("fromUser").get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}var _currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();if(_currentUser){currentUserid=_currentUser.id;var chek=followinguserid.find(function(c){return c.id===followers.get("fromUser").id;});var followingresults=chek!=undefined?JSON.parse(JSON.stringify(chek)):"";var chek1=followingmyuserid.find(function(c){return c.id===followers.get("fromUser").id;});var followingmyresults=chek1!=undefined?JSON.parse(JSON.stringify(chek1)):"";var checksavequery=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Activity');checksavequery.equalTo('type','follow');if(followers.get("fromUser").id){checksavequery.equalTo('toUser',"_User$"+followers.get("fromUser").id);}checksavequery.equalTo('fromUser',"_User$"+currentUserid);checksavequery.find().then(function(resultAct){var activityresult=resultAct[0];if(activityresult){//$('#follwerModal a.unfollowpost_linkpopup#followpopup_'+followers.get("fromUser").id).attr("style", "display: block");
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#follwerModal a.followpost_linkpopup#followpopup_'+followers.get("fromUser").id).attr("style","display: none");}/*else{
                         $('#follwerModal a.unfollowpost_linkpopup#followpopup_'+followers.get("fromUser").id).attr("style", "display: none");
                         $('#follwerModal a.followpost_linkpopup#followpopup_'+followers.get("fromUser").id).attr("style", "display: block");
                     }*/});/*$('a.unfollowpost_linkpopup#followpopup_'+followers.get("fromUser").id).attr("style", "display: none");
                     $('a.followpost_linkpopup#followpopup_'+followers.get("fromUser").id).attr("style", "display: block");*/}if(currentUserid){bufferfollowers.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'items',key:69*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'box follow-usr'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media',id:currentUserid},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-left',id:followers.get("fromUser").id},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'mr-3',src:userimage,alt:'Generic placeholder image'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5',{className:'m-0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/user/'+followers.get('fromUser').get('displayUsername')},followers.get('fromUser').get('displayName')?followers.get('fromUser').get('displayName'):''),' '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,followers.get('fromUser').get('displayName')?followers.get('fromUser').get('displayName'):''))),/*currentUserid!==followers.get("fromUser").id? */__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'action cta_btn'},currentUserid===followers.get('fromUser').id?"":followingmyresults.id==followers.get('fromUser').id&&currentUserid!==followers.get("fromUser").id?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'fourth-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);'},'Following')):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'third-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{id:follow_id_ms,'data-fromuser':followingresults.id,'data-myuser':followingmyresults.id,title:currentUserid,'data-id':followers.get('fromUser').id,onClick:function onClick(e){return _this2.handleFollowUserProfile(e);},style:{display:"block"},href:'javascript:void(0);',className:'followpost_linkpopup'},'Follow')))/* :""*/)));}else{bufferfollowers.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'items',key:69*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'box follow-usr'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media',id:currentUserid},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-left',id:followers.get("fromUser").id},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'mr-3',src:userimage,alt:'Generic placeholder image'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5',{className:'m-0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/user/'+followers.get('fromUser').get('displayUsername')},followers.get('fromUser').get('displayUsername'),' ')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,followers.get('fromUser').get('displayName')))),currentUserid!==followers.get("fromUser").id?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'third-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{id:follow_id_ms,title:currentUserid,'data-id':followers.get('fromUser').id,onClick:function onClick(e){return _this2.handleFollowUserProfile(e);},style:{display:"block"},href:'javascript:void(0);',className:'followpost_linkpopup'},'Follow '))):"")));}}}/*if (this.state.challenges)
        {
            var rows = Math.floor(this.state.challenges.length / 3) + 1;
            for (var i = 0; i < rows; i++)
            {
               
                var post = this.state.challenges[i * 3];
                var post2 = this.state.challenges[(i * 3)+1];
                var post3 = this.state.challenges[(i * 3)+2];
                var post4 = this.state.challenges[(i * 3)+3];               
              if ((post !== undefined   && post.get('image')) && 
                    (post2 !== undefined   && post2.get('image'))  && 
                    (post3 !== undefined   && post3.get('image')) 
                    )
                {
                    challengebuffer.push(<div className="gridPostRow" key={69*i}>
 
                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+post.id}>
                                 <div className='chlng-icon'>
                                        {post.get("isChallengeWinner")===true?<img src='/images/chlng-wnr.png' className='chlng-wnr' />:<img src='/images/chlng-entry.png' className='chlng-entry' />}
                                    </div>
                                    <figure className='thumbnail'>
                                        <img src={post.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                                <a href={"/post/"+post2.id}>
                                <div className='chlng-icon'>
                                      
                                        {post2.get("isChallengeWinner")===true?<img src='/images/chlng-wnr.png' className='chlng-wnr' />:<img src='/images/chlng-entry.png' className='chlng-entry' />}
                                   
                                    </div>
                                    <figure className='thumbnail'>
                                        <img src={post2.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                               <a href={"/post/"+post3.id}>
                                <div className='chlng-icon'>
                                        
                                    {post3.get("isChallengeWinner")===true?<img src='/images/chlng-wnr.png' className='chlng-wnr' />:<img src='/images/chlng-entry.png' className='chlng-entry' />}
                                   
                                        
                                    </div>
                                    <figure className='thumbnail'>
                                        <img src={post3.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>

                            </div>);
                }
                else if ((post != undefined) && (post.get("image")) &&
                    (post2 != undefined) && (post2.get("image")))
                {
                    challengebuffer.push(<div className="gridPostRow" key={69*i}>

                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+post.id}>
                                 <div className='chlng-icon'>    
                                        {post.get("isChallengeWinner")===true?<img src='/images/chlng-wnr.png' className='chlng-wnr' />:<img src='/images/chlng-entry.png' className='chlng-entry' />}
                                    </div>
                                    <figure className='thumbnail'>
                                        <img src={post.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                               <a href={"/post/"+post2.id}>
                                 <div className='chlng-icon'>
                                       {post2.get("isChallengeWinner")===true?<img src='/images/chlng-wnr.png' className='chlng-wnr' />:<img src='/images/chlng-entry.png' className='chlng-entry' />}
                                    </div>
                                    <figure className='thumbnail'>
                                        <img src={post2.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>
                            </div>

                            </div>);
                }
                else if ((post != undefined) && (post.get("image")))
                {
                    challengebuffer.push(<div className="gridPostRow" key={69*i}>

                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+post.id}>
                                  <div className='chlng-icon'>    
                                        {post.get("isChallengeWinner")===true?<img src='/images/chlng-wnr.png' className='chlng-wnr' />:<img src='/images/chlng-entry.png' className='chlng-entry' />}
                                    
                                    </div>
                                    <figure className='thumbnail'>
                                        <img className="gridPost" src={post.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>

                            </div>);
                }
               
            }
        }*/if(this.state.followingImages1){var rows=this.state.followingImages1.length;var _followinguserid=this.state.followinguserid;var _followingmyuserid=this.state.followingmyuserid;var _currentUser2=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();var _currentUserid="";if(_currentUser2!=null){var _currentUserid2=_currentUser2.id;}if(rows!=undefined){for(var i=0;i<rows;i++){var followers=this.state.followingImages1[i];var follow_id_ms='followpopup_'+followers.id;var _userimage=null;if(followers.image){_userimage=followers.image;}else{_userimage="/images/default_userpic0.png";}var chek=_followinguserid.find(function(c){return c.id===followers.id;});var followingresults=chek!=undefined?JSON.parse(JSON.stringify(chek)):"";var chek1=_followingmyuserid.find(function(c){return c.id===followers.id;});var followingmyresults=chek1!=undefined?JSON.parse(JSON.stringify(chek1)):"";bufferfollowing.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'items',key:69*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'box follow-usr'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-left'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'mr-3',src:_userimage,alt:'Generic placeholder image'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5',{className:'m-0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/user/'+followers.displayUsername},followers.displayName,' ')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,followers.displayUsername))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'third-btn btn-wrp'},_currentUserid===followers.id?"":followingmyresults.id==followers.id?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'fourth-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);'},'Following')):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'third-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{id:follow_id_ms,'data-id':followers.id,onClick:function onClick(e){return _this2.handleFollowUserProfile(e);},style:{display:"block"},href:'javascript:void(0);',className:'followpost_linkpopup'},'Follow')))))));}}}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'post_grid-tab'},' ',isNotificationOpen?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__saveNotification_jsx__["a" /* default */],{isOpen:isNotificationOpen,postNotificationid:post_Notification_Ids,postMsg:post_Notification_Msg,postPhotoid:post_Notification_Ids,postActivityComment:post_Notification_Comment}):"",'  ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CommonPopup_jsx__["a" /* default */],{isOpen:isPopupOpen,onClose:function onClose(e){togglePopup(postcommonid);},postcommonid:postcommonid}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'nav nav-tabs',id:'myTab',role:'tablist'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'nav-item',role:'presentation'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'nav-link active',onClick:function onClick(){return _this2.updateTabValue('posts');},id:'posts-tab','data-toggle':'tab','data-target':'#posts',type:'button',role:'tab','aria-controls':'posts','aria-selected':'true'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'gridPost def',src:'/images/tab_prf_posts.svg',alt:'posts'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'gridPost act',src:'/images/tab_prf_posts_actv.svg',alt:'posts'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,'posts'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'nav-item',role:'presentation'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'nav-link',onClick:function onClick(){return _this2.updateTabValue('recipes');},id:'recipes-tab','data-toggle':'tab','data-target':'#recipes',type:'button',role:'tab','aria-controls':'recipes','aria-selected':'false'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'gridPost def',src:'/images/tab_prf_recipes.svg',alt:'recipes'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'gridPost act',src:'/images/tab_prf_recipes_actv.svg',alt:'recipes'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,'recipes'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'nav-item',role:'presentation'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'nav-link',onClick:function onClick(){return _this2.updateTabValue('saved');},id:'saved-tab','data-toggle':'tab','data-target':'#saved',type:'button',role:'tab','aria-controls':'saved','aria-selected':'false'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'gridPost def',src:'/images/tab_prf_bookmark.svg',alt:'savedy'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'gridPost act',src:'/images/tab_prf_bookmark_actv.svg',alt:'savedy'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,'saved')))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tab-content',id:'myTabContent'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tab-pane fade show active',id:'posts',role:'tabpanel','aria-labelledby':'posts-tab'},'  ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPostRow'},postRecord)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tab-pane fade',id:'recipes',role:'tabpanel','aria-labelledby':'recipes-tab'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPostRow'},recipeRecord)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tab-pane fade',id:'saved',role:'tabpanel','aria-labelledby':'saved-tab'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPostRow'},saveRecord))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal fade post_modal follwerModal',id:'follwerModal',tabIndex:'-1',role:'dialog','data-backdrop':'true','data-keyboard':'true','aria-labelledby':'createPostCloseTitle','aria-hidden':'false'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{type:'button',className:'close','data-dismiss':'modal','aria-label':'Modal'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/back-arrow.svg',alt:'Close'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'search_wrap'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('form',{className:'form-mn d-flex flex-row flex-wrap'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{className:'form-control',type:'search',placeholder:'Search','aria-label':'Search',value:this.state.searchTerm,onChange:this.handleSearch}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{type:'submit'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/search.svg',alt:'Search'}))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tab-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'nav nav-tabs',id:'usrfollwerTabs',role:'tablist'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'nav-item'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{className:'nav-link active',id:'usrFlwrsTabs','data-toggle':'tab',href:'#usrFlwrsPane',role:'tab','aria-controls':'usrFlwrsPane','aria-selected':'true'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,this.state.followersCountPopup),' Followers')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'nav-item'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{className:'nav-link',id:'usrFlwingTabs','data-toggle':'tab',href:'#usrFlwingPane',role:'tab','aria-controls':'usrFlwingPane','aria-selected':'true'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,this.state.followingCountPopup),' Following'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tab-content',id:'usrfollwerPanel'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tab-pane fade show active',id:'usrFlwrsPane',role:'tabpanel','aria-labelledby':'usrFlwrsTabs'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'list-wrap'},bufferfollowers)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tab-pane fade',id:'usrFlwingPane',role:'tabpanel','aria-labelledby':'usrFlwingTabs'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'list-wrap'},bufferfollowing)))))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-backdrop fade show'})));}},{key:'getImpressionCount',value:function getImpressionCount(){if(this.state.userData.get("impr"))return this.state.userData.get("impr").toLocaleString(navigator.language,{minimumFractionDigits:0});else return 2;}},{key:'renderProfileMain',value:function renderProfileMain(){var _this3=this;if(this.state.width<=860){var follow_id_m='follow_'+this.state.userData.id;var userEmail=this.state.userEmail;var display_username=this.state.userData.get("displayUsername");var usernameParams=this.usernameParam;var sameprofile=0;var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();if(currentUser){var currentUser_name=currentUser.get('displayUsername');if(currentUser_name===usernameParams){sameprofile=1;}}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'porfile_card'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'user_detail d-flex flex-row flex-wrap'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'thumbnail'},this.state.userImage!==null?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{height:'150',width:'150',className:'userProfileImageLarge',src:this.state.userImage,alt:'Profile Picture'}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{height:'150',width:'150',src:'/images/default_userpic0.png',alt:'Profile Picture'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'detail d-flex flex-column flex-wrap justify-content-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'title-part d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'name'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h1',null,this.state.userData.get("displayUsername"))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'mobile_action'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'action cta_btn d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'third-btn btn-wrp'},sameprofile===0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{id:follow_id_m,style:{display:"block"},href:'javascript:void(0);',title:'Follow',className:'followpost_link',onClick:function onClick(){return _this3.handleFollowUser(_this3.state.userData);}},'Follow'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{id:follow_id_m,onClick:function onClick(){return _this3.handleUnFollowUser(_this3.state.userData);},style:{display:"none"},href:'javascript:void(0);',title:'Unfollow',className:'unfollowpost_link'},'Unfollow')):"",this.handleGetFollowUserProfile(this.state.userData)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'fourth-btn btn-wrp'},this.state.userEmail!==null?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'mailto:'+userEmail,title:'Email'},'Email'):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'#',title:'Email'},'Email')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{type:'button',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/profile',className:'dropdown-item',type:'button'},'Profile'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'#',className:'dropdown-item',type:'button'},'Business Suite'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'#',className:'dropdown-item',type:'button'},'Insights'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'#',className:'dropdown-item',type:'button'},'Notifications'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'#',className:'dropdown-item',type:'button'},'Settings')))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'post-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'postcount'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,this.state.postsCount),'Posts')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'follwer'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'#usrFlwrsPane',type:'button','data-toggle':'modal','data-id':'#usrFlwrsTabs',onClick:this.checktabActive,'data-target':'#follwerModal'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,this.state.followersCount),'Followers'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'follwing'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{onClick:this.checktabActive,href:'#usrFlwingPane','data-id':'#usrFlwingTabs',type:'button','data-toggle':'modal','data-target':'#follwerModal'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,this.state.followingCount),'Following')))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'bio_detail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'dname'},this.state.userData.get("displayName")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'dbio'},this.state.userData.get("bio")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'web'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{target:'_blank',href:this.getWebsite()},this.getWebsite()))),this.renderFollowingImages()));}else{var follow_id_m='follow_'+this.state.userData.id;var userEmail=this.state.userEmail;var _display_username=this.state.userData.get("displayUsername");var _usernameParams=this.usernameParam;var _sameprofile=0;var _currentUser3=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();if(_currentUser3){var _currentUser_name=_currentUser3.get('displayUsername');if(_currentUser_name===_usernameParams){_sameprofile=1;}}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'porfile_card'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'user_detail d-flex flex-row flex-wrap'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'thumbnail'},this.state.userImage!==null?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{height:'150',width:'150',className:'userProfileImageLarge',src:this.state.userImage,alt:'Profile Picture'}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{height:'150',width:'150',src:'/images/default_userpic0.png',alt:'Profile Picture'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'detail d-flex flex-column flex-wrap justify-content-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'title-part d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'name'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h1',null,this.state.userData.get("displayUsername"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'action cta_btn d-flex flex-row flex-wrap align-items-center'},_sameprofile===0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'third-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{id:follow_id_m,style:{display:"block"},href:'javascript:void(0);',title:'Follow',className:'followpost_link',onClick:function onClick(){return _this3.handleFollowUser(_this3.state.userData);}},'Follow'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{id:follow_id_m,onClick:function onClick(){return _this3.handleUnFollowUser(_this3.state.userData);},style:{display:"none"},href:'javascript:void(0);',title:'Unfollow',className:'unfollowpost_link'},'Unfollow')),this.handleGetFollowUserProfile(this.state.userData)):"",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'fourth-btn btn-wrp'},this.state.userEmail!==null?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'mailto:'+userEmail,title:'Email'},'Email'):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'#',title:'Email'},'Email')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{type:'button',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/profile',className:'dropdown-item',type:'button'},'Profile'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'#',className:'dropdown-item',type:'button'},'Business Suite'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'#',className:'dropdown-item',type:'button'},'Insights'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'#',className:'dropdown-item',type:'button'},'Notifications'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'#',className:'dropdown-item',type:'button'},'Settings'))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'post-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'postcount'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,this.state.postsCount),'Posts')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'follwer'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'#usrFlwrsPane',type:'button','data-toggle':'modal','data-id':'#usrFlwrsTabs',onClick:this.checktabActive,'data-target':'#follwerModal'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,this.state.followersCount),'Followers'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'follwing'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{onClick:this.checktabActive,href:'#usrFlwingPane','data-id':'#usrFlwingTabs',type:'button','data-toggle':'modal','data-target':'#follwerModal'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,this.state.followingCount),'Following'))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'bio_detail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'dname'},this.state.userData.get("displayName")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'dbio'},this.state.userData.get("bio")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'web'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:this.getWebsite()},this.getWebsite()))),this.renderFollowingImages())));}}},{key:'render',value:function render(){var likesWord="likes";var savesWord="saves";var commentsWord="comments";if(this.state.likeCount==1)likesWord="like";if(this.state.saveCount==1)savesWord="save";if(this.state.commentCount==1)commentsWord="comment";if(!this.state.userData){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'user_not_found'});}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('section',{className:'post_list'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('nav',{className:'sidebar'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Leftsidebar_jsx__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('main',{className:'listing myprofile-listing'},this.renderProfileMain(),this.renderPosts()))));}}]);return UserProfile;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);var UserProfiles=function(_React$Component2){_inherits(UserProfiles,_React$Component2);function UserProfiles(){_classCallCheck(this,UserProfiles);return _possibleConstructorReturn(this,(UserProfiles.__proto__||Object.getPrototypeOf(UserProfiles)).apply(this,arguments));}_createClass(UserProfiles,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Route */],{path:'/user/:id',component:UserProfile}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Route */],{path:'/users/:id',component:UserProfile}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Route */],{path:'/profile/:id',component:UserProfile}));}}]);return UserProfiles;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (UserProfiles);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(137);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var allOptions=["Alabama","Alaska","American Samoa","Arizona","Arkansas","California","Colorado","Connecticut","Delaware","District of Columbia","Federated States of Micronesia","Florida","Georgia","Guam","Hawaii","Idaho","Illinois","Indiana","Iowa","Kansas","Kentucky","Louisiana","Maine","Marshall Islands","Maryland","Massachusetts","Michigan","Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada","New Hampshire","New Jersey","New Mexico","New York","North Carolina","North Dakota","Northern Mariana Islands","Ohio","Oklahoma","Oregon","Palau","Pennsylvania","Puerto Rico","Rhode Island","South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont","Virgin Island","Virginia","Washington","West Virginia","Wisconsin","Wyoming"];var Editprofile=function(_React$Component){_inherits(Editprofile,_React$Component);function Editprofile(props){_classCallCheck(this,Editprofile);var _this=_possibleConstructorReturn(this,(Editprofile.__proto__||Object.getPrototypeOf(Editprofile)).call(this,props));_initialiseProps.call(_this);var getUsername=localStorage.getItem('username');var getUseremail=localStorage.getItem('useremail');var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(!currentUser){window.location.href="/";}var fetchusername=currentUser.get('displayUsername');//currentUser.get('username');
var name=currentUser.get('displayName');//currentUser.get("name");
var bio=currentUser.get("bio");var website=currentUser.get("website");var creator_name=currentUser.get("creator_name");var creator_phonenumber=currentUser.get("creator_phonenumber");var city=currentUser.get("city");var address1=currentUser.get("address1");var address2=currentUser.get("address2");var states=currentUser.get("state");var zipcode=currentUser.get("zipcode");var paypal_email=currentUser.get("paypal_email");var isCreator=currentUser.get("isCreator");/*
        let instagram = currentUser.get("instagram");
        let tiktok = currentUser.get("tiktok");
        let youtube = currentUser.get("youtube");*/var profile_picture=currentUser.get("profilePictureMedium");if(profile_picture){profile_picture=profile_picture._url;__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#profilePicturePreview").attr("style","display: block");}else{profile_picture='';__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#profilePicturePreview").attr("style","display: none");}_this.state={username:getUsername,email:getUseremail,name:name,bio:bio,city:city,website:website,/* city:city,
            instagram:instagram,
            tiktok:tiktok,
            youtube:youtube,*/profile_picture:profile_picture,currentUser:currentUser,nametext:name,namecharCount:(name||'').length,namemaxChars:100,usernametext:fetchusername,usernamecharCount:(fetchusername||'').length,usernamemaxChars:100,biotext:bio,biocharCount:(bio||'').length,biomaxChars:150,linktext:website,linkcharCount:(website||'').length,linkmaxChars:100,profile_message:null,profile_message_show:false,creator_name_msg:null,creator_phone_number_msg:null,creator_state_msg:null,creator_isCreator:isCreator,phonevalue:creator_phonenumber,creator_profile_message:null,creator_name:creator_name,address1:address1,address2:address2,states:states,zipcode:zipcode,paypal_email:paypal_email,username_exist_message:null};_this.handleProfileSubmit=_this.handleProfileSubmit.bind(_this);_this.handleProfilePic=_this.handleProfilePic.bind(_this);_this.handleProfileSet=_this.handleProfileSet.bind(_this);_this.handleLogout=_this.handleLogout.bind(_this);_this.handleNameTextChange=_this.handleNameTextChange.bind(_this);_this.handleUserNameTextChange=_this.handleUserNameTextChange.bind(_this);_this.handleBioTextChange=_this.handleBioTextChange.bind(_this);_this.handleLinkTextChange=_this.handleLinkTextChange.bind(_this);_this.handleProfileCreatorSubmit=_this.handleProfileCreatorSubmit.bind(_this);_this.onPhoneChange=_this.onPhoneChange.bind(_this);_this.handleCreatorNameTextChange=_this.handleCreatorNameTextChange.bind(_this);_this.handleCreatorPhoneTextChange=_this.handleCreatorPhoneTextChange.bind(_this);_this.handleCreatorAddress1TextChange=_this.handleCreatorAddress1TextChange.bind(_this);_this.handleCreatorAddress2TextChange=_this.handleCreatorAddress2TextChange.bind(_this);_this.handleCreatorCityTextChange=_this.handleCreatorCityTextChange.bind(_this);_this.handleCreatorStateTextChange=_this.handleCreatorStateTextChange.bind(_this);_this.handleCreatorZipcodeTextChange=_this.handleCreatorZipcodeTextChange.bind(_this);_this.handleCreatorPaypalTextChange=_this.handleCreatorPaypalTextChange.bind(_this);_this.handleCreatorIsCreatorTextChange=_this.handleCreatorPaypalTextChange.bind(_this);return _this;}_createClass(Editprofile,[{key:'handleProfileCreatorSubmit',value:function handleProfileCreatorSubmit(event){event.preventDefault();var self=this;var forms=document.forms.new_profile_creator_form;var creator_name=forms.creator_name.value;var creator_phone_number=forms.creator_phone_number.value;var address1=forms.creator_address1.value;var address2=forms.creator_address2.value;var city=forms.creator_city.value;var creator_state=forms.creator_state.value;var zipcode=forms.creator_zipcode.value;var paypal_email=forms.creator_paypal_email.value;var isCreator=0;var creator_isCreator=this.state.creator_isCreator;console.log(creator_isCreator+'ddd');if(creator_name===''){self.setState({creator_name_msg:"Please enter name!"});}if(creator_phone_number===''){self.setState({creator_phone_number_msg:"Please enter phone number!"});}if(creator_state===''){self.setState({creator_state_msg:"Please select state!"});}if(creator_isCreator===true||creator_isCreator===1){isCreator=1;}console.log(isCreator+'creator_isCreator');if(creator_state!==''&&creator_name!==''&&creator_phone_number!==''){var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){currentUser.set("isCreator",isCreator);currentUser.set('creator_name',creator_name);currentUser.set('creator_phonenumber',creator_phone_number);currentUser.set('address1',address1);currentUser.set('address2',address2);currentUser.set('city',city);currentUser.set('state',creator_state);currentUser.set('zipcode',zipcode);currentUser.set('paypal_email',paypal_email);var self=this;currentUser.save().then(function(updatedUser){self.setState({creator_profile_message:'Creator profile updated successfully'});setTimeout(function(){self.setState({creator_profile_message:null});},3000);}).catch(function(error){});}}setTimeout(function(){self.setState({creator_name_msg:null});self.setState({creator_phone_number_msg:null});self.setState({creator_state_msg:null});},3000);}},{key:'handleProfileSubmit',value:function handleProfileSubmit(event){event.preventDefault();var forms=document.forms.new_profile_form;var name=forms.name.value;//var email=forms.email.value;
var username=forms.username.value;var bio=forms.bio.value;var website=forms.website.value;/*var city=forms.city.value;
     var instagram=forms.instagram.value;
     var tiktok=forms.tiktok.value;
     var youtube=forms.youtube.value;*/var fullname=name.split(/(?<=^\S+)\s/);//name.split(" ");
var firstName='';var lastName='';if(fullname[0]==undefined){firstName='';}else{firstName=fullname[0];}if(fullname[1]==undefined){lastName='';}else{lastName=fullname[1];}//const profilePicture = new Parse.File("profilePicture.jpg", newProfilePictureFile);
var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var self=this;var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('_User');query.include("displayUsername");query.include("username");query.equalTo("displayUsername",username);query.notEqualTo('objectId',currentUser.id);query.first().then(function(result){if(result){console.log(result);self.setState({username_exist_message:'Username already exist!'});setTimeout(function(){self.setState({username_exist_message:null});},3000);}else{//Update profile data
//currentUser.set('name', name);
currentUser.set('name',name);currentUser.set('bio',bio);currentUser.set('website',website);//currentUser.set('city', city);
//currentUser.set('username', username);
//currentUser.set('email', email);
//currentUser.set('instagram', instagram);
//currentUser.set('tiktok', tiktok);
//currentUser.set('youtube', youtube);
currentUser.set("displayName",name);currentUser.set("displayUsername",username);currentUser.set("isCreator",0);currentUser.set("firstName",firstName);currentUser.set("lastName",lastName);currentUser.set("veganSince",'');//currentUser.set("isAdmin",  '0');
currentUser.set("recipeRate",'$0');currentUser.set("videoRate",'');//currentUser.set("isBusiness", 0);
//Save changes
currentUser.save().then(function(updatedUser){self.setState({profile_message_show:true});self.setState({profile_message:'User profile updated successfully'});setTimeout(function(){self.setState({profile_message_show:false});self.setState({profile_message:null});self.setState({username_exist_message:null});},3000);}).catch(function(error){});}});}else{//console.error('No user is currently logged in.');
}}},{key:'render',value:function render(){var _this2=this;var fetchUsername=this.state.username;///var fetchEmail = this.state.email;
var fetchName=this.state.name;var fetchBio=this.state.bio;var fetchWebsite=this.state.website;/* var fetchCity = this.state.city;
        var fetchInstagram = this.state.instagram;
        var fetchTiktok = this.state.tiktok;
        var fetchYoutube = this.state.youtube;*/var fetchProfile_picture=this.state.profile_picture;var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();fetchUsername=currentUser.get('displayUsername');//currentUser.get("username");
var profile_pictures=currentUser.get("profilePictureMedium");if(profile_pictures){profile_pictures=profile_pictures._url;}else{}var result=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('section',{className:'post_list profile-edit'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('nav',{className:'sidebar'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'border-0 nav flex-column nav-tabs',id:'myTab',role:'tablist'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'back-page'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript: window.history.back()'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/back_top.svg',alt:'Back to Top'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'sidebar-item'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:'editprfl-tab',className:'active','data-toggle':'tab',href:'#editprfl',type:'button',role:'tab','aria-controls':'editprfl','aria-selected':'true'},'Edit Profile')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'sidebar-item'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:'cretaccunt-tab','data-toggle':'tab',href:'#cretaccunt',type:'button',role:'tab','aria-controls':'cretaccunt','aria-selected':'false'},'Creator Account')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('main',{className:'listing profilefrm'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tab-content',id:'myTabContent'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tab-pane edit-prf-tab fade show active ',id:'editprfl',role:'tabpanel','aria-labelledby':'editprfl-tab'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form_grp form-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'profile_message_alert'},this.state.profile_message),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'profile_message_alert_red'},this.state.username_exist_message),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:'form-signup form_mn',id:'new_profile_form',onSubmit:this.handleProfileSubmit},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_wrapper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'heading'},'Edit Profile'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Information you add here will be visible on your public profile.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'top-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'thumbnail'},fetchProfile_picture!=""?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{height:'150',width:'150',id:'profilePicturePreview',src:fetchProfile_picture,alt:'Profile Picture'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{height:'150',width:'150',id:'profilePicturePreview',src:'/images/default_userpic0.png',alt:'Profile Picture'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_userinformation'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usrtxt'},this.state.usernametext),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'nametxt'},this.state.nametext)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'file-upld'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'profilePic'},'Change photo '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{id:'profilePic',accept:'.jpg, .jpeg, .png',type:'file',onChange:this.handleProfilePic}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_grp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',placeholder:'',size:'large',name:'name',value:this.state.nametext,onChange:this.handleNameTextChange,defaultValue:fetchName,className:'form-control'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_grp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Username'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',placeholder:'',size:'large',name:'username',defaultValue:fetchUsername,className:'form-control',value:this.state.usernametext,onChange:this.handleUserNameTextChange,required:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_grp bio_frm_grp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Bio'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{placeholder:'',size:'large',defaultValue:fetchBio,value:this.state.biotext,onChange:this.handleBioTextChange,name:'bio',rows:'3',className:'form-control'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_grp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Website'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'url',placeholder:'',size:'large',value:this.state.linktext,onChange:this.handleLinkTextChange,name:'website',defaultValue:fetchWebsite,className:'form-control'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action cta_btn d-flex flex-row flex-wrap align-items-center justify-content-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fourth-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/',title:'Cancel'},'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'third-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'primary',className:'form_button',color:'#208AEC',size:'large'},'Save '))))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tab-pane crat-acnt-tab fade',id:'cretaccunt',role:'tabpanel','aria-labelledby':'cretaccunt-tab'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form_grp form-part create-account'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'profile_message_alert'},this.state.creator_profile_message),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:'form-signup form_mn',id:'new_profile_creator_form',onSubmit:this.handleProfileCreatorSubmit},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_wrapper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'heading'},'Creator Account'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Creators on Joel\'s Kitchen have the opportunity to collaborate with brands on paid campaigns and generate income. To begin, please provide the information below.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'switch-crt-acnt'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'switch'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',value:'1',id:'creator_isCreator',name:'creator_isCreator',checked:this.state.creator_isCreator,onClick:function onClick(){return _this2.setState({creator_isCreator:!_this2.state.creator_isCreator});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'slider round'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'switch-lbl'},'Switch to a Creator Account'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:'frm-tlt'},'Contact Information'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_grp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',name:'creator_name',id:'creator_name',className:'form-control',defaultValue:this.state.creator_name,value:this.state.creator_name,onChange:this.handleCreatorNameTextChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'profile_message_alert'},this.state.creator_name_msg))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_grp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Phone number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{name:'creator_phone_number',id:'creator_phone_number',onChange:this.onPhoneChange,defaultValue:this.state.phonevalue,value:this.state.phonevalue,className:'form-control'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'profile_message_alert'},this.state.creator_phone_number_msg)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:'frm-tlt'},'Address'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'If you want to collect brand samples, please include your mailing address.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_grp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Street address 1'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleCreatorAddress1TextChange,defaultValue:this.state.address1,value:this.state.address1,name:'creator_address1',id:'creator_address1',className:'form-control'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_grp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Street address 2'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleCreatorAddress2TextChange,defaultValue:this.state.address2,value:this.state.address2,name:'creator_address2',id:'creator_address2',className:'form-control'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_grp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'City'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',name:'creator_city',id:'creator_city',onChange:this.handleCreatorCityTextChange,defaultValue:this.state.city,value:this.state.city,className:'form-control'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_grp frm_grp_stat'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'State'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{onChange:this.handleCreatorStateTextChange,defaultValue:this.state.states,className:'creator_state',id:'creator_state'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:''}),allOptions.map(function(option){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:option,value:option,'data-id':_this2.state.state},option);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'profile_message_alert'},this.state.creator_state_msg))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_grp frm_grp_zip'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Zip Code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleCreatorZipcodeTextChange,defaultValue:this.state.zipcode,value:this.state.zipcode,name:'creator_zipcode',id:'creator_zipcode',className:'form-control'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:'frm-tlt'},'Payments'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'In order to collect your payments, connect your PayPal account. ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/info-icon.svg',alt:'Info Icon'}),' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm-part_inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'lft-img'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/paypal_icon.png',alt:'Paypal'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'rght-inpt'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_grp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Email address'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm_wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'email',onChange:this.handleCreatorPaypalTextChange,defaultValue:this.state.paypal_email,value:this.state.paypal_email,name:'creator_paypal_email',id:'creator_paypal_email',className:'form-control'})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm-part justify-content-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action cta_btn d-flex flex-row flex-wrap align-items-center justify-content-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fourth-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript: window.history.back()',title:'Cancel'},'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'third-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'primary',className:'form_button',size:'large'},'Save '))))))))))))));return result;}}]);return Editprofile;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this3=this;this.handleCreatorNameTextChange=function(event){var newText=event.target.value;_this3.setState({creator_name:newText});};this.handleCreatorPhoneTextChange=function(event){var newText=event.target.value;_this3.setState({phonevalue:newText});};this.handleCreatorAddress1TextChange=function(event){var newText=event.target.value;_this3.setState({address1:newText});};this.handleCreatorIsCreatorTextChange=function(event){var newText=event.target.value;_this3.setState({//isCreator: newText
});};this.handleCreatorPaypalTextChange=function(event){var newText=event.target.value;_this3.setState({paypal_email:newText});};this.handleCreatorZipcodeTextChange=function(event){var newText=event.target.value;_this3.setState({zipcode:newText});};this.handleCreatorAddress2TextChange=function(event){var newText=event.target.value;_this3.setState({address2:newText});};this.handleCreatorCityTextChange=function(event){var newText=event.target.value;_this3.setState({city:newText});};this.handleCreatorStateTextChange=function(event){var newText=event.target.value;_this3.setState({states:newText});};this.onPhoneChange=function(e){var re=/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i;if(e.target.value===''||re.test(e.target.value)){this.setState({phonevalue:e.target.value});}};this.handleLogout=function(e){Object(__WEBPACK_IMPORTED_MODULE_4__common__["a" /* commonLogoutFunction */])();};this.handleProfileSet=function(e){var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var profile_picture=currentUser.get("profilePictureMedium");if(profile_picture){__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#profilePicturePreview").attr("style","display: block");}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#profilePicturePreview").attr("style","display: none");}};this.handleProfilePic=function(e){var file=e.target.files[0];var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser&&file){var reader=new FileReader();var profilePicturePreview=document.getElementById('profilePicturePreview');reader.readAsDataURL(file);reader.onloadend=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var base64,profilePictureFile,self;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:base64=reader.result.split(',')[1];// Extract base64 data
profilePictureFile=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.File("profilePicture.jpg",{base64:base64});// Save the file to Parse
currentUser.set('profilePictureMedium',profilePictureFile);currentUser.set('profilePictureSmall',profilePictureFile);self=_this3;_context.prev=5;_context.next=8;return currentUser.save();case 8:// Show preview
profilePicturePreview.style="display: block";profilePicturePreview.src=profilePictureFile.url();self.setState({profile_message_show:true});self.setState({profile_message:'User profile picture updated'});setTimeout(function(){self.setState({profile_message_show:false});self.setState({profile_message:null});self.setState({username_exist_message:null});},3000);_this3.handleProfileSet();_context.next=19;break;case 16:_context.prev=16;_context.t0=_context['catch'](5);console.error("File upload failed:",_context.t0);case 19:case'end':return _context.stop();}}},_callee,_this3,[[5,16]]);}));}};this.handleProfilePic1=function(e){/*  const profilePicturePreview = document.getElementById('profilePicturePreview');        
        const currentUser = Parse.User.current();
        var filedata=e.target.files[0];   
        if (currentUser && filedata) {   
        var profilePictureFile = new Parse.File("profilePicture.jpg", filedata);
        currentUser.set('profilePictureMedium', profilePictureFile);
        currentUser.set('profilePictureSmall', profilePictureFile);
        var self = this;   
            currentUser.save().then((updatedUser) => {
                profilePicturePreview.style = "display: block";
                profilePicturePreview.src = profilePictureFile.url(); 
           
              self.setState({profile_message_show:true}); 
              self.setState({profile_message:'User profile picture updated'}); 
              setTimeout(() => {
                  self.setState({profile_message_show:false});  
                  self.setState({profile_message:null}); 
                  self.setState({username_exist_message:null}); 
              }, 3000);
                this.handleProfileSet();   
            }).catch((error) => {
            });
        } */};this.handleUserNameTextChange=function(event){var fetchusername=void 0;var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();/*if(event.target.value=='')
    {
       fetchusername= currentUser.get('displayUsername');//currentUser.get('username');
    }else
    {
        fetchusername=event.target.value;
    }*/// $(this).val($(this).val().toLowerCase());
fetchusername=event.target.value.toLowerCase().replace(/\s/g,'');var newText=fetchusername;//event.target.value;
if(newText.length<=_this3.state.usernamemaxChars){_this3.setState({usernametext:newText,usernamecharCount:newText.length});}};this.handleNameTextChange=function(event){var newText=event.target.value;if(newText.length<=_this3.state.namemaxChars){_this3.setState({nametext:newText,namecharCount:newText.length});}};this.handleBioTextChange=function(event){var newText=event.target.value;if(newText.length<=_this3.state.biomaxChars){_this3.setState({biotext:newText});}};this.handleBioTextChange=function(event){var newText=event.target.value;if(newText.length<=_this3.state.biomaxChars){_this3.setState({biotext:newText,biocharCount:newText.length});}};this.handleLinkTextChange=function(event){var newText=event.target.value;if(newText.length<=_this3.state.linkmaxChars){_this3.setState({linktext:newText,linkcharCount:newText.length});}};};/* harmony default export */ __webpack_exports__["a"] = (Editprofile);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Notfound=function Notfound(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"Not found");};/* harmony default export */ __webpack_exports__["a"] = (Notfound);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var AppStore=function AppStore(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("center",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"To go deeper, download the ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://itunes.apple.com/us/app/joels-kitchen/id1151259671?mt=8"},"Joel's Kitchen app"),"!"));};/* harmony default export */ __webpack_exports__["a"] = (AppStore);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__creatorlist_css__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__creatorlist_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__creatorlist_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreatorList=function(_React$Component){_inherits(CreatorList,_React$Component);function CreatorList(props){_classCallCheck(this,CreatorList);var _this=_possibleConstructorReturn(this,(CreatorList.__proto__||Object.getPrototypeOf(CreatorList)).call(this,props));_this.state={creators:{},globalStatsArray:{},width:0,height:0};_this.getCreators=_this.getCreators.bind(_this);_this.getCreatorsAux=_this.getCreatorsAux.bind(_this);_this.isUserInCD=_this.isUserInCD.bind(_this);_this.getCreatorsAux();global.productList=_this;_this.updateWindowDimensions=_this.updateWindowDimensions.bind(_this);var query=new __WEBPACK_IMPORTED_MODULE_0_parse___default.a.Query('GlobalStats');//query.equalTo("id", "tRYoc3dDiZ");
var self=_this;console.log("GLOBALSTATS");query.find().then(function(result){if(result){self.setState({globalStats:result[0]});console.log("GLOBALSTATS<><>:");console.log(result);console.log(this.state.globalStats.get("showInCreatorDirectory"));// If result was defined, the object with this objectID was found
//promise.resolve(result);
}else{console.log("No GLOBALSTATS found");// promise.resolve(null);
}},function(error){console.error("Error searching for GLOBALSTATS  Error: "+error);//promise.error(error);
});return _this;}_createClass(CreatorList,[{key:'componentDidMount',value:function componentDidMount(){this.updateWindowDimensions();window.addEventListener('resize',this.updateWindowDimensions);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.updateWindowDimensions);}},{key:'updateWindowDimensions',value:function updateWindowDimensions(){this.setState({width:window.innerWidth,height:window.innerHeight});}},{key:'isUserInCD',value:function isUserInCD(user){/*
        var un = user.get("username");
        console.log("Checking user in CD " + un);
        var list = this.state.globalStats.get("showInCreatorDirectory");
        return ((list != undefined) && list.includes(un));
        */var userStats=user.get("userStats");if(!userStats)return false;var cdState=userStats.get("showInCreatorDirectory");if(cdState)return true;return false;}},{key:'getCreatorsAux',value:function getCreatorsAux(){console.log('Getting Creators for current user');var isAdmin=false;if(__WEBPACK_IMPORTED_MODULE_0_parse___default.a.User.current())isAdmin=__WEBPACK_IMPORTED_MODULE_0_parse___default.a.User.current().get("isAdmin");var query=new __WEBPACK_IMPORTED_MODULE_0_parse___default.a.Query('_User');//TEMP -- see all Products
//if (!isAdmin)
//    query.equalTo("user", Parse.User.current());
//query.ascending("name");
query.limit(500);query.equalTo("isCreator",1);query.include("profilePictureSmall");query.include("displayName");query.include("recipeRate");query.include("videoRate");query.include("photoRate");query.include("instagram");query.include("facebook");query.include("pinterest");query.include("tiktok");query.include("youtube");query.include("website");query.include("name");query.include("userStats");query.include("instaFollowers");query.include("instaFollowersChange");query.ascending("displayUsername");var self=this;query.find().then(function(result){if(result){console.log(result);var filteredCreators=[];for(var i=0;i<result.length;i++){var user=result[i];if(self.isUserInCD(user))//only add users set to show in CD
{filteredCreators.push(user);console.log("Added user");}}self.setState({creators:filteredCreators});// self.setState({creators: result});
//console.log(self.state.creators);
// If result was defined, the object with this objectID was found
//promise.resolve(result);
}else{console.log("No Creators found");// promise.resolve(null);
}},function(error){console.error("Error searching for Creators  Error: "+error);//promise.error(error);
});}},{key:'getCreators',value:function getCreators(event){event.preventDefault();this.getCreators();}},{key:'formatCount',value:function formatCount(count){if(!count||count==undefined)return"";if(count>1000000){var dig1=Math.floor(count/1000000);var dig2=Math.floor(count/100000)-dig1*10;if(dig2==0)return dig1+"m";return dig1+"."+dig2+"m";}else if(count>1000){var _dig=Math.floor(count/1000);var _dig2=Math.floor(count/100)-_dig*10;if(_dig2==0)return _dig+"k";return _dig+"."+_dig2+"k";}return count.toString().replace(/\B(?=(\d{3})+(?!\d))/g,",");}},{key:'formatCountNoAbbrev',value:function formatCountNoAbbrev(count){if(!count||count==undefined)return"";return count.toString().replace(/\B(?=(\d{3})+(?!\d))/g,",");}},{key:'formatRate',value:function formatRate(rate){if(!rate||rate==undefined)return"";if(rate.includes("$"))return rate;else return"$"+rate;}},{key:'formatSocialLink',value:function formatSocialLink(rate){if(!rate||rate==undefined)return"";if(rate.includes("$"))return rate;else return"$"+rate;}},{key:'socialLinkClass',value:function socialLinkClass(linkVal){if(linkVal&&linkVal!=undefined&&linkVal.length>1){return"sociallink";}else return"displayNone";}},{key:'formatWebsite',value:function formatWebsite(linkVal){if(!linkVal||linkVal==undefined)return"";if(linkVal.includes("http://")||linkVal.includes("https://")||linkVal.includes("Https://")||linkVal.includes("Http://"))return linkVal;else return"https://"+linkVal;}},{key:'formatFacebook',value:function formatFacebook(linkVal){if(!linkVal||linkVal==undefined)return"";linkVal=linkVal.replace("@","");linkVal=linkVal.replace("m.facebook.com","facebook.com");if(linkVal.includes("http://")||linkVal.includes("https://")||linkVal.includes("Https://")||linkVal.includes("Http://"))return linkVal;else if(linkVal.includes("facebook.com"))return"https://"+linkVal;else return"https://facebook.com/"+linkVal;}},{key:'formatPinterest',value:function formatPinterest(linkVal){if(!linkVal||linkVal==undefined)return"";linkVal=linkVal.replace("@","");if(linkVal.includes("http://")||linkVal.includes("https://")||linkVal.includes("Https://")||linkVal.includes("Http://"))return linkVal;else if(linkVal.includes("pinterest.com"))return"https://"+linkVal;else return"https://pinterest.com/"+linkVal;}},{key:'formatInstagram',value:function formatInstagram(linkVal){if(!linkVal||linkVal==undefined)return"";linkVal.replace("@","");if(linkVal.includes("http://")||linkVal.includes("https://")||linkVal.includes("Https://")||linkVal.includes("Http://"))return linkVal;else return"https://instagram.com/"+linkVal;}},{key:'renderFollowerCount',value:function renderFollowerCount(followerProps)//followerCount, followerChange, abbrev)
{var followerCount=followerProps.followerCount;var followerChange=followerProps.followerChange;var abbrev=followerProps.abbrev;if(followerCount==undefined)followerCount=0;if(followerChange==undefined)followerChange=0;var count=abbrev?this.formatCount(followerCount):this.formatCountNoAbbrev(followerCount);var countChangeClass=followerChange>=0?"followerChangeUp":"followerChangeDown";if(followerChange>=0)followerChange="+"+followerChange;var result=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,count,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:countChangeClass},'\xA0'));return result;}},{key:'renderSocial',value:function renderSocial(creator){var result=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,' ');var instagram=creator.get("instagram");var facebook=creator.get("facebook");var pinterest=creator.get("pinterest");var tiktok=creator.get("tiktok");var youtube=creator.get("youtube");var website=creator.get("website");result=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:this.socialLinkClass(instagram)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:this.formatInstagram(instagram)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'images/social/instagram.png',width:'32',height:'32',alt:'instagram'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:this.socialLinkClass(tiktok)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:this.formatWebsite(tiktok)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'images/social/tiktok.png',width:'32',height:'32',alt:'tiktok'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:this.socialLinkClass(youtube)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:this.formatWebsite(youtube)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'images/social/youtube.png',width:'32',height:'32',alt:'youtube'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:this.socialLinkClass(website)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:this.formatWebsite(website)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'images/social/website.png',width:'32',height:'32',alt:'website'}))));return result;}},{key:'render',value:function render(){//console.log("Rendering product list");
var result=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'});if(1){var creators=this.state.creators.length!==undefined?this.state.creators:[];//console.log("Products length " + products.length);
var self=this;// if (this.state.curProduct != null)
if(0){}else if(1){var lastUpdated=this.state.globalStats?this.state.globalStats.get("lastCreatorDirUpdate"):"";console.log("Render: globalstats are "+this.state.globalStats);if(this.state.width>1000){result=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container',key:'-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'joelSectionHeader',width:'100%'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Creator Directory')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'creatorDirLastUpdate'},'Last update was: ',lastUpdated),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'creatorTable'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Creator'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'images/social/joels.png',width:'32',height:'32',alt:'joels'}),'\xA0Post Rate'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'images/social/instagram.png',width:'32',height:'32',alt:'instagram'}),'\xA0Followers'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Social Links'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,creators.map(function(creator,i){//itemUser.fetch();
var itemUsername=creator.get("displayUsername");var followerProps={followerCount:creator.get("userStats")?creator.get("userStats").get("instaFollowers"):"",followerChange:creator.get("userStats")?creator.get("userStats").get("instaFollowersChange"):"",abbrev:false};{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:"https://www.joelskitchen.com/user/"+itemUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'creatorUsername'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'userProfileImageCreator',src:creator.get("profilePictureSmall").url(),alt:'userProfileImag'}),'\xA0 ',itemUsername))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,self.formatRate(creator.get("photoRate"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,self.formatRate(creator.get("recipeRate"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,self.renderFollowerCount(followerProps)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,self.renderSocial(creator)));/*
                                    return (
                                       <div className="productListEntry" key={i}> <a className="itemLink" onClick={() => self.selectProduct(product)} >{product.get("name")}</a> by {itemUsername}</div>
                                    );
                                    */}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'emailTeam'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'mailto:joel@joelskitchen.com'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'emailTeamEmail'},'Email'),'\xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'emailTeamSecondPart'},'for a full list of rates & analytics from Joel\'s Kitchen.'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)));}else//mobile
{result=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container',key:'-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'joelSectionHeader',width:'100%'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Creator Directory')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'creatorDirLastUpdate'},'Last update was: ',lastUpdated),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'creatorTable'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Creator'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'images/social/joels.png',width:'32',height:'32',alt:'joels'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'Post Rate'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'images/social/instagram.png',width:'32',height:'32',alt:'instagram'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'Followers'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,creators.map(function(creator,i){//itemUser.fetch();
var itemUsername=creator.get("displayUsername");var followerProps={followerCount:creator.get("userStats")?creator.get("userStats").get("instaFollowers"):"",followerChange:creator.get("userStats")?creator.get("userStats").get("instaFollowersChange"):"",abbrev:true};{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:"https://www.joelskitchen.com/user/"+itemUsername},itemUsername)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,self.formatRate(creator.get("photoRate"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,self.renderFollowerCount(followerProps)));/*
                                    return (
                                       <div className="productListEntry" key={i}> <a className="itemLink" onClick={() => self.selectProduct(product)} >{product.get("name")}</a> by {itemUsername}</div>
                                    );
                                    */}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'emailTeam'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'mailto:joel@joelskitchen.com'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'emailTeamEmail'},'Email')),'\xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'emailTeamSecondPart'},'for a full list of rates & analytics from Joel\'s Kitchen.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)));}}/*

                  { self.state.ingredTypes.map(function (ingredType, i) {
                        return (
                           <span key={i+100}><h4> {ingredType}  <a onClick={() => self.handleAdd(i)} >Add</a></h4></span>

                           { self.state.ingredArr[i].map(function (ingred, j) {
                                return (
                                   <span key={(i*j)+100}><h4> {ingred}  <a onClick={() => self.handleDelete(i,j))} >Delete</a></h4></span>
                                );
                            })}
                        );
                    })}
                    *//*
            result =  (
                 <div className="container" key="-1">
                 <h3>My Products</h3>
                 {buffer}
                 <span >Test<a onClick={this.selectProduct}>(selectProduct?)</a></span>
                 <br/>
                <form className="form-signup" onSubmit={this.handleNew}>
                    <button className="btn btn-lg btn-primary btn-block" type="submit">New Product</button>
                </form>
                <span><a onClick={this.selectProduct}>
                       TEST
                    </a></span>
             </div>
              );
              *//*
  <li>
                  <div className='view'>
                    <label>{product.title}</label>
                    <button className="destroy" onClick={this.deleteTodo.bind(null, todo)} />
                  </div>
                </li>

            result = (
                 <div className="container">
                 <h3>My Products</h3>
                 <br/>
                <form className="form-signup" onSubmit={this.handleNew}>
                    <br/><br/>
                    <button className="btn btn-lg btn-primary btn-block" type="submit">New Product</button>
                </form>
            </div>
            );


/*
            return (
               <span key={i+100}><h4> {ingredType}  <a onClick={() => self.handleAdd(i)} >Add</a></h4></span>

               { self.state.ingredArr[i].map(function (ingred, j) {
                    return (
                       <span key={(i*j)+100}><h4> {ingred}  <a onClick={() => self.handleDelete(i,j))} >Delete</a></h4></span>
                    );
                })}
            );*/}return result;/* 
                    <label className="checkbox">
                        <input type="checkbox" value="remember-me" onChange={this.handleRememberMeClick}/>
                        &nbsp; Remember me
                    </label>
                    */}}]);return CreatorList;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CreatorList);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(37)))

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__global_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__singlepost_jsx__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Leftsidebar_jsx__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Singlepostoverly from "./Singlepostoverly.jsx";
function time_ago(time){switch(typeof time==='undefined'?'undefined':_typeof(time)){case'number':break;case'string':time=+new Date(time);break;case'object':if(time.constructor===Date)time=time.getTime();break;default:time=+new Date();}var time_formats=[[60,'seconds',1],// 60
[120,'1 minute ago','1 minute from now'],// 60*2
[3600,'minutes',60],// 60*60, 60
[7200,'1 hour ago','1 hour from now'],// 60*60*2
[86400,'hours',3600],// 60*60*24, 60*60
[172800,'Yesterday','Tomorrow'],// 60*60*24*2
[604800,'days',86400],// 60*60*24*7, 60*60*24
[1209600,'Last week','Next week'],// 60*60*24*7*4*2
[2419200,'weeks',604800],// 60*60*24*7*4, 60*60*24*7
[4838400,'Last month','Next month'],// 60*60*24*7*4*2
[29030400,'months',2419200],// 60*60*24*7*4*12, 60*60*24*7*4
[58060800,'Last year','Next year'],// 60*60*24*7*4*12*2
[2903040000,'years',29030400],// 60*60*24*7*4*12*100, 60*60*24*7*4*12
[5806080000,'Last century','Next century'],// 60*60*24*7*4*12*100*2
[58060800000,'centuries',2903040000]// 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
];var seconds=(+new Date()-time)/1000,token='ago',list_choice=1;if(seconds==0){return'Just now';}if(seconds<0){seconds=Math.abs(seconds);token='from now';list_choice=2;}var i=0,format;while(format=time_formats[i++]){if(seconds<format[0]){if(typeof format[2]=='string')return format[list_choice];else return Math.floor(seconds/format[2])+' '+format[1]+' '+token;}}return time;}var HomeStream=function(_React$Component){_inherits(HomeStream,_React$Component);function HomeStream(props){_classCallCheck(this,HomeStream);var _this=_possibleConstructorReturn(this,(HomeStream.__proto__||Object.getPrototypeOf(HomeStream)).call(this,props));__WEBPACK_IMPORTED_MODULE_1_parse___default.a.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5","sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw");//PASTE HERE YOUR Back4App APPLICATION ID AND YOUR JavaScript KEY
__WEBPACK_IMPORTED_MODULE_1_parse___default.a.serverURL="https://parse.joelskitchen.com/parse";//Parse.serverURL = "https://parsetest.joelskitchen.com/parse";
var now=new Date();_this.state={posts:{},users:{},created_at:now.getTime()//loader:true,
};_this.queryForPostData();//this.getSuggestedUsers();
_this.homeFetch=_this.homeFetch.bind(_this);return _this;}_createClass(HomeStream,[{key:'homeFetch',value:function homeFetch(event){// setTimeout(() => {
this.queryForPostData();//  },500);
}},{key:'componentDidMount',value:function componentDidMount(){// Simulate a delay for loading
/* setTimeout(() => {
      this.setState({ loader: false });
    }, 6000);*/}},{key:'getSuggestedUsers',value:function getSuggestedUsers(){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('User');query.equalTo('isSuggested',1);query.include("username");query.descending('_created_at');var self=this;query.find().then(function(result){if(result){self.setState({users:result});}else{console.log("No user found");}},function(error){console.error("Error loading post Error: "+error);});}},{key:'queryForPostData',value:function queryForPostData(){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');/*
        var isAdmin = false;
        if (Parse.User.current())
            isAdmin = Parse.User.current().get("isAdmin");

       //TEMP -- see all recipes
        if (!isAdmin)
          */query.include("user");query.include("image");query.include("thumbnail");query.include("likeCountNew");query.include("saveCount");query.include("commentcount");query.include("_created_at");query.include("createdAt");query.exists("user");query.descending("createdAt");//query.containedIn('challengeStatus',["Active","Billed"]);
query.limit(100);var self=this;// self.setState({ loader: true });
query.find().then(function(result){if(result){self.setState({posts:result});// If result was defined, the object with this objectID was found
//promise.resolve(result);
}else{console.log("No post found");// promise.resolve(null);
}},function(error){console.error("Error loading post Error: "+error);//promise.error(error);
});}},{key:'renderUsers',value:function renderUsers(){/*let buffer = [];

        if (this.state.users)
        {
            for (var i = 0; i < this.state.users.length; i++)
            {
                var user = this.state.users[i];
                var profile_picture= user.get("profilePictureSmall").url();
                if(profile_picture!==undefined)
                {
                  profile_picture=profile_picture;
                }else
                {
                  profile_picture="/images/menu-account.svg";
                }
                buffer.push(
                   <li className='menu'  key={69*i}>
                        <a href={'/user/'+user.get("displayUsername")}  title={user.get("displayUsername")} className='media'>
                          <div className="media-left">

                            <img src={profile_picture} className='mr-2' width="40px" height="40px" alt="itsallgoodvegan"/>
                          </div>
                          <div className="media-body">
                            <h6 className="mt-0">{user.get("displayUsername")}</h6>
                            <span>{user.get("displayName")}</span>
                          </div>
                        </a>
                      </li>
                  
                );
            }
        }

        return (  <ul className='list_grp'>
                {buffer}
                </ul>
               
        );
*/}},{key:'renderPosts',value:function renderPosts(){//console.log("renderIngredients");
//return      <span key="66"><h4> ingredType  <a onClick={() => this.handleAdd(0)} >Add</a></h4></span>;
var buffer=[];var self=this;if(this.state.posts){for(var i=0;i<this.state.posts.length;i++){var post=this.state.posts[i];// if (ingredType != undefined)
buffer.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'card_box',key:69*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__singlepost_jsx__["a" /* default */],{postData:post})));//
//  
}}//const { loader } = this.state;
/*if (loader) {
      return <div>Loading...</div>; 
    }*/return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'list_group'},buffer,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{type:'hidden',id:'home_id',name:'home_id'}));}},{key:'render',value:function render(){var likesWord="likes";var savesWord="saves";var commentsWord="comments";if(this.state.likeCount==1)likesWord="like";if(this.state.saveCount==1)savesWord="save";if(this.state.commentCount==1)commentsWord="comment";return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('section',{className:'post_list'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('nav',{className:'sidebar'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Leftsidebar_jsx__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('main',{className:'listing sticky_app_btn'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'get-app cta_btn'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'secondary-btn btn-wrp sml-btn'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);',type:'button','data-toggle':'modal','data-target':'#kitchenQrModal',title:'Get app'},'Get app'))),this.renderPosts()))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{type:'hidden',id:'home_fetch',className:'cnlebtn',onClick:this.homeFetch}));}}]);return HomeStream;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* unused harmony default export */ var _unused_webpack_default_export = (HomeStream);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__challenge_css__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__challenge_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__challenge_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__saveNotification_jsx__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__saveNotificationall_jsx__ = __webpack_require__(322);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateChallenge=function(_Component){_inherits(CreateChallenge,_Component);function CreateChallenge(props){_classCallCheck(this,CreateChallenge);var _this=_possibleConstructorReturn(this,(CreateChallenge.__proto__||Object.getPrototypeOf(CreateChallenge)).call(this,props));_initialiseProps.call(_this);__WEBPACK_IMPORTED_MODULE_2_parse___default.a.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5","sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw");__WEBPACK_IMPORTED_MODULE_2_parse___default.a.serverURL="https://parse.joelskitchen.com/parse";//Parse.serverURL = "https://parsetest.joelskitchen.com/parse";
var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(!currentUser){window.location.href="/";}_this.state={parseFile_210:'',parseFile_640:'',challenge_title_msg:null,challenge_image_msg:null,challenge_caption_msg:null,more_creators:false,more_content:false,create_message:null,create_message_show:false,challenge_image_msg_size:false,lastjob_number:0,isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:'',isNotificationOpen1:false,post_Notification_Id1:'',post_Notification_Msg1:'',post_Notification_Comment1:''};_this.handleFileChange=_this.handleFileChange.bind(_this);_this.discardImage=_this.discardImage.bind(_this);_this.handleChallengeSubmit=_this.handleChallengeSubmit.bind(_this);_this.handleMoreCreators=_this.handleMoreCreators.bind(_this);_this.handleMoreContent=_this.handleMoreContent.bind(_this);_this.checkChallengeDiscard=_this.checkChallengeDiscard.bind(_this);_this.challengeCancel=_this.challengeCancel.bind(_this);var queryString=window.location.href;var challenge_id=queryString.split("/")[4];_this.checkChallengeAvailable(challenge_id);_this.challenge_id=challenge_id;_this.checkCancelBtn=_this.checkCancelBtn.bind(_this);_this.checkJobNumber();return _this;}_createClass(CreateChallenge,[{key:'checkJobNumber',value:function checkJobNumber(){var self=this;/*get last job number*/var ClassObject=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend('Photo');var queryjob=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query(ClassObject);// Sort by the field in descending order to get the latest entry
queryjob.descending('jobNumber');queryjob.limit(1);queryjob.find().then(function(queryrresult){if(queryrresult){self.setState({lastjob_number:queryrresult[0].get('jobNumber')+1});}});}},{key:'challengeCancel',value:function challengeCancel(event){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.createChallange__mn #challenge_cancel').trigger('click');}},{key:'checkCancelBtn',value:function checkCancelBtn(event){console.log('checkCancelBtn');window.location.href="/";}},{key:'checkChallengeDiscard',value:function checkChallengeDiscard(event){__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#photoUrlInput").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_210").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_210_img").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_640").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_640_img").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#challenge_title").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#challenge_caption").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#profilePicturePreview").parent(".img_view").attr("style","display: none");document.getElementById("profilePicturePreview").src="/images/defaultcamera.png";__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".content-wrap .file-input").attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".content-wrap .img_view").attr("style","display: none");this.setState({more_creators:false});this.setState({more_content:false});__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#more_creators").prop("checked",false);__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#more_content").prop("checked",false);window.history.back();}},{key:'handleMoreCreators',value:function handleMoreCreators(event){this.setState({more_creators:event.target.checked});}},{key:'handleMoreContent',value:function handleMoreContent(event){this.setState({more_content:event.target.checked});}//  toggleNotificationAll = async (photodata,msg,comment) => {
/*  toggleNotificationAll = (postid,msg,comment) => {   console.log('toggleNotification all'+postid);
      var self = this;
        self.setState(prevState => ({
          isNotificationOpen1: !prevState.isNotificationOpen1,
          post_Notification_Id1: postid,
          post_Notification_Msg1: msg,
          post_Notification_Comment1:comment  
        }));       
      };*/},{key:'checkChallengeAvailable',value:function checkChallengeAvailable(challenge_id){var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Photo');query.equalTo("objectId",challenge_id);var self=this;query.first().then(function(result){if(result){var image=result.get('image');var thumbnail=result.get('thumbnail');if(image){self.setState({dataurl_640_img:thumbnail});//thumbnail.url()
document.getElementById("profilePicturePreview").src=image.url();__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#profilePicturePreview").parent(".img_view").attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#discard_image').attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".content-wrap .file-input").attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".content-wrap .img_view").attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_640_img").val(thumbnail.url());}if(thumbnail){self.setState({dataurl_210_img:image});//image.url()
}}else{self.setState({dataurl_640_img:''});self.setState({dataurl_210_img:''});//window.location.href = "/business/challenges";
}});}},{key:'render',value:function render(){var isNotificationOpen=this.state.isNotificationOpen;var post_Notification_Ids=this.state.post_Notification_Id;var post_Notification_Msg=this.state.post_Notification_Msg;var post_Notification_Comment=this.state.post_Notification_Comment;var isNotificationOpen1=this.state.isNotificationOpen1;var post_Notification_Ids1=this.state.post_Notification_Id1;var post_Notification_Msg1=this.state.post_Notification_Msg1;var post_Notification_Comment1=this.state.post_Notification_Comment1;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,isNotificationOpen?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__saveNotification_jsx__["a" /* default */],{isOpen:isNotificationOpen,postNotificationid:post_Notification_Ids,postMsg:post_Notification_Msg,postPhotoid:post_Notification_Ids,postActivityComment:post_Notification_Comment}):"",isNotificationOpen1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__saveNotificationall_jsx__["a" /* default */],{isOpen:isNotificationOpen1,postNotificationid:post_Notification_Ids1,postMsg:post_Notification_Msg1,postPhotoid:post_Notification_Ids1,postActivityComment:post_Notification_Comment1}):"",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'createChallange__mn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:'frm_challenge',id:'frm_challenge',onSubmit:this.handleChallengeSubmit},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'wrapper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'top-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript: window.history.back()'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/back_top.svg',alt:'Back to Top'}),' '),' Add Challenge'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Create a challenge to reach more creators and build more content for your brand. '))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bottom-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inner_wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('aside',{className:'card-wrap preview-challenge'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Challenge Photo')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'file_upld'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'img_view',style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button',style:{display:"none"},onClick:this.discardImage,id:'discard_image',className:'edit_icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/img_edit.png',alt:'Photo edit'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{height:'',width:'250',id:'profilePicturePreview',src:'/images/defaultcamera.png',alt:'photo Picture'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'file-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'myFile'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'hidden',id:'photoUrlInput',name:'photoUrl'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'hidden',id:'dataurl_210',name:'dataurl_210'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'hidden',id:'dataurl_640',name:'dataurl_640'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'hidden',id:'dataurl_640_img',name:'dataurl_640_img'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'hidden',id:'dataurl_210_img',name:'dataurl_210_img'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/file_upload.svg',alt:'Joel\'s Kitchen'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Choose a file to upload.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'file',id:'myFile',onChange:this.handleFileChange,accept:'.jpg, .jpeg, .png',name:'filename'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'file-infor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'We recommend using high quality .jpg & .png files less than 20MB.')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'create_message_alert'},this.state.challenge_image_msg,this.state.create_message))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('aside',{className:'card-wrap  create-challenge'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Create Challenge ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',type:'button','data-toggle':'modal','data-target':'#createChallengeModal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/info-icon.svg',alt:'Info Icon'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-wrap frm-wrapper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm-grp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'frm-lbl'},'Title'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',placeholder:'Give your challenge a title.',name:'challenge_title',autoComplete:'off',className:'frm-cntrl',id:'challenge_title'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'create_message_alert'},this.state.challenge_title_msg)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm-grp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'frm-lbl'},'Creative Direction'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{autoComplete:'off',placeholder:'Create a fun and simple description to guide creators.',name:'challenge_caption',className:'frm-cntrl',id:'challenge_caption'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'create_message_alert'},this.state.challenge_caption_msg)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('aside',{className:'card-wrap goal_challenge'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'What is your goal? ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',type:'button','data-toggle':'modal','data-target':'#challengeGoalsModal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/info-icon.svg',alt:'Info Icon'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Choose a goal for your challenge.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-wrap frm-wrapper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{className:'form-check-input',type:'radio',value:'1',name:'more_creators_grp',id:'more_creators',onChange:this.onSiteChanged}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'more_creators'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'More Creators'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Get more creators for your brand'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{className:'form-check-inputs',type:'radio',value:'2',name:'more_creators_grp',id:'more_content',onChange:this.onSiteChanged}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'more_content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'More Content'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Get more content for your brand')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action_grp btn-group'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'cta_btn fourth-btn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button',className:'btn-canl',onClick:this.challengeCancel},'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'cta_btn third-btn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn-submt'},'Submit '))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chalng_info text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Challenges are reviewed within 24 hours. ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'By creating a challenge you agree to the ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0)'},'Challenge Rules.')))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{href:'javascript:void(0);',id:'challenge_submitted',type:'button','data-toggle':'modal','data-target':'#chnlgPostConfrModal',style:{display:"none"}},'submit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay createPostCloseModal chnlgPostConfrModal',id:'chnlgPostConfrModal','data-backdrop':'static','data-keyboard':'false',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'Thank you for submitting your challenge!'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Joel\u2019s Kitchen will contact you within 24 hours to discuss budget and payment. ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel',onClick:this.checkCancel,'data-dismiss':'modal','aria-label':'Close',title:'Cancel'},'Close'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{href:'javascript:void(0);',id:'challenge_cancel',type:'button','data-toggle':'modal','data-target':'#challengCloseModal',style:{display:"none"}},'submit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay createPostCloseModal',id:'challengCloseModal','data-backdrop':'static','data-keyboard':'false',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'Are you sure you want to leave?'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'If you exit, your challenge won\u2019t be saved.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn danger btn-post-discard','data-dismiss':'modal','aria-label':'Close',title:'Discard',onClick:this.checkChallengeDiscard},'Discard'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel',onClick:this.checkCancel,'data-dismiss':'modal','aria-label':'Close',title:'Cancel'},'Cancel'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{href:'javascript:void(0);',id:'large_challenge_image_btn',type:'button','data-toggle':'modal','data-target':'#large_challenge_image',style:{display:"none"}},'submit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay createPostCloseModal large_challenge_image',id:'large_challenge_image','data-backdrop':'static','data-keyboard':'false',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.state.challenge_image_msg_size)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel','data-dismiss':'modal','aria-label':'Close',title:'Close'},'Close')))))))));}}]);return CreateChallenge;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.toggleNotification=function(postid,msg,comment){console.log('toggleNotification'+postid);var self=_this2;self.setState(function(prevState){return{isNotificationOpen:!prevState.isNotificationOpen,post_Notification_Id:postid,post_Notification_Msg:msg,post_Notification_Comment:comment};});//self.setState({ post_Notification_Id: postid });        
};this.handleChallengeSubmit=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var forms,challenge_title,challenge_caption,dataurl_210,dataurl_640,dataurl_210_img,dataurl_640_img,more_creators_val,more_content_val,more_creators,more_content,self,currentUser,Photo,photo,_currentUser,jobNumber,parseFile_210,parseFile_640;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();forms=document.forms.frm_challenge;challenge_title=forms.challenge_title.value;challenge_caption=forms.challenge_caption.value;dataurl_210=forms.dataurl_210.value;dataurl_640=forms.dataurl_640.value;dataurl_210_img=forms.dataurl_210_img.value;dataurl_640_img=forms.dataurl_640_img.value;more_creators_val=_this2.state.more_creators;more_content_val=_this2.state.more_content;more_creators=0;more_content=0;self=_this2;if((dataurl_210===''||dataurl_210_img==='')&&_this2.state.dataurl_640_img===''){self.setState({challenge_image_msg:'Please upload image.'});}if(challenge_title===''){self.setState({challenge_title_msg:"Please write some challenge title!"});}if(challenge_caption===''){self.setState({challenge_caption_msg:"Please write some challenge caption!"});}if((dataurl_210_img!==''||_this2.state.dataurl_640_img!=='')&&challenge_title!==''&&challenge_caption!==''){/* if(more_creators_val===true)
          {
            more_creators=1;
          }
          if(more_content_val===true)
          {
            more_content=1;
          }*/if(more_creators_val==1){more_creators=1;more_content=0;}if(more_content_val==1){more_content=1;more_creators=0;}currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){//const parseFile_210 = new Parse.File('image.jpg', { base64: dataurl_210 });
//const parseFile_640 = new Parse.File('thumbnail.jpg', { base64: dataurl_640 });
Photo=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend('Photo');photo=new Photo();_currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();//let randomnumber=Math.floor(Math.random() * 900) + 100; 
dataurl_210=forms.dataurl_210.value;dataurl_640=forms.dataurl_640.value;jobNumber=_this2.state.lastjob_number?_this2.state.lastjob_number:1;if(_this2.state.dataurl_640_img!=''&&_this2.state.dataurl_210_img!=''&&dataurl_640==''){photo.set('image',_this2.state.dataurl_640_img);photo.set('thumbnail',_this2.state.dataurl_210_img);}if(dataurl_640!=''&&dataurl_210!=''){parseFile_210=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.File('image.jpg',{base64:dataurl_210});parseFile_640=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.File('thumbnail.jpg',{base64:dataurl_640});photo.set('image',parseFile_640);photo.set('thumbnail',parseFile_210);}//if(dataurl_640)
//{
// const parseFile_210 = new Parse.File('image.jpg', { base64: dataurl_210 });
//  const parseFile_640 = new Parse.File('thumbnail.jpg', { base64: dataurl_640 });
// const parseFile_210 = new Parse.File('image.jpg',  { base64: dataurl_210 });
// const parseFile_640 = new Parse.File('thumbnail.jpg',  { base64: dataurl_640 });
//  const parseFile_210 = new Parse.File('image.jpg', { base64: dataurl_210 });
// }         
//photo.set('image', dataurl_640);  
//photo.set('thumbnail', dataurl_640);
photo.set('nonMealPost',1);photo.set('prize',"");photo.set('user',_currentUser);photo.set('isChallenge',"1");photo.set('caption',challenge_caption);photo.set('fulltext',challenge_caption);photo.set('challengeTitle',challenge_title);photo.set('more_content',more_content);photo.set('more_creators',more_creators);photo.set('challengeStatus','Pending');photo.set('impr',0);photo.set('businessAccount',__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current().get("displayUsername"));photo.set('businessAccountUser',__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current());//photo.set('jobNumber', randomnumber);
photo.set('jobNumber',jobNumber);photo.save().then(function(photodata){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.createChallange__mn #challenge_submitted').trigger('click');setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#challenge_title").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#challenge_caption").val('');_this2.setState({more_creators:false});_this2.setState({more_content:false});__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#more_creators").prop("checked",false);__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#more_content").prop("checked",false);self.toggleNotification(photodata.id,'Thank you for submitting your challenge. It is currently pending review.','');self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});/*  self.toggleNotification(photodata.id,'created a challenge','');
                           self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});*/},500);}).catch(function(error){});}}setTimeout(function(){self.setState({challenge_image_msg:null});self.setState({challenge_title_msg:null});self.setState({challenge_caption_msg:null});},5000);case 18:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();this.discardImage=function(e){__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#photoUrlInput").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_210").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_210_img").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_640").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_640_img").val('');//$("#caption").val('');
this.setState({dataurl_640_img:''});this.setState({dataurl_210_img:''});__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#profilePicturePreview").parent(".img_view").attr("style","display: none");document.getElementById("profilePicturePreview").src="/images/defaultcamera.png";__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".content-wrap .file-input").attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".content-wrap .img_view").attr("style","display: none");};this.handleFileChange=function(event){var file=event.target.files[0];var self=_this2;if(file){var fileSizeInBytes=file.size;var fileSizeInKB=fileSizeInBytes/1024;var maxSizeInKB=20480;// 20MB
if(fileSizeInKB>maxSizeInKB){self.setState({create_message_show:true});self.setState({create_message:"File size exceeds the limit."});}else{var fileType=file.type;if(fileType==='image/jpeg'||fileType==='image/png'){var imageFile=event.target.files[0];var reader=new FileReader();reader.onload=function(e){var img=document.createElement("img");img.onload=function(event){var custom_width_640=640;var custom_width_210=210;if(custom_width_640){var canvas=document.createElement("canvas");var canvasResize=document.createElement('canvas');var ctxResize=canvasResize.getContext('2d');var maxWidth=1000;var maxHeight=1000;var aspectRatio=img.width/img.height;var newWidth=img.width;var newHeight=img.height;var newHeightCheck=0;var newWidthCheck=0;var newMessageCheck='';if(img.width>maxWidth){newWidth=maxWidth;newHeight=newWidth/aspectRatio;}if(newHeight>maxHeight){newHeight=maxHeight;newWidth=newHeight*aspectRatio;}// console.log('custom_width_640'+custom_width_640);
//   console.log(newHeight+'newHeight');
//   console.log(newWidth+'newWidth');
if(custom_width_640>newHeight||custom_width_640>newWidth){//console.log('custom_width_640'+custom_width_640);
//console.log('newHeight'+newHeight);
//console.log('newWidth'+newWidth);
if(custom_width_640>newHeight){newHeightCheck=newHeight;newMessageCheck="Please upload a larger size image. The height proportionally is "+parseInt(newHeight)+"px, it must be at least 640px";}if(custom_width_640>newWidth){newWidthCheck=newWidth;newMessageCheck="Please upload a larger size image. The  width proportionally is "+parseInt(newWidth)+"px, it must be at least 640px";}if(custom_width_640>newHeight&&custom_width_640>newWidth){newMessageCheck="Please upload a larger size image. The  width/height proportionally is "+parseInt(newWidth)+"px & "+parseInt(newHeight)+"px, it must be at least 640px";}//console.log(newHeightCheck+'newHeightCheck');
//console.log(newMessageCheck);
//console.log('less'); width is 570, it must be at least 640.
self.setState({challenge_image_msg_size:newMessageCheck});__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#profilePicturePreview").parent(".img_view").attr("style","display: none");document.getElementById("profilePicturePreview").src="/images/defaultcamera.png";__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#photoUrlInput").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_210").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_640").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_640_img").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_210_img").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#large_challenge_image_btn').trigger('click');}else{canvasResize.width=newWidth;canvasResize.height=newHeight;ctxResize.drawImage(img,0,0,img.width,img.height,0,0,newWidth,newHeight);var resizedDataURL=canvasResize.toDataURL('image/jpeg');var canvasCrop=document.createElement('canvas');var ctxCrop=canvasCrop.getContext('2d');var cropWidth=custom_width_640;var cropHeight=custom_width_640;canvasCrop.width=cropWidth;canvasCrop.height=cropHeight;var x=(newWidth-cropWidth)/2;var y=(newHeight-cropHeight)/2;ctxCrop.drawImage(canvasResize,x,y,cropWidth,cropHeight,0,0,cropWidth,cropHeight);var croppedDataURL=canvasCrop.toDataURL('image/jpeg');var dataurl_640=croppedDataURL;//new
if(custom_width_210){var canvas=document.createElement("canvas");var _canvasResize=document.createElement('canvas');var _ctxResize=_canvasResize.getContext('2d');var _maxWidth=500;var _maxHeight=500;var _aspectRatio=img.width/img.height;var _newWidth=img.width;var _newHeight=img.height;if(img.width>_maxWidth){_newWidth=_maxWidth;_newHeight=_newWidth/_aspectRatio;}if(_newHeight>_maxHeight){_newHeight=_maxHeight;_newWidth=_newHeight*_aspectRatio;}_canvasResize.width=_newWidth;_canvasResize.height=_newHeight;_ctxResize.drawImage(img,0,0,img.width,img.height,0,0,_newWidth,_newHeight);var _resizedDataURL=_canvasResize.toDataURL('image/jpeg');var _canvasCrop=document.createElement('canvas');var _ctxCrop=_canvasCrop.getContext('2d');var _cropWidth=custom_width_210;var _cropHeight=custom_width_210;_canvasCrop.width=_cropWidth;_canvasCrop.height=_cropHeight;var _x2=(_newWidth-_cropWidth)/2;var _y=(_newHeight-_cropHeight)/2;_ctxCrop.drawImage(_canvasResize,_x2,_y,_cropWidth,_cropHeight,0,0,_cropWidth,_cropHeight);var _croppedDataURL=_canvasCrop.toDataURL('image/jpeg');var dataurl_210=_croppedDataURL;/*new code 1*/}if(dataurl_640!==undefined||dataurl_210!==undefined){var dataurl_210s=document.getElementById('dataurl_210');dataurl_210s.value=dataurl_210;var dataurl_640s=document.getElementById('dataurl_640');dataurl_640s.value=dataurl_640;var parseFile_210=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.File('image.jpg',{base64:dataurl_210});var parseFile_640=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.File('thumbnail.jpg',{base64:dataurl_640});parseFile_640.save().then(function(savedFile){var dataurl_640_img=document.getElementById('dataurl_640_img');dataurl_640_img.value=savedFile.url();}).catch(function(error){console.error('Error saving file:',error);});parseFile_210.save().then(function(savedFile){var dataurl_210_img=document.getElementById('dataurl_210_img');dataurl_210_img.value=savedFile.url();}).catch(function(error){console.error('Error saving file:',error);});document.getElementById("profilePicturePreview").src=dataurl_640;__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#profilePicturePreview").parent(".img_view").attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#discard_image').attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".content-wrap .file-input").attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".content-wrap .img_view").attr("style","display: block");}//new
}}};img.src=e.target.result;};reader.readAsDataURL(imageFile);}else{self.setState({create_message_show:true});self.setState({create_message:'Unsupported file type.'});// You can display an error message or take other actions here
}}setTimeout(function(){self.setState({create_message_show:false});self.setState({create_message:null});self.setState({challenge_image_msg:null});},3000);}};this.onSiteChanged=function(e){if(e.currentTarget.value==1){_this2.setState({more_creators:1});_this2.setState({more_content:0});}if(e.currentTarget.value==2){_this2.setState({more_creators:0});_this2.setState({more_content:1});}};};/* harmony default export */ __webpack_exports__["a"] = (CreateChallenge);

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BATCH_SIZE=100;var saveNotificationall=function(_React$Component){_inherits(saveNotificationall,_React$Component);function saveNotificationall(props){_classCallCheck(this,saveNotificationall);var _this=_possibleConstructorReturn(this,(saveNotificationall.__proto__||Object.getPrototypeOf(saveNotificationall)).call(this,props));_initialiseProps.call(_this);_this.state={currentIndex:0,data:{},// Assuming data is an array of objects to be saved
batchSize:100,// Define the batch size for processing
isUploading:false,uploadProgress:0,isSaving:false,saveProgress:0,isMountedFlagdata:false,dataBuffer:[],isProcessing:false};_this.isMountedFlag=false;var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var postNotificationid=props.postNotificationid;var postPhotoid=props.postPhotoid;var postMsg=props.postMsg;var communityComment='';var comment='';//let currentIndex=0;
var postActivityComment=props.postActivityComment;console.log('all postPhotoid');console.log(postPhotoid);console.log(postMsg);if(currentUser){if(postMsg==='created a challenge'){_this.saveallnotification(postPhotoid,postMsg,'');// this.uploadData(postPhotoid,postMsg,'');
}}return _this;}_createClass(saveNotificationall,[{key:'componentDidMount',value:function componentDidMount(){console.log('componentDidMount');// this.isMountedFlag = true; // Component is mounted
this.state.isMountedFlagdata=true;var _loadStateFromLocalSt=this.loadStateFromLocalStorage(),buffer=_loadStateFromLocalSt.buffer,currentIndex=_loadStateFromLocalSt.currentIndex;this.setState({dataBuffer:buffer,currentIndex:currentIndex});console.log('componentDidMount buffer');console.log(buffer);console.log('currentIndex'+currentIndex);}},{key:'componentWillUnmount',value:function componentWillUnmount(){//  this.isMountedFlag = false; // Component is unmounted
this.state.isMountedFlagdata=false;}// saveStateToLocalStorage(buffer, currentIndex) {
/*saveStateToLocalStorage = (buffer, currentIndex) => { console.log('saveStateToLocalStorage');
console.log(buffer);
console.log(currentIndex);
  localStorage.setItem('dataBuffer', JSON.stringify(buffer));
  localStorage.setItem('currentIndex', currentIndex.toString());
}*/// Function to chunk data into smaller batches
// Function to save a single batch to Parse
},{key:'render',value:function render(){return'';}}]);return saveNotificationall;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this2=this;this.loadStateFromLocalStorage=function(){var buffer=localStorage.getItem('dataBuffer');var index=localStorage.getItem('currentIndex');return{buffer:buffer?JSON.parse(buffer):[],currentIndex:index?parseInt(index,10):0};};this.saveallnotification=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(photodata,msg,comment){var currentUser,self,userquery,communityComment,records,result,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,matchusername,NotificationN,notificationNew,thumbnail,_currentUser,currentUser_id,fromUserThumb,data,batchSize,chunks,i,success;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();console.log('toggleNotificationAll');console.log(photodata);self=_this2;userquery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('User');userquery.limit(999999999);userquery.notEqualTo("displayUsername",currentUser.get("displayUsername"));comment="created a challenge";communityComment=photodata.get('user').get("displayUsername")+"'s created a challenge";records=[];_context.prev=10;_context.next=13;return userquery.find();case 13:result=_context.sent;if(!result){_context.next=49;break;}/* notificationNew.set("_wperm", {
                                                  "*": {
                                                    "read": true,
                                                    "write": true 
                                                  }
                                                });
                                                 notificationNew.set("_rperm", {
                                                  "*": {
                                                   "read": true,
                                                    "write": true 
                                                  }
                                                });
                                                 notificationNew.set("_acl", {
                                                  "*": {
                                                    "read": true,
                                                    "write": true 
                                                  }
                                                });*//*var acl = new Parse.ACL();
                                                acl.setPublicReadAccess(true);
                                                acl.setPublicWriteAccess(true);
                                                acl.setWriteAccess(currentUser, true); 
                                                acl.setReadAccess(currentUser, true); 
                                                notificationNew.setACL(acl);*/_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context.prev=18;for(_iterator=result[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){matchusername=_step.value;NotificationN=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend("Notification");notificationNew=new NotificationN();notificationNew.set('viewed',0);thumbnail=photodata.get('thumbnail');_currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();currentUser_id=_currentUser.id;if(thumbnail!=undefined){notificationNew.set('thumbnail',thumbnail);}notificationNew.set('commentingUser',_currentUser);notificationNew.set('photo',photodata);notificationNew.set('communityComment',communityComment);notificationNew.set('comment',comment);notificationNew.set('index',0);notificationNew.set('challenge',1);notificationNew.set('notifiedUser',matchusername);fromUserThumb=matchusername.get('profilePictureSmall');if(fromUserThumb!=undefined){notificationNew.set('profilePictureSmall',fromUserThumb);}// await notificationNew.save();
records.push(notificationNew);}_context.next=26;break;case 22:_context.prev=22;_context.t0=_context['catch'](18);_didIteratorError=true;_iteratorError=_context.t0;case 26:_context.prev=26;_context.prev=27;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 29:_context.prev=29;if(!_didIteratorError){_context.next=32;break;}throw _iteratorError;case 32:return _context.finish(29);case 33:return _context.finish(26);case 34:data=records;batchSize=1000;chunks=_this2.chunkData(records,batchSize);i=0;case 38:if(!(i<chunks.length)){_context.next=48;break;}_context.next=41;return _this2.saveBatch(chunks[i]);case 41:success=_context.sent;console.log(success);if(!success){console.error('Failed to save batch '+(i+1));}//  if (this.isMountedFlag) {
if(_this2.state.isMountedFlagdata){console.log('isMountedFlagdata DD'+_this2.state.isMountedFlagdata);_this2.setState({saveProgress:(i+1)/chunks.length*1000});}case 45:i++;_context.next=38;break;case 48:// if (this.isMountedFlag) {
if(_this2.state.isMountedFlagdata){_this2.setState({isSaving:false});alert('Save complete!');}case 49:_context.next=54;break;case 51:_context.prev=51;_context.t1=_context['catch'](10);console.error('Error fetching data from Parse:',_context.t1);case 54:case'end':return _context.stop();}}},_callee,_this2,[[10,51],[18,22,26,34],[27,,29,33]]);}));return function(_x,_x2,_x3){return _ref.apply(this,arguments);};}();this.chunkData=function(data,batchSize){console.log('chunkData');var chunks=[];for(var i=0;i<data.length;i+=batchSize){chunks.push(data.slice(i,i+batchSize));}return chunks;};this.saveBatch=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(batch){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:try{//  await Parse.Object.saveAll(batch);
/*   this.setState(
        prevState => ({ currentIndex: prevState.currentIndex + BATCH_SIZE }),
        () => {
        
         localStorage.setItem('dataBuffer', JSON.stringify(batch));
         localStorage.setItem('currentIndex', this.state.currentIndex.toString());
          setTimeout(this.processInBackground, 5000); // Adjust delay as needed
        }
      );*/}catch(error){console.error('Error saving record:',error);}case 1:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x4){return _ref2.apply(this,arguments);};}();};/* harmony default export */ __webpack_exports__["a"] = (saveNotificationall);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__global_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Leftsidebar_jsx__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CommonPopup_jsx__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ExploreListing=function(_React$Component){_inherits(ExploreListing,_React$Component);function ExploreListing(props){_classCallCheck(this,ExploreListing);var _this=_possibleConstructorReturn(this,(ExploreListing.__proto__||Object.getPrototypeOf(ExploreListing)).call(this,props));__WEBPACK_IMPORTED_MODULE_1_parse___default.a.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5","sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw");__WEBPACK_IMPORTED_MODULE_1_parse___default.a.serverURL="https://parse.joelskitchen.com/parse";//Parse.serverURL = "https://parsetest.joelskitchen.com/parse";
var now=new Date();_this.state={challenges:{},users:{},posts:{},created_at:now.getTime(),isPopupOpen:false,post_common_id:''};_this.queryForChallengeData();_this.queryForPostsData();localStorage.setItem('storestreamtabValue','explore');localStorage.setItem('storestreampagepath','explore');return _this;}_createClass(ExploreListing,[{key:'queryForChallengeData',value:function queryForChallengeData(){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');query.equalTo('isChallenge',"1");// query.containedIn('challengeStatus',["Active","Billed"]);
query.containedIn('challengeStatus',["Active"]);query.include("user");query.include("image");query.include("thumbnail");query.include("_created_at");query.include("createdAt");query.exists("user");query.descending("createdAt");// query.limit(4);
var self=this;query.find().then(function(result){if(result){//console.log(result);
self.setState({challenges:result});}else{console.log("No challenge found");}},function(error){console.error("Error loading post Error: "+error);});}},{key:'queryForPostsData',value:function queryForPostsData(){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');query.include("user");query.include("image");query.include("thumbnail");query.include("_created_at");query.include("createdAt");query.doesNotExist("isChallenge");query.select("isChallengeWinner");query.select("isChallengeEntry");query.select("image");query.select("thumbnail");query.select("isRecipe");query.exists("user");query.descending("createdAt");var self=this;query.find().then(function(result){if(result){self.setState({posts:result});}else{console.log("No post found");}},function(error){console.error("Error loading post Error: "+error);});}},{key:'renderChallenges',value:function renderChallenges(){var _this2=this;var buffer=[];var bufferrecord=[];var bufferpost=[];var bufferpostrecord=[];var isPopupOpen=this.state.isPopupOpen;var postcommonid=this.state.post_common_id;var togglePopup=function togglePopup(postid){_this2.setState(function(prevState){return{isPopupOpen:!prevState.isPopupOpen};});_this2.setState({post_common_id:postid});};var streamid=function streamid(postid){localStorage.setItem('storestreamid',postid);};if(this.state.challenges){var activeclass='';for(var i=0;i<this.state.challenges.length;i++){var post=this.state.challenges[i];/*buffer.push(<div className='card_box' key={69*i}>
                    <div>{post.id}</div>
                   <SinglePost postData={post}/>
                </div>);*/activeclass=i===0?"carousel-item active":'carousel-item';buffer.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{'data-target':'#explr-lis-indicatr','data-slide-to':i,className:''+(i==0?'active':''),key:69*i}));bufferrecord.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'carousel-item '+(i==0?'active':''),key:69*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'listing-box'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:"/challenge/"+post.id,className:''},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'bg-img'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'d-block w-100',src:post.get("image")?post.get("image").url():'',alt:post.get('challengeTitle')?post.get('challengeTitle'):""})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'detail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h1',null,' ',post.get('challengeTitle')?post.get('challengeTitle'):""),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h2',null,post.get('prize')?"$"+post.get('prize').toString().replace(/,/g,"").replace(/\B(?=(\d{3})+(?!\d))/g,",")+" in prizes":""),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h3',null,post.get('businessAccount')?"Sponsored by "+post.get('businessAccount'):''))))));}}if(this.state.posts){var _loop=function _loop(){{/*href='javascript:void(0);' onClick={(e) => {togglePopup(postdata_id);}}*/}postdata=_this2.state.posts[i];var postdata_id=postdata.id;bufferpostrecord.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPost',key:i+100},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/stream',onClick:function onClick(e){streamid(postdata_id);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'chlng-icon'},postdata.get("isChallengeWinner")!==undefined&&postdata.get("isChallengeWinner")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'winner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/winner-icon-img.svg'})),postdata.get("isRecipe")!==undefined&&postdata.get("isRecipe")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'recipe'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/recipe-icon-img.svg'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{className:'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:postdata.get("image")?postdata.get("image").url():''})))));};for(var i=0;i<this.state.posts.length;i++){var postdata;_loop();}}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('main',{className:'listing explr-list'},' ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{id:'explr-lis-indicatr',className:'carousel slide','data-ride':'carousel'},' ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ol',{className:'carousel-indicators'},buffer,'  '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'carousel-inner'},bufferrecord),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{className:'carousel-control-prev',href:'#explr-lis-indicatr',role:'button','data-slide':'prev'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/sld-arrow.svg',alt:'Prev'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{className:'carousel-control-next',href:'#explr-lis-indicatr',role:'button','data-slide':'next'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/sld-arrow.svg',alt:'Next'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'explr_list_grid'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPostRow'},bufferpostrecord)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CommonPopup_jsx__["a" /* default */],{isOpen:isPopupOpen,onClose:function onClose(e){togglePopup(postcommonid);},postcommonid:postcommonid}))//}
;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('section',{className:'post_list'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('nav',{className:'sidebar'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Leftsidebar_jsx__["a" /* default */],null)),this.renderChallenges())));}}]);return ExploreListing;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ExploreListing);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__global_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Leftsidebar_jsx__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ExploreChallengeDetail=function(_React$Component){_inherits(ExploreChallengeDetail,_React$Component);function ExploreChallengeDetail(){_classCallCheck(this,ExploreChallengeDetail);return _possibleConstructorReturn(this,(ExploreChallengeDetail.__proto__||Object.getPrototypeOf(ExploreChallengeDetail)).apply(this,arguments));}_createClass(ExploreChallengeDetail,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('section',{className:'post_list'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('nav',{className:'sidebar'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Leftsidebar_jsx__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('main',{className:'listing explr-list '},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'explr_list_hreo'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'listing-box'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'bg-img'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'d-block w-100',src:'/images/default_userpic0.png',alt:'Soup for the Soul'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'detail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h1',null,'Soup for the Soul'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h2',null,'$1,000 in prizes'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h3',null,'Sponsored by joelskitchen'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'explr_cotent'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sin ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'#',title:'#soup'},'#soup')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'join_challange '},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'cta_btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/create-challenge',title:'Join Challenge'},'Join Challenge'))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'explr_list_grid'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{'class':'gridPostRow'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{'class':'gridPost'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/post/pasdunb4ED'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/a27945920eebce7bb8ea450e0cb5fa04_thumbnail.jpg'})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{'class':'gridPost'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/post/2EsYcZIBii'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6b4758a0861a27967ded810dca3000eb_thumbnail.jpg'})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{'class':'gridPost'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/post/WmL3QeLgGE'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg'})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{'class':'gridPost'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/post/2EsYcZIBii'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6b4758a0861a27967ded810dca3000eb_thumbnail.jpg'})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{'class':'gridPost'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/post/WmL3QeLgGE'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg'}))))))))));}}]);return ExploreChallengeDetail;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ExploreChallengeDetail);

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__global_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Leftsidebar_jsx__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CommonPopup_jsx__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__saveNotification_jsx__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChallengeDetail=function(_React$Component){_inherits(ChallengeDetail,_React$Component);function ChallengeDetail(props){_classCallCheck(this,ChallengeDetail);var _this=_possibleConstructorReturn(this,(ChallengeDetail.__proto__||Object.getPrototypeOf(ChallengeDetail)).call(this,props));_this.changeChallengeCaption=function(e){var forms=document.forms.new_challenge_form;var caption=forms.caption1.value;var dataurl_210=forms.dataurl_2101.value;if(caption!==''||dataurl_210!==''){__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#close_Postmodalwithdiscard1').attr("style","display: block");__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#close_Postmodal1').attr("style","display: none");}else{__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#close_Postmodalwithdiscard1').attr("style","display: none");__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#close_Postmodal1').attr("style","display: block");}};_this.toggleNotification=function(postid,msg,comment){var self=_this;self.setState(function(prevState){return{isNotificationOpen:!prevState.isNotificationOpen,post_Notification_Id:postid,post_Notification_Msg:msg,post_Notification_Comment:comment};});//self.setState({ post_Notification_Id: postid });        
};_this.checkChallengePostModal=function(e){var forms=document.forms.new_challenge_form;var caption=forms.caption1.value;var dataurl_210=forms.dataurl_210.value;if(caption!==''||dataurl_210!==''){__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#close_Postmodalwithdiscard1').attr("style","display: block");__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#close_Postmodal1').attr("style","display: none");if(__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#addChallengeModal.modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")){__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#addChallengeModal.modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");}}else{__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#close_Postmodalwithdiscard1').attr("style","display: none");__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#close_Postmodal1').attr("style","display: block");if(!__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#addChallengeModal.modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")){__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#addChallengeModal.modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");}}};_this.checkChallengeModal=function(e){var forms=document.forms.new_challenge_form;var caption=forms.caption1.value;var dataurl_210=forms.dataurl_2101.value;if(caption!==''||dataurl_210!==''){__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#addChallengeModal #close_Postmodalwithdiscard1').attr("style","display: block");__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#addChallengeModal #close_Postmodal1').attr("style","display: none");if(__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#addChallengeModal.modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")){__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#addChallengeModal.modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");}}else{__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#addChallengeModal #close_Postmodalwithdiscard1').attr("style","display: none");__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#addChallengeModal #close_Postmodal1').attr("style","display: block");if(!__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#addChallengeModal.modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")){__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#addChallengeModal.modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");}}};_this.handleChallengeFileChange=function(event){var file=event.target.files[0];var self=_this;if(file){var fileSizeInBytes=file.size;var fileSizeInKB=fileSizeInBytes/1024;var maxSizeInKB=20480;// 20MB
if(fileSizeInKB>maxSizeInKB){self.setState({create_message_show:true});self.setState({create_message:"File size exceeds the limit."});}else{var fileType=file.type;if(fileType==='image/jpeg'||fileType==='image/png'){var imageFile=event.target.files[0];var reader=new FileReader();reader.onload=function(e){var img=document.createElement("img");img.onload=function(event){var custom_width_640=640;var custom_width_210=210;if(custom_width_640){var canvas=document.createElement("canvas");var canvasResize=document.createElement('canvas');var ctxResize=canvasResize.getContext('2d');var maxWidth=1000;var maxHeight=1000;var aspectRatio=img.width/img.height;var newHeightCheck=0;var newWidthCheck=0;var newMessageCheck='';var newWidth=img.width;var newHeight=img.height;if(img.width>maxWidth){newWidth=maxWidth;newHeight=newWidth/aspectRatio;}if(newHeight>maxHeight){newHeight=maxHeight;newWidth=newHeight*aspectRatio;}if(custom_width_640>newHeight||custom_width_640>newWidth){//console.log('less');
if(custom_width_640>newHeight){newHeightCheck=newHeight;newMessageCheck="Please upload a larger size image. The height proportionally is "+parseInt(newHeight)+"px, it must be at least 640px";}if(custom_width_640>newWidth){newWidthCheck=newWidth;newMessageCheck="Please upload a larger size image. The  width proportionally is "+parseInt(newWidth)+"px, it must be at least 640px";}if(custom_width_640>newHeight&&custom_width_640>newWidth){newMessageCheck="Please upload a larger size image. The  width/height proportionally is "+parseInt(newWidth)+"px & "+parseInt(newHeight)+"px, it must be at least 640px";}self.setState({challenge_image_msg_size:newMessageCheck});//self.setState({photo_image_message:"Please upload large size image!"});  
__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#profilePicturePreview1").parent(".img_view1").attr("style","display: none");document.getElementById("profilePicturePreview1").src="/images/defaultcamera.png";__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#photoUrlInput1").val('');__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#dataurl_2101").val('');__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#dataurl_6401").val('');__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#dataurl_640_img1").val('');__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#dataurl_210_img1").val('');__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#large_challenge_image_btn1').trigger('click');}else{canvasResize.width=newWidth;canvasResize.height=newHeight;ctxResize.drawImage(img,0,0,img.width,img.height,0,0,newWidth,newHeight);var resizedDataURL=canvasResize.toDataURL('image/jpeg');var canvasCrop=document.createElement('canvas');var ctxCrop=canvasCrop.getContext('2d');var cropWidth=custom_width_640;var cropHeight=custom_width_640;canvasCrop.width=cropWidth;canvasCrop.height=cropHeight;var x=(newWidth-cropWidth)/2;var y=(newHeight-cropHeight)/2;ctxCrop.drawImage(canvasResize,x,y,cropWidth,cropHeight,0,0,cropWidth,cropHeight);var croppedDataURL=canvasCrop.toDataURL('image/jpeg');var dataurl_640=croppedDataURL;//new
if(custom_width_210){var canvas=document.createElement("canvas");var _canvasResize=document.createElement('canvas');var _ctxResize=_canvasResize.getContext('2d');var _maxWidth=500;var _maxHeight=500;var _aspectRatio=img.width/img.height;var _newWidth=img.width;var _newHeight=img.height;if(img.width>_maxWidth){_newWidth=_maxWidth;_newHeight=_newWidth/_aspectRatio;}if(_newHeight>_maxHeight){_newHeight=_maxHeight;_newWidth=_newHeight*_aspectRatio;}_canvasResize.width=_newWidth;_canvasResize.height=_newHeight;_ctxResize.drawImage(img,0,0,img.width,img.height,0,0,_newWidth,_newHeight);var _resizedDataURL=_canvasResize.toDataURL('image/jpeg');var _canvasCrop=document.createElement('canvas');var _ctxCrop=_canvasCrop.getContext('2d');var _cropWidth=custom_width_210;var _cropHeight=custom_width_210;_canvasCrop.width=_cropWidth;_canvasCrop.height=_cropHeight;var _x=(_newWidth-_cropWidth)/2;var _y=(_newHeight-_cropHeight)/2;_ctxCrop.drawImage(_canvasResize,_x,_y,_cropWidth,_cropHeight,0,0,_cropWidth,_cropHeight);var _croppedDataURL=_canvasCrop.toDataURL('image/jpeg');var dataurl_210=_croppedDataURL;/*new code 1*/}if(dataurl_640!==undefined||dataurl_210!==undefined){var dataurl_210s=document.getElementById('dataurl_2101');dataurl_210s.value=dataurl_210;var dataurl_640s=document.getElementById('dataurl_6401');dataurl_640s.value=dataurl_640;var parseFile_210=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.File('image.jpg',{base64:dataurl_210});var parseFile_640=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.File('thumbnail.jpg',{base64:dataurl_640});parseFile_640.save().then(function(savedFile){var dataurl_640_img=document.getElementById('dataurl_640_img1');dataurl_640_img.value=savedFile.url();}).catch(function(error){console.error('Error saving file:',error);});parseFile_210.save().then(function(savedFile){var dataurl_210_img=document.getElementById('dataurl_210_img1');dataurl_210_img.value=savedFile.url();}).catch(function(error){console.error('Error saving file:',error);});__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#profilePicturePreview1").parent(".img_view1").attr("style","display: block");document.getElementById("profilePicturePreview1").src=dataurl_640;}//new
}}};img.src=e.target.result;};reader.readAsDataURL(imageFile);}else{console.log('Unsupported file type.');self.setState({create_message_show:true});self.setState({create_message:'Unsupported file type.'});// You can display an error message or take other actions here
}__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#close_Postmodalwithdiscard1').attr("style","display: block");__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#close_Postmodal1').attr("style","display: none");/*if ($(".modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")) {
               $(".modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");
            }*/}setTimeout(function(){self.setState({create_message_show:false});self.setState({create_message:null});self.setState({photo_image_message:null});},3000);}};_this.checkChallengeDiscard=function(e){setTimeout(function(){__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#close_Postmodal1').trigger('click');__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#photoUrlInput1").val('');__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#dataurl_2101").val('');__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#dataurl_210_img1").val('');__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#dataurl_6401").val('');__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#dataurl_640_img1").val('');__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#caption1").val('');__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#profilePicturePreview1").parent(".img_view1").attr("style","display: none");document.getElementById("profilePicturePreview1").src="/images/defaultcamera.png";},500);__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#close_Postmodalwithdiscard1').attr("style","display: none");__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#close_Postmodal1').attr("style","display: block");if(!__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#addChallengeModal.modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")){__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#addChallengeModal.modal.fade.post_modal.createPostModal").addClass("post_modal_overlay");}};__WEBPACK_IMPORTED_MODULE_1_parse___default.a.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5","sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw");__WEBPACK_IMPORTED_MODULE_1_parse___default.a.serverURL="https://parse.joelskitchen.com/parse";//Parse.serverURL = "https://parsetest.joelskitchen.com/parse";
var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();/*if(!currentUser)
        {
            window.location.href = "/";
        }*/_this.state={challenge_image:null,challengeTitle:null,caption:null,challengeHashtag:null,prize:null,sponsor:null,entries:{},create_message:null,create_message_show:false,challenge_image_msg_size:false,challenge:{},isPopupOpen:false,post_common_id:'',challengeStatus:null,isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''};var queryString=window.location.href;var challenge_id=queryString.split("/")[4];_this.checkChallengeIsAvailable(challenge_id);_this.challenge_id=challenge_id;_this.checkChallengeEntries(challenge_id);_this.handleChallengeSubmit=_this.handleChallengeSubmit.bind(_this);_this.checkChallengeModal=_this.checkChallengeModal.bind(_this);_this.checkChallengePostModal=_this.checkChallengePostModal.bind(_this);_this.handleChallengeFileChange=_this.handleChallengeFileChange.bind(_this);_this.checkChallengeDiscard=_this.checkChallengeDiscard.bind(_this);_this.changeChallengeCaption=_this.changeChallengeCaption.bind(_this);localStorage.setItem('storestreamtabValue',_this.challenge_id);localStorage.setItem('storestreampagepath','challengedetail');return _this;}_createClass(ChallengeDetail,[{key:'handleChallengeSubmit',value:function handleChallengeSubmit(event){var _this2=this;event.preventDefault();var forms=document.forms.new_challenge_form;var caption=forms.caption1.value;var dataurl_210=forms.dataurl_2101.value;var dataurl_640=forms.dataurl_6401.value;var dataurl_210_img=forms.dataurl_210_img1.value;var dataurl_640_img=forms.dataurl_640_img1.value;var self=this;if(caption===''){self.setState({create_message:"Please write some caption first!"});}else if(dataurl_210===''||dataurl_210_img===''){self.setState({create_message:'Please upload image.'});}else{var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();if(currentUser){var parseFile_210=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.File('image.jpg',{base64:dataurl_210});var parseFile_640=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.File('thumbnail.jpg',{base64:dataurl_640});var Photo=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.Object.extend('Photo');var photo=new Photo();var _currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();photo.set('image',parseFile_640);photo.set('thumbnail',parseFile_210);photo.set('nonMealPost',1);photo.set('user',_currentUser);photo.set('caption',caption);photo.set('fulltext',caption);photo.set('isChallengeEntry',"1");photo.set('challenge',this.state.challenge);photo.set('impr',0);photo.save().then(function(photodata){/*this.toggleNotification(this.challenge_id,'joined a challenge','');
                       self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});   */_this2.checkChallengeDiscard();__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#challenge_entry_submitted').trigger('click');console.log('photodata.id'+photodata.id);self.toggleNotification(photodata.id,'posted to your challenge','');self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#caption1").val('');},3000);}).catch(function(error){console.log(error.message);});}else{}/* setTimeout(() => {
                       this.checkChallengeEntries(this.challenge_id);
                        },500);*/}setTimeout(function(){self.setState({create_message_show:false});self.setState({create_message:null});_this2.checkChallengeEntries(_this2.challenge_id);// this.toggleNotification(this.challenge_id,'posted to your challenge','');
// self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''}); 
},20000);}},{key:'checkChallengeEntries',value:function checkChallengeEntries(challenge_id){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');query.equalTo('isChallengeEntry',"1");query.equalTo('challenge',"Photo$"+this.challenge_id);query.select("isChallengeWinner");query.select("isChallengeEntry");query.select("hideEntry");query.select("image");query.select("thumbnail");query.select("isRecipe");query.include("user");query.include("image");query.include("thumbnail");query.exists("user");query.descending("createdAt");query.limit(100);var self=this;query.find().then(function(result){if(result){self.setState({entries:result});}});}},{key:'checkChallengeIsAvailable',value:function checkChallengeIsAvailable(challenge_id){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');query.equalTo("objectId",challenge_id);//query.containedIn('challengeStatus',["Active","Billed"]);
var self=this;query.first().then(function(result){if(result){console.log(result);var challengeTitle=result.get('challengeTitle');var caption=result.get('caption');var challengeHashtag=result.get('challengeHashtag');var image=result.get('image');var thumbnail=result.get('thumbnail');var prize=result.get('prize');var sponsor=result.get('businessAccount');var challengeStatus=result.get('challengeStatus');self.setState({challenge:result});if(challengeTitle){self.setState({challengeTitle:challengeTitle});}if(caption){self.setState({caption:caption});}if(challengeHashtag){self.setState({challengeHashtag:challengeHashtag});}if(prize){self.setState({prize:prize});}if(sponsor){self.setState({sponsor:sponsor});}if(image){//self.setState({challenge_image: thumbnail.url()});
self.setState({challenge_image:image.url()});}if(challengeStatus){self.setState({challengeStatus:challengeStatus});}}else{//window.location.href = "/explore";
}});}},{key:'renderEntries',value:function renderEntries(){var _this3=this;var entryrecord=[];var isPopupOpen=this.state.isPopupOpen;var postcommonid=this.state.post_common_id;var togglePopup=function togglePopup(postid){_this3.setState(function(prevState){return{isPopupOpen:!prevState.isPopupOpen};});_this3.setState({post_common_id:postid});};var streamid=function streamid(postid){localStorage.setItem('storestreamid',postid);};if(this.state.entries){var _loop=function _loop(){postdata=_this3.state.entries[i];var postdata_id=postdata.id;var hideEntry=postdata.get("hideEntry")?postdata.get("hideEntry"):'0';if(hideEntry==="0"){{/*href='javascript:void(0);' onClick={(e) => {togglePopup(postdata_id);}}*/}entryrecord.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{'class':'gridPost',key:69*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/stream',onClick:function onClick(e){streamid(postdata_id);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'chlng-icon'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'chlng-icon'},postdata.get("isChallengeWinner")!==undefined&&postdata.get("isChallengeWinner")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'winner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/winner-icon-img.svg'})),postdata.get("isRecipe")!==undefined&&postdata.get("isRecipe")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'recipe'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/recipe-icon-img.svg'})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:postdata.get("image")?postdata.get("image").url():''})))));}};for(var i=0;i<this.state.entries.length;i++){var postdata;_loop();}}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'explr_list_grid'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{'class':'gridPostRow'},entryrecord),'  ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CommonPopup_jsx__["a" /* default */],{isOpen:isPopupOpen,onClose:function onClose(e){togglePopup(postcommonid);},postcommonid:postcommonid}))//}
;}},{key:'render',value:function render(){var challenge_image=this.state.challenge_image;var challengeTitle=this.state.challengeTitle;var caption=this.state.caption;var challengeHashtag=this.state.challengeHashtag;var prize=this.state.prize;var sponsor=this.state.sponsor;var challengeStatus=this.state.challengeStatus;var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();var isNotificationOpen=this.state.isNotificationOpen;var post_Notification_Ids=this.state.post_Notification_Id;var post_Notification_Msg=this.state.post_Notification_Msg;var post_Notification_Comment=this.state.post_Notification_Comment;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('section',{className:'challenge_entry_popup post_list'},'    ',isNotificationOpen?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__saveNotification_jsx__["a" /* default */],{isOpen:isNotificationOpen,postNotificationid:post_Notification_Ids,postMsg:post_Notification_Msg,postPhotoid:post_Notification_Ids,postActivityComment:post_Notification_Comment}):"",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('nav',{className:'sidebar'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Leftsidebar_jsx__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('main',{className:'listing explr-list '},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'explr_list_hreo'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'listing-box'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'bg-img'},challenge_image!==null?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'d-block w-100',src:challenge_image,alt:challengeTitle}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'d-block w-100',src:'/images/emptygrid.png',alt:''})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'detail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h1',null,challengeTitle),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h2',null,prize?"$"+prize.toString().replace(/,/g,"").replace(/\B(?=(\d{3})+(?!\d))/g,",")+" in prizes":""),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h3',null,sponsor?"Sponsored by "+sponsor:""))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'explr_cotent'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,caption),challengeStatus==="Active"&&currentUser?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'join_challange '},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'cta_btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);',type:'button','data-toggle':'modal','data-target':'#createPostModalchallenge'},'Join Challenge'))):"",challengeStatus==="Active"&&!currentUser?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'join_challange '},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'cta_btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);',type:'button',disabled:true},'Join Challenge'))):"")),this.renderEntries()))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal fade post_modal createPostModal post_modal_overlay createPostModalchallenge',id:'createPostModalchallenge',tabIndex:'-1',role:'dialog','data-backdrop':'false','data-keyboard':'true','aria-labelledby':'createPostModalTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{'class':'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-dialog modal-lg modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('form',{id:'new_challenge_form',onSubmit:this.handleChallengeSubmit},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'top-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{type:'button',style:{display:"none"},onClick:this.checkPostModal,className:'close','data-toggle':'modal','data-target':'#createPostCloseModal1',id:'close_Postmodalwithdiscard1','aria-label':'Modal'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/close.svg',alt:'Close'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{type:'button',className:'close','data-dismiss':'modal',id:'close_Postmodal1','aria-label':'Modal',onClick:this.discardData},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/close.svg',alt:'Close'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5',{className:'modal-title'},'Challenge Entry'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'cta_btn third-btn'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'submit'},'Post'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'left-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label',{htmlFor:'myFile1'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'create_message_alert'},this.state.create_message,this.state.photo_image_message),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'file_upld'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'img_view1',style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{height:'',width:'250',id:'profilePicturePreview1',src:'/images/defaultcamera.png',alt:'photo Picture'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'file-input'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{type:'hidden',id:'photoUrlInput1',name:'photoUrl1'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{type:'hidden',id:'dataurl_2101',name:'dataurl_2101'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{type:'hidden',id:'dataurl_6401',name:'dataurl_6401'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{type:'hidden',id:'dataurl_640_img1',name:'dataurl_640_img1'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{type:'hidden',id:'dataurl_210_img1',name:'dataurl_210_img1'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/file_upload.svg',alt:'Joel\'s Kitchen'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,'Choose a file to upload.'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'file-infor'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label',null,'We recommend using high quality .jpg & .png files less than 20MB.'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{type:'file',id:'myFile1',accept:'.jpg, .jpeg, .png',name:'filename1',onChange:this.handleChallengeFileChange}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'right-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'post-comment'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('textarea',{name:'caption1',id:'caption1',onChange:this.changeChallengeCaption,rows:'10',placeholder:'Write a caption...'}))))))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay createPostCloseModal',id:'createPostCloseModal1','data-backdrop':'false','data-keyboard':'false',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h6',null,'Are you sure you want to leave?'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'If you exit, your post won\u2019t be saved.')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn danger btn-post-discard','data-dismiss':'modal','aria-label':'Close',title:'Discard',onClick:this.checkChallengeDiscard},'Discard'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel',onClick:this.checkCancel,'data-dismiss':'modal','aria-label':'Close',title:'Cancel'},'Cancel'))))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{href:'javascript:void(0);',id:'large_challenge_image_btn1',type:'button','data-toggle':'modal','data-target':'#large_challenge_image1',style:{display:"none"}},'submit'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay createPostCloseModal large_challenge_image',id:'large_challenge_image1','data-backdrop':'false','data-keyboard':'false',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,this.state.challenge_image_msg_size)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel','data-dismiss':'modal','aria-label':'Close',title:'Close'},'Close'))))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{href:'javascript:void(0);',id:'challenge_entry_submitted',type:'button','data-toggle':'modal','data-target':'#chnlgEntryConfrModal',style:{display:"none"}},'submit'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay createPostCloseModal chnlgPostupdateConfrModal',id:'chnlgEntryConfrModal','data-backdrop':'false','data-keyboard':'false',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h6',null,'Thank you for submitting your entry!')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:this.checkChallengeDiscard,className:'btn cancel  btn-post-cancel','data-dismiss':'modal','aria-label':'Close',title:'Close'},'Close'))))))));}}]);return ChallengeDetail;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ChallengeDetail);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_mentions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultStyle__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__defaultMentionStyle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MentionTextarea_css__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MentionTextarea_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__MentionTextarea_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CommonPopup_jsx__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__saveNotification_jsx__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { Notification } from 'react-web-notification'; 
/*const users = [
    {
      id: "isaac",
      display: "Isaac Newton",
    },
    {
      id: "sam",
      display: "Sam Victor",
    },
    {
      id: "emma",
      display: "emmanuel@nobody.com",
    },
  ];*/function time_ago(time){switch(typeof time==='undefined'?'undefined':_typeof(time)){case'number':break;case'string':time=+new Date(time);break;case'object':if(time.constructor===Date)time=time.getTime();break;default:time=+new Date();}var time_formats=[[60,'s',1],// 60
[120,'1m','1 minute from now'],// 60*2
[3600,'m',60],// 60*60, 60
[7200,'1h','1 hour from now'],// 60*60*2
[86400,'h',3600],// 60*60*24, 60*60
[172800,'1d','Tomorrow'],// 60*60*24*2
[604800,'d',86400],// 60*60*24*7, 60*60*24
[1209600,'1w','Next week'],// 60*60*24*7*4*2
[2419200,'w',604800],// 60*60*24*7*4, 60*60*24*7
[4838400,'1m','Next month'],// 60*60*24*7*4*2
[29030400,'m',2419200],// 60*60*24*7*4*12, 60*60*24*7*4
[58060800,'1y','Next year'],// 60*60*24*7*4*12*2
[2903040000,'y',29030400],// 60*60*24*7*4*12*100, 60*60*24*7*4*12
[5806080000,'Last century','Next century'],// 60*60*24*7*4*12*100*2
[58060800000,'centuries',2903040000]// 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
];var seconds=(+new Date()-time)/1000,token='',list_choice=1;if(seconds==0){return'';}if(seconds<0){seconds=Math.abs(seconds);//token = 'from now';
token='';list_choice=2;}var i=0,format;while(format=time_formats[i++]){if(seconds<format[0]){if(typeof format[2]=='string')return format[list_choice];else return Math.floor(seconds/format[2])+''+format[1]+''+token;}}return time;}var getWeekStartAndEndDates=function getWeekStartAndEndDates(){var offsetWeeks=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var now=new Date();var dayOfWeek=now.getDay();//now.getDay(); 
var startOfWeek='';var endOfWeek='';/* if(offsetWeeks===2)
  {     
      endOfWeek = new Date(now);
      startOfWeek =new Date(new Date(now) - (24*60*60*1000));      
      console.log('22'+dayOfWeek+'dayOfWeek'+endOfWeek+'endOfWeek'+startOfWeek+'startOfWeek')
  }else{ */if(offsetWeeks===0){//console.log('0000');
endOfWeek=new Date(new Date().setHours(0,0,0,0));//new Date(new Date(now) - (24*60*60*1000));  //new Date(new Date().setHours(0, 0, 0, 0));//new Date(now); 
startOfWeek=new Date(now);//new Date(new Date(now) - (24*60*60*1000)); //new Date(now);
}else{//console.log(' not 0000');
endOfWeek=new Date(now);//new Date(new Date(now) - (24*60*60*1000));  //new Date(new Date().setHours(0, 0, 0, 0));//new Date(now); 
startOfWeek=new Date(new Date(now)-24*60*60*1000);//new Date(now);
}//}
//const startOfWeek = new Date(now);
// const endOfWeek = new Date(now);
startOfWeek.setDate(now.getDate()-dayOfWeek+offsetWeeks*7);startOfWeek.setHours(0,0,0,0);endOfWeek.setDate(now.getDate()+(6-dayOfWeek)+offsetWeeks*7);endOfWeek.setHours(23,59,59,999);// endOfWeek = new Date(endOfWeek - (24*60*60*1000));
/*if(offsetWeeks===0)
  {
   console.log('startOfWeek  0'+startOfWeek);
   console.log('endOfWeek 0'+endOfWeek);
 }else{
  console.log('startOfWeek else'+startOfWeek);
   console.log('endOfWeek else'+endOfWeek);
 }*/return{startOfWeek:startOfWeek,endOfWeek:endOfWeek};};var Footer=function(_Component){_inherits(Footer,_Component);function Footer(props){var _this2=this;_classCallCheck(this,Footer);var _this=_possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).call(this,props));_this.checkForNewEntries=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var user,notificationglobal,now,dateend,datestart,startOfDay,query,mainQuery,results;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0://console.log('checkForNewEntries');
user=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();// Get the current logged-in user
if(user){_context.next=3;break;}return _context.abrupt('return');case 3://query 1
notificationglobal=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Notification');notificationglobal.equalTo("global",1);notificationglobal.equalTo("challenge",1);//notificationglobal.notEqualTo('notifiedUser', user);
notificationglobal.notEqualTo('commentingUser',user);now=new Date();dateend=new Date(now);datestart=new Date(new Date().setHours(0,0,0,0));startOfDay=new Date(new Date().setHours(0,0,0,0));notificationglobal.include('activity');notificationglobal.include('activity.content');notificationglobal.greaterThanOrEqualTo('createdAt',datestart);notificationglobal.lessThanOrEqualTo('createdAt',dateend);notificationglobal.descending('createdAt');//query 1 end
//query 2
query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Notification');// Replace with your Parse class name
query.equalTo('notifiedUser',user);// Filter by the current user
/*if (this.state.lastChecked) {
      query.greaterThan('createdAt', this.state.lastChecked); 
    }*//* const now = new Date();
    let dateend =new Date(now);
    let datestart =new Date(new Date().setHours(0, 0, 0, 0));
    let startOfDay =new Date(new Date().setHours(0, 0, 0, 0))*/query.include('activity');query.include('activity.content');query.greaterThanOrEqualTo('createdAt',datestart);query.lessThanOrEqualTo('createdAt',dateend);query.descending('createdAt');mainQuery=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query.or(query,notificationglobal);mainQuery.descending('createdAt');_context.prev=25;_context.next=28;return mainQuery.find();case 28:results=_context.sent;if(results.length>0){//console.log(results);
_this.setState({newEntries:results,lastChecked:new Date()});}_context.next=35;break;case 32:_context.prev=32;_context.t0=_context['catch'](25);console.error('Error fetching new entries:',_context.t0);case 35:case'end':return _context.stop();}}},_callee,_this2,[[25,32]]);}));_this.fetchThisWeekEntries=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _getWeekStartAndEndDa,startOfWeek,endOfWeek;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_getWeekStartAndEndDa=getWeekStartAndEndDates(0),startOfWeek=_getWeekStartAndEndDa.startOfWeek,endOfWeek=_getWeekStartAndEndDa.endOfWeek;//0
_context2.next=3;return _this.fetchEntriesForWeek(startOfWeek,endOfWeek,'thisWeekEntries');case 3:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.fetchLastWeekEntries=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _getWeekStartAndEndDa2,startOfWeek,endOfWeek;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_getWeekStartAndEndDa2=getWeekStartAndEndDates(-1),startOfWeek=_getWeekStartAndEndDa2.startOfWeek,endOfWeek=_getWeekStartAndEndDa2.endOfWeek;_context3.next=3;return _this.fetchEntriesForWeek(startOfWeek,endOfWeek,'lastWeekEntries');case 3:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.fetchEntriesForWeek=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(startOfWeek,endOfWeek,stateKey){var user,notificationglobal,query,mainQuery,results;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:user=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();// Get the current logged-in user
if(user){_context4.next=4;break;}console.error('User not logged in');return _context4.abrupt('return');case 4://query 1
notificationglobal=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Notification');notificationglobal.equalTo("global",1);notificationglobal.equalTo("challenge",1);// notificationglobal.notEqualTo('notifiedUser', user);
notificationglobal.notEqualTo('commentingUser',user);notificationglobal.include('activity');notificationglobal.include('activity.content');notificationglobal.greaterThanOrEqualTo('createdAt',startOfWeek);notificationglobal.lessThanOrEqualTo('createdAt',endOfWeek);notificationglobal.descending('createdAt');//query 1 end
query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Notification');query.greaterThanOrEqualTo('createdAt',startOfWeek);query.lessThanOrEqualTo('createdAt',endOfWeek);query.include('activity');query.include('activity.content');query.equalTo('notifiedUser',user);query.descending('createdAt');mainQuery=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query.or(query,notificationglobal);mainQuery.descending('createdAt');_context4.prev=22;_context4.next=25;return mainQuery.find();case 25:results=_context4.sent;// console.log(results);
_this.setState(_defineProperty({},stateKey,results));_context4.next=32;break;case 29:_context4.prev=29;_context4.t0=_context4['catch'](22);console.error('Error fetching entries:',_context4.t0);case 32:case'end':return _context4.stop();}}},_callee4,_this2,[[22,29]]);}));return function(_x2,_x3,_x4){return _ref4.apply(this,arguments);};}();_this.renderUserSuggestion=function(suggestion,search,highlightedDisplay){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user-suggestion'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:suggestion.avatar,alt:suggestion.display,className:'user-avatar'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'displayUserName'},highlightedDisplay),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'displayName'},suggestion.displayName)));};_this.handleChange=function(e){this.setState({mentioned:e.target.value});};_this.openLoginPopup=function(e){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#close_signup').trigger('click');__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#login_popup_btn').trigger('click');};_this.checkPostModal=function(e){var forms=document.forms.new_photo_form;var caption=forms.caption.value;var dataurl_210=forms.dataurl_210.value;if(caption!==''||dataurl_210!==''){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#close_Postmodalwithdiscard').attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#close_Postmodal').attr("style","display: none");if(__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");}}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#close_Postmodalwithdiscard').attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#close_Postmodal').attr("style","display: block");if(!__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");}}/*if ($(".modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")) {
         $(".modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");
      }*/};_this.changeCaption=function(e){var forms=document.forms.new_photo_form;var caption=forms.caption.value;var dataurl_210=forms.dataurl_210.value;this.setState({mentioned:e.target.value});if(caption!==''||dataurl_210!==''){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#close_Postmodalwithdiscard').attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#close_Postmodal').attr("style","display: none");/*if ($(".modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")) {
         $(".modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");
      }*/}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#close_Postmodalwithdiscard').attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#close_Postmodal').attr("style","display: block");/*if (!$(".modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")) {
         $(".modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");
      }*/}};_this.discardData=function(e){this.setState({mentioned:''});__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#photoUrlInput").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_210").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_640").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_640_img").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_210_img").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#caption").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#profilePicturePreview").parent(".img_view").attr("style","display: none");document.getElementById("profilePicturePreview").src="/images/defaultcamera.png";};_this.checkCancel=function(e){if(!__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".modal.fade.post_modal.createPostModal").addClass("post_modal_overlay");}};_this.checkDiscard=function(e){var _this3=this;setTimeout(function(){_this3.setState({mentioned:''});__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#close_Postmodal').trigger('click');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#photoUrlInput").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_210").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_210_img").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_640").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_640_img").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#caption").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#profilePicturePreview").parent(".img_view").attr("style","display: none");document.getElementById("profilePicturePreview").src="/images/defaultcamera.png";},500);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#close_Postmodalwithdiscard').attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#close_Postmodal').attr("style","display: block");if(!__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".modal.fade.post_modal.createPostModal").addClass("post_modal_overlay");}};_this.openSignupPopup=function(e){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#close_login').trigger('click');__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#register_popup_btn').trigger('click');};_this.toggleNotification=function(postid,msg,comment){//console.log('toggleNotification'+postid);
var self=_this;self.setState(function(prevState){return{isNotificationOpen:!prevState.isNotificationOpen,post_Notification_Id:postid,post_Notification_Msg:msg,post_Notification_Comment:comment};});//self.setState({ post_Notification_Id: postid });        
};_this.handleFileChange=function(event){var file=event.target.files[0];var self=_this;if(file){var fileSizeInBytes=file.size;var fileSizeInKB=fileSizeInBytes/1024;var maxSizeInKB=20480;// 20MB
if(fileSizeInKB>maxSizeInKB){self.setState({create_message_show:true});self.setState({create_message:"File size exceeds the limit."});}else{var fileType=file.type;if(fileType==='image/jpeg'||fileType==='image/png'){var imageFile=event.target.files[0];var reader=new FileReader();reader.onload=function(e){var img=document.createElement("img");img.onload=function(event){var custom_width_640=640;var custom_width_210=210;if(custom_width_640){var canvas=document.createElement("canvas");var canvasResize=document.createElement('canvas');var ctxResize=canvasResize.getContext('2d');var maxWidth=1000;var maxHeight=1000;var aspectRatio=img.width/img.height;var newHeightCheck=0;var newWidthCheck=0;var newMessageCheck='';var newWidth=img.width;var newHeight=img.height;if(img.width>maxWidth){newWidth=maxWidth;newHeight=newWidth/aspectRatio;}if(newHeight>maxHeight){newHeight=maxHeight;newWidth=newHeight*aspectRatio;}if(custom_width_640>newHeight||custom_width_640>newWidth){if(custom_width_640>newHeight){newHeightCheck=newHeight;newMessageCheck="Please upload a larger size image. The height proportionally is "+parseInt(newHeight)+"px, it must be at least 640px";}if(custom_width_640>newWidth){newWidthCheck=newWidth;newMessageCheck="Please upload a larger size image. The  width proportionally is "+parseInt(newWidth)+"px, it must be at least 640px";}if(custom_width_640>newHeight&&custom_width_640>newWidth){newMessageCheck="Please upload a larger size image. The  width/height proportionally is "+parseInt(newWidth)+"px & "+parseInt(newHeight)+"px, it must be at least 640px";}self.setState({challenge_image_msg_size:newMessageCheck});//console.log('less');
//self.setState({photo_image_message:"Please upload large size image!"});  
__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#profilePicturePreview").parent(".img_view").attr("style","display: none");document.getElementById("profilePicturePreview").src="/images/defaultcamera.png";__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#photoUrlInput").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_210").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_640").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_640_img").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#dataurl_210_img").val('');__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#large_challenge_image_btn').trigger('click');}else{canvasResize.width=newWidth;canvasResize.height=newHeight;ctxResize.drawImage(img,0,0,img.width,img.height,0,0,newWidth,newHeight);var resizedDataURL=canvasResize.toDataURL('image/jpeg');var canvasCrop=document.createElement('canvas');var ctxCrop=canvasCrop.getContext('2d');var cropWidth=custom_width_640;var cropHeight=custom_width_640;canvasCrop.width=cropWidth;canvasCrop.height=cropHeight;var x=(newWidth-cropWidth)/2;var y=(newHeight-cropHeight)/2;ctxCrop.drawImage(canvasResize,x,y,cropWidth,cropHeight,0,0,cropWidth,cropHeight);var croppedDataURL=canvasCrop.toDataURL('image/jpeg');var dataurl_640=croppedDataURL;//new
if(custom_width_210){var canvas=document.createElement("canvas");var _canvasResize=document.createElement('canvas');var _ctxResize=_canvasResize.getContext('2d');var _maxWidth=500;var _maxHeight=500;var _aspectRatio=img.width/img.height;var _newWidth=img.width;var _newHeight=img.height;if(img.width>_maxWidth){_newWidth=_maxWidth;_newHeight=_newWidth/_aspectRatio;}if(_newHeight>_maxHeight){_newHeight=_maxHeight;_newWidth=_newHeight*_aspectRatio;}_canvasResize.width=_newWidth;_canvasResize.height=_newHeight;_ctxResize.drawImage(img,0,0,img.width,img.height,0,0,_newWidth,_newHeight);var _resizedDataURL=_canvasResize.toDataURL('image/jpeg');var _canvasCrop=document.createElement('canvas');var _ctxCrop=_canvasCrop.getContext('2d');var _cropWidth=custom_width_210;var _cropHeight=custom_width_210;_canvasCrop.width=_cropWidth;_canvasCrop.height=_cropHeight;var _x5=(_newWidth-_cropWidth)/2;var _y=(_newHeight-_cropHeight)/2;_ctxCrop.drawImage(_canvasResize,_x5,_y,_cropWidth,_cropHeight,0,0,_cropWidth,_cropHeight);var _croppedDataURL=_canvasCrop.toDataURL('image/jpeg');var dataurl_210=_croppedDataURL;/*new code 1*/}if(dataurl_640!==undefined||dataurl_210!==undefined){var dataurl_210s=document.getElementById('dataurl_210');dataurl_210s.value=dataurl_210;var dataurl_640s=document.getElementById('dataurl_640');dataurl_640s.value=dataurl_640;var parseFile_210=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.File('image.jpg',{base64:dataurl_210});var parseFile_640=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.File('thumbnail.jpg',{base64:dataurl_640});parseFile_640.save().then(function(savedFile){var dataurl_640_img=document.getElementById('dataurl_640_img');dataurl_640_img.value=savedFile.url();}).catch(function(error){console.error('Error saving file:',error);});parseFile_210.save().then(function(savedFile){var dataurl_210_img=document.getElementById('dataurl_210_img');dataurl_210_img.value=savedFile.url();}).catch(function(error){console.error('Error saving file:',error);});__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#profilePicturePreview").parent(".img_view").attr("style","display: block");document.getElementById("profilePicturePreview").src=dataurl_640;}//new
}}};img.src=e.target.result;};reader.readAsDataURL(imageFile);}else{console.log('Unsupported file type.');self.setState({create_message_show:true});self.setState({create_message:'Unsupported file type.'});// You can display an error message or take other actions here
}__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#close_Postmodalwithdiscard').attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#close_Postmodal').attr("style","display: none");/*if ($(".modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")) {
               $(".modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");
            }*/}setTimeout(function(){self.setState({create_message_show:false});self.setState({create_message:null});self.setState({photo_image_message:null});},3000);}};_this.handleUnFollowMyProfileLike=function(e){var datapost_id=e.target.dataset.id;var self=_this;var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.followimg_button #followpopup_'+datapost_id).attr("style","pointer-events: none");if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('User');query.equalTo("objectId",datapost_id);query.first().then(function(result){if(result){var touser=result;//console.log('touser');console.log(touser);
var checksavequery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');checksavequery.equalTo('type','follow');checksavequery.equalTo('toUser',touser);checksavequery.equalTo('fromUser',currentUser);checksavequery.first().then(function(object){if(object){return object.destroy();}}).then(function(deletedObject){setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.followimg_button #followpopup_'+datapost_id).attr("style","pointer-events: auto");self.getfollowersListing();},1000);}).catch(function(error){console.error('Error deleting record:',error);});}});}else{return false;}};_this.handleFollowMyProfileLike=function(e){var datapost_id=e.target.dataset.id;__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.followimg_button #followpopup_'+datapost_id).attr("style","pointer-events: none");var self=_this;var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('User');query.equalTo("objectId",datapost_id);query.first().then(function(result){if(result){var touser=result;var Activity=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend("Activity");var activity=new Activity();activity.set('fromUser',currentUser);activity.set('toUser',touser);activity.set('type','follow');activity.save().then(function(savedFile){setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.followimg_button #followpopup_'+datapost_id).attr("style","pointer-events: auto");self.toggleNotification(touser,'started following you.','');self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});// self.singlegetUsersCommentLike(datapost_id);     
self.getfollowersListing();},1000);}).catch(function(error){});}});}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}};_this.state={email:'',password:'',caption:'',parseFile_210:'',parseFile_640:'',create_message:null,create_message_show:false,signup_message_show:null,photo_image_message:null,login_message_show:null,challenge_image_msg_size:false,mentioned:'',get_allusers:[],isRecipe:0,newEntries:[],lastChecked:null,thisWeekEntries:[],lastWeekEntries:[],isPopupOpenFooter:false,post_common_idFooter:'',isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:'',followersListing:{},followinguserid:[],NotificationIgnore:false,NotificationTitle:''};_this.handleRegisterFrmSubmit=_this.handleRegisterFrmSubmit.bind(_this);_this.handleLoginFrmSubmit=_this.handleLoginFrmSubmit.bind(_this);_this.openSignupPopup=_this.openSignupPopup.bind(_this);_this.openLoginPopup=_this.openLoginPopup.bind(_this);_this.handlePhotoSubmit=_this.handlePhotoSubmit.bind(_this);_this.handleFileChange=_this.handleFileChange.bind(_this);_this.checkDiscard=_this.checkDiscard.bind(_this);_this.discardData=_this.discardData.bind(_this);_this.changeCaption=_this.changeCaption.bind(_this);_this.checkPostModal=_this.checkPostModal.bind(_this);_this.checkCancel=_this.checkCancel.bind(_this);//this.getNotification();
_this.getNotificationClose();_this.handleChange=_this.handleChange.bind(_this);_this.getAllUsers();_this.getfollowersListing();//this.showNotification = this.showNotification.bind(this);
return _this;}/*showNotification(title,body) { console.log('showNotification click');
    var options = {
      body: body,
      icon: 'favicon.ico',
      dir: 'ltr',
    };
   let notification = new Notification(title, options);
  }*/_createClass(Footer,[{key:'getfollowersListing',value:function getfollowersListing(){//followers
var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var followersquery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');followersquery.include("user");followersquery.include("fromUser");followersquery.include("image");followersquery.include("thumbnail");followersquery.equalTo("type","follow");followersquery.equalTo("toUser",currentUser);var self=this;followersquery.find().then(function(followerresult){if(followerresult){//console.log('followerresult'); console.log(followerresult);
var resultcount=followerresult.length;if(followerresult.length>0){var userdataresult=[];for(var i=0;i<resultcount;i++){var Images=null;var user=followerresult[i];if(user.get("fromUser").get("profilePictureSmall")&&user.get("fromUser").get("profilePictureSmall").url()!==undefined){Images=user.get("fromUser").get("profilePictureSmall").url();}userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images,'toUser':user.get("toUser").id});//self.setState({followersListing:resultcount});
}self.setState({followersListing:userdataresult});}}});//followers
//following
var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Activity');query.include("user");query.include("image");query.include("toUser");query.include("thumbnail");query.equalTo("type","follow");query.equalTo("fromUser",currentUser);var self=this;query.find().then(function(result){if(result){var resultcount=result.length;var followingdataresult1=[];if(resultcount>0){var userdataresult1=[];for(var i=0;i<resultcount;i++){var user=result[i];var userimage='';if(user.get("toUser").get("profilePictureSmall")&&user.get("toUser").get("profilePictureSmall").url()!==undefined){userimage=user.get("toUser").get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}userdataresult1.push({'id':user.get("toUser").id,'displayName':user.get("toUser").get("displayName"),'displayUsername':user.get("toUser").get("displayUsername"),'image':userimage,'fromUser':user.get("fromUser").id});followingdataresult1.push({'id':user.get("toUser").id,'name':user.get("toUser").id});self.setState({followinguserid:followingdataresult1});}}else{self.setState({followinguserid:[]});}}});//following
}},{key:'componentDidMount',value:function componentDidMount(){// Start polling for new entries
this.pollInterval=setInterval(this.checkForNewEntries,5000);// Check every 10 seconds
this.fetchThisWeekEntries();this.fetchLastWeekEntries();if(!("Notification"in window)){console.log("Browser does not support desktop notification");}else{console.log("Notifications are supported");}}},{key:'componentWillUnmount',value:function componentWillUnmount(){// Clean up the interval on component unmount
clearInterval(this.pollInterval);}},{key:'getAllUsers',value:function getAllUsers(){var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('_User');query.limit(999999999);query.include("profilePictureSmall");query.include("displayUsername");query.exists("displayUsername");query.include("name");var self=this;query.find().then(function(result){var userdataresult1=[];if(result){for(var i=0;i<result.length;i++){var user=result[i];var userimage='';if(user.get("profilePictureSmall")&&user.get("profilePictureSmall").url()!==undefined){userimage=user.get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}userdataresult1.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});self.state.get_allusers.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});}this.state.get_allusers=userdataresult1;}else{console.log("No users found");}},function(error){});}},{key:'handleLoginFrmSubmit',value:function handleLoginFrmSubmit(event){event.preventDefault();var forms=document.forms.login_frm;var username=forms.login_email.value;var password=forms.login_password.value;var user=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.User();var self=this;var userloggedin=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.logIn(username,password).then(function(user){localStorage.setItem('username',user.get("username"));localStorage.setItem('useremail',user.get("email"));localStorage.setItem('sessionToken',user.get("sessionToken"));localStorage.setItem('isLoggedin',true);localStorage.setItem('ispicture_popup',false);//window.alert( 'You have successfully loggedin');                 
window.location.href="/";}).catch(function(error){self.setState({login_message_show:error.message});setTimeout(function(){self.setState({login_message_show:null});},8000);});}},{key:'handleRegisterFrmSubmit',value:function handleRegisterFrmSubmit(event){event.preventDefault();var forms=document.forms.new_register;var email=forms.email.value;var password=forms.password.value;var user=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.User();var getusername=email.replace(/@.*$/,"");var username=getusername!==email?getusername:null;//user.set("username", username);
user.set("username",email);user.set("password",password);user.set("email",email);user.set("displayName",username);user.set("displayUsername",username);user.set("isCreator",0);user.set("firstName",'');user.set("lastName",'');user.set("veganSince",'');user.set("isAdmin",'0');user.set("recipeRate",'$0');user.set("videoRate",'');user.set("isBusiness",0);var self=this;user.signUp().then(function(user){var userloggedin=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.logIn(email,password).then(function(user){localStorage.setItem('username',user.get("username"));localStorage.setItem('useremail',user.get("email"));localStorage.setItem('sessionToken',user.get("sessionToken"));localStorage.setItem('isLoggedin',true);localStorage.setItem('ispicture_popup',true);window.location.href="/";}).catch(function(error){console.log("Error: "+error.code+" "+error.message);});}).catch(function(error){self.setState({signup_message_show:error.message});//window.alert( error.message);
//$("form#new_register")[0].reset();  
setTimeout(function(){self.setState({signup_message_show:null});},8000);return false;});}/*getNotification() {
    $('#notf_sidebar').val(0);
    let notf_sidebar=$('#notf_sidebar').val();
    if(notf_sidebar!=true) {
      $(".notf_sidebar").css({"left": "398px"});
      $('#notf_sidebar').val(1);
      $('#notf_sidebar_close').val(0);
    } else { 
      $(".notf_sidebar").css({"left": "-398px"});
      $('#notf_sidebar').val(0);
      $('#notf_sidebar_close').val(1);
    }
  } */},{key:'getNotificationClose',value:function getNotificationClose(){var notf_sidebar_close=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#notf_sidebar_close').val('');var notf_sidebar=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#notf_sidebar').val('');if(notf_sidebar_close==true){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".notf_sidebar").css({"left":"398px"});__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#notf_sidebar_close').val(0);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#notf_sidebar').val(1);}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".notf_sidebar").css({"left":"-398px"});__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#notf_sidebar_close').val(1);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#notf_sidebar').val(0);}}},{key:'handlePhotoSubmit',value:function handlePhotoSubmit(event){var _this4=this;event.preventDefault();var forms=document.forms.new_photo_form;var caption=forms.caption.value;var dataurl_210=forms.dataurl_210.value;var dataurl_640=forms.dataurl_640.value;var dataurl_210_img=forms.dataurl_210_img.value;var dataurl_640_img=forms.dataurl_640_img.value;var isRecipe=this.state.isRecipe;var self=this;if(caption===''){self.setState({create_message_show:true});self.setState({create_message:"Please write some caption first!"});//window.alert('Please write some caption first!');
}else if(dataurl_210===''||dataurl_210_img===''){self.setState({create_message_show:true});self.setState({create_message:'Please upload image.'});//window.alert('Please upload image.');
}else{var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();if(currentUser){var isRecipeVal=false;var parseFile_210=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.File('image.jpg',{base64:dataurl_210});var parseFile_640=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.File('thumbnail.jpg',{base64:dataurl_640});var Photo=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend('Photo');var photo=new Photo();var _currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();photo.set('image',parseFile_640);photo.set('thumbnail',parseFile_210);photo.set('nonMealPost',1);photo.set('user',_currentUser);photo.set('caption',caption);photo.set('fulltext',caption);photo.set('impr',0);if(isRecipe===true||isRecipe===1){isRecipeVal=true;photo.set('isRecipe',isRecipeVal);}var captionusername='';var captionusernameupdated='';if(caption){captionusername=caption.match(/@\w+/);if(captionusername){captionusernameupdated=captionusername[0].substr(1);}}photo.save().then(function(photodata){if(captionusernameupdated){//this.toggleNotification(photo.id,'tagged you in a post','');
_this4.toggleNotification(photo.id,'mentioned you in a post','');self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});}__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#close_Postmodal').trigger('click');setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#caption").val('');window.location.href="/";},3000);}).catch(function(error){console.log(error.message);});}else{}}setTimeout(function(){self.setState({create_message_show:false});self.setState({create_message:null});},3000);}},{key:'render',value:function render(){var _this5=this;var isPopupOpenFooter=this.state.isPopupOpenFooter;var postcommonid=this.state.post_common_idFooter;var isNotificationOpen=this.state.isNotificationOpen;var post_Notification_Ids=this.state.post_Notification_Id;var post_Notification_Msg=this.state.post_Notification_Msg;var post_Notification_Comment=this.state.post_Notification_Comment;var followersListing=this.state.followersListing;var followinguserid=this.state.followinguserid;var NotificationTitle=this.state.NotificationTitle;var NotificationIgnore=this.state.NotificationIgnore;var self=this;var togglePopup=function togglePopup(postid){_this5.setState(function(prevState){return{isPopupOpenFooter:!prevState.isPopupOpenFooter};});_this5.setState({post_common_idFooter:postid});};var updateNotification=function updateNotification(entryid,globaldata){console.log('updateNotification globaldata globaldata');if(globaldata===1){console.log(globaldata+'Loop globaldata');var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var userquery=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('User');userquery.limit(999999999);userquery.notEqualTo("displayUsername",currentUser.get("displayUsername"));userquery.find().then(function(result){if(result){var countercheck=0;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=result[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var matchusername=_step.value;if(matchusername!==''){countercheck=1;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}if(countercheck===1){console.log('countercheck done'+countercheck);var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Notification');query.equalTo("objectId",entryid);query.first().then(function(result){if(result){result.set('webviewed',0);result.save().then(function(resultSaved){});}});}}});}else{var query=new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query('Notification');query.equalTo("objectId",entryid);query.first().then(function(result){if(result){result.set('webviewed',0);result.save().then(function(resultSaved){});}});}};var makeNotification=function makeNotification(title,body){console.log('make showNotification');var options={body:body,icon:'favicon.ico',dir:'ltr'};var notification=new Notification("Joel's Kitchen",options);};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,isNotificationOpen?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__saveNotification_jsx__["a" /* default */],{isOpen:isNotificationOpen,postNotificationid:post_Notification_Ids,postMsg:post_Notification_Msg,postPhotoid:post_Notification_Ids,postActivityComment:post_Notification_Comment}):"",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CommonPopup_jsx__["a" /* default */],{isOpen:isPopupOpenFooter,onClose:function onClose(e){togglePopup(postcommonid);},postcommonid:postcommonid}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal fade auth_modal ragister_login_model createPostCloseModal',id:'loginModal',tabIndex:'-1',role:'dialog','data-backdrop':'true','data-keyboard':'true','aria-labelledby':'loginModalTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'close cancel  btn-post-cancel','data-dismiss':'modal','aria-label':'Close',title:'Cancel'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/close.svg',alt:'Close'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'logo_login_main'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form_midddle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:'logo',rel:'home',href:'/'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/joelskitchen_logo.png',alt:'Joel\'s Kitchen',className:'dt_logo'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:'logiN_form',id:'login_frm',onSubmit:this.handleLoginFrmSubmit},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'frm-error error-msg-data'},this.state.login_message_show),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',placeholder:'Email',size:'large',name:'login_email',className:'form-control',required:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{placeholder:'Password',size:'large',type:'password',name:'login_password',className:'form-control',required:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'frm-lbl text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:;',className:'forgot_password'},'forgot password?')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'secondary-btn btn-wrp cta_btn '},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'submit_button_ragister action',type:'submit'},'Log in')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'logiN_singUp'},'Don\u2019t have an account? ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'#',onClick:this.openSignupPopup},'Sign up')))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal fade auth_modal ragister_login_model createPostCloseModal',id:'registrationModal',tabIndex:'-1',role:'dialog','data-backdrop':'true','data-keyboard':'true','aria-labelledby':'registrationModalTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'close cancel btn-post-cancel','data-dismiss':'modal','aria-label':'Close',title:'Cancel'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/close.svg',alt:'Close'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'logo_login_main'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form_midddle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:'logo',rel:'home',href:'/'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/joelskitchen_logo.png',alt:'Joel\'s Kitchen',className:'dt_logo'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:'logiN_form',id:'new_register',onSubmit:this.handleRegisterFrmSubmit},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'frm-error error-msg-data'},this.state.signup_message_show),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'email',placeholder:'Email',size:'large',name:'email',className:'form-control',required:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{placeholder:'Password',size:'large',type:'password',name:'password',className:'form-control',required:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:;',className:'forgot_password'},'\xA0'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'primary-btn btn-wrp cta_btn '},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'signUp submit_button_ragister action',type:'submit'},'Sign up')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'logiN_singUp'},'Already have an account? ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'#',onClick:this.openLoginPopup},'Log in')))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal fade kitchenQrModal',id:'kitchenQrModal',tabIndex:'-1',role:'dialog','data-backdrop':'true','data-keyboard':'true','aria-labelledby':'kitchenQrModalTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-dialog modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'modal-title'},'Get Joel\'s Kitchen app'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button',className:'close',id:'close_signup','data-dismiss':'modal','aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/close.svg',alt:'Close'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Scan QR code to download the app'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'app_qr_code'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/app_qr_code.png',alt:'App QR Code'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Download from app store'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'app-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'https://apps.apple.com/us/app/joels-kitchen/id1151259671',title:'Download on App Store'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/app-store.png',alt:'Download on App Store'}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay createPostModal',id:'createPostModal',tabIndex:'-1',role:'dialog','data-backdrop':'true','data-keyboard':'true','aria-labelledby':'createPostModalTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-dialog modal-lg modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{id:'new_photo_form',onSubmit:this.handlePhotoSubmit},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'top-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button',style:{display:"none"},onClick:this.checkPostModal,className:'close','data-toggle':'modal','data-target':'#createPostCloseModal',id:'close_Postmodalwithdiscard','aria-label':'Modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/close.svg',alt:'Close'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button',className:'close','data-dismiss':'modal',id:'close_Postmodal','aria-label':'Modal',onClick:this.discardData},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/close.svg',alt:'Close'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'modal-title'},'Create a Post'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'cta_btn third-btn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'submit'},'Share'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'left-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'myFile'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'create_message_alert'},this.state.create_message,this.state.photo_image_message),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'file_upld'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'img_view',style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{height:'',width:'250',id:'profilePicturePreview',src:'/images/defaultcamera.png',alt:'photo Picture'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'file-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'hidden',id:'photoUrlInput',name:'photoUrl'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'hidden',id:'dataurl_210',name:'dataurl_210'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'hidden',id:'dataurl_640',name:'dataurl_640'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'hidden',id:'dataurl_640_img',name:'dataurl_640_img'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'hidden',id:'dataurl_210_img',name:'dataurl_210_img'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/file_upload.svg',alt:'Joel\'s Kitchen'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Choose a file to upload.'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'file-infor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'We recommend using high quality .jpg & .png files less than 20MB.'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'file',id:'myFile',accept:'.jpg, .jpeg, .png',name:'filename',onChange:this.handleFileChange}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'right-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'post-comment'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'post-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_mentions__["b" /* MentionsInput */],{name:'caption',id:'caption',value:this.state.mentioned,placeholder:'Write a caption...',onChange:this.changeCaption,style:__WEBPACK_IMPORTED_MODULE_5__defaultStyle__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_mentions__["a" /* Mention */],{trigger:'@',data:this.state.get_allusers,markup:'@__display__ ',displayTransform:function displayTransform(id,display,displayName){return'@'+display;},appendSpaceOnAdd:true,style:__WEBPACK_IMPORTED_MODULE_6__defaultMentionStyle__["a" /* default */],renderSuggestion:this.renderUserSuggestion,className:'mentions__mention',placeholder:'Write a caption...'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recept_addons'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inner_wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'recept-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/restaurant.svg',alt:'Restaurant'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Recipe included?'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'help-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/info.svg',alt:'Info'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'switch'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',value:'1',id:'isRecipe',name:'isRecipe',defaultChecked:this.state.isRecipe,onClick:function onClick(){return _this5.setState({isRecipe:!_this5.state.isRecipe});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'slider round'}))))))))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay createPostCloseModal',id:'createPostCloseModal',tabIndex:'-1',role:'dialog','data-backdrop':'true','data-keyboard':'true','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'Are you sure you want to leave?'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'If you exit, your post won\u2019t be saved.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn danger btn-post-discard','data-dismiss':'modal','aria-label':'Close',title:'Discard',onClick:this.checkDiscard},'Discard'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel',onClick:this.checkCancel,'data-dismiss':'modal','aria-label':'Close',title:'Cancel'},'Cancel'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay challengeModal createChallengeModal',id:'createChallengeModal',tabIndex:'-1',role:'dialog','data-backdrop':'true','data-keyboard':'true','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'top-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'modal-title'},'Challenge Details'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button',className:'close','data-dismiss':'modal','aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/close.svg',alt:'Close'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chlng-box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'Photo'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Your post\'s picture will show creators the type of content you want for your challenge.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chlng-box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'Title'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'This is how we will list your challenge.  Keep it short and sweet.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chlng-box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'Creative Direction'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Your creative direction serves as a guide for creators and their content. The greater freedom you give, the higher the participation.')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay challengeModal challengeGoalsModal',id:'challengeGoalsModal',tabIndex:'-1',role:'dialog','data-backdrop':'true','data-keyboard':'true','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'top-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'modal-title'},'Challenge Goals'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button',className:'close','data-dismiss':'modal','aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/close.svg',alt:'Close'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chlng-box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'More Creators'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'We\'ll help you connect with the most trusted creators on social media. Get started meeting creator that are a perfect fit for growing your brand and selling your products.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chlng-box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'More Content'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Get a library of high quality content for your brand. Perfect for setting up your digital marketing campaigns.')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{href:'javascript:void(0);',id:'large_challenge_image_btn',type:'button','data-toggle':'modal','data-target':'#large_challenge_image',style:{display:"none"}},'submit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay createPostCloseModal large_challenge_image',id:'large_challenge_image',tabIndex:'-1',role:'dialog','data-backdrop':'true','data-keyboard':'true','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.state.challenge_image_msg_size)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel','data-dismiss':'modal','aria-label':'Close',title:'Close'},'Close'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'notf_sidebar'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'notf_inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'top_part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Notifications'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:this.getNotificationClose,title:'Icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/close.svg',alt:'Close'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'hidden',name:'notf_sidebar_close',id:'notf_sidebar_close',value:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bottom_part'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('aside',{style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'New'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',title:'Follow',className:'chnlg-approv'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/ntf-challenge.png',alt:'Challenge'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'detail'},' Your challenge is approved!',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('time',null,'1m')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',title:'Follow'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/4d5cb539af6bff07a4607d156c1f00e2_profilePicture.jpg',alt:'Challenge'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'detail'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,'joelskitchen'),' started following you.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('time',null,'2m'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flw-btn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',title:'Follow'},'Follow'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',title:'Follow'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/ntf-challenge.svg',alt:'Challenge'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'detail'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,'laurencatino'),' tagged you in a post.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('time',null,'1h')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/40fcc132bb1f5c1cf70ae38ed176ca3c_profilePicture.jpg',alt:'User'})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('aside',{style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'This week'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',title:'Follow'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/default_userpic0.png',alt:'Challenge'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'detail'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,'foodie'),' commented on your post: \u201CYUM!\u201D ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('time',null,'5h')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/40fcc132bb1f5c1cf70ae38ed176ca3c_profilePicture.jpg',alt:'User'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',title:'Follow'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/ntf-challenge.png',alt:'Challenge'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'detail'},'Thank you for submitting your challenge. It is currently pending review.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('time',null,'2d')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('aside',{style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'Last week'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',title:'Follow'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'icon'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'detail'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,'joelskitchen'),' liked your comment: \u201CLooks delicious\u201D ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('time',null,'4d')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/40fcc132bb1f5c1cf70ae38ed176ca3c_profilePicture.jpg',alt:'User'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',title:'Follow'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/5989ff0d488a0df33044b58facacac4f_file.bin',alt:'Challenge'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'detail'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,'laurencatino'),' posted to your challenge. ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('time',null,'6d')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/40fcc132bb1f5c1cf70ae38ed176ca3c_profilePicture.jpg',alt:'User'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',title:'Follow'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/53165c895f57c5e34db5716f1fb3e98c_profilePicture.jpg',alt:'Challenge'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'detail'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,'benspees'),' liked your post. ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('time',null,'1w')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/40fcc132bb1f5c1cf70ae38ed176ca3c_profilePicture.jpg',alt:'User'})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('aside',{className:'entries_section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'New'),this.state.newEntries.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,this.state.newEntries.map(function(entry,i){{var following_match_id;var rows;var i;var followers;var follow_id_ms;var chek;var followingresults;var _ret=function(){var userimage='';var photoimage='';var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var currentUser_id='_User$'+currentUser.id;var commentingUser='_User$'+entry.get('commentingUser').id;//'_User$'+entry.get('notifiedUser').id;
var notifiedUser_id=entry.get('notifiedUser').id;var challengedata=entry.get('challenge')&&entry.get('challenge')===1?entry.get('challenge'):0;var commentingUserid=entry.get('commentingUser').id;var globaldata=entry.get('global')&&entry.get('global')===1?entry.get('global'):0;var commentingUseridNew=entry.get('commentingUser').id;var currentUseridNew=currentUser.id;var allusers=currentUseridNew.trim()!==commentingUseridNew.trim()===false?1:0;var usercommentdata=entry.get('comment');if(usercommentdata.includes('was awarded winner of the challenge')){if(entry.get('notifiedUser')&&entry.get('notifiedUser').get("profilePictureSmall")&&entry.get('notifiedUser').get("profilePictureSmall").url()!==undefined){userimage=entry.get('notifiedUser').get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}}else{if(entry.get('commentingUser').get("profilePictureSmall")&&entry.get('commentingUser').get("profilePictureSmall").url()!==undefined){userimage=entry.get('commentingUser').get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}}/*if(entry.get('commentingUser').get("profilePictureSmall") && entry.get('commentingUser').get("profilePictureSmall").url()!==undefined)
                 {
                     userimage=entry.get('commentingUser').get("profilePictureSmall").url();
                 }
                 else{
                     userimage="/images/default_userpic0.png";
                 }*/if(entry.get('photo')&&entry.get('photo').get("thumbnail")&&entry.get('photo').get("thumbnail").url()!==undefined){photoimage=entry.get('photo').get("thumbnail").url();}else{photoimage="/images/default_userpic0.png";}var commentingUsername=entry.get('commentingUser')?entry.get('commentingUser').get('displayUsername'):'';var comment_msg="commented on your post: ";var comment_reply_msg="replied to a comment on your post: ";var checkreply_msg=entry.get('reply')&&entry.get('reply')===true?1:0;var checkwebnotification=entry.get('webviewed')&&entry.get('webviewed')===1?1:0;if(usercommentdata.includes('following you')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('liked your post')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('created a challenge')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('challenge just became active!')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('challenge became active!')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('You was awarded winner of the challenge')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('was awarded winner of the challenge')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('saved your post')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('is cooking your')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('collaborated ')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('tagged you in a post')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('tagged you in a comment')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('mentioned you in a post')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('mentioned you in a comment')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('Your challenge is approved')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('Thank you for submitting your challenge. It is currently pending review.')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('liked your comment')){var contentdata=entry.get('activity')!==undefined&&entry.get('activity')?entry.get('activity').get('content'):'';comment_msg=entry.get('comment');//entry.get('comment')+' “'+contentdata+'”  ';
}/*else if(usercommentdata.includes('commented your post'))
                 {
                  let contentdata=entry.get('activity')!==undefined && entry.get('activity')?entry.get('activity').get('content'):'';
                  
                  comment_msg='commented on your post: “'+contentdata+'”  ';
                 }*/else if(usercommentdata.includes('posted to your challenge')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('joined a challenge')){comment_msg=entry.get('comment');}else if(checkreply_msg===1){comment_msg=comment_reply_msg+" “"+entry.get('comment')+'” ';}else{comment_msg=comment_msg+" “"+entry.get('comment')+'” ';//comment_msg +entry.get('comment');
}var user_imagedata='';var user_userdata='';var user_userdataNotification='';var user_photodata='';var user_followersdata='';if(followersListing!==''){var followinguserids=followinguserid;following_match_id=[];rows=followersListing.length;if(rows!=undefined){for(i=0;i<rows;i++){followers=followersListing[i];follow_id_ms='followpopup_'+commentingUserid;//'followpopup_'+followers.id;
var _currentUser2=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var currentUserid=_currentUser2.id;chek=followinguserids.find(function(c){return c.id===commentingUserid;});//'K1iL8XNQOd'  
followingresults=chek!=undefined?JSON.parse(JSON.stringify(chek)):"";user_followersdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'   ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'followimg_button'},currentUserid===commentingUserid?"":followingresults.id===commentingUserid?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fourth-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:follow_id_ms,'data-id':commentingUserid,href:'javascript:void(0);',title:'Unfollow',onClick:function onClick(e){return self.handleUnFollowMyProfileLike(e);}},'Unfollow ')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'third-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:follow_id_ms,title:'Follow','data-id':commentingUserid,onClick:function onClick(e){return self.handleFollowMyProfileLike(e);},style:{display:"block"},href:'javascript:void(0);',className:'followpost_linkpopup'},'Follow')),' '));}}}if(usercommentdata.includes('Thank you for submitting your challenge. It is currently pending review')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'challenge_pending',src:'/images/ntf-challenge.png',alt:'Challenge'});user_userdata='';user_photodata='';user_userdataNotification='';}else if(usercommentdata.includes('You was awarded winner of the challenge')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'challenge_aproved',src:'/images/ntf-challenge.png',alt:'Challenge',id:entry.id});user_userdata='';user_photodata='';user_userdataNotification='';}else if(usercommentdata.includes('was awarded winner of the challenge')){//user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
var userdisplayname=entry.get('notifiedUser')&&entry.get('notifiedUser').get('displayUsername')?entry.get('notifiedUser').get('displayUsername'):'';user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+userdisplayname},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));// user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>;
user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+userdisplayname},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',userdisplayname),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){togglePopup(entry.get('photo').id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:photoimage,alt:''}),' '));user_userdataNotification=userdisplayname;}else if(usercommentdata.includes('joined a challenge')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',commentingUsername),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){togglePopup(entry.get('photo').id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:photoimage,alt:''}),' '));user_userdataNotification=commentingUsername;}else if(usercommentdata.includes('posted to your challenge')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',commentingUsername),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){togglePopup(entry.get('photo').id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:photoimage,alt:''}),' '));user_userdataNotification=commentingUsername;}else if(usercommentdata.includes('challenge just became active!')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',commentingUsername+"'s"),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){togglePopup(entry.get('photo').id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:photoimage,alt:''}),' '));user_userdataNotification=commentingUsername+"'s";}else if(usercommentdata.includes('challenge became active!')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',commentingUsername+"'s"),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){togglePopup(entry.get('photo').id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:photoimage,alt:''}),' '));user_userdataNotification=commentingUsername+"'s";}else if(usercommentdata.includes('started following you.')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',commentingUsername),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flw-btn'},' ',user_followersdata);user_userdataNotification=commentingUsername;}else if(entry.get('comment').includes('Your challenge is approved!')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/challenge/'+entry.get('photo').id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'challenge_aproved',src:'/images/ntf-challenge.png',alt:'Challenge',id:entry.id}));user_userdata='';user_photodata='';user_userdataNotification='';}else{user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',commentingUsername),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){togglePopup(entry.get('photo').id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:photoimage,alt:''}),' '));user_userdataNotification=commentingUsername;}//console.log('this.state.followersListing');
//    console.log(followersListing);
// if(entry.get('photo') && entry.get('photo').id!==undefined && entry.get('photo').get("thumbnail") && entry.get('photo').get("thumbnail").url()!==undefined) {
// console.log('loop')
if(currentUser_id.trim()!==commentingUser.trim()||challengedata===1){if(checkwebnotification===1){var commonmsg='';if(user_userdataNotification){commonmsg=user_userdataNotification+' '+comment_msg;}else{commonmsg=comment_msg;}makeNotification('',commonmsg);updateNotification(entry.id,globaldata);}//console.log('allusers'+allusers+'globaldata'+globaldata);
return{v:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:entry.id,style:{display:allusers===1&&globaldata===1?'none':''}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'icon'},'  ',user_imagedata,' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'detail'},' ',user_userdata,' ',comment_msg,' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('time',null,time_ago(entry.get("createdAt")))),' ',user_photodata)};}//   }
}();if((typeof _ret==='undefined'?'undefined':_typeof(_ret))==="object")return _ret.v;}})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('small',null,'No notification found.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('aside',{className:'entries_section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'This week'),this.state.thisWeekEntries.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,this.state.thisWeekEntries.map(function(entry,i){{var following_match_id;var rows;var i;var followers;var follow_id_ms;var chek;var followingresults;var _ret2=function(){var userimage='';var photoimage='';//commentingUseridNew  currentUseridNew
var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var currentUser_id='_User$'+currentUser.id;var commentingUser='_User$'+entry.get('commentingUser').id;var challengedata=entry.get('challenge')&&entry.get('challenge')===1?entry.get('challenge'):0;var notifiedUser_id=entry.get('notifiedUser').id;var commentingUserid=entry.get('commentingUser').id;var globaldata=entry.get('global')&&entry.get('global')===1?entry.get('global'):0;var commentingUseridNew=entry.get('commentingUser').id;var currentUseridNew=currentUser.id;var allusers=currentUseridNew.trim()!==commentingUseridNew.trim()===false?1:0;var usercommentdata=entry.get('comment');var usercommenunitydata=entry.get('communityComment');if(usercommentdata.includes('was awarded winner of the challenge')){if(entry.get('notifiedUser')&&entry.get('notifiedUser').get("profilePictureSmall")&&entry.get('notifiedUser').get("profilePictureSmall").url()!==undefined){userimage=entry.get('notifiedUser').get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}}else{if(entry.get('commentingUser').get("profilePictureSmall")&&entry.get('commentingUser').get("profilePictureSmall").url()!==undefined){userimage=entry.get('commentingUser').get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}}if(entry.get('photo')&&entry.get('photo').get("thumbnail")&&entry.get('photo').get("thumbnail").url()!==undefined){photoimage=entry.get('photo').get("thumbnail").url();}else{photoimage="/images/default_userpic0.png";}var commentingUsername=entry.get('commentingUser')?entry.get('commentingUser').get('displayUsername'):'';var comment_msg="commented on your post: ";var comment_reply_msg="replied to a comment on your post: ";var checkreply_msg=entry.get('reply')&&entry.get('reply')===true?1:0;if(usercommentdata.includes('following you')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('liked your post')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('created a challenge')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('challenge just became active!')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('challenge became active!')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('You was awarded winner of the challenge')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('was awarded winner of the challenge')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('saved your post')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('is cooking your')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('collaborated ')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('tagged you in a post')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('tagged you in a comment')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('mentioned you in a post')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('mentioned you in a comment')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('Your challenge is approved')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('joined a challenge')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('Thank you for submitting your challenge. It is currently pending review.')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('liked your comment')){//comment_msg=entry.get('comment')+': “'+entry.get('photo').get('caption')+'”  ';
var contentdata=entry.get('activity')!==undefined&&entry.get('activity')?entry.get('activity').get('content'):'';comment_msg=entry.get('comment');//entry.get('comment')+' “'+contentdata+'”  ';
}/*else if(usercommentdata.includes('commented your post'))
                 {
                 
                  let contentdata=entry.get('activity')!==undefined && entry.get('activity')?entry.get('activity').get('content'):'';
                 
                  comment_msg='commented on your post: “'+contentdata+'”  ';
                 }*/else if(usercommentdata.includes('posted to your challenge')){comment_msg=entry.get('comment');}else if(checkreply_msg===1){comment_msg=comment_reply_msg+" “"+entry.get('comment')+'” ';}else{comment_msg=comment_msg+" “"+entry.get('comment')+'” ';//comment_msg +entry.get('comment'); ;
}var user_imagedata='';var user_userdata='';var user_photodata='';var user_followersdata='';if(followersListing!==''){var followinguserids=followinguserid;following_match_id=[];rows=followersListing.length;if(rows!=undefined){for(i=0;i<rows;i++){followers=followersListing[i];follow_id_ms='followpopup_'+commentingUserid;//'followpopup_'+followers.id;
var _currentUser3=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var currentUserid=_currentUser3.id;chek=followinguserids.find(function(c){return c.id===commentingUserid;});//'K1iL8XNQOd'  
followingresults=chek!=undefined?JSON.parse(JSON.stringify(chek)):"";user_followersdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'   ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'followimg_button'},currentUserid===commentingUserid?"":followingresults.id===commentingUserid?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fourth-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:follow_id_ms,title:'Unfollow','data-id':commentingUserid,href:'javascript:void(0);',onClick:function onClick(e){return self.handleUnFollowMyProfileLike(e);}},'Unfollow ')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'third-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:follow_id_ms,title:'Follow','data-id':commentingUserid,onClick:function onClick(e){return self.handleFollowMyProfileLike(e);},style:{display:"block"},href:'javascript:void(0);',className:'followpost_linkpopup'},'Follow')),' '));}}}if(usercommentdata.includes('Thank you for submitting your challenge. It is currently pending review')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'challenge_pending',src:'/images/ntf-challenge.png',alt:'Challenge'});user_userdata='';user_photodata='';}else if(usercommentdata.includes('posted to your challenge')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',commentingUsername),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){togglePopup(entry.get('photo').id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:photoimage,alt:''}),' '));// user_userdataNotification=commentingUsername;
}else if(usercommentdata.includes('challenge became active!')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',commentingUsername+"'s"),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){togglePopup(entry.get('photo').id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:photoimage,alt:''}),' '));// user_userdataNotification=commentingUsername;
}else if(usercommentdata.includes('challenge just became active!')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',commentingUsername+"'s"),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){togglePopup(entry.get('photo').id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:photoimage,alt:''}),' '));// user_userdataNotification=commentingUsername;
}else if(usercommentdata.includes('You was awarded winner of the challenge')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'challenge_aproved',src:'/images/ntf-challenge.png',alt:'Challenge',id:entry.id});user_userdata='';user_photodata='';}else if(usercommentdata.includes('was awarded winner of the challenge')){//user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
var userdisplayname=entry.get('notifiedUser')&&entry.get('notifiedUser').get('displayUsername')?entry.get('notifiedUser').get('displayUsername'):'';user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+userdisplayname},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));// user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>;
user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+userdisplayname},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',userdisplayname),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){togglePopup(entry.get('photo').id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:photoimage,alt:''}),' '));}else if(usercommentdata.includes('joined a challenge')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',commentingUsername),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){togglePopup(entry.get('photo').id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:photoimage,alt:''}),' '));}else if(usercommentdata.includes('started following you.')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',commentingUsername),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flw-btn'},' ',user_followersdata);}else if(entry.get('comment').includes('Your challenge is approved!')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/challenge/'+entry.get('photo').id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'challenge_aproved',src:'/images/ntf-challenge.png',alt:'Challenge',id:entry.id}));user_userdata='';user_photodata='';}else{user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',commentingUsername),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){togglePopup(entry.get('photo').id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:photoimage,alt:''}),' '));}if(currentUser_id.trim()!==commentingUser.trim()||challengedata===1){return{v:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:entry.id,style:{display:allusers===1&&globaldata===1?'none':''}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'icon'},'  ',' ',user_imagedata,' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'detail'},' ',user_userdata,' ',comment_msg,' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('time',null,time_ago(entry.get("createdAt")))),' ',user_photodata)};}}();if((typeof _ret2==='undefined'?'undefined':_typeof(_ret2))==="object")return _ret2.v;}})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('small',null,'No notification found.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('aside',{className:'entries_section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'Last week'),this.state.lastWeekEntries.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,this.state.lastWeekEntries.map(function(entry,i){{var following_match_id;var rows;var i;var followers;var follow_id_ms;var chek;var followingresults;var _ret3=function(){var userimage='';var photoimage='';var currentUser=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var currentUser_id='_User$'+currentUser.id;var commentingUser='_User$'+entry.get('commentingUser').id;var challengedata=entry.get('challenge')&&entry.get('challenge')===1?entry.get('challenge'):0;var globaldata=entry.get('global')&&entry.get('global')===1?entry.get('global'):0;var commentingUseridNew=entry.get('commentingUser').id;var currentUseridNew=currentUser.id;var allusers=currentUseridNew.trim()!==commentingUseridNew.trim()===false?1:0;var notifiedUser_id=entry.get('notifiedUser').id;var commentingUserid=entry.get('commentingUser').id;var usercommentdata=entry.get('comment');if(usercommentdata.includes('was awarded winner of the challenge')){if(entry.get('notifiedUser')&&entry.get('notifiedUser').get("profilePictureSmall")&&entry.get('notifiedUser').get("profilePictureSmall").url()!==undefined){userimage=entry.get('notifiedUser').get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}}else{if(entry.get('commentingUser').get("profilePictureSmall")&&entry.get('commentingUser').get("profilePictureSmall").url()!==undefined){userimage=entry.get('commentingUser').get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}}if(entry.get('photo')&&entry.get('photo').get("thumbnail")&&entry.get('photo').get("thumbnail").url()!==undefined){photoimage=entry.get('photo').get("thumbnail").url();}else{photoimage="/images/default_userpic0.png";}var commentingUsername=entry.get('commentingUser')?entry.get('commentingUser').get('displayUsername'):'';var comment_msg="commented on your post: ";var comment_reply_msg="replied to a comment on your post: ";var checkreply_msg=entry.get('reply')&&entry.get('reply')===true?1:0;if(usercommentdata.includes('following you')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('liked your post')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('created a challenge')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('challenge just became active!')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('challenge became active!')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('You was awarded winner of the challenge')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('was awarded winner of the challenge')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('saved your post')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('is cooking your')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('collaborated ')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('tagged you in a post')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('tagged you in a comment')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('mentioned you in a post')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('mentioned you in a comment')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('Thank you for submitting your challenge. It is currently pending review.')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('Your challenge is approved')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('joined a challenge')){comment_msg=entry.get('comment');}else if(usercommentdata.includes('liked your comment')){//comment_msg=entry.get('comment')+': “'+entry.get('photo').get('caption')+'”  ';
var contentdata=entry.get('activity')!==undefined&&entry.get('activity')?entry.get('activity').get('content'):'';comment_msg=entry.get('comment');//entry.get('comment')+': “'+contentdata+'”  ';
}/*else if(usercommentdata.includes('commented your post'))
                 {
                    
                   let contentdata=entry.get('activity')!==undefined && entry.get('activity')?entry.get('activity').get('content'):'';
                   
                   comment_msg='commented on your post: “'+contentdata+'”  ';
                 }*/else if(usercommentdata.includes('posted to your challenge')){comment_msg=entry.get('comment');}else if(checkreply_msg===1){comment_msg=comment_reply_msg+" “"+entry.get('comment')+'” ';}else{comment_msg=comment_msg+" “"+entry.get('comment')+'” ';}var user_imagedata='';var user_userdata='';var user_photodata='';var user_followersdata='';if(followersListing!==''){var followinguserids=followinguserid;following_match_id=[];rows=followersListing.length;if(rows!=undefined){for(i=0;i<rows;i++){followers=followersListing[i];follow_id_ms='followpopup_'+commentingUserid;//'followpopup_'+followers.id;
var _currentUser4=__WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();var currentUserid=_currentUser4.id;chek=followinguserids.find(function(c){return c.id===commentingUserid;});//'K1iL8XNQOd'  
followingresults=chek!=undefined?JSON.parse(JSON.stringify(chek)):"";user_followersdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'   ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'followimg_button'},currentUserid===commentingUserid?"":followingresults.id===commentingUserid?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fourth-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:follow_id_ms,title:'Unfollow','data-id':commentingUserid,href:'javascript:void(0);',onClick:function onClick(e){return self.handleUnFollowMyProfileLike(e);}},'Unfollow ')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'third-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:follow_id_ms,title:'Follow','data-id':commentingUserid,onClick:function onClick(e){return self.handleFollowMyProfileLike(e);},style:{display:"block"},href:'javascript:void(0);',className:'followpost_linkpopup'},'Follow')),' '));}}}if(usercommentdata.includes('Thank you for submitting your challenge. It is currently pending review')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'challenge_pending',src:'/images/ntf-challenge.png',alt:'Challenge'});user_userdata='';user_photodata='';}else if(usercommentdata.includes('You was awarded winner of the challenge')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'challenge_aproved',src:'/images/ntf-challenge.png',alt:'Challenge',id:entry.id});user_userdata='';user_photodata='';}else if(usercommentdata.includes('was awarded winner of the challenge')){//user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
var userdisplayname=entry.get('notifiedUser')&&entry.get('notifiedUser').get('displayUsername')?entry.get('notifiedUser').get('displayUsername'):'';user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+userdisplayname},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));// user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>;
user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+userdisplayname},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',userdisplayname),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){togglePopup(entry.get('photo').id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:photoimage,alt:''}),' '));}else if(usercommentdata.includes('posted to your challenge')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',commentingUsername),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){togglePopup(entry.get('photo').id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:photoimage,alt:''}),' '));// user_userdataNotification=commentingUsername;
}else if(usercommentdata.includes('challenge just became active!')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',commentingUsername+"'s"),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){togglePopup(entry.get('photo').id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:photoimage,alt:''}),' '));// user_userdataNotification=commentingUsername;
}else if(usercommentdata.includes('challenge became active!')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',commentingUsername+"'s"),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){togglePopup(entry.get('photo').id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:photoimage,alt:''}),' '));// user_userdataNotification=commentingUsername;
}else if(usercommentdata.includes('joined a challenge')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',commentingUsername),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){togglePopup(entry.get('photo').id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:photoimage,alt:''}),' '));}else if(usercommentdata.includes('started following you.')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',commentingUsername),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flw-btn'},' ',user_followersdata);}else if(entry.get('comment').includes('Your challenge is approved!')){user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/challenge/'+entry.get('photo').id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'challenge_aproved',src:'/images/ntf-challenge.png',alt:'Challenge',id:entry.id}));user_userdata='';user_photodata='';}else{user_imagedata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:userimage,alt:''}));user_userdata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/user/'+commentingUsername},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,' ',commentingUsername),' ');user_photodata=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'usr-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){togglePopup(entry.get('photo').id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:photoimage,alt:''}),' '));}// if(entry.get('photo') && entry.get('photo').id!==undefined && entry.get('photo').get("thumbnail") && entry.get('photo').get("thumbnail").url()!==undefined) {
if(currentUser_id.trim()!==commentingUser.trim()||challengedata===1){return{v:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:entry.id,style:{display:allusers===1&&globaldata===1?'none':''}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'icon'},' ',user_imagedata),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'detail'},' ',user_userdata,' ',comment_msg,' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('time',null,time_ago(entry.get("createdAt")))),' ',user_photodata)};}}();if((typeof _ret3==='undefined'?'undefined':_typeof(_ret3))==="object")return _ret3.v;}})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('small',null,'No notification found.'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'hidden',name:'notf_sidebar',id:'notf_sidebar',value:'0'}));}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Contact=function(_Component){_inherits(Contact,_Component);function Contact(props){_classCallCheck(this,Contact);return _possibleConstructorReturn(this,(Contact.__proto__||Object.getPrototypeOf(Contact)).call(this,props));}_createClass(Contact,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"contact"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content cf"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"Contact"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"DOContact"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{method:"post",id:"contact_form",action:"contact"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"default"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",size:"40",value:"",name:"first_name",id:"contact_f_name",className:"default",placeholder:"First Name"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"default"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",size:"40",value:"",name:"last_name",id:"contact_l_name",className:"default",placeholder:"Last Name"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"default"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",size:"40",value:"",name:"email",id:"contact_email",className:"default",placeholder:"Email Address"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"default"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",size:"40",value:"",name:"phone",id:"contact_phone",className:"default",placeholder:"Mobile Number"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{rows:"10",cols:"30",name:"comments",id:"contact_comments",className:"text",placeholder:"Comments or Questions"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"submit",value:"Submit",id:"submit"}))))));}}]);return Contact;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Contact);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserRegistration=function(_React$Component){_inherits(UserRegistration,_React$Component);function UserRegistration(props){_classCallCheck(this,UserRegistration);var _this=_possibleConstructorReturn(this,(UserRegistration.__proto__||Object.getPrototypeOf(UserRegistration)).call(this,props));_this.state={email:'',password:''};_this.handleRegisterSubmit=_this.handleRegisterSubmit.bind(_this);return _this;}_createClass(UserRegistration,[{key:'handleRegisterSubmit',value:function handleRegisterSubmit(event){event.preventDefault();var forms=document.forms.new_register_form;var email=forms.email.value;var password=forms.password.value;var user=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.User();var getusername=email.replace(/@.*$/,"");var username=getusername!==email?getusername:null;user.set("username",username);user.set("password",password);user.set("email",email);user.set("displayName",username);user.set("displayUsername",username);user.set("isCreator",0);user.set("firstName",'');user.set("lastName",'');user.set("veganSince",'');user.set("isAdmin",'0');user.set("recipeRate",'$0');user.set("videoRate",'');user.set("isBusiness",0);//user.set("isCreator", 1);
//user.set("isCreator", 1);
user.signUp().then(function(user){var userloggedin=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.logIn(username,password).then(function(user){console.log('user');console.log(user);localStorage.setItem('username',user.get("username"));localStorage.setItem('useremail',user.get("email"));localStorage.setItem('sessionToken',user.get("sessionToken"));localStorage.setItem('isLoggedin',true);localStorage.setItem('ispicture_popup',true);window.location.href="/";}).catch(function(error){console.log("Error: "+error.code+" "+error.message);});}).catch(function(error){window.alert(error.message);__WEBPACK_IMPORTED_MODULE_2_jquery___default()("form#new_register_form")[0].reset();});}},{key:'render',value:function render(){var result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'signupfrm container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,this.state.message),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'form-signup',id:'new_register_form',onSubmit:this.handleRegisterSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'heading_logo'},'Joel\'s'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'heading'},'Signup'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'email',placeholder:'',size:'large',name:'email',className:'form_input',required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Password'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'',size:'large',type:'password',name:'password',className:'form_input',required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'By signing up, you agree to the ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'Terms')),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'primary',className:'form_button',color:'#208AEC',size:'large'},'Sign Up'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'or ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'Log In')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,this.state.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'handlechangeMessage',style:{display:"none"},onClick:this.handlechangeMessage},'Msg'));return result;}}]);return UserRegistration;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (UserRegistration);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import ImageCropper from './ImageCropper.jsx';
//import { resizeFile } from 'react-image-file-resizer';
var Photo=function(_React$Component){_inherits(Photo,_React$Component);function Photo(props){_classCallCheck(this,Photo);var _this=_possibleConstructorReturn(this,(Photo.__proto__||Object.getPrototypeOf(Photo)).call(this,props));_this.handleFileChange=function(event){var file=event.target.files[0];if(file){var imageFile=event.target.files[0];var reader=new FileReader();reader.onload=function(e){var img=document.createElement("img");img.onload=function(event){var custom_width_640=640;var custom_width_210=210;if(custom_width_640){var canvas=document.createElement("canvas");var canvasResize=document.createElement('canvas');var ctxResize=canvasResize.getContext('2d');var maxWidth=1000;var maxHeight=1000;var aspectRatio=img.width/img.height;var newWidth=img.width;var newHeight=img.height;if(img.width>maxWidth){newWidth=maxWidth;newHeight=newWidth/aspectRatio;}if(newHeight>maxHeight){newHeight=maxHeight;newWidth=newHeight*aspectRatio;}canvasResize.width=newWidth;canvasResize.height=newHeight;ctxResize.drawImage(img,0,0,img.width,img.height,0,0,newWidth,newHeight);var resizedDataURL=canvasResize.toDataURL('image/jpeg');var canvasCrop=document.createElement('canvas');var ctxCrop=canvasCrop.getContext('2d');var cropWidth=custom_width_640;var cropHeight=custom_width_640;canvasCrop.width=cropWidth;canvasCrop.height=cropHeight;var x=(newWidth-cropWidth)/2;var y=(newHeight-cropHeight)/2;ctxCrop.drawImage(canvasResize,x,y,cropWidth,cropHeight,0,0,cropWidth,cropHeight);var croppedDataURL=canvasCrop.toDataURL('image/jpeg');var dataurl_640=croppedDataURL;}if(custom_width_210){var canvas=document.createElement("canvas");var _canvasResize=document.createElement('canvas');var _ctxResize=_canvasResize.getContext('2d');var _maxWidth=500;var _maxHeight=500;var _aspectRatio=img.width/img.height;var _newWidth=img.width;var _newHeight=img.height;if(img.width>_maxWidth){_newWidth=_maxWidth;_newHeight=_newWidth/_aspectRatio;}if(_newHeight>_maxHeight){_newHeight=_maxHeight;_newWidth=_newHeight*_aspectRatio;}_canvasResize.width=_newWidth;_canvasResize.height=_newHeight;_ctxResize.drawImage(img,0,0,img.width,img.height,0,0,_newWidth,_newHeight);var _resizedDataURL=_canvasResize.toDataURL('image/jpeg');var _canvasCrop=document.createElement('canvas');var _ctxCrop=_canvasCrop.getContext('2d');var _cropWidth=custom_width_210;var _cropHeight=custom_width_210;_canvasCrop.width=_cropWidth;_canvasCrop.height=_cropHeight;var _x=(_newWidth-_cropWidth)/2;var _y=(_newHeight-_cropHeight)/2;_ctxCrop.drawImage(_canvasResize,_x,_y,_cropWidth,_cropHeight,0,0,_cropWidth,_cropHeight);var _croppedDataURL=_canvasCrop.toDataURL('image/jpeg');var dataurl_210=_croppedDataURL;}var dataurl_210s=document.getElementById('dataurl_210');dataurl_210s.value=dataurl_210;var dataurl_640s=document.getElementById('dataurl_640');dataurl_640s.value=dataurl_640;var parseFile_210=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.File('image.jpg',{base64:dataurl_210});var parseFile_640=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.File('thumbnail.jpg',{base64:dataurl_640});parseFile_640.save().then(function(savedFile){var dataurl_640_img=document.getElementById('dataurl_640_img');dataurl_640_img.value=savedFile.url();}).catch(function(error){console.error('Error saving file:',error);});parseFile_210.save().then(function(savedFile){var dataurl_210_img=document.getElementById('dataurl_210_img');dataurl_210_img.value=savedFile.url();}).catch(function(error){console.error('Error saving file:',error);});document.getElementById("profilePicturePreview").src=dataurl_640;};img.src=e.target.result;};reader.readAsDataURL(imageFile);}};__WEBPACK_IMPORTED_MODULE_1_parse___default.a.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5","sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw");//PASTE HERE YOUR Back4App APPLICATION ID AND YOUR JavaScript KEY
__WEBPACK_IMPORTED_MODULE_1_parse___default.a.serverURL="https://parse.joelskitchen.com/parse";//Parse.serverURL = "https://parsetest.joelskitchen.com/parse";
var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();if(!currentUser){window.location.href="/";}var profile_picture=currentUser.get("profilePictureMedium");if(profile_picture){profile_picture=profile_picture._url;__WEBPACK_IMPORTED_MODULE_2_jquery___default()("#profilePicturePreview").attr("style","display: block");}else{profile_picture='';__WEBPACK_IMPORTED_MODULE_2_jquery___default()("#profilePicturePreview").attr("style","display: none");}_this.state={caption:'',profile_picture:profile_picture,currentUser:currentUser,// originalImage: null,
//croppedImages: [],
parseFile_210:'',parseFile_640:''};_this.handlePhotoSubmit=_this.handlePhotoSubmit.bind(_this);_this.handleFileChange=_this.handleFileChange.bind(_this);return _this;}_createClass(Photo,[{key:'handlePhotoSubmit',value:function handlePhotoSubmit(event){event.preventDefault();var forms=document.forms.new_photo_form;var caption=forms.caption.value;var dataurl_210=forms.dataurl_210.value;var dataurl_640=forms.dataurl_640.value;//var isChallenge="0";
var dataurl_210_img=forms.dataurl_210_img.value;var dataurl_640_img=forms.dataurl_640_img.value;if(caption===''){window.alert('Please write some caption first!');}else{var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();if(currentUser){var parseFile_210=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.File('image.jpg',{base64:dataurl_210});var parseFile_640=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.File('thumbnail.jpg',{base64:dataurl_640});var _Photo=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.Object.extend('Photo');var photo=new _Photo();var _currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();photo.set('image',parseFile_640);photo.set('thumbnail',parseFile_210);photo.set('nonMealPost',1);photo.set('user',_currentUser);photo.set('caption',caption);photo.set('fulltext',caption);photo.save().then(function(photodata){setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2_jquery___default()("#caption").val('');window.alert('Post publish successfully');window.location.href="/";},1500);}).catch(function(error){console.log(error.message);});}else{//console.error('No user is currently logged in.');
}}}},{key:'render',value:function render(){var fetchProfile_picture=this.state.profile_picture;var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();var profile_pictures=currentUser.get("profilePictureMedium");if(profile_pictures){profile_pictures=profile_pictures._url;}else{}var result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-photo photofrm container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'form-signup',id:'new_photo_form',onSubmit:this.handlePhotoSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',id:'image-input',onChange:this.handleFileChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'photo_section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{height:'',width:'250',id:'profilePicturePreview',src:'/images/defaultcamera.png',alt:'photo Picture'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',id:'photoUrlInput',name:'photoUrl'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',id:'dataurl_210',name:'dataurl_210'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',id:'dataurl_640',name:'dataurl_640'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',id:'dataurl_640_img',name:'dataurl_640_img'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',id:'dataurl_210_img',name:'dataurl_210_img'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Write a caption...',size:'large',name:'caption',id:'caption',className:'form_input'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'primary',className:'form_button  btn btn-success',color:'#208AEC',size:'large'},'Share'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))));return result;}}]);return Photo;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Photo);

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__global_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__singlepost_jsx__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Leftsidebar_jsx__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CommonPopup_jsx__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__saveNotification_jsx__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Myprofiles=function(_React$Component){_inherits(Myprofiles,_React$Component);function Myprofiles(props){_classCallCheck(this,Myprofiles);var _this=_possibleConstructorReturn(this,(Myprofiles.__proto__||Object.getPrototypeOf(Myprofiles)).call(this,props));_initialiseProps.call(_this);var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();if(!currentUser){window.location.href="/";}//let displayUsername = currentUser.get("displayUsername");
var displayUsername='';if(currentUser){displayUsername=currentUser.get("displayUsername");}__WEBPACK_IMPORTED_MODULE_1_parse___default.a.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5","sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw");//PASTE HERE YOUR Back4App APPLICATION ID AND YOUR JavaScript KEY
__WEBPACK_IMPORTED_MODULE_1_parse___default.a.serverURL="https://parse.joelskitchen.com/parse";//Parse.serverURL = "https://parsetest.joelskitchen.com/parse";
var now=new Date();var getLoggedinUsername=localStorage.getItem('username');_this.state={usernameParam:0,userData:null,created_at:now.getTime(),comments:null,userImage:null,user:null,caption:null,likeCount:0,saveCount:0,commentCount:0,posts:{},width:0,height:0,getLoggedinUsername:getLoggedinUsername,saveposts:{},recipeposts:{},postsCount:0,followingCount:0,followersCount:0,followersListing:{},followingImages:{},challenges:{},followinguserid:[],searchTerm:'',searchfollowersListing:{},searchfollowingListing:{},followersCountPopup:0,followingCountPopup:0,isPopupOpen:false,post_common_id:'',isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:'',streamtabValue:'posts',streampagepath:'my-profile'};_this.updateWindowDimensions=_this.updateWindowDimensions.bind(_this);//this.setState({usernameParam: this.props.match.params.id});
//this.setState({usernameParam: displayUsername});
//this.usernameParam = this.props.match.params.id;
_this.usernameParam=displayUsername;//this.state.userData.get("website")
_this.queryForUserData();_this.checktabActive=_this.checktabActive.bind(_this);_this.handleUnFollowMyProfile=_this.handleUnFollowMyProfile.bind(_this);_this.handleFollowMyProfile=_this.handleFollowMyProfile.bind(_this);_this.handleSearch=_this.handleSearch.bind(_this);localStorage.setItem('storestreamtabValue','posts');localStorage.setItem('storestreampagepath','my-profile');return _this;}_createClass(Myprofiles,[{key:'componentDidMount',value:function componentDidMount(){this.updateWindowDimensions();window.addEventListener('resize',this.updateWindowDimensions);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.updateWindowDimensions);}},{key:'updateWindowDimensions',value:function updateWindowDimensions(){this.setState({width:window.innerWidth,height:window.innerHeight});}},{key:'queryForPosts',value:function queryForPosts(){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');query.include("user");query.include("image");query.include("thumbnail");query.include("likeCountNew");query.include("saveCount");query.include("commentcount");query.include("_created_at");query.include("createdAt");query.exists("user");query.exists("image");//added
query.exists("thumbnail");//added
query.doesNotExist("isChallenge");//added
query.descending("createdAt");query.limit(99999999999999999999999999);query.equalTo("user",this.state.userData);var self=this;query.find().then(function(result){if(result){self.setState({posts:result});var resultcount=result.length;if(resultcount!==undefined){self.setState({postsCount:resultcount});}}else{console.log("No post found");// promise.resolve(null);
}},function(error){console.error("Error loading post Error: "+error);//promise.error(error);
});}},{key:'queryForPostsRecipe',value:function queryForPostsRecipe(){/*var query = new Parse.Query('User');      
        query.equalTo("displayUsername", 'ben_dev');
        query.include("user");
        var self = this;    
        query.first().then(function(user){
            if(user){ 
              var getRecipequery = new Parse.Query('Photo');  
                  getRecipequery.exists('recipeV2');
                  getRecipequery.equalTo('user',user);
                  getRecipequery.find().then(function(recipe){
                  if(recipe)
                  {          
                    self.setState({recipeposts: recipe});
                  }
                 })            
                }
        })*/var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();var self=this;if(currentUser){var getRecipequery=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');// getRecipequery.exists('recipeV2');
getRecipequery.exists('isRecipe');getRecipequery.equalTo('user',currentUser);getRecipequery.doesNotExist("isChallenge");getRecipequery.descending("_created_at");getRecipequery.find().then(function(recipe){if(recipe){self.setState({recipeposts:recipe});}});}}},{key:'queryForChallenges',value:function queryForChallenges(){var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();var self=this;if(currentUser){var getChallengequery=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');getChallengequery.exists('isChallengeWinner');//getChallengequery.exists('isChallengeEntry');
getChallengequery.include('isChallengeWinner');getChallengequery.equalTo('isChallengeWinner',true);getChallengequery.equalTo('user',currentUser);getChallengequery.find().then(function(challenge){if(challenge){self.setState({challenges:challenge});}});}}},{key:'queryForPostsSave',value:function queryForPostsSave(){var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();var self=this;if(currentUser){/*const Save = Parse.Object.extend('Save');
        const query = new Parse.Query(Save);
      
        query.equalTo("fromUser","_User$"+currentUser.id);
        query.include('Photo');*///let savequerydata=[];
/*query.find().then(function(resultSave){
                 if(resultSave)
                 {
                      resultSave.forEach(results => {
                          var photodata = new Parse.Query('Photo');  
                              photodata.equalTo('objectId',results.get('photo').id);
                              photodata.find().then(function(photos){

                              if(photos[0]!=undefined)
                              {    
                                   savequerydata.push(photos[0]);
                              }
                             })
                      })
                    self.setState({saveposts: savequerydata});
                    
                    console.log(savequerydata);
                 }
             }) *//*new code*/var Save=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.Object.extend('Save');var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query(Save);// query1.equalTo("fromUser","_User$"+currentUser.id);
query.equalTo("fromUser","_User$"+currentUser.id);query.exists('photo');query.include('photo');query.include("image");query.doesNotExist("isChallenge");//added
/* query.include('photo');
        query.select("photo.image");
        query.select("photo.isChallengeWinner");
        query.select("photo.isChallengeEntry");
        query.select("photo.isRecipe");*/query.descending("_created_at");var self=this;query.find().then(function(results){if(results){self.setState({saveposts:results});}});/*new code*/}}},{key:'queryGetFollowersFollowing',value:function queryGetFollowersFollowing(){var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Activity');query.include("user");query.include("image");query.include("toUser");query.include("thumbnail");query.equalTo("type","follow");query.equalTo("fromUser",currentUser);var self=this;query.find().then(function(result){if(result){var resultcount=result.length;var followingdataresult1=[];if(resultcount>0){var userdataresult1=[];self.setState({followingCount:resultcount});self.setState({followingCountPopup:resultcount});for(var i=0;i<resultcount;i++){var user=result[i];var userimage='';if(user.get("toUser").get("profilePictureSmall")&&user.get("toUser").get("profilePictureSmall").url()!==undefined){userimage=user.get("toUser").get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}userdataresult1.push({'id':user.get("toUser").id,'displayName':user.get("toUser").get("displayName"),'displayUsername':user.get("toUser").get("displayUsername"),'image':userimage,'fromUser':user.get("fromUser").id});followingdataresult1.push({'id':user.get("toUser").id,'name':user.get("toUser").id});self.setState({followinguserid:followingdataresult1});self.setState({followingImages:userdataresult1});self.setState({searchfollowingListing:userdataresult1});}}else{self.setState({followingImages:[]});self.setState({followingCount:0});self.setState({followinguserid:[]});self.setState({followingCountPopup:0});}}});//followingImages
//followers
var followersquery=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Activity');followersquery.include("user");followersquery.include("fromUser");followersquery.include("image");followersquery.include("thumbnail");followersquery.equalTo("type","follow");followersquery.equalTo("toUser",currentUser);var self=this;followersquery.find().then(function(followerresult){if(followerresult){var resultcount=followerresult.length;if(resultcount>0){var userdataresult=[];self.setState({followersCount:resultcount});self.setState({followersCountPopup:resultcount});//self.setState({followersListing:'followerresult'});
for(var i=0;i<resultcount;i++){var Images=null;var user=followerresult[i];if(user.get("fromUser").get("profilePictureSmall")&&user.get("fromUser").get("profilePictureSmall").url()!==undefined){Images=user.get("fromUser").get("profilePictureSmall").url();}userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images,'toUser':user.get("toUser").id});//self.setState({followersListing:resultcount});
}self.setState({followersListing:userdataresult});self.setState({searchfollowersListing:userdataresult});}}});}}},{key:'queryForUserData',value:function queryForUserData(){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('User');query.equalTo("displayUsername",this.usernameParam);// query.equalTo("displayUsername", 'cinnamonshtick');
query.include("user");query.include("image");query.include("thumbnail");query.include("likeCountNew");query.include("saveCount");query.include("commentcount");query.include("_created_at");query.include("createdAt");query.include("recipe");query.include("product");query.include("collabUser");query.include("collabUser.displayUsername");query.ascending("name");var self=this;query.first().then(function(result){if(result){self.setState({userData:result});self.setState({user:result});var profilePictureSmall='';if(result.get("profilePictureSmall")){self.setState({userImage:result.get("profilePictureSmall").url()});}self.queryForPosts();self.queryForPostsSave();self.queryForPostsRecipe();self.queryForChallenges();self.queryGetFollowersFollowing();}else{console.log("No post found");// promise.resolve(null);
}},function(error){console.error("Error loading post Error: "+error);//promise.error(error);
});}},{key:'getWebsite',value:function getWebsite(){var website=this.state.userData.get("website");if(!website)return"";else if(website.includes("http://"))return website;else if(website.includes("https://"))return website;else return"https://"+website;}},{key:'renderPosts',value:function renderPosts(){var _this2=this;var buffer=[];var savebuffer=[];var recipebuffer=[];var challengebuffer=[];var bufferfollowers=[];var bufferfollowing=[];var isPopupOpen=this.state.isPopupOpen;var postcommonid=this.state.post_common_id;var isNotificationOpen=this.state.isNotificationOpen;var post_Notification_Ids=this.state.post_Notification_Id;var post_Notification_Msg=this.state.post_Notification_Msg;var post_Notification_Comment=this.state.post_Notification_Comment;var togglePopup=function togglePopup(postid){_this2.setState(function(prevState){return{isPopupOpen:!prevState.isPopupOpen};});_this2.setState({post_common_id:postid});};var streamid=function streamid(postid){localStorage.setItem('storestreamid',postid);};/*new code*/var postRecord=[];if(this.state.posts){var _loop=function _loop(){post=_this2.state.posts[i];var postdata_id=post&&post.id;var postdata_image=post&&post.get("image")&&post.get("image").url();// if(postdata_image) {
postRecord.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPost',key:69*3*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{id:postdata_id,href:'/stream',onClick:function onClick(e){streamid(postdata_id);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'chlng-icon'},post&&post.get("isChallengeWinner")&&post.get("isChallengeWinner")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'winner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/winner-icon-img.svg'})),post&&post.get("isRecipe")&&post.get("isRecipe")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'recipe'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/recipe-icon-img.svg'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{className:'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:postdata_image})))));// }
};for(var i=0;i<this.state.posts.length;i++){var post;_loop();}}/*new code*//*if (this.state.posts)
        {
           
            var rows = Math.floor(this.state.posts.length / 3) + 1;
            for (var i = 0; i < rows; i++)
            {
                
                var post = this.state.posts[i * 3];
                var post2 = this.state.posts[(i * 3)+1];
                var post3 = this.state.posts[(i * 3)+2];
                var post4 = this.state.posts[(i * 3)+3];               

               if ((post !== undefined   && post.get('image')) && 
                    (post2 !== undefined   && post2.get('image'))  && 
                    (post3 !== undefined   && post3.get('image')) 
                    )
                {
                    buffer.push(<div className="gridPostRow" key={69*i}>
 
                            <div className="gridPost" key={69*3*i}>

                                <a href={"/post/"+post.id}>

  
                             <div className='chlng-icon'>
                       
                                {post.get("isChallengeWinner") && post.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                             
                                {post.get("isRecipe") && post.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                   
                                    
                                    <figure className='thumbnail'>
                                        <img src={post.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                           
                                <a href={"/post/"+post2.id}>
                                 <div className='chlng-icon'>
                             
                                {post2.get("isChallengeWinner") && post2.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                           
                                {post2.get("isRecipe") && post2.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={post2.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                               <a href={"/post/"+post3.id}>
                                 <div className='chlng-icon'>
                             
                                {post3.get("isChallengeWinner") && post3.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                            
                                {post3.get("isRecipe") && post3.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={post3.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                        

                            </div>);
                }
                else if ((post != undefined) && (post.get("image")) &&
                    (post2 != undefined) && (post2.get("image")))
                {
                    buffer.push(<div className="gridPostRow" key={69*i}>

                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+post.id}>
                                  <div className='chlng-icon'>
                             
                                {post.get("isChallengeWinner") && post.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                             
                                {post.get("isRecipe") && post.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={post.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                               <a href={"/post/"+post2.id}>
                                 <div className='chlng-icon'>
                              
                                {post2.get("isChallengeWinner") && post2.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                              
                                {post2.get("isRecipe") && post2.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={post2.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>
                            </div>
                          

                            </div>);
                }
                else if ((post != undefined) && (post.get("image")))
                {
                    buffer.push(<div className="gridPostRow" key={69*i}>

                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+post.id}>
                                 <div className='chlng-icon'>
                           
                                {post.get("isChallengeWinner") && post.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                             
                                {post.get("isRecipe") && post.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img className="gridPost" src={post.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>
                          

                            </div>);
                }
               
            }
        }*//*if (this.state.saveposts)
        { 
          
            var savepostsrows =  Math.floor(this.state.saveposts.length / 3) + 1;
            
            for (var i = 0; i < savepostsrows; i++)
            { 
              
                var savepost =  this.state.saveposts[i * 3];
                var savepost2 = this.state.saveposts[(i * 3)+1];
                var savepost3 = this.state.saveposts[(i * 3)+2];
              
                 if ((savepost && savepost.get('photo') && savepost.get('photo')!=='undefined') && (savepost2 && savepost2.get('photo') && savepost2.get('photo')!=='undefined') && (savepost3 && savepost3.get('photo') && savepost3.get('photo')!=='undefined') ) 
                    
                {
                  
                    savebuffer.push(<div className="gridPostRow" key={69*i}>
 
                            <div className="gridPost" key={69*3*i}>
                          
                                <a   href={"/post/"+savepost.get('photo').id}>
                                  <div className='chlng-icon'>
                                {savepost.get('photo').get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                            
                                {savepost.get('photo').get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={savepost.get('photo').get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                          
                            <div className="gridPost" key={69*3*(i+1)}>
                               <a  href={"/post/"+savepost.get('photo').id} >
                                <div className='chlng-icon'>
                                {savepost2.get('photo').get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                             
                                 {savepost2.get('photo').get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={savepost2.get('photo').get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                             <a   href={"/post/"+savepost.get('photo').id}>
                              <div className='chlng-icon'>
                                {savepost3.get('photo').get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                           
                                 {savepost3.get('photo').get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={savepost3.get('photo').get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                         

                            </div>);
                }
                else if ((savepost && savepost.get('photo') && savepost.get('photo')!=='undefined') && (savepost2 && savepost2.get('photo') && savepost2.get('photo')!=='undefined'))
                {
                    savebuffer.push(<div className="gridPostRow" key={69*i}>

                            <div className="gridPost" key={69*3*i}>
                               <a   href={"/post/"+savepost.get('photo').id}>
                                 <div className='chlng-icon'>
                                {savepost.get('photo').get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                             
                                 {savepost.get('photo').get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={savepost.get('photo').get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                              <a    href={"/post/"+savepost.get('photo').id}>
                               <div className='chlng-icon'>
                                {savepost2.get('photo').get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                             
                                 {savepost2.get('photo').get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={savepost2.get('photo').get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>
                            </div>
                        

                            </div>);
                }
                else if ((savepost && savepost.get('photo') && savepost.get('photo')!=='undefined'))
                {
                   

                    savebuffer.push(<div className="gridPostRow" key={69*i}>
                            <div className="gridPost" key={69*3*i}>
                              <a   href={"/post/"+savepost.get('photo').id} >
                                <div className='chlng-icon'>
                                {savepost.get('photo').get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                                
                                {savepost.get('photo').get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img className="gridPost" src={savepost.get('photo').get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>
                       
                            </div>);
                }
            }  
        }*//*new code*/var saveRecord=[];if(this.state.saveposts){var _loop2=function _loop2(){post=_this2.state.saveposts[i];var postdata_id=post.get('photo')&&post.get('photo').id;var postdata_image=post.get("photo")&&post.get('photo').get("image").url();if(postdata_image){saveRecord.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPost',key:69*3*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/stream',id:postdata_id,onClick:function onClick(e){streamid(postdata_id);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'chlng-icon'},post.get('photo')&&post.get('photo').get("isChallengeWinner")&&post.get('photo').get("isChallengeWinner")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'winner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/winner-icon-img.svg'})),post.get('photo')&&post.get('photo').get("isRecipe")&&post.get('photo').get("isRecipe")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'recipe'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/recipe-icon-img.svg'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{className:'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:postdata_image})))));}};for(var i=0;i<this.state.saveposts.length;i++){var post;_loop2();}}/*new code*//*new code*/var recipeRecord=[];if(this.state.recipeposts){var _loop3=function _loop3(){post=_this2.state.recipeposts[i];var postdata_id=post&&post.id;var postdata_image=post&&post.get("image")&&post.get("image").url();{/*href = "javascript:void(0);" id={postdata_id} onClick={(e) => {togglePopup(postdata_id);}}*/}recipeRecord.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPost',key:69*3*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/stream',id:postdata_id,onClick:function onClick(e){streamid(postdata_id);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'chlng-icon'},post&&post.get("isChallengeWinner")&&post.get("isChallengeWinner")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'winner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/winner-icon-img.svg'})),post&&post.get("isRecipe")&&post.get("isRecipe")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'recipe'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/recipe-icon-img.svg'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{className:'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:postdata_image})))));};for(var i=0;i<this.state.recipeposts.length;i++){var post;_loop3();}}/*new code*/if(this.state.recipeposts){var reciperows=Math.floor(this.state.recipeposts.length/3)+1;for(var i=0;i<reciperows;i++){var recipepost=this.state.recipeposts[i*3];var recipepost2=this.state.recipeposts[i*3+1];var recipepost3=this.state.recipeposts[i*3+2];var recipepost4=this.state.recipeposts[i*3+3];if(recipepost!==undefined&&recipepost.get('image')&&recipepost2!==undefined&&recipepost2.get('image')&&recipepost3!==undefined&&recipepost3.get('image')){recipebuffer.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPostRow',key:69*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPost',key:69*3*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:"/post/"+recipepost.id},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'chlng-icon'},recipepost.get("isChallengeWinner")!==undefined&&recipepost.get("isChallengeWinner")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'winner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/winner-icon-img.svg'})),recipepost.get("isRecipe")!==undefined&&recipepost.get("isRecipe")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'recipe'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/recipe-icon-img.svg'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{className:'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:recipepost.get("image").url()})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPost',key:69*3*(i+1)},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:"/post/"+recipepost2.id},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'chlng-icon'},recipepost2.get("isChallengeWinner")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'winner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/winner-icon-img.svg'})),recipepost2.get("isRecipe")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'recipe'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/recipe-icon-img.svg'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{className:'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:recipepost2.get("image").url()})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPost',key:69*3*(i+2)},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:"/post/"+recipepost3.id},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'chlng-icon'},recipepost3.get("isChallengeWinner")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'winner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/winner-icon-img.svg'})),recipepost3.get("isRecipe")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'recipe'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/recipe-icon-img.svg'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{className:'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:recipepost3.get("image").url()}))))));}else if(recipepost!==undefined&&recipepost.get('image')&&recipepost2!==undefined&&recipepost2.get('image')){recipebuffer.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPostRow',key:69*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPost',key:69*3*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:"/post/"+recipepost.id},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'chlng-icon'},recipepost.get("isChallengeWinner")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'winner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/winner-icon-img.svg'})),recipepost.get("isRecipe")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'recipe'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/recipe-icon-img.svg'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{className:'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:recipepost.get("image").url()})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPost',key:69*3*(i+1)},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:"/post/"+recipepost2.id},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'chlng-icon'},recipepost2.get("isChallengeWinner")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'winner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/winner-icon-img.svg'})),recipepost2.get("isRecipe")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'recipe'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/recipe-icon-img.svg'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{className:'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:recipepost2.get("image").url()})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPost',key:69*3*(i+2)},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{className:'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'gridPost',src:'/images/emptygrid.png'})))));}else if(recipepost!==undefined&&recipepost.get('image')){recipebuffer.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPostRow',key:69*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPost',key:69*3*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:"/post/"+recipepost.id},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'chlng-icon'},recipepost.get("isChallengeWinner")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'winner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/winner-icon-img.svg'})),recipepost.get("isRecipe")===true&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'recipe'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'../images/recipe-icon-img.svg'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{className:'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'gridPost',src:recipepost.get("image").url()})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPost',key:69*3*(i+1)},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{className:'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'gridPost',src:'/images/emptygrid.png'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPost',key:69*3*(i+2)},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('figure',{className:'thumbnail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'gridPost',src:'/images/emptygrid.png'})))));}}}/*if (this.state.challenges)
        {
            var rows = Math.floor(this.state.challenges.length / 3) + 1;
            for (var i = 0; i < rows; i++)
            {
               
                var post = this.state.challenges[i * 3];
                var post2 = this.state.challenges[(i * 3)+1];
                var post3 = this.state.challenges[(i * 3)+2];
                var post4 = this.state.challenges[(i * 3)+3];               
              if ((post !== undefined   && post.get('image')) && 
                    (post2 !== undefined   && post2.get('image'))  && 
                    (post3 !== undefined   && post3.get('image')) 
                    )
                {
                    challengebuffer.push(<div className="gridPostRow" key={69*i}> 
 
                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+post.id}>
                                    <div className='chlng-icon'>
                                       
                                     {post.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                                    </div>
                                    <figure className='thumbnail'>
                                        <img src={post.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                                <a href={"/post/"+post2.id}>
                                    <div className='chlng-icon'>
                                      
                                    {post2.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                                   
                                    </div>
                                    <figure className='thumbnail'>
                                        <img src={post2.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                               <a href={"/post/"+post3.id}>
                                    <div className='chlng-icon'>
                                      
                                    {post3.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                                   
                                        
                                    </div>
                                    <figure className='thumbnail'>
                                        <img src={post3.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>

                            </div>);
                }
                else if ((post != undefined) && (post.get("image")) &&
                    (post2 != undefined) && (post2.get("image")))
                {
                    challengebuffer.push(<div className="gridPostRow" key={69*i}>

                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+post.id}>
                                    <div className='chlng-icon'>    
                                    
                                    {post.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                                    </div>
                                    <figure className='thumbnail'>
                                        <img src={post.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                               <a href={"/post/"+post2.id}>
                                    <div className='chlng-icon'>
                                     
                                    {post2.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                                    </div>
                                    <figure className='thumbnail'>
                                        <img src={post2.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>
                            </div>

                            </div>);
                }
                else if ((post != undefined) && (post.get("image")))
                {
                    challengebuffer.push(<div className="gridPostRow" key={69*i}>

                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+post.id}>
                                 <div className='chlng-icon'>    
                                   
                                 {post.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                                    
                                    </div>
                                    <figure className='thumbnail'>
                                        <img className="gridPost" src={post.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>

                            </div>);
                }
               
            }
        }*/if(this.state.followersListing){var followinguserid=this.state.followinguserid;var following_match_id=[];var rows=this.state.followersListing.length;if(rows!=undefined){for(var i=0;i<rows;i++){var followers=this.state.followersListing[i];var follow_id_ms='followpopup_'+followers.id;var userimage=null;if(followers.image){userimage=followers.image;}else{userimage="/images/default_userpic0.png";}var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();var currentUserid=currentUser.id;var chek=followinguserid.find(function(c){return c.id===followers.id;});//'K1iL8XNQOd'  
var followingresults=chek!=undefined?JSON.parse(JSON.stringify(chek)):"";bufferfollowers.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'items',key:69*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'box follow-usr'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-left'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'mr-3',src:userimage,alt:'Generic placeholder image'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5',{className:'m-0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/user/'+followers.displayUsername},followers.displayName,' ')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,followers.displayUsername))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'action cta_btn'},currentUserid===followers.id?"":followingresults.id===followers.id?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'fourth-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);'},'Following')):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'third-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{id:follow_id_ms,title:followers.toUser,'data-id':followers.id,onClick:function onClick(e){return _this2.handleFollowMyProfile(e);},style:{display:"block"},href:'javascript:void(0);',className:'followpost_linkpopup'},'Follow'))))));}}}if(this.state.followingImages){var rows=this.state.followingImages.length;if(rows!=undefined||rows!=0){for(var i=0;i<rows;i++){var followers=this.state.followingImages[i];//console.log(followers.id+'followers.fromUser');
var follow_id_ms='followpopup_'+followers.id;//'followpopup_'+followers.get("fromUser").id;
var _userimage=null;var _currentUserid=null;if(followers.image){_userimage=followers.image;}else{_userimage="/images/default_userpic0.png";}var _currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();/*if(currentUser)
               {  
                  currentUserid=currentUser.id;            
                  var checksavequery = new Parse.Query('Activity');  
                     checksavequery.equalTo('type', 'follow'); 
                    // checksavequery.equalTo('toUser', "_User$"+followers.get("fromUser").id);
                     checksavequery.equalTo('toUser', "_User$"+followers.id);
                     checksavequery.equalTo('fromUser',"_User$"+currentUserid);
                     checksavequery.find().then(function(resultAct){   
                     let activityresult=resultAct[0];   
                     if(activityresult)
                     { 
                        //$('#follwerModal a.unfollowpost_linkpopup#followpopup_'+followers.get("fromUser").id).attr("style", "display: block");
                       // $('#follwerModal a.followpost_linkpopup#followpopup_'+followers.get("fromUser").id).attr("style", "display: none");
                        $('#follwerModal a.followpost_linkpopup#followpopup_'+followers.id).attr("style", "display: none");
                     }
                    })
                      
               }*/if(followers.id){bufferfollowing.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'items',key:69*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'box follow-usr'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-left'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'mr-3',src:_userimage,alt:'Generic placeholder image'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5',{className:'m-0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/user/'+followers.displayUsername},followers.displayName),' '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,followers.displayUsername))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'third-btn btn-wrp'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{id:follow_id_ms,title:'UnFollow','data-id':followers.id,onClick:function onClick(e){return _this2.handleUnFollowMyProfile(e);},style:{display:"block"},href:'javascript:void(0);',className:'unfollowpost_linkpopup'},'Unfollow '))))));}}}}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'post_grid-tab'},'  ',isNotificationOpen?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__saveNotification_jsx__["a" /* default */],{isOpen:isNotificationOpen,postNotificationid:post_Notification_Ids,postMsg:post_Notification_Msg,postPhotoid:post_Notification_Ids,postActivityComment:post_Notification_Comment}):"",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CommonPopup_jsx__["a" /* default */],{isOpen:isPopupOpen,onClose:function onClose(e){togglePopup(postcommonid);},postcommonid:postcommonid}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'nav nav-tabs',id:'myTab',role:'tablist'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'nav-item',role:'presentation'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'nav-link active',onClick:function onClick(){return _this2.updateTabValue('posts');},id:'posts-tab','data-toggle':'tab','data-target':'#posts',type:'button',role:'tab','aria-controls':'posts','aria-selected':'true'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'gridPost def',src:'/images/tab_prf_posts.svg',alt:'posts'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'gridPost act',src:'/images/tab_prf_posts_actv.svg',alt:'posts'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,'posts'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'nav-item',role:'presentation'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'nav-link',id:'recipes-tab',onClick:function onClick(){return _this2.updateTabValue('recipes');},'data-toggle':'tab','data-target':'#recipes',type:'button',role:'tab','aria-controls':'recipes','aria-selected':'false'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'gridPost def',src:'/images/tab_prf_recipes.svg',alt:'recipes'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'gridPost act',src:'/images/tab_prf_recipes_actv.svg',alt:'recipes'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,'recipes'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'nav-item',role:'presentation'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'nav-link',id:'saved-tab','data-toggle':'tab','data-target':'#saved',onClick:function onClick(){return _this2.updateTabValue('saved');},type:'button',role:'tab','aria-controls':'saved','aria-selected':'false'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'gridPost def',src:'/images/tab_prf_bookmark.svg',alt:'savedy'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'gridPost act',src:'/images/tab_prf_bookmark_actv.svg',alt:'savedy'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,'saved')))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tab-content',id:'myTabContent'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tab-pane fade show active',id:'posts',role:'tabpanel','aria-labelledby':'posts-tab'},' ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPostRow'},'  ',postRecord,'  ')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tab-pane fade',id:'recipes',role:'tabpanel','aria-labelledby':'recipes-tab'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPostRow'},'   ',recipeRecord)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tab-pane fade',id:'saved',role:'tabpanel','aria-labelledby':'saved-tab'},' ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'gridPostRow'},'  ',saveRecord,' '))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal fade post_modal follwerModal',id:'follwerModal',tabIndex:'-1',role:'dialog','data-backdrop':'true','data-keyboard':'true','aria-labelledby':'createPostCloseTitle','aria-hidden':'false'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{type:'button',className:'close','data-dismiss':'modal','aria-label':'Modal'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/back-arrow.svg',alt:'Close'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'search_wrap'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('form',{className:'form-mn d-flex flex-row flex-wrap'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{className:'form-control',type:'search',placeholder:'Search','aria-label':'Search',value:this.state.searchTerm,onChange:this.handleSearch}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{type:'submit'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'/images/search.svg',alt:'Search'}))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tab-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'nav nav-tabs',id:'usrfollwerTabs',role:'tablist'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'nav-item'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{className:'nav-link active',id:'usrFlwrsTabs','data-toggle':'tab',href:'#usrFlwrsPane',role:'tab','aria-controls':'usrFlwrsPane','aria-selected':'true'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,this.state.followersCountPopup),' Followers')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'nav-item'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{className:'nav-link',id:'usrFlwingTabs','data-toggle':'tab',href:'#usrFlwingPane',role:'tab','aria-controls':'usrFlwingPane','aria-selected':'true'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,this.state.followingCountPopup),' Following'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tab-content',id:'usrfollwerPanel'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tab-pane fade show active',id:'usrFlwrsPane',role:'tabpanel','aria-labelledby':'usrFlwrsTabs'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'list-wrap'},bufferfollowers)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tab-pane fade',id:'usrFlwingPane',role:'tabpanel','aria-labelledby':'usrFlwingTabs'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'list-wrap'},bufferfollowing)))))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-backdrop fade show'})));}},{key:'getImpressionCount',value:function getImpressionCount(){if(this.state.userData.get("impr"))return this.state.userData.get("impr").toLocaleString(navigator.language,{minimumFractionDigits:0});else return 2;}},{key:'renderProfileMain',value:function renderProfileMain(){if(this.state.width<=860){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'porfile_card'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'user_detail d-flex flex-row flex-wrap'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'thumbnail'},this.state.userImage!==null?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{height:'150',width:'150',className:'userProfileImageLarge',src:this.state.userImage,alt:'Profile Picture'}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{height:'150',width:'150',src:'/images/default_userpic0.png',alt:'Profile Picture'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'detail d-flex flex-column flex-wrap justify-content-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'title-part d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'name'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h1',null,this.state.userData.get("displayUsername"))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'mobile_action'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'action cta_btn d-flex flex-row flex-wrap align-items-center justify-content-end'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'fourth-btn btn-wrp'},this.state.getLoggedinUsername!=null?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/edit-profile',title:'Edit Profile'},'Edit Profile'):''))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'post-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'postcount'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,this.state.postsCount),'Posts')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'follwer'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'#usrFlwrsPane',type:'button','data-toggle':'modal','data-id':'#usrFlwrsTabs',onClick:this.checktabActive,'data-target':'#follwerModal'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,this.state.followersCount),'Followers'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'follwing'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{onClick:this.checktabActive,href:'#usrFlwingPane','data-id':'#usrFlwingTabs',type:'button','data-toggle':'modal','data-target':'#follwerModal'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,this.state.followingCount),'Following')))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'bio_detail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'dname'},this.state.userData.get("displayName")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'dbio'},this.state.userData.get("bio")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'web'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:this.getWebsite()},this.getWebsite()))));}else{return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'porfile_card'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'user_detail d-flex flex-row flex-wrap'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'thumbnail'},this.state.userImage!==null?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{height:'150',width:'150',className:'userProfileImageLarge',src:this.state.userImage,alt:'Profile Picture'}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{height:'150',width:'150',src:'/images/default_userpic0.png',alt:'Profile Picture'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'detail d-flex flex-column flex-wrap justify-content-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'title-part d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'name'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h1',null,this.state.userData.get("displayUsername"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'action cta_btn d-flex flex-row flex-wrap align-items-center justify-content-end'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'fourth-btn btn-wrp'},this.state.getLoggedinUsername!=null?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/edit-profile',title:'Edit Profile'},'Edit Profile'):''))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'post-part'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'postcount'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,this.state.postsCount),'Posts')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'follwer'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'#usrFlwrsPane',type:'button','data-toggle':'modal','data-id':'#usrFlwrsTabs',onClick:this.checktabActive,'data-target':'#follwerModal'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,this.state.followersCount),'Followers'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'follwing'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{onClick:this.checktabActive,href:'#usrFlwingPane','data-id':'#usrFlwingTabs',type:'button','data-toggle':'modal','data-target':'#follwerModal'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,this.state.followingCount),'Following'))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'bio_detail'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'dname'},this.state.userData.get("displayName")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'dbio'},this.state.userData.get("bio")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'web'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:this.getWebsite()},this.getWebsite()))))));}}},{key:'render',value:function render(){var likesWord="likes";var savesWord="saves";var commentsWord="comments";if(this.state.likeCount==1)likesWord="like";if(this.state.saveCount==1)savesWord="save";if(this.state.commentCount==1)commentsWord="comment";if(!this.state.userData){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null);}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('section',{className:'post_list'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('nav',{className:'sidebar'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Leftsidebar_jsx__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('main',{className:'listing myprofile-listing'},this.renderProfileMain(),this.renderPosts()))));}}]);return Myprofiles;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/*class Myprofiles extends React.Component {
    render() {
    return (
        <div className="App">
        <div className="mainProfileWrapper">
          <div className="mainProfileColumn">adaffa

         

            <center>


            </center>
          </div>
        </div>
       
         
        </div>

    );
  }
}*/var _initialiseProps=function _initialiseProps(){var _this3=this;this.toggleNotification=function(postid,msg,comment){//console.log('toggleNotification'+postid);
var self=_this3;self.setState(function(prevState){return{isNotificationOpen:!prevState.isNotificationOpen,post_Notification_Id:postid,post_Notification_Msg:msg,post_Notification_Comment:comment};});//self.setState({ post_Notification_Id: postid });        
};this.handleSearch=function(event){var searchTerm=event.target.value;var followersListings=_this3.state.followersListing;var searchfollowersListing=_this3.state.searchfollowersListing;var followersListing=searchfollowersListing.filter(function(item){return item.displayName.toLowerCase().includes(searchTerm.toLowerCase());}//item.get('fromUser').get('displayUsername').toLowerCase().includes(searchTerm.toLowerCase())
);_this3.setState({searchTerm:searchTerm});_this3.setState({followersListing:followersListing});_this3.setState({followersCountPopup:followersListing.length});//followingImages1
var followingListings=_this3.state.followingImages;var searchfollowingListing=_this3.state.searchfollowingListing;var followingListing=searchfollowingListing.filter(function(item){return item.displayName.toLowerCase().includes(searchTerm.toLowerCase());}// item.displayUsername.toLowerCase().includes(searchTerm.toLowerCase())
);_this3.setState({followingImages:followingListing});_this3.setState({followingCountPopup:followingListing.length});//searchfollowingListing
if(searchTerm===''){_this3.queryGetFollowersFollowing();}};this.handleFollowMyProfile=function(e){var datapost_id=e.target.dataset.id;var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();if(currentUser){var self=_this3;var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('User');query.equalTo("objectId",datapost_id);query.first().then(function(result){if(result){var touser=result;//var Activity = Parse.Object.extend("Activity");
//var activity = new Activity();
//activity.equalTo('fromUser', "_User$"+datapost_id);
//activity.set('toUser', touser);    
//activity.equalTo('toUser', "_User$"+datapost_id);    
//activity.equalTo('toUser', "_User$"+currentUser.id);         
// activity.equalTo('type', 'follow');    
var Activity=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.Object.extend("Activity");var activity=new Activity();activity.set('fromUser',currentUser);activity.set('toUser',touser);activity.set('type','follow');activity.save().then(function(savedFile){setTimeout(function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.unfollowpost_link#follow_'+datapost_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.followpost_link#follow_'+datapost_id).attr("style","display: none");},500);self.toggleNotification(touser,'started following you.','');self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});/*setTimeout(() => {
                         this.queryGetFollowersFollowing();
                      },500);*/}).catch(function(error){});}});setTimeout(function(){_this3.queryGetFollowersFollowing();},1000);}else{// $('#kitchenQrModal_btn').trigger('click');  
return false;}};this.handleUnFollowMyProfile=function(e){var datapost_id=e.target.dataset.id;var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('User');query.equalTo("objectId",datapost_id);query.first().then(function(result){if(result){var touser=result;var checksavequery=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Activity');checksavequery.equalTo('type','follow');checksavequery.equalTo('toUser',"_User$"+datapost_id);checksavequery.equalTo('fromUser',currentUser);checksavequery.first().then(function(object){if(object){//console.log(object);
return object.destroy();}}).then(function(deletedObject){//$('#follwerModal a.followpost_linkpopup#followpopup_'+touser.id).attr("style", "display: block");
//$('#follwerModal a.unfollowpost_linkpopup#followpopup_'+touser.id).attr("style", "display: none");
}).catch(function(error){console.error('Error deleting record:',error);});}});setTimeout(function(){_this3.queryGetFollowersFollowing();},2000);}else{// $('#kitchenQrModal_btn').trigger('click');  
return false;}};this.checktabActive=function(e){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.modal-backdrop').remove();var activetab=e.target.dataset.id;if(activetab==='#usrFlwrsTabs'){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#follwerModal li.nav-item a.nav-link#usrFlwrsTabs').addClass('active show');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#follwerModal li.nav-item a.nav-link#usrFlwingTabs').removeClass('active show');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#follwerModal #usrfollwerPanel #usrFlwrsPane').addClass('active show');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#follwerModal #usrfollwerPanel #usrFlwingPane').removeClass('active show');}if(activetab==='#usrFlwingTabs'){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#follwerModal li.nav-item a.nav-link#usrFlwingTabs').addClass('active show');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#follwerModal li.nav-item a.nav-link#usrFlwrsTabs').removeClass('active show');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#follwerModal #usrfollwerPanel #usrFlwrsPane').removeClass('active show');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#follwerModal #usrfollwerPanel #usrFlwingPane').addClass('active show');}};this.updateTabValue=function(newValue){/*var url = window.location.href;
    if(url.includes('my-profile'))
    {
      this.setState({ streampagepath: 'my-profile' });
    }*///this.setState({ streamtabValue: newValue });
localStorage.setItem('storestreamtabValue',newValue);};};/* harmony default export */ __webpack_exports__["a"] = (Myprofiles);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__global_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__singlepost_jsx__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Leftsidebar_jsx__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function time_ago(time){switch(typeof time==='undefined'?'undefined':_typeof(time)){case'number':break;case'string':time=+new Date(time);break;case'object':if(time.constructor===Date)time=time.getTime();break;default:time=+new Date();}var time_formats=[[60,'seconds',1],// 60
[120,'1 minute ago','1 minute from now'],// 60*2
[3600,'minutes',60],// 60*60, 60
[7200,'1 hour ago','1 hour from now'],// 60*60*2
[86400,'hours',3600],// 60*60*24, 60*60
[172800,'Yesterday','Tomorrow'],// 60*60*24*2
[604800,'days',86400],// 60*60*24*7, 60*60*24
[1209600,'Last week','Next week'],// 60*60*24*7*4*2
[2419200,'weeks',604800],// 60*60*24*7*4, 60*60*24*7
[4838400,'Last month','Next month'],// 60*60*24*7*4*2
[29030400,'months',2419200],// 60*60*24*7*4*12, 60*60*24*7*4
[58060800,'Last year','Next year'],// 60*60*24*7*4*12*2
[2903040000,'years',29030400],// 60*60*24*7*4*12*100, 60*60*24*7*4*12
[5806080000,'Last century','Next century'],// 60*60*24*7*4*12*100*2
[58060800000,'centuries',2903040000]// 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
];var seconds=(+new Date()-time)/1000,token='ago',list_choice=1;if(seconds==0){return'Just now';}if(seconds<0){seconds=Math.abs(seconds);token='from now';list_choice=2;}var i=0,format;while(format=time_formats[i++]){if(seconds<format[0]){if(typeof format[2]=='string')return format[list_choice];else return Math.floor(seconds/format[2])+' '+format[1]+' '+token;}}return time;}var Explorer=function(_React$Component){_inherits(Explorer,_React$Component);function Explorer(props){_classCallCheck(this,Explorer);var _this=_possibleConstructorReturn(this,(Explorer.__proto__||Object.getPrototypeOf(Explorer)).call(this,props));__WEBPACK_IMPORTED_MODULE_1_parse___default.a.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5","sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw");__WEBPACK_IMPORTED_MODULE_1_parse___default.a.serverURL="https://parse.joelskitchen.com/parse";//Parse.serverURL = "https://parsetest.joelskitchen.com/parse";
var now=new Date();_this.state={posts:{},users:{},created_at:now.getTime()};_this.queryForPostData();_this.getSuggestedUsers();_this.homeFetch=_this.homeFetch.bind(_this);return _this;}_createClass(Explorer,[{key:'homeFetch',value:function homeFetch(event){// setTimeout(() => {
this.queryForPostData();//  },500);
}},{key:'getSuggestedUsers',value:function getSuggestedUsers(){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('User');query.equalTo('isSuggested',1);query.include("username");query.descending('_created_at');var self=this;query.find().then(function(result){if(result){self.setState({users:result});}else{console.log("No user found");}},function(error){console.error("Error loading post Error: "+error);});}},{key:'queryForPostData',value:function queryForPostData(){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');query.include("user");query.include("image");query.include("thumbnail");query.include("likeCountNew");query.include("saveCount");query.include("commentcount");query.include("_created_at");query.include("createdAt");query.exists("user");query.descending("createdAt");query.limit(100);var self=this;query.find().then(function(result){if(result){self.setState({posts:result});}else{console.log("No post found");}},function(error){console.error("Error loading post Error: "+error);});}},{key:'renderUsers',value:function renderUsers(){var buffer=[];if(this.state.users){for(var i=0;i<this.state.users.length;i++){var user=this.state.users[i];var profile_picture=user.get("profilePictureSmall").url();if(profile_picture!==undefined){profile_picture=profile_picture;}else{profile_picture="/images/menu-account.svg";}buffer.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'menu',key:69*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/user/'+user.get("displayUsername"),title:user.get("displayUsername"),className:'media'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-left'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:profile_picture,className:'mr-2',width:'40px',height:'40px',alt:'itsallgoodvegan'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'media-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h6',{className:'mt-0'},user.get("displayUsername")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,user.get("displayName"))))));}}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'list_grp'},buffer);}/* renderPosts()
    {
        

        let buffer = [];

        if (this.state.posts)
        {
            for (var i = 0; i < this.state.posts.length; i++)
            {
                var post = this.state.posts[i];
            
                buffer.push(<div className='card_box' key={69*i}>
                    <SinglePost postData={post}/>
                </div>);
            }
        }

        return ( <div className='list_group'>
                {buffer}
                </div>
        );
    }*/},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('section',{className:'post_list'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('nav',{className:'sidebar'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Leftsidebar_jsx__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('main',{className:'listing sticky_app_btn'}))));}}]);return Explorer;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Explorer);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import messaging, { requestNotificationPermission } from './firebase';
var NotificationComponent=function(_Component){_inherits(NotificationComponent,_Component);function NotificationComponent(props){_classCallCheck(this,NotificationComponent);var _this=_possibleConstructorReturn(this,(NotificationComponent.__proto__||Object.getPrototypeOf(NotificationComponent)).call(this,props));_this.state={notificationToken:null,notification:null};/*code*///https://fcm.googleapis.com/fcm/send
__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({url:'https://fcm.googleapis.com/v1/projects/myproject-b5ae1/messages:send',crossDomain:true,method:'post',headers:{'Authorization':'Bearer 641479387246-d14nc2lv0piad9a46s9i37v88dam8rg4.apps.googleusercontent.com'},contentType:'application/json',// data: '{\n  "to": "YOUR_FCM_TOKEN",\n  "notification": {\n    "title": "Test Notification",\n    "body": "This is a test notification from Firebase!"\n  }\n}',
data:JSON.stringify({'to':'d5438927bc22bc2475ad454eea717b57a5919630bb7adbf58e8df1d880d429e3','notification':{'title':'Test Notification','body':'This is a test notification from Firebase!'}})}).done(function(response){console.log(response);});/*code*/return _this;}/*async componentDidMount() {
    const token = await requestNotificationPermission();
    if (token) {
      this.saveTokenToParse(token);
    }
  }

  saveTokenToParse = async (token) => {
    const FCMToken = Parse.Object.extend('FCMToken');
    const fcmToken = new FCMToken();

    fcmToken.set('token', token);
    fcmToken.set('user', Parse.User.current());

    try {
      await fcmToken.save();
      console.log('FCM Token saved to Parse');
    } catch (error) {
      console.error('Error saving FCM Token to Parse:', error);
    }
  };*/_createClass(NotificationComponent,[{key:'render',value:function render(){var notification=this.state.notification;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Firebase Notifications'),notification?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,notification.notification.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,notification.notification.body)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'No new notifications'));}}]);return NotificationComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NotificationComponent);

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__global_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Leftsidebar_jsx__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gridsinglepost_jsx__ = __webpack_require__(335);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import SinglePost from "./singlepost.jsx";
function time_ago(time){switch(typeof time==='undefined'?'undefined':_typeof(time)){case'number':break;case'string':time=+new Date(time);break;case'object':if(time.constructor===Date)time=time.getTime();break;default:time=+new Date();}var time_formats=[[60,'seconds',1],// 60
[120,'1 minute ago','1 minute from now'],// 60*2
[3600,'minutes',60],// 60*60, 60
[7200,'1 hour ago','1 hour from now'],// 60*60*2
[86400,'hours',3600],// 60*60*24, 60*60
[172800,'Yesterday','Tomorrow'],// 60*60*24*2
[604800,'days',86400],// 60*60*24*7, 60*60*24
[1209600,'Last week','Next week'],// 60*60*24*7*4*2
[2419200,'weeks',604800],// 60*60*24*7*4, 60*60*24*7
[4838400,'Last month','Next month'],// 60*60*24*7*4*2
[29030400,'months',2419200],// 60*60*24*7*4*12, 60*60*24*7*4
[58060800,'Last year','Next year'],// 60*60*24*7*4*12*2
[2903040000,'years',29030400],// 60*60*24*7*4*12*100, 60*60*24*7*4*12
[5806080000,'Last century','Next century'],// 60*60*24*7*4*12*100*2
[58060800000,'centuries',2903040000]// 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
];var seconds=(+new Date()-time)/1000,token='ago',list_choice=1;if(seconds==0){return'Just now';}if(seconds<0){seconds=Math.abs(seconds);token='from now';list_choice=2;}var i=0,format;while(format=time_formats[i++]){if(seconds<format[0]){if(typeof format[2]=='string')return format[list_choice];else return Math.floor(seconds/format[2])+' '+format[1]+' '+token;}}return time;}var GridStream=function(_React$Component){_inherits(GridStream,_React$Component);function GridStream(props){_classCallCheck(this,GridStream);var _this=_possibleConstructorReturn(this,(GridStream.__proto__||Object.getPrototypeOf(GridStream)).call(this,props));_this.shouldHide=function(id){var allpostids=[];for(var i=0;i<_this.state.posts.length;i++){var posts=_this.state.posts[i];allpostids.push(posts.id);}var allIds=allpostids;//['kN23G3RilJ','JZTWnFoMr3', 'SyupXzNACc']; // All ids in order
var hideIndex=allIds.indexOf(_this.state.hideUntilId);var currentIndex=allIds.indexOf(id);return currentIndex<hideIndex;};__WEBPACK_IMPORTED_MODULE_1_parse___default.a.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5","sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw");__WEBPACK_IMPORTED_MODULE_1_parse___default.a.serverURL="https://parse.joelskitchen.com/parse";//Parse.serverURL = "https://parsetest.joelskitchen.com/parse";
var now=new Date();_this.state={posts:{},users:{},created_at:now.getTime(),hideUntilId:''};_this.queryForPostData();_this.homeFetch=_this.homeFetch.bind(_this);var storestreamid=localStorage.getItem('storestreamid');_this.state.hideUntilId=storestreamid;return _this;}_createClass(GridStream,[{key:'homeFetch',value:function homeFetch(event){this.queryForPostData();}},{key:'getSuggestedUsers',value:function getSuggestedUsers(){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('User');query.equalTo('isSuggested',1);query.include("username");query.descending('_created_at');var self=this;query.find().then(function(result){if(result){self.setState({users:result});}else{console.log("No user found");}},function(error){console.error("Error loading post Error: "+error);});}},{key:'queryForPostData',value:function queryForPostData(){var storestreamtabValue=localStorage.getItem('storestreamtabValue');var storestreampagepath=localStorage.getItem('storestreampagepath');console.log(storestreamtabValue+'storestreamtabValue');console.log(storestreampagepath+'storestreampagepath');if(storestreamtabValue==='saved'&&storestreampagepath==='my-profile'){var currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();var Save=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.Object.extend('Save');var _query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query(Save);_query.equalTo("fromUser","_User$"+currentUser.id);_query.exists('photo');_query.include('photo');_query.include("image");_query.doesNotExist("isChallenge");_query.include("photo.user");_query.include("photo.image");_query.include("photo.thumbnail");_query.include("photo.likeCountNew");_query.include("photo.saveCount");_query.include("photo.commentcount");_query.include("photo._created_at");_query.include("photo.createdAt");_query.descending("_created_at");//query.exists("photo.user");
var self=this;_query.find().then(function(results){var saveRecord=[];if(results){for(var i=0;i<results.length;i++){var post=results[i];if(post.get('photo')&&post.get('photo').id){saveRecord.push(post.get('photo'));}}}self.setState({posts:saveRecord});});}if(storestreamtabValue==='posts'&&storestreampagepath==='my-profile'){var _currentUser=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');query.include("user");query.include("image");query.include("thumbnail");query.include("likeCountNew");query.include("saveCount");query.include("commentcount");query.include("_created_at");query.include("createdAt");query.exists("user");query.exists("image");//added
query.exists("thumbnail");//added
query.doesNotExist("isChallenge");//added
query.descending("createdAt");query.limit(99999999999999999999999999);query.equalTo("user",_currentUser);var self=this;query.find().then(function(result){if(result){self.setState({posts:result});}});}if(storestreamtabValue==='recipes'&&storestreampagepath==='my-profile'){var _currentUser2=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();var self=this;var getRecipequery=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');// getRecipequery.exists('recipeV2');
getRecipequery.exists('isRecipe');getRecipequery.equalTo('user',_currentUser2);getRecipequery.doesNotExist("isChallenge");getRecipequery.descending("_created_at");getRecipequery.find().then(function(recipe){if(recipe){self.setState({posts:recipe});}});}if(storestreamtabValue==='posts'&&storestreampagepath==='user'){console.log('posts user');var _currentUser3=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');var streampagepathuser=localStorage.getItem('streampagepathuser');query.include("user");query.exists("image");//added
query.exists("thumbnail");//added
query.include("image");query.include("thumbnail");query.include("likeCountNew");query.include("saveCount");query.include("commentcount");query.include("_created_at");query.include("createdAt");query.exists("user");query.doesNotExist("isChallenge");//added
query.descending("createdAt");query.limit(99999999999999999999999999);//query.equalTo("user", currentUser);
query.equalTo("user","_User$"+streampagepathuser);var self=this;query.find().then(function(result){if(result.length!==undefined){self.setState({posts:result});}});}if(storestreamtabValue==='recipes'&&storestreampagepath==='user'){var _currentUser4=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();var _streampagepathuser=localStorage.getItem('streampagepathuser');var self=this;var getRecipequery=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');// getRecipequery.exists('recipeV2');
getRecipequery.exists('isRecipe');getRecipequery.include("user");getRecipequery.equalTo("user","_User$"+_streampagepathuser);getRecipequery.doesNotExist("isChallenge");getRecipequery.descending("_created_at");getRecipequery.find().then(function(recipe){if(recipe){self.setState({posts:recipe});}});}if(storestreamtabValue==='saved'&&storestreampagepath==='user'){var _streampagepathuser2=localStorage.getItem('streampagepathuser');var _currentUser5=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.User.current();var _Save=__WEBPACK_IMPORTED_MODULE_1_parse___default.a.Object.extend('Save');var _query2=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query(_Save);_query2.equalTo("fromUser","_User$"+_streampagepathuser2);_query2.exists('photo');_query2.include('photo');_query2.include("image");_query2.doesNotExist("isChallenge");_query2.include("photo.user");_query2.include("photo.image");_query2.include("photo.thumbnail");_query2.include("photo.likeCountNew");_query2.include("photo.saveCount");_query2.include("photo.commentcount");_query2.include("photo._created_at");_query2.include("photo.createdAt");_query2.descending("_created_at");//query.exists("photo.user"); 
var self=this;_query2.find().then(function(results){var saveRecord=[];if(results){for(var i=0;i<results.length;i++){var post=results[i];if(post.get('photo')&&post.get('photo').id){saveRecord.push(post.get('photo'));}}}self.setState({posts:saveRecord});});}if(storestreamtabValue==='explore'&&storestreampagepath==='explore'){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');query.include("image");query.include("thumbnail");query.include("_created_at");query.include("createdAt");query.doesNotExist("isChallenge");/* query.select("isChallengeWinner");
        query.select("isChallengeEntry");
        query.select("image");
        query.select("thumbnail");
        query.select("isRecipe");*/query.exists("user");query.include("user");query.descending("createdAt");var self=this;query.find().then(function(result){if(result){self.setState({posts:result});}});}if(storestreampagepath==='challengedetail'){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');query.equalTo('isChallengeEntry',"1");query.equalTo('challenge',"Photo$"+storestreamtabValue);/*query.select("isChallengeWinner");
        query.select("isChallengeEntry");
        query.select("hideEntry");*//*query.select("image");
        query.select("thumbnail");
        query.select("isRecipe");*/query.exists("user");query.include("user");query.include("image");query.include("thumbnail");query.descending("createdAt");var self=this;query.find().then(function(result){if(result){self.setState({posts:result});}});}if(storestreampagepath==='searchresult'){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('User');query.equalTo('isSuggested',1);query.descending('_created_at');var SearchTitle=storestreamtabValue;var self=this;query.find().then(function(result){if(result){var userSuggdataresult1=[];if(result.length>0){for(var i=0;i<result.length;i++){var user=result[i];userSuggdataresult1[i]='_User$'+user.id;}var queryphoto=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');queryphoto.include("user");queryphoto.limit(99999999999);var jointuser=userSuggdataresult1;queryphoto.descending("createdAt");if(SearchTitle){queryphoto.contains('caption',SearchTitle);}queryphoto.find().then(function(photo){self.setState({posts:photo});});}}else{}},function(error){console.error("Error loading post Error: "+error);});}if(storestreampagepath==='search'&&storestreamtabValue===''){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('User');query.equalTo('isSuggested',1);query.descending('_created_at');query.limit(4);var self=this;query.find().then(function(result){if(result){var userSuggdataresult1=[];if(result.length>0){for(var i=0;i<result.length;i++){var user=result[i];userSuggdataresult1[i]='_User$'+user.id;}var queryphoto=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');queryphoto.include("user");queryphoto.limit(4);var jointuser=userSuggdataresult1;queryphoto.descending("createdAt");queryphoto.find().then(function(photo){self.setState({posts:photo});});}}else{}},function(error){console.error("Error loading post Error: "+error);});}if(storestreampagepath==='search'&&storestreamtabValue!==''){var query=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('User');query.equalTo('isSuggested',1);query.descending('_created_at');query.limit(10);var _SearchTitle=storestreamtabValue;var self=this;query.find().then(function(result){if(result){var userSuggdataresult1=[];if(result.length>0){for(var i=0;i<result.length;i++){var user=result[i];userSuggdataresult1[i]='_User$'+user.id;}var queryphoto=new __WEBPACK_IMPORTED_MODULE_1_parse___default.a.Query('Photo');queryphoto.include("user");queryphoto.limit(4);var jointuser=userSuggdataresult1;queryphoto.descending("createdAt");if(_SearchTitle){queryphoto.contains('caption',_SearchTitle);}queryphoto.find().then(function(photo){self.setState({posts:photo});});}}else{}},function(error){console.error("Error loading post Error: "+error);});}}},{key:'renderPosts',value:function renderPosts(){var buffer=[];var self=this;if(this.state.posts){for(var i=0;i<this.state.posts.length;i++){var post=this.state.posts[i];buffer.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{display:self.shouldHide(post.id)?'none':'block'},id:post.id,className:'card_box b',key:69*i},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__gridsinglepost_jsx__["a" /* default */],{postData:post})));}}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'list_group streampage'},buffer,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{type:'hidden',id:'home_id',name:'home_id'}));}},{key:'render',value:function render(){var likesWord="likes";var savesWord="saves";var commentsWord="comments";if(this.state.likeCount==1)likesWord="like";if(this.state.saveCount==1)savesWord="save";if(this.state.commentCount==1)commentsWord="comment";return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('section',{className:'post_list'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('nav',{className:'sidebar'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Leftsidebar_jsx__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('main',{className:'listing sticky_app_btn'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'get-app cta_btn'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'secondary-btn btn-wrp sml-btn'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'javascript:void(0);',type:'button','data-toggle':'modal','data-target':'#kitchenQrModal',title:'Get app'},'Get app'))),this.renderPosts()))));}}]);return GridStream;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (GridStream);

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__singlepost_css__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__singlepost_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__singlepost_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_mentions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__defaultStyle__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__defaultMentionStyle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MentionTextarea_css__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MentionTextarea_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__MentionTextarea_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_emoji_picker_react__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_emoji_picker_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_emoji_picker_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__followersUser_jsx__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__postSaveUser_jsx__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__getLikePostHome_jsx__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Leftsidebar_jsx__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__saveNotification_jsx__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CommonPopup_jsx__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Recipe from "./recipe.jsx";
//import Product from "./product.jsx";
//import Modaldata from "./Modaldata.jsx";
function time_ago(time){switch(typeof time==='undefined'?'undefined':_typeof(time)){case'number':break;case'string':time=+new Date(time);break;case'object':if(time.constructor===Date)time=time.getTime();break;default:time=+new Date();}var time_formats=[[60,'s',1],// 60
[120,'1m','1 minute from now'],// 60*2
[3600,'m',60],// 60*60, 60
[7200,'1h','1 hour from now'],// 60*60*2
[86400,'h',3600],// 60*60*24, 60*60
[172800,'1d','Tomorrow'],// 60*60*24*2
[604800,'d',86400],// 60*60*24*7, 60*60*24
[1209600,'1w','Next week'],// 60*60*24*7*4*2
[2419200,'w',604800],// 60*60*24*7*4, 60*60*24*7
[4838400,'1m','Next month'],// 60*60*24*7*4*2
[29030400,'m',2419200],// 60*60*24*7*4*12, 60*60*24*7*4
[58060800,'1y','Next year'],// 60*60*24*7*4*12*2
[2903040000,'y',29030400],// 60*60*24*7*4*12*100, 60*60*24*7*4*12
[5806080000,'Last century','Next century'],// 60*60*24*7*4*12*100*2
[58060800000,'centuries',2903040000]// 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
];var seconds=(+new Date()-time)/1000,token='',list_choice=1;if(seconds==0){return'';}if(seconds<0){seconds=Math.abs(seconds);//token = 'from now';
token='';list_choice=2;}var i=0,format;while(format=time_formats[i++]){if(seconds<format[0]){if(typeof format[2]=='string')return format[list_choice];else return Math.floor(seconds/format[2])+''+format[1]+''+token;}}return time;}var GridSinglePost=function(_React$Component){_inherits(GridSinglePost,_React$Component);function GridSinglePost(props){_classCallCheck(this,GridSinglePost);var _this=_possibleConstructorReturn(this,(GridSinglePost.__proto__||Object.getPrototypeOf(GridSinglePost)).call(this,props));_initialiseProps.call(_this);__WEBPACK_IMPORTED_MODULE_3_parse___default.a.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5","sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw");//PASTE HERE YOUR Back4App APPLICATION ID AND YOUR JavaScript KEY
__WEBPACK_IMPORTED_MODULE_3_parse___default.a.serverURL="https://parse.joelskitchen.com/parse";//Parse.serverURL = "https://parsetest.joelskitchen.com/parse";
var now=new Date();_this.state={postID:0,postData:null,created_at:now.getTime(),comments:null,postImage:null,userImage:null,user:null,caption:null,likeCount:0,saveCount:0,commentCount:0,recipe:null,product:null,city:null,postcomment:'',isChallenge:"0",CurrentSaveCount:0,currentuserImage:null,currentUserId:null,singlelikeCount:0,isExpanded:false,expandedCommentId:null,blank_comment_message:null,challengeStatus:null,singlementioned:'',singleget_allusers:[],linkdata:'',loadpage:'home',getUsernamefetch:null,usertype:0,popup_username:null,popup_comments:null,commentsdatas:[],likeCount1:0,likeuserlist:[],single_post_id:null,bufferdatalist:[],singlemodalstates:false,isPopupOpen:false,postDetails:null,loading:false,error:null,postDetailscomment:null,singlementioned_popup:'',singleget_allusers_popup:[],postcomment_popup:'',blank_comment_message_popup:null,followersListing:{},followinguserid:[],inputText:'',showPicker:false,reply_id:'',loadingdata:false,singlelikeCountChild:0,loader:false,reply_thread_id:'',followinglikeuserid:[],followerslikeListing:{},isHideEntry:0,isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:'',isPopupOpendetails:false,post_common_id:''};var result=props.postData;if(result.get("image")&&result.get("image").url()){_this.state.postImage=result.get("image").url();}if(result.get("isChallenge")){_this.state.isChallenge=result.get("isChallenge");}_this.state.user=result.get("user");var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser!=null){if(currentUser.get("isCreator")!==undefined&&currentUser.get("isCreator")===1||currentUser.get("isBusiness")!==undefined&&currentUser.get("isBusiness")===1||currentUser.get("isAdmin")!==undefined&&currentUser.get("isAdmin")==="1"){_this.state.usertype=1;}}_this.state.username=result.get("user").get("displayUsername");//new code
if(_this.state.user){_this.state.getUsernamefetch=_this.state.username;if(!_this.state.getUsernamefetch||_this.state.getUsernamefetch.length<2){_this.state.getUsernamefetch=_this.state.user.get("firstName")+"_"+_this.state.user.get("lastName");_this.state.getUsernamefetch=_this.state.getUsernamefetch.toLowerCase(_this.state.getUsernamefetch);}}//new code
if(result.get("user").get("profilePictureSmall")){//console.log("User image: ", result.get("user").get("profilePictureSmall").url());
_this.state.userImage=result.get("user").get("profilePictureSmall").url();}else{_this.state.userImage="/images/default_userpic0.png";}_this.state.caption=result.get("caption");_this.state.created_at=result.get("createdAt");_this.state.city=result.get("user").get("city");var likeCount=result.get("likeCountNew");//var likeCount1 = result.get("likeCountNew");
var saveCount=result.get("saveCount");var commentCount=result.get("commentcount");var imprCount=result.get("impr");_this.state.title=result.get("title");_this.state.url=result.get("url");_this.state.collabUser=result.get("collabUser");_this.state.collabUsername=result.get("collabUsername");if(_this.state.collabUser){result.get("collabUser").fetch();}if(!likeCount)likeCount=0;if(!saveCount)saveCount=0;if(!commentCount)commentCount=0;if(!imprCount)imprCount=1;_this.state.likeCount=likeCount;_this.state.saveCount=saveCount;_this.state.commentCount=commentCount;_this.state.imprCount=imprCount;_this.state.postID=result.id;_this.state.challengeStatus=result.get("challengeStatus");_this.state.isChallengeEntry=result.get("isChallengeEntry");_this.state.isChallengeWinner=result.get("isChallengeWinner");_this.state.isRecipe=result.get("isRecipe");_this.state.challenge_id=result.get("challenge")?result.get("challenge").id:'';_this.state.barcolor=result.get("challenge")?result.get("challenge").get('barcolor')?result.get("challenge").get('barcolor'):'':'';_this.state.challengeentrystatus=result.get("challenge")?result.get("challenge").get('challengeStatus')?result.get("challenge").get('challengeStatus'):'':'';_this.state.postLink="/posts/"+_this.state.postID;_this.state.recipe=result.get("recipeV2");_this.state.product=result.get("productV2");_this.state.isHideEntry=result.get("hideEntry")?result.get("hideEntry"):'0';if(_this.props.showComments&&_this.state.recipe)_this.state.recipe.fetch();if(_this.props.showComments&&_this.state.product)_this.state.product.fetch();if(_this.props.showComments)//detail view only
{_this.queryForComments();_this.props.postData.increment("impr");_this.props.postData.save();_this.state.loadpage='single';_this.singlegetAllUsers();imprCount++;_this.props.postData.set("imprcount",imprCount);_this.props.postData.save();}//this.popuprenderComments()
_this.updateInput=_this.updateInput.bind(_this);_this.handleCommentPost=_this.handleCommentPost.bind(_this);_this.handleCommentPostUpdate=_this.handleCommentPostUpdate.bind(_this);_this.handleSavePost=_this.handleSavePost.bind(_this);// this.handleGetSavePost = this.handleGetSavePost.bind(this);
_this.handleFollowUser=_this.handleFollowUser.bind(_this);_this.handleUnFollowUser=_this.handleUnFollowUser.bind(_this);//this.handleGetFollowUser = this.handleGetFollowUser.bind(this); 
_this.cancelText=_this.cancelText.bind(_this);_this.getUserProfileImage();_this.handlePhotoLike=_this.handlePhotoLike.bind(_this);_this.formatRenderComments=_this.formatRenderComments.bind(_this);_this.handlePostModelOpen=_this.handlePostModelOpen.bind(_this);//this.handleGetLikePost = this.handleGetLikePost.bind(this);
_this.handlePhotoUnLike=_this.handlePhotoUnLike.bind(_this);_this.handlePhotoActivityLike=_this.handlePhotoActivityLike.bind(_this);_this.handleGetActivityLikePost=_this.handleGetActivityLikePost.bind(_this);_this.handlePhotoActivityUnLike=_this.handlePhotoActivityUnLike.bind(_this);_this.handleRemoveSavePost=_this.handleRemoveSavePost.bind(_this);_this.handleNotLoginClick=_this.handleNotLoginClick.bind(_this);_this.singlePostModalClass=_this.singlePostModalClass.bind(_this);_this.singlePostLikeModal=_this.singlePostLikeModal.bind(_this);_this.singlePostLikeModalClose=_this.singlePostLikeModalClose.bind(_this);_this.toggleExpand=_this.toggleExpand.bind(_this);_this.deleteCommentId=_this.deleteCommentId.bind(_this);_this.checkDeleteComment=_this.checkDeleteComment.bind(_this);_this.deletePostId=_this.deletePostId.bind(_this);_this.checkDeletePost=_this.checkDeletePost.bind(_this);_this.handleGetLikeUser=_this.handleGetLikeUser.bind(_this);_this.renderDetailPage=_this.renderDetailPage.bind(_this);_this.singlePostModalClose1=_this.singlePostModalClose1.bind(_this);_this.handleCommentPostPopup=_this.handleCommentPostPopup.bind(_this);_this.updateInputPopup=_this.updateInputPopup.bind(_this);_this.handleFollowMyProfile=_this.handleFollowMyProfile.bind(_this);_this.onEmojiClick=_this.onEmojiClick.bind(_this);_this.handlePhotoActivityLikeChild=_this.handlePhotoActivityLikeChild.bind(_this);_this.handleGetActivityLikePostChild=_this.handleGetActivityLikePostChild.bind(_this);_this.handlePhotoActivityUnLikeChild=_this.handlePhotoActivityUnLikeChild.bind(_this);_this.replyComment=_this.replyComment.bind(_this);_this.handleUnFollowMyProfile=_this.handleUnFollowMyProfile.bind(_this);_this.handleFollowMyProfileLike=_this.handleFollowMyProfileLike.bind(_this);_this.handleUnFollowMyProfileLike=_this.handleUnFollowMyProfileLike.bind(_this);//this.toggleNotification = this.toggleNotification.bind(this);
return _this;}_createClass(GridSinglePost,[{key:'componentDidMount',value:function componentDidMount(){}// Method to fetch post data from Parse
},{key:'faqOpenClose',value:function faqOpenClose(commentId){var commentIds=commentId.split('comnt_');var commenUpdatedId=commentIds[1];var self=this;var check=__WEBPACK_IMPORTED_MODULE_6_jquery___default()(".view_replies_comment .faq-drawer #faq-drawer-"+commenUpdatedId).is(":checked");if(check){__WEBPACK_IMPORTED_MODULE_6_jquery___default()(".view_replies_comment .faq-drawer label.faq-drawer__title span#faq-"+commenUpdatedId).html('Hide Replies');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.view_replies_comment .faq-drawer .faq-drawer__content-wrapper#fq-'+commenUpdatedId).addClass('active');}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()(".view_replies_comment .faq-drawer label.faq-drawer__title span#faq-"+commenUpdatedId).html('View Replies');if(__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.view_replies_comment .faq-drawer .faq-drawer__content-wrapper#fq-'+commenUpdatedId).hasClass("active")){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.view_replies_comment .faq-drawer .faq-drawer__content-wrapper#fq-'+commenUpdatedId).removeClass('active');}}}//handleCommentPostUpdate = function(e){
//  handleCommentPostUpdate  = () => {
// Method to handle closing the popup
},{key:'singlegetUsersCommentLike',value:function singlegetUsersCommentLike(post_id,main_activity_id){var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){//following
var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query.include("user");query.include("image");query.include("toUser");query.include("thumbnail");query.equalTo("type","follow");query.equalTo("fromUser",currentUser);var self=this;query.find().then(function(result){if(result){var resultcount=result.length;var followingdataresult1=[];if(resultcount>0){var userdataresult1=[];for(var i=0;i<resultcount;i++){var user=result[i];var userimage='';if(user.get("toUser").get("profilePictureSmall")&&user.get("toUser").get("profilePictureSmall").url()!==undefined){userimage=user.get("toUser").get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}//console.log(user.get("fromUser").id);
//console.log(user.get("toUser").id);
userdataresult1.push({'id':user.get("toUser").id,'displayName':user.get("toUser").get("displayName"),'displayUsername':user.get("toUser").get("displayUsername"),'image':userimage,'fromUser':user.get("fromUser").id});followingdataresult1.push({'id':user.get("toUser").id,'name':user.get("toUser").id});self.setState({followinglikeuserid:followingdataresult1});}}else{self.setState({followinglikeuserid:[]});}}});//followers 
var followersquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');followersquery.include("user");followersquery.include("fromUser");followersquery.include("image");followersquery.include("thumbnail");followersquery.doesNotExist("activity");followersquery.equalTo('activity',"Activity$"+main_activity_id);followersquery.equalTo('photo',"Photo$"+post_id);//followersquery.equalTo("fromUser", currentUser);
var self=this;followersquery.find().then(function(followerresult){if(followerresult){var resultcount=followerresult.length;if(followerresult.length>0){var userdataresult=[];//self.setState({followersListing:'followerresult'});
for(var i=0;i<resultcount;i++){var Images=null;var user=followerresult[i];if(user.get("fromUser").get("profilePictureSmall")&&user.get("fromUser").get("profilePictureSmall").url()!==undefined){Images=user.get("fromUser").get("profilePictureSmall").url();}userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});//self.setState({followersListing:resultcount});
}self.setState({followerslikeListing:userdataresult});}}});}else{var followersquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');followersquery.include("user");followersquery.include("fromUser");followersquery.include("image");followersquery.include("thumbnail");followersquery.doesNotExist("activity");followersquery.equalTo('activity',"Activity$"+main_activity_id);followersquery.equalTo('photo',"Photo$"+post_id);//followersquery.equalTo("fromUser", currentUser);
var self=this;followersquery.find().then(function(followerresult){if(followerresult){var resultcount=followerresult.length;if(resultcount>0){var userdataresult=[];//self.setState({followersListing:'followerresult'});
for(var i=0;i<resultcount;i++){var Images=null;var user=followerresult[i];if(user.get("fromUser").get("profilePictureSmall")&&user.get("fromUser").get("profilePictureSmall").url()!==undefined){Images=user.get("fromUser").get("profilePictureSmall").url();}userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});//self.setState({followersListing:resultcount});
}self.setState({followerslikeListing:userdataresult});}}});}}},{key:'singlegetUsersLike',value:function singlegetUsersLike(post_id){var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){//following
var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query.include("user");query.include("image");query.include("toUser");query.include("thumbnail");query.equalTo("type","follow");query.equalTo("fromUser",currentUser);var self=this;query.find().then(function(result){if(result){var resultcount=result.length;var followingdataresult1=[];if(resultcount>0){var userdataresult1=[];for(var i=0;i<resultcount;i++){var user=result[i];var userimage='';if(user.get("toUser").get("profilePictureSmall")&&user.get("toUser").get("profilePictureSmall").url()!==undefined){userimage=user.get("toUser").get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}//console.log(user.get("fromUser").id);
//console.log(user.get("toUser").id);
userdataresult1.push({'id':user.get("toUser").id,'displayName':user.get("toUser").get("displayName"),'displayUsername':user.get("toUser").get("displayUsername"),'image':userimage,'fromUser':user.get("fromUser").id});followingdataresult1.push({'id':user.get("toUser").id,'name':user.get("toUser").id});self.setState({followinguserid:followingdataresult1});}}else{self.setState({followinguserid:[]});}}});//followers 
var followersquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');followersquery.include("user");followersquery.include("fromUser");followersquery.include("image");followersquery.include("thumbnail");followersquery.doesNotExist("activity");followersquery.equalTo('photo',"Photo$"+post_id);//followersquery.equalTo("fromUser", currentUser);
var self=this;followersquery.find().then(function(followerresult){if(followerresult){var resultcount=followerresult.length;if(followerresult.length>0){var userdataresult=[];//self.setState({followersListing:'followerresult'});
for(var i=0;i<resultcount;i++){var Images=null;var user=followerresult[i];if(user.get("fromUser").get("profilePictureSmall")&&user.get("fromUser").get("profilePictureSmall").url()!==undefined){Images=user.get("fromUser").get("profilePictureSmall").url();}userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});//self.setState({followersListing:resultcount});
}self.setState({followersListing:userdataresult});}}});}else{var followersquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');followersquery.include("user");followersquery.include("fromUser");followersquery.include("image");followersquery.include("thumbnail");followersquery.doesNotExist("activity");followersquery.equalTo('photo',"Photo$"+post_id);//followersquery.equalTo("fromUser", currentUser);
var self=this;followersquery.find().then(function(followerresult){if(followerresult){var resultcount=followerresult.length;if(resultcount>0){var userdataresult=[];//self.setState({followersListing:'followerresult'});
for(var i=0;i<resultcount;i++){var Images=null;var user=followerresult[i];if(user.get("fromUser").get("profilePictureSmall")&&user.get("fromUser").get("profilePictureSmall").url()!==undefined){Images=user.get("fromUser").get("profilePictureSmall").url();}userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});//self.setState({followersListing:resultcount});
}self.setState({followersListing:userdataresult});}}});}}},{key:'singlegetAllUsersPopup',value:function singlegetAllUsersPopup(){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('_User');query.limit(999999999);query.include("profilePictureSmall");query.include("displayUsername");query.exists("displayUsername");query.include("name");var self=this;query.find().then(function(result){var userdataresult1=[];if(result){for(var i=0;i<result.length;i++){var user=result[i];var userimage='';if(user.get("profilePictureSmall")&&user.get("profilePictureSmall").url()!==undefined){userimage=user.get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}//userdataresult1.push({'id':user.id,'display':user.get("displayName"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
//self.state.singleget_allusers.push({'id':user.id,'display':user.get("displayName"),'username':user.get("username"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
userdataresult1.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});self.state.singleget_allusers_popup.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});}this.state.singleget_allusers_popup=userdataresult1;}else{// console.log("No users found");
}},function(error){});}},{key:'singlegetAllUsers',value:function singlegetAllUsers(){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('_User');query.limit(999999999);query.include("profilePictureSmall");query.include("displayUsername");query.include("name");var self=this;query.find().then(function(result){var userdataresult1=[];if(result){for(var i=0;i<result.length;i++){var user=result[i];var userimage='';if(user.get("profilePictureSmall")&&user.get("profilePictureSmall").url()!==undefined){userimage=user.get("profilePictureSmall").url();}else{userimage="/images/default_userpic0.png";}//userdataresult1.push({'id':user.id,'display':user.get("displayName"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
//self.state.singleget_allusers.push({'id':user.id,'display':user.get("displayName"),'username':user.get("username"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
userdataresult1.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});self.state.singleget_allusers.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});}this.state.singleget_allusers=userdataresult1;}else{// console.log("No users found");
}},function(error){});}},{key:'getUserProfileImage',value:function getUserProfileImage(){var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var profile_picture=currentUser.get("profilePictureSmall");if(profile_picture){this.state.currentuserImage=profile_picture.url();}this.state.currentUserId=currentUser.id;}}},{key:'renderComments',value:function renderComments(){var _this2=this;//console.log("renderIngredients");
//return      <span key="66"><h4> ingredType  <a onClick={() => this.handleAdd(0)} >Add</a></h4></span>;
var buffer=[];if(this.state.comments&&this.props.showComments){var _loop=function _loop(){comment=_this2.state.comments[i];var comment_activity_id="comment_"+comment.id;var comment_id="comnt_"+comment.id;_this2.state.singlelikeCount=comment.get("likeCount")?comment.get("likeCount"):0;likesWord="Likes";if(_this2.state.singlelikeCount==1)likesWord="Like";var comment_fromuserid=comment.get("fromUser").id;var comment_currentUserId=_this2.state.currentUserId;// if (ingredType != undefined)
//console.log(comment.get('Photo').id);
buffer.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{key:69*i,className:'cmt_wrap'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usr_img_detail'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usr_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:_this2.getCommentProfilePic(comment)})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_usr'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'name'},comment.get("fromUser").get('displayUsername')!=undefined?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+comment.get("fromUser").get('displayUsername')},comment.get("fromUser").get('displayUsername')):"",__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,time_ago(comment.get("createdAt")))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'/images/dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},comment_fromuserid===comment_currentUserId?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button','data-toggle':'modal','data-target':'#deleteCommentCloseModal',onClick:function onClick(e){return _this2.deleteCommentId(comment_id);},id:'close_deleteCommentwithdiscard','aria-label':'Modal'},'Delete'):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item',type:'button'},'Cancel')))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_cnt',id:comment_id},_this2.formatRenderComment(comment.get("content"),comment_id,comment.id)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_mn '},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_action d-flex flex-column flex-wrap align-items-start w-100'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action_grp'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'liked_activity',id:comment_activity_id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{'data-id':comment.id,id:comment_activity_id,onClick:function onClick(e){_this2.handlePhotoActivityLike(e);},className:'activitydefault',src:'../images/cmt-like.svg'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{'data-id':comment.id,id:comment_activity_id,onClick:function onClick(e){_this2.handlePhotoActivityUnLike(e);},className:'activityactive',style:{display:"none"},src:'../images/like-fill.svg'}),_this2.handleGetActivityLikePost(comment.id))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_count'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'like box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'#'},' ',' ',_this2.state.singlelikeCount,' ',likesWord))))))));};for(var i=0;i<this.state.comments.length;i++){var comment;var likesWord;_loop();}}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_wrap_list'},buffer);}// handleGetSavePost = (post_id,page) => {
},{key:'updateInput',value:function updateInput(event){this.setState({singlementioned:event.target.value});this.setState({postcomment:event.target.value});}},{key:'handleSinglePostPopupEnter',value:function handleSinglePostPopupEnter(event){if(event.key==="Enter"){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_button_comment#handleCommentPost_popup').click();}}},{key:'updateInputPopup',value:function updateInputPopup(event){//console.log('updateInputPopup');
var reply_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#reply_id').val();if(reply_id===''){//console.log('singlementioned_popup==='+event.target.value)
this.state.singlementioned_popup='';}var self=this;this.setState({singlementioned_popup:event.target.value});this.setState({postcomment_popup:event.target.value});this.setState({inputText:event.target.value});if(event.target.value!==null&&reply_id===''){}else{//console.log('Test2');
}}},{key:'postHeaderText',value:function postHeaderText(){var headerText="";//disable timestamp 5/29/19 //time_ago(this.state.created_at);
if(this.state.city){headerText+=this.state.city;}return headerText;}},{key:'queryForComments',value:function queryForComments(){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query.equalTo("photo",this.props.postData);query.equalTo("type","comment");query.doesNotExist("activity");query.include("fromUser");query.include("image");query.include("content");query.include("_created_at");query.include("createdAt");//query.ascending("_created_at");
query.descending("_created_at");var self=this;query.find().then(function(result){if(result){self.setState({comments:result});//promise.resolve(result);
}else{// console.log("No comments found");
// promise.resolve(null);
}},function(error){//console.error("Error loading comments Error: " + error);
//promise.error(error);
});}},{key:'queryForCommentspopup',value:function queryForCommentspopup(photo_ob){var post_id=this.state.single_post_id?this.state.single_post_id:'';//$('#popup_post_id').val();
// console.log('single_post_id'+this.state.single_post_id); 
if(post_id){//console.log('queryForCommentspopup');
var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query.equalTo("photo",photo_ob);// query.equalTo('photo', "Photo$"+post_id);
query.equalTo("type","comment");query.include("fromUser");query.include("image");query.include("content");query.include("_created_at");query.include("createdAt");//query.ascending("_created_at");
query.descending("_created_at");var self=this;query.find().then(function(result){if(result){// this.setState({commentsdatas: result});
}else{}},function(error){});}}},{key:'cancelText',value:function cancelText(event){var _this3=this;var postcomment=this.state.postcomment;setTimeout(function(){_this3.state.postcomment='';__WEBPACK_IMPORTED_MODULE_6_jquery___default()(".comment_box").val('');},500);}},{key:'toggleExpand',value:function toggleExpand(commentId){this.setState(function(prevState){return{isExpanded:!prevState.isExpanded};});this.setState(function(prevStates){return{expandedCommentId:commentId};});}},{key:'deleteCommentId',value:function deleteCommentId(commentId){var commentIds=commentId.split('comnt_');var commenUpdatedId=commentIds[1];__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#delete_comment_id').val(commenUpdatedId);}},{key:'deleteCommentIdOverlay',value:function deleteCommentIdOverlay(commentId){var commentIds=commentId.split('comnt_');var commenUpdatedId=commentIds[1];__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#delete_comment_id').val(commenUpdatedId);this.checkDeleteComment();}},{key:'checkDeleteComment',value:function checkDeleteComment(){var _this4=this;var delete_comment_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#delete_comment_id').val();var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var photo_post_id=this.state.postID;var self=this;if(currentUser){/*child*/var query_activityChild=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query_activityChild.equalTo('activity',"Activity$"+delete_comment_id);query_activityChild.equalTo('fromUser',currentUser);query_activityChild.find().then(function(object){if(object){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=object[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var objects=_step.value;objects.destroy();var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequery.equalTo('photo',"Photo$"+photo_post_id);//checklikequery.equalTo('fromUser', currentUser);
checklikequery.equalTo('activity',"Activity$"+objects.id);checklikequery.find().then(function(object){if(object){var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=object[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var _objects=_step2.value;_objects.destroy();}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});}//return object.destroy();
}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}}).then(function(deletedObject){/*setTimeout(() => {
              var self = this;
              self.handleCommentPostUpdate();
            },500);*/}).catch(function(error){console.error('Error deleting record:',error);});/*child*//*like*/var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequery.equalTo('photo',"Photo$"+photo_post_id);//checklikequery.equalTo('fromUser', currentUser);
checklikequery.equalTo('activity',"Activity$"+delete_comment_id);checklikequery.find().then(function(object){if(object){var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=object[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var objects=_step3.value;objects.destroy();}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});/*like*/var query_activity=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query_activity.equalTo('objectId',delete_comment_id);//query_activity.equalTo('fromUser', currentUser);
query_activity.first().then(function(object){if(object){//var photo_obj_id= object.get('photo').id;         
/*photo*//*var query = new Parse.Query('Photo');  
              query.equalTo('objectId', photo_obj_id);
              query.find().then(function(photo){
              if(photo)
              {
                  let photo_ob=photo[0];
                  var photoid= photo_ob.id;
                  var commentcount= photo_ob.get('commentcount');
                  if(commentcount==undefined || commentcount===1 || commentcount < 0)
                  {
                      commentcount=0;
                  }else
                  {
                      commentcount=commentcount-1;
                  } 
                    photo_ob.set("commentcount", commentcount.toString()); 
                    photo_ob.save();
                  }
              });*//*photo*/return object.destroy();}}).then(function(deletedObject){/* var getActivityquery = new Parse.Query('Activity');  
          getActivityquery.equalTo('objectId', delete_comment_id);
          var self = this;
          getActivityquery.find().then(function(activitydata){
          if(activitydata)
          {
              let activity_ob=activitydata[0];
              console.log(activity_ob.length);
            }
          })*/var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');var reply_id=_this4.state.reply_id;query.equalTo('photo',"Photo$"+photo_post_id);query.equalTo("type","comment");//query.doesNotExist("activity");
query.include("fromUser");query.include("photo");query.include("image");query.include("content");query.include("_created_at");query.include("createdAt");query.descending("_created_at");var self=_this4;query.find().then(function(result){if(result){var totalcomment=result.length;//console.log(totalcomment+'totalcomment')
var getPhotoquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');var self=this;getPhotoquery.equalTo('objectId',photo_post_id);getPhotoquery.find().then(function(photo){if(photo){var photo_ob=photo[0];var commentcount=totalcomment?totalcomment:0;photo_ob.set("commentcount",commentcount.toString());photo_ob.save();self.setState({commentCount:commentcount.toString()});// setTimeout(() => {
//var self = this;
// this.handleCommentPostUpdate();
//},1000);
}});}});setTimeout(function(){var self=_this4;self.handleCommentPostUpdate();},1500);}).catch(function(error){console.error('Error deleting record:',error);});}}},{key:'deletePostId',value:function deletePostId(post_id){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#delete_post_id').val(post_id);}},{key:'checkDeletePost',value:function checkDeletePost(){var delete_post_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#delete_post_id').val();var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');query.equalTo('objectId',delete_post_id);var self=this;query.find().then(function(photo){if(photo){var photo_ob=photo[0];var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequery.equalTo('photo',"Photo$"+delete_post_id);checklikequery.find().then(function(object){if(object){var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=object[Symbol.iterator](),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){var objects=_step4.value;objects.destroy();}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});var checkActivityquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');checkActivityquery.equalTo('photo',"Photo$"+delete_post_id);checkActivityquery.find().then(function(object){if(object){var _iteratorNormalCompletion5=true;var _didIteratorError5=false;var _iteratorError5=undefined;try{for(var _iterator5=object[Symbol.iterator](),_step5;!(_iteratorNormalCompletion5=(_step5=_iterator5.next()).done);_iteratorNormalCompletion5=true){var objects=_step5.value;objects.destroy();}}catch(err){_didIteratorError5=true;_iteratorError5=err;}finally{try{if(!_iteratorNormalCompletion5&&_iterator5.return){_iterator5.return();}}finally{if(_didIteratorError5){throw _iteratorError5;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});var checkSavequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Save');checkSavequery.equalTo('photo',"Photo$"+delete_post_id);checkSavequery.find().then(function(object){if(object){var _iteratorNormalCompletion6=true;var _didIteratorError6=false;var _iteratorError6=undefined;try{for(var _iterator6=object[Symbol.iterator](),_step6;!(_iteratorNormalCompletion6=(_step6=_iterator6.next()).done);_iteratorNormalCompletion6=true){var objects=_step6.value;objects.destroy();}}catch(err){_didIteratorError6=true;_iteratorError6=err;}finally{try{if(!_iteratorNormalCompletion6&&_iterator6.return){_iterator6.return();}}finally{if(_didIteratorError6){throw _iteratorError6;}}}}}).then(function(deletedObject){}).catch(function(error){console.error('Error deleting record:',error);});if(photo_ob){photo_ob.destroy();}setTimeout(function(){window.location.href="/";},500);}});}}},{key:'formatComment',value:function formatComment(origComment){if(!origComment)return"";var stringSplit=origComment.split(" ");var result="";for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);if(firstChar=="#"){result+='<a href="/appstore">'+comp+'</a> ';}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){//link
result+='<a href="'+comp+'"">'+comp+'</a>';}else{result+=comp;}result+=" ";}return result;}},{key:'renderComment',value:function renderComment(comment){//console.log("renderIngredients");
//return      <span key="66"><h4> ingredType  <a onClick={() => this.handleAdd(0)} >Add</a></h4></span>;
var buffer=[];var cmt=this.formatComment(comment);buffer.push(cmt);return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,buffer);}},{key:'formatRenderComments',value:function formatRenderComments(origComment){var _this5=this;var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,buffer);}var self=this;var stringSplit=origComment.split(" ");var maxLength=320;for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);/*if (firstChar == "#")
            {
                buffer.push(comp);
            }*/if(comp.indexOf("#")!==-1){//buffer.push(<a href="/appstore">{comp} </a>);
//var userdisplayname = comp.replace('#','');
var linkdata='<a>'+comp+'</a>';buffer.push(linkdata);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){//link
//buffer.push(<a href={comp}>{comp} </a>);
buffer.push('<a href='+comp+'>'+comp+'</a>');}else if(comp.indexOf("@")!==-1||comp.indexOf("@")!==-1){//console.log(followersListing);
//console.log(self.state.singleget_allusers);
/*if(self.state.singleget_allusers.includes(comp))
               {
                console.log(self.state.singleget_allusers);
               }*//*if (self.state.singleget_allusers) {
                for (var i = 0; i < self.state.singleget_allusers.length; i++) {
                  var display = self.state.singleget_allusers[i];
                  let displayid=display.id;
                  console.log(displayid);

                }
              }*//*let linkdatas = singleget_alluserss.display.find(function(ele) {
                   ele.display === comp;
                   console.log(comp+'comp');
                   console.log(ele.display+'ele.display');
              });*//*const index = singleget_allusers.display.findIndex((el) => el === comp)
              arr[index] = 0;
              if(self.state.singleget_allusers.display.includes(comp))
              {
                linkdata= self.state.singleget_allusers.display;
              }*///let linkdatas='';
/*var userdisplayname = comp.replace('@','');
               var query = new Parse.Query('_User');
               query.include("displayUsername");
               query.equalTo("displayUsername", userdisplayname);
               query.first().then(function(result){
                if(result){
                    let userdata=result;
                    let linkdatas='/user/'+userdata.get('displayUsername');
                    self.setState({linkdata:linkdatas}); 
                }
                })*/// let linkdata='<a href ='+this.state.linkdata+'>'+comp+'</a>';
/*var userdisplayname = comp.replace(/\s/g, "").replace('@','');
              let linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';
                  buffer.push(linkdata);  */var regex=/@(\w+)/g;var linkedText=comp.replace(regex,'<a href="/user/$1">@$1</a>');buffer.push(linkedText);}else{buffer.push(comp);}}// Replace the item at the found index
// The new array with the replaced item
var content=buffer.join(' ');var self=this;// var data=content.length > maxLength ? `${content.substring(0, maxLength).replace(/<[^>]+>/g, "")}...` : content;
var data=content.length>maxLength?content.substring(0,maxLength)+'...':content;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:data}}),content.length>maxLength&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',onClick:function onClick(){return _this5.togglePopup(_this5.state.postID);}},'more'));}},{key:'formatRenderComment',value:function formatRenderComment(origComment,comnt_id,comment_id){var _this6=this;var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,buffer);}var stringSplit=origComment.split(" ");var maxLength=250;for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);var self=this;if(firstChar=="#"){//buffer.push(<a href="/appstore">{comp} </a>);
buffer.push(comp);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){//link
// buffer.push(<a href={comp}>{comp} </a>);
buffer.push(comp);}else if(comp.indexOf("@")!==-1||comp.indexOf("@")!==-1){/*var userdisplayname = comp.replace('@','');
               var query = new Parse.Query('_User');
               query.include("displayUsername");
               query.include("username");
               query.equalTo("displayUsername", userdisplayname);
               query.first().then(function(result){
                if(result){
                    let userdata=result;
                    let linkdatas='/user/'+userdata.get('displayUsername');
                    self.setState({linkdata:linkdatas}); 
                }
                })
                let linkdata='<a href ='+this.state.linkdata+'>'+comp+'</a>';
                  buffer.push(linkdata);  */var userdisplayname=comp.replace('@','');var linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';buffer.push(linkdata);}else{// buffer.push(<span>{comp} </span>);  
//buffer.push(comp+' ');  
buffer.push(comp);}}var content=buffer.join(' ');/* return ( <span className='cmt-txt'>
                {buffer}
                </span>
        );*/var _props=this.props,_props$showMoreText=_props.showMoreText,showMoreText=_props$showMoreText===undefined?'more':_props$showMoreText,_props$showLessText=_props.showLessText,showLessText=_props$showLessText===undefined?'less':_props$showLessText;var isExpanded=this.state.isExpanded;var expandedCommentId=this.state.expandedCommentId;// Determine whether to truncate the text
var shouldTruncate=content.length>maxLength&&!isExpanded;// Truncate the text if necessary  //expandedCommentId===comment_id
var displayText=shouldTruncate?content.slice(0,maxLength)+'...':content;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt',id:comment_id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:displayText}}),shouldTruncate&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{onClick:function onClick(){return _this6.toggleExpand(comment_id);},style:{color:'#868589',cursor:'pointer',border:'none',background:'none'}},isExpanded?showLessText:showMoreText));}},{key:'formatRenderComment_old',value:function formatRenderComment_old(origComment){var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,buffer);}var self=this;var stringSplit=origComment.split(" ");for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);if(firstChar=="#"){//buffer.push(<a href="/appstore">{comp} </a>);
buffer.push(comp);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){//link
// buffer.push(<a href={comp}>{comp} </a>);
buffer.push(comp);}else if(comp.indexOf("@")!==-1||comp.indexOf("@")!==-1){/*var userdisplayname = comp.replace('@','');
               var query = new Parse.Query('_User');
               query.include("displayUsername");
               query.include("username");
               query.equalTo("displayUsername", userdisplayname);
               query.first().then(function(result){
                if(result){
                    let userdata=result;
                    let linkdatas='/user/'+userdata.get('displayUsername');
                    self.setState({linkdata:linkdatas}); 
                }
                })
                let linkdata='<a href ='+this.state.linkdata+'>'+comp+'</a>';
                  buffer.push(linkdata); */var userdisplayname=comp.replace('@','');var linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';buffer.push(linkdata);}else{// buffer.push(<span>{comp} </span>);  
// buffer.push(comp+' ');  
buffer.push(comp);}}var content=buffer.join(' ');return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:content}}));}},{key:'getUsername',value:function getUsername(user){/*if ((!user) || (user == undefined))
            return "User";


          user.fetch();

          var username = user.get("displayUsername");

          if ((!username) || (username.length < 2)) 
          {
            username = user.get("firstName") + "_" + user.get("lastName");
            username = username.toLowerCase(username);
          }
          if ((!username) || (username.length < 2)) 
          {
            username = "facebook_user";
          }

          return username;*/}},{key:'getCommentProfilePic',value:function getCommentProfilePic(comment){var user=comment.get("fromUser");if(user&&user!=undefined){var pic=user.get("profilePictureSmall");if(pic&&pic!=undefined)return pic.url();}return"/images/default_userpic0.png";}},{key:'renderTitleURL',value:function renderTitleURL(){if(this.state.title||this.state.url){var urlDomain=this.state.url.replace('http://','').replace('https://','').split(/[/?#]/)[0];urlDomain=urlDomain.replace('www.','');if(!(this.state.url&&this.state.url.length>1)){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'titleURLContainer'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'titleText'},this.state.title)));}else{return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:this.state.url,target:'_blank'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'titleURLContainer'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'urlText'},urlDomain),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'titleText'},this.state.title))));}}else{//don't show this section
return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null);}}},{key:'formatRenderComments2main',value:function formatRenderComments2main(origComment){var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,buffer);}var stringSplit=origComment.split(" ");var maxLength=320;for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);if(comp.indexOf("#")!==-1){//buffer.push(<a href="/appstore">{comp} </a>);
//var userdisplayname = comp.replace('#','');
var linkdata='<a>'+comp+'</a>';buffer.push(linkdata);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){buffer.push('<a href='+comp+'>'+comp+'</a>');}else if(comp.indexOf("@")!==-1||comp.indexOf("@")!==-1){/*var userdisplayname = comp.replace(/\s/g, "").replace('@','');
              let linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';
                  buffer.push(linkdata);  */var regex=/@(\w+)/g;var linkedText=comp.replace(regex,'<a href="/user/$1">@$1</a>');buffer.push(linkedText);}else{buffer.push(comp);}}var content=buffer.join(' ');return{'a':__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt'},content)};//return <img src={"https:aaaa"} />
}},{key:'formatRenderComments2',value:function formatRenderComments2(origComment){var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,buffer);}var stringSplit=origComment.split(" ");var maxLength=320;for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);if(firstChar=="#"){//buffer.push(<a href="/appstore">{comp} </a>);
buffer.push(comp);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){buffer.push('<a href='+comp+'>'+comp+'</a>');}else{buffer.push(comp);}}var content=buffer.join(' ');return{'a':__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt'},content.length>maxLength?content.substring(0,maxLength).replace(/<[^>]+>/g,"")+'...':content,content.length>maxLength&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:this.state.postLink},'more'))};}},{key:'queryForSinglepost',value:function queryForSinglepost(){var post_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');query.equalTo('objectId',post_id);query.include("user");query.include("image");query.include("thumbnail");query.include("likeCountNew");query.include("saveCount");query.include("commentcount");query.include("_created_at");query.include("createdAt");query.exists("user");query.descending("createdAt");var self=this;query.find().then(function(result){if(result){self.setState({postData:result});self.setState({likeCount:result[0].get('likeCountNew')});}else{console.log("No post found");}},function(error){});}},{key:'popuprenderComments',value:function popuprenderComments(){var bufferpopup=[];if(this.state.popup_comments){for(var i=0;i<this.state.popup_comments.length;i++){var comment=this.state.popup_comments[i];var comment_activity_id="comment_"+comment.id;var _comment_id="comnt1_"+comment.id;var comment_fromuserid=comment.get("fromUser").id;bufferpopup.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{key:69*i,className:'cmt_wrap1'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usr_img_detail1'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usr_img1'}))));}}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_wrap_lists'},bufferpopup);}},{key:'renderCaption',value:function renderCaption(){if(this.props.showComments){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'commentsContainer sngl_post_cmt'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_wrap'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usr_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'userProfileImage',src:this.state.userImage})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_usr'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+this.state.getUsernamefetch},this.state.getUsernamefetch)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_cnt_full'},this.formatRenderComment_old(this.state.caption)))));}else{//don't show the user and timestamp on the main stream view
return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'commentsContainer'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'home_pg'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'cmt_box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_usr'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+this.state.getUsernamefetch},this.state.getUsernamefetch)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_cnt'},this.formatRenderComments(this.state.caption)))));}}},{key:'renderRecipeAndProduct',value:function renderRecipeAndProduct(){if(this.props.showComments){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null);}else{//don't show the user and timestamp on the main stream view
return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null);}}},{key:'renderUserHeaderSharedALinkOrCollab',value:function renderUserHeaderSharedALinkOrCollab(user,url,collabUser){var getLoggedinUsername=localStorage.getItem('username');if(collabUser&&collabUser!=undefined){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usernameText'},getLoggedinUsername===this.state.getUsernamefetch?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/my-profile'},this.state.getUsernamefetch):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+this.state.getUsernamefetch},this.state.getUsernamefetch),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'sharedA'},'\xA0and\xA0'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+collabUser},collabUser));}else if(url){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usernameText'},getLoggedinUsername===this.state.getUsernamefetch?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'my-profile'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usernameText'},this.state.getUsernamefetch,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'sharedA'},'\xA0shared a link'))):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+this.state.getUsernamefetch},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usernameText'},this.state.getUsernamefetch,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'sharedA'},'\xA0shared a link'))));}else{//don't show the user and timestamp on the main stream view
return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usernameText'},getLoggedinUsername===this.state.getUsernamefetch?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/my-profile'},this.state.getUsernamefetch):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+this.state.getUsernamefetch},this.state.getUsernamefetch));}}},{key:'singlePostModalClass',value:function singlePostModalClass(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").addClass("sngl_mdl_open");}},{key:'singlePostModalClose1',value:function singlePostModalClose1(){var self=this;this.setState({isPopupOpen:false,postDetails:null,postDetailscomment:null});__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").removeClass("sngl_mdl_open");__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").removeClass("modal-open1");__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").removeClass("modal-open");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val('');//tabopenarray.length = 0;
/*url update*/window.history.replaceState("","","/");/*url update*/}},{key:'singlePostModalClose',value:function singlePostModalClose(){var self=this;__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").removeClass("sngl_mdl_open");__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").removeClass("modal-open1");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val('');}},{key:'singlePostLikeModalLikes',value:function singlePostLikeModalLikes(main_activity_id){var post_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();this.singlegetUsersCommentLike(post_id,main_activity_id);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#large_challenge_like_list_likes').trigger('click');},500);__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").addClass("sngl_mdlpstlk_open");}},{key:'singlePostLikeModal',value:function singlePostLikeModal(){var post_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();this.singlegetUsersLike(post_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").addClass("sngl_mdlpstlk_open");}},{key:'singlePostLikeModalClose',value:function singlePostLikeModalClose(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").addClass("modal-open1");__WEBPACK_IMPORTED_MODULE_6_jquery___default()("body").removeClass("sngl_mdlpstlk_open");// console.log("Test");
}},{key:'render',value:function render(){var _this7=this;var _state=this.state,isPopupOpen=_state.isPopupOpen,loading=_state.loading,error=_state.error,postDetails=_state.postDetails,postDetailscomment=_state.postDetailscomment,loadingdata=_state.loadingdata;var likesWord="Likes";var savesWord="saves";var commentsWord="Comments";var imprWord="impressions";var page="home";var self=this;if(this.props.showComments){page='single';}var getLoggedinUsername=localStorage.getItem('username');if(this.state.likeCount==1)likesWord="Like";if(this.state.saveCount==1)savesWord="save";if(this.state.commentCount==1)commentsWord="Comment";if(this.state.imprCount==1)imprWord="impression";var post_id_m='save_'+this.state.postID;var follow_id_m='follow_'+this.state.user.id;var currentuserImage=this.state.currentuserImage;var post_like_id_m='like_'+this.state.postID;var currentUserId=this.state.currentUserId;var sameprofile=0;if(currentUserId===this.state.user.id){sameprofile=1;}//console.log(this.state.challengeStatus+'this.state.challengeStatus')
var getchallengeStatus=this.state.challengeStatus;var isChallengeEntry=this.state.isChallengeEntry;var isChallengeWinner=this.state.isChallengeWinner;var isHideEntry=this.state.isHideEntry;var isRecipe=this.state.isRecipe;var isChallengeWinnersel=0;var isRecipesel=0;if(isChallengeWinner===true){isChallengeWinnersel=1;}if(isRecipe===true){isRecipesel=1;}var ischallengeStatus=0;var isHideEntryStatus=0;var iconclass='';if(this.state.isChallengeEntry=="1"&&this.state.usertype===1&&this.state.challengeentrystatus=="Active"){iconclass='joinchallengein';}//getchallengeStatus==='Active' || 
if(this.state.isHideEntry=="1"){isHideEntryStatus=1;}if(getchallengeStatus==='Billed'||getchallengeStatus==='Pending'||getchallengeStatus==='Complete'||getchallengeStatus==='Active'){ischallengeStatus=1;}var isNotificationOpen=this.state.isNotificationOpen;var post_Notification_Ids=this.state.post_Notification_Id;var post_Notification_Msg=this.state.post_Notification_Msg;var post_Notification_Comment=this.state.post_Notification_Comment;var isPopupOpendetails=this.state.isPopupOpendetails;var postcommonid=this.state.post_common_id;if(ischallengeStatus==0||isChallengeEntry==1){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_details_section_main'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__CommonPopup_jsx__["a" /* default */],{isOpen:isPopupOpendetails,onClose:function onClose(e){_this7.togglePopup(_this7.state.post_common_id);},postcommonid:this.state.post_common_id}),isNotificationOpen?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__saveNotification_jsx__["a" /* default */],{isOpen:isNotificationOpen,postNotificationid:post_Notification_Ids,postMsg:post_Notification_Msg,postPhotoid:this.state.postID,postActivityComment:post_Notification_Comment}):"",page==='single'?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('section',{className:'post_list',style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('nav',{className:'sidebar'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Leftsidebar_jsx__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('main',{className:'listing spd_page'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'spd_page_inner singlePostOverlayModal '},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner_post_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'img_leftSide'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:'lef_img',src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/c02b98ff933601a1ddd7930d8bd0f1bc_file.bin',alt:'Comment'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'right_side_content_post'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_top_row border_bottom'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_top_card'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'user_icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'popup_user_image',src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/599cddfce141ae7f0a7d86fd18168fd7_file.bin',alt:'img'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{className:'popup_user_name',href:'/user/rosslynmaria'},'rosslynmaria'))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'/images/dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);','aria-label':'Close',className:'dropdown-item',type:'button',title:'Cancel'},'Cancel'))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_listing_ul_wrap'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('ul',{className:'post_listing_ul'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{className:'post_listing_li'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'detail_bottom user_top_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_top_card'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inline_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_leftbar_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'user_icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'popup_display_userimage',src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/599cddfce141ae7f0a7d86fd18168fd7_file.bin',alt:'img'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name_wrapper'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/rosslynmaria',className:'popup_display_username'},'rosslynmaria'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_cnt'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt',id:'full_text'},'This Grilled Peach Arugula Salad is inspired by summer and a must-try! \uD83C\uDF51\uD83E\uDD57 The sweet, juicy peaches pair perfectly with peppery arugula, creamy vegan feta, and a drizzle of olive oil, balsamic vinegar, maple syrup and salt & pepper to taste. It\u2019s a quick and delicious way to celebrate the season! Recipe: \u2022 Grill Peaches: Slice 2 ripe peaches. Lightly brush with olive oil and grill for 2-3 minutes on each side until caramelized. \u2022 Prepare Salad: Toss a handful of fresh arugula with the grilled peaches and crumble vegan feta on top. \u2022 Make Dressing: Whisk together 2 tbsp olive oil, 1 tbsp balsamic vinegar, 1 tsp maple syrup, salt and pepper. Drizzle over the salad. \u2022 Serve & Enjoy: Toss everything gently, serve immediately, and enjoy!! \uD83C\uDF1E'))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'content-span'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_sidebar_heart'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'product_content_details'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'day box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'time_interval_new'},'5d'))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',id:'like_button_challenge',type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{id:'like_count_new'},'3 Likes'))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment box'}))))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{className:'post_listing_li'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_wrap'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'detail_bottom user_top_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_top_card'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inline_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_leftbar_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'user_icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/7dbb41bbd6e35056a861bd98d8786263_file.bin'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name_wrapper'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/joel'},'joel'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'content-span'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_cnt'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,'Grilled peaches are definitely a summer seasonal treat! Simple, delicious, and healthy. The perfect trifecta. Thanks so much for sharing, Rosslyn. \uD83E\uDD57'))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_sidebar_heart'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/like-fill.svg'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/cmt-like.svg'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like box maincomment'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'count'},'1'))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'product_content_details'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'day box'},'5d'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'reply_count'},'Reply'))))))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_wrap'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'detail_bottom user_top_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_top_card'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inline_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_leftbar_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'user_icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/389fcf7e78aba3f4f5abd39780c837e1_file.bin'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name_wrapper'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/joelskitchen'},'joelskitchen'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'content-span'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_cnt'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,'Super-duper, Rosslyn! Thanks so much for sharing. \uD83D\uDE4F'))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_sidebar_heart'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'liked_activity'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'activitydefault',src:'../images/cmt-like.svg'})),' ')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'product_content_details'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'day box'},'5d'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'reply_count'},'Reply')))))))))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_post_bottom_add'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_like_shere'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'wrapper d-flex flex-row flex-wrap align-items-center justify-content-between w-100'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action_grp'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'popup_post_id',name:'popup_post_id'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'popup_load_id',name:'popup_load_id'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'reply_id',name:'reply_id'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'activity_parent_id1',name:'activity_parent_id1'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'like-icon liked'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'default1',src:'../images/like-new.svg'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',className:'comment-icon home-comment'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/comment-bold.svg',alt:'Comment'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',className:'share-icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/cmt-share-bold.svg',alt:'Share'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_save1'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'savepost_link1'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'savedefault1',src:'../images/bookmark.svg',alt:'No BookMark'})))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'liked_others'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label',null,'Liked by ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/joel',id:'like_button_challenge',type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},' joel')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,' and ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{id:'like_button_challenge',type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},'2'),' others '))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'add_in_comment'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'emoji_icon_input_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'emogi_icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/add_reaction.svg',alt:'img'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'textarea_bottom active'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('textarea',{placeholder:'Add a comment...'})))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{disabled:true,className:'post_button_comment'},'Post')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'comment_message_alert'})))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'border_top_middle'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'spd_page_grid'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3',{className:'more_post_title'},'More posts from ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,'rosslynmarie')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{'class':'gridPostRow'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{'class':'gridPost'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/a27945920eebce7bb8ea450e0cb5fa04_thumbnail.jpg'})))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{'class':'gridPost'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6b4758a0861a27967ded810dca3000eb_thumbnail.jpg'})))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{'class':'gridPost'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6b4758a0861a27967ded810dca3000eb_thumbnail.jpg'})))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{'class':'gridPost'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('figure',{'class':'thumbnail'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6b4758a0861a27967ded810dca3000eb_thumbnail.jpg'})))))))))):"",__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post-card card'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'card_inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_card'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:this.state.userImage}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'name'},this.renderUserHeaderSharedALinkOrCollab(this.state.user,this.state.url,this.state.collabUsername))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action cta_btn d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'secondary-btn btn-wrp sml-btn'},sameprofile===0?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',id:follow_id_m,'data-id':this.state.user.id,style:{display:"block"},onClick:function onClick(){return _this7.handleFollowUser(_this7.state.user);},className:'followpost_link',title:'Follow'},'Follow')):"",__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__followersUser_jsx__["a" /* default */],{postData:this.state.user})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{type:'button',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'/images/dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},sameprofile===1?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button',id:'delete_post_with_discard','data-toggle':'modal','data-target':'#deletePostCloseModal',onClick:function onClick(e){return _this7.deletePostId(_this7.state.postID);}},'Delete'):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);','data-dismiss':'modal','aria-label':'Close',className:'dropdown-item',type:'button'},'Cancel'))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'hero_image'},page=="home"?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'image_icon_wrap chlng-icon'},this.state.isChallengeEntry=="1"&&this.state.usertype===1&&this.state.isHideEntry==="0"&&this.state.challengeentrystatus=="Active"?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'join_challange',style:{'backgroundColor':this.state.barcolor?'#'+this.state.barcolor:'#c13828'}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this7.hometaps(_this7.state.postID,_this7.state.challenge_id);},id:'large_challenge_image_challenge',className:'sinlg_post_over_mdl',type:'button'},'Join Challenge Now',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'/images/arrow_forward.svg',alt:'Join Arrow'}))):'',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:iconclass?'iconGrp '+iconclass:'iconGrp'},isRecipesel===1?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'recipe'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/recipe-icon-img.svg'})):"",isChallengeWinnersel===1?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'winner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/winner-icon-img.svg'})):""),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){_this7.togglePopup(_this7.state.postID);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'img-thumbnail',src:this.state.postImage}))):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'image_icon_wrap chlng-icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'iconGrp'},this.state.isChallengeEntry=="1"&&this.state.usertype===1&&this.state.challengeentrystatus=="Active"?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'join_challange',style:{'backgroundColor':this.state.barcolor?'#'+this.state.barcolor:'#c13828'}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/challenge/'+this.state.challenge_id,id:'large_challenge_image_challenge',className:'sinlg_post_over_mdl',type:'button'},'Join Challenge Now',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'/images/arrow_forward.svg',alt:'Join Arrow'}))):'',isRecipesel===1?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'recipe'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/recipe-icon-img.svg'})):"",isChallengeWinnersel===1?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'winner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/winner-icon-img.svg'})):""),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',id:'large_challenge_image_btn2',type:'button','data-toggle':'modal'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'img-thumbnail',src:this.state.postImage}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',style:{display:"none"},'data-toggle':'modal','data-target':'#large_challenge_image3',id:'large_challenge_image_btn22',type:'button'},'modal')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_challange '},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cta_btn third-btn btn-wrp'},sameprofile===1&&this.state.isChallenge==0?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/create-challenge/'+this.state.postID,title:'Create Challenge'},'Create Challenge'):"")),this.renderTitleURL(),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_mn'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_action'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'wrapper d-flex flex-row flex-wrap align-items-center justify-content-between w-100'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action_grp'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'like-icon liked',id:post_like_id_m},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:post_like_id_m,onClick:function onClick(){return _this7.handlePhotoLike(_this7.state.postID,page);},className:'default',src:'../images/like.svg'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:post_like_id_m,onClick:function onClick(){return _this7.handlePhotoUnLike(_this7.state.postID,page);},className:'active',style:{display:"none"},src:'../images/like-fill.svg'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__getLikePostHome_jsx__["a" /* default */],{postIdData:this.state.postID})),getLoggedinUsername===null?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'comment-icon',onClick:function onClick(){return _this7.handleNotLoginClick();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/comment.svg',alt:'Comment'})):getLoggedinUsername!=null&&page==='home'?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'comment-icon home-comment',onClick:function onClick(e){_this7.togglePopup(_this7.state.postID);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/comment.svg',alt:'Comment'})):getLoggedinUsername!=null&&page==='single'?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this7.handleCommentSingleClick();},className:'comment-icon single-comment '},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/comment.svg',alt:'Comment'})):"",__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'../appstore',className:'share-icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/cmt-share.svg',alt:'Share'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_save'},getLoggedinUsername!=null?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',style:{display:"block"},id:post_id_m,className:'savepost_link'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:post_id_m,style:{display:"block"},className:'savedefault',src:'../images/bookmark.svg',onClick:function onClick(){return _this7.handleSavePost(_this7.state.postID,page);},alt:'No BookMark'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:post_id_m,style:{display:"none"},className:'saveactive',src:'../images/bookmark-fill.svg',onClick:function onClick(){return _this7.handleRemoveSavePost(_this7.state.postID,page);},alt:'BookMark'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__postSaveUser_jsx__["a" /* default */],{postIdData:this.state.postID})):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this7.handleNotLoginClick();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{style:{display:"block"},className:'savedefault',src:'../images/bookmark.svg',alt:'No BookMark'}))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like-count comment_count d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',onClick:function onClick(e){_this7.togglePopup(_this7.state.postID);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{id:'like_counts_'+this.state.postID},this.state.likeCount),'\xA0',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{id:'like_words_'+this.state.postID},likesWord)))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_list'},this.renderRecipeAndProduct(),this.renderCaption()),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_count d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',id:'large_challenge_image_btn2','data-id':this.state.postID,onClick:function onClick(e){_this7.togglePopup(_this7.state.postID);},type:'button'},'View all ',this.state.commentCount,' ',commentsWord)))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_list_mn '},getLoggedinUsername!=null&&this.props.showComments?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_inpt_grp'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inptWrap'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'usr_img'},currentuserImage!==null?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:currentuserImage,alt:'User Image'}):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'/images/default_userpic0.png'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inpt_box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_mentions__["b" /* MentionsInput */],{placeholder:'Add a comment...',id:'comment_box',value:this.state.singlementioned,onChange:this.updateInput,style:__WEBPACK_IMPORTED_MODULE_8__defaultStyle__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_mentions__["a" /* Mention */],{trigger:'@',data:this.state.singleget_allusers,markup:'@__display__ ',displayTransform:function displayTransform(id,display,displayName){return'@'+display;},appendSpaceOnAdd:true,style:__WEBPACK_IMPORTED_MODULE_9__defaultMentionStyle__["a" /* default */],renderSuggestion:this.singlerenderUserSuggestion,required:true,id:'comment_box',className:'mentions__mention',placeholder:'Add a comment...'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'comment_message_alert'},this.state.blank_comment_message)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cmt_action_wrap'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{id:'cancelCommentPost',className:'cnlebtn',onClick:this.cancelText},'Cancel'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{id:'handleCommentPost',className:'postbtn',onClick:this.handleCommentPost},'Post'))):'',this.state.loadpage==='single'?this.renderComments():'','        ')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay deleteCommentCloseModal',id:'deleteCommentCloseModal','data-backdrop':'false','data-keyboard':'false',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h6',null,'Are you sure you want to delete?')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'delete_comment_id',name:'delete_comment_id'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn danger btn-post-discard','data-dismiss':'modal','aria-label':'Close',onClick:this.checkDeleteComment,title:'Discard'},'Delete'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel','data-dismiss':'modal','aria-label':'Close',title:'Cancel'},'Cancel'))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay deletePostCloseModal',id:'deletePostCloseModal','data-backdrop':'false','data-keyboard':'false',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h6',null,'Are you sure you want to delete this post?')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'delete_post_id',name:'delete_post_id'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn danger btn-post-discard','data-dismiss':'modal','aria-label':'Close',onClick:function onClick(e){return _this7.checkDeletePost();},title:'Delete'},'Delete'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel','data-dismiss':'modal','aria-label':'Close',title:'Cancel'},'Cancel'))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay singlePostOverlayModal createPostCloseModal large_challenge_image',id:'large_challenge_image2','data-backdrop':'false','data-keyboard':'false',role:'dialog','aria-labelledby':'createPostCloseTitle'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel',onClick:this.singlePostModalClose,'data-dismiss':'modal','aria-label':'Close',title:'Close'},'\u2715'))))),isPopupOpen&&loading?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',null):error?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',null,error):postDetails&&isPopupOpen&&postDetailscomment&&this.renderDetailPage(postDetails.id)));}else{return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null);}}}]);return GridSinglePost;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this8=this;this.onEmojiClick=function(event,emojiObject){_this8.setState(function(prevState){return{//inputText: prevState.inputText + emojiObject.emoji,
singlementioned_popup:prevState.singlementioned_popup+emojiObject.emoji,showPicker:false// Optional: hide the picker after selection
};});};this.togglePicker=function(){_this8.setState(function(prevState){return{showPicker:!prevState.showPicker};});};this.handleUnFollowMyProfileLike=function(e){var datapost_id=e.target.dataset.id;var self=_this8;var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('User');query.equalTo("objectId",datapost_id);query.first().then(function(result){if(result){var touser=result;var checksavequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');checksavequery.equalTo('type','follow');checksavequery.equalTo('toUser',touser);checksavequery.equalTo('fromUser',currentUser);checksavequery.first().then(function(object){if(object){return object.destroy();}}).then(function(deletedObject){setTimeout(function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style","display: block");self.singlegetUsersCommentLike(datapost_id);},1000);}).catch(function(error){console.error('Error deleting record:',error);});}});}else{// $('#kitchenQrModal_btn').trigger('click');  
return false;}};this.handleUnFollowMyProfile=function(e){var self=_this8;var datapost_id=e.target.dataset.id;var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('User');query.equalTo("objectId",datapost_id);query.first().then(function(result){if(result){var touser=result;var checksavequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');checksavequery.equalTo('type','follow');checksavequery.equalTo('toUser',touser);checksavequery.equalTo('fromUser',currentUser);checksavequery.first().then(function(object){if(object){return object.destroy();}}).then(function(deletedObject){setTimeout(function(){self.singlegetUsersLike(datapost_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style","display: block");},1000);}).catch(function(error){console.error('Error deleting record:',error);});}});}else{// $('#kitchenQrModal_btn').trigger('click');  
return false;}};this.handleFollowMyProfile=function(e){var datapost_id=e.target.dataset.id;var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var self=_this8;if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('User');query.equalTo("objectId",datapost_id);query.first().then(function(result){if(result){var touser=result;var Activity=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Activity");var activity=new Activity();activity.set('fromUser',currentUser);activity.set('toUser',touser);activity.set('type','follow');activity.save().then(function(savedFile){setTimeout(function(){//$('a.unfollowpost_link#follow_'+datapost_id).attr("style", "display: block");
//$('a.followpost_link#follow_'+datapost_id).attr("style", "display: none");
self.singlegetUsersLike(datapost_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style","display: block");self.toggleNotification(touser,'started following you.','');self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});},1000);}).catch(function(error){});}});}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}};this.handleFollowMyProfileLike=function(e){var datapost_id=e.target.dataset.id;var self=_this8;var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('User');query.equalTo("objectId",datapost_id);query.first().then(function(result){if(result){var touser=result;var Activity=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Activity");var activity=new Activity();activity.set('fromUser',currentUser);activity.set('toUser',touser);activity.set('type','follow');activity.save().then(function(savedFile){setTimeout(function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style","display: block");self.singlegetUsersCommentLike(datapost_id);},1000);}).catch(function(error){});}});}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}};this.fetchData=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var photo_post_id,query,self;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:photo_post_id=_this8.state.postID;query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query.equalTo('photo',"Photo$"+photo_post_id);//query query1 = await query1.get(postId);
query.equalTo("type","comment");query.doesNotExist("activity");query.include("fromUser");query.include("photo");query.include("image");query.include("content");query.include("_created_at");query.include("createdAt");query.ascending("_created_at");//query.descending("_created_at");
self=_this8;query.find().then(function(result){if(result){self.setState({singlementioned_popup:''});self.setState({comments:result});self.setState({commentCount:result.length});var commentdataresults1=[];var _loop2=function _loop2(){var userActivitylist=[];comment=result[i];replyQuery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');replyQuery.equalTo('photo',"Photo$"+photo_post_id);replyQuery.exists("activity");replyQuery.equalTo('activity',"Activity$"+comment.id);replyQuery.include("photo");replyQuery.ascending("_created_at");//replyQuery.descending("_created_at");
replyQuery.find().then(function(result){if(result){var processedData=result.map(function(result){return{id:result.id,content:result.get('content'),createdAt:result.get('createdAt'),fromUser:result.get('fromUser'),likeCount:result.get('likeCount'),toUser:result.get('toUser'),type:result.get('type'),updatedAt:result.get('updatedAt')};});userActivitylist.push(processedData);}});commentdataresults1.push({comments:comment,children:userActivitylist});};for(var i=0;i<result.length;i++){var comment;var replyQuery;_loop2();}}else{}},function(error){});case 14:case'end':return _context.stop();}}},_callee,_this8);}));this.fetchPostData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(postId){var Post,query,post,userlikelist,query1,self;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0://console.log('fetchPostData'+postId);
_this8.setState({loading:true,error:null});_context2.prev=1;Post=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend('Photo');query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query(Post);_context2.next=6;return query.get(postId);case 6:post=_context2.sent;userlikelist=[];query1=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query1.equalTo('photo',"Photo$"+postId);query1.equalTo("type","comment");query1.include("fromUser");query1.include("photo");query1.include("image");query1.include("content");query1.include("_created_at");query1.include("createdAt");query1.doesNotExist("activity");query1.ascending("_created_at");self=_this8;query1.find().then(function(result){if(result){var commentdataresults=[];var _loop3=function _loop3(){var userActivitylist=[];comment=result[i];replyQuery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');replyQuery.equalTo('photo',"Photo$"+postId);replyQuery.exists("activity");replyQuery.equalTo('activity',"Activity$"+comment.id);replyQuery.include("photo");replyQuery.ascending("_created_at");//replyQuery.descending("_created_at");
replyQuery.find().then(function(result){if(result){var processedData=result.map(function(result){return{id:result.id,content:result.get('content'),createdAt:result.get('createdAt'),fromUser:result.get('fromUser'),likeCount:result.get('likeCount'),toUser:result.get('toUser'),type:result.get('type'),updatedAt:result.get('updatedAt')};});userActivitylist.push(processedData);}});commentdataresults.push({comments:comment,children:userActivitylist});};for(var i=0;i<result.length;i++){var comment;var replyQuery;_loop3();}self.setState({postDetailscomment:commentdataresults,//result,
postDetails:post,loading:false,loadingdata:true});var obj=post.get('caption')!=''?self.formatRenderComments2main(post.get('caption')):self.formatRenderComments2main(post.get('caption'));var full_text=obj.a.props.children?obj.a.props.children:'';__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#full_text').html(full_text);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#lef_img').attr('src','../images/default_userpic0.png');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_user_image').attr('src','../images/default_userpic0.png');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_display_userimage').attr('src','../images/default_userpic0.png');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.user_name a.popup_user_name').html('');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.user_name a.popup_user_name').html(post.get('user').get('displayUsername'));__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.user_name a.popup_user_name').attr("href","/user/"+post.get('user').get('displayUsername'));__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_display_username').html(post.get('user').get('displayUsername'));__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_display_username').attr("href","/user/"+post.get('user').get('displayUsername'));var userprofileimage=post?post.get('user')?post.get('user').get('profilePictureSmall')?post.get('user').get('profilePictureSmall').url():'../images/default_userpic0.png':'../images/default_userpic0.png':'../images/default_userpic0.png';__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_user_image').attr('src',userprofileimage);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_display_userimage').attr('src',userprofileimage);var photo_img=post?post.get('image')?post.get('image')?post.get('image').url():'../images/default_userpic0.png':'../images/default_userpic0.png':'../images/default_userpic0.png';__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#lef_img').attr('src',photo_img);var likeCountNew=post.get('likeCountNew')?post.get('likeCountNew'):0;var likesWord="Likes";if(likeCountNew==1){likesWord="Like";}__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#like_count_new').html(likeCountNew+' '+likesWord);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.time_interval_new').html(time_ago(post.get('createdAt')));document.getElementById('large_challenge_image_btn22').click();self.singlegetAllUsersPopup();//
self.handleGetSavePost(post.id,'popup');self.singlegetUsersLike(post.id);self.handleGetLikeUser(postId);//count update
var postimpt=post?post.get('impr')+1:1;post.set('impr',postimpt);post.save().then(function(postupdated){});//count update
/*url update*///let stateObj = { postId: postId }; 
window.history.replaceState(window.history.state,"","/post/"+postId);/*url update*/}else{}//$('#large_challenge_image2').trigger('click');
},function(error){});//comment listing 
_context2.next=26;break;case 23:_context2.prev=23;_context2.t0=_context2['catch'](1);_this8.setState({//error: 'Failed to fetch post data',
loading:false});case 26:case'end':return _context2.stop();}}},_callee2,_this8,[[1,23]]);}));return function(_x){return _ref2.apply(this,arguments);};}();this.openPopup=function(postId){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val(postId);_this8.setState({isPopupOpen:true},function(){_this8.fetchPostData(postId);});};this.hometaps=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(postId,challengeId){var getPhotoquery;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:getPhotoquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');getPhotoquery.equalTo('objectId',postId);getPhotoquery.first().then(function(photo){if(photo){var homeCount=photo.get('homeCount')?photo.get('homeCount'):0;if(homeCount){var updated_comment_count=parseInt(homeCount)+1;}else{var updated_comment_count=1;}photo.set("homeCount",updated_comment_count.toString());photo.save().then(function(photodata){window.location.href='/challenge/'+challengeId;}).catch(function(error){console.log(error.message);});}});case 3:case'end':return _context3.stop();}}},_callee3,_this8);}));return function(_x2,_x3){return _ref3.apply(this,arguments);};}();this.handleCommentPostUpdate=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var photo_post_id,reply_thread_id,self,query,reply_id,commentCountval,getPhotoquery;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:photo_post_id=_this8.state.postID;reply_thread_id=_this8.state.reply_thread_id;self=_this8;query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');reply_id=_this8.state.reply_id;query.equalTo('photo',"Photo$"+photo_post_id);query.equalTo("type","comment");query.doesNotExist("activity");query.include("fromUser");query.include("photo");query.limit(999999999);query.include("image");query.include("content");query.include("_created_at");query.include("createdAt");//query.descending("_created_at");
query.ascending("_created_at");commentCountval=_this8.state.commentCount;query.find().then(function(result){var commentdataresults1=[];if(result){var totalcomment=result.length;var totalcommentchild=0;self.setState({singlementioned_popup:''});self.setState({comments:result});var _loop4=function _loop4(){var userActivitylist=[];comment=result[i];comment_idsval=comment.id;replyQuery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');replyQuery.equalTo('photo',"Photo$"+photo_post_id);replyQuery.exists("activity");replyQuery.equalTo('activity',"Activity$"+comment.id);replyQuery.include("photo");replyQuery.ascending("_created_at");// replyQuery.descending("_created_at");
replyQuery.find().then(function(result){if(result){//totalcommentchild=result.length;
var processedData=result.map(function(result){return{id:result.id,content:result.get('content'),createdAt:result.get('createdAt'),fromUser:result.get('fromUser'),likeCount:result.get('likeCount'),toUser:result.get('toUser'),type:result.get('type'),updatedAt:result.get('updatedAt')};});userActivitylist.push(processedData);}//self.handleGetActivityLikePostChild(comment_idsval) ; 
//self.handleGetActivityLikePost(result.id); 
});commentdataresults1.push({comments:comment,children:userActivitylist});/*setTimeout(() => {
                if(comment.id) {
                  // $('.comment_like  .comment.box a .reply_count#comnt_'+comment.id).trigger('click');
                    self.handleGetActivityLikePostChild(comment.id)
                }
              },1000); */};for(var i=0;i<result.length;i++){var comment;var comment_idsval;var replyQuery;_loop4();}setTimeout(function(){self.setState({postDetailscomment:commentdataresults1},function(){self.setState({loadingdata:true,loading:false,singlementioned_popup:'',loader:false,reply_id:''});});if(reply_thread_id){__WEBPACK_IMPORTED_MODULE_6_jquery___default()(' a.liked_activity_child .activitydefault#comment_'+reply_thread_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activityactive#comment_'+reply_thread_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box .count#childlike_'+reply_thread_id).html(0);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box .like_count#childlike_'+reply_thread_id).html('Likes');}self.setState({reply_thread_id:''});setTimeout(function(){self.handleCommentPostLikes();__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#activity_parent_id').val('');},500);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_button_comment#handleCommentPost_popup').attr("disabled",false);},3500);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#reply_id').val('');}else{}},function(error){});getPhotoquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');getPhotoquery.equalTo('objectId',photo_post_id);self=_this8;getPhotoquery.find().then(function(photo){if(photo){var photo_ob=photo[0];var commentcount=photo_ob.get('commentcount')?photo_ob.get('commentcount'):0;self.setState({commentCount:commentcount});photo_ob.set("commentcount",commentcount.toString());photo_ob.save();}});case 22:case'end':return _context4.stop();}}},_callee4,_this8);}));this.handleCommentPostLikes=function(){var post_id=_this8.state.postID;var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var query_activityChild=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query_activityChild.equalTo('photo',"Photo$"+post_id);query_activityChild.exists("activity");query_activityChild.find().then(function(resultactivity){var resultactivitys=resultactivity;var _loop5=function _loop5(objects){setTimeout(function(){if(objects.get('likeCount')===0){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activityactive#comment_'+objects.id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activitydefault#comment_'+objects.id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box .count#childlike_'+objects.id).html(0);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box .like_count#childlike_'+objects.id).html('Likes');}},1000);};var _iteratorNormalCompletion7=true;var _didIteratorError7=false;var _iteratorError7=undefined;try{for(var _iterator7=resultactivitys[Symbol.iterator](),_step7;!(_iteratorNormalCompletion7=(_step7=_iterator7.next()).done);_iteratorNormalCompletion7=true){var objects=_step7.value;_loop5(objects);}}catch(err){_didIteratorError7=true;_iteratorError7=err;}finally{try{if(!_iteratorNormalCompletion7&&_iterator7.return){_iterator7.return();}}finally{if(_didIteratorError7){throw _iteratorError7;}}}});}};this.closePopup=function(){_this8.setState({isPopupOpen:false,postDetails:null,postDetailscomment:null,postDetailsReplycomment:null});};this.replyComment=function(commentId,activity_parent_id,event){var commentIds=commentId.split('comnt_');var commenUpdatedId=commentIds[1];__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#reply_id').val(commenUpdatedId);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#activity_parent_id').val(activity_parent_id);_this8.setState({reply_id:commenUpdatedId});var reply_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#reply_id').val();var query1=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query1.equalTo('objectId',commenUpdatedId);query1.equalTo("type","comment");query1.include("fromUser");var self=_this8;__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.add_in_comment #comment_box_popup').val('');var activity_parent_ids=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#activity_parent_id').val();query1.find().then(function(photo){if(photo){var photo_ob=photo[0];var displayusername=photo_ob?photo_ob.get('fromUser')?'@'+photo_ob.get('fromUser').get('displayUsername')+'  ':'':'';var displayusernameval=photo_ob?photo_ob.get('fromUser')?photo_ob.get('fromUser').get('displayUsername'):'':'';self.setState({singlementioned_popup:displayusername});}});setTimeout(function(){if(activity_parent_ids===''&&reply_id===''){self.setState({singlementioned_popup:''});__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#clearInput').trigger('click');}},2000);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.add_in_comment #comment_box_popup').focus();};this.renderDetailPage=function(post_id){var _state2=_this8.state,postDetails=_state2.postDetails,postDetailscomment=_state2.postDetailscomment,likeuserlist=_state2.likeuserlist,inputText=_state2.inputText,showPicker=_state2.showPicker,postDetailsReplycomment=_state2.postDetailsReplycomment,loadingdata=_state2.loadingdata,loader=_state2.loader;var othertext='';var bufferdata=[];var bufferdatacommentreply=[];var userlikeusername=[];var fetchuserlikeusername=[];var bufferfollowers=[];var bufferlikefollowers=[];var formatRenderCommentChild=function formatRenderCommentChild(origComment,comnt_id,comment_id){var buffer=[];if(!origComment){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,buffer);}var stringSplit=origComment.split(" ");var maxLength=250;for(var i=0;i<stringSplit.length;i++){var comp=stringSplit[i];var firstChar=comp.charAt(0);var self=_this8;if(firstChar=="#"){buffer.push(comp);}else if(comp.indexOf("http://")!==-1||comp.indexOf("https://")!==-1){buffer.push(comp);}else if(comp.indexOf("@")!==-1||comp.indexOf("@")!==-1){var userdisplayname=comp.replace('@','');var linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';buffer.push(linkdata);}else{buffer.push(comp);}}var content=buffer.join(' ');var _props2=_this8.props,_props2$showMoreText=_props2.showMoreText,showMoreText=_props2$showMoreText===undefined?'more':_props2$showMoreText,_props2$showLessText=_props2.showLessText,showLessText=_props2$showLessText===undefined?'less':_props2$showLessText;var isExpanded=_this8.state.isExpanded;var expandedCommentId=_this8.state.expandedCommentId;var shouldTruncate=content.length>maxLength&&!isExpanded;var displayText=shouldTruncate?content.slice(0,maxLength)+'...':content;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt',id:comment_id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:displayText}}),shouldTruncate&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{onClick:function onClick(){return _this8.toggleExpand(comment_id);},style:{color:'#868589',cursor:'pointer',border:'none',background:'none'}},isExpanded?showLessText:showMoreText));};var clearInput=function clearInput(){var self=_this8;//this.setState({ inputValue: '' });
self.setState({singlementioned_popup:''});};var getCommentProfilePicChild=function getCommentProfilePicChild(comment){var user=comment.fromUser;if(user&&user!=undefined){var pic=user.get('profilePictureSmall');if(pic&&pic!=undefined)return pic.url();}return"/images/default_userpic0.png";};if(_this8.state.postDetailscomment){if(_this8.state.postDetailscomment.length>0){var buffercommentdata=[];var _loop6=function _loop6(){comment=_this8.state.postDetailscomment[i];var children=comment.children!==undefined?comment.children[0]:'';comment=comment.comments;var comment_activity_id="comment_"+comment.id;var comment_id="comnt_"+comment.id;var comment_par_id="comnt_"+comment.id;var likeCount=comment.get("likeCount")?comment.get("likeCount"):0;likesWord="Likes";if(likeCount==1)likesWord="Like";var comment_fromuserid=comment.get("fromUser")?comment.get("fromUser").id:'';var comment_currentUserId=_this8.state.currentUserId;var hasKey=comment.has('activity');//console.log(i);
self=_this8;var main_activity_id=comment.id;bufferdata.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{key:69*i,className:'cmt_wrap'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'detail_bottom user_top_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_top_card'},hasKey==false?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inline_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_leftbar_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'user_icon'},' ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:_this8.getCommentProfilePic(comment)}),'  ')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name_wrapper'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name'},comment.get("fromUser")?comment.get("fromUser").get('displayUsername')?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+comment.get("fromUser").get('displayUsername')},comment.get("fromUser").get('displayUsername')):'':'',hasKey==false?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'content-span'},'  ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_cnt',id:comment_id},_this8.formatRenderComment(comment.get("content"),comment_id,comment.id))):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,_this8.formatRenderComment(comment.get("content"),comment_id,comment.id),' ')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_sidebar_heart'},_this8.handleGetActivityLikePost(comment.id),likeCount==0?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'liked_activity',id:comment_activity_id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{'data-id':comment.id,id:comment_activity_id,onClick:function onClick(e){_this8.handlePhotoActivityLike(e);},className:'activitydefault',src:'../images/cmt-like.svg'})):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'liked_activity',id:comment_activity_id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{'data-id':comment.id,id:comment_activity_id,onClick:function onClick(e){_this8.handlePhotoActivityUnLike(e);},className:'activityactive',style:{display:"none"},src:'../images/like-fill.svg'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{'data-id':comment.id,id:comment_activity_id,onClick:function onClick(e){_this8.handlePhotoActivityLike(e);},className:'activitydefault',src:'../images/cmt-like.svg'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like box maincomment',id:comment.id,style:{display:likeCount===0?'none':'block'}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',id:'like_button_challenge',onClick:function onClick(e){_this8.singlePostLikeModalLikes(main_activity_id,false);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'count'},likeCount),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'like_count',style:{display:"none"}},likesWord))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'product_content_details'},hasKey==false?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center',id:comment_id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'day box'},time_ago(comment.get("createdAt"))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'reply_count',id:comment_id,onClick:function onClick(e){return _this8.replyComment(comment_id,main_activity_id,e);}},'Reply'))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment box',style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'/images/small_dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},comment_fromuserid===comment_currentUserId?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button',onClick:function onClick(e){return _this8.deleteCommentIdOverlay(comment_id);},id:'close_deleteCommentwithdiscard','aria-label':'Modal'},'Delete'):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report '),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item',type:'button'},'Cancel')))))):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null),children!==undefined&&children.length>0&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'view_replies_comment'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'faq-drawer'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{className:'faq-drawer__trigger',id:"faq-drawer-"+comment.id,type:'checkbox',title:comment_id,onClick:function onClick(e){return _this8.faqOpenClose(comment_id);}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label',{className:'faq-drawer__title',htmlFor:"faq-drawer-"+comment.id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{id:"faq-"+comment.id},'View Replies '),' ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'replies_count',id:"faqreply-"+comment.id},'(',children.length,')'),' '),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'faq-drawer__content-wrapper',id:"fq-"+comment.id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'faq-drawer__content'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('ul',{className:'ul_list_replay_user'},loadingdata&&children&&children.map(function(child,i,row){{var _comment_fromuserid=child.fromUser.id;var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var _comment_currentUserId='';if(currentUser){_comment_currentUserId=currentUser.id;}//console.log('child');
//console.log(child);
//self.state.singlementioned_popup='';
var comment_activity_id_child="comment_"+child.id;var comment_id_child="comnt_"+child.id;var likeCountChild=child.likeCount?child.likeCount:0;//this.state.singlelikeCountChild=child.likeCount?child.likeCount:0;
//console.log(likeCountChild+'likeCount children');
var likesWord="Likes";if(likeCountChild==1)likesWord="Like";return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{className:'li_list_replay_user',key:69*i},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_replay_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_replay_inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_userimg_inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:getCommentProfilePicChild(child)})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_content_inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'content_replay'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'title_userName'},' ',child.fromUser?child.fromUser.get('displayUsername')?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+child.fromUser.get('displayUsername')},child.fromUser.get('displayUsername')):'':'',' '),'  ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'content-span'},'  ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_cnt',id:comment_id_child},formatRenderCommentChild(child.content,comment_id_child,child.id)))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'day box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;'},time_ago(child.createdAt))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'reply_count',id:comment_id_child,onClick:function onClick(e){return self.replyComment(comment_id_child,main_activity_id,e);}},'Reply'))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment box',style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot dropup'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist1',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'/images/small_dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'dropdown-menu'},_comment_fromuserid===_comment_currentUserId?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button',onClick:function onClick(e){return self.deleteCommentIdOverlay(comment_id_child);},id:'close_deleteCommentwithdiscard','aria-label':'Modal'},'Delete'):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report '),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item',type:'button'},'Cancel'))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_user_content'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'liked_activity_child',id:comment_activity_id_child},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{'data-id':child.id,id:comment_activity_id_child,onClick:function onClick(e){self.handlePhotoActivityUnLikeChild(e);},className:'activityactive',style:{display:"none"},src:'../images/like-fill.svg'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{'data-id':child.id,id:comment_activity_id_child,onClick:function onClick(e){self.handlePhotoActivityLikeChild(e);},className:'activitydefault',src:'../images/cmt-like.svg',style:{display:"block"}})),self.handleGetActivityLikePostChild(child.id,child),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like box childcomment',id:"child_"+child.id,style:{display:likeCountChild===0?'none':'block'}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',id:'like_button_challenge',onClick:function onClick(e){self.singlePostLikeModalLikes(child.id,false);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'count',id:"childlike_"+child.id},likeCountChild),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'like_count',style:{display:"none"},id:"childlike_"+child.id},likesWord))))))));}})))))))))):''))));};for(var i=0;i<_this8.state.postDetailscomment.length;i++){var comment;var likesWord;var self;_loop6();}}}if(_this8.state.likeuserlist){var rows=_this8.state.likeuserlist.length;var other=0;for(var i=0;i<rows;i++){var likeuser=_this8.state.likeuserlist[i];if(rows>1){other=rows-1;}if(i==0){if(likeuser.get('fromUser')&&likeuser.get('fromUser').id!==undefined){userlikeusername.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{key:69*i},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+likeuser.get('fromUser').get("displayUsername"),id:'like_button_challenge',onClick:_this8.singlePostLikeModal,type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},'  ',likeuser.get('fromUser').get("displayUsername"))));}}}if(userlikeusername){fetchuserlikeusername.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{key:69*i},userlikeusername!=''?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'liked_others'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label',null,'Liked by  ',userlikeusername,' ',rows>1&&other?other==1?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,' and ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{id:'like_button_challenge',onClick:_this8.singlePostLikeModal,type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},other),'  other '):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,' and ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{id:'like_button_challenge',onClick:_this8.singlePostLikeModal,type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},other),'  others '):"",' ')):''));/**/}}if(_this8.state.followersListing){var followinguserid=_this8.state.followinguserid;var following_match_id=[];var rows=_this8.state.followersListing.length;if(rows!=undefined){for(var i=0;i<rows;i++){var followers=_this8.state.followersListing[i];var follow_id_ms='followpopup_'+followers.id;var userimage=null;if(followers.image){userimage=followers.image;}else{userimage="/images/default_userpic0.png";}var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUserid=currentUser.id;var chek=followinguserid.find(function(c){return c.id===followers.id;});//'K1iL8XNQOd'  
var followingresults=chek!=undefined?JSON.parse(JSON.stringify(chek)):"";bufferfollowers.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{key:69*i},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'img_like_li'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like_user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'mr-3',src:userimage,alt:'Generic placeholder image'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like_user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4',{className:'name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+followers.displayUsername},followers.displayName,' ')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5',{className:'name_tagline'},followers.displayUsername))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'followimg_button'},currentUserid===followers.id?"":followingresults.id===followers.id?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'following_user follow_button ',id:follow_id_ms,title:'UnFollow','data-id':followers.id,onClick:function onClick(e){return _this8.handleUnFollowMyProfile(e);}},'Unfollow'):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{id:follow_id_ms,title:followers.toUser,'data-id':followers.id,onClick:function onClick(e){return _this8.handleFollowMyProfile(e);},style:{display:"block"},href:'javascript:void(0);',className:'follow_user follow_button'},'Follow'))));}else{// var followingresults= chek!=undefined?JSON.parse(JSON.stringify(chek)):""; 
bufferfollowers.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{key:69*i},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'img_like_li'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like_user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'mr-3',src:userimage,alt:'Generic placeholder image'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like_user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4',{className:'name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+followers.displayUsername},followers.displayName,' ')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5',{className:'name_tagline'},followers.displayUsername))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'followimg_button'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{id:follow_id_ms,title:followers.toUser,'data-id':followers.id,onClick:function onClick(e){return _this8.handleFollowMyProfile(e);},style:{display:"block"},href:'javascript:void(0);',className:'follow_user follow_button'},'Follow'))));}}}}if(_this8.state.followerslikeListing){var _followinguserid=_this8.state.followinglikeuserid;var following_match_id=[];var rows=_this8.state.followerslikeListing.length;if(rows!=undefined){for(var i=0;i<rows;i++){var followers=_this8.state.followerslikeListing[i];var follow_id_ms='followpopup_'+followers.id;var _userimage=null;if(followers.image){_userimage=followers.image;}else{_userimage="/images/default_userpic0.png";}var _currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(_currentUser){var _currentUserid=_currentUser.id;var chek=_followinguserid.find(function(c){return c.id===followers.id;});//'K1iL8XNQOd'  
var followingresults=chek!=undefined?JSON.parse(JSON.stringify(chek)):"";bufferlikefollowers.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{key:69*i},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'img_like_li'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like_user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'mr-3',src:_userimage,alt:'Generic placeholder image'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like_user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4',{className:'name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+followers.displayUsername},followers.displayName,' ')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5',{className:'name_tagline'},followers.displayUsername))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'followimg_button'},_currentUserid===followers.id?"":followingresults.id===followers.id?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'following_user follow_button ',id:follow_id_ms,title:'UnFollow','data-id':followers.id,onClick:function onClick(e){return self.handleUnFollowMyProfileLike(e);}},'Unfollow'):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{id:follow_id_ms,title:followers.toUser,'data-id':followers.id,onClick:function onClick(e){return self.handleFollowMyProfileLike(e);},style:{display:"block"},href:'javascript:void(0);',className:'follow_user follow_button'},'Follow'))));}else{// var followingresults= chek!=undefined?JSON.parse(JSON.stringify(chek)):""; 
bufferlikefollowers.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{key:69*i},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'img_like_li'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like_user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'mr-3',src:_userimage,alt:'Generic placeholder image'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like_user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4',{className:'name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/user/'+followers.displayUsername},followers.displayName,' ')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5',{className:'name_tagline'},followers.displayUsername))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'followimg_button'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{id:follow_id_ms,title:followers.toUser,'data-id':followers.id,onClick:function onClick(e){return self.handleFollowMyProfileLike(e);},style:{display:"block"},href:'javascript:void(0);',className:'follow_user follow_button'},'Follow'))));}}}}var getLoggedinUsername=localStorage.getItem('username');var post_id_m='save_'+post_id;var follow_id_m='follow_'+_this8.state.user.id;var currentuserImage=_this8.state.currentuserImage;var post_like_id_m='like_'+post_id;var currentUserId=_this8.state.currentUserId;var sameprofile=0;if(currentUserId===_this8.state.user.id){sameprofile=1;}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay singlePostOverlayModal createPostCloseModal large_challenge_image',id:'large_challenge_image3','data-backdrop':'false','data-keyboard':'true',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel',onClick:_this8.singlePostModalClose1,'data-dismiss':'modal','aria-label':'Close',title:'Close'},'\u2715')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{style:{display:"none"},href:'javascript:void(0);',type:'button',className:'btn','data-toggle':'modal','data-target':'#large_challenge_like_list_likes1',id:'large_challenge_like_list_likes'},'get '),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner_post_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'img_leftSide'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:'lef_img',src:'../images/default_userpic0.png',alt:'Comment'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'right_side_content_post'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_top_row border_bottom'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_top_card'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'user_icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'popup_user_image',src:'../images/default_userpic0.png',alt:'img'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{className:'popup_user_name',href:'#'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action cta_btn'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'btn-wrp btn-group more_action three-dot'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{type:'button',id:'comment_dropdownlist',className:'dropdown-toggle','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'/images/dot_action.svg',alt:'More Option'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'dropdown-menu dropdown-menu-right'},sameprofile===1?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_delete_cm'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button',id:'delete_post_with_discardpoup',onClick:function onClick(e){return _this8.deletePostId(post_id);},title:'Delete','data-toggle':'modal','data-target':'#deletePostCloseModalpopup'},'Delete')):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'dropdown-item danger',type:'button'},'Report'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);','aria-label':'Close',className:'dropdown-item',type:'button',title:'Cancel'},'Cancel'))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_listing_ul_wrap'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('ul',{className:'post_listing_ul'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{className:'post_listing_li'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'detail_bottom user_top_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_top_card'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inline_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_leftbar_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'user_icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'popup_display_userimage',src:'../images/default_userpic0.png',alt:'img'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name_wrapper'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_inner'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_name'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',className:'popup_display_username'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt_cnt'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'cmt-txt',id:'full_text'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'content-span'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user_sidebar_heart'},' ')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'product_content_details'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_like d-flex flex-row flex-wrap align-items-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'day box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'time_interval_new'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'like box'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',id:'like_button_challenge',onClick:_this8.singlePostLikeModal,type:'button','data-toggle':'modal','data-target':'#large_challenge_like_list'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{id:'like_count_new'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment box'}))))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{className:'post_listing_li'},bufferdata))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_post_bottom_add'},sameprofile===1&&_this8.state.isChallenge==0?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'create_challenge_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'/create-challenge/'+_this8.state.postID,className:'create_button',title:'Create Challenge'},'Create Challenge')):"",__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'comment_like_shere'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'wrapper d-flex flex-row flex-wrap align-items-center justify-content-between w-100'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action_grp'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'popup_post_id',name:'popup_post_id',value:post_id}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'popup_load_id',name:'popup_load_id',onClick:function onClick(){return _this8.handleLoadPopup(post_id);}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'reply_id',name:'reply_id'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'activity_parent_id',name:'activity_parent_id'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'like-icon liked1',id:post_like_id_m},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:post_like_id_m,onClick:function onClick(){return _this8.handlePhotoLike(post_id,'popup');},className:'default1',src:'../images/like-new.svg'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:post_like_id_m,onClick:function onClick(){return _this8.handlePhotoUnLike(post_id,'popup');},className:'active1',style:{display:"none"},src:'../images/like-fill.svg'}),_this8.handleGetLikePost(post_id)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',onClick:function onClick(){return _this8.handleCommentClick();},className:'comment-icon home-comment'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/comment-bold.svg',alt:'Comment'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:;',className:'share-icon'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/cmt-share-bold.svg',alt:'Share'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'post_save1'},getLoggedinUsername!=null?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',style:{display:"block"},id:post_id_m,className:'savepost_link1'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:post_id_m,style:{display:"block"},className:'savedefault1',src:'../images/bookmark.svg',onClick:function onClick(){return _this8.handleSavePost(post_id,'popup');},alt:'No BookMark'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{id:post_id_m,style:{display:"none"},className:'saveactive1',src:'../images/bookmark-fill.svg',onClick:function onClick(){return _this8.handleRemoveSavePost(post_id,'popup');},alt:'BookMark'}),_this8.handleGetSavePost(post_id,'popup')):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this8.handleNotLoginClick();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{style:{display:"block"},className:'savedefault1',src:'../images/bookmark.svg',alt:'No BookMark'})))),fetchuserlikeusername),showPicker&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_emoji_picker_react___default.a,{onEmojiClick:_this8.onEmojiClick}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'add_in_comment'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'emoji_icon_input_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'emogi_icon'},' ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'../images/add_reaction.svg',alt:'img',onClick:_this8.togglePicker})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'textarea_bottom active'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_mentions__["b" /* MentionsInput */],{placeholder:'Add a comment...',value:_this8.state.singlementioned_popup,id:'comment_box_popup',onChange:_this8.updateInputPopup,style:__WEBPACK_IMPORTED_MODULE_8__defaultStyle__["a" /* default */],onKeyDown:_this8.handleSinglePostPopupEnter},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_mentions__["a" /* Mention */],{trigger:'@',data:_this8.state.singleget_allusers_popup,markup:'@__display__ ',displayTransform:function displayTransform(id,display,displayName){return'@'+display;},appendSpaceOnAdd:true,style:__WEBPACK_IMPORTED_MODULE_9__defaultMentionStyle__["a" /* default */],renderSuggestion:_this8.singlerenderUserSuggestionPopup,required:true,id:'comment_box_popup',className:'mentions__mention',placeholder:'Add a comment...'}))),_this8.state.singlementioned_popup===''?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{id:'handleCommentPost_popup',disabled:true,className:'post_button_comment',onClick:_this8.handleCommentPostPopup},'Post'):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{id:'handleCommentPost_popup',className:'post_button_comment',onClick:_this8.handleCommentPostPopup},'Post'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{style:{display:"none"},onClick:clearInput,id:'clearInput'},'Clear Input'),_this8.state.loader&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'loading_img',style:{'position':"absolute",'top':"50%",'left':"50%",'transform':"translate(-50%, -50%)"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{style:{'width':"40px"},src:'/images/loading-gif.gif'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'comment_message_alert'},_this8.state.blank_comment_message_popup))))))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal fade post_modal singlelikesModal createPostCloseModal large_challenge_image',id:'large_challenge_like_list',onKeyDown:_this8.singlePostLikeModalClose,'data-backdrop':'false','data-keyboard':'true',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel','data-dismiss':'modal','aria-label':'Close',onClick:_this8.singlePostLikeModalClose,title:'Close'},'\u2715')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'likes_user_model'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'likes_model_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h1',{className:'like_title'},'Likes')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'model_likes_main'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('ul',{className:'like_total_list'},bufferfollowers)))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal fade post_modal singlelikesModal createPostCloseModal large_challenge_image',id:'large_challenge_like_list_likes1',onKeyDown:_this8.singlePostLikeModalClose,'data-backdrop':'false','data-keyboard':'true',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel','data-dismiss':'modal','aria-label':'Close',onClick:_this8.singlePostLikeModalClose,title:'Close'},'\u2715')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'likes_user_model'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'likes_model_row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h1',{className:'like_title'},'Likes')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'model_likes_main'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('ul',{className:'like_total_list'},bufferlikefollowers)))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal fade post_modal post_modal_overlay deletePostCloseModalpopup',id:'deletePostCloseModalpopup','data-backdrop':'false','data-keyboard':'false',tabIndex:'-1',role:'dialog','aria-labelledby':'createPostCloseTitle','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'bg_overlay'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-dialog modal-md modal-dialog-centered',role:'document'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'inner text-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'title-main'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h6',null,'Are you sure you want to delete this post?')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'action-part'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'delete_post_id',name:'delete_post_id'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this8.checkDeletePost();},className:'btn danger btn-post-discard','data-dismiss':'modal','aria-label':'Close',title:'Delete'},'Delete'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn cancel  btn-post-cancel','data-dismiss':'modal','aria-label':'Close',title:'Cancel'},'Cancel'))))))));};this.singlerenderUserSuggestion=function(suggestion,search,highlightedDisplay){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user-suggestion'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:suggestion.avatar,alt:suggestion.display,className:'user-avatar'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'details'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'displayUserName'},highlightedDisplay),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'displayName'},suggestion.displayName)));};this.singlerenderUserSuggestionPopup=function(suggestion,search,highlightedDisplay){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'user-suggestion'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:suggestion.avatar,alt:suggestion.display,className:'user-avatar'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'details'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'displayUserName'},highlightedDisplay),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'displayName'},suggestion.displayName)));};this.handleUnFollowUser=function(touser_id){var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var checksavequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');checksavequery.equalTo('type','follow');checksavequery.equalTo('toUser',"_User$"+touser_id.id);checksavequery.equalTo('fromUser',"_User$"+currentUser_id);checksavequery.find().then(function(resultAct){if(resultAct){var activityresult=resultAct[0];try{activityresult.destroy();setTimeout(function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.unfollowpost_link#follow_'+touser_id.id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.followpost_link#follow_'+touser_id.id).attr("style","display: block");},500);}catch(error){console.error('Error deleting activity:',error);}}});setTimeout(function(){_this8.handleGetFollowUser(touser_id);},1000);}else{//window.alert('You need to login for follow user.');
return false;}};this.handleFollowUser=function(touser_id){var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var Activity=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Activity");var activity=new Activity();activity.set('fromUser',currentUser);activity.set('toUser',touser_id);activity.set('type','follow');activity.save().then(function(savedFile){setTimeout(function(){//$('a.followpost_link#follow_'+touser_id.id).attr("style", "display: none");
//$('a.unfollowpost_link#follow_'+touser_id.id).attr("style", "display: block");
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.followpost_link#follow_'+touser_id.id).attr("style","display: none");_this8.handleGetFollowUser(touser_id);_this8.toggleNotification(touser_id,'started following you.','');_this8.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});},500);}).catch(function(error){});}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#login_popup_btn').trigger('click');// $('#kitchenQrModal_btn').trigger('click');  
return false;}};this.handleGetFollowUser=function(touser_id){var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultSavedid=0;var checksavequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');checksavequery.equalTo('type','follow');checksavequery.equalTo('toUser',"_User$"+touser_id.id);checksavequery.equalTo('fromUser',"_User$"+currentUser_id);checksavequery.find().then(function(resultSave){if(resultSave){var resultSaved=resultSave[0];resultSavedid=resultSaved.id;__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.followpost_link#follow_'+touser_id.id).attr("style","display: none");}else{}});}};this.handleGetSavePost=function(post_id,page){var posts_id='';if(page==='popup'){posts_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();post_id=posts_id;}//var check_value=0;
var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultSavedid=0;var checksavequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Save');checksavequery.equalTo('photo',"Photo$"+post_id);checksavequery.equalTo('fromUser',"_User$"+currentUser_id);checksavequery.find().then(function(resultSave){if(resultSave){var resultSaved=resultSave[0];resultSavedid=resultSaved.id;var photo_id=resultSaved.get('photo').id;if(resultSavedid){//$('.active#save_'+post_id).attr("style", "display: block"); 
//$('.default#save_'+post_id).attr("style", "display: none"); 
//$('a.savepost_link#save_'+post_id).attr("style", "display: none");  
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.savepost_link1#save_'+post_id).attr("style","pointer-events: auto");if(posts_id){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save1 a.savepost_link1 .savedefault1#save_'+posts_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save1 a.savepost_link1 .saveactive1#save_'+posts_id).attr("style","display: block");}}}});}};this.handleRemoveSavePost=function(post_id,page){var posts_id='';if(page==='popup'){posts_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();post_id=posts_id;}var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){//window.alert('You need to login to save post.');
return false;}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.savepost_link1#save_'+post_id).attr("style","pointer-events: none");var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');query.equalTo('objectId',post_id);query.find().then(function(photo){if(photo){var photo_ob=photo[0];var photoid=photo_ob.id;var saveCount=photo_ob.get('saveCount');if(saveCount==undefined||saveCount<0){saveCount=0;}else{saveCount=saveCount-1;}photo_ob.set("saveCount",saveCount);photo_ob.save();var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Save');checklikequery.equalTo('photo',photo_ob);checklikequery.equalTo('fromUser',currentUser);checklikequery.first().then(function(object){if(object){return object.destroy();}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save1 a.savepost_link1 .savedefault1#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save1 a.savepost_link1 .saveactive1#save_'+post_id).attr("style","display: none");}}).then(function(deletedObject){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save1 a.savepost_link1 .savedefault1#save_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save1 a.savepost_link1 .saveactive1#save_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.savepost_link1#save_'+post_id).attr("style","pointer-events: auto");}).catch(function(error){console.error('Error deleting record:',error);});}else{//console.log("No post found");
}},function(error){//   console.error("Error loading post Error: " + error);
//promise.error(error);
});setTimeout(function(){var self=_this8;self.handleGetSavePost(post_id,page);},1000);}};this.handleSavePost=function(post_id,page){var posts_id='';if(page==='popup'){posts_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();post_id=posts_id;}var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){//window.alert('You need to login to save post.');
return false;}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.savepost_link1#save_'+post_id).attr("style","pointer-events: none");var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');query.equalTo('objectId',post_id);var self=_this8;query.find().then(function(photo){//$('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style", "display: none"); 
if(photo){var photo_ob=photo[0];var photoid=photo_ob.id;var saveCount=photo_ob.get('saveCount');if(saveCount==undefined){saveCount=1;}else{saveCount=saveCount+1;}photo_ob.set("saveCount",saveCount);photo_ob.save();var Save=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Save");var save=new Save();var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var currentUser_id=currentUser.id;save.set('fromUser',currentUser);save.set('photo',photo_ob);save.set("_wperm",{"*":{"read":true,"write":true}});save.set("_rperm",{"*":{"read":true,"write":true}});save.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);//acl.setWriteAccess(photo_ob.get('user'), true); 
acl.setWriteAccess(currentUser,true);acl.setReadAccess(currentUser,true);save.setACL(acl);save.save().then(function(savedFile){//  window.alert('You Saved post.');
//  window.location.href = "/";
}).catch(function(error){});self.toggleNotification(post_id,'saved photo','');self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});}else{//console.log("No post found");
}},function(error){//   console.error("Error loading post Error: " + error);
//promise.error(error);
});setTimeout(function(){var self=_this8;self.handleGetSavePost(post_id,page);/*if(posts_id)
                          {
                            self.handleGetSavePost(post_id,'popup');
                          }*/},1500);}};this.handleGetLikePost=function(post_id){var check_value=0;var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultLikedid=0;var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequery.equalTo('photo',"Photo$"+post_id);//checklikequery.equalTo('fromUser',"_User$"+currentUser_id);
checklikequery.equalTo('fromUser',currentUser);//checklikequery.notContainedIn("activity");   
checklikequery.doesNotExist("activity");checklikequery.find().then(function(resultLike){if(resultLike){var resultLiked=resultLike[0];resultLikedid=resultLiked.id;if(resultLikedid!==undefined){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .active1#like_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .default1#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked1#like_'+post_id).attr("style","pointer-events: auto");}if(resultLikedid===undefined){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .active1#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .default1#like_'+post_id).attr("style","display: block");}}});}};this.handleCommentClick=function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.add_in_comment #comment_box_popup').focus();};this.handleCommentSingleClick=function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_list_mn  #comment_box').focus();};this.handlePhotoUnLike=function(post_id,page){var posts_id='';if(page==='popup'){//post_id=post_id;
//post_id=$('#popup_post_id').val();
//posts_id=$('#popup_post_id').val();
post_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();posts_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();}var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{//$('a.liked .active#like_'+post_id).attr("style", "display: none");
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked1#like_'+post_id).attr("style","pointer-events: none");var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');query.equalTo('objectId',post_id);//query.equalTo('user', currentUser);
var self=_this8;query.find().then(function(photo){if(photo){var photo_ob=photo[0];var photoid=photo_ob.id;var likeCount=photo_ob.get('likeCountNew');if(likeCount==undefined||likeCount==1){likeCount=0;}else{likeCount=likeCount-1;}photo_ob.set("likeCountNew",likeCount);photo_ob.save();var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequery.equalTo('photo',photo_ob);checklikequery.equalTo('fromUser',currentUser);checklikequery.first().then(function(object){if(object){return object.destroy();__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: block");if(posts_id){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style","display: block");}}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: block");if(posts_id){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style","display: block");}}}).then(function(deletedObject){self.handleGetLikeUser(post_id);self.handleGetLikePost(post_id);self.setState({likeCount:likeCount});//self.setState({likeCount1:likeCount}); 
//$('#home_fetch').trigger('click');
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: block");if(posts_id){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style","display: block");var likesWord="Likes";if(likeCount==1)likesWord="Like";__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_mn #like_counts_'+posts_id).html(likeCount);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_mn #like_words_'+posts_id).html(likesWord);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked1#like_'+post_id).attr("style","pointer-events: auto");/*if(likeCount==1)
                                  {
                                    likesWord = "Like";
                                   
                                  }*/}var likeCountNew=likeCount;__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#like_count_new').html(likeCountNew+' '+likesWord);//$('#popup_post_id').val(posts_id);  
}).catch(function(error){console.error('Error deleting record:',error);});__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#home_fetch').trigger('click');}});/*setTimeout(() => {
                            var self = this;
                           self.handleGetLikeUser(post_id);
                           if(posts_id)
                           {                            
                             self.handleGetLikeUser(posts_id); 
                           }                                                  
                      },1500);*//*  setTimeout(() => {
                          var self = this;
                          self.handleGetLikePost(post_id);
                          self.handleGetLikeUser(post_id);                          
                     },2000);*/}}};this.toggleNotification=function(postid,msg,comment){var self=_this8;self.setState(function(prevState){return{isNotificationOpen:!prevState.isNotificationOpen,post_Notification_Id:postid,post_Notification_Msg:msg,post_Notification_Comment:comment};});//self.setState({ post_Notification_Id: postid });        
};this.handleGetActivityLikePost=function(comment_id){var check_value=0;var post_id=_this8.state.postID;var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultLikedid=0;var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequery.include("activity");checklikequery.equalTo('photo',"Photo$"+post_id);checklikequery.equalTo('activity',"Activity$"+comment_id);checklikequery.equalTo('fromUser',currentUser);var self=_this8;checklikequery.find().then(function(resultLike){if(resultLike){var resultLiked=resultLike[0];resultLikedid=resultLiked.id;if(resultLikedid!==undefined){__WEBPACK_IMPORTED_MODULE_6_jquery___default()(' a.liked_activity .activitydefault#comment_'+comment_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity .activityactive#comment_'+comment_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_userimg_inner .like.box.maincomment#'+comment_id).attr("style","display: block");// $(' a.liked_activity#comment_'+comment_id).attr("disabled", false);
/*if ($('a.liked_activity#comment_'+comment_id).hasClass('disabled'))
                       {
                         $('a.liked_activity#comment_'+comment_id).removeClass('disabled'); 
                       }*/__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity#comment_'+comment_id).attr("style","pointer-events: auto");}if(resultLikedid===undefined){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity .activitydefault#comment_'+comment_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity .activityactive#comment_'+comment_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_userimg_inner .like.box.maincomment#'+comment_id).attr("style","display: none");}}});}};this.handlePhotoActivityUnLike=function(e){var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{var post_id=e.target.id;var datapost_id=e.target.dataset.id;//$('a.liked_activity .activityactive#comment_'+datapost_id).attr("style", "display: none");
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity#comment_'+datapost_id).attr("style","pointer-events: none");var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query.equalTo('objectId',datapost_id);var self=_this8;query.find().then(function(activity){if(activity){var activity_ob=activity[0];var likeCount=void 0;if(activity_ob){likeCount=activity_ob.get('likeCount');}else{likeCount=0;}if(likeCount===undefined||likeCount===0){likeCount=0;}else{likeCount=likeCount-1;}/*if(likeCount==undefined || likeCount < 0)
                              {
                                  likeCount=0;
                              }else
                              {
                                  likeCount=likeCount-1;
                              }*/var photo_ob=activity_ob.get('photo');activity_ob.set("likeCount",likeCount);activity_ob.save();//like 
var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var currentUser_id=currentUser.id;var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequery.equalTo('photo',photo_ob);checklikequery.equalTo('fromUser',currentUser);checklikequery.equalTo('activity',activity_ob);checklikequery.first().then(function(object){if(object){return object.destroy();}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity .activitydefault#comment_'+datapost_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity .activityactive#comment_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_userimg_inner .like.box.maincomment#'+datapost_id).attr("style","display: none");}}).then(function(deletedObject){//self.setState({likeCount:likeCount});  
//$('#home_fetch').trigger('click');
self.setState({singlelikeCount:likeCount});__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity .activityactive#comment_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity .activitydefault#comment_'+datapost_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity#comment_'+datapost_id).attr("style","pointer-events: auto");}).catch(function(error){console.error('Error deleting record:',error);});//like  
}});setTimeout(function(){var self=_this8;self.handleGetActivityLikePost(datapost_id);},500);}};this.handlePhotoActivityLike=function(e){var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{var post_id=e.target.id;var datapost_id=e.target.dataset.id;//$('a.liked_activity .activitydefault#comment_'+datapost_id).attr("style", "display: none");
//$('a.liked_activity .activitydefault#comment_'+datapost_id).attr("disabled", true);
//if(('a.liked_activity .activitydefault#comment_'+datapost_id).attr('disabled') === 'true'){  return;}
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity#comment_'+datapost_id).attr("style","pointer-events: none");//e.stopImmediatePropagation();
var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query.equalTo('objectId',datapost_id);var self=_this8;query.find().then(function(activity){if(activity){var activity_ob=activity[0];var likeCount=void 0;if(activity_ob){likeCount=activity_ob.get('likeCount');}else{likeCount=0;}if(likeCount==undefined){likeCount=1;}else{likeCount=likeCount+1;}var photo_ob=activity_ob.get('photo');activity_ob.set("likeCount",likeCount);activity_ob.save();//like 
var Like=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Like");var like=new Like();var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var currentUser_id=currentUser.id;like.set('fromUser',currentUser);like.set('photo',photo_ob);like.set('activity',activity_ob);like.set("_wperm",{"*":{"read":true,"write":true}});like.set("_rperm",{"*":{"read":true,"write":true}});like.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);acl.setWriteAccess(currentUser,true);acl.setReadAccess(currentUser,true);like.setACL(acl);var fromUserThumb=currentUser.get('profilePictureSmall');if(fromUserThumb!=undefined){like.set('fromUserThumb',fromUserThumb);}like.save().then(function(likeActivitySaved){//if ($('a.liked_activity#comment_'+datapost_id).hasClass('disabled')){ return false;}               
self.setState({singlelikeCount:likeCount});}).catch(function(error){});//like  
self.toggleNotification(post_id,'liked comment',activity_ob);self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});}});setTimeout(function(){var self=_this8;self.handleGetActivityLikePost(datapost_id);},500);}};this.handleGetActivityLikePostChild=function(comment_id){var check_value=0;var post_id=_this8.state.postID;var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){var currentUser_id=currentUser.id;var resultLikedid=0;var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequery.include("activity");checklikequery.equalTo('photo',"Photo$"+post_id);checklikequery.equalTo('activity',"Activity$"+comment_id);checklikequery.equalTo('fromUser',currentUser);checklikequery.find().then(function(resultLike){if(resultLike){var resultLiked=resultLike[0];resultLikedid=resultLiked.id;if(resultLikedid!==undefined){__WEBPACK_IMPORTED_MODULE_6_jquery___default()(' a.liked_activity_child .activitydefault#comment_'+comment_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activityactive#comment_'+comment_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box.childcomment#child_'+comment_id).attr("style","display: block");//$('.comment_like  .comment.box a .reply_count#comnt_'+comment_id).trigger('click');
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_user_content .liked_activity_child#comment_'+comment_id).attr("style","pointer-events: auto");}if(resultLikedid===undefined){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activitydefault#comment_'+comment_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activityactive#comment_'+comment_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box.childcomment#child_'+comment_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_user_content .liked_activity_child#comment_'+comment_id).attr("style","pointer-events: auto");}}});// this.state.singlementioned_popup='';
/*  var reply_id=$('#reply_id').val();
         if(reply_id==='')
          {
           this.state.singlementioned_popup='';
          }*///setTimeout(() => {
//  var self = this;
//  self.handleCommentPostUpdate();
// },1000);
}};this.handlePhotoActivityUnLikeChild=function(e){var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{var post_id=e.target.id;var datapost_id=e.target.dataset.id;//$('a.liked_activity .activityactive#comment_'+datapost_id).attr("style", "display: none");
//console.log('datapost_id'+datapost_id);
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_user_content .liked_activity_child#comment_'+datapost_id).attr("style","pointer-events: none");var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query.equalTo('objectId',datapost_id);var self=_this8;query.find().then(function(activity){if(activity){var activity_ob=activity[0];var likeCount=void 0;if(activity_ob){likeCount=activity_ob.get('likeCount');}else{likeCount=0;}if(likeCount===undefined||likeCount===0){likeCount=0;}else{likeCount=likeCount-1;}var photo_ob=activity_ob.get('photo');activity_ob.set("likeCount",likeCount);activity_ob.save();//like 
var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var currentUser_id=currentUser.id;var checklikequery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');checklikequery.equalTo('photo',photo_ob);checklikequery.equalTo('fromUser',currentUser);checklikequery.equalTo('activity',activity_ob);checklikequery.first().then(function(object){if(object){return object.destroy();}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activitydefault#comment_'+datapost_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activityactive#comment_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box.childcomment#child_'+datapost_id).attr("style","display: none");}}).then(function(deletedObject){//self.setState({likeCount:likeCount});  
//$('#home_fetch').trigger('click');
self.setState({singlelikeCountChild:likeCount});var likesWord="Likes";if(likeCount==1){likesWord="Like";}__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box .count#childlike_'+datapost_id).html(likeCount);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box .like_count#childlike_'+datapost_id).html(likesWord);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box .like_count#childlike_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activityactive#comment_'+datapost_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity_child .activitydefault#comment_'+datapost_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_user_content .liked_activity_child#comment_'+datapost_id).attr("style","pointer-events: auto");if(likeCount===0){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box.childcomment#child_'+datapost_id).attr("style","display: none");}}).catch(function(error){console.error('Error deleting record:',error);});//like  
}});setTimeout(function(){var self=_this8;self.handleGetActivityLikePostChild(datapost_id);},2000);}};this.handlePhotoActivityLikeChild=function(e){var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{var post_id=e.target.id;var datapost_id=e.target.dataset.id;__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_user_content .liked_activity_child#comment_'+datapost_id).attr("style","pointer-events: none");var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');query.equalTo('objectId',datapost_id);var self=_this8;query.find().then(function(activity){if(activity){var activity_ob=activity[0];var likeCount=void 0;if(activity_ob){likeCount=activity_ob.get('likeCount');}else{likeCount=0;}if(likeCount==undefined){likeCount=1;}else{likeCount=likeCount+1;}var photo_ob=activity_ob.get('photo');activity_ob.set("likeCount",likeCount);activity_ob.save();//like 
var Like=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Like");var like=new Like();var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var currentUser_id=currentUser.id;like.set('fromUser',currentUser);like.set('photo',photo_ob);like.set('activity',activity_ob);like.set("_wperm",{"*":{"read":true,"write":true}});like.set("_rperm",{"*":{"read":true,"write":true}});like.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);acl.setWriteAccess(currentUser,true);acl.setReadAccess(currentUser,true);like.setACL(acl);var fromUserThumb=currentUser.get('profilePictureSmall');if(fromUserThumb!=undefined){like.set('fromUserThumb',fromUserThumb);}like.save().then(function(likeActivitySaved){var likesWord="Likes";if(likeCount==1){likesWord="Like";}__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box .count#childlike_'+datapost_id).html(likeCount);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box .like_count#childlike_'+datapost_id).html(likesWord);if(likeCount===0){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.like.box.childcomment#child_'+datapost_id).attr("style","display: none");}self.setState({singlelikeCountChild:likeCount});}).catch(function(error){});//like  
self.toggleNotification(post_id,'liked comment',activity_ob);self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});}});setTimeout(function(){var self=_this8;self.handleGetActivityLikePostChild(datapost_id);},2000);}};this.handleLoadPopup=function(post_id){//console.log('handleLoadPopup');
/*  setTimeout(() => {
                          var self = this;
                          self.handleGetLikePost(post_id);
                          self.handleGetLikeUser(post_id);                          
                     },1500);*/};this.handlePhotoLike=function(post_id,page){var posts_id='';if(page==='popup'){post_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();posts_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();}var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}else{//$('a.liked .default#like_'+post_id).attr("style", "display: none");
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked1#like_'+post_id).attr("style","pointer-events: none");var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');query.equalTo('objectId',post_id);var self=_this8;query.find().then(function(photo){if(photo){var photo_ob=photo[0];var photoid=photo_ob.id;var likeCount=photo_ob.get('likeCountNew');if(likeCount==undefined){likeCount=1;}else{likeCount=likeCount+1;}photo_ob.set("likeCountNew",likeCount);photo_ob.save();var Like=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Like");var like=new Like();var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();var currentUser_id=currentUser.id;like.set('fromUser',currentUser);like.set('photo',photo_ob);like.set("_wperm",{"*":{"read":true,"write":true}});like.set("_rperm",{"*":{"read":true,"write":true}});like.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);acl.setWriteAccess(currentUser,true);acl.setReadAccess(currentUser,true);like.setACL(acl);var fromUserThumb=currentUser.get('profilePictureSmall');if(fromUserThumb!=undefined){like.set('fromUserThumb',fromUserThumb);}like.save().then(function(likeSaved){self.setState({likeCount:likeCount});__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .default#like_'+post_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked .active#like_'+post_id).attr("style","display: block");if(posts_id){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style","display: block");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_mn #like_counts_'+posts_id).html(likeCount);var likesWord="Likes";//if (likeCount == 1) likesWord = "Like";
if(likeCount==1){likesWord="Like";__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_mn #like_words_'+posts_id).html(likesWord);}}var likeCountNew=likeCount;__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#like_count_new').html(likeCountNew+' '+likesWord);//$('#home_fetch').trigger('click');
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val(posts_id);// this.handleGetLikePost(post_id);
self.handleGetLikePost(post_id);self.handleGetLikeUser(post_id);}).catch(function(error){});}else{}},function(error){});setTimeout(function(){var self=_this8;_this8.toggleNotification(post_id,'liked photo','');self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});},1000);}};this.handleCommentPost=function(e){var _this9=this;var Photo=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Photo");var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query(Photo);var photo_post_id=this.state.postID;var postcomment=this.state.postcomment;if(postcomment){query.include("user");query.include("image");query.include("thumbnail");query.include("likeCountNew");query.include("saveCount");query.include("commentcount");query.include("_created_at");query.include("createdAt");query.exists("user");query.descending("createdAt");query.find({success:function success(results){if(results.length>0){results.forEach(function(photo){if(photo.id===photo_post_id){var Activity=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Activity");var activity=new Activity();var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();activity.set('fromUser',currentUser);activity.set('toUser',photo.get("user"));activity.set('content',postcomment);activity.set('type','comment');activity.set('photo',photo);activity.set('likeCount',0);var currentUser_id=currentUser.id;activity.set("_wperm",{"*":{"write":true}});activity.set("_rperm",{"*":{"read":true}});activity.set("_acl",{"*":{"read":true,"write":true}});var acl=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.ACL();acl.setPublicReadAccess(true);acl.setPublicWriteAccess(true);acl.setWriteAccess(photo.get('user'),true);acl.setWriteAccess(currentUser_id,true);acl.setReadAccess(currentUser_id,true);activity.setACL(acl);var self=this;try{activity.save().then(function(savedActivity){var activityId=savedActivity.id;setTimeout(function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity .activityactive#comment_'+activityId).attr("style","display: none");__WEBPACK_IMPORTED_MODULE_6_jquery___default()('a.liked_activity .activitydefault#comment_'+activityId).attr("style","display: block");},1000);}).catch(function(error){});__WEBPACK_IMPORTED_MODULE_6_jquery___default()(".comment_box").val('');__WEBPACK_IMPORTED_MODULE_6_jquery___default()("#comment_box").val('');var updated_photo_id=photo.get('id');var Photo_single=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Photo");var Photoquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query(Photo_single);var photoId=photo.id;Photoquery.get(photoId).then(function(photo){var commentcount_val=parseInt(photo.get('commentcount'));if(isNaN(commentcount_val)){commentcount_val=0;}var updated_comment_count=commentcount_val+1;photo.set("commentcount",updated_comment_count.toString());photo.save();}).catch(function(error){});}catch(error){}}});}else{//console.log("No photos found.");
}},error:function error(_error){// console.error("Error fetching photos: " + error.code + " " + error.message);
}});setTimeout(function(){var self=_this9;self.handleCommentPostUpdate();_this9.state.postcomment='';_this9.state.singlementioned='';},1500);}//photo.id = "photo_object_id";
// console.log(photo.id);
var self=this;var post_id=this.state.postID;if(postcomment!=''){}else{self.setState({blank_comment_message:"Your message box is empty. Please write a message to continue."});// window.alert('Please write some comment first!');
}setTimeout(function(){self.setState({blank_comment_message:null});},3000);};this.handleCommentPostPopup=function(e){var currentUser=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();if(currentUser){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_button_comment#handleCommentPost_popup').attr("disabled",true);this.setState({loader:true});e.preventDefault();//$(".add_in_comment .emoji_icon_input_row .textarea_bottom.active").attr("style", "visibility: hidden");
var Photo=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Photo");var query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query(Photo);var photo_post_id=this.state.postID;var postcomment=this.state.singlementioned_popup;//this.state.postcomment_popup;
var reply_id=this.state.reply_id;//$('#reply_id').val();
var activity_parent_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#activity_parent_id').val();var self=this;if(postcomment){query.include("user");query.include("image");query.include("thumbnail");query.include("likeCountNew");query.include("saveCount");query.include("commentcount");query.include("_created_at");query.include("createdAt");query.exists("user");query.descending("createdAt");query.find({success:function success(results){if(results.length>0){results.forEach(function(photo){if(photo.id===photo_post_id){var Activity=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Activity");var activity=new Activity();var _currentUser2=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.User.current();activity.set('fromUser',_currentUser2);activity.set('toUser',photo.get("user"));activity.set('content',postcomment);activity.set('type','comment');if(reply_id){activity.set('activity','Activity$'+activity_parent_id);}activity.set('photo',photo);activity.set('likeCount',0);var currentUser_id=_currentUser2.id;try{activity.save().then(function(savedActivity){var activityId=savedActivity.id;self.setState({reply_thread_id:activityId});// setTimeout(() => {
// $('a.liked_activity .activityactive#comment_'+activityId).attr("style", "display: none"); 
//$('a.liked_activity .activitydefault#comment_'+activityId).attr("style", "display: block"); 
// },1000); 
if(reply_id){self.toggleNotification(photo_post_id,'commented post reply',savedActivity);}else{self.toggleNotification(photo_post_id,'commented post',savedActivity);}self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});var captionusername='';var captionusernameupdated='';if(postcomment){captionusername=postcomment.match(/@\w+/);if(captionusername){captionusernameupdated=captionusername[0].substr(1);if(captionusernameupdated){//self.toggleNotification(photo_post_id,'tagged you in a comment',savedActivity);
self.toggleNotification(photo_post_id,'mentioned you in a comment',savedActivity);self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});}}}}).catch(function(error){});__WEBPACK_IMPORTED_MODULE_6_jquery___default()(".comment_box_popup").val('');__WEBPACK_IMPORTED_MODULE_6_jquery___default()("#comment_box_popup").val('');var updated_photo_id=photo.get('id');var Photo_single=__WEBPACK_IMPORTED_MODULE_3_parse___default.a.Object.extend("Photo");var Photoquery=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query(Photo_single);var photoId=photo.id;Photoquery.get(photoId).then(function(photo){var commentcount_val=parseInt(photo.get('commentcount'));if(isNaN(commentcount_val)){commentcount_val=0;}var updated_comment_count=commentcount_val+1;photo.set("commentcount",updated_comment_count.toString());self.setState({commentCount:updated_comment_count.toString()});photo.save();self.setState({singlementioned_popup:''});}).catch(function(error){});setTimeout(function(){self.setState({singlementioned_popup:'',reply_id:''});self.handleCommentPostUpdate();},500);}catch(error){}}});}else{}},error:function error(_error2){}});}var self=this;var post_id=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val();}else{__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}};this.handlePostModelOpen1=function(post_id){_this8.setState({post_id:post_id});};this.handlePostModelOpen=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(post_id){var getLoggedinUsername,query,self,activity_data,query1;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#home_id').val(post_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#popup_post_id').val(post_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere .like-icon.liked1').attr('id','like_'+post_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere .like-icon.liked1 img.default1').attr('id','like_'+post_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.comment_like_shere .like-icon.liked1 img.active1').attr('id','like_'+post_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save1 .savepost_link1 .savedefault1').attr('id','save_'+post_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save1 .savepost_link1 .saveactive1').attr('id','save_'+post_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.post_save1 .savepost_link1').attr('id','save_'+post_id);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#full_text').html('');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#lef_img').attr('src','../images/default_userpic0.png');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_user_image').attr('src','../images/default_userpic0.png');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_display_userimage').attr('src','../images/default_userpic0.png');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.user_name a.popup_user_name').html('');getLoggedinUsername=localStorage.getItem('username');query=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Photo');query.include("likeCountNew");query.include("commentcount");query.equalTo('objectId',post_id);//await query.get(post_id);
self=_this8;self.setState({single_post_id:post_id});self.setState({singlemodalstates:true});//comment listing
activity_data=[];query1=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Activity');// query1.equalTo('photo', photo[0]);
_context5.next=25;return query1.equalTo('photo',"Photo$"+post_id);case 25://await query1.get(postId);
query1.equalTo("type","comment");query1.include("fromUser");query1.include("image");query1.include("content");query1.include("_created_at");query1.include("createdAt");//query.ascending("_created_at");
query1.descending("_created_at");self=_this8;query1.find().then(function(result){if(result){activity_data.push(result);}else{}self.setState({commentsdatas:activity_data[0]});},function(error){});//comment listing  
query.find().then(function(photo){if(photo){//self.setState({popup_username:null});
var photo_img=photo[0].get('image').url()?photo[0].get('image').url():'';__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#lef_img').attr('src',photo_img);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.time_interval_new').html(time_ago(photo[0].get('createdAt')));var obj=self.formatRenderComments2main(photo[0].get('caption'));//console.log(photo_data+'photo_data');
var full_text=obj?obj.a?obj.a.props?obj.a.props.children?obj.a.props.children:'':'':'':'';__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#full_text').html(full_text);var photo_data=photo[0].get('caption');var likeCountNew=photo[0].get('likeCountNew')?photo[0].get('likeCountNew'):0;var likesWord="Likes";if(likeCountNew==1)likesWord="Like";__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#like_count_new').html(likeCountNew+' '+likesWord);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.user_name a.popup_user_name').html(photo[0].get('user').get('displayUsername'));__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.user_name a.popup_user_name').attr("href","/user/"+photo[0].get('user').get('displayUsername'));__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.user_name a.popup_display_username').html(photo[0].get('user').get('displayUsername'));__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.user_name a.popup_display_username').attr("href","/user/"+photo[0].get('user').get('displayUsername'));var user_image=photo[0].get('user')?photo[0].get('user').get('profilePictureSmall')?photo[0].get('user').get('profilePictureSmall').url():'../images/default_userpic0.png':'../images/default_userpic0.png';__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_user_image').attr('src',user_image);__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.popup_display_userimage').attr('src',user_image);}});return _context5.abrupt('return',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:''}));case 36:case'end':return _context5.stop();}}},_callee5,_this8);}));return function(_x4){return _ref5.apply(this,arguments);};}();this.handleNotLoginClick=function(){var getLoggedinUsername=localStorage.getItem('username');if(!getLoggedinUsername){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#kitchenQrModal_btn').trigger('click');return false;}};this.handleGetLikeUser=function(post_id){//var  posts_id=$('#popup_post_id').val();
if(post_id){var like=new __WEBPACK_IMPORTED_MODULE_3_parse___default.a.Query('Like');var self=_this8;like.equalTo('photo','Photo$'+post_id);like.doesNotExist('activity');like.find().then(function(result){if(result){self.setState({likeuserlist:result});}});}};this.togglePopup=function(postid){_this8.setState(function(prevState){return{isPopupOpendetails:!prevState.isPopupOpendetails};});_this8.setState({post_common_id:postid});//$("body").addClass("modal-open-search");
};};/* harmony default export */ __webpack_exports__["a"] = (GridSinglePost);

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__global_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Leftsidebar_jsx__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Messages=function(_React$Component){_inherits(Messages,_React$Component);function Messages(){_classCallCheck(this,Messages);return _possibleConstructorReturn(this,(Messages.__proto__||Object.getPrototypeOf(Messages)).apply(this,arguments));}_createClass(Messages,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('section',{className:'post_list'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('nav',{className:'sidebar'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Leftsidebar_jsx__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('main',{className:'listing explr-list no_message'},'Direct Messages coming soon.'))));}}]);return Messages;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Messages);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.64bc683e.js